
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2ac4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2ac4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eokS8", function(module, exports) {

$parcel$export(module.exports, "AbstractConnector", () => $3d8addc4c1746845$export$c3faceeb92aa39dd);
$parcel$export(module.exports, "iterateDeletedStructs", () => $3d8addc4c1746845$export$8afefebbaf4e4c78);
$parcel$export(module.exports, "isDeleted", () => $3d8addc4c1746845$export$dcb04af092e44fde);
$parcel$export(module.exports, "mergeDeleteSets", () => $3d8addc4c1746845$export$b7826cadad53901e);
$parcel$export(module.exports, "createDeleteSet", () => $3d8addc4c1746845$export$8cbac0d946238699);
$parcel$export(module.exports, "createDeleteSetFromStructStore", () => $3d8addc4c1746845$export$8450d668bec558e2);
$parcel$export(module.exports, "getState", () => $3d8addc4c1746845$export$50fdfeece43146fd);
$parcel$export(module.exports, "findIndexSS", () => $3d8addc4c1746845$export$5f8f02523cf47b58);
$parcel$export(module.exports, "UpdateEncoderV2", () => $3d8addc4c1746845$export$30c99e08943e1c2);
$parcel$export(module.exports, "equalDeleteSets", () => $3d8addc4c1746845$export$9697b72c46fd3a5d);
$parcel$export(module.exports, "Doc", () => $3d8addc4c1746845$export$bceacc74c2212615);
$parcel$export(module.exports, "transact", () => $3d8addc4c1746845$export$dac1bad6146b2469);
$parcel$export(module.exports, "AbstractType", () => $3d8addc4c1746845$export$c265dc8338484497);
$parcel$export(module.exports, "Array", () => $3d8addc4c1746845$export$c4be6576ca6fe4aa);
$parcel$export(module.exports, "Text", () => $3d8addc4c1746845$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Map", () => $3d8addc4c1746845$export$a5c7b93649eaf8f8);
$parcel$export(module.exports, "XmlElement", () => $3d8addc4c1746845$export$4db87581d3ca170d);
$parcel$export(module.exports, "XmlFragment", () => $3d8addc4c1746845$export$d5ce8c3e1731f1a7);
$parcel$export(module.exports, "UpdateDecoderV1", () => $3d8addc4c1746845$export$1aa46d9818b5d1ec);
$parcel$export(module.exports, "createID", () => $3d8addc4c1746845$export$6c7d4e6171d008d0);
$parcel$export(module.exports, "UpdateDecoderV2", () => $3d8addc4c1746845$export$1c932452355c5571);
$parcel$export(module.exports, "ID", () => $3d8addc4c1746845$export$8be180ec26319f9f);
$parcel$export(module.exports, "UpdateEncoderV1", () => $3d8addc4c1746845$export$99171b804d9c5b54);
$parcel$export(module.exports, "GC", () => $3d8addc4c1746845$export$12d259ff017e6b58);
$parcel$export(module.exports, "Skip", () => $3d8addc4c1746845$export$38d24f5c1eb0e4c0);
$parcel$export(module.exports, "Item", () => $3d8addc4c1746845$export$6d08773d2e66f8f2);
$parcel$export(module.exports, "readUpdateV2", () => $3d8addc4c1746845$export$7abe492a0b891b4d);
$parcel$export(module.exports, "mergeUpdatesV2", () => $3d8addc4c1746845$export$ce273d78de0331d1);
$parcel$export(module.exports, "applyUpdateV2", () => $3d8addc4c1746845$export$acc3b0324aabf1b6);
$parcel$export(module.exports, "readUpdate", () => $3d8addc4c1746845$export$d67ac8d73b7d336c);
$parcel$export(module.exports, "applyUpdate", () => $3d8addc4c1746845$export$c271737a9c02e925);
$parcel$export(module.exports, "encodeStateAsUpdateV2", () => $3d8addc4c1746845$export$90338e0798f6f64f);
$parcel$export(module.exports, "decodeStateVector", () => $3d8addc4c1746845$export$324ac6fb20a844e3);
$parcel$export(module.exports, "diffUpdateV2", () => $3d8addc4c1746845$export$a8143edf39d2ad8e);
$parcel$export(module.exports, "mergeUpdates", () => $3d8addc4c1746845$export$6319871659fd2460);
$parcel$export(module.exports, "convertUpdateFormatV2ToV1", () => $3d8addc4c1746845$export$afffbdeed14adbd);
$parcel$export(module.exports, "encodeStateAsUpdate", () => $3d8addc4c1746845$export$e5848df80e65bd53);
$parcel$export(module.exports, "encodeStateVector", () => $3d8addc4c1746845$export$3e2f5393f32e71f);
$parcel$export(module.exports, "compareIDs", () => $3d8addc4c1746845$export$c0af976e7e459c02);
$parcel$export(module.exports, "findRootTypeKey", () => $3d8addc4c1746845$export$e726a40920d54663);
$parcel$export(module.exports, "isParentOf", () => $3d8addc4c1746845$export$3c81af374b054d6a);
$parcel$export(module.exports, "logType", () => $3d8addc4c1746845$export$e9068ad704ba2f79);
$parcel$export(module.exports, "PermanentUserData", () => $3d8addc4c1746845$export$b9e8b5fa1162ca4e);
$parcel$export(module.exports, "RelativePosition", () => $3d8addc4c1746845$export$da21a415c5907662);
$parcel$export(module.exports, "relativePositionToJSON", () => $3d8addc4c1746845$export$a783b081767a452e);
$parcel$export(module.exports, "createRelativePositionFromJSON", () => $3d8addc4c1746845$export$ddad8a1b8f7475d8);
$parcel$export(module.exports, "AbsolutePosition", () => $3d8addc4c1746845$export$64c95a3fb7344864);
$parcel$export(module.exports, "createRelativePositionFromTypeIndex", () => $3d8addc4c1746845$export$197e7d99e3857e88);
$parcel$export(module.exports, "encodeRelativePosition", () => $3d8addc4c1746845$export$c5c95ef724203575);
$parcel$export(module.exports, "decodeRelativePosition", () => $3d8addc4c1746845$export$58a46cebc90e7851);
$parcel$export(module.exports, "getItem", () => $3d8addc4c1746845$export$f92dfeb71e9bb569);
$parcel$export(module.exports, "createAbsolutePositionFromRelativePosition", () => $3d8addc4c1746845$export$8fc3152f62fb7ed1);
$parcel$export(module.exports, "ContentType", () => $3d8addc4c1746845$export$e2e108cbe2e4f865);
$parcel$export(module.exports, "compareRelativePositions", () => $3d8addc4c1746845$export$fc8bd253c948b475);
$parcel$export(module.exports, "Snapshot", () => $3d8addc4c1746845$export$c963130a5525248f);
$parcel$export(module.exports, "equalSnapshots", () => $3d8addc4c1746845$export$742742a0f55b273d);
$parcel$export(module.exports, "encodeSnapshotV2", () => $3d8addc4c1746845$export$b946cadc55f8e512);
$parcel$export(module.exports, "encodeSnapshot", () => $3d8addc4c1746845$export$a6d29989648e995);
$parcel$export(module.exports, "decodeSnapshotV2", () => $3d8addc4c1746845$export$b0049fa299f4f58e);
$parcel$export(module.exports, "decodeSnapshot", () => $3d8addc4c1746845$export$5c696daccf32bd2e);
$parcel$export(module.exports, "createSnapshot", () => $3d8addc4c1746845$export$548fae0445f878fd);
$parcel$export(module.exports, "emptySnapshot", () => $3d8addc4c1746845$export$d4568a81dd107a34);
$parcel$export(module.exports, "snapshot", () => $3d8addc4c1746845$export$b8801ea43165ed7d);
$parcel$export(module.exports, "getItemCleanStart", () => $3d8addc4c1746845$export$e550586ad633138d);
$parcel$export(module.exports, "createDocFromSnapshot", () => $3d8addc4c1746845$export$5be4ae1e1e56a014);
$parcel$export(module.exports, "snapshotContainsUpdate", () => $3d8addc4c1746845$export$f938135bed5d8db7);
$parcel$export(module.exports, "getItemCleanEnd", () => $3d8addc4c1746845$export$73a181de908c608);
$parcel$export(module.exports, "Transaction", () => $3d8addc4c1746845$export$febc5573c75cefb0);
$parcel$export(module.exports, "tryGc", () => $3d8addc4c1746845$export$c2e5de00fc43f658);
$parcel$export(module.exports, "UndoManager", () => $3d8addc4c1746845$export$932a3f9a7e88971c);
$parcel$export(module.exports, "logUpdate", () => $3d8addc4c1746845$export$d6235ced6e55ace9);
$parcel$export(module.exports, "logUpdateV2", () => $3d8addc4c1746845$export$624b3f0248c2dc40);
$parcel$export(module.exports, "decodeUpdate", () => $3d8addc4c1746845$export$aa45cba8121663dc);
$parcel$export(module.exports, "decodeUpdateV2", () => $3d8addc4c1746845$export$2fed33908eb23d71);
$parcel$export(module.exports, "encodeStateVectorFromUpdateV2", () => $3d8addc4c1746845$export$ed51750cf3ab2381);
$parcel$export(module.exports, "encodeStateVectorFromUpdate", () => $3d8addc4c1746845$export$5c451fd8502b011f);
$parcel$export(module.exports, "parseUpdateMetaV2", () => $3d8addc4c1746845$export$8212a58b2178fdcf);
$parcel$export(module.exports, "parseUpdateMeta", () => $3d8addc4c1746845$export$e212b06fd4bf78fd);
$parcel$export(module.exports, "diffUpdate", () => $3d8addc4c1746845$export$bf60b51d6c283426);
$parcel$export(module.exports, "ContentDeleted", () => $3d8addc4c1746845$export$3b06e0b3a2ece602);
$parcel$export(module.exports, "XmlHook", () => $3d8addc4c1746845$export$ec64c1dd5e7a264);
$parcel$export(module.exports, "ContentAny", () => $3d8addc4c1746845$export$1d788b93bbb631a0);
$parcel$export(module.exports, "ContentBinary", () => $3d8addc4c1746845$export$e8d530cdf62d1cbd);
$parcel$export(module.exports, "ContentDoc", () => $3d8addc4c1746845$export$b564c0e69572c0e);
$parcel$export(module.exports, "ContentEmbed", () => $3d8addc4c1746845$export$c3787ba7f6086664);
$parcel$export(module.exports, "ContentFormat", () => $3d8addc4c1746845$export$3194899188fb5a88);
$parcel$export(module.exports, "ContentJSON", () => $3d8addc4c1746845$export$6a907ea8f733ecf3);
$parcel$export(module.exports, "ContentString", () => $3d8addc4c1746845$export$ee670b2cf091bbb6);
$parcel$export(module.exports, "obfuscateUpdate", () => $3d8addc4c1746845$export$2dc24d59ec48a24e);
$parcel$export(module.exports, "obfuscateUpdateV2", () => $3d8addc4c1746845$export$90648fb14f8c31aa);
$parcel$export(module.exports, "convertUpdateFormatV1ToV2", () => $3d8addc4c1746845$export$162408325d5832c);
$parcel$export(module.exports, "YEvent", () => $3d8addc4c1746845$export$80fac438977fb51c);
$parcel$export(module.exports, "getTypeChildren", () => $3d8addc4c1746845$export$5418d693f13991b3);
$parcel$export(module.exports, "typeListToArraySnapshot", () => $3d8addc4c1746845$export$9de42b6dda4c7e48);
$parcel$export(module.exports, "typeMapGetSnapshot", () => $3d8addc4c1746845$export$a7c089bf6c22a1db);
$parcel$export(module.exports, "typeMapGetAllSnapshot", () => $3d8addc4c1746845$export$7769bdedaef2c91b);
$parcel$export(module.exports, "YArrayEvent", () => $3d8addc4c1746845$export$a095f7fee639264a);
$parcel$export(module.exports, "YMapEvent", () => $3d8addc4c1746845$export$33aab1b1a47c1cc3);
$parcel$export(module.exports, "cleanupYTextFormatting", () => $3d8addc4c1746845$export$5d9f53c13ebffb65);
$parcel$export(module.exports, "YTextEvent", () => $3d8addc4c1746845$export$51155b8ebb74188a);
$parcel$export(module.exports, "YXmlEvent", () => $3d8addc4c1746845$export$88c9145a0c3b556c);
$parcel$export(module.exports, "XmlText", () => $3d8addc4c1746845$export$b35b8f45887823df);
$parcel$export(module.exports, "AbstractStruct", () => $3d8addc4c1746845$export$3cf6f9765c5c3196);

var $1UXIn = parcelRequire("1UXIn");

var $5DExo = parcelRequire("5DExo");

var $3Lr38 = parcelRequire("3Lr38");

var $iUvcZ = parcelRequire("iUvcZ");

var $xchLN = parcelRequire("xchLN");

var $dB3PR = parcelRequire("dB3PR");

var $fwtVw = parcelRequire("fwtVw");

var $hX8wf = parcelRequire("hX8wf");

var $0Sial = parcelRequire("0Sial");

var $AgXfe = parcelRequire("AgXfe");

var $8FTfp = parcelRequire("8FTfp");

var $5Ci8T = parcelRequire("5Ci8T");

var $ivn6P = parcelRequire("ivn6P");

var $70wUZ = parcelRequire("70wUZ");
var $bamwN = parcelRequire("bamwN");

var $g2kVL = parcelRequire("g2kVL");

var $552MW = parcelRequire("552MW");

var $3ZDaC = parcelRequire("3ZDaC");

var $kqHhc = parcelRequire("kqHhc");

var $44IZO = parcelRequire("44IZO");
/**
 * This is an abstract interface that all Connectors should implement to keep them interchangeable.
 *
 * @note This interface is experimental and it is not advised to actually inherit this class.
 *       It just serves as typing information.
 *
 * @extends {ObservableV2<any>}
 */ class $3d8addc4c1746845$export$c3faceeb92aa39dd extends (0, $1UXIn.ObservableV2) {
    /**
   * @param {Doc} ydoc
   * @param {any} awareness
   */ constructor(ydoc, awareness){
        super();
        this.doc = ydoc;
        this.awareness = awareness;
    }
}
class $3d8addc4c1746845$var$DeleteItem {
    /**
   * @param {number} clock
   * @param {number} len
   */ constructor(clock, len){
        /**
     * @type {number}
     */ this.clock = clock;
        /**
     * @type {number}
     */ this.len = len;
    }
}
/**
 * We no longer maintain a DeleteStore. DeleteSet is a temporary object that is created when needed.
 * - When created in a transaction, it must only be accessed after sorting, and merging
 *   - This DeleteSet is send to other clients
 * - We do not create a DeleteSet when we send a sync message. The DeleteSet message is created directly from StructStore
 * - We read a DeleteSet as part of a sync/update message. In this case the DeleteSet is already sorted and merged.
 */ class $3d8addc4c1746845$var$DeleteSet {
    constructor(){
        /**
     * @type {Map<number,Array<DeleteItem>>}
     */ this.clients = new Map();
    }
}
/**
 * Iterate over all structs that the DeleteSet gc's.
 *
 * @param {Transaction} transaction
 * @param {DeleteSet} ds
 * @param {function(GC|Item):void} f
 *
 * @function
 */ const $3d8addc4c1746845$export$8afefebbaf4e4c78 = (transaction, ds, f)=>ds.clients.forEach((deletes, clientid)=>{
        const structs = /** @type {Array<GC|Item>} */ transaction.doc.store.clients.get(clientid);
        if (structs != null) {
            const lastStruct = structs[structs.length - 1];
            const clockState = lastStruct.id.clock + lastStruct.length;
            for(let i = 0, del = deletes[i]; i < deletes.length && del.clock < clockState; del = deletes[++i])$3d8addc4c1746845$var$iterateStructs(transaction, structs, del.clock, del.len, f);
        }
    });
/**
 * @param {Array<DeleteItem>} dis
 * @param {number} clock
 * @return {number|null}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$findIndexDS = (dis, clock)=>{
    let left = 0;
    let right = dis.length - 1;
    while(left <= right){
        const midindex = $3Lr38.floor((left + right) / 2);
        const mid = dis[midindex];
        const midclock = mid.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.len) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
    }
    return null;
};
/**
 * @param {DeleteSet} ds
 * @param {ID} id
 * @return {boolean}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$export$dcb04af092e44fde = (ds, id)=>{
    const dis = ds.clients.get(id.client);
    return dis !== undefined && $3d8addc4c1746845$var$findIndexDS(dis, id.clock) !== null;
};
/**
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$sortAndMergeDeleteSet = (ds)=>{
    ds.clients.forEach((dels)=>{
        dels.sort((a, b)=>a.clock - b.clock);
        // merge items without filtering or splicing the array
        // i is the current pointer
        // j refers to the current insert position for the pointed item
        // try to merge dels[i] into dels[j-1] or set dels[j]=dels[i]
        let i, j;
        for(i = 1, j = 1; i < dels.length; i++){
            const left = dels[j - 1];
            const right = dels[i];
            if (left.clock + left.len >= right.clock) dels[j - 1] = new $3d8addc4c1746845$var$DeleteItem(left.clock, $3Lr38.max(left.len, right.clock + right.len - left.clock));
            else {
                if (j < i) dels[j] = right;
                j++;
            }
        }
        dels.length = j;
    });
};
/**
 * @param {Array<DeleteSet>} dss
 * @return {DeleteSet} A fresh DeleteSet
 */ const $3d8addc4c1746845$export$b7826cadad53901e = (dss)=>{
    const merged = new $3d8addc4c1746845$var$DeleteSet();
    for(let dssI = 0; dssI < dss.length; dssI++)dss[dssI].clients.forEach((delsLeft, client)=>{
        if (!merged.clients.has(client)) {
            // Write all missing keys from current ds and all following.
            // If merged already contains `client` current ds has already been added.
            /**
         * @type {Array<DeleteItem>}
         */ const dels = delsLeft.slice();
            for(let i = dssI + 1; i < dss.length; i++)$5DExo.appendTo(dels, dss[i].clients.get(client) || []);
            merged.clients.set(client, dels);
        }
    });
    $3d8addc4c1746845$var$sortAndMergeDeleteSet(merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {number} client
 * @param {number} clock
 * @param {number} length
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$addToDeleteSet = (ds, client, clock, length)=>{
    $iUvcZ.setIfUndefined(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []).push(new $3d8addc4c1746845$var$DeleteItem(clock, length));
};
const $3d8addc4c1746845$export$8cbac0d946238699 = ()=>new $3d8addc4c1746845$var$DeleteSet();
/**
 * @param {StructStore} ss
 * @return {DeleteSet} Merged and sorted DeleteSet
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$export$8450d668bec558e2 = (ss)=>{
    const ds = $3d8addc4c1746845$export$8cbac0d946238699();
    ss.clients.forEach((structs, client)=>{
        /**
     * @type {Array<DeleteItem>}
     */ const dsitems = [];
        for(let i = 0; i < structs.length; i++){
            const struct = structs[i];
            if (struct.deleted) {
                const clock = struct.id.clock;
                let len = struct.length;
                if (i + 1 < structs.length) for(let next = structs[i + 1]; i + 1 < structs.length && next.deleted; next = structs[++i + 1])len += next.length;
                dsitems.push(new $3d8addc4c1746845$var$DeleteItem(clock, len));
            }
        }
        if (dsitems.length > 0) ds.clients.set(client, dsitems);
    });
    return ds;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$writeDeleteSet = (encoder, ds)=>{
    $xchLN.writeVarUint(encoder.restEncoder, ds.clients.size);
    // Ensure that the delete set is written in a deterministic order
    $5DExo.from(ds.clients.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, dsitems])=>{
        encoder.resetDsCurVal();
        $xchLN.writeVarUint(encoder.restEncoder, client);
        const len = dsitems.length;
        $xchLN.writeVarUint(encoder.restEncoder, len);
        for(let i = 0; i < len; i++){
            const item = dsitems[i];
            encoder.writeDsClock(item.clock);
            encoder.writeDsLen(item.len);
        }
    });
};
/**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {DeleteSet}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$readDeleteSet = (decoder)=>{
    const ds = new $3d8addc4c1746845$var$DeleteSet();
    const numClients = $dB3PR.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        const client = $dB3PR.readVarUint(decoder.restDecoder);
        const numberOfDeletes = $dB3PR.readVarUint(decoder.restDecoder);
        if (numberOfDeletes > 0) {
            const dsField = $iUvcZ.setIfUndefined(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []);
            for(let i = 0; i < numberOfDeletes; i++)dsField.push(new $3d8addc4c1746845$var$DeleteItem(decoder.readDsClock(), decoder.readDsLen()));
        }
    }
    return ds;
};
/**
 * @todo YDecoder also contains references to String and other Decoders. Would make sense to exchange YDecoder.toUint8Array for YDecoder.DsToUint8Array()..
 */ /**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @return {Uint8Array|null} Returns a v2 update containing all deletes that couldn't be applied yet; or null if all deletes were applied successfully.
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$readAndApplyDeleteSet = (decoder, transaction, store)=>{
    const unappliedDS = new $3d8addc4c1746845$var$DeleteSet();
    const numClients = $dB3PR.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        const client = $dB3PR.readVarUint(decoder.restDecoder);
        const numberOfDeletes = $dB3PR.readVarUint(decoder.restDecoder);
        const structs = store.clients.get(client) || [];
        const state = $3d8addc4c1746845$export$50fdfeece43146fd(store, client);
        for(let i = 0; i < numberOfDeletes; i++){
            const clock = decoder.readDsClock();
            const clockEnd = clock + decoder.readDsLen();
            if (clock < state) {
                if (state < clockEnd) $3d8addc4c1746845$var$addToDeleteSet(unappliedDS, client, state, clockEnd - state);
                let index = $3d8addc4c1746845$export$5f8f02523cf47b58(structs, clock);
                /**
         * We can ignore the case of GC and Delete structs, because we are going to skip them
         * @type {Item}
         */ // @ts-ignore
                let struct = structs[index];
                // split the first item if necessary
                if (!struct.deleted && struct.id.clock < clock) {
                    structs.splice(index + 1, 0, $3d8addc4c1746845$var$splitItem(transaction, struct, clock - struct.id.clock));
                    index++; // increase we now want to use the next struct
                }
                while(index < structs.length){
                    // @ts-ignore
                    struct = structs[index++];
                    if (struct.id.clock < clockEnd) {
                        if (!struct.deleted) {
                            if (clockEnd < struct.id.clock + struct.length) structs.splice(index, 0, $3d8addc4c1746845$var$splitItem(transaction, struct, clockEnd - struct.id.clock));
                            struct.delete(transaction);
                        }
                    } else break;
                }
            } else $3d8addc4c1746845$var$addToDeleteSet(unappliedDS, client, clock, clockEnd - clock);
        }
    }
    if (unappliedDS.clients.size > 0) {
        const ds = new $3d8addc4c1746845$export$30c99e08943e1c2();
        $xchLN.writeVarUint(ds.restEncoder, 0); // encode 0 structs
        $3d8addc4c1746845$var$writeDeleteSet(ds, unappliedDS);
        return ds.toUint8Array();
    }
    return null;
};
/**
 * @param {DeleteSet} ds1
 * @param {DeleteSet} ds2
 */ const $3d8addc4c1746845$export$9697b72c46fd3a5d = (ds1, ds2)=>{
    if (ds1.clients.size !== ds2.clients.size) return false;
    for (const [client, deleteItems1] of ds1.clients.entries()){
        const deleteItems2 = /** @type {Array<import('../internals.js').DeleteItem>} */ ds2.clients.get(client);
        if (deleteItems2 === undefined || deleteItems1.length !== deleteItems2.length) return false;
        for(let i = 0; i < deleteItems1.length; i++){
            const di1 = deleteItems1[i];
            const di2 = deleteItems2[i];
            if (di1.clock !== di2.clock || di1.len !== di2.len) return false;
        }
    }
    return true;
};
/**
 * @module Y
 */ const $3d8addc4c1746845$var$generateNewClientId = $fwtVw.uint32;
/**
 * @typedef {Object} DocOpts
 * @property {boolean} [DocOpts.gc=true] Disable garbage collection (default: gc=true)
 * @property {function(Item):boolean} [DocOpts.gcFilter] Will be called before an Item is garbage collected. Return false to keep the Item.
 * @property {string} [DocOpts.guid] Define a globally unique identifier for this document
 * @property {string | null} [DocOpts.collectionid] Associate this document with a collection. This only plays a role if your provider has a concept of collection.
 * @property {any} [DocOpts.meta] Any kind of meta information you want to associate with this document. If this is a subdocument, remote peers will store the meta information as well.
 * @property {boolean} [DocOpts.autoLoad] If a subdocument, automatically load document. If this is a subdocument, remote peers will load the document as well automatically.
 * @property {boolean} [DocOpts.shouldLoad] Whether the document should be synced by the provider now. This is toggled to true when you call ydoc.load()
 */ /**
 * @typedef {Object} DocEvents
 * @property {function(Doc):void} DocEvents.destroy
 * @property {function(Doc):void} DocEvents.load
 * @property {function(boolean, Doc):void} DocEvents.sync
 * @property {function(Uint8Array, any, Doc, Transaction):void} DocEvents.update
 * @property {function(Uint8Array, any, Doc, Transaction):void} DocEvents.updateV2
 * @property {function(Doc):void} DocEvents.beforeAllTransactions
 * @property {function(Transaction, Doc):void} DocEvents.beforeTransaction
 * @property {function(Transaction, Doc):void} DocEvents.beforeObserverCalls
 * @property {function(Transaction, Doc):void} DocEvents.afterTransaction
 * @property {function(Transaction, Doc):void} DocEvents.afterTransactionCleanup
 * @property {function(Doc, Array<Transaction>):void} DocEvents.afterAllTransactions
 * @property {function({ loaded: Set<Doc>, added: Set<Doc>, removed: Set<Doc> }, Doc, Transaction):void} DocEvents.subdocs
 */ /**
 * A Yjs instance handles the state of shared data.
 * @extends ObservableV2<DocEvents>
 */ class $3d8addc4c1746845$export$bceacc74c2212615 extends (0, $1UXIn.ObservableV2) {
    /**
   * @param {DocOpts} opts configuration
   */ constructor({ guid: guid = $fwtVw.uuidv4(), collectionid: collectionid = null, gc: gc = true, gcFilter: gcFilter = ()=>true, meta: meta = null, autoLoad: autoLoad = false, shouldLoad: shouldLoad = true } = {}){
        super();
        this.gc = gc;
        this.gcFilter = gcFilter;
        this.clientID = $3d8addc4c1746845$var$generateNewClientId();
        this.guid = guid;
        this.collectionid = collectionid;
        /**
     * @type {Map<string, AbstractType<YEvent<any>>>}
     */ this.share = new Map();
        this.store = new $3d8addc4c1746845$var$StructStore();
        /**
     * @type {Transaction | null}
     */ this._transaction = null;
        /**
     * @type {Array<Transaction>}
     */ this._transactionCleanups = [];
        /**
     * @type {Set<Doc>}
     */ this.subdocs = new Set();
        /**
     * If this document is a subdocument - a document integrated into another document - then _item is defined.
     * @type {Item?}
     */ this._item = null;
        this.shouldLoad = shouldLoad;
        this.autoLoad = autoLoad;
        this.meta = meta;
        /**
     * This is set to true when the persistence provider loaded the document from the database or when the `sync` event fires.
     * Note that not all providers implement this feature. Provider authors are encouraged to fire the `load` event when the doc content is loaded from the database.
     *
     * @type {boolean}
     */ this.isLoaded = false;
        /**
     * This is set to true when the connection provider has successfully synced with a backend.
     * Note that when using peer-to-peer providers this event may not provide very useful.
     * Also note that not all providers implement this feature. Provider authors are encouraged to fire
     * the `sync` event when the doc has been synced (with `true` as a parameter) or if connection is
     * lost (with false as a parameter).
     */ this.isSynced = false;
        this.isDestroyed = false;
        /**
     * Promise that resolves once the document has been loaded from a persistence provider.
     */ this.whenLoaded = $hX8wf.create((resolve)=>{
            this.on('load', ()=>{
                this.isLoaded = true;
                resolve(this);
            });
        });
        const provideSyncedPromise = ()=>$hX8wf.create((resolve)=>{
                /**
       * @param {boolean} isSynced
       */ const eventHandler = (isSynced)=>{
                    if (isSynced === undefined || isSynced === true) {
                        this.off('sync', eventHandler);
                        resolve();
                    }
                };
                this.on('sync', eventHandler);
            });
        this.on('sync', (isSynced)=>{
            if (isSynced === false && this.isSynced) this.whenSynced = provideSyncedPromise();
            this.isSynced = isSynced === undefined || isSynced === true;
            if (this.isSynced && !this.isLoaded) this.emit('load', [
                this
            ]);
        });
        /**
     * Promise that resolves once the document has been synced with a backend.
     * This promise is recreated when the connection is lost.
     * Note the documentation about the `isSynced` property.
     */ this.whenSynced = provideSyncedPromise();
    }
    /**
   * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
   *
   * `load()` might be used in the future to request any provider to load the most current data.
   *
   * It is safe to call `load()` multiple times.
   */ load() {
        const item = this._item;
        if (item !== null && !this.shouldLoad) $3d8addc4c1746845$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, (transaction)=>{
            transaction.subdocsLoaded.add(this);
        }, null, true);
        this.shouldLoad = true;
    }
    getSubdocs() {
        return this.subdocs;
    }
    getSubdocGuids() {
        return new Set($5DExo.from(this.subdocs).map((doc)=>doc.guid));
    }
    /**
   * Changes that happen inside of a transaction are bundled. This means that
   * the observer fires _after_ the transaction is finished and that all changes
   * that happened inside of the transaction are sent as one message to the
   * other peers.
   *
   * @template T
   * @param {function(Transaction):T} f The function that should be executed as a transaction
   * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
   * @return T
   *
   * @public
   */ transact(f, origin = null) {
        return $3d8addc4c1746845$export$dac1bad6146b2469(this, f, origin);
    }
    /**
   * Define a shared data type.
   *
   * Multiple calls of `ydoc.get(name, TypeConstructor)` yield the same result
   * and do not overwrite each other. I.e.
   * `ydoc.get(name, Y.Array) === ydoc.get(name, Y.Array)`
   *
   * After this method is called, the type is also available on `ydoc.share.get(name)`.
   *
   * *Best Practices:*
   * Define all types right after the Y.Doc instance is created and store them in a separate object.
   * Also use the typed methods `getText(name)`, `getArray(name)`, ..
   *
   * @template {typeof AbstractType<any>} Type
   * @example
   *   const ydoc = new Y.Doc(..)
   *   const appState = {
   *     document: ydoc.getText('document')
   *     comments: ydoc.getArray('comments')
   *   }
   *
   * @param {string} name
   * @param {Type} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
   * @return {InstanceType<Type>} The created type. Constructed with TypeConstructor
   *
   * @public
   */ get(name, TypeConstructor = /** @type {any} */ $3d8addc4c1746845$export$c265dc8338484497) {
        const type = $iUvcZ.setIfUndefined(this.share, name, ()=>{
            // @ts-ignore
            const t = new TypeConstructor();
            t._integrate(this, null);
            return t;
        });
        const Constr = type.constructor;
        if (TypeConstructor !== $3d8addc4c1746845$export$c265dc8338484497 && Constr !== TypeConstructor) {
            if (Constr === $3d8addc4c1746845$export$c265dc8338484497) {
                // @ts-ignore
                const t = new TypeConstructor();
                t._map = type._map;
                type._map.forEach(/** @param {Item?} n */ (n)=>{
                    for(; n !== null; n = n.left)// @ts-ignore
                    n.parent = t;
                });
                t._start = type._start;
                for(let n = t._start; n !== null; n = n.right)n.parent = t;
                t._length = type._length;
                this.share.set(name, t);
                t._integrate(this, null);
                return /** @type {InstanceType<Type>} */ t;
            } else throw new Error(`Type with the name ${name} has already been defined with a different constructor`);
        }
        return /** @type {InstanceType<Type>} */ type;
    }
    /**
   * @template T
   * @param {string} [name]
   * @return {YArray<T>}
   *
   * @public
   */ getArray(name = '') {
        return /** @type {YArray<T>} */ this.get(name, $3d8addc4c1746845$export$c4be6576ca6fe4aa);
    }
    /**
   * @param {string} [name]
   * @return {YText}
   *
   * @public
   */ getText(name = '') {
        return this.get(name, $3d8addc4c1746845$export$5f1af8db9871e1d6);
    }
    /**
   * @template T
   * @param {string} [name]
   * @return {YMap<T>}
   *
   * @public
   */ getMap(name = '') {
        return /** @type {YMap<T>} */ this.get(name, $3d8addc4c1746845$export$a5c7b93649eaf8f8);
    }
    /**
   * @param {string} [name]
   * @return {YXmlElement}
   *
   * @public
   */ getXmlElement(name = '') {
        return /** @type {YXmlElement<{[key:string]:string}>} */ this.get(name, $3d8addc4c1746845$export$4db87581d3ca170d);
    }
    /**
   * @param {string} [name]
   * @return {YXmlFragment}
   *
   * @public
   */ getXmlFragment(name = '') {
        return this.get(name, $3d8addc4c1746845$export$d5ce8c3e1731f1a7);
    }
    /**
   * Converts the entire document into a js object, recursively traversing each yjs type
   * Doesn't log types that have not been defined (using ydoc.getType(..)).
   *
   * @deprecated Do not use this method and rather call toJSON directly on the shared types.
   *
   * @return {Object<string, any>}
   */ toJSON() {
        /**
     * @type {Object<string, any>}
     */ const doc = {};
        this.share.forEach((value, key)=>{
            doc[key] = value.toJSON();
        });
        return doc;
    }
    /**
   * Emit `destroy` event and unregister all event handlers.
   */ destroy() {
        this.isDestroyed = true;
        $5DExo.from(this.subdocs).forEach((subdoc)=>subdoc.destroy());
        const item = this._item;
        if (item !== null) {
            this._item = null;
            const content = /** @type {ContentDoc} */ item.content;
            content.doc = new $3d8addc4c1746845$export$bceacc74c2212615({
                guid: this.guid,
                ...content.opts,
                shouldLoad: false
            });
            content.doc._item = item;
            $3d8addc4c1746845$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, (transaction)=>{
                const doc = content.doc;
                if (!item.deleted) transaction.subdocsAdded.add(doc);
                transaction.subdocsRemoved.add(this);
            }, null, true);
        }
        // @ts-ignore
        this.emit('destroyed', [
            true
        ]); // DEPRECATED!
        this.emit('destroy', [
            this
        ]);
        super.destroy();
    }
}
class $3d8addc4c1746845$var$DSDecoderV1 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        this.restDecoder = decoder;
    }
    resetDsCurVal() {
    // nop
    }
    /**
   * @return {number}
   */ readDsClock() {
        return $dB3PR.readVarUint(this.restDecoder);
    }
    /**
   * @return {number}
   */ readDsLen() {
        return $dB3PR.readVarUint(this.restDecoder);
    }
}
class $3d8addc4c1746845$export$1aa46d9818b5d1ec extends $3d8addc4c1746845$var$DSDecoderV1 {
    /**
   * @return {ID}
   */ readLeftID() {
        return $3d8addc4c1746845$export$6c7d4e6171d008d0($dB3PR.readVarUint(this.restDecoder), $dB3PR.readVarUint(this.restDecoder));
    }
    /**
   * @return {ID}
   */ readRightID() {
        return $3d8addc4c1746845$export$6c7d4e6171d008d0($dB3PR.readVarUint(this.restDecoder), $dB3PR.readVarUint(this.restDecoder));
    }
    /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ readClient() {
        return $dB3PR.readVarUint(this.restDecoder);
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readInfo() {
        return $dB3PR.readUint8(this.restDecoder);
    }
    /**
   * @return {string}
   */ readString() {
        return $dB3PR.readVarString(this.restDecoder);
    }
    /**
   * @return {boolean} isKey
   */ readParentInfo() {
        return $dB3PR.readVarUint(this.restDecoder) === 1;
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readTypeRef() {
        return $dB3PR.readVarUint(this.restDecoder);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number} len
   */ readLen() {
        return $dB3PR.readVarUint(this.restDecoder);
    }
    /**
   * @return {any}
   */ readAny() {
        return $dB3PR.readAny(this.restDecoder);
    }
    /**
   * @return {Uint8Array}
   */ readBuf() {
        return $0Sial.copyUint8Array($dB3PR.readVarUint8Array(this.restDecoder));
    }
    /**
   * Legacy implementation uses JSON parse. We use any-decoding in v2.
   *
   * @return {any}
   */ readJSON() {
        return JSON.parse($dB3PR.readVarString(this.restDecoder));
    }
    /**
   * @return {string}
   */ readKey() {
        return $dB3PR.readVarString(this.restDecoder);
    }
}
class $3d8addc4c1746845$var$DSDecoderV2 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        /**
     * @private
     */ this.dsCurrVal = 0;
        this.restDecoder = decoder;
    }
    resetDsCurVal() {
        this.dsCurrVal = 0;
    }
    /**
   * @return {number}
   */ readDsClock() {
        this.dsCurrVal += $dB3PR.readVarUint(this.restDecoder);
        return this.dsCurrVal;
    }
    /**
   * @return {number}
   */ readDsLen() {
        const diff = $dB3PR.readVarUint(this.restDecoder) + 1;
        this.dsCurrVal += diff;
        return diff;
    }
}
class $3d8addc4c1746845$export$1c932452355c5571 extends $3d8addc4c1746845$var$DSDecoderV2 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        super(decoder);
        /**
     * List of cached keys. If the keys[id] does not exist, we read a new key
     * from stringEncoder and push it to keys.
     *
     * @type {Array<string>}
     */ this.keys = [];
        $dB3PR.readVarUint(decoder); // read feature flag - currently unused
        this.keyClockDecoder = new $dB3PR.IntDiffOptRleDecoder($dB3PR.readVarUint8Array(decoder));
        this.clientDecoder = new $dB3PR.UintOptRleDecoder($dB3PR.readVarUint8Array(decoder));
        this.leftClockDecoder = new $dB3PR.IntDiffOptRleDecoder($dB3PR.readVarUint8Array(decoder));
        this.rightClockDecoder = new $dB3PR.IntDiffOptRleDecoder($dB3PR.readVarUint8Array(decoder));
        this.infoDecoder = new $dB3PR.RleDecoder($dB3PR.readVarUint8Array(decoder), $dB3PR.readUint8);
        this.stringDecoder = new $dB3PR.StringDecoder($dB3PR.readVarUint8Array(decoder));
        this.parentInfoDecoder = new $dB3PR.RleDecoder($dB3PR.readVarUint8Array(decoder), $dB3PR.readUint8);
        this.typeRefDecoder = new $dB3PR.UintOptRleDecoder($dB3PR.readVarUint8Array(decoder));
        this.lenDecoder = new $dB3PR.UintOptRleDecoder($dB3PR.readVarUint8Array(decoder));
    }
    /**
   * @return {ID}
   */ readLeftID() {
        return new $3d8addc4c1746845$export$8be180ec26319f9f(this.clientDecoder.read(), this.leftClockDecoder.read());
    }
    /**
   * @return {ID}
   */ readRightID() {
        return new $3d8addc4c1746845$export$8be180ec26319f9f(this.clientDecoder.read(), this.rightClockDecoder.read());
    }
    /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ readClient() {
        return this.clientDecoder.read();
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readInfo() {
        return /** @type {number} */ this.infoDecoder.read();
    }
    /**
   * @return {string}
   */ readString() {
        return this.stringDecoder.read();
    }
    /**
   * @return {boolean}
   */ readParentInfo() {
        return this.parentInfoDecoder.read() === 1;
    }
    /**
   * @return {number} An unsigned 8-bit integer
   */ readTypeRef() {
        return this.typeRefDecoder.read();
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number}
   */ readLen() {
        return this.lenDecoder.read();
    }
    /**
   * @return {any}
   */ readAny() {
        return $dB3PR.readAny(this.restDecoder);
    }
    /**
   * @return {Uint8Array}
   */ readBuf() {
        return $dB3PR.readVarUint8Array(this.restDecoder);
    }
    /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @return {any}
   */ readJSON() {
        return $dB3PR.readAny(this.restDecoder);
    }
    /**
   * @return {string}
   */ readKey() {
        const keyClock = this.keyClockDecoder.read();
        if (keyClock < this.keys.length) return this.keys[keyClock];
        else {
            const key = this.stringDecoder.read();
            this.keys.push(key);
            return key;
        }
    }
}
class $3d8addc4c1746845$var$DSEncoderV1 {
    constructor(){
        this.restEncoder = $xchLN.createEncoder();
    }
    toUint8Array() {
        return $xchLN.toUint8Array(this.restEncoder);
    }
    resetDsCurVal() {
    // nop
    }
    /**
   * @param {number} clock
   */ writeDsClock(clock) {
        $xchLN.writeVarUint(this.restEncoder, clock);
    }
    /**
   * @param {number} len
   */ writeDsLen(len) {
        $xchLN.writeVarUint(this.restEncoder, len);
    }
}
class $3d8addc4c1746845$export$99171b804d9c5b54 extends $3d8addc4c1746845$var$DSEncoderV1 {
    /**
   * @param {ID} id
   */ writeLeftID(id) {
        $xchLN.writeVarUint(this.restEncoder, id.client);
        $xchLN.writeVarUint(this.restEncoder, id.clock);
    }
    /**
   * @param {ID} id
   */ writeRightID(id) {
        $xchLN.writeVarUint(this.restEncoder, id.client);
        $xchLN.writeVarUint(this.restEncoder, id.clock);
    }
    /**
   * Use writeClient and writeClock instead of writeID if possible.
   * @param {number} client
   */ writeClient(client) {
        $xchLN.writeVarUint(this.restEncoder, client);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeInfo(info) {
        $xchLN.writeUint8(this.restEncoder, info);
    }
    /**
   * @param {string} s
   */ writeString(s) {
        $xchLN.writeVarString(this.restEncoder, s);
    }
    /**
   * @param {boolean} isYKey
   */ writeParentInfo(isYKey) {
        $xchLN.writeVarUint(this.restEncoder, isYKey ? 1 : 0);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeTypeRef(info) {
        $xchLN.writeVarUint(this.restEncoder, info);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ writeLen(len) {
        $xchLN.writeVarUint(this.restEncoder, len);
    }
    /**
   * @param {any} any
   */ writeAny(any) {
        $xchLN.writeAny(this.restEncoder, any);
    }
    /**
   * @param {Uint8Array} buf
   */ writeBuf(buf) {
        $xchLN.writeVarUint8Array(this.restEncoder, buf);
    }
    /**
   * @param {any} embed
   */ writeJSON(embed) {
        $xchLN.writeVarString(this.restEncoder, JSON.stringify(embed));
    }
    /**
   * @param {string} key
   */ writeKey(key) {
        $xchLN.writeVarString(this.restEncoder, key);
    }
}
class $3d8addc4c1746845$var$DSEncoderV2 {
    constructor(){
        this.restEncoder = $xchLN.createEncoder(); // encodes all the rest / non-optimized
        this.dsCurrVal = 0;
    }
    toUint8Array() {
        return $xchLN.toUint8Array(this.restEncoder);
    }
    resetDsCurVal() {
        this.dsCurrVal = 0;
    }
    /**
   * @param {number} clock
   */ writeDsClock(clock) {
        const diff = clock - this.dsCurrVal;
        this.dsCurrVal = clock;
        $xchLN.writeVarUint(this.restEncoder, diff);
    }
    /**
   * @param {number} len
   */ writeDsLen(len) {
        if (len === 0) $AgXfe.unexpectedCase();
        $xchLN.writeVarUint(this.restEncoder, len - 1);
        this.dsCurrVal += len;
    }
}
class $3d8addc4c1746845$export$30c99e08943e1c2 extends $3d8addc4c1746845$var$DSEncoderV2 {
    constructor(){
        super();
        /**
     * @type {Map<string,number>}
     */ this.keyMap = new Map();
        /**
     * Refers to the next unique key-identifier to me used.
     * See writeKey method for more information.
     *
     * @type {number}
     */ this.keyClock = 0;
        this.keyClockEncoder = new $xchLN.IntDiffOptRleEncoder();
        this.clientEncoder = new $xchLN.UintOptRleEncoder();
        this.leftClockEncoder = new $xchLN.IntDiffOptRleEncoder();
        this.rightClockEncoder = new $xchLN.IntDiffOptRleEncoder();
        this.infoEncoder = new $xchLN.RleEncoder($xchLN.writeUint8);
        this.stringEncoder = new $xchLN.StringEncoder();
        this.parentInfoEncoder = new $xchLN.RleEncoder($xchLN.writeUint8);
        this.typeRefEncoder = new $xchLN.UintOptRleEncoder();
        this.lenEncoder = new $xchLN.UintOptRleEncoder();
    }
    toUint8Array() {
        const encoder = $xchLN.createEncoder();
        $xchLN.writeVarUint(encoder, 0); // this is a feature flag that we might use in the future
        $xchLN.writeVarUint8Array(encoder, this.keyClockEncoder.toUint8Array());
        $xchLN.writeVarUint8Array(encoder, this.clientEncoder.toUint8Array());
        $xchLN.writeVarUint8Array(encoder, this.leftClockEncoder.toUint8Array());
        $xchLN.writeVarUint8Array(encoder, this.rightClockEncoder.toUint8Array());
        $xchLN.writeVarUint8Array(encoder, $xchLN.toUint8Array(this.infoEncoder));
        $xchLN.writeVarUint8Array(encoder, this.stringEncoder.toUint8Array());
        $xchLN.writeVarUint8Array(encoder, $xchLN.toUint8Array(this.parentInfoEncoder));
        $xchLN.writeVarUint8Array(encoder, this.typeRefEncoder.toUint8Array());
        $xchLN.writeVarUint8Array(encoder, this.lenEncoder.toUint8Array());
        // @note The rest encoder is appended! (note the missing var)
        $xchLN.writeUint8Array(encoder, $xchLN.toUint8Array(this.restEncoder));
        return $xchLN.toUint8Array(encoder);
    }
    /**
   * @param {ID} id
   */ writeLeftID(id) {
        this.clientEncoder.write(id.client);
        this.leftClockEncoder.write(id.clock);
    }
    /**
   * @param {ID} id
   */ writeRightID(id) {
        this.clientEncoder.write(id.client);
        this.rightClockEncoder.write(id.clock);
    }
    /**
   * @param {number} client
   */ writeClient(client) {
        this.clientEncoder.write(client);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeInfo(info) {
        this.infoEncoder.write(info);
    }
    /**
   * @param {string} s
   */ writeString(s) {
        this.stringEncoder.write(s);
    }
    /**
   * @param {boolean} isYKey
   */ writeParentInfo(isYKey) {
        this.parentInfoEncoder.write(isYKey ? 1 : 0);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeTypeRef(info) {
        this.typeRefEncoder.write(info);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ writeLen(len) {
        this.lenEncoder.write(len);
    }
    /**
   * @param {any} any
   */ writeAny(any) {
        $xchLN.writeAny(this.restEncoder, any);
    }
    /**
   * @param {Uint8Array} buf
   */ writeBuf(buf) {
        $xchLN.writeVarUint8Array(this.restEncoder, buf);
    }
    /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @param {any} embed
   */ writeJSON(embed) {
        $xchLN.writeAny(this.restEncoder, embed);
    }
    /**
   * Property keys are often reused. For example, in y-prosemirror the key `bold` might
   * occur very often. For a 3d application, the key `position` might occur very often.
   *
   * We cache these keys in a Map and refer to them via a unique number.
   *
   * @param {string} key
   */ writeKey(key) {
        const clock = this.keyMap.get(key);
        if (clock === undefined) {
            /**
       * @todo uncomment to introduce this feature finally
       *
       * Background. The ContentFormat object was always encoded using writeKey, but the decoder used to use readString.
       * Furthermore, I forgot to set the keyclock. So everything was working fine.
       *
       * However, this feature here is basically useless as it is not being used (it actually only consumes extra memory).
       *
       * I don't know yet how to reintroduce this feature..
       *
       * Older clients won't be able to read updates when we reintroduce this feature. So this should probably be done using a flag.
       *
       */ // this.keyMap.set(key, this.keyClock)
            this.keyClockEncoder.write(this.keyClock++);
            this.stringEncoder.write(key);
        } else this.keyClockEncoder.write(clock);
    }
}
/**
 * @module encoding
 */ /*
 * We use the first five bits in the info flag for determining the type of the struct.
 *
 * 0: GC
 * 1: Item with Deleted content
 * 2: Item with JSON content
 * 3: Item with Binary content
 * 4: Item with String content
 * 5: Item with Embed content (for richtext content)
 * 6: Item with Format content (a formatting marker for richtext content)
 * 7: Item with Type
 */ /**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Array<GC|Item>} structs All structs by `client`
 * @param {number} client
 * @param {number} clock write structs starting with `ID(client,clock)`
 *
 * @function
 */ const $3d8addc4c1746845$var$writeStructs = (encoder, structs, client, clock)=>{
    // write first id
    clock = $3Lr38.max(clock, structs[0].id.clock); // make sure the first id exists
    const startNewStructs = $3d8addc4c1746845$export$5f8f02523cf47b58(structs, clock);
    // write # encoded structs
    $xchLN.writeVarUint(encoder.restEncoder, structs.length - startNewStructs);
    encoder.writeClient(client);
    $xchLN.writeVarUint(encoder.restEncoder, clock);
    const firstStruct = structs[startNewStructs];
    // write first struct with an offset
    firstStruct.write(encoder, clock - firstStruct.id.clock);
    for(let i = startNewStructs + 1; i < structs.length; i++)structs[i].write(encoder, 0);
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {StructStore} store
 * @param {Map<number,number>} _sm
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$writeClientsStructs = (encoder, store, _sm)=>{
    // we filter all valid _sm entries into sm
    const sm = new Map();
    _sm.forEach((clock, client)=>{
        // only write if new structs are available
        if ($3d8addc4c1746845$export$50fdfeece43146fd(store, client) > clock) sm.set(client, clock);
    });
    $3d8addc4c1746845$var$getStateVector(store).forEach((_clock, client)=>{
        if (!_sm.has(client)) sm.set(client, 0);
    });
    // write # states that were updated
    $xchLN.writeVarUint(encoder.restEncoder, sm.size);
    // Write items with higher client ids first
    // This heavily improves the conflict algorithm.
    $5DExo.from(sm.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, clock])=>{
        $3d8addc4c1746845$var$writeStructs(encoder, /** @type {Array<GC|Item>} */ store.clients.get(client), client, clock);
    });
};
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder The decoder object to read data from.
 * @param {Doc} doc
 * @return {Map<number, { i: number, refs: Array<Item | GC> }>}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$readClientsStructRefs = (decoder, doc)=>{
    /**
   * @type {Map<number, { i: number, refs: Array<Item | GC> }>}
   */ const clientRefs = $iUvcZ.create();
    const numOfStateUpdates = $dB3PR.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numOfStateUpdates; i++){
        const numberOfStructs = $dB3PR.readVarUint(decoder.restDecoder);
        /**
     * @type {Array<GC|Item>}
     */ const refs = new Array(numberOfStructs);
        const client = decoder.readClient();
        let clock = $dB3PR.readVarUint(decoder.restDecoder);
        // const start = performance.now()
        clientRefs.set(client, {
            i: 0,
            refs: refs
        });
        for(let i = 0; i < numberOfStructs; i++){
            const info = decoder.readInfo();
            switch($8FTfp.BITS5 & info){
                case 0:
                    {
                        const len = decoder.readLen();
                        refs[i] = new $3d8addc4c1746845$export$12d259ff017e6b58($3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                case 10:
                    {
                        // @todo we could reduce the amount of checks by adding Skip struct to clientRefs so we know that something is missing.
                        const len = $dB3PR.readVarUint(decoder.restDecoder);
                        refs[i] = new $3d8addc4c1746845$export$38d24f5c1eb0e4c0($3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                default:
                    {
                        /**
           * The optimized implementation doesn't use any variables because inlining variables is faster.
           * Below a non-optimized version is shown that implements the basic algorithm with
           * a few comments
           */ const cantCopyParentInfo = (info & ($8FTfp.BIT7 | $8FTfp.BIT8)) === 0;
                        // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                        // and we read the next string as parentYKey.
                        // It indicates how we store/retrieve parent from `y.share`
                        // @type {string|null}
                        const struct = new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock), null, (info & $8FTfp.BIT8) === $8FTfp.BIT8 ? decoder.readLeftID() : null, null, (info & $8FTfp.BIT7) === $8FTfp.BIT7 ? decoder.readRightID() : null, cantCopyParentInfo ? decoder.readParentInfo() ? doc.get(decoder.readString()) : decoder.readLeftID() : null, cantCopyParentInfo && (info & $8FTfp.BIT6) === $8FTfp.BIT6 ? decoder.readString() : null, $3d8addc4c1746845$var$readItemContent(decoder, info) // item content
                        );
                        /* A non-optimized implementation of the above algorithm:

          // The item that was originally to the left of this item.
          const origin = (info & binary.BIT8) === binary.BIT8 ? decoder.readLeftID() : null
          // The item that was originally to the right of this item.
          const rightOrigin = (info & binary.BIT7) === binary.BIT7 ? decoder.readRightID() : null
          const cantCopyParentInfo = (info & (binary.BIT7 | binary.BIT8)) === 0
          const hasParentYKey = cantCopyParentInfo ? decoder.readParentInfo() : false
          // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
          // and we read the next string as parentYKey.
          // It indicates how we store/retrieve parent from `y.share`
          // @type {string|null}
          const parentYKey = cantCopyParentInfo && hasParentYKey ? decoder.readString() : null

          const struct = new Item(
            createID(client, clock),
            null, // left
            origin, // origin
            null, // right
            rightOrigin, // right origin
            cantCopyParentInfo && !hasParentYKey ? decoder.readLeftID() : (parentYKey !== null ? doc.get(parentYKey) : null), // parent
            cantCopyParentInfo && (info & binary.BIT6) === binary.BIT6 ? decoder.readString() : null, // parentSub
            readItemContent(decoder, info) // item content
          )
          */ refs[i] = struct;
                        clock += struct.length;
                    }
            }
        }
    // console.log('time to read: ', performance.now() - start) // @todo remove
    }
    return clientRefs;
};
/**
 * Resume computing structs generated by struct readers.
 *
 * While there is something to do, we integrate structs in this order
 * 1. top element on stack, if stack is not empty
 * 2. next element from current struct reader (if empty, use next struct reader)
 *
 * If struct causally depends on another struct (ref.missing), we put next reader of
 * `ref.id.client` on top of stack.
 *
 * At some point we find a struct that has no causal dependencies,
 * then we start emptying the stack.
 *
 * It is not possible to have circles: i.e. struct1 (from client1) depends on struct2 (from client2)
 * depends on struct3 (from client1). Therefore the max stack size is equal to `structReaders.length`.
 *
 * This method is implemented in a way so that we can resume computation if this update
 * causally depends on another update.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {Map<number, { i: number, refs: (GC | Item)[] }>} clientsStructRefs
 * @return { null | { update: Uint8Array, missing: Map<number,number> } }
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$integrateStructs = (transaction, store, clientsStructRefs)=>{
    /**
   * @type {Array<Item | GC>}
   */ const stack = [];
    // sort them so that we take the higher id first, in case of conflicts the lower id will probably not conflict with the id from the higher user.
    let clientsStructRefsIds = $5DExo.from(clientsStructRefs.keys()).sort((a, b)=>a - b);
    if (clientsStructRefsIds.length === 0) return null;
    const getNextStructTarget = ()=>{
        if (clientsStructRefsIds.length === 0) return null;
        let nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
        while(nextStructsTarget.refs.length === nextStructsTarget.i){
            clientsStructRefsIds.pop();
            if (clientsStructRefsIds.length > 0) nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
            else return null;
        }
        return nextStructsTarget;
    };
    let curStructsTarget = getNextStructTarget();
    if (curStructsTarget === null) return null;
    /**
   * @type {StructStore}
   */ const restStructs = new $3d8addc4c1746845$var$StructStore();
    const missingSV = new Map();
    /**
   * @param {number} client
   * @param {number} clock
   */ const updateMissingSv = (client, clock)=>{
        const mclock = missingSV.get(client);
        if (mclock == null || mclock > clock) missingSV.set(client, clock);
    };
    /**
   * @type {GC|Item}
   */ let stackHead = /** @type {any} */ curStructsTarget.refs[/** @type {any} */ curStructsTarget.i++];
    // caching the state because it is used very often
    const state = new Map();
    const addStackToRestSS = ()=>{
        for (const item of stack){
            const client = item.id.client;
            const inapplicableItems = clientsStructRefs.get(client);
            if (inapplicableItems) {
                // decrement because we weren't able to apply previous operation
                inapplicableItems.i--;
                restStructs.clients.set(client, inapplicableItems.refs.slice(inapplicableItems.i));
                clientsStructRefs.delete(client);
                inapplicableItems.i = 0;
                inapplicableItems.refs = [];
            } else // item was the last item on clientsStructRefs and the field was already cleared. Add item to restStructs and continue
            restStructs.clients.set(client, [
                item
            ]);
            // remove client from clientsStructRefsIds to prevent users from applying the same update again
            clientsStructRefsIds = clientsStructRefsIds.filter((c)=>c !== client);
        }
        stack.length = 0;
    };
    // iterate over all struct readers until we are done
    while(true){
        if (stackHead.constructor !== $3d8addc4c1746845$export$38d24f5c1eb0e4c0) {
            const localClock = $iUvcZ.setIfUndefined(state, stackHead.id.client, ()=>$3d8addc4c1746845$export$50fdfeece43146fd(store, stackHead.id.client));
            const offset = localClock - stackHead.id.clock;
            if (offset < 0) {
                // update from the same client is missing
                stack.push(stackHead);
                updateMissingSv(stackHead.id.client, stackHead.id.clock - 1);
                // hid a dead wall, add all items from stack to restSS
                addStackToRestSS();
            } else {
                const missing = stackHead.getMissing(transaction, store);
                if (missing !== null) {
                    stack.push(stackHead);
                    // get the struct reader that has the missing struct
                    /**
           * @type {{ refs: Array<GC|Item>, i: number }}
           */ const structRefs = clientsStructRefs.get(/** @type {number} */ missing) || {
                        refs: [],
                        i: 0
                    };
                    if (structRefs.refs.length === structRefs.i) {
                        // This update message causally depends on another update message that doesn't exist yet
                        updateMissingSv(/** @type {number} */ missing, $3d8addc4c1746845$export$50fdfeece43146fd(store, missing));
                        addStackToRestSS();
                    } else {
                        stackHead = structRefs.refs[structRefs.i++];
                        continue;
                    }
                } else if (offset === 0 || offset < stackHead.length) {
                    // all fine, apply the stackhead
                    stackHead.integrate(transaction, offset);
                    state.set(stackHead.id.client, stackHead.id.clock + stackHead.length);
                }
            }
        }
        // iterate to next stackHead
        if (stack.length > 0) stackHead = /** @type {GC|Item} */ stack.pop();
        else if (curStructsTarget !== null && curStructsTarget.i < curStructsTarget.refs.length) stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        else {
            curStructsTarget = getNextStructTarget();
            if (curStructsTarget === null) break;
            else stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        }
    }
    if (restStructs.clients.size > 0) {
        const encoder = new $3d8addc4c1746845$export$30c99e08943e1c2();
        $3d8addc4c1746845$var$writeClientsStructs(encoder, restStructs, new Map());
        // write empty deleteset
        // writeDeleteSet(encoder, new DeleteSet())
        $xchLN.writeVarUint(encoder.restEncoder, 0); // => no need for an extra function call, just write 0 deletes
        return {
            missing: missingSV,
            update: encoder.toUint8Array()
        };
    }
    return null;
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$writeStructsFromTransaction = (encoder, transaction)=>$3d8addc4c1746845$var$writeClientsStructs(encoder, transaction.doc.store, transaction.beforeState);
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts a decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {UpdateDecoderV1 | UpdateDecoderV2} [structDecoder]
 *
 * @function
 */ const $3d8addc4c1746845$export$7abe492a0b891b4d = (decoder, ydoc, transactionOrigin, structDecoder = new $3d8addc4c1746845$export$1c932452355c5571(decoder))=>$3d8addc4c1746845$export$dac1bad6146b2469(ydoc, (transaction)=>{
        // force that transaction.local is set to non-local
        transaction.local = false;
        let retry = false;
        const doc = transaction.doc;
        const store = doc.store;
        // let start = performance.now()
        const ss = $3d8addc4c1746845$var$readClientsStructRefs(structDecoder, doc);
        // console.log('time to read structs: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to merge: ', performance.now() - start) // @todo remove
        // start = performance.now()
        const restStructs = $3d8addc4c1746845$var$integrateStructs(transaction, store, ss);
        const pending = store.pendingStructs;
        if (pending) {
            // check if we can apply something
            for (const [client, clock] of pending.missing)if (clock < $3d8addc4c1746845$export$50fdfeece43146fd(store, client)) {
                retry = true;
                break;
            }
            if (restStructs) {
                // merge restStructs into store.pending
                for (const [client, clock] of restStructs.missing){
                    const mclock = pending.missing.get(client);
                    if (mclock == null || mclock > clock) pending.missing.set(client, clock);
                }
                pending.update = $3d8addc4c1746845$export$ce273d78de0331d1([
                    pending.update,
                    restStructs.update
                ]);
            }
        } else store.pendingStructs = restStructs;
        // console.log('time to integrate: ', performance.now() - start) // @todo remove
        // start = performance.now()
        const dsRest = $3d8addc4c1746845$var$readAndApplyDeleteSet(structDecoder, transaction, store);
        if (store.pendingDs) {
            // @todo we could make a lower-bound state-vector check as we do above
            const pendingDSUpdate = new $3d8addc4c1746845$export$1c932452355c5571($dB3PR.createDecoder(store.pendingDs));
            $dB3PR.readVarUint(pendingDSUpdate.restDecoder); // read 0 structs, because we only encode deletes in pendingdsupdate
            const dsRest2 = $3d8addc4c1746845$var$readAndApplyDeleteSet(pendingDSUpdate, transaction, store);
            if (dsRest && dsRest2) // case 1: ds1 != null && ds2 != null
            store.pendingDs = $3d8addc4c1746845$export$ce273d78de0331d1([
                dsRest,
                dsRest2
            ]);
            else // case 2: ds1 != null
            // case 3: ds2 != null
            // case 4: ds1 == null && ds2 == null
            store.pendingDs = dsRest || dsRest2;
        } else // Either dsRest == null && pendingDs == null OR dsRest != null
        store.pendingDs = dsRest;
        // console.log('time to cleanup: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to resume delete readers: ', performance.now() - start) // @todo remove
        // start = performance.now()
        if (retry) {
            const update = /** @type {{update: Uint8Array}} */ store.pendingStructs.update;
            store.pendingStructs = null;
            $3d8addc4c1746845$export$acc3b0324aabf1b6(transaction.doc, update);
        }
    }, transactionOrigin, false);
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts a decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ const $3d8addc4c1746845$export$d67ac8d73b7d336c = (decoder, ydoc, transactionOrigin)=>$3d8addc4c1746845$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new $3d8addc4c1746845$export$1aa46d9818b5d1ec(decoder));
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 *
 * @function
 */ const $3d8addc4c1746845$export$acc3b0324aabf1b6 = (ydoc, update, transactionOrigin, YDecoder = $3d8addc4c1746845$export$1c932452355c5571)=>{
    const decoder = $dB3PR.createDecoder(update);
    $3d8addc4c1746845$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new YDecoder(decoder));
};
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ const $3d8addc4c1746845$export$c271737a9c02e925 = (ydoc, update, transactionOrigin)=>$3d8addc4c1746845$export$acc3b0324aabf1b6(ydoc, update, transactionOrigin, $3d8addc4c1746845$export$1aa46d9818b5d1ec);
/**
 * Write all the document as a single update message. If you specify the state of the remote client (`targetStateVector`) it will
 * only write the operations that are missing.
 *
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Doc} doc
 * @param {Map<number,number>} [targetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 *
 * @function
 */ const $3d8addc4c1746845$var$writeStateAsUpdate = (encoder, doc, targetStateVector = new Map())=>{
    $3d8addc4c1746845$var$writeClientsStructs(encoder, doc.store, targetStateVector);
    $3d8addc4c1746845$var$writeDeleteSet(encoder, $3d8addc4c1746845$export$8450d668bec558e2(doc.store));
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @param {UpdateEncoderV1 | UpdateEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ const $3d8addc4c1746845$export$90338e0798f6f64f = (doc, encodedTargetStateVector = new Uint8Array([
    0
]), encoder = new $3d8addc4c1746845$export$30c99e08943e1c2())=>{
    const targetStateVector = $3d8addc4c1746845$export$324ac6fb20a844e3(encodedTargetStateVector);
    $3d8addc4c1746845$var$writeStateAsUpdate(encoder, doc, targetStateVector);
    const updates = [
        encoder.toUint8Array()
    ];
    // also add the pending updates (if there are any)
    if (doc.store.pendingDs) updates.push(doc.store.pendingDs);
    if (doc.store.pendingStructs) updates.push($3d8addc4c1746845$export$a8143edf39d2ad8e(doc.store.pendingStructs.update, encodedTargetStateVector));
    if (updates.length > 1) {
        if (encoder.constructor === $3d8addc4c1746845$export$99171b804d9c5b54) return $3d8addc4c1746845$export$6319871659fd2460(updates.map((update, i)=>i === 0 ? update : $3d8addc4c1746845$export$afffbdeed14adbd(update)));
        else if (encoder.constructor === $3d8addc4c1746845$export$30c99e08943e1c2) return $3d8addc4c1746845$export$ce273d78de0331d1(updates);
    }
    return updates[0];
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @return {Uint8Array}
 *
 * @function
 */ const $3d8addc4c1746845$export$e5848df80e65bd53 = (doc, encodedTargetStateVector)=>$3d8addc4c1746845$export$90338e0798f6f64f(doc, encodedTargetStateVector, new $3d8addc4c1746845$export$99171b804d9c5b54());
/**
 * Read state vector from Decoder and return as Map
 *
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ const $3d8addc4c1746845$var$readStateVector = (decoder)=>{
    const ss = new Map();
    const ssLength = $dB3PR.readVarUint(decoder.restDecoder);
    for(let i = 0; i < ssLength; i++){
        const client = $dB3PR.readVarUint(decoder.restDecoder);
        const clock = $dB3PR.readVarUint(decoder.restDecoder);
        ss.set(client, clock);
    }
    return ss;
};
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ // export const decodeStateVectorV2 = decodedState => readStateVector(new DSDecoderV2(decoding.createDecoder(decodedState)))
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ const $3d8addc4c1746845$export$324ac6fb20a844e3 = (decodedState)=>$3d8addc4c1746845$var$readStateVector(new $3d8addc4c1746845$var$DSDecoderV1($dB3PR.createDecoder(decodedState)));
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Map<number,number>} sv
 * @function
 */ const $3d8addc4c1746845$var$writeStateVector = (encoder, sv)=>{
    $xchLN.writeVarUint(encoder.restEncoder, sv.size);
    $5DExo.from(sv.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, clock])=>{
        $xchLN.writeVarUint(encoder.restEncoder, client); // @todo use a special client decoder that is based on mapping
        $xchLN.writeVarUint(encoder.restEncoder, clock);
    });
    return encoder;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Doc} doc
 *
 * @function
 */ const $3d8addc4c1746845$var$writeDocumentStateVector = (encoder, doc)=>$3d8addc4c1746845$var$writeStateVector(encoder, $3d8addc4c1746845$var$getStateVector(doc.store));
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ const $3d8addc4c1746845$var$encodeStateVectorV2 = (doc, encoder = new $3d8addc4c1746845$var$DSEncoderV2())=>{
    if (doc instanceof Map) $3d8addc4c1746845$var$writeStateVector(encoder, doc);
    else $3d8addc4c1746845$var$writeDocumentStateVector(encoder, doc);
    return encoder.toUint8Array();
};
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @return {Uint8Array}
 *
 * @function
 */ const $3d8addc4c1746845$export$3e2f5393f32e71f = (doc)=>$3d8addc4c1746845$var$encodeStateVectorV2(doc, new $3d8addc4c1746845$var$DSEncoderV1());
/**
 * General event handler implementation.
 *
 * @template ARG0, ARG1
 *
 * @private
 */ class $3d8addc4c1746845$var$EventHandler {
    constructor(){
        /**
     * @type {Array<function(ARG0, ARG1):void>}
     */ this.l = [];
    }
}
/**
 * @template ARG0,ARG1
 * @returns {EventHandler<ARG0,ARG1>}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$createEventHandler = ()=>new $3d8addc4c1746845$var$EventHandler();
/**
 * Adds an event listener that is called when
 * {@link EventHandler#callEventListeners} is called.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler.
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$addEventHandlerListener = (eventHandler, f)=>eventHandler.l.push(f);
/**
 * Removes an event listener.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler that was added with
 *                     {@link EventHandler#addEventListener}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$removeEventHandlerListener = (eventHandler, f)=>{
    const l = eventHandler.l;
    const len = l.length;
    eventHandler.l = l.filter((g)=>f !== g);
    if (len === eventHandler.l.length) console.error('[yjs] Tried to remove event handler that doesn\'t exist.');
};
/**
 * Call all event listeners that were added via
 * {@link EventHandler#addEventListener}.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {ARG0} arg0
 * @param {ARG1} arg1
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$callEventHandlerListeners = (eventHandler, arg0, arg1)=>$5Ci8T.callAll(eventHandler.l, [
        arg0,
        arg1
    ]);
class $3d8addc4c1746845$export$8be180ec26319f9f {
    /**
   * @param {number} client client id
   * @param {number} clock unique per client id, continuous number
   */ constructor(client, clock){
        /**
     * Client id
     * @type {number}
     */ this.client = client;
        /**
     * unique per client id, continuous number
     * @type {number}
     */ this.clock = clock;
    }
}
/**
 * @param {ID | null} a
 * @param {ID | null} b
 * @return {boolean}
 *
 * @function
 */ const $3d8addc4c1746845$export$c0af976e7e459c02 = (a, b)=>a === b || a !== null && b !== null && a.client === b.client && a.clock === b.clock;
/**
 * @param {number} client
 * @param {number} clock
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$export$6c7d4e6171d008d0 = (client, clock)=>new $3d8addc4c1746845$export$8be180ec26319f9f(client, clock);
/**
 * @param {encoding.Encoder} encoder
 * @param {ID} id
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$writeID = (encoder, id)=>{
    $xchLN.writeVarUint(encoder, id.client);
    $xchLN.writeVarUint(encoder, id.clock);
};
/**
 * Read ID.
 * * If first varUint read is 0xFFFFFF a RootID is returned.
 * * Otherwise an ID is returned
 *
 * @param {decoding.Decoder} decoder
 * @return {ID}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$readID = (decoder)=>$3d8addc4c1746845$export$6c7d4e6171d008d0($dB3PR.readVarUint(decoder), $dB3PR.readVarUint(decoder));
/**
 * The top types are mapped from y.share.get(keyname) => type.
 * `type` does not store any information about the `keyname`.
 * This function finds the correct `keyname` for `type` and throws otherwise.
 *
 * @param {AbstractType<any>} type
 * @return {string}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$export$e726a40920d54663 = (type)=>{
    // @ts-ignore _y must be defined, otherwise unexpected case
    for (const [key, value] of type.doc.share.entries()){
        if (value === type) return key;
    }
    throw $AgXfe.unexpectedCase();
};
/**
 * Check if `parent` is a parent of `child`.
 *
 * @param {AbstractType<any>} parent
 * @param {Item|null} child
 * @return {Boolean} Whether `parent` is a parent of `child`.
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$export$3c81af374b054d6a = (parent, child)=>{
    while(child !== null){
        if (child.parent === parent) return true;
        child = /** @type {AbstractType<any>} */ child.parent._item;
    }
    return false;
};
/**
 * Convenient helper to log type information.
 *
 * Do not use in productive systems as the output can be immense!
 *
 * @param {AbstractType<any>} type
 */ const $3d8addc4c1746845$export$e9068ad704ba2f79 = (type)=>{
    const res = [];
    let n = type._start;
    while(n){
        res.push(n);
        n = n.right;
    }
    console.log('Children: ', res);
    console.log('Children content: ', res.filter((m)=>!m.deleted).map((m)=>m.content));
};
class $3d8addc4c1746845$export$b9e8b5fa1162ca4e {
    /**
   * @param {Doc} doc
   * @param {YMap<any>} [storeType]
   */ constructor(doc, storeType = doc.getMap('users')){
        /**
     * @type {Map<string,DeleteSet>}
     */ const dss = new Map();
        this.yusers = storeType;
        this.doc = doc;
        /**
     * Maps from clientid to userDescription
     *
     * @type {Map<number,string>}
     */ this.clients = new Map();
        this.dss = dss;
        /**
     * @param {YMap<any>} user
     * @param {string} userDescription
     */ const initUser = (user, userDescription)=>{
            /**
       * @type {YArray<Uint8Array>}
       */ const ds = user.get('ds');
            const ids = user.get('ids');
            const addClientId = /** @param {number} clientid */ (clientid)=>this.clients.set(clientid, userDescription);
            ds.observe(/** @param {YArrayEvent<any>} event */ (event)=>{
                event.changes.added.forEach((item)=>{
                    item.content.getContent().forEach((encodedDs)=>{
                        if (encodedDs instanceof Uint8Array) this.dss.set(userDescription, $3d8addc4c1746845$export$b7826cadad53901e([
                            this.dss.get(userDescription) || $3d8addc4c1746845$export$8cbac0d946238699(),
                            $3d8addc4c1746845$var$readDeleteSet(new $3d8addc4c1746845$var$DSDecoderV1($dB3PR.createDecoder(encodedDs)))
                        ]));
                    });
                });
            });
            this.dss.set(userDescription, $3d8addc4c1746845$export$b7826cadad53901e(ds.map((encodedDs)=>$3d8addc4c1746845$var$readDeleteSet(new $3d8addc4c1746845$var$DSDecoderV1($dB3PR.createDecoder(encodedDs))))));
            ids.observe(/** @param {YArrayEvent<any>} event */ (event)=>event.changes.added.forEach((item)=>item.content.getContent().forEach(addClientId)));
            ids.forEach(addClientId);
        };
        // observe users
        storeType.observe((event)=>{
            event.keysChanged.forEach((userDescription)=>initUser(storeType.get(userDescription), userDescription));
        });
        // add initial data
        storeType.forEach(initUser);
    }
    /**
   * @param {Doc} doc
   * @param {number} clientid
   * @param {string} userDescription
   * @param {Object} conf
   * @param {function(Transaction, DeleteSet):boolean} [conf.filter]
   */ setUserMapping(doc, clientid, userDescription, { filter: filter = ()=>true } = {}) {
        const users = this.yusers;
        let user = users.get(userDescription);
        if (!user) {
            user = new $3d8addc4c1746845$export$a5c7b93649eaf8f8();
            user.set('ids', new $3d8addc4c1746845$export$c4be6576ca6fe4aa());
            user.set('ds', new $3d8addc4c1746845$export$c4be6576ca6fe4aa());
            users.set(userDescription, user);
        }
        user.get('ids').push([
            clientid
        ]);
        users.observe((_event)=>{
            setTimeout(()=>{
                const userOverwrite = users.get(userDescription);
                if (userOverwrite !== user) {
                    // user was overwritten, port all data over to the next user object
                    // @todo Experiment with Y.Sets here
                    user = userOverwrite;
                    // @todo iterate over old type
                    this.clients.forEach((_userDescription, clientid)=>{
                        if (userDescription === _userDescription) user.get('ids').push([
                            clientid
                        ]);
                    });
                    const encoder = new $3d8addc4c1746845$var$DSEncoderV1();
                    const ds = this.dss.get(userDescription);
                    if (ds) {
                        $3d8addc4c1746845$var$writeDeleteSet(encoder, ds);
                        user.get('ds').push([
                            encoder.toUint8Array()
                        ]);
                    }
                }
            }, 0);
        });
        doc.on('afterTransaction', /** @param {Transaction} transaction */ (transaction)=>{
            setTimeout(()=>{
                const yds = user.get('ds');
                const ds = transaction.deleteSet;
                if (transaction.local && ds.clients.size > 0 && filter(transaction, ds)) {
                    const encoder = new $3d8addc4c1746845$var$DSEncoderV1();
                    $3d8addc4c1746845$var$writeDeleteSet(encoder, ds);
                    yds.push([
                        encoder.toUint8Array()
                    ]);
                }
            });
        });
    }
    /**
   * @param {number} clientid
   * @return {any}
   */ getUserByClientId(clientid) {
        return this.clients.get(clientid) || null;
    }
    /**
   * @param {ID} id
   * @return {string | null}
   */ getUserByDeletedId(id) {
        for (const [userDescription, ds] of this.dss.entries()){
            if ($3d8addc4c1746845$export$dcb04af092e44fde(ds, id)) return userDescription;
        }
        return null;
    }
}
/**
 * A relative position is based on the Yjs model and is not affected by document changes.
 * E.g. If you place a relative position before a certain character, it will always point to this character.
 * If you place a relative position at the end of a type, it will always point to the end of the type.
 *
 * A numeric position is often unsuited for user selections, because it does not change when content is inserted
 * before or after.
 *
 * ```Insert(0, 'x')('a|bc') = 'xa|bc'``` Where | is the relative position.
 *
 * One of the properties must be defined.
 *
 * @example
 *   // Current cursor position is at position 10
 *   const relativePosition = createRelativePositionFromIndex(yText, 10)
 *   // modify yText
 *   yText.insert(0, 'abc')
 *   yText.delete(3, 10)
 *   // Compute the cursor position
 *   const absolutePosition = createAbsolutePositionFromRelativePosition(y, relativePosition)
 *   absolutePosition.type === yText // => true
 *   console.log('cursor location is ' + absolutePosition.index) // => cursor location is 3
 *
 */ class $3d8addc4c1746845$export$da21a415c5907662 {
    /**
   * @param {ID|null} type
   * @param {string|null} tname
   * @param {ID|null} item
   * @param {number} assoc
   */ constructor(type, tname, item, assoc = 0){
        /**
     * @type {ID|null}
     */ this.type = type;
        /**
     * @type {string|null}
     */ this.tname = tname;
        /**
     * @type {ID | null}
     */ this.item = item;
        /**
     * A relative position is associated to a specific character. By default
     * assoc >= 0, the relative position is associated to the character
     * after the meant position.
     * I.e. position 1 in 'ab' is associated to character 'b'.
     *
     * If assoc < 0, then the relative position is associated to the character
     * before the meant position.
     *
     * @type {number}
     */ this.assoc = assoc;
    }
}
/**
 * @param {RelativePosition} rpos
 * @return {any}
 */ const $3d8addc4c1746845$export$a783b081767a452e = (rpos)=>{
    const json = {};
    if (rpos.type) json.type = rpos.type;
    if (rpos.tname) json.tname = rpos.tname;
    if (rpos.item) json.item = rpos.item;
    if (rpos.assoc != null) json.assoc = rpos.assoc;
    return json;
};
/**
 * @param {any} json
 * @return {RelativePosition}
 *
 * @function
 */ const $3d8addc4c1746845$export$ddad8a1b8f7475d8 = (json)=>new $3d8addc4c1746845$export$da21a415c5907662(json.type == null ? null : $3d8addc4c1746845$export$6c7d4e6171d008d0(json.type.client, json.type.clock), json.tname ?? null, json.item == null ? null : $3d8addc4c1746845$export$6c7d4e6171d008d0(json.item.client, json.item.clock), json.assoc == null ? 0 : json.assoc);
class $3d8addc4c1746845$export$64c95a3fb7344864 {
    /**
   * @param {AbstractType<any>} type
   * @param {number} index
   * @param {number} [assoc]
   */ constructor(type, index, assoc = 0){
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
        /**
     * @type {number}
     */ this.index = index;
        this.assoc = assoc;
    }
}
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @param {number} [assoc]
 *
 * @function
 */ const $3d8addc4c1746845$var$createAbsolutePosition = (type, index, assoc = 0)=>new $3d8addc4c1746845$export$64c95a3fb7344864(type, index, assoc);
/**
 * @param {AbstractType<any>} type
 * @param {ID|null} item
 * @param {number} [assoc]
 *
 * @function
 */ const $3d8addc4c1746845$var$createRelativePosition = (type, item, assoc)=>{
    let typeid = null;
    let tname = null;
    if (type._item === null) tname = $3d8addc4c1746845$export$e726a40920d54663(type);
    else typeid = $3d8addc4c1746845$export$6c7d4e6171d008d0(type._item.id.client, type._item.id.clock);
    return new $3d8addc4c1746845$export$da21a415c5907662(typeid, tname, item, assoc);
};
/**
 * Create a relativePosition based on a absolute position.
 *
 * @param {AbstractType<any>} type The base type (e.g. YText or YArray).
 * @param {number} index The absolute position.
 * @param {number} [assoc]
 * @return {RelativePosition}
 *
 * @function
 */ const $3d8addc4c1746845$export$197e7d99e3857e88 = (type, index, assoc = 0)=>{
    let t = type._start;
    if (assoc < 0) {
        // associated to the left character or the beginning of a type, increment index if possible.
        if (index === 0) return $3d8addc4c1746845$var$createRelativePosition(type, null, assoc);
        index--;
    }
    while(t !== null){
        if (!t.deleted && t.countable) {
            if (t.length > index) // case 1: found position somewhere in the linked list
            return $3d8addc4c1746845$var$createRelativePosition(type, $3d8addc4c1746845$export$6c7d4e6171d008d0(t.id.client, t.id.clock + index), assoc);
            index -= t.length;
        }
        if (t.right === null && assoc < 0) // left-associated position, return last available id
        return $3d8addc4c1746845$var$createRelativePosition(type, t.lastId, assoc);
        t = t.right;
    }
    return $3d8addc4c1746845$var$createRelativePosition(type, null, assoc);
};
/**
 * @param {encoding.Encoder} encoder
 * @param {RelativePosition} rpos
 *
 * @function
 */ const $3d8addc4c1746845$var$writeRelativePosition = (encoder, rpos)=>{
    const { type: type, tname: tname, item: item, assoc: assoc } = rpos;
    if (item !== null) {
        $xchLN.writeVarUint(encoder, 0);
        $3d8addc4c1746845$var$writeID(encoder, item);
    } else if (tname !== null) {
        // case 2: found position at the end of the list and type is stored in y.share
        $xchLN.writeUint8(encoder, 1);
        $xchLN.writeVarString(encoder, tname);
    } else if (type !== null) {
        // case 3: found position at the end of the list and type is attached to an item
        $xchLN.writeUint8(encoder, 2);
        $3d8addc4c1746845$var$writeID(encoder, type);
    } else throw $AgXfe.unexpectedCase();
    $xchLN.writeVarInt(encoder, assoc);
    return encoder;
};
/**
 * @param {RelativePosition} rpos
 * @return {Uint8Array}
 */ const $3d8addc4c1746845$export$c5c95ef724203575 = (rpos)=>{
    const encoder = $xchLN.createEncoder();
    $3d8addc4c1746845$var$writeRelativePosition(encoder, rpos);
    return $xchLN.toUint8Array(encoder);
};
/**
 * @param {decoding.Decoder} decoder
 * @return {RelativePosition}
 *
 * @function
 */ const $3d8addc4c1746845$var$readRelativePosition = (decoder)=>{
    let type = null;
    let tname = null;
    let itemID = null;
    switch($dB3PR.readVarUint(decoder)){
        case 0:
            // case 1: found position somewhere in the linked list
            itemID = $3d8addc4c1746845$var$readID(decoder);
            break;
        case 1:
            // case 2: found position at the end of the list and type is stored in y.share
            tname = $dB3PR.readVarString(decoder);
            break;
        case 2:
            // case 3: found position at the end of the list and type is attached to an item
            type = $3d8addc4c1746845$var$readID(decoder);
    }
    const assoc = $dB3PR.hasContent(decoder) ? $dB3PR.readVarInt(decoder) : 0;
    return new $3d8addc4c1746845$export$da21a415c5907662(type, tname, itemID, assoc);
};
/**
 * @param {Uint8Array} uint8Array
 * @return {RelativePosition}
 */ const $3d8addc4c1746845$export$58a46cebc90e7851 = (uint8Array)=>$3d8addc4c1746845$var$readRelativePosition($dB3PR.createDecoder(uint8Array));
/**
 * @param {StructStore} store
 * @param {ID} id
 */ const $3d8addc4c1746845$var$getItemWithOffset = (store, id)=>{
    const item = $3d8addc4c1746845$export$f92dfeb71e9bb569(store, id);
    const diff = id.clock - item.id.clock;
    return {
        item: item,
        diff: diff
    };
};
/**
 * Transform a relative position to an absolute position.
 *
 * If you want to share the relative position with other users, you should set
 * `followUndoneDeletions` to false to get consistent results across all clients.
 *
 * When calculating the absolute position, we try to follow the "undone deletions". This yields
 * better results for the user who performed undo. However, only the user who performed the undo
 * will get the better results, the other users don't know which operations recreated a deleted
 * range of content. There is more information in this ticket: https://github.com/yjs/yjs/issues/638
 *
 * @param {RelativePosition} rpos
 * @param {Doc} doc
 * @param {boolean} followUndoneDeletions - whether to follow undone deletions - see https://github.com/yjs/yjs/issues/638
 * @return {AbsolutePosition|null}
 *
 * @function
 */ const $3d8addc4c1746845$export$8fc3152f62fb7ed1 = (rpos, doc, followUndoneDeletions = true)=>{
    const store = doc.store;
    const rightID = rpos.item;
    const typeID = rpos.type;
    const tname = rpos.tname;
    const assoc = rpos.assoc;
    let type = null;
    let index = 0;
    if (rightID !== null) {
        if ($3d8addc4c1746845$export$50fdfeece43146fd(store, rightID.client) <= rightID.clock) return null;
        const res = followUndoneDeletions ? $3d8addc4c1746845$var$followRedone(store, rightID) : $3d8addc4c1746845$var$getItemWithOffset(store, rightID);
        const right = res.item;
        if (!(right instanceof $3d8addc4c1746845$export$6d08773d2e66f8f2)) return null;
        type = /** @type {AbstractType<any>} */ right.parent;
        if (type._item === null || !type._item.deleted) {
            index = right.deleted || !right.countable ? 0 : res.diff + (assoc >= 0 ? 0 : 1); // adjust position based on left association if necessary
            let n = right.left;
            while(n !== null){
                if (!n.deleted && n.countable) index += n.length;
                n = n.left;
            }
        }
    } else {
        if (tname !== null) type = doc.get(tname);
        else if (typeID !== null) {
            if ($3d8addc4c1746845$export$50fdfeece43146fd(store, typeID.client) <= typeID.clock) // type does not exist yet
            return null;
            const { item: item } = followUndoneDeletions ? $3d8addc4c1746845$var$followRedone(store, typeID) : {
                item: $3d8addc4c1746845$export$f92dfeb71e9bb569(store, typeID)
            };
            if (item instanceof $3d8addc4c1746845$export$6d08773d2e66f8f2 && item.content instanceof $3d8addc4c1746845$export$e2e108cbe2e4f865) type = item.content.type;
            else // struct is garbage collected
            return null;
        } else throw $AgXfe.unexpectedCase();
        if (assoc >= 0) index = type._length;
        else index = 0;
    }
    return $3d8addc4c1746845$var$createAbsolutePosition(type, index, rpos.assoc);
};
/**
 * @param {RelativePosition|null} a
 * @param {RelativePosition|null} b
 * @return {boolean}
 *
 * @function
 */ const $3d8addc4c1746845$export$fc8bd253c948b475 = (a, b)=>a === b || a !== null && b !== null && a.tname === b.tname && $3d8addc4c1746845$export$c0af976e7e459c02(a.item, b.item) && $3d8addc4c1746845$export$c0af976e7e459c02(a.type, b.type) && a.assoc === b.assoc;
class $3d8addc4c1746845$export$c963130a5525248f {
    /**
   * @param {DeleteSet} ds
   * @param {Map<number,number>} sv state map
   */ constructor(ds, sv){
        /**
     * @type {DeleteSet}
     */ this.ds = ds;
        /**
     * State Map
     * @type {Map<number,number>}
     */ this.sv = sv;
    }
}
/**
 * @param {Snapshot} snap1
 * @param {Snapshot} snap2
 * @return {boolean}
 */ const $3d8addc4c1746845$export$742742a0f55b273d = (snap1, snap2)=>{
    const ds1 = snap1.ds.clients;
    const ds2 = snap2.ds.clients;
    const sv1 = snap1.sv;
    const sv2 = snap2.sv;
    if (sv1.size !== sv2.size || ds1.size !== ds2.size) return false;
    for (const [key, value] of sv1.entries()){
        if (sv2.get(key) !== value) return false;
    }
    for (const [client, dsitems1] of ds1.entries()){
        const dsitems2 = ds2.get(client) || [];
        if (dsitems1.length !== dsitems2.length) return false;
        for(let i = 0; i < dsitems1.length; i++){
            const dsitem1 = dsitems1[i];
            const dsitem2 = dsitems2[i];
            if (dsitem1.clock !== dsitem2.clock || dsitem1.len !== dsitem2.len) return false;
        }
    }
    return true;
};
/**
 * @param {Snapshot} snapshot
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 */ const $3d8addc4c1746845$export$b946cadc55f8e512 = (snapshot, encoder = new $3d8addc4c1746845$var$DSEncoderV2())=>{
    $3d8addc4c1746845$var$writeDeleteSet(encoder, snapshot.ds);
    $3d8addc4c1746845$var$writeStateVector(encoder, snapshot.sv);
    return encoder.toUint8Array();
};
/**
 * @param {Snapshot} snapshot
 * @return {Uint8Array}
 */ const $3d8addc4c1746845$export$a6d29989648e995 = (snapshot)=>$3d8addc4c1746845$export$b946cadc55f8e512(snapshot, new $3d8addc4c1746845$var$DSEncoderV1());
/**
 * @param {Uint8Array} buf
 * @param {DSDecoderV1 | DSDecoderV2} [decoder]
 * @return {Snapshot}
 */ const $3d8addc4c1746845$export$b0049fa299f4f58e = (buf, decoder = new $3d8addc4c1746845$var$DSDecoderV2($dB3PR.createDecoder(buf)))=>{
    return new $3d8addc4c1746845$export$c963130a5525248f($3d8addc4c1746845$var$readDeleteSet(decoder), $3d8addc4c1746845$var$readStateVector(decoder));
};
/**
 * @param {Uint8Array} buf
 * @return {Snapshot}
 */ const $3d8addc4c1746845$export$5c696daccf32bd2e = (buf)=>$3d8addc4c1746845$export$b0049fa299f4f58e(buf, new $3d8addc4c1746845$var$DSDecoderV1($dB3PR.createDecoder(buf)));
/**
 * @param {DeleteSet} ds
 * @param {Map<number,number>} sm
 * @return {Snapshot}
 */ const $3d8addc4c1746845$export$548fae0445f878fd = (ds, sm)=>new $3d8addc4c1746845$export$c963130a5525248f(ds, sm);
const $3d8addc4c1746845$export$d4568a81dd107a34 = $3d8addc4c1746845$export$548fae0445f878fd($3d8addc4c1746845$export$8cbac0d946238699(), new Map());
/**
 * @param {Doc} doc
 * @return {Snapshot}
 */ const $3d8addc4c1746845$export$b8801ea43165ed7d = (doc)=>$3d8addc4c1746845$export$548fae0445f878fd($3d8addc4c1746845$export$8450d668bec558e2(doc.store), $3d8addc4c1746845$var$getStateVector(doc.store));
/**
 * @param {Item} item
 * @param {Snapshot|undefined} snapshot
 *
 * @protected
 * @function
 */ const $3d8addc4c1746845$var$isVisible = (item, snapshot)=>snapshot === undefined ? !item.deleted : snapshot.sv.has(item.id.client) && (snapshot.sv.get(item.id.client) || 0) > item.id.clock && !$3d8addc4c1746845$export$dcb04af092e44fde(snapshot.ds, item.id);
/**
 * @param {Transaction} transaction
 * @param {Snapshot} snapshot
 */ const $3d8addc4c1746845$var$splitSnapshotAffectedStructs = (transaction, snapshot)=>{
    const meta = $iUvcZ.setIfUndefined(transaction.meta, $3d8addc4c1746845$var$splitSnapshotAffectedStructs, $ivn6P.create);
    const store = transaction.doc.store;
    // check if we already split for this snapshot
    if (!meta.has(snapshot)) {
        snapshot.sv.forEach((clock, client)=>{
            if (clock < $3d8addc4c1746845$export$50fdfeece43146fd(store, client)) $3d8addc4c1746845$export$e550586ad633138d(transaction, $3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock));
        });
        $3d8addc4c1746845$export$8afefebbaf4e4c78(transaction, snapshot.ds, (_item)=>{});
        meta.add(snapshot);
    }
};
/**
 * @example
 *  const ydoc = new Y.Doc({ gc: false })
 *  ydoc.getText().insert(0, 'world!')
 *  const snapshot = Y.snapshot(ydoc)
 *  ydoc.getText().insert(0, 'hello ')
 *  const restored = Y.createDocFromSnapshot(ydoc, snapshot)
 *  assert(restored.getText().toString() === 'world!')
 *
 * @param {Doc} originDoc
 * @param {Snapshot} snapshot
 * @param {Doc} [newDoc] Optionally, you may define the Yjs document that receives the data from originDoc
 * @return {Doc}
 */ const $3d8addc4c1746845$export$5be4ae1e1e56a014 = (originDoc, snapshot, newDoc = new $3d8addc4c1746845$export$bceacc74c2212615())=>{
    if (originDoc.gc) // we should not try to restore a GC-ed document, because some of the restored items might have their content deleted
    throw new Error('Garbage-collection must be disabled in `originDoc`!');
    const { sv: sv, ds: ds } = snapshot;
    const encoder = new $3d8addc4c1746845$export$30c99e08943e1c2();
    originDoc.transact((transaction)=>{
        let size = 0;
        sv.forEach((clock)=>{
            if (clock > 0) size++;
        });
        $xchLN.writeVarUint(encoder.restEncoder, size);
        // splitting the structs before writing them to the encoder
        for (const [client, clock] of sv){
            if (clock === 0) continue;
            if (clock < $3d8addc4c1746845$export$50fdfeece43146fd(originDoc.store, client)) $3d8addc4c1746845$export$e550586ad633138d(transaction, $3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock));
            const structs = originDoc.store.clients.get(client) || [];
            const lastStructIndex = $3d8addc4c1746845$export$5f8f02523cf47b58(structs, clock - 1);
            // write # encoded structs
            $xchLN.writeVarUint(encoder.restEncoder, lastStructIndex + 1);
            encoder.writeClient(client);
            // first clock written is 0
            $xchLN.writeVarUint(encoder.restEncoder, 0);
            for(let i = 0; i <= lastStructIndex; i++)structs[i].write(encoder, 0);
        }
        $3d8addc4c1746845$var$writeDeleteSet(encoder, ds);
    });
    $3d8addc4c1746845$export$acc3b0324aabf1b6(newDoc, encoder.toUint8Array(), 'snapshot');
    return newDoc;
};
/**
 * @param {Snapshot} snapshot
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 */ const $3d8addc4c1746845$var$snapshotContainsUpdateV2 = (snapshot, update, YDecoder = $3d8addc4c1746845$export$1c932452355c5571)=>{
    const updateDecoder = new YDecoder($dB3PR.createDecoder(update));
    const lazyDecoder = new $3d8addc4c1746845$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next()){
        if ((snapshot.sv.get(curr.id.client) || 0) < curr.id.clock + curr.length) return false;
    }
    const mergedDS = $3d8addc4c1746845$export$b7826cadad53901e([
        snapshot.ds,
        $3d8addc4c1746845$var$readDeleteSet(updateDecoder)
    ]);
    return $3d8addc4c1746845$export$9697b72c46fd3a5d(snapshot.ds, mergedDS);
};
/**
 * @param {Snapshot} snapshot
 * @param {Uint8Array} update
 */ const $3d8addc4c1746845$export$f938135bed5d8db7 = (snapshot, update)=>$3d8addc4c1746845$var$snapshotContainsUpdateV2(snapshot, update, $3d8addc4c1746845$export$1aa46d9818b5d1ec);
class $3d8addc4c1746845$var$StructStore {
    constructor(){
        /**
     * @type {Map<number,Array<GC|Item>>}
     */ this.clients = new Map();
        /**
     * @type {null | { missing: Map<number, number>, update: Uint8Array }}
     */ this.pendingStructs = null;
        /**
     * @type {null | Uint8Array}
     */ this.pendingDs = null;
    }
}
/**
 * Return the states as a Map<client,clock>.
 * Note that clock refers to the next expected clock id.
 *
 * @param {StructStore} store
 * @return {Map<number,number>}
 *
 * @public
 * @function
 */ const $3d8addc4c1746845$var$getStateVector = (store)=>{
    const sm = new Map();
    store.clients.forEach((structs, client)=>{
        const struct = structs[structs.length - 1];
        sm.set(client, struct.id.clock + struct.length);
    });
    return sm;
};
/**
 * @param {StructStore} store
 * @param {number} client
 * @return {number}
 *
 * @public
 * @function
 */ const $3d8addc4c1746845$export$50fdfeece43146fd = (store, client)=>{
    const structs = store.clients.get(client);
    if (structs === undefined) return 0;
    const lastStruct = structs[structs.length - 1];
    return lastStruct.id.clock + lastStruct.length;
};
/**
 * @param {StructStore} store
 * @param {GC|Item} struct
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$addStruct = (store, struct)=>{
    let structs = store.clients.get(struct.id.client);
    if (structs === undefined) {
        structs = [];
        store.clients.set(struct.id.client, structs);
    } else {
        const lastStruct = structs[structs.length - 1];
        if (lastStruct.id.clock + lastStruct.length !== struct.id.clock) throw $AgXfe.unexpectedCase();
    }
    structs.push(struct);
};
/**
 * Perform a binary search on a sorted array
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 * @return {number}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$export$5f8f02523cf47b58 = (structs, clock)=>{
    let left = 0;
    let right = structs.length - 1;
    let mid = structs[right];
    let midclock = mid.id.clock;
    if (midclock === clock) return right;
    // @todo does it even make sense to pivot the search?
    // If a good split misses, it might actually increase the time to find the correct item.
    // Currently, the only advantage is that search with pivoting might find the item on the first try.
    let midindex = $3Lr38.floor(clock / (midclock + mid.length - 1) * right); // pivoting the search
    while(left <= right){
        mid = structs[midindex];
        midclock = mid.id.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.length) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
        midindex = $3Lr38.floor((left + right) / 2);
    }
    // Always check state before looking for a struct in StructStore
    // Therefore the case of not finding a struct is unexpected
    throw $AgXfe.unexpectedCase();
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {GC|Item}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$find = (store, id)=>{
    /**
   * @type {Array<GC|Item>}
   */ // @ts-ignore
    const structs = store.clients.get(id.client);
    return structs[$3d8addc4c1746845$export$5f8f02523cf47b58(structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 * @private
 * @function
 */ const $3d8addc4c1746845$export$f92dfeb71e9bb569 = /** @type {function(StructStore,ID):Item} */ $3d8addc4c1746845$var$find;
/**
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 */ const $3d8addc4c1746845$var$findIndexCleanStart = (transaction, structs, clock)=>{
    const index = $3d8addc4c1746845$export$5f8f02523cf47b58(structs, clock);
    const struct = structs[index];
    if (struct.id.clock < clock && struct instanceof $3d8addc4c1746845$export$6d08773d2e66f8f2) {
        structs.splice(index + 1, 0, $3d8addc4c1746845$var$splitItem(transaction, struct, clock - struct.id.clock));
        return index + 1;
    }
    return index;
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$export$e550586ad633138d = (transaction, id)=>{
    const structs = /** @type {Array<Item>} */ transaction.doc.store.clients.get(id.client);
    return structs[$3d8addc4c1746845$var$findIndexCleanStart(transaction, structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$export$73a181de908c608 = (transaction, store, id)=>{
    /**
   * @type {Array<Item>}
   */ // @ts-ignore
    const structs = store.clients.get(id.client);
    const index = $3d8addc4c1746845$export$5f8f02523cf47b58(structs, id.clock);
    const struct = structs[index];
    if (id.clock !== struct.id.clock + struct.length - 1 && struct.constructor !== $3d8addc4c1746845$export$12d259ff017e6b58) structs.splice(index + 1, 0, $3d8addc4c1746845$var$splitItem(transaction, struct, id.clock - struct.id.clock + 1));
    return struct;
};
/**
 * Replace `item` with `newitem` in store
 * @param {StructStore} store
 * @param {GC|Item} struct
 * @param {GC|Item} newStruct
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$replaceStruct = (store, struct, newStruct)=>{
    const structs = /** @type {Array<GC|Item>} */ store.clients.get(struct.id.client);
    structs[$3d8addc4c1746845$export$5f8f02523cf47b58(structs, struct.id.clock)] = newStruct;
};
/**
 * Iterate over a range of structs
 *
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clockStart Inclusive start
 * @param {number} len
 * @param {function(GC|Item):void} f
 *
 * @function
 */ const $3d8addc4c1746845$var$iterateStructs = (transaction, structs, clockStart, len, f)=>{
    if (len === 0) return;
    const clockEnd = clockStart + len;
    let index = $3d8addc4c1746845$var$findIndexCleanStart(transaction, structs, clockStart);
    let struct;
    do {
        struct = structs[index++];
        if (clockEnd < struct.id.clock + struct.length) $3d8addc4c1746845$var$findIndexCleanStart(transaction, structs, clockEnd);
        f(struct);
    }while (index < structs.length && structs[index].id.clock < clockEnd);
};
/**
 * A transaction is created for every change on the Yjs model. It is possible
 * to bundle changes on the Yjs model in a single transaction to
 * minimize the number on messages sent and the number of observer calls.
 * If possible the user of this library should bundle as many changes as
 * possible. Here is an example to illustrate the advantages of bundling:
 *
 * @example
 * const ydoc = new Y.Doc()
 * const map = ydoc.getMap('map')
 * // Log content when change is triggered
 * map.observe(() => {
 *   console.log('change triggered')
 * })
 * // Each change on the map type triggers a log message:
 * map.set('a', 0) // => "change triggered"
 * map.set('b', 0) // => "change triggered"
 * // When put in a transaction, it will trigger the log after the transaction:
 * ydoc.transact(() => {
 *   map.set('a', 1)
 *   map.set('b', 1)
 * }) // => "change triggered"
 *
 * @public
 */ class $3d8addc4c1746845$export$febc5573c75cefb0 {
    /**
   * @param {Doc} doc
   * @param {any} origin
   * @param {boolean} local
   */ constructor(doc, origin, local){
        /**
     * The Yjs instance.
     * @type {Doc}
     */ this.doc = doc;
        /**
     * Describes the set of deleted items by ids
     * @type {DeleteSet}
     */ this.deleteSet = new $3d8addc4c1746845$var$DeleteSet();
        /**
     * Holds the state before the transaction started.
     * @type {Map<Number,Number>}
     */ this.beforeState = $3d8addc4c1746845$var$getStateVector(doc.store);
        /**
     * Holds the state after the transaction.
     * @type {Map<Number,Number>}
     */ this.afterState = new Map();
        /**
     * All types that were directly modified (property added or child
     * inserted/deleted). New types are not included in this Set.
     * Maps from type to parentSubs (`item.parentSub = null` for YArray)
     * @type {Map<AbstractType<YEvent<any>>,Set<String|null>>}
     */ this.changed = new Map();
        /**
     * Stores the events for the types that observe also child elements.
     * It is mainly used by `observeDeep`.
     * @type {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>}
     */ this.changedParentTypes = new Map();
        /**
     * @type {Array<AbstractStruct>}
     */ this._mergeStructs = [];
        /**
     * @type {any}
     */ this.origin = origin;
        /**
     * Stores meta information on the transaction
     * @type {Map<any,any>}
     */ this.meta = new Map();
        /**
     * Whether this change originates from this doc.
     * @type {boolean}
     */ this.local = local;
        /**
     * @type {Set<Doc>}
     */ this.subdocsAdded = new Set();
        /**
     * @type {Set<Doc>}
     */ this.subdocsRemoved = new Set();
        /**
     * @type {Set<Doc>}
     */ this.subdocsLoaded = new Set();
        /**
     * @type {boolean}
     */ this._needFormattingCleanup = false;
    }
}
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 * @return {boolean} Whether data was written.
 */ const $3d8addc4c1746845$var$writeUpdateMessageFromTransaction = (encoder, transaction)=>{
    if (transaction.deleteSet.clients.size === 0 && !$iUvcZ.any(transaction.afterState, (clock, client)=>transaction.beforeState.get(client) !== clock)) return false;
    $3d8addc4c1746845$var$sortAndMergeDeleteSet(transaction.deleteSet);
    $3d8addc4c1746845$var$writeStructsFromTransaction(encoder, transaction);
    $3d8addc4c1746845$var$writeDeleteSet(encoder, transaction.deleteSet);
    return true;
};
/**
 * If `type.parent` was added in current transaction, `type` technically
 * did not change, it was just added and we should not fire events for `type`.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<YEvent<any>>} type
 * @param {string|null} parentSub
 */ const $3d8addc4c1746845$var$addChangedTypeToTransaction = (transaction, type, parentSub)=>{
    const item = type._item;
    if (item === null || item.id.clock < (transaction.beforeState.get(item.id.client) || 0) && !item.deleted) $iUvcZ.setIfUndefined(transaction.changed, type, $ivn6P.create).add(parentSub);
};
/**
 * @param {Array<AbstractStruct>} structs
 * @param {number} pos
 * @return {number} # of merged structs
 */ const $3d8addc4c1746845$var$tryToMergeWithLefts = (structs, pos)=>{
    let right = structs[pos];
    let left = structs[pos - 1];
    let i = pos;
    for(; i > 0; right = left, left = structs[--i - 1]){
        if (left.deleted === right.deleted && left.constructor === right.constructor) {
            if (left.mergeWith(right)) {
                if (right instanceof $3d8addc4c1746845$export$6d08773d2e66f8f2 && right.parentSub !== null && /** @type {AbstractType<any>} */ right.parent._map.get(right.parentSub) === right) /** @type {AbstractType<any>} */ right.parent._map.set(right.parentSub, /** @type {Item} */ left);
                continue;
            }
        }
        break;
    }
    const merged = pos - i;
    if (merged) // remove all merged structs from the array
    structs.splice(pos + 1 - merged, merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ const $3d8addc4c1746845$var$tryGcDeleteSet = (ds, store, gcFilter)=>{
    for (const [client, deleteItems] of ds.clients.entries()){
        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(let di = deleteItems.length - 1; di >= 0; di--){
            const deleteItem = deleteItems[di];
            const endDeleteItemClock = deleteItem.clock + deleteItem.len;
            for(let si = $3d8addc4c1746845$export$5f8f02523cf47b58(structs, deleteItem.clock), struct = structs[si]; si < structs.length && struct.id.clock < endDeleteItemClock; struct = structs[++si]){
                const struct = structs[si];
                if (deleteItem.clock + deleteItem.len <= struct.id.clock) break;
                if (struct instanceof $3d8addc4c1746845$export$6d08773d2e66f8f2 && struct.deleted && !struct.keep && gcFilter(struct)) struct.gc(store, false);
            }
        }
    }
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 */ const $3d8addc4c1746845$var$tryMergeDeleteSet = (ds, store)=>{
    // try to merge deleted / gc'd items
    // merge from right to left for better efficiency and so we don't miss any merge targets
    ds.clients.forEach((deleteItems, client)=>{
        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(let di = deleteItems.length - 1; di >= 0; di--){
            const deleteItem = deleteItems[di];
            // start with merging the item next to the last deleted item
            const mostRightIndexToCheck = $3Lr38.min(structs.length - 1, 1 + $3d8addc4c1746845$export$5f8f02523cf47b58(structs, deleteItem.clock + deleteItem.len - 1));
            for(let si = mostRightIndexToCheck, struct = structs[si]; si > 0 && struct.id.clock >= deleteItem.clock; struct = structs[si])si -= 1 + $3d8addc4c1746845$var$tryToMergeWithLefts(structs, si);
        }
    });
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ const $3d8addc4c1746845$export$c2e5de00fc43f658 = (ds, store, gcFilter)=>{
    $3d8addc4c1746845$var$tryGcDeleteSet(ds, store, gcFilter);
    $3d8addc4c1746845$var$tryMergeDeleteSet(ds, store);
};
/**
 * @param {Array<Transaction>} transactionCleanups
 * @param {number} i
 */ const $3d8addc4c1746845$var$cleanupTransactions = (transactionCleanups, i)=>{
    if (i < transactionCleanups.length) {
        const transaction = transactionCleanups[i];
        const doc = transaction.doc;
        const store = doc.store;
        const ds = transaction.deleteSet;
        const mergeStructs = transaction._mergeStructs;
        try {
            $3d8addc4c1746845$var$sortAndMergeDeleteSet(ds);
            transaction.afterState = $3d8addc4c1746845$var$getStateVector(transaction.doc.store);
            doc.emit('beforeObserverCalls', [
                transaction,
                doc
            ]);
            /**
       * An array of event callbacks.
       *
       * Each callback is called even if the other ones throw errors.
       *
       * @type {Array<function():void>}
       */ const fs = [];
            // observe events on changed types
            transaction.changed.forEach((subs, itemtype)=>fs.push(()=>{
                    if (itemtype._item === null || !itemtype._item.deleted) itemtype._callObserver(transaction, subs);
                }));
            fs.push(()=>{
                // deep observe events
                transaction.changedParentTypes.forEach((events, type)=>{
                    // We need to think about the possibility that the user transforms the
                    // Y.Doc in the event.
                    if (type._dEH.l.length > 0 && (type._item === null || !type._item.deleted)) fs.push(()=>{
                        // The same event instance is shared by all parent types. Hence, we must set
                        // currentTarget right before calling the handlers (see #768).
                        events = events.filter((event)=>event.target._item === null || !event.target._item.deleted);
                        events.forEach((event)=>{
                            event.currentTarget = type;
                            // path is relative to the current target
                            event._path = null;
                        });
                        // sort events by path length so that top-level events are fired first.
                        events.sort((event1, event2)=>event1.path.length - event2.path.length);
                        // We don't need to check for events.length
                        // because we know it has at least one element
                        $3d8addc4c1746845$var$callEventHandlerListeners(type._dEH, events, transaction);
                    });
                });
                fs.push(()=>doc.emit('afterTransaction', [
                        transaction,
                        doc
                    ]));
                fs.push(()=>{
                    if (transaction._needFormattingCleanup) $3d8addc4c1746845$var$cleanupYTextAfterTransaction(transaction);
                });
            });
            // note the nested fs calls, must not modify fs at this point
            (0, $5Ci8T.callAll)(fs, []);
        } finally{
            // Replace deleted items with ItemDeleted / GC.
            // This is where content is actually remove from the Yjs Doc.
            if (doc.gc) $3d8addc4c1746845$var$tryGcDeleteSet(ds, store, doc.gcFilter);
            $3d8addc4c1746845$var$tryMergeDeleteSet(ds, store);
            // on all affected store.clients props, try to merge
            transaction.afterState.forEach((clock, client)=>{
                const beforeClock = transaction.beforeState.get(client) || 0;
                if (beforeClock !== clock) {
                    const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                    // we iterate from right to left so we can safely remove entries
                    const firstChangePos = $3Lr38.max($3d8addc4c1746845$export$5f8f02523cf47b58(structs, beforeClock), 1);
                    for(let i = structs.length - 1; i >= firstChangePos;)i -= 1 + $3d8addc4c1746845$var$tryToMergeWithLefts(structs, i);
                }
            });
            // try to merge mergeStructs
            // @todo: it makes more sense to transform mergeStructs to a DS, sort it, and merge from right to left
            //        but at the moment DS does not handle duplicates
            for(let i = mergeStructs.length - 1; i >= 0; i--){
                const { client: client, clock: clock } = mergeStructs[i].id;
                const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                const replacedStructPos = $3d8addc4c1746845$export$5f8f02523cf47b58(structs, clock);
                if (replacedStructPos + 1 < structs.length) {
                    if ($3d8addc4c1746845$var$tryToMergeWithLefts(structs, replacedStructPos + 1) > 1) continue; // no need to perform next check, both are already merged
                }
                if (replacedStructPos > 0) $3d8addc4c1746845$var$tryToMergeWithLefts(structs, replacedStructPos);
            }
            if (!transaction.local && transaction.afterState.get(doc.clientID) !== transaction.beforeState.get(doc.clientID)) {
                $70wUZ.print($bamwN.ORANGE, $bamwN.BOLD, '[yjs] ', $bamwN.UNBOLD, $bamwN.RED, 'Changed the client-id because another client seems to be using it.');
                doc.clientID = $3d8addc4c1746845$var$generateNewClientId();
            }
            // @todo Merge all the transactions into one and provide send the data as a single update message
            doc.emit('afterTransactionCleanup', [
                transaction,
                doc
            ]);
            if (doc._observers.has('update')) {
                const encoder = new $3d8addc4c1746845$export$99171b804d9c5b54();
                const hasContent = $3d8addc4c1746845$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit('update', [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            if (doc._observers.has('updateV2')) {
                const encoder = new $3d8addc4c1746845$export$30c99e08943e1c2();
                const hasContent = $3d8addc4c1746845$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit('updateV2', [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            const { subdocsAdded: subdocsAdded, subdocsLoaded: subdocsLoaded, subdocsRemoved: subdocsRemoved } = transaction;
            if (subdocsAdded.size > 0 || subdocsRemoved.size > 0 || subdocsLoaded.size > 0) {
                subdocsAdded.forEach((subdoc)=>{
                    subdoc.clientID = doc.clientID;
                    if (subdoc.collectionid == null) subdoc.collectionid = doc.collectionid;
                    doc.subdocs.add(subdoc);
                });
                subdocsRemoved.forEach((subdoc)=>doc.subdocs.delete(subdoc));
                doc.emit('subdocs', [
                    {
                        loaded: subdocsLoaded,
                        added: subdocsAdded,
                        removed: subdocsRemoved
                    },
                    doc,
                    transaction
                ]);
                subdocsRemoved.forEach((subdoc)=>subdoc.destroy());
            }
            if (transactionCleanups.length <= i + 1) {
                doc._transactionCleanups = [];
                doc.emit('afterAllTransactions', [
                    doc,
                    transactionCleanups
                ]);
            } else $3d8addc4c1746845$var$cleanupTransactions(transactionCleanups, i + 1);
        }
    }
};
/**
 * Implements the functionality of `y.transact(()=>{..})`
 *
 * @template T
 * @param {Doc} doc
 * @param {function(Transaction):T} f
 * @param {any} [origin=true]
 * @return {T}
 *
 * @function
 */ const $3d8addc4c1746845$export$dac1bad6146b2469 = (doc, f, origin = null, local = true)=>{
    const transactionCleanups = doc._transactionCleanups;
    let initialCall = false;
    /**
   * @type {any}
   */ let result = null;
    if (doc._transaction === null) {
        initialCall = true;
        doc._transaction = new $3d8addc4c1746845$export$febc5573c75cefb0(doc, origin, local);
        transactionCleanups.push(doc._transaction);
        if (transactionCleanups.length === 1) doc.emit('beforeAllTransactions', [
            doc
        ]);
        doc.emit('beforeTransaction', [
            doc._transaction,
            doc
        ]);
    }
    try {
        result = f(doc._transaction);
    } finally{
        if (initialCall) {
            const finishCleanup = doc._transaction === transactionCleanups[0];
            doc._transaction = null;
            if (finishCleanup) // The first transaction ended, now process observer calls.
            // Observer call may create new transactions for which we need to call the observers and do cleanup.
            // We don't want to nest these calls, so we execute these calls one after
            // another.
            // Also we need to ensure that all cleanups are called, even if the
            // observes throw errors.
            // This file is full of hacky try {} finally {} blocks to ensure that an
            // event can throw errors and also that the cleanup is called.
            $3d8addc4c1746845$var$cleanupTransactions(transactionCleanups, 0);
        }
    }
    return result;
};
class $3d8addc4c1746845$var$StackItem {
    /**
   * @param {DeleteSet} deletions
   * @param {DeleteSet} insertions
   */ constructor(deletions, insertions){
        this.insertions = insertions;
        this.deletions = deletions;
        /**
     * Use this to save and restore metadata like selection range
     */ this.meta = new Map();
    }
}
/**
 * @param {Transaction} tr
 * @param {UndoManager} um
 * @param {StackItem} stackItem
 */ const $3d8addc4c1746845$var$clearUndoManagerStackItem = (tr, um, stackItem)=>{
    $3d8addc4c1746845$export$8afefebbaf4e4c78(tr, stackItem.deletions, (item)=>{
        if (item instanceof $3d8addc4c1746845$export$6d08773d2e66f8f2 && um.scope.some((type)=>type === tr.doc || $3d8addc4c1746845$export$3c81af374b054d6a(/** @type {AbstractType<any>} */ type, item))) $3d8addc4c1746845$var$keepItem(item, false);
    });
};
/**
 * @param {UndoManager} undoManager
 * @param {Array<StackItem>} stack
 * @param {'undo'|'redo'} eventType
 * @return {StackItem?}
 */ const $3d8addc4c1746845$var$popStackItem = (undoManager, stack, eventType)=>{
    /**
   * Keep a reference to the transaction so we can fire the event with the changedParentTypes
   * @type {any}
   */ let _tr = null;
    const doc = undoManager.doc;
    const scope = undoManager.scope;
    $3d8addc4c1746845$export$dac1bad6146b2469(doc, (transaction)=>{
        while(stack.length > 0 && undoManager.currStackItem === null){
            const store = doc.store;
            const stackItem = /** @type {StackItem} */ stack.pop();
            /**
       * @type {Set<Item>}
       */ const itemsToRedo = new Set();
            /**
       * @type {Array<Item>}
       */ const itemsToDelete = [];
            let performedChange = false;
            $3d8addc4c1746845$export$8afefebbaf4e4c78(transaction, stackItem.insertions, (struct)=>{
                if (struct instanceof $3d8addc4c1746845$export$6d08773d2e66f8f2) {
                    if (struct.redone !== null) {
                        let { item: item, diff: diff } = $3d8addc4c1746845$var$followRedone(store, struct.id);
                        if (diff > 0) item = $3d8addc4c1746845$export$e550586ad633138d(transaction, $3d8addc4c1746845$export$6c7d4e6171d008d0(item.id.client, item.id.clock + diff));
                        struct = item;
                    }
                    if (!struct.deleted && scope.some((type)=>type === transaction.doc || $3d8addc4c1746845$export$3c81af374b054d6a(/** @type {AbstractType<any>} */ type, /** @type {Item} */ struct))) itemsToDelete.push(struct);
                }
            });
            $3d8addc4c1746845$export$8afefebbaf4e4c78(transaction, stackItem.deletions, (struct)=>{
                if (struct instanceof $3d8addc4c1746845$export$6d08773d2e66f8f2 && scope.some((type)=>type === transaction.doc || $3d8addc4c1746845$export$3c81af374b054d6a(/** @type {AbstractType<any>} */ type, struct)) && // Never redo structs in stackItem.insertions because they were created and deleted in the same capture interval.
                !$3d8addc4c1746845$export$dcb04af092e44fde(stackItem.insertions, struct.id)) itemsToRedo.add(struct);
            });
            itemsToRedo.forEach((struct)=>{
                performedChange = $3d8addc4c1746845$var$redoItem(transaction, struct, itemsToRedo, stackItem.insertions, undoManager.ignoreRemoteMapChanges, undoManager) !== null || performedChange;
            });
            // We want to delete in reverse order so that children are deleted before
            // parents, so we have more information available when items are filtered.
            for(let i = itemsToDelete.length - 1; i >= 0; i--){
                const item = itemsToDelete[i];
                if (undoManager.deleteFilter(item)) {
                    item.delete(transaction);
                    performedChange = true;
                }
            }
            undoManager.currStackItem = performedChange ? stackItem : null;
        }
        transaction.changed.forEach((subProps, type)=>{
            // destroy search marker if necessary
            if (subProps.has(null) && type._searchMarker) type._searchMarker.length = 0;
        });
        _tr = transaction;
    }, undoManager);
    const res = undoManager.currStackItem;
    if (res != null) {
        const changedParentTypes = _tr.changedParentTypes;
        undoManager.emit('stack-item-popped', [
            {
                stackItem: res,
                type: eventType,
                changedParentTypes: changedParentTypes,
                origin: undoManager
            },
            undoManager
        ]);
        undoManager.currStackItem = null;
    }
    return res;
};
/**
 * @typedef {Object} UndoManagerOptions
 * @property {number} [UndoManagerOptions.captureTimeout=500]
 * @property {function(Transaction):boolean} [UndoManagerOptions.captureTransaction] Do not capture changes of a Transaction if result false.
 * @property {function(Item):boolean} [UndoManagerOptions.deleteFilter=()=>true] Sometimes
 * it is necessary to filter what an Undo/Redo operation can delete. If this
 * filter returns false, the type/item won't be deleted even it is in the
 * undo/redo scope.
 * @property {Set<any>} [UndoManagerOptions.trackedOrigins=new Set([null])]
 * @property {boolean} [ignoreRemoteMapChanges] Experimental. By default, the UndoManager will never overwrite remote changes. Enable this property to enable overwriting remote changes on key-value changes (Y.Map, properties on Y.Xml, etc..).
 * @property {Doc} [doc] The document that this UndoManager operates on. Only needed if typeScope is empty.
 */ /**
 * @typedef {Object} StackItemEvent
 * @property {StackItem} StackItemEvent.stackItem
 * @property {any} StackItemEvent.origin
 * @property {'undo'|'redo'} StackItemEvent.type
 * @property {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>} StackItemEvent.changedParentTypes
 */ /**
 * Fires 'stack-item-added' event when a stack item was added to either the undo- or
 * the redo-stack. You may store additional stack information via the
 * metadata property on `event.stackItem.meta` (it is a `Map` of metadata properties).
 * Fires 'stack-item-popped' event when a stack item was popped from either the
 * undo- or the redo-stack. You may restore the saved stack information from `event.stackItem.meta`.
 *
 * @extends {ObservableV2<{'stack-item-added':function(StackItemEvent, UndoManager):void, 'stack-item-popped': function(StackItemEvent, UndoManager):void, 'stack-cleared': function({ undoStackCleared: boolean, redoStackCleared: boolean }):void, 'stack-item-updated': function(StackItemEvent, UndoManager):void }>}
 */ class $3d8addc4c1746845$export$932a3f9a7e88971c extends (0, $1UXIn.ObservableV2) {
    /**
   * @param {Doc|AbstractType<any>|Array<AbstractType<any>>} typeScope Limits the scope of the UndoManager. If this is set to a ydoc instance, all changes on that ydoc will be undone. If set to a specific type, only changes on that type or its children will be undone. Also accepts an array of types.
   * @param {UndoManagerOptions} options
   */ constructor(typeScope, { captureTimeout: captureTimeout = 500, captureTransaction: captureTransaction = (_tr)=>true, deleteFilter: deleteFilter = ()=>true, trackedOrigins: trackedOrigins = new Set([
        null
    ]), ignoreRemoteMapChanges: ignoreRemoteMapChanges = false, doc: doc = /** @type {Doc} */ $5DExo.isArray(typeScope) ? typeScope[0].doc : typeScope instanceof $3d8addc4c1746845$export$bceacc74c2212615 ? typeScope : typeScope.doc } = {}){
        super();
        /**
     * @type {Array<AbstractType<any> | Doc>}
     */ this.scope = [];
        this.doc = doc;
        this.addToScope(typeScope);
        this.deleteFilter = deleteFilter;
        trackedOrigins.add(this);
        this.trackedOrigins = trackedOrigins;
        this.captureTransaction = captureTransaction;
        /**
     * @type {Array<StackItem>}
     */ this.undoStack = [];
        /**
     * @type {Array<StackItem>}
     */ this.redoStack = [];
        /**
     * Whether the client is currently undoing (calling UndoManager.undo)
     *
     * @type {boolean}
     */ this.undoing = false;
        this.redoing = false;
        /**
     * The currently popped stack item if UndoManager.undoing or UndoManager.redoing
     *
     * @type {StackItem|null}
     */ this.currStackItem = null;
        this.lastChange = 0;
        this.ignoreRemoteMapChanges = ignoreRemoteMapChanges;
        this.captureTimeout = captureTimeout;
        /**
     * @param {Transaction} transaction
     */ this.afterTransactionHandler = (transaction)=>{
            // Only track certain transactions
            if (!this.captureTransaction(transaction) || !this.scope.some((type)=>transaction.changedParentTypes.has(/** @type {AbstractType<any>} */ type) || type === this.doc) || !this.trackedOrigins.has(transaction.origin) && (!transaction.origin || !this.trackedOrigins.has(transaction.origin.constructor))) return;
            const undoing = this.undoing;
            const redoing = this.redoing;
            const stack = undoing ? this.redoStack : this.undoStack;
            if (undoing) this.stopCapturing(); // next undo should not be appended to last stack item
            else if (!redoing) // neither undoing nor redoing: delete redoStack
            this.clear(false, true);
            const insertions = new $3d8addc4c1746845$var$DeleteSet();
            transaction.afterState.forEach((endClock, client)=>{
                const startClock = transaction.beforeState.get(client) || 0;
                const len = endClock - startClock;
                if (len > 0) $3d8addc4c1746845$var$addToDeleteSet(insertions, client, startClock, len);
            });
            const now = $g2kVL.getUnixTime();
            let didAdd = false;
            if (this.lastChange > 0 && now - this.lastChange < this.captureTimeout && stack.length > 0 && !undoing && !redoing) {
                // append change to last stack op
                const lastOp = stack[stack.length - 1];
                lastOp.deletions = $3d8addc4c1746845$export$b7826cadad53901e([
                    lastOp.deletions,
                    transaction.deleteSet
                ]);
                lastOp.insertions = $3d8addc4c1746845$export$b7826cadad53901e([
                    lastOp.insertions,
                    insertions
                ]);
            } else {
                // create a new stack op
                stack.push(new $3d8addc4c1746845$var$StackItem(transaction.deleteSet, insertions));
                didAdd = true;
            }
            if (!undoing && !redoing) this.lastChange = now;
            // make sure that deleted structs are not gc'd
            $3d8addc4c1746845$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, /** @param {Item|GC} item */ (item)=>{
                if (item instanceof $3d8addc4c1746845$export$6d08773d2e66f8f2 && this.scope.some((type)=>type === transaction.doc || $3d8addc4c1746845$export$3c81af374b054d6a(/** @type {AbstractType<any>} */ type, item))) $3d8addc4c1746845$var$keepItem(item, true);
            });
            /**
       * @type {[StackItemEvent, UndoManager]}
       */ const changeEvent = [
                {
                    stackItem: stack[stack.length - 1],
                    origin: transaction.origin,
                    type: undoing ? 'redo' : 'undo',
                    changedParentTypes: transaction.changedParentTypes
                },
                this
            ];
            if (didAdd) this.emit('stack-item-added', changeEvent);
            else this.emit('stack-item-updated', changeEvent);
        };
        this.destroy = this.destroy.bind(this);
        this.doc.on('afterTransaction', this.afterTransactionHandler);
        this.doc.on('destroy', this.destroy);
    }
    /**
   * Extend the scope.
   *
   * @param {Array<AbstractType<any> | Doc> | AbstractType<any> | Doc} ytypes
   */ addToScope(ytypes) {
        const tmpSet = new Set(this.scope);
        ytypes = $5DExo.isArray(ytypes) ? ytypes : [
            ytypes
        ];
        ytypes.forEach((ytype)=>{
            if (!tmpSet.has(ytype)) {
                tmpSet.add(ytype);
                if (ytype instanceof $3d8addc4c1746845$export$c265dc8338484497 ? ytype.doc !== this.doc : ytype !== this.doc) $70wUZ.warn('[yjs#509] Not same Y.Doc'); // use MultiDocUndoManager instead. also see https://github.com/yjs/yjs/issues/509
                this.scope.push(ytype);
            }
        });
    }
    /**
   * @param {any} origin
   */ addTrackedOrigin(origin) {
        this.trackedOrigins.add(origin);
    }
    /**
   * @param {any} origin
   */ removeTrackedOrigin(origin) {
        this.trackedOrigins.delete(origin);
    }
    clear(clearUndoStack = true, clearRedoStack = true) {
        if (clearUndoStack && this.canUndo() || clearRedoStack && this.canRedo()) this.doc.transact((tr)=>{
            if (clearUndoStack) {
                this.undoStack.forEach((item)=>$3d8addc4c1746845$var$clearUndoManagerStackItem(tr, this, item));
                this.undoStack = [];
            }
            if (clearRedoStack) {
                this.redoStack.forEach((item)=>$3d8addc4c1746845$var$clearUndoManagerStackItem(tr, this, item));
                this.redoStack = [];
            }
            this.emit('stack-cleared', [
                {
                    undoStackCleared: clearUndoStack,
                    redoStackCleared: clearRedoStack
                }
            ]);
        });
    }
    /**
   * UndoManager merges Undo-StackItem if they are created within time-gap
   * smaller than `options.captureTimeout`. Call `um.stopCapturing()` so that the next
   * StackItem won't be merged.
   *
   *
   * @example
   *     // without stopCapturing
   *     ytext.insert(0, 'a')
   *     ytext.insert(1, 'b')
   *     um.undo()
   *     ytext.toString() // => '' (note that 'ab' was removed)
   *     // with stopCapturing
   *     ytext.insert(0, 'a')
   *     um.stopCapturing()
   *     ytext.insert(0, 'b')
   *     um.undo()
   *     ytext.toString() // => 'a' (note that only 'b' was removed)
   *
   */ stopCapturing() {
        this.lastChange = 0;
    }
    /**
   * Undo last changes on type.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ undo() {
        this.undoing = true;
        let res;
        try {
            res = $3d8addc4c1746845$var$popStackItem(this, this.undoStack, 'undo');
        } finally{
            this.undoing = false;
        }
        return res;
    }
    /**
   * Redo last undo operation.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ redo() {
        this.redoing = true;
        let res;
        try {
            res = $3d8addc4c1746845$var$popStackItem(this, this.redoStack, 'redo');
        } finally{
            this.redoing = false;
        }
        return res;
    }
    /**
   * Are undo steps available?
   *
   * @return {boolean} `true` if undo is possible
   */ canUndo() {
        return this.undoStack.length > 0;
    }
    /**
   * Are redo steps available?
   *
   * @return {boolean} `true` if redo is possible
   */ canRedo() {
        return this.redoStack.length > 0;
    }
    destroy() {
        this.trackedOrigins.delete(this);
        this.doc.off('afterTransaction', this.afterTransactionHandler);
        this.doc.off('destroy', this.destroy);
        super.destroy();
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 */ function* $3d8addc4c1746845$var$lazyStructReaderGenerator(decoder) {
    const numOfStateUpdates = $dB3PR.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numOfStateUpdates; i++){
        const numberOfStructs = $dB3PR.readVarUint(decoder.restDecoder);
        const client = decoder.readClient();
        let clock = $dB3PR.readVarUint(decoder.restDecoder);
        for(let i = 0; i < numberOfStructs; i++){
            const info = decoder.readInfo();
            // @todo use switch instead of ifs
            if (info === 10) {
                const len = $dB3PR.readVarUint(decoder.restDecoder);
                yield new $3d8addc4c1746845$export$38d24f5c1eb0e4c0($3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock), len);
                clock += len;
            } else if (($8FTfp.BITS5 & info) !== 0) {
                const cantCopyParentInfo = (info & ($8FTfp.BIT7 | $8FTfp.BIT8)) === 0;
                // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                // and we read the next string as parentYKey.
                // It indicates how we store/retrieve parent from `y.share`
                // @type {string|null}
                const struct = new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock), null, (info & $8FTfp.BIT8) === $8FTfp.BIT8 ? decoder.readLeftID() : null, null, (info & $8FTfp.BIT7) === $8FTfp.BIT7 ? decoder.readRightID() : null, // @ts-ignore Force writing a string here.
                cantCopyParentInfo ? decoder.readParentInfo() ? decoder.readString() : decoder.readLeftID() : null, cantCopyParentInfo && (info & $8FTfp.BIT6) === $8FTfp.BIT6 ? decoder.readString() : null, $3d8addc4c1746845$var$readItemContent(decoder, info) // item content
                );
                yield struct;
                clock += struct.length;
            } else {
                const len = decoder.readLen();
                yield new $3d8addc4c1746845$export$12d259ff017e6b58($3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock), len);
                clock += len;
            }
        }
    }
}
class $3d8addc4c1746845$var$LazyStructReader {
    /**
   * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
   * @param {boolean} filterSkips
   */ constructor(decoder, filterSkips){
        this.gen = $3d8addc4c1746845$var$lazyStructReaderGenerator(decoder);
        /**
     * @type {null | Item | Skip | GC}
     */ this.curr = null;
        this.done = false;
        this.filterSkips = filterSkips;
        this.next();
    }
    /**
   * @return {Item | GC | Skip |null}
   */ next() {
        // ignore "Skip" structs
        do this.curr = this.gen.next().value || null;
        while (this.filterSkips && this.curr !== null && this.curr.constructor === $3d8addc4c1746845$export$38d24f5c1eb0e4c0);
        return this.curr;
    }
}
/**
 * @param {Uint8Array} update
 *
 */ const $3d8addc4c1746845$export$d6235ced6e55ace9 = (update)=>$3d8addc4c1746845$export$624b3f0248c2dc40(update, $3d8addc4c1746845$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ const $3d8addc4c1746845$export$624b3f0248c2dc40 = (update, YDecoder = $3d8addc4c1746845$export$1c932452355c5571)=>{
    const structs = [];
    const updateDecoder = new YDecoder($dB3PR.createDecoder(update));
    const lazyDecoder = new $3d8addc4c1746845$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    $70wUZ.print('Structs: ', structs);
    const ds = $3d8addc4c1746845$var$readDeleteSet(updateDecoder);
    $70wUZ.print('DeleteSet: ', ds);
};
/**
 * @param {Uint8Array} update
 *
 */ const $3d8addc4c1746845$export$aa45cba8121663dc = (update)=>$3d8addc4c1746845$export$2fed33908eb23d71(update, $3d8addc4c1746845$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ const $3d8addc4c1746845$export$2fed33908eb23d71 = (update, YDecoder = $3d8addc4c1746845$export$1c932452355c5571)=>{
    const structs = [];
    const updateDecoder = new YDecoder($dB3PR.createDecoder(update));
    const lazyDecoder = new $3d8addc4c1746845$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    return {
        structs: structs,
        ds: $3d8addc4c1746845$var$readDeleteSet(updateDecoder)
    };
};
class $3d8addc4c1746845$var$LazyStructWriter {
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ constructor(encoder){
        this.currClient = 0;
        this.startClock = 0;
        this.written = 0;
        this.encoder = encoder;
        /**
     * We want to write operations lazily, but also we need to know beforehand how many operations we want to write for each client.
     *
     * This kind of meta-information (#clients, #structs-per-client-written) is written to the restEncoder.
     *
     * We fragment the restEncoder and store a slice of it per-client until we know how many clients there are.
     * When we flush (toUint8Array) we write the restEncoder using the fragments and the meta-information.
     *
     * @type {Array<{ written: number, restEncoder: Uint8Array }>}
     */ this.clientStructs = [];
    }
}
/**
 * @param {Array<Uint8Array>} updates
 * @return {Uint8Array}
 */ const $3d8addc4c1746845$export$6319871659fd2460 = (updates)=>$3d8addc4c1746845$export$ce273d78de0331d1(updates, $3d8addc4c1746845$export$1aa46d9818b5d1ec, $3d8addc4c1746845$export$99171b804d9c5b54);
/**
 * @param {Uint8Array} update
 * @param {typeof DSEncoderV1 | typeof DSEncoderV2} YEncoder
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {Uint8Array}
 */ const $3d8addc4c1746845$export$ed51750cf3ab2381 = (update, YEncoder = $3d8addc4c1746845$var$DSEncoderV2, YDecoder = $3d8addc4c1746845$export$1c932452355c5571)=>{
    const encoder = new YEncoder();
    const updateDecoder = new $3d8addc4c1746845$var$LazyStructReader(new YDecoder($dB3PR.createDecoder(update)), false);
    let curr = updateDecoder.curr;
    if (curr !== null) {
        let size = 0;
        let currClient = curr.id.client;
        let stopCounting = curr.id.clock !== 0; // must start at 0
        let currClock = stopCounting ? 0 : curr.id.clock + curr.length;
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                if (currClock !== 0) {
                    size++;
                    // We found a new client
                    // write what we have to the encoder
                    $xchLN.writeVarUint(encoder.restEncoder, currClient);
                    $xchLN.writeVarUint(encoder.restEncoder, currClock);
                }
                currClient = curr.id.client;
                currClock = 0;
                stopCounting = curr.id.clock !== 0;
            }
            // we ignore skips
            if (curr.constructor === $3d8addc4c1746845$export$38d24f5c1eb0e4c0) stopCounting = true;
            if (!stopCounting) currClock = curr.id.clock + curr.length;
        }
        // write what we have
        if (currClock !== 0) {
            size++;
            $xchLN.writeVarUint(encoder.restEncoder, currClient);
            $xchLN.writeVarUint(encoder.restEncoder, currClock);
        }
        // prepend the size of the state vector
        const enc = $xchLN.createEncoder();
        $xchLN.writeVarUint(enc, size);
        $xchLN.writeBinaryEncoder(enc, encoder.restEncoder);
        encoder.restEncoder = enc;
        return encoder.toUint8Array();
    } else {
        $xchLN.writeVarUint(encoder.restEncoder, 0);
        return encoder.toUint8Array();
    }
};
/**
 * @param {Uint8Array} update
 * @return {Uint8Array}
 */ const $3d8addc4c1746845$export$5c451fd8502b011f = (update)=>$3d8addc4c1746845$export$ed51750cf3ab2381(update, $3d8addc4c1746845$var$DSEncoderV1, $3d8addc4c1746845$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ const $3d8addc4c1746845$export$8212a58b2178fdcf = (update, YDecoder = $3d8addc4c1746845$export$1c932452355c5571)=>{
    /**
   * @type {Map<number, number>}
   */ const from = new Map();
    /**
   * @type {Map<number, number>}
   */ const to = new Map();
    const updateDecoder = new $3d8addc4c1746845$var$LazyStructReader(new YDecoder($dB3PR.createDecoder(update)), false);
    let curr = updateDecoder.curr;
    if (curr !== null) {
        let currClient = curr.id.client;
        let currClock = curr.id.clock;
        // write the beginning to `from`
        from.set(currClient, currClock);
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                // We found a new client
                // write the end to `to`
                to.set(currClient, currClock);
                // write the beginning to `from`
                from.set(curr.id.client, curr.id.clock);
                // update currClient
                currClient = curr.id.client;
            }
            currClock = curr.id.clock + curr.length;
        }
        // write the end to `to`
        to.set(currClient, currClock);
    }
    return {
        from: from,
        to: to
    };
};
/**
 * @param {Uint8Array} update
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ const $3d8addc4c1746845$export$e212b06fd4bf78fd = (update)=>$3d8addc4c1746845$export$8212a58b2178fdcf(update, $3d8addc4c1746845$export$1aa46d9818b5d1ec);
/**
 * This method is intended to slice any kind of struct and retrieve the right part.
 * It does not handle side-effects, so it should only be used by the lazy-encoder.
 *
 * @param {Item | GC | Skip} left
 * @param {number} diff
 * @return {Item | GC}
 */ const $3d8addc4c1746845$var$sliceStruct = (left, diff)=>{
    if (left.constructor === $3d8addc4c1746845$export$12d259ff017e6b58) {
        const { client: client, clock: clock } = left.id;
        return new $3d8addc4c1746845$export$12d259ff017e6b58($3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else if (left.constructor === $3d8addc4c1746845$export$38d24f5c1eb0e4c0) {
        const { client: client, clock: clock } = left.id;
        return new $3d8addc4c1746845$export$38d24f5c1eb0e4c0($3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else {
        const leftItem = /** @type {Item} */ left;
        const { client: client, clock: clock } = leftItem.id;
        return new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock + diff), null, $3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock + diff - 1), null, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    }
};
/**
 *
 * This function works similarly to `readUpdateV2`.
 *
 * @param {Array<Uint8Array>} updates
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 * @return {Uint8Array}
 */ const $3d8addc4c1746845$export$ce273d78de0331d1 = (updates, YDecoder = $3d8addc4c1746845$export$1c932452355c5571, YEncoder = $3d8addc4c1746845$export$30c99e08943e1c2)=>{
    if (updates.length === 1) return updates[0];
    const updateDecoders = updates.map((update)=>new YDecoder($dB3PR.createDecoder(update)));
    let lazyStructDecoders = updateDecoders.map((decoder)=>new $3d8addc4c1746845$var$LazyStructReader(decoder, true));
    /**
   * @todo we don't need offset because we always slice before
   * @type {null | { struct: Item | GC | Skip, offset: number }}
   */ let currWrite = null;
    const updateEncoder = new YEncoder();
    // write structs lazily
    const lazyStructEncoder = new $3d8addc4c1746845$var$LazyStructWriter(updateEncoder);
    // Note: We need to ensure that all lazyStructDecoders are fully consumed
    // Note: Should merge document updates whenever possible - even from different updates
    // Note: Should handle that some operations cannot be applied yet ()
    while(true){
        // Write higher clients first ⇒ sort by clientID & clock and remove decoders without content
        lazyStructDecoders = lazyStructDecoders.filter((dec)=>dec.curr !== null);
        lazyStructDecoders.sort(/** @type {function(any,any):number} */ (dec1, dec2)=>{
            if (dec1.curr.id.client === dec2.curr.id.client) {
                const clockDiff = dec1.curr.id.clock - dec2.curr.id.clock;
                if (clockDiff === 0) // @todo remove references to skip since the structDecoders must filter Skips.
                return dec1.curr.constructor === dec2.curr.constructor ? 0 : dec1.curr.constructor === $3d8addc4c1746845$export$38d24f5c1eb0e4c0 ? 1 : -1 // we are filtering skips anyway.
                ;
                else return clockDiff;
            } else return dec2.curr.id.client - dec1.curr.id.client;
        });
        if (lazyStructDecoders.length === 0) break;
        const currDecoder = lazyStructDecoders[0];
        // write from currDecoder until the next operation is from another client or if filler-struct
        // then we need to reorder the decoders and find the next operation to write
        const firstClient = /** @type {Item | GC} */ currDecoder.curr.id.client;
        if (currWrite !== null) {
            let curr = /** @type {Item | GC | null} */ currDecoder.curr;
            let iterated = false;
            // iterate until we find something that we haven't written already
            // remember: first the high client-ids are written
            while(curr !== null && curr.id.clock + curr.length <= currWrite.struct.id.clock + currWrite.struct.length && curr.id.client >= currWrite.struct.id.client){
                curr = currDecoder.next();
                iterated = true;
            }
            if (curr === null || // current decoder is empty
            curr.id.client !== firstClient || // check whether there is another decoder that has has updates from `firstClient`
            iterated && curr.id.clock > currWrite.struct.id.clock + currWrite.struct.length // the above while loop was used and we are potentially missing updates
            ) continue;
            if (firstClient !== currWrite.struct.id.client) {
                $3d8addc4c1746845$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                currWrite = {
                    struct: curr,
                    offset: 0
                };
                currDecoder.next();
            } else if (currWrite.struct.id.clock + currWrite.struct.length < curr.id.clock) {
                // @todo write currStruct & set currStruct = Skip(clock = currStruct.id.clock + currStruct.length, length = curr.id.clock - self.clock)
                if (currWrite.struct.constructor === $3d8addc4c1746845$export$38d24f5c1eb0e4c0) // extend existing skip
                currWrite.struct.length = curr.id.clock + curr.length - currWrite.struct.id.clock;
                else {
                    $3d8addc4c1746845$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    const diff = curr.id.clock - currWrite.struct.id.clock - currWrite.struct.length;
                    /**
             * @type {Skip}
             */ const struct = new $3d8addc4c1746845$export$38d24f5c1eb0e4c0($3d8addc4c1746845$export$6c7d4e6171d008d0(firstClient, currWrite.struct.id.clock + currWrite.struct.length), diff);
                    currWrite = {
                        struct: struct,
                        offset: 0
                    };
                }
            } else {
                const diff = currWrite.struct.id.clock + currWrite.struct.length - curr.id.clock;
                if (diff > 0) {
                    if (currWrite.struct.constructor === $3d8addc4c1746845$export$38d24f5c1eb0e4c0) // prefer to slice Skip because the other struct might contain more information
                    currWrite.struct.length -= diff;
                    else curr = $3d8addc4c1746845$var$sliceStruct(curr, diff);
                }
                if (!currWrite.struct.mergeWith(/** @type {any} */ curr)) {
                    $3d8addc4c1746845$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    currWrite = {
                        struct: curr,
                        offset: 0
                    };
                    currDecoder.next();
                }
            }
        } else {
            currWrite = {
                struct: /** @type {Item | GC} */ currDecoder.curr,
                offset: 0
            };
            currDecoder.next();
        }
        for(let next = currDecoder.curr; next !== null && next.id.client === firstClient && next.id.clock === currWrite.struct.id.clock + currWrite.struct.length && next.constructor !== $3d8addc4c1746845$export$38d24f5c1eb0e4c0; next = currDecoder.next()){
            $3d8addc4c1746845$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
            currWrite = {
                struct: next,
                offset: 0
            };
        }
    }
    if (currWrite !== null) {
        $3d8addc4c1746845$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
        currWrite = null;
    }
    $3d8addc4c1746845$var$finishLazyStructWriting(lazyStructEncoder);
    const dss = updateDecoders.map((decoder)=>$3d8addc4c1746845$var$readDeleteSet(decoder));
    const ds = $3d8addc4c1746845$export$b7826cadad53901e(dss);
    $3d8addc4c1746845$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 */ const $3d8addc4c1746845$export$a8143edf39d2ad8e = (update, sv, YDecoder = $3d8addc4c1746845$export$1c932452355c5571, YEncoder = $3d8addc4c1746845$export$30c99e08943e1c2)=>{
    const state = $3d8addc4c1746845$export$324ac6fb20a844e3(sv);
    const encoder = new YEncoder();
    const lazyStructWriter = new $3d8addc4c1746845$var$LazyStructWriter(encoder);
    const decoder = new YDecoder($dB3PR.createDecoder(update));
    const reader = new $3d8addc4c1746845$var$LazyStructReader(decoder, false);
    while(reader.curr){
        const curr = reader.curr;
        const currClient = curr.id.client;
        const svClock = state.get(currClient) || 0;
        if (reader.curr.constructor === $3d8addc4c1746845$export$38d24f5c1eb0e4c0) {
            // the first written struct shouldn't be a skip
            reader.next();
            continue;
        }
        if (curr.id.clock + curr.length > svClock) {
            $3d8addc4c1746845$var$writeStructToLazyStructWriter(lazyStructWriter, curr, $3Lr38.max(svClock - curr.id.clock, 0));
            reader.next();
            while(reader.curr && reader.curr.id.client === currClient){
                $3d8addc4c1746845$var$writeStructToLazyStructWriter(lazyStructWriter, reader.curr, 0);
                reader.next();
            }
        } else // read until something new comes up
        while(reader.curr && reader.curr.id.client === currClient && reader.curr.id.clock + reader.curr.length <= svClock)reader.next();
    }
    $3d8addc4c1746845$var$finishLazyStructWriting(lazyStructWriter);
    // write ds
    const ds = $3d8addc4c1746845$var$readDeleteSet(decoder);
    $3d8addc4c1746845$var$writeDeleteSet(encoder, ds);
    return encoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 */ const $3d8addc4c1746845$export$bf60b51d6c283426 = (update, sv)=>$3d8addc4c1746845$export$a8143edf39d2ad8e(update, sv, $3d8addc4c1746845$export$1aa46d9818b5d1ec, $3d8addc4c1746845$export$99171b804d9c5b54);
/**
 * @param {LazyStructWriter} lazyWriter
 */ const $3d8addc4c1746845$var$flushLazyStructWriter = (lazyWriter)=>{
    if (lazyWriter.written > 0) {
        lazyWriter.clientStructs.push({
            written: lazyWriter.written,
            restEncoder: $xchLN.toUint8Array(lazyWriter.encoder.restEncoder)
        });
        lazyWriter.encoder.restEncoder = $xchLN.createEncoder();
        lazyWriter.written = 0;
    }
};
/**
 * @param {LazyStructWriter} lazyWriter
 * @param {Item | GC} struct
 * @param {number} offset
 */ const $3d8addc4c1746845$var$writeStructToLazyStructWriter = (lazyWriter, struct, offset)=>{
    // flush curr if we start another client
    if (lazyWriter.written > 0 && lazyWriter.currClient !== struct.id.client) $3d8addc4c1746845$var$flushLazyStructWriter(lazyWriter);
    if (lazyWriter.written === 0) {
        lazyWriter.currClient = struct.id.client;
        // write next client
        lazyWriter.encoder.writeClient(struct.id.client);
        // write startClock
        $xchLN.writeVarUint(lazyWriter.encoder.restEncoder, struct.id.clock + offset);
    }
    struct.write(lazyWriter.encoder, offset);
    lazyWriter.written++;
};
/**
 * Call this function when we collected all parts and want to
 * put all the parts together. After calling this method,
 * you can continue using the UpdateEncoder.
 *
 * @param {LazyStructWriter} lazyWriter
 */ const $3d8addc4c1746845$var$finishLazyStructWriting = (lazyWriter)=>{
    $3d8addc4c1746845$var$flushLazyStructWriter(lazyWriter);
    // this is a fresh encoder because we called flushCurr
    const restEncoder = lazyWriter.encoder.restEncoder;
    /**
   * Now we put all the fragments together.
   * This works similarly to `writeClientsStructs`
   */ // write # states that were updated - i.e. the clients
    $xchLN.writeVarUint(restEncoder, lazyWriter.clientStructs.length);
    for(let i = 0; i < lazyWriter.clientStructs.length; i++){
        const partStructs = lazyWriter.clientStructs[i];
        /**
     * Works similarly to `writeStructs`
     */ // write # encoded structs
        $xchLN.writeVarUint(restEncoder, partStructs.written);
        // write the rest of the fragment
        $xchLN.writeUint8Array(restEncoder, partStructs.restEncoder);
    }
};
/**
 * @param {Uint8Array} update
 * @param {function(Item|GC|Skip):Item|GC|Skip} blockTransformer
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} YDecoder
 * @param {typeof UpdateEncoderV2 | typeof UpdateEncoderV1 } YEncoder
 */ const $3d8addc4c1746845$var$convertUpdateFormat = (update, blockTransformer, YDecoder, YEncoder)=>{
    const updateDecoder = new YDecoder($dB3PR.createDecoder(update));
    const lazyDecoder = new $3d8addc4c1746845$var$LazyStructReader(updateDecoder, false);
    const updateEncoder = new YEncoder();
    const lazyWriter = new $3d8addc4c1746845$var$LazyStructWriter(updateEncoder);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())$3d8addc4c1746845$var$writeStructToLazyStructWriter(lazyWriter, blockTransformer(curr), 0);
    $3d8addc4c1746845$var$finishLazyStructWriting(lazyWriter);
    const ds = $3d8addc4c1746845$var$readDeleteSet(updateDecoder);
    $3d8addc4c1746845$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @typedef {Object} ObfuscatorOptions
 * @property {boolean} [ObfuscatorOptions.formatting=true]
 * @property {boolean} [ObfuscatorOptions.subdocs=true]
 * @property {boolean} [ObfuscatorOptions.yxml=true] Whether to obfuscate nodeName / hookName
 */ /**
 * @param {ObfuscatorOptions} obfuscator
 */ const $3d8addc4c1746845$var$createObfuscator = ({ formatting: formatting = true, subdocs: subdocs = true, yxml: yxml = true } = {})=>{
    let i = 0;
    const mapKeyCache = $iUvcZ.create();
    const nodeNameCache = $iUvcZ.create();
    const formattingKeyCache = $iUvcZ.create();
    const formattingValueCache = $iUvcZ.create();
    formattingValueCache.set(null, null); // end of a formatting range should always be the end of a formatting range
    /**
   * @param {Item|GC|Skip} block
   * @return {Item|GC|Skip}
   */ return (block)=>{
        switch(block.constructor){
            case $3d8addc4c1746845$export$12d259ff017e6b58:
            case $3d8addc4c1746845$export$38d24f5c1eb0e4c0:
                return block;
            case $3d8addc4c1746845$export$6d08773d2e66f8f2:
                {
                    const item = /** @type {Item} */ block;
                    const content = item.content;
                    switch(content.constructor){
                        case $3d8addc4c1746845$export$3b06e0b3a2ece602:
                            break;
                        case $3d8addc4c1746845$export$e2e108cbe2e4f865:
                            if (yxml) {
                                const type = /** @type {ContentType} */ content.type;
                                if (type instanceof $3d8addc4c1746845$export$4db87581d3ca170d) type.nodeName = $iUvcZ.setIfUndefined(nodeNameCache, type.nodeName, ()=>'node-' + i);
                                if (type instanceof $3d8addc4c1746845$export$ec64c1dd5e7a264) type.hookName = $iUvcZ.setIfUndefined(nodeNameCache, type.hookName, ()=>'hook-' + i);
                            }
                            break;
                        case $3d8addc4c1746845$export$1d788b93bbb631a0:
                            {
                                const c = /** @type {ContentAny} */ content;
                                c.arr = c.arr.map(()=>i);
                                break;
                            }
                        case $3d8addc4c1746845$export$e8d530cdf62d1cbd:
                            {
                                const c = /** @type {ContentBinary} */ content;
                                c.content = new Uint8Array([
                                    i
                                ]);
                                break;
                            }
                        case $3d8addc4c1746845$export$b564c0e69572c0e:
                            {
                                const c = /** @type {ContentDoc} */ content;
                                if (subdocs) {
                                    c.opts = {};
                                    c.doc.guid = i + '';
                                }
                                break;
                            }
                        case $3d8addc4c1746845$export$c3787ba7f6086664:
                            {
                                const c = /** @type {ContentEmbed} */ content;
                                c.embed = {};
                                break;
                            }
                        case $3d8addc4c1746845$export$3194899188fb5a88:
                            {
                                const c = /** @type {ContentFormat} */ content;
                                if (formatting) {
                                    c.key = $iUvcZ.setIfUndefined(formattingKeyCache, c.key, ()=>i + '');
                                    c.value = $iUvcZ.setIfUndefined(formattingValueCache, c.value, ()=>({
                                            i: i
                                        }));
                                }
                                break;
                            }
                        case $3d8addc4c1746845$export$6a907ea8f733ecf3:
                            {
                                const c = /** @type {ContentJSON} */ content;
                                c.arr = c.arr.map(()=>i);
                                break;
                            }
                        case $3d8addc4c1746845$export$ee670b2cf091bbb6:
                            {
                                const c = /** @type {ContentString} */ content;
                                c.str = $552MW.repeat(i % 10 + '', c.str.length);
                                break;
                            }
                        default:
                            // unknown content type
                            $AgXfe.unexpectedCase();
                    }
                    if (item.parentSub) item.parentSub = $iUvcZ.setIfUndefined(mapKeyCache, item.parentSub, ()=>i + '');
                    i++;
                    return block;
                }
            default:
                // unknown block-type
                $AgXfe.unexpectedCase();
        }
    };
};
/**
 * This function obfuscates the content of a Yjs update. This is useful to share
 * buggy Yjs documents while significantly limiting the possibility that a
 * developer can on the user. Note that it might still be possible to deduce
 * some information by analyzing the "structure" of the document or by analyzing
 * the typing behavior using the CRDT-related metadata that is still kept fully
 * intact.
 *
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ const $3d8addc4c1746845$export$2dc24d59ec48a24e = (update, opts)=>$3d8addc4c1746845$var$convertUpdateFormat(update, $3d8addc4c1746845$var$createObfuscator(opts), $3d8addc4c1746845$export$1aa46d9818b5d1ec, $3d8addc4c1746845$export$99171b804d9c5b54);
/**
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ const $3d8addc4c1746845$export$90648fb14f8c31aa = (update, opts)=>$3d8addc4c1746845$var$convertUpdateFormat(update, $3d8addc4c1746845$var$createObfuscator(opts), $3d8addc4c1746845$export$1c932452355c5571, $3d8addc4c1746845$export$30c99e08943e1c2);
/**
 * @param {Uint8Array} update
 */ const $3d8addc4c1746845$export$162408325d5832c = (update)=>$3d8addc4c1746845$var$convertUpdateFormat(update, $5Ci8T.id, $3d8addc4c1746845$export$1aa46d9818b5d1ec, $3d8addc4c1746845$export$30c99e08943e1c2);
/**
 * @param {Uint8Array} update
 */ const $3d8addc4c1746845$export$afffbdeed14adbd = (update)=>$3d8addc4c1746845$var$convertUpdateFormat(update, $5Ci8T.id, $3d8addc4c1746845$export$1c932452355c5571, $3d8addc4c1746845$export$99171b804d9c5b54);
const $3d8addc4c1746845$var$errorComputeChanges = 'You must not compute changes after the event-handler fired.';
/**
 * @template {AbstractType<any>} T
 * YEvent describes the changes on a YType.
 */ class $3d8addc4c1746845$export$80fac438977fb51c {
    /**
   * @param {T} target The changed type.
   * @param {Transaction} transaction
   */ constructor(target, transaction){
        /**
     * The type on which this event was created on.
     * @type {T}
     */ this.target = target;
        /**
     * The current target on which the observe callback is called.
     * @type {AbstractType<any>}
     */ this.currentTarget = target;
        /**
     * The transaction that triggered this event.
     * @type {Transaction}
     */ this.transaction = transaction;
        /**
     * @type {Object|null}
     */ this._changes = null;
        /**
     * @type {null | Map<string, { action: 'add' | 'update' | 'delete', oldValue: any }>}
     */ this._keys = null;
        /**
     * @type {null | Array<{ insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any> }>}
     */ this._delta = null;
        /**
     * @type {Array<string|number>|null}
     */ this._path = null;
    }
    /**
   * Computes the path from `y` to the changed type.
   *
   * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
   *
   * The following property holds:
   * @example
   *   let type = y
   *   event.path.forEach(dir => {
   *     type = type.get(dir)
   *   })
   *   type === event.target // => true
   */ get path() {
        return this._path || (this._path = $3d8addc4c1746845$var$getPathTo(this.currentTarget, this.target));
    }
    /**
   * Check if a struct is deleted by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ deletes(struct) {
        return $3d8addc4c1746845$export$dcb04af092e44fde(this.transaction.deleteSet, struct.id);
    }
    /**
   * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any }>}
   */ get keys() {
        if (this._keys === null) {
            if (this.transaction.doc._transactionCleanups.length === 0) throw $AgXfe.create($3d8addc4c1746845$var$errorComputeChanges);
            const keys = new Map();
            const target = this.target;
            const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
            changed.forEach((key)=>{
                if (key !== null) {
                    const item = /** @type {Item} */ target._map.get(key);
                    /**
           * @type {'delete' | 'add' | 'update'}
           */ let action;
                    let oldValue;
                    if (this.adds(item)) {
                        let prev = item.left;
                        while(prev !== null && this.adds(prev))prev = prev.left;
                        if (this.deletes(item)) {
                            if (prev !== null && this.deletes(prev)) {
                                action = 'delete';
                                oldValue = $5DExo.last(prev.content.getContent());
                            } else return;
                        } else if (prev !== null && this.deletes(prev)) {
                            action = 'update';
                            oldValue = $5DExo.last(prev.content.getContent());
                        } else {
                            action = 'add';
                            oldValue = undefined;
                        }
                    } else {
                        if (this.deletes(item)) {
                            action = 'delete';
                            oldValue = $5DExo.last(/** @type {Item} */ item.content.getContent());
                        } else return; // nop
                    }
                    keys.set(key, {
                        action: action,
                        oldValue: oldValue
                    });
                }
            });
            this._keys = keys;
        }
        return this._keys;
    }
    /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
   */ get delta() {
        return this.changes.delta;
    }
    /**
   * Check if a struct is added by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ adds(struct) {
        return struct.id.clock >= (this.transaction.beforeState.get(struct.id.client) || 0);
    }
    /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ get changes() {
        let changes = this._changes;
        if (changes === null) {
            if (this.transaction.doc._transactionCleanups.length === 0) throw $AgXfe.create($3d8addc4c1746845$var$errorComputeChanges);
            const target = this.target;
            const added = $ivn6P.create();
            const deleted = $ivn6P.create();
            /**
       * @type {Array<{insert:Array<any>}|{delete:number}|{retain:number}>}
       */ const delta = [];
            changes = {
                added: added,
                deleted: deleted,
                delta: delta,
                keys: this.keys
            };
            const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
            if (changed.has(null)) {
                /**
         * @type {any}
         */ let lastOp = null;
                const packOp = ()=>{
                    if (lastOp) delta.push(lastOp);
                };
                for(let item = target._start; item !== null; item = item.right){
                    if (item.deleted) {
                        if (this.deletes(item) && !this.adds(item)) {
                            if (lastOp === null || lastOp.delete === undefined) {
                                packOp();
                                lastOp = {
                                    delete: 0
                                };
                            }
                            lastOp.delete += item.length;
                            deleted.add(item);
                        } // else nop
                    } else if (this.adds(item)) {
                        if (lastOp === null || lastOp.insert === undefined) {
                            packOp();
                            lastOp = {
                                insert: []
                            };
                        }
                        lastOp.insert = lastOp.insert.concat(item.content.getContent());
                        added.add(item);
                    } else {
                        if (lastOp === null || lastOp.retain === undefined) {
                            packOp();
                            lastOp = {
                                retain: 0
                            };
                        }
                        lastOp.retain += item.length;
                    }
                }
                if (lastOp !== null && lastOp.retain === undefined) packOp();
            }
            this._changes = changes;
        }
        return /** @type {any} */ changes;
    }
}
/**
 * Compute the path from this type to the specified target.
 *
 * @example
 *   // `child` should be accessible via `type.get(path[0]).get(path[1])..`
 *   const path = type.getPathTo(child)
 *   // assuming `type instanceof YArray`
 *   console.log(path) // might look like => [2, 'key1']
 *   child === type.get(path[0]).get(path[1])
 *
 * @param {AbstractType<any>} parent
 * @param {AbstractType<any>} child target
 * @return {Array<string|number>} Path to the target
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$getPathTo = (parent, child)=>{
    const path = [];
    while(child._item !== null && child !== parent){
        if (child._item.parentSub !== null) // parent is map-ish
        path.unshift(child._item.parentSub);
        else {
            // parent is array-ish
            let i = 0;
            let c = /** @type {AbstractType<any>} */ child._item.parent._start;
            while(c !== child._item && c !== null){
                if (!c.deleted && c.countable) i += c.length;
                c = c.right;
            }
            path.unshift(i);
        }
        child = /** @type {AbstractType<any>} */ child._item.parent;
    }
    return path;
};
/**
 * https://docs.yjs.dev/getting-started/working-with-shared-types#caveats
 */ const $3d8addc4c1746845$var$warnPrematureAccess = ()=>{
    $70wUZ.warn('Invalid access: Add Yjs type to a document before reading data.');
};
const $3d8addc4c1746845$var$maxSearchMarker = 80;
/**
 * A unique timestamp that identifies each marker.
 *
 * Time is relative,.. this is more like an ever-increasing clock.
 *
 * @type {number}
 */ let $3d8addc4c1746845$var$globalSearchMarkerTimestamp = 0;
class $3d8addc4c1746845$var$ArraySearchMarker {
    /**
   * @param {Item} p
   * @param {number} index
   */ constructor(p, index){
        p.marker = true;
        this.p = p;
        this.index = index;
        this.timestamp = $3d8addc4c1746845$var$globalSearchMarkerTimestamp++;
    }
}
/**
 * @param {ArraySearchMarker} marker
 */ const $3d8addc4c1746845$var$refreshMarkerTimestamp = (marker)=>{
    marker.timestamp = $3d8addc4c1746845$var$globalSearchMarkerTimestamp++;
};
/**
 * This is rather complex so this function is the only thing that should overwrite a marker
 *
 * @param {ArraySearchMarker} marker
 * @param {Item} p
 * @param {number} index
 */ const $3d8addc4c1746845$var$overwriteMarker = (marker, p, index)=>{
    marker.p.marker = false;
    marker.p = p;
    p.marker = true;
    marker.index = index;
    marker.timestamp = $3d8addc4c1746845$var$globalSearchMarkerTimestamp++;
};
/**
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {Item} p
 * @param {number} index
 */ const $3d8addc4c1746845$var$markPosition = (searchMarker, p, index)=>{
    if (searchMarker.length >= $3d8addc4c1746845$var$maxSearchMarker) {
        // override oldest marker (we don't want to create more objects)
        const marker = searchMarker.reduce((a, b)=>a.timestamp < b.timestamp ? a : b);
        $3d8addc4c1746845$var$overwriteMarker(marker, p, index);
        return marker;
    } else {
        // create new marker
        const pm = new $3d8addc4c1746845$var$ArraySearchMarker(p, index);
        searchMarker.push(pm);
        return pm;
    }
};
/**
 * Search marker help us to find positions in the associative array faster.
 *
 * They speed up the process of finding a position without much bookkeeping.
 *
 * A maximum of `maxSearchMarker` objects are created.
 *
 * This function always returns a refreshed marker (updated timestamp)
 *
 * @param {AbstractType<any>} yarray
 * @param {number} index
 */ const $3d8addc4c1746845$var$findMarker = (yarray, index)=>{
    if (yarray._start === null || index === 0 || yarray._searchMarker === null) return null;
    const marker = yarray._searchMarker.length === 0 ? null : yarray._searchMarker.reduce((a, b)=>$3Lr38.abs(index - a.index) < $3Lr38.abs(index - b.index) ? a : b);
    let p = yarray._start;
    let pindex = 0;
    if (marker !== null) {
        p = marker.p;
        pindex = marker.index;
        $3d8addc4c1746845$var$refreshMarkerTimestamp(marker); // we used it, we might need to use it again
    }
    // iterate to right if possible
    while(p.right !== null && pindex < index){
        if (!p.deleted && p.countable) {
            if (index < pindex + p.length) break;
            pindex += p.length;
        }
        p = p.right;
    }
    // iterate to left if necessary (might be that pindex > index)
    while(p.left !== null && pindex > index){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // we want to make sure that p can't be merged with left, because that would screw up everything
    // in that cas just return what we have (it is most likely the best marker anyway)
    // iterate to left until p can't be merged with left
    while(p.left !== null && p.left.id.client === p.id.client && p.left.id.clock + p.left.length === p.id.clock){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // @todo remove!
    // assure position
    // {
    //   let start = yarray._start
    //   let pos = 0
    //   while (start !== p) {
    //     if (!start.deleted && start.countable) {
    //       pos += start.length
    //     }
    //     start = /** @type {Item} */ (start.right)
    //   }
    //   if (pos !== pindex) {
    //     debugger
    //     throw new Error('Gotcha position fail!')
    //   }
    // }
    // if (marker) {
    //   if (window.lengths == null) {
    //     window.lengths = []
    //     window.getLengths = () => window.lengths.sort((a, b) => a - b)
    //   }
    //   window.lengths.push(marker.index - pindex)
    //   console.log('distance', marker.index - pindex, 'len', p && p.parent.length)
    // }
    if (marker !== null && $3Lr38.abs(marker.index - pindex) < /** @type {YText|YArray<any>} */ p.parent.length / $3d8addc4c1746845$var$maxSearchMarker) {
        // adjust existing marker
        $3d8addc4c1746845$var$overwriteMarker(marker, p, pindex);
        return marker;
    } else // create new marker
    return $3d8addc4c1746845$var$markPosition(yarray._searchMarker, p, pindex);
};
/**
 * Update markers when a change happened.
 *
 * This should be called before doing a deletion!
 *
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {number} index
 * @param {number} len If insertion, len is positive. If deletion, len is negative.
 */ const $3d8addc4c1746845$var$updateMarkerChanges = (searchMarker, index, len)=>{
    for(let i = searchMarker.length - 1; i >= 0; i--){
        const m = searchMarker[i];
        if (len > 0) {
            /**
       * @type {Item|null}
       */ let p = m.p;
            p.marker = false;
            // Ideally we just want to do a simple position comparison, but this will only work if
            // search markers don't point to deleted items for formats.
            // Iterate marker to prev undeleted countable position so we know what to do when updating a position
            while(p && (p.deleted || !p.countable)){
                p = p.left;
                if (p && !p.deleted && p.countable) // adjust position. the loop should break now
                m.index -= p.length;
            }
            if (p === null || p.marker === true) {
                // remove search marker if updated position is null or if position is already marked
                searchMarker.splice(i, 1);
                continue;
            }
            m.p = p;
            p.marker = true;
        }
        if (index < m.index || len > 0 && index === m.index) m.index = $3Lr38.max(index, m.index + len);
    }
};
/**
 * Accumulate all (list) children of a type and return them as an Array.
 *
 * @param {AbstractType<any>} t
 * @return {Array<Item>}
 */ const $3d8addc4c1746845$export$5418d693f13991b3 = (t)=>{
    t.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
    let s = t._start;
    const arr = [];
    while(s){
        arr.push(s);
        s = s.right;
    }
    return arr;
};
/**
 * Call event listeners with an event. This will also add an event to all
 * parents (for `.observeDeep` handlers).
 *
 * @template EventType
 * @param {AbstractType<EventType>} type
 * @param {Transaction} transaction
 * @param {EventType} event
 */ const $3d8addc4c1746845$var$callTypeObservers = (type, transaction, event)=>{
    const changedType = type;
    const changedParentTypes = transaction.changedParentTypes;
    while(true){
        // @ts-ignore
        $iUvcZ.setIfUndefined(changedParentTypes, type, ()=>[]).push(event);
        if (type._item === null) break;
        type = /** @type {AbstractType<any>} */ type._item.parent;
    }
    $3d8addc4c1746845$var$callEventHandlerListeners(changedType._eH, event, transaction);
};
/**
 * @template EventType
 * Abstract Yjs Type class
 */ class $3d8addc4c1746845$export$c265dc8338484497 {
    constructor(){
        /**
     * @type {Item|null}
     */ this._item = null;
        /**
     * @type {Map<string,Item>}
     */ this._map = new Map();
        /**
     * @type {Item|null}
     */ this._start = null;
        /**
     * @type {Doc|null}
     */ this.doc = null;
        this._length = 0;
        /**
     * Event handlers
     * @type {EventHandler<EventType,Transaction>}
     */ this._eH = $3d8addc4c1746845$var$createEventHandler();
        /**
     * Deep event handlers
     * @type {EventHandler<Array<YEvent<any>>,Transaction>}
     */ this._dEH = $3d8addc4c1746845$var$createEventHandler();
        /**
     * @type {null | Array<ArraySearchMarker>}
     */ this._searchMarker = null;
    }
    /**
   * @return {AbstractType<any>|null}
   */ get parent() {
        return this._item ? /** @type {AbstractType<any>} */ this._item.parent : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item|null} item
   */ _integrate(y, item) {
        this.doc = y;
        this._item = item;
    }
    /**
   * @return {AbstractType<EventType>}
   */ _copy() {
        throw $AgXfe.methodUnimplemented();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {AbstractType<EventType>}
   */ clone() {
        throw $AgXfe.methodUnimplemented();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} _encoder
   */ _write(_encoder) {}
    /**
   * The first non-deleted item
   */ get _first() {
        let n = this._start;
        while(n !== null && n.deleted)n = n.right;
        return n;
    }
    /**
   * Creates YEvent and calls all type observers.
   * Must be implemented by each type.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} _parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, _parentSubs) {
        if (!transaction.local && this._searchMarker) this._searchMarker.length = 0;
    }
    /**
   * Observe all events that are created on this type.
   *
   * @param {function(EventType, Transaction):void} f Observer function
   */ observe(f) {
        $3d8addc4c1746845$var$addEventHandlerListener(this._eH, f);
    }
    /**
   * Observe all events that are created by this type and its children.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ observeDeep(f) {
        $3d8addc4c1746845$var$addEventHandlerListener(this._dEH, f);
    }
    /**
   * Unregister an observer function.
   *
   * @param {function(EventType,Transaction):void} f Observer function
   */ unobserve(f) {
        $3d8addc4c1746845$var$removeEventHandlerListener(this._eH, f);
    }
    /**
   * Unregister an observer function.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ unobserveDeep(f) {
        $3d8addc4c1746845$var$removeEventHandlerListener(this._dEH, f);
    }
    /**
   * @abstract
   * @return {any}
   */ toJSON() {}
}
/**
 * @param {AbstractType<any>} type
 * @param {number} start
 * @param {number} end
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeListSlice = (type, start, end)=>{
    type.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
    if (start < 0) start = type._length + start;
    if (end < 0) end = type._length + end;
    let len = end - start;
    const cs = [];
    let n = type._start;
    while(n !== null && len > 0){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            if (c.length <= start) start -= c.length;
            else {
                for(let i = start; i < c.length && len > 0; i++){
                    cs.push(c[i]);
                    len--;
                }
                start = 0;
            }
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeListToArray = (type)=>{
    type.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
    const cs = [];
    let n = type._start;
    while(n !== null){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @param {Snapshot} snapshot
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$export$9de42b6dda4c7e48 = (type, snapshot)=>{
    const cs = [];
    let n = type._start;
    while(n !== null){
        if (n.countable && $3d8addc4c1746845$var$isVisible(n, snapshot)) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * Executes a provided function on once on every element of this YArray.
 *
 * @param {AbstractType<any>} type
 * @param {function(any,number,any):void} f A function to execute on every element of this YArray.
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeListForEach = (type, f)=>{
    let index = 0;
    let n = type._start;
    type.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
    while(n !== null){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)f(c[i], index++, type);
        }
        n = n.right;
    }
};
/**
 * @template C,R
 * @param {AbstractType<any>} type
 * @param {function(C,number,AbstractType<any>):R} f
 * @return {Array<R>}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeListMap = (type, f)=>{
    /**
   * @type {Array<any>}
   */ const result = [];
    $3d8addc4c1746845$var$typeListForEach(type, (c, i)=>{
        result.push(f(c, i, type));
    });
    return result;
};
/**
 * @param {AbstractType<any>} type
 * @return {IterableIterator<any>}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeListCreateIterator = (type)=>{
    let n = type._start;
    /**
   * @type {Array<any>|null}
   */ let currentContent = null;
    let currentContentIndex = 0;
    return {
        [Symbol.iterator] () {
            return this;
        },
        next: ()=>{
            // find some content
            if (currentContent === null) {
                while(n !== null && n.deleted)n = n.right;
                // check if we reached the end, no need to check currentContent, because it does not exist
                if (n === null) return {
                    done: true,
                    value: undefined
                };
                // we found n, so we can set currentContent
                currentContent = n.content.getContent();
                currentContentIndex = 0;
                n = n.right; // we used the content of n, now iterate to next
            }
            const value = currentContent[currentContentIndex++];
            // check if we need to empty currentContent
            if (currentContent.length <= currentContentIndex) currentContent = null;
            return {
                done: false,
                value: value
            };
        }
    };
};
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @return {any}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeListGet = (type, index)=>{
    type.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
    const marker = $3d8addc4c1746845$var$findMarker(type, index);
    let n = type._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) return n.content.getContent()[index];
        index -= n.length;
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Item?} referenceItem
 * @param {Array<Object<string,any>|Array<any>|boolean|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeListInsertGenericsAfter = (transaction, parent, referenceItem, content)=>{
    let left = referenceItem;
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    const store = doc.store;
    const right = referenceItem === null ? parent._start : referenceItem.right;
    /**
   * @type {Array<Object|Array<any>|number|null>}
   */ let jsonContent = [];
    const packJsonContent = ()=>{
        if (jsonContent.length > 0) {
            left = new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(ownClientId, $3d8addc4c1746845$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $3d8addc4c1746845$export$1d788b93bbb631a0(jsonContent));
            left.integrate(transaction, 0);
            jsonContent = [];
        }
    };
    content.forEach((c)=>{
        if (c === null) jsonContent.push(c);
        else switch(c.constructor){
            case Number:
            case Object:
            case Boolean:
            case Array:
            case String:
                jsonContent.push(c);
                break;
            default:
                packJsonContent();
                switch(c.constructor){
                    case Uint8Array:
                    case ArrayBuffer:
                        left = new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(ownClientId, $3d8addc4c1746845$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $3d8addc4c1746845$export$e8d530cdf62d1cbd(new Uint8Array(/** @type {Uint8Array} */ c)));
                        left.integrate(transaction, 0);
                        break;
                    case $3d8addc4c1746845$export$bceacc74c2212615:
                        left = new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(ownClientId, $3d8addc4c1746845$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $3d8addc4c1746845$export$b564c0e69572c0e(/** @type {Doc} */ c));
                        left.integrate(transaction, 0);
                        break;
                    default:
                        if (c instanceof $3d8addc4c1746845$export$c265dc8338484497) {
                            left = new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(ownClientId, $3d8addc4c1746845$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $3d8addc4c1746845$export$e2e108cbe2e4f865(c));
                            left.integrate(transaction, 0);
                        } else throw new Error('Unexpected content type in insert operation');
                }
        }
    });
    packJsonContent();
};
const $3d8addc4c1746845$var$lengthExceeded = ()=>$AgXfe.create('Length exceeded!');
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeListInsertGenerics = (transaction, parent, index, content)=>{
    if (index > parent._length) throw $3d8addc4c1746845$var$lengthExceeded();
    if (index === 0) {
        if (parent._searchMarker) $3d8addc4c1746845$var$updateMarkerChanges(parent._searchMarker, index, content.length);
        return $3d8addc4c1746845$var$typeListInsertGenericsAfter(transaction, parent, null, content);
    }
    const startIndex = index;
    const marker = $3d8addc4c1746845$var$findMarker(parent, index);
    let n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
        // we need to iterate one to the left so that the algorithm works
        if (index === 0) {
            // @todo refactor this as it actually doesn't consider formats
            n = n.prev; // important! get the left undeleted item so that we can actually decrease index
            index += n && n.countable && !n.deleted ? n.length : 0;
        }
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index <= n.length) {
            if (index < n.length) // insert in-between
            $3d8addc4c1746845$export$e550586ad633138d(transaction, $3d8addc4c1746845$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
            break;
        }
        index -= n.length;
    }
    if (parent._searchMarker) $3d8addc4c1746845$var$updateMarkerChanges(parent._searchMarker, startIndex, content.length);
    return $3d8addc4c1746845$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * Pushing content is special as we generally want to push after the last item. So we don't have to update
 * the search marker.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeListPushGenerics = (transaction, parent, content)=>{
    // Use the marker with the highest index and iterate to the right.
    const marker = (parent._searchMarker || []).reduce((maxMarker, currMarker)=>currMarker.index > maxMarker.index ? currMarker : maxMarker, {
        index: 0,
        p: parent._start
    });
    let n = marker.p;
    if (n) while(n.right)n = n.right;
    return $3d8addc4c1746845$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {number} length
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeListDelete = (transaction, parent, index, length)=>{
    if (length === 0) return;
    const startIndex = index;
    const startLength = length;
    const marker = $3d8addc4c1746845$var$findMarker(parent, index);
    let n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    // compute the first item to be deleted
    for(; n !== null && index > 0; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) $3d8addc4c1746845$export$e550586ad633138d(transaction, $3d8addc4c1746845$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
        index -= n.length;
    }
    // delete all items until done
    while(length > 0 && n !== null){
        if (!n.deleted) {
            if (length < n.length) $3d8addc4c1746845$export$e550586ad633138d(transaction, $3d8addc4c1746845$export$6c7d4e6171d008d0(n.id.client, n.id.clock + length));
            n.delete(transaction);
            length -= n.length;
        }
        n = n.right;
    }
    if (length > 0) throw $3d8addc4c1746845$var$lengthExceeded();
    if (parent._searchMarker) $3d8addc4c1746845$var$updateMarkerChanges(parent._searchMarker, startIndex, -startLength + length /* in case we remove the above exception */ );
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeMapDelete = (transaction, parent, key)=>{
    const c = parent._map.get(key);
    if (c !== undefined) c.delete(transaction);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} value
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeMapSet = (transaction, parent, key, value)=>{
    const left = parent._map.get(key) || null;
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    let content;
    if (value == null) content = new $3d8addc4c1746845$export$1d788b93bbb631a0([
        value
    ]);
    else switch(value.constructor){
        case Number:
        case Object:
        case Boolean:
        case Array:
        case String:
        case Date:
        case BigInt:
            content = new $3d8addc4c1746845$export$1d788b93bbb631a0([
                value
            ]);
            break;
        case Uint8Array:
            content = new $3d8addc4c1746845$export$e8d530cdf62d1cbd(/** @type {Uint8Array} */ value);
            break;
        case $3d8addc4c1746845$export$bceacc74c2212615:
            content = new $3d8addc4c1746845$export$b564c0e69572c0e(/** @type {Doc} */ value);
            break;
        default:
            if (value instanceof $3d8addc4c1746845$export$c265dc8338484497) content = new $3d8addc4c1746845$export$e2e108cbe2e4f865(value);
            else throw new Error('Unexpected content type');
    }
    new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(ownClientId, $3d8addc4c1746845$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, null, null, parent, key, content).integrate(transaction, 0);
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeMapGet = (parent, key)=>{
    parent.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
    const val = parent._map.get(key);
    return val !== undefined && !val.deleted ? val.content.getContent()[val.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeMapGetAll = (parent)=>{
    /**
   * @type {Object<string,any>}
   */ const res = {};
    parent.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
    parent._map.forEach((value, key)=>{
        if (!value.deleted) res[key] = value.content.getContent()[value.length - 1];
    });
    return res;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {boolean}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$typeMapHas = (parent, key)=>{
    parent.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
    const val = parent._map.get(key);
    return val !== undefined && !val.deleted;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Snapshot} snapshot
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$export$a7c089bf6c22a1db = (parent, key, snapshot)=>{
    let v = parent._map.get(key) || null;
    while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
    return v !== null && $3d8addc4c1746845$var$isVisible(v, snapshot) ? v.content.getContent()[v.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @param {Snapshot} snapshot
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$export$7769bdedaef2c91b = (parent, snapshot)=>{
    /**
   * @type {Object<string,any>}
   */ const res = {};
    parent._map.forEach((value, key)=>{
        /**
     * @type {Item|null}
     */ let v = value;
        while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
        if (v !== null && $3d8addc4c1746845$var$isVisible(v, snapshot)) res[key] = v.content.getContent()[v.length - 1];
    });
    return res;
};
/**
 * @param {AbstractType<any> & { _map: Map<string, Item> }} type
 * @return {IterableIterator<Array<any>>}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$createMapIterator = (type)=>{
    type.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
    return $3ZDaC.iteratorFilter(type._map.entries(), /** @param {any} entry */ (entry)=>!entry[1].deleted);
};
/**
 * @module YArray
 */ /**
 * Event that describes the changes on a YArray
 * @template T
 * @extends YEvent<YArray<T>>
 */ class $3d8addc4c1746845$export$a095f7fee639264a extends $3d8addc4c1746845$export$80fac438977fb51c {
}
/**
 * A shared Array implementation.
 * @template T
 * @extends AbstractType<YArrayEvent<T>>
 * @implements {Iterable<T>}
 */ class $3d8addc4c1746845$export$c4be6576ca6fe4aa extends $3d8addc4c1746845$export$c265dc8338484497 {
    constructor(){
        super();
        /**
     * @type {Array<any>?}
     * @private
     */ this._prelimContent = [];
        /**
     * @type {Array<ArraySearchMarker>}
     */ this._searchMarker = [];
    }
    /**
   * Construct a new YArray containing the specified items.
   * @template {Object<string,any>|Array<any>|number|null|string|Uint8Array} T
   * @param {Array<T>} items
   * @return {YArray<T>}
   */ static from(items) {
        /**
     * @type {YArray<T>}
     */ const a = new $3d8addc4c1746845$export$c4be6576ca6fe4aa();
        a.push(items);
        return a;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        this.insert(0, /** @type {Array<any>} */ this._prelimContent);
        this._prelimContent = null;
    }
    /**
   * @return {YArray<T>}
   */ _copy() {
        return new $3d8addc4c1746845$export$c4be6576ca6fe4aa();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YArray<T>}
   */ clone() {
        /**
     * @type {YArray<T>}
     */ const arr = new $3d8addc4c1746845$export$c4be6576ca6fe4aa();
        arr.insert(0, this.toArray().map((el)=>el instanceof $3d8addc4c1746845$export$c265dc8338484497 ? /** @type {typeof el} */ el.clone() : el));
        return arr;
    }
    get length() {
        this.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
        return this._length;
    }
    /**
   * Creates YArrayEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        super._callObserver(transaction, parentSubs);
        $3d8addc4c1746845$var$callTypeObservers(this, transaction, new $3d8addc4c1746845$export$a095f7fee639264a(this, transaction));
    }
    /**
   * Inserts new content at an index.
   *
   * Important: This function expects an array of content. Not just a content
   * object. The reason for this "weirdness" is that inserting several elements
   * is very efficient when it is done as a single operation.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  yarray.insert(0, ['a'])
   *  // Insert numbers 1, 2 at position 1
   *  yarray.insert(1, [1, 2])
   *
   * @param {number} index The index to insert content at.
   * @param {Array<T>} content The array of content
   */ insert(index, content) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $3d8addc4c1746845$var$typeListInsertGenerics(transaction, this, index, /** @type {any} */ content);
        });
        else /** @type {Array<any>} */ this._prelimContent.splice(index, 0, ...content);
    }
    /**
   * Appends content to this YArray.
   *
   * @param {Array<T>} content Array of content to append.
   *
   * @todo Use the following implementation in all types.
   */ push(content) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $3d8addc4c1746845$var$typeListPushGenerics(transaction, this, /** @type {any} */ content);
        });
        else /** @type {Array<any>} */ this._prelimContent.push(...content);
    }
    /**
   * Prepends content to this YArray.
   *
   * @param {Array<T>} content Array of content to prepend.
   */ unshift(content) {
        this.insert(0, content);
    }
    /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} length The number of elements to remove. Defaults to 1.
   */ delete(index, length = 1) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $3d8addc4c1746845$var$typeListDelete(transaction, this, index, length);
        });
        else /** @type {Array<any>} */ this._prelimContent.splice(index, length);
    }
    /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {T}
   */ get(index) {
        return $3d8addc4c1746845$var$typeListGet(this, index);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<T>}
   */ toArray() {
        return $3d8addc4c1746845$var$typeListToArray(this);
    }
    /**
   * Returns a portion of this YArray into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<T>}
   */ slice(start = 0, end = this.length) {
        return $3d8addc4c1746845$var$typeListSlice(this, start, end);
    }
    /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Array<any>}
   */ toJSON() {
        return this.map((c)=>c instanceof $3d8addc4c1746845$export$c265dc8338484497 ? c.toJSON() : c);
    }
    /**
   * Returns an Array with the result of calling a provided function on every
   * element of this YArray.
   *
   * @template M
   * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
   * @return {Array<M>} A new array with each element being the result of the
   *                 callback function
   */ map(f) {
        return $3d8addc4c1746845$var$typeListMap(this, /** @type {any} */ f);
    }
    /**
   * Executes a provided function once on every element of this YArray.
   *
   * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        $3d8addc4c1746845$var$typeListForEach(this, f);
    }
    /**
   * @return {IterableIterator<T>}
   */ [Symbol.iterator]() {
        return $3d8addc4c1746845$var$typeListCreateIterator(this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($3d8addc4c1746845$var$YArrayRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$readYArray = (_decoder)=>new $3d8addc4c1746845$export$c4be6576ca6fe4aa();
/**
 * @module YMap
 */ /**
 * @template T
 * @extends YEvent<YMap<T>>
 * Event that describes the changes on a YMap.
 */ class $3d8addc4c1746845$export$33aab1b1a47c1cc3 extends $3d8addc4c1746845$export$80fac438977fb51c {
    /**
   * @param {YMap<T>} ymap The YArray that changed.
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed.
   */ constructor(ymap, transaction, subs){
        super(ymap, transaction);
        this.keysChanged = subs;
    }
}
/**
 * @template MapType
 * A shared Map implementation.
 *
 * @extends AbstractType<YMapEvent<MapType>>
 * @implements {Iterable<[string, MapType]>}
 */ class $3d8addc4c1746845$export$a5c7b93649eaf8f8 extends $3d8addc4c1746845$export$c265dc8338484497 {
    /**
   *
   * @param {Iterable<readonly [string, any]>=} entries - an optional iterable to initialize the YMap
   */ constructor(entries){
        super();
        /**
     * @type {Map<string,any>?}
     * @private
     */ this._prelimContent = null;
        if (entries === undefined) this._prelimContent = new Map();
        else this._prelimContent = new Map(entries);
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item); /** @type {Map<string, any>} */ 
        this._prelimContent.forEach((value, key)=>{
            this.set(key, value);
        });
        this._prelimContent = null;
    }
    /**
   * @return {YMap<MapType>}
   */ _copy() {
        return new $3d8addc4c1746845$export$a5c7b93649eaf8f8();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YMap<MapType>}
   */ clone() {
        /**
     * @type {YMap<MapType>}
     */ const map = new $3d8addc4c1746845$export$a5c7b93649eaf8f8();
        this.forEach((value, key)=>{
            map.set(key, value instanceof $3d8addc4c1746845$export$c265dc8338484497 ? /** @type {typeof value} */ value.clone() : value);
        });
        return map;
    }
    /**
   * Creates YMapEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        $3d8addc4c1746845$var$callTypeObservers(this, transaction, new $3d8addc4c1746845$export$33aab1b1a47c1cc3(this, transaction, parentSubs));
    }
    /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Object<string,any>}
   */ toJSON() {
        this.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
        /**
     * @type {Object<string,MapType>}
     */ const map = {};
        this._map.forEach((item, key)=>{
            if (!item.deleted) {
                const v = item.content.getContent()[item.length - 1];
                map[key] = v instanceof $3d8addc4c1746845$export$c265dc8338484497 ? v.toJSON() : v;
            }
        });
        return map;
    }
    /**
   * Returns the size of the YMap (count of key/value pairs)
   *
   * @return {number}
   */ get size() {
        return [
            ...$3d8addc4c1746845$var$createMapIterator(this)
        ].length;
    }
    /**
   * Returns the keys for each element in the YMap Type.
   *
   * @return {IterableIterator<string>}
   */ keys() {
        return $3ZDaC.iteratorMap($3d8addc4c1746845$var$createMapIterator(this), /** @param {any} v */ (v)=>v[0]);
    }
    /**
   * Returns the values for each element in the YMap Type.
   *
   * @return {IterableIterator<MapType>}
   */ values() {
        return $3ZDaC.iteratorMap($3d8addc4c1746845$var$createMapIterator(this), /** @param {any} v */ (v)=>v[1].content.getContent()[v[1].length - 1]);
    }
    /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */ entries() {
        return $3ZDaC.iteratorMap($3d8addc4c1746845$var$createMapIterator(this), /** @param {any} v */ (v)=>/** @type {any} */ [
                v[0],
                v[1].content.getContent()[v[1].length - 1]
            ]);
    }
    /**
   * Executes a provided function on once on every key-value pair.
   *
   * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        this.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
        this._map.forEach((item, key)=>{
            if (!item.deleted) f(item.content.getContent()[item.length - 1], key, this);
        });
    }
    /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
   * Remove a specified element from this YMap.
   *
   * @param {string} key The key of the element to remove.
   */ delete(key) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $3d8addc4c1746845$var$typeMapDelete(transaction, this, key);
        });
        else /** @type {Map<string, any>} */ this._prelimContent.delete(key);
    }
    /**
   * Adds or updates an element with a specified key and value.
   * @template {MapType} VAL
   *
   * @param {string} key The key of the element to add to this YMap
   * @param {VAL} value The value of the element to add
   * @return {VAL}
   */ set(key, value) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $3d8addc4c1746845$var$typeMapSet(transaction, this, key, /** @type {any} */ value);
        });
        else /** @type {Map<string, any>} */ this._prelimContent.set(key, value);
        return value;
    }
    /**
   * Returns a specified element from this YMap.
   *
   * @param {string} key
   * @return {MapType|undefined}
   */ get(key) {
        return /** @type {any} */ $3d8addc4c1746845$var$typeMapGet(this, key);
    }
    /**
   * Returns a boolean indicating whether the specified key exists or not.
   *
   * @param {string} key The key to test.
   * @return {boolean}
   */ has(key) {
        return $3d8addc4c1746845$var$typeMapHas(this, key);
    }
    /**
   * Removes all elements from this YMap.
   */ clear() {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            this.forEach(function(_value, key, map) {
                $3d8addc4c1746845$var$typeMapDelete(transaction, map, key);
            });
        });
        else /** @type {Map<string, any>} */ this._prelimContent.clear();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($3d8addc4c1746845$var$YMapRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$readYMap = (_decoder)=>new $3d8addc4c1746845$export$a5c7b93649eaf8f8();
/**
 * @module YText
 */ /**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */ const $3d8addc4c1746845$var$equalAttrs = (a, b)=>a === b || typeof a === 'object' && typeof b === 'object' && a && b && $kqHhc.equalFlat(a, b);
class $3d8addc4c1746845$var$ItemTextListPosition {
    /**
   * @param {Item|null} left
   * @param {Item|null} right
   * @param {number} index
   * @param {Map<string,any>} currentAttributes
   */ constructor(left, right, index, currentAttributes){
        this.left = left;
        this.right = right;
        this.index = index;
        this.currentAttributes = currentAttributes;
    }
    /**
   * Only call this if you know that this.right is defined
   */ forward() {
        if (this.right === null) $AgXfe.unexpectedCase();
        switch(this.right.content.constructor){
            case $3d8addc4c1746845$export$3194899188fb5a88:
                if (!this.right.deleted) $3d8addc4c1746845$var$updateCurrentAttributes(this.currentAttributes, /** @type {ContentFormat} */ this.right.content);
                break;
            default:
                if (!this.right.deleted) this.index += this.right.length;
                break;
        }
        this.left = this.right;
        this.right = this.right.right;
    }
}
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} pos
 * @param {number} count steps to move forward
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$findNextPosition = (transaction, pos, count)=>{
    while(pos.right !== null && count > 0){
        switch(pos.right.content.constructor){
            case $3d8addc4c1746845$export$3194899188fb5a88:
                if (!pos.right.deleted) $3d8addc4c1746845$var$updateCurrentAttributes(pos.currentAttributes, /** @type {ContentFormat} */ pos.right.content);
                break;
            default:
                if (!pos.right.deleted) {
                    if (count < pos.right.length) // split right
                    $3d8addc4c1746845$export$e550586ad633138d(transaction, $3d8addc4c1746845$export$6c7d4e6171d008d0(pos.right.id.client, pos.right.id.clock + count));
                    pos.index += pos.right.length;
                    count -= pos.right.length;
                }
                break;
        }
        pos.left = pos.right;
        pos.right = pos.right.right;
    // pos.forward() - we don't forward because that would halve the performance because we already do the checks above
    }
    return pos;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {boolean} useSearchMarker
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$findPosition = (transaction, parent, index, useSearchMarker)=>{
    const currentAttributes = new Map();
    const marker = useSearchMarker ? $3d8addc4c1746845$var$findMarker(parent, index) : null;
    if (marker) {
        const pos = new $3d8addc4c1746845$var$ItemTextListPosition(marker.p.left, marker.p, marker.index, currentAttributes);
        return $3d8addc4c1746845$var$findNextPosition(transaction, pos, index - marker.index);
    } else {
        const pos = new $3d8addc4c1746845$var$ItemTextListPosition(null, parent._start, 0, currentAttributes);
        return $3d8addc4c1746845$var$findNextPosition(transaction, pos, index);
    }
};
/**
 * Negate applied formats
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Map<string,any>} negatedAttributes
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$insertNegatedAttributes = (transaction, parent, currPos, negatedAttributes)=>{
    // check if we really need to remove attributes
    while(currPos.right !== null && (currPos.right.deleted === true || currPos.right.content.constructor === $3d8addc4c1746845$export$3194899188fb5a88 && $3d8addc4c1746845$var$equalAttrs(negatedAttributes.get(/** @type {ContentFormat} */ currPos.right.content.key), /** @type {ContentFormat} */ currPos.right.content.value))){
        if (!currPos.right.deleted) negatedAttributes.delete(/** @type {ContentFormat} */ currPos.right.content.key);
        currPos.forward();
    }
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    negatedAttributes.forEach((val, key)=>{
        const left = currPos.left;
        const right = currPos.right;
        const nextFormat = new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(ownClientId, $3d8addc4c1746845$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $3d8addc4c1746845$export$3194899188fb5a88(key, val));
        nextFormat.integrate(transaction, 0);
        currPos.right = nextFormat;
        currPos.forward();
    });
};
/**
 * @param {Map<string,any>} currentAttributes
 * @param {ContentFormat} format
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$updateCurrentAttributes = (currentAttributes, format)=>{
    const { key: key, value: value } = format;
    if (value === null) currentAttributes.delete(key);
    else currentAttributes.set(key, value);
};
/**
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$minimizeAttributeChanges = (currPos, attributes)=>{
    // go right while attributes[right.key] === right.value (or right is deleted)
    while(true){
        if (currPos.right === null) break;
        else if (currPos.right.deleted || currPos.right.content.constructor === $3d8addc4c1746845$export$3194899188fb5a88 && $3d8addc4c1746845$var$equalAttrs(attributes[/** @type {ContentFormat} */ currPos.right.content.key] ?? null, /** @type {ContentFormat} */ currPos.right.content.value)) ;
        else break;
        currPos.forward();
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 * @return {Map<string,any>}
 *
 * @private
 * @function
 **/ const $3d8addc4c1746845$var$insertAttributes = (transaction, parent, currPos, attributes)=>{
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    const negatedAttributes = new Map();
    // insert format-start items
    for(const key in attributes){
        const val = attributes[key];
        const currentVal = currPos.currentAttributes.get(key) ?? null;
        if (!$3d8addc4c1746845$var$equalAttrs(currentVal, val)) {
            // save negated attribute (set null if currentVal undefined)
            negatedAttributes.set(key, currentVal);
            const { left: left, right: right } = currPos;
            currPos.right = new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(ownClientId, $3d8addc4c1746845$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $3d8addc4c1746845$export$3194899188fb5a88(key, val));
            currPos.right.integrate(transaction, 0);
            currPos.forward();
        }
    }
    return negatedAttributes;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {string|object|AbstractType<any>} text
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 **/ const $3d8addc4c1746845$var$insertText = (transaction, parent, currPos, text, attributes)=>{
    currPos.currentAttributes.forEach((_val, key)=>{
        if (attributes[key] === undefined) attributes[key] = null;
    });
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    $3d8addc4c1746845$var$minimizeAttributeChanges(currPos, attributes);
    const negatedAttributes = $3d8addc4c1746845$var$insertAttributes(transaction, parent, currPos, attributes);
    // insert content
    const content = text.constructor === String ? new $3d8addc4c1746845$export$ee670b2cf091bbb6(/** @type {string} */ text) : text instanceof $3d8addc4c1746845$export$c265dc8338484497 ? new $3d8addc4c1746845$export$e2e108cbe2e4f865(text) : new $3d8addc4c1746845$export$c3787ba7f6086664(text);
    let { left: left, right: right, index: index } = currPos;
    if (parent._searchMarker) $3d8addc4c1746845$var$updateMarkerChanges(parent._searchMarker, currPos.index, content.getLength());
    right = new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(ownClientId, $3d8addc4c1746845$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, content);
    right.integrate(transaction, 0);
    currPos.right = right;
    currPos.index = index;
    currPos.forward();
    $3d8addc4c1746845$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$formatText = (transaction, parent, currPos, length, attributes)=>{
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    $3d8addc4c1746845$var$minimizeAttributeChanges(currPos, attributes);
    const negatedAttributes = $3d8addc4c1746845$var$insertAttributes(transaction, parent, currPos, attributes);
    // iterate until first non-format or null is found
    // delete all formats with attributes[format.key] != null
    // also check the attributes after the first non-format as we do not want to insert redundant negated attributes there
    // eslint-disable-next-line no-labels
    iterationLoop: while(currPos.right !== null && (length > 0 || negatedAttributes.size > 0 && (currPos.right.deleted || currPos.right.content.constructor === $3d8addc4c1746845$export$3194899188fb5a88))){
        if (!currPos.right.deleted) switch(currPos.right.content.constructor){
            case $3d8addc4c1746845$export$3194899188fb5a88:
                {
                    const { key: key, value: value } = /** @type {ContentFormat} */ currPos.right.content;
                    const attr = attributes[key];
                    if (attr !== undefined) {
                        if ($3d8addc4c1746845$var$equalAttrs(attr, value)) negatedAttributes.delete(key);
                        else {
                            if (length === 0) break iterationLoop;
                            negatedAttributes.set(key, value);
                        }
                        currPos.right.delete(transaction);
                    } else currPos.currentAttributes.set(key, value);
                    break;
                }
            default:
                if (length < currPos.right.length) $3d8addc4c1746845$export$e550586ad633138d(transaction, $3d8addc4c1746845$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                break;
        }
        currPos.forward();
    }
    // Quill just assumes that the editor starts with a newline and that it always
    // ends with a newline. We only insert that newline when a new newline is
    // inserted - i.e when length is bigger than type.length
    if (length > 0) {
        let newlines = '';
        for(; length > 0; length--)newlines += '\n';
        currPos.right = new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(ownClientId, $3d8addc4c1746845$export$50fdfeece43146fd(doc.store, ownClientId)), currPos.left, currPos.left && currPos.left.lastId, currPos.right, currPos.right && currPos.right.id, parent, null, new $3d8addc4c1746845$export$ee670b2cf091bbb6(newlines));
        currPos.right.integrate(transaction, 0);
        currPos.forward();
    }
    $3d8addc4c1746845$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * Call this function after string content has been deleted in order to
 * clean up formatting Items.
 *
 * @param {Transaction} transaction
 * @param {Item} start
 * @param {Item|null} curr exclusive end, automatically iterates to the next Content Item
 * @param {Map<string,any>} startAttributes
 * @param {Map<string,any>} currAttributes
 * @return {number} The amount of formatting Items deleted.
 *
 * @function
 */ const $3d8addc4c1746845$var$cleanupFormattingGap = (transaction, start, curr, startAttributes, currAttributes)=>{
    /**
   * @type {Item|null}
   */ let end = start;
    /**
   * @type {Map<string,ContentFormat>}
   */ const endFormats = $iUvcZ.create();
    while(end && (!end.countable || end.deleted)){
        if (!end.deleted && end.content.constructor === $3d8addc4c1746845$export$3194899188fb5a88) {
            const cf = /** @type {ContentFormat} */ end.content;
            endFormats.set(cf.key, cf);
        }
        end = end.right;
    }
    let cleanups = 0;
    let reachedCurr = false;
    while(start !== end){
        if (curr === start) reachedCurr = true;
        if (!start.deleted) {
            const content = start.content;
            switch(content.constructor){
                case $3d8addc4c1746845$export$3194899188fb5a88:
                    {
                        const { key: key, value: value } = /** @type {ContentFormat} */ content;
                        const startAttrValue = startAttributes.get(key) ?? null;
                        if (endFormats.get(key) !== content || startAttrValue === value) {
                            // Either this format is overwritten or it is not necessary because the attribute already existed.
                            start.delete(transaction);
                            cleanups++;
                            if (!reachedCurr && (currAttributes.get(key) ?? null) === value && startAttrValue !== value) {
                                if (startAttrValue === null) currAttributes.delete(key);
                                else currAttributes.set(key, startAttrValue);
                            }
                        }
                        if (!reachedCurr && !start.deleted) $3d8addc4c1746845$var$updateCurrentAttributes(currAttributes, /** @type {ContentFormat} */ content);
                        break;
                    }
            }
        }
        start = /** @type {Item} */ start.right;
    }
    return cleanups;
};
/**
 * @param {Transaction} transaction
 * @param {Item | null} item
 */ const $3d8addc4c1746845$var$cleanupContextlessFormattingGap = (transaction, item)=>{
    // iterate until item.right is null or content
    while(item && item.right && (item.right.deleted || !item.right.countable))item = item.right;
    const attrs = new Set();
    // iterate back until a content item is found
    while(item && (item.deleted || !item.countable)){
        if (!item.deleted && item.content.constructor === $3d8addc4c1746845$export$3194899188fb5a88) {
            const key = /** @type {ContentFormat} */ item.content.key;
            if (attrs.has(key)) item.delete(transaction);
            else attrs.add(key);
        }
        item = item.left;
    }
};
/**
 * This function is experimental and subject to change / be removed.
 *
 * Ideally, we don't need this function at all. Formatting attributes should be cleaned up
 * automatically after each change. This function iterates twice over the complete YText type
 * and removes unnecessary formatting attributes. This is also helpful for testing.
 *
 * This function won't be exported anymore as soon as there is confidence that the YText type works as intended.
 *
 * @param {YText} type
 * @return {number} How many formatting attributes have been cleaned up.
 */ const $3d8addc4c1746845$export$5d9f53c13ebffb65 = (type)=>{
    let res = 0;
    $3d8addc4c1746845$export$dac1bad6146b2469(/** @type {Doc} */ type.doc, (transaction)=>{
        let start = /** @type {Item} */ type._start;
        let end = type._start;
        let startAttributes = $iUvcZ.create();
        const currentAttributes = $iUvcZ.copy(startAttributes);
        while(end){
            if (end.deleted === false) switch(end.content.constructor){
                case $3d8addc4c1746845$export$3194899188fb5a88:
                    $3d8addc4c1746845$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ end.content);
                    break;
                default:
                    res += $3d8addc4c1746845$var$cleanupFormattingGap(transaction, start, end, startAttributes, currentAttributes);
                    startAttributes = $iUvcZ.copy(currentAttributes);
                    start = end;
                    break;
            }
            end = end.right;
        }
    });
    return res;
};
/**
 * This will be called by the transaction once the event handlers are called to potentially cleanup
 * formatting attributes.
 *
 * @param {Transaction} transaction
 */ const $3d8addc4c1746845$var$cleanupYTextAfterTransaction = (transaction)=>{
    /**
   * @type {Set<YText>}
   */ const needFullCleanup = new Set();
    // check if another formatting item was inserted
    const doc = transaction.doc;
    for (const [client, afterClock] of transaction.afterState.entries()){
        const clock = transaction.beforeState.get(client) || 0;
        if (afterClock === clock) continue;
        $3d8addc4c1746845$var$iterateStructs(transaction, /** @type {Array<Item|GC>} */ doc.store.clients.get(client), clock, afterClock, (item)=>{
            if (!item.deleted && /** @type {Item} */ item.content.constructor === $3d8addc4c1746845$export$3194899188fb5a88 && item.constructor !== $3d8addc4c1746845$export$12d259ff017e6b58) needFullCleanup.add(/** @type {any} */ item.parent);
        });
    }
    // cleanup in a new transaction
    $3d8addc4c1746845$export$dac1bad6146b2469(doc, (t)=>{
        $3d8addc4c1746845$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, (item)=>{
            if (item instanceof $3d8addc4c1746845$export$12d259ff017e6b58 || !/** @type {YText} */ item.parent._hasFormatting || needFullCleanup.has(/** @type {YText} */ item.parent)) return;
            const parent = /** @type {YText} */ item.parent;
            if (item.content.constructor === $3d8addc4c1746845$export$3194899188fb5a88) needFullCleanup.add(parent);
            else // If no formatting attribute was inserted or deleted, we can make due with contextless
            // formatting cleanups.
            // Contextless: it is not necessary to compute currentAttributes for the affected position.
            $3d8addc4c1746845$var$cleanupContextlessFormattingGap(t, item);
        });
        // If a formatting item was inserted, we simply clean the whole type.
        // We need to compute currentAttributes for the current position anyway.
        for (const yText of needFullCleanup)$3d8addc4c1746845$export$5d9f53c13ebffb65(yText);
    });
};
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$deleteText = (transaction, currPos, length)=>{
    const startLength = length;
    const startAttrs = $iUvcZ.copy(currPos.currentAttributes);
    const start = currPos.right;
    while(length > 0 && currPos.right !== null){
        if (currPos.right.deleted === false) switch(currPos.right.content.constructor){
            case $3d8addc4c1746845$export$e2e108cbe2e4f865:
            case $3d8addc4c1746845$export$c3787ba7f6086664:
            case $3d8addc4c1746845$export$ee670b2cf091bbb6:
                if (length < currPos.right.length) $3d8addc4c1746845$export$e550586ad633138d(transaction, $3d8addc4c1746845$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                currPos.right.delete(transaction);
                break;
        }
        currPos.forward();
    }
    if (start) $3d8addc4c1746845$var$cleanupFormattingGap(transaction, start, currPos.right, startAttrs, currPos.currentAttributes);
    const parent = /** @type {AbstractType<any>} */ /** @type {Item} */ (currPos.left || currPos.right).parent;
    if (parent._searchMarker) $3d8addc4c1746845$var$updateMarkerChanges(parent._searchMarker, currPos.index, -startLength + length);
    return currPos;
};
/**
 * The Quill Delta format represents changes on a text document with
 * formatting information. For more information visit {@link https://quilljs.com/docs/delta/|Quill Delta}
 *
 * @example
 *   {
 *     ops: [
 *       { insert: 'Gandalf', attributes: { bold: true } },
 *       { insert: ' the ' },
 *       { insert: 'Grey', attributes: { color: '#cccccc' } }
 *     ]
 *   }
 *
 */ /**
  * Attributes that can be assigned to a selection of text.
  *
  * @example
  *   {
  *     bold: true,
  *     font-size: '40px'
  *   }
  *
  * @typedef {Object} TextAttributes
  */ /**
 * @extends YEvent<YText>
 * Event that describes the changes on a YText type.
 */ class $3d8addc4c1746845$export$51155b8ebb74188a extends $3d8addc4c1746845$export$80fac438977fb51c {
    /**
   * @param {YText} ytext
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed
   */ constructor(ytext, transaction, subs){
        super(ytext, transaction);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ this.keysChanged = new Set();
        subs.forEach((sub)=>{
            if (sub === null) this.childListChanged = true;
            else this.keysChanged.add(sub);
        });
    }
    /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ get changes() {
        if (this._changes === null) {
            /**
       * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string|AbstractType<any>|object, delete?:number, retain?:number}>}}
       */ const changes = {
                keys: this.keys,
                delta: this.delta,
                added: new Set(),
                deleted: new Set()
            };
            this._changes = changes;
        }
        return /** @type {any} */ this._changes;
    }
    /**
   * Compute the changes in the delta format.
   * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
   *
   * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
   *
   * @public
   */ get delta() {
        if (this._delta === null) {
            const y = /** @type {Doc} */ this.target.doc;
            /**
       * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
       */ const delta = [];
            $3d8addc4c1746845$export$dac1bad6146b2469(y, (transaction)=>{
                const currentAttributes = new Map(); // saves all current attributes for insert
                const oldAttributes = new Map();
                let item = this.target._start;
                /**
         * @type {string?}
         */ let action = null;
                /**
         * @type {Object<string,any>}
         */ const attributes = {}; // counts added or removed new attributes for retain
                /**
         * @type {string|object}
         */ let insert = '';
                let retain = 0;
                let deleteLen = 0;
                const addOp = ()=>{
                    if (action !== null) {
                        /**
             * @type {any}
             */ let op = null;
                        switch(action){
                            case 'delete':
                                if (deleteLen > 0) op = {
                                    delete: deleteLen
                                };
                                deleteLen = 0;
                                break;
                            case 'insert':
                                if (typeof insert === 'object' || insert.length > 0) {
                                    op = {
                                        insert: insert
                                    };
                                    if (currentAttributes.size > 0) {
                                        op.attributes = {};
                                        currentAttributes.forEach((value, key)=>{
                                            if (value !== null) op.attributes[key] = value;
                                        });
                                    }
                                }
                                insert = '';
                                break;
                            case 'retain':
                                if (retain > 0) {
                                    op = {
                                        retain: retain
                                    };
                                    if (!$kqHhc.isEmpty(attributes)) op.attributes = $kqHhc.assign({}, attributes);
                                }
                                retain = 0;
                                break;
                        }
                        if (op) delta.push(op);
                        action = null;
                    }
                };
                while(item !== null){
                    switch(item.content.constructor){
                        case $3d8addc4c1746845$export$e2e108cbe2e4f865:
                        case $3d8addc4c1746845$export$c3787ba7f6086664:
                            if (this.adds(item)) {
                                if (!this.deletes(item)) {
                                    addOp();
                                    action = 'insert';
                                    insert = item.content.getContent()[0];
                                    addOp();
                                }
                            } else if (this.deletes(item)) {
                                if (action !== 'delete') {
                                    addOp();
                                    action = 'delete';
                                }
                                deleteLen += 1;
                            } else if (!item.deleted) {
                                if (action !== 'retain') {
                                    addOp();
                                    action = 'retain';
                                }
                                retain += 1;
                            }
                            break;
                        case $3d8addc4c1746845$export$ee670b2cf091bbb6:
                            if (this.adds(item)) {
                                if (!this.deletes(item)) {
                                    if (action !== 'insert') {
                                        addOp();
                                        action = 'insert';
                                    }
                                    insert += /** @type {ContentString} */ item.content.str;
                                }
                            } else if (this.deletes(item)) {
                                if (action !== 'delete') {
                                    addOp();
                                    action = 'delete';
                                }
                                deleteLen += item.length;
                            } else if (!item.deleted) {
                                if (action !== 'retain') {
                                    addOp();
                                    action = 'retain';
                                }
                                retain += item.length;
                            }
                            break;
                        case $3d8addc4c1746845$export$3194899188fb5a88:
                            {
                                const { key: key, value: value } = /** @type {ContentFormat} */ item.content;
                                if (this.adds(item)) {
                                    if (!this.deletes(item)) {
                                        const curVal = currentAttributes.get(key) ?? null;
                                        if (!$3d8addc4c1746845$var$equalAttrs(curVal, value)) {
                                            if (action === 'retain') addOp();
                                            if ($3d8addc4c1746845$var$equalAttrs(value, oldAttributes.get(key) ?? null)) delete attributes[key];
                                            else attributes[key] = value;
                                        } else if (value !== null) item.delete(transaction);
                                    }
                                } else if (this.deletes(item)) {
                                    oldAttributes.set(key, value);
                                    const curVal = currentAttributes.get(key) ?? null;
                                    if (!$3d8addc4c1746845$var$equalAttrs(curVal, value)) {
                                        if (action === 'retain') addOp();
                                        attributes[key] = curVal;
                                    }
                                } else if (!item.deleted) {
                                    oldAttributes.set(key, value);
                                    const attr = attributes[key];
                                    if (attr !== undefined) {
                                        if (!$3d8addc4c1746845$var$equalAttrs(attr, value)) {
                                            if (action === 'retain') addOp();
                                            if (value === null) delete attributes[key];
                                            else attributes[key] = value;
                                        } else if (attr !== null) item.delete(transaction);
                                    }
                                }
                                if (!item.deleted) {
                                    if (action === 'insert') addOp();
                                    $3d8addc4c1746845$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ item.content);
                                }
                                break;
                            }
                    }
                    item = item.right;
                }
                addOp();
                while(delta.length > 0){
                    const lastOp = delta[delta.length - 1];
                    if (lastOp.retain !== undefined && lastOp.attributes === undefined) // retain delta's if they don't assign attributes
                    delta.pop();
                    else break;
                }
            });
            this._delta = delta;
        }
        return /** @type {any} */ this._delta;
    }
}
/**
 * Type that represents text with formatting information.
 *
 * This type replaces y-richtext as this implementation is able to handle
 * block formats (format information on a paragraph), embeds (complex elements
 * like pictures and videos), and text formats (**bold**, *italic*).
 *
 * @extends AbstractType<YTextEvent>
 */ class $3d8addc4c1746845$export$5f1af8db9871e1d6 extends $3d8addc4c1746845$export$c265dc8338484497 {
    /**
   * @param {String} [string] The initial value of the YText.
   */ constructor(string){
        super();
        /**
     * Array of pending operations on this type
     * @type {Array<function():void>?}
     */ this._pending = string !== undefined ? [
            ()=>this.insert(0, string)
        ] : [];
        /**
     * @type {Array<ArraySearchMarker>|null}
     */ this._searchMarker = [];
        /**
     * Whether this YText contains formatting attributes.
     * This flag is updated when a formatting item is integrated (see ContentFormat.integrate)
     */ this._hasFormatting = false;
    }
    /**
   * Number of characters of this text type.
   *
   * @type {number}
   */ get length() {
        this.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
        return this._length;
    }
    /**
   * @param {Doc} y
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        try {
            /** @type {Array<function>} */ this._pending.forEach((f)=>f());
        } catch (e) {
            console.error(e);
        }
        this._pending = null;
    }
    _copy() {
        return new $3d8addc4c1746845$export$5f1af8db9871e1d6();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YText}
   */ clone() {
        const text = new $3d8addc4c1746845$export$5f1af8db9871e1d6();
        text.applyDelta(this.toDelta());
        return text;
    }
    /**
   * Creates YTextEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        super._callObserver(transaction, parentSubs);
        const event = new $3d8addc4c1746845$export$51155b8ebb74188a(this, transaction, parentSubs);
        $3d8addc4c1746845$var$callTypeObservers(this, transaction, event);
        // If a remote change happened, we try to cleanup potential formatting duplicates.
        if (!transaction.local && this._hasFormatting) transaction._needFormattingCleanup = true;
    }
    /**
   * Returns the unformatted string representation of this YText type.
   *
   * @public
   */ toString() {
        this.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
        let str = '';
        /**
     * @type {Item|null}
     */ let n = this._start;
        while(n !== null){
            if (!n.deleted && n.countable && n.content.constructor === $3d8addc4c1746845$export$ee670b2cf091bbb6) str += /** @type {ContentString} */ n.content.str;
            n = n.right;
        }
        return str;
    }
    /**
   * Returns the unformatted string representation of this YText type.
   *
   * @return {string}
   * @public
   */ toJSON() {
        return this.toString();
    }
    /**
   * Apply a {@link Delta} on this shared YText type.
   *
   * @param {Array<any>} delta The changes to apply on this element.
   * @param {object}  opts
   * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
   *
   *
   * @public
   */ applyDelta(delta, { sanitize: sanitize = true } = {}) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            const currPos = new $3d8addc4c1746845$var$ItemTextListPosition(null, this._start, 0, new Map());
            for(let i = 0; i < delta.length; i++){
                const op = delta[i];
                if (op.insert !== undefined) {
                    // Quill assumes that the content starts with an empty paragraph.
                    // Yjs/Y.Text assumes that it starts empty. We always hide that
                    // there is a newline at the end of the content.
                    // If we omit this step, clients will see a different number of
                    // paragraphs, but nothing bad will happen.
                    const ins = !sanitize && typeof op.insert === 'string' && i === delta.length - 1 && currPos.right === null && op.insert.slice(-1) === '\n' ? op.insert.slice(0, -1) : op.insert;
                    if (typeof ins !== 'string' || ins.length > 0) $3d8addc4c1746845$var$insertText(transaction, this, currPos, ins, op.attributes || {});
                } else if (op.retain !== undefined) $3d8addc4c1746845$var$formatText(transaction, this, currPos, op.retain, op.attributes || {});
                else if (op.delete !== undefined) $3d8addc4c1746845$var$deleteText(transaction, currPos, op.delete);
            }
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.applyDelta(delta));
    }
    /**
   * Returns the Delta representation of this YText type.
   *
   * @param {Snapshot} [snapshot]
   * @param {Snapshot} [prevSnapshot]
   * @param {function('removed' | 'added', ID):any} [computeYChange]
   * @return {any} The Delta representation of this type.
   *
   * @public
   */ toDelta(snapshot, prevSnapshot, computeYChange) {
        this.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
        /**
     * @type{Array<any>}
     */ const ops = [];
        const currentAttributes = new Map();
        const doc = /** @type {Doc} */ this.doc;
        let str = '';
        let n = this._start;
        function packStr() {
            if (str.length > 0) {
                // pack str with attributes to ops
                /**
         * @type {Object<string,any>}
         */ const attributes = {};
                let addAttributes = false;
                currentAttributes.forEach((value, key)=>{
                    addAttributes = true;
                    attributes[key] = value;
                });
                /**
         * @type {Object<string,any>}
         */ const op = {
                    insert: str
                };
                if (addAttributes) op.attributes = attributes;
                ops.push(op);
                str = '';
            }
        }
        const computeDelta = ()=>{
            while(n !== null){
                if ($3d8addc4c1746845$var$isVisible(n, snapshot) || prevSnapshot !== undefined && $3d8addc4c1746845$var$isVisible(n, prevSnapshot)) switch(n.content.constructor){
                    case $3d8addc4c1746845$export$ee670b2cf091bbb6:
                        {
                            const cur = currentAttributes.get('ychange');
                            if (snapshot !== undefined && !$3d8addc4c1746845$var$isVisible(n, snapshot)) {
                                if (cur === undefined || cur.user !== n.id.client || cur.type !== 'removed') {
                                    packStr();
                                    currentAttributes.set('ychange', computeYChange ? computeYChange('removed', n.id) : {
                                        type: 'removed'
                                    });
                                }
                            } else if (prevSnapshot !== undefined && !$3d8addc4c1746845$var$isVisible(n, prevSnapshot)) {
                                if (cur === undefined || cur.user !== n.id.client || cur.type !== 'added') {
                                    packStr();
                                    currentAttributes.set('ychange', computeYChange ? computeYChange('added', n.id) : {
                                        type: 'added'
                                    });
                                }
                            } else if (cur !== undefined) {
                                packStr();
                                currentAttributes.delete('ychange');
                            }
                            str += /** @type {ContentString} */ n.content.str;
                            break;
                        }
                    case $3d8addc4c1746845$export$e2e108cbe2e4f865:
                    case $3d8addc4c1746845$export$c3787ba7f6086664:
                        {
                            packStr();
                            /**
               * @type {Object<string,any>}
               */ const op = {
                                insert: n.content.getContent()[0]
                            };
                            if (currentAttributes.size > 0) {
                                const attrs = /** @type {Object<string,any>} */ {};
                                op.attributes = attrs;
                                currentAttributes.forEach((value, key)=>{
                                    attrs[key] = value;
                                });
                            }
                            ops.push(op);
                            break;
                        }
                    case $3d8addc4c1746845$export$3194899188fb5a88:
                        if ($3d8addc4c1746845$var$isVisible(n, snapshot)) {
                            packStr();
                            $3d8addc4c1746845$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ n.content);
                        }
                        break;
                }
                n = n.right;
            }
            packStr();
        };
        if (snapshot || prevSnapshot) // snapshots are merged again after the transaction, so we need to keep the
        // transaction alive until we are done
        $3d8addc4c1746845$export$dac1bad6146b2469(doc, (transaction)=>{
            if (snapshot) $3d8addc4c1746845$var$splitSnapshotAffectedStructs(transaction, snapshot);
            if (prevSnapshot) $3d8addc4c1746845$var$splitSnapshotAffectedStructs(transaction, prevSnapshot);
            computeDelta();
        }, 'cleanup');
        else computeDelta();
        return ops;
    }
    /**
   * Insert text at a given index.
   *
   * @param {number} index The index at which to start inserting.
   * @param {String} text The text to insert at the specified position.
   * @param {TextAttributes} [attributes] Optionally define some formatting
   *                                    information to apply on the inserted
   *                                    Text.
   * @public
   */ insert(index, text, attributes) {
        if (text.length <= 0) return;
        const y = this.doc;
        if (y !== null) $3d8addc4c1746845$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $3d8addc4c1746845$var$findPosition(transaction, this, index, !attributes);
            if (!attributes) {
                attributes = {};
                // @ts-ignore
                pos.currentAttributes.forEach((v, k)=>{
                    attributes[k] = v;
                });
            }
            $3d8addc4c1746845$var$insertText(transaction, this, pos, text, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.insert(index, text, attributes));
    }
    /**
   * Inserts an embed at a index.
   *
   * @param {number} index The index to insert the embed at.
   * @param {Object | AbstractType<any>} embed The Object that represents the embed.
   * @param {TextAttributes} [attributes] Attribute information to apply on the
   *                                    embed
   *
   * @public
   */ insertEmbed(index, embed, attributes) {
        const y = this.doc;
        if (y !== null) $3d8addc4c1746845$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $3d8addc4c1746845$var$findPosition(transaction, this, index, !attributes);
            $3d8addc4c1746845$var$insertText(transaction, this, pos, embed, attributes || {});
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.insertEmbed(index, embed, attributes || {}));
    }
    /**
   * Deletes text starting from an index.
   *
   * @param {number} index Index at which to start deleting.
   * @param {number} length The number of characters to remove. Defaults to 1.
   *
   * @public
   */ delete(index, length) {
        if (length === 0) return;
        const y = this.doc;
        if (y !== null) $3d8addc4c1746845$export$dac1bad6146b2469(y, (transaction)=>{
            $3d8addc4c1746845$var$deleteText(transaction, $3d8addc4c1746845$var$findPosition(transaction, this, index, true), length);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.delete(index, length));
    }
    /**
   * Assigns properties to a range of text.
   *
   * @param {number} index The position where to start formatting.
   * @param {number} length The amount of characters to assign properties to.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    text.
   *
   * @public
   */ format(index, length, attributes) {
        if (length === 0) return;
        const y = this.doc;
        if (y !== null) $3d8addc4c1746845$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $3d8addc4c1746845$var$findPosition(transaction, this, index, false);
            if (pos.right === null) return;
            $3d8addc4c1746845$var$formatText(transaction, this, pos, length, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.format(index, length, attributes));
    }
    /**
   * Removes an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */ removeAttribute(attributeName) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $3d8addc4c1746845$var$typeMapDelete(transaction, this, attributeName);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.removeAttribute(attributeName));
    }
    /**
   * Sets or updates an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {any} attributeValue The attribute value that is to be set.
   *
   * @public
   */ setAttribute(attributeName, attributeValue) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $3d8addc4c1746845$var$typeMapSet(transaction, this, attributeName, attributeValue);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.setAttribute(attributeName, attributeValue));
    }
    /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {any} The queried attribute value.
   *
   * @public
   */ getAttribute(attributeName) {
        return /** @type {any} */ $3d8addc4c1746845$var$typeMapGet(this, attributeName);
    }
    /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */ getAttributes() {
        return $3d8addc4c1746845$var$typeMapGetAll(this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($3d8addc4c1746845$var$YTextRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YText}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$readYText = (_decoder)=>new $3d8addc4c1746845$export$5f1af8db9871e1d6();
/**
 * @module YXml
 */ /**
 * Define the elements to which a set of CSS queries apply.
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Selectors|CSS_Selectors}
 *
 * @example
 *   query = '.classSelector'
 *   query = 'nodeSelector'
 *   query = '#idSelector'
 *
 * @typedef {string} CSS_Selector
 */ /**
 * Dom filter function.
 *
 * @callback domFilter
 * @param {string} nodeName The nodeName of the element
 * @param {Map} attributes The map of attributes.
 * @return {boolean} Whether to include the Dom node in the YXmlElement.
 */ /**
 * Represents a subset of the nodes of a YXmlElement / YXmlFragment and a
 * position within them.
 *
 * Can be created with {@link YXmlFragment#createTreeWalker}
 *
 * @public
 * @implements {Iterable<YXmlElement|YXmlText|YXmlElement|YXmlHook>}
 */ class $3d8addc4c1746845$var$YXmlTreeWalker {
    /**
   * @param {YXmlFragment | YXmlElement} root
   * @param {function(AbstractType<any>):boolean} [f]
   */ constructor(root, f = ()=>true){
        this._filter = f;
        this._root = root;
        /**
     * @type {Item}
     */ this._currentNode = /** @type {Item} */ root._start;
        this._firstCall = true;
        root.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
    }
    [Symbol.iterator]() {
        return this;
    }
    /**
   * Get the next node.
   *
   * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
   *
   * @public
   */ next() {
        /**
     * @type {Item|null}
     */ let n = this._currentNode;
        let type = n && n.content && /** @type {any} */ n.content.type;
        if (n !== null && (!this._firstCall || n.deleted || !this._filter(type))) do {
            type = /** @type {any} */ n.content.type;
            if (!n.deleted && (type.constructor === $3d8addc4c1746845$export$4db87581d3ca170d || type.constructor === $3d8addc4c1746845$export$d5ce8c3e1731f1a7) && type._start !== null) // walk down in the tree
            n = type._start;
            else // walk right or up in the tree
            while(n !== null){
                /**
             * @type {Item | null}
             */ const nxt = n.next;
                if (nxt !== null) {
                    n = nxt;
                    break;
                } else if (n.parent === this._root) n = null;
                else n = /** @type {AbstractType<any>} */ n.parent._item;
            }
        }while (n !== null && (n.deleted || !this._filter(/** @type {ContentType} */ n.content.type)));
        this._firstCall = false;
        if (n === null) // @ts-ignore
        return {
            value: undefined,
            done: true
        };
        this._currentNode = n;
        return {
            value: /** @type {any} */ n.content.type,
            done: false
        };
    }
}
/**
 * Represents a list of {@link YXmlElement}.and {@link YXmlText} types.
 * A YxmlFragment is similar to a {@link YXmlElement}, but it does not have a
 * nodeName and it does not have attributes. Though it can be bound to a DOM
 * element - in this case the attributes and the nodeName are not shared.
 *
 * @public
 * @extends AbstractType<YXmlEvent>
 */ class $3d8addc4c1746845$export$d5ce8c3e1731f1a7 extends $3d8addc4c1746845$export$c265dc8338484497 {
    constructor(){
        super();
        /**
     * @type {Array<any>|null}
     */ this._prelimContent = [];
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get firstChild() {
        const first = this._first;
        return first ? first.content.getContent()[0] : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        this.insert(0, /** @type {Array<any>} */ this._prelimContent);
        this._prelimContent = null;
    }
    _copy() {
        return new $3d8addc4c1746845$export$d5ce8c3e1731f1a7();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlFragment}
   */ clone() {
        const el = new $3d8addc4c1746845$export$d5ce8c3e1731f1a7();
        // @ts-ignore
        el.insert(0, this.toArray().map((item)=>item instanceof $3d8addc4c1746845$export$c265dc8338484497 ? item.clone() : item));
        return el;
    }
    get length() {
        this.doc ?? $3d8addc4c1746845$var$warnPrematureAccess();
        return this._prelimContent === null ? this._length : this._prelimContent.length;
    }
    /**
   * Create a subtree of childNodes.
   *
   * @example
   * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
   * for (let node in walker) {
   *   // `node` is a div node
   *   nop(node)
   * }
   *
   * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
   *                          returns a Boolean indicating whether the child
   *                          is to be included in the subtree.
   * @return {YXmlTreeWalker} A subtree and a position within it.
   *
   * @public
   */ createTreeWalker(filter) {
        return new $3d8addc4c1746845$var$YXmlTreeWalker(this, filter);
    }
    /**
   * Returns the first YXmlElement that matches the query.
   * Similar to DOM's {@link querySelector}.
   *
   * Query support:
   *   - tagname
   * TODO:
   *   - id
   *   - attribute
   *
   * @param {CSS_Selector} query The query on the children.
   * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
   *
   * @public
   */ querySelector(query) {
        query = query.toUpperCase();
        // @ts-ignore
        const iterator = new $3d8addc4c1746845$var$YXmlTreeWalker(this, (element)=>element.nodeName && element.nodeName.toUpperCase() === query);
        const next = iterator.next();
        if (next.done) return null;
        else return next.value;
    }
    /**
   * Returns all YXmlElements that match the query.
   * Similar to Dom's {@link querySelectorAll}.
   *
   * @todo Does not yet support all queries. Currently only query by tagName.
   *
   * @param {CSS_Selector} query The query on the children
   * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
   *
   * @public
   */ querySelectorAll(query) {
        query = query.toUpperCase();
        // @ts-ignore
        return $5DExo.from(new $3d8addc4c1746845$var$YXmlTreeWalker(this, (element)=>element.nodeName && element.nodeName.toUpperCase() === query));
    }
    /**
   * Creates YXmlEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        $3d8addc4c1746845$var$callTypeObservers(this, transaction, new $3d8addc4c1746845$export$88c9145a0c3b556c(this, parentSubs, transaction));
    }
    /**
   * Get the string representation of all the children of this YXmlFragment.
   *
   * @return {string} The string representation of all children.
   */ toString() {
        return $3d8addc4c1746845$var$typeListMap(this, (xml)=>xml.toString()).join('');
    }
    /**
   * @return {string}
   */ toJSON() {
        return this.toString();
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const fragment = _document.createDocumentFragment();
        if (binding !== undefined) binding._createAssociation(fragment, this);
        $3d8addc4c1746845$var$typeListForEach(this, (xmlType)=>{
            fragment.insertBefore(xmlType.toDOM(_document, hooks, binding), null);
        });
        return fragment;
    }
    /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {number} index The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ insert(index, content) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $3d8addc4c1746845$var$typeListInsertGenerics(transaction, this, index, content);
        });
        else // @ts-ignore _prelimContent is defined because this is not yet integrated
        this._prelimContent.splice(index, 0, ...content);
    }
    /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ insertAfter(ref, content) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            const refItem = ref && ref instanceof $3d8addc4c1746845$export$c265dc8338484497 ? ref._item : ref;
            $3d8addc4c1746845$var$typeListInsertGenericsAfter(transaction, this, refItem, content);
        });
        else {
            const pc = /** @type {Array<any>} */ this._prelimContent;
            const index = ref === null ? 0 : pc.findIndex((el)=>el === ref) + 1;
            if (index === 0 && ref !== null) throw $AgXfe.create('Reference item not found');
            pc.splice(index, 0, ...content);
        }
    }
    /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} [length=1] The number of elements to remove. Defaults to 1.
   */ delete(index, length = 1) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $3d8addc4c1746845$var$typeListDelete(transaction, this, index, length);
        });
        else // @ts-ignore _prelimContent is defined because this is not yet integrated
        this._prelimContent.splice(index, length);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<YXmlElement|YXmlText|YXmlHook>}
   */ toArray() {
        return $3d8addc4c1746845$var$typeListToArray(this);
    }
    /**
   * Appends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
   */ push(content) {
        this.insert(this.length, content);
    }
    /**
   * Prepends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to prepend.
   */ unshift(content) {
        this.insert(0, content);
    }
    /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {YXmlElement|YXmlText}
   */ get(index) {
        return $3d8addc4c1746845$var$typeListGet(this, index);
    }
    /**
   * Returns a portion of this YXmlFragment into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<YXmlElement|YXmlText>}
   */ slice(start = 0, end = this.length) {
        return $3d8addc4c1746845$var$typeListSlice(this, start, end);
    }
    /**
   * Executes a provided function on once on every child element.
   *
   * @param {function(YXmlElement|YXmlText,number, typeof self):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        $3d8addc4c1746845$var$typeListForEach(this, f);
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($3d8addc4c1746845$var$YXmlFragmentRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YXmlFragment}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$readYXmlFragment = (_decoder)=>new $3d8addc4c1746845$export$d5ce8c3e1731f1a7();
/**
 * @typedef {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} ValueTypes
 */ /**
 * An YXmlElement imitates the behavior of a
 * https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element
 *
 * * An YXmlElement has attributes (key value pairs)
 * * An YXmlElement has childElements that must inherit from YXmlElement
 *
 * @template {{ [key: string]: ValueTypes }} [KV={ [key: string]: string }]
 */ class $3d8addc4c1746845$export$4db87581d3ca170d extends $3d8addc4c1746845$export$d5ce8c3e1731f1a7 {
    constructor(nodeName = 'UNDEFINED'){
        super();
        this.nodeName = nodeName;
        /**
     * @type {Map<string, any>|null}
     */ this._prelimAttrs = new Map();
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get nextSibling() {
        const n = this._item ? this._item.next : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get prevSibling() {
        const n = this._item ? this._item.prev : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        /** @type {Map<string, any>} */ this._prelimAttrs.forEach((value, key)=>{
            this.setAttribute(key, value);
        });
        this._prelimAttrs = null;
    }
    /**
   * Creates an Item with the same effect as this Item (without position effect)
   *
   * @return {YXmlElement}
   */ _copy() {
        return new $3d8addc4c1746845$export$4db87581d3ca170d(this.nodeName);
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlElement<KV>}
   */ clone() {
        /**
     * @type {YXmlElement<KV>}
     */ const el = new $3d8addc4c1746845$export$4db87581d3ca170d(this.nodeName);
        const attrs = this.getAttributes();
        $kqHhc.forEach(attrs, (value, key)=>{
            el.setAttribute(key, /** @type {any} */ value);
        });
        // @ts-ignore
        el.insert(0, this.toArray().map((v)=>v instanceof $3d8addc4c1746845$export$c265dc8338484497 ? v.clone() : v));
        return el;
    }
    /**
   * Returns the XML serialization of this YXmlElement.
   * The attributes are ordered by attribute-name, so you can easily use this
   * method to compare YXmlElements
   *
   * @return {string} The string representation of this type.
   *
   * @public
   */ toString() {
        const attrs = this.getAttributes();
        const stringBuilder = [];
        const keys = [];
        for(const key in attrs)keys.push(key);
        keys.sort();
        const keysLen = keys.length;
        for(let i = 0; i < keysLen; i++){
            const key = keys[i];
            stringBuilder.push(key + '="' + attrs[key] + '"');
        }
        const nodeName = this.nodeName.toLocaleLowerCase();
        const attrsString = stringBuilder.length > 0 ? ' ' + stringBuilder.join(' ') : '';
        return `<${nodeName}${attrsString}>${super.toString()}</${nodeName}>`;
    }
    /**
   * Removes an attribute from this YXmlElement.
   *
   * @param {string} attributeName The attribute name that is to be removed.
   *
   * @public
   */ removeAttribute(attributeName) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $3d8addc4c1746845$var$typeMapDelete(transaction, this, attributeName);
        });
        else /** @type {Map<string,any>} */ this._prelimAttrs.delete(attributeName);
    }
    /**
   * Sets or updates an attribute.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that is to be set.
   * @param {KV[KEY]} attributeValue The attribute value that is to be set.
   *
   * @public
   */ setAttribute(attributeName, attributeValue) {
        if (this.doc !== null) $3d8addc4c1746845$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $3d8addc4c1746845$var$typeMapSet(transaction, this, attributeName, attributeValue);
        });
        else /** @type {Map<string, any>} */ this._prelimAttrs.set(attributeName, attributeValue);
    }
    /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {KV[KEY]|undefined} The queried attribute value.
   *
   * @public
   */ getAttribute(attributeName) {
        return /** @type {any} */ $3d8addc4c1746845$var$typeMapGet(this, attributeName);
    }
    /**
   * Returns whether an attribute exists
   *
   * @param {string} attributeName The attribute name to check for existence.
   * @return {boolean} whether the attribute exists.
   *
   * @public
   */ hasAttribute(attributeName) {
        return /** @type {any} */ $3d8addc4c1746845$var$typeMapHas(this, attributeName);
    }
    /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @param {Snapshot} [snapshot]
   * @return {{ [Key in Extract<keyof KV,string>]?: KV[Key]}} A JSON Object that describes the attributes.
   *
   * @public
   */ getAttributes(snapshot) {
        return /** @type {any} */ snapshot ? $3d8addc4c1746845$export$7769bdedaef2c91b(this, snapshot) : $3d8addc4c1746845$var$typeMapGetAll(this);
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const dom = _document.createElement(this.nodeName);
        const attrs = this.getAttributes();
        for(const key in attrs){
            const value = attrs[key];
            if (typeof value === 'string') dom.setAttribute(key, value);
        }
        $3d8addc4c1746845$var$typeListForEach(this, (yxml)=>{
            dom.appendChild(yxml.toDOM(_document, hooks, binding));
        });
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($3d8addc4c1746845$var$YXmlElementRefID);
        encoder.writeKey(this.nodeName);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlElement}
 *
 * @function
 */ const $3d8addc4c1746845$var$readYXmlElement = (decoder)=>new $3d8addc4c1746845$export$4db87581d3ca170d(decoder.readKey());
/**
 * @extends YEvent<YXmlElement|YXmlText|YXmlFragment>
 * An Event that describes changes on a YXml Element or Yxml Fragment
 */ class $3d8addc4c1746845$export$88c9145a0c3b556c extends $3d8addc4c1746845$export$80fac438977fb51c {
    /**
   * @param {YXmlElement|YXmlText|YXmlFragment} target The target on which the event is created.
   * @param {Set<string|null>} subs The set of changed attributes. `null` is included if the
   *                   child list changed.
   * @param {Transaction} transaction The transaction instance with which the
   *                                  change was created.
   */ constructor(target, subs, transaction){
        super(target, transaction);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ this.attributesChanged = new Set();
        subs.forEach((sub)=>{
            if (sub === null) this.childListChanged = true;
            else this.attributesChanged.add(sub);
        });
    }
}
/**
 * You can manage binding to a custom type with YXmlHook.
 *
 * @extends {YMap<any>}
 */ class $3d8addc4c1746845$export$ec64c1dd5e7a264 extends $3d8addc4c1746845$export$a5c7b93649eaf8f8 {
    /**
   * @param {string} hookName nodeName of the Dom Node.
   */ constructor(hookName){
        super();
        /**
     * @type {string}
     */ this.hookName = hookName;
    }
    /**
   * Creates an Item with the same effect as this Item (without position effect)
   */ _copy() {
        return new $3d8addc4c1746845$export$ec64c1dd5e7a264(this.hookName);
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlHook}
   */ clone() {
        const el = new $3d8addc4c1746845$export$ec64c1dd5e7a264(this.hookName);
        this.forEach((value, key)=>{
            el.set(key, value);
        });
        return el;
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type
   * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const hook = hooks[this.hookName];
        let dom;
        if (hook !== undefined) dom = hook.createDom(this);
        else dom = document.createElement(this.hookName);
        dom.setAttribute('data-yjs-hook', this.hookName);
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($3d8addc4c1746845$var$YXmlHookRefID);
        encoder.writeKey(this.hookName);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlHook}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$readYXmlHook = (decoder)=>new $3d8addc4c1746845$export$ec64c1dd5e7a264(decoder.readKey());
/**
 * Represents text in a Dom Element. In the future this type will also handle
 * simple formatting information like bold and italic.
 */ class $3d8addc4c1746845$export$b35b8f45887823df extends $3d8addc4c1746845$export$5f1af8db9871e1d6 {
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get nextSibling() {
        const n = this._item ? this._item.next : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get prevSibling() {
        const n = this._item ? this._item.prev : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    _copy() {
        return new $3d8addc4c1746845$export$b35b8f45887823df();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlText}
   */ clone() {
        const text = new $3d8addc4c1746845$export$b35b8f45887823df();
        text.applyDelta(this.toDelta());
        return text;
    }
    /**
   * Creates a Dom Element that mirrors this YXmlText.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks, binding) {
        const dom = _document.createTextNode(this.toString());
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    toString() {
        // @ts-ignore
        return this.toDelta().map((delta)=>{
            const nestedNodes = [];
            for(const nodeName in delta.attributes){
                const attrs = [];
                for(const key in delta.attributes[nodeName])attrs.push({
                    key: key,
                    value: delta.attributes[nodeName][key]
                });
                // sort attributes to get a unique order
                attrs.sort((a, b)=>a.key < b.key ? -1 : 1);
                nestedNodes.push({
                    nodeName: nodeName,
                    attrs: attrs
                });
            }
            // sort node order to get a unique order
            nestedNodes.sort((a, b)=>a.nodeName < b.nodeName ? -1 : 1);
            // now convert to dom string
            let str = '';
            for(let i = 0; i < nestedNodes.length; i++){
                const node = nestedNodes[i];
                str += `<${node.nodeName}`;
                for(let j = 0; j < node.attrs.length; j++){
                    const attr = node.attrs[j];
                    str += ` ${attr.key}="${attr.value}"`;
                }
                str += '>';
            }
            str += delta.insert;
            for(let i = nestedNodes.length - 1; i >= 0; i--)str += `</${nestedNodes[i].nodeName}>`;
            return str;
        }).join('');
    }
    /**
   * @return {string}
   */ toJSON() {
        return this.toString();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($3d8addc4c1746845$var$YXmlTextRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlText}
 *
 * @private
 * @function
 */ const $3d8addc4c1746845$var$readYXmlText = (decoder)=>new $3d8addc4c1746845$export$b35b8f45887823df();
class $3d8addc4c1746845$export$3cf6f9765c5c3196 {
    /**
   * @param {ID} id
   * @param {number} length
   */ constructor(id, length){
        this.id = id;
        this.length = length;
    }
    /**
   * @type {boolean}
   */ get deleted() {
        throw $AgXfe.methodUnimplemented();
    }
    /**
   * Merge this struct with the item to the right.
   * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
   * Also this method does *not* remove right from StructStore!
   * @param {AbstractStruct} right
   * @return {boolean} whether this merged with right
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   * @param {number} encodingRef
   */ write(encoder, offset, encodingRef) {
        throw $AgXfe.methodUnimplemented();
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        throw $AgXfe.methodUnimplemented();
    }
}
const $3d8addc4c1746845$var$structGCRefNumber = 0;
/**
 * @private
 */ class $3d8addc4c1746845$export$12d259ff017e6b58 extends $3d8addc4c1746845$export$3cf6f9765c5c3196 {
    get deleted() {
        return true;
    }
    delete() {}
    /**
   * @param {GC} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor !== right.constructor) return false;
        this.length += right.length;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        if (offset > 0) {
            this.id.clock += offset;
            this.length -= offset;
        }
        $3d8addc4c1746845$var$addStruct(transaction.doc.store, this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeInfo($3d8addc4c1746845$var$structGCRefNumber);
        encoder.writeLen(this.length - offset);
    }
    /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        return null;
    }
}
class $3d8addc4c1746845$export$e8d530cdf62d1cbd {
    /**
   * @param {Uint8Array} content
   */ constructor(content){
        this.content = content;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.content
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentBinary}
   */ copy() {
        return new $3d8addc4c1746845$export$e8d530cdf62d1cbd(this.content);
    }
    /**
   * @param {number} offset
   * @return {ContentBinary}
   */ splice(offset) {
        throw $AgXfe.methodUnimplemented();
    }
    /**
   * @param {ContentBinary} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeBuf(this.content);
    }
    /**
   * @return {number}
   */ getRef() {
        return 3;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentBinary}
 */ const $3d8addc4c1746845$var$readContentBinary = (decoder)=>new $3d8addc4c1746845$export$e8d530cdf62d1cbd(decoder.readBuf());
class $3d8addc4c1746845$export$3b06e0b3a2ece602 {
    /**
   * @param {number} len
   */ constructor(len){
        this.len = len;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.len;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return false;
    }
    /**
   * @return {ContentDeleted}
   */ copy() {
        return new $3d8addc4c1746845$export$3b06e0b3a2ece602(this.len);
    }
    /**
   * @param {number} offset
   * @return {ContentDeleted}
   */ splice(offset) {
        const right = new $3d8addc4c1746845$export$3b06e0b3a2ece602(this.len - offset);
        this.len = offset;
        return right;
    }
    /**
   * @param {ContentDeleted} right
   * @return {boolean}
   */ mergeWith(right) {
        this.len += right.len;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        $3d8addc4c1746845$var$addToDeleteSet(transaction.deleteSet, item.id.client, item.id.clock, this.len);
        item.markDeleted();
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeLen(this.len - offset);
    }
    /**
   * @return {number}
   */ getRef() {
        return 1;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentDeleted}
 */ const $3d8addc4c1746845$var$readContentDeleted = (decoder)=>new $3d8addc4c1746845$export$3b06e0b3a2ece602(decoder.readLen());
/**
 * @param {string} guid
 * @param {Object<string, any>} opts
 */ const $3d8addc4c1746845$var$createDocFromOpts = (guid, opts)=>new $3d8addc4c1746845$export$bceacc74c2212615({
        guid: guid,
        ...opts,
        shouldLoad: opts.shouldLoad || opts.autoLoad || false
    });
/**
 * @private
 */ class $3d8addc4c1746845$export$b564c0e69572c0e {
    /**
   * @param {Doc} doc
   */ constructor(doc){
        if (doc._item) console.error('This document was already integrated as a sub-document. You should create a second instance instead with the same guid.');
        /**
     * @type {Doc}
     */ this.doc = doc;
        /**
     * @type {any}
     */ const opts = {};
        this.opts = opts;
        if (!doc.gc) opts.gc = false;
        if (doc.autoLoad) opts.autoLoad = true;
        if (doc.meta !== null) opts.meta = doc.meta;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.doc
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentDoc}
   */ copy() {
        return new $3d8addc4c1746845$export$b564c0e69572c0e($3d8addc4c1746845$var$createDocFromOpts(this.doc.guid, this.opts));
    }
    /**
   * @param {number} offset
   * @return {ContentDoc}
   */ splice(offset) {
        throw $AgXfe.methodUnimplemented();
    }
    /**
   * @param {ContentDoc} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        // this needs to be reflected in doc.destroy as well
        this.doc._item = item;
        transaction.subdocsAdded.add(this.doc);
        if (this.doc.shouldLoad) transaction.subdocsLoaded.add(this.doc);
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {
        if (transaction.subdocsAdded.has(this.doc)) transaction.subdocsAdded.delete(this.doc);
        else transaction.subdocsRemoved.add(this.doc);
    }
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeString(this.doc.guid);
        encoder.writeAny(this.opts);
    }
    /**
   * @return {number}
   */ getRef() {
        return 9;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentDoc}
 */ const $3d8addc4c1746845$var$readContentDoc = (decoder)=>new $3d8addc4c1746845$export$b564c0e69572c0e($3d8addc4c1746845$var$createDocFromOpts(decoder.readString(), decoder.readAny()));
/**
 * @private
 */ class $3d8addc4c1746845$export$c3787ba7f6086664 {
    /**
   * @param {Object} embed
   */ constructor(embed){
        this.embed = embed;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.embed
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentEmbed}
   */ copy() {
        return new $3d8addc4c1746845$export$c3787ba7f6086664(this.embed);
    }
    /**
   * @param {number} offset
   * @return {ContentEmbed}
   */ splice(offset) {
        throw $AgXfe.methodUnimplemented();
    }
    /**
   * @param {ContentEmbed} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeJSON(this.embed);
    }
    /**
   * @return {number}
   */ getRef() {
        return 5;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentEmbed}
 */ const $3d8addc4c1746845$var$readContentEmbed = (decoder)=>new $3d8addc4c1746845$export$c3787ba7f6086664(decoder.readJSON());
/**
 * @private
 */ class $3d8addc4c1746845$export$3194899188fb5a88 {
    /**
   * @param {string} key
   * @param {Object} value
   */ constructor(key, value){
        this.key = key;
        this.value = value;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return false;
    }
    /**
   * @return {ContentFormat}
   */ copy() {
        return new $3d8addc4c1746845$export$3194899188fb5a88(this.key, this.value);
    }
    /**
   * @param {number} _offset
   * @return {ContentFormat}
   */ splice(_offset) {
        throw $AgXfe.methodUnimplemented();
    }
    /**
   * @param {ContentFormat} _right
   * @return {boolean}
   */ mergeWith(_right) {
        return false;
    }
    /**
   * @param {Transaction} _transaction
   * @param {Item} item
   */ integrate(_transaction, item) {
        // @todo searchmarker are currently unsupported for rich text documents
        const p = /** @type {YText} */ item.parent;
        p._searchMarker = null;
        p._hasFormatting = true;
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeKey(this.key);
        encoder.writeJSON(this.value);
    }
    /**
   * @return {number}
   */ getRef() {
        return 6;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentFormat}
 */ const $3d8addc4c1746845$var$readContentFormat = (decoder)=>new $3d8addc4c1746845$export$3194899188fb5a88(decoder.readKey(), decoder.readJSON());
/**
 * @private
 */ class $3d8addc4c1746845$export$6a907ea8f733ecf3 {
    /**
   * @param {Array<any>} arr
   */ constructor(arr){
        /**
     * @type {Array<any>}
     */ this.arr = arr;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.arr.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.arr;
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentJSON}
   */ copy() {
        return new $3d8addc4c1746845$export$6a907ea8f733ecf3(this.arr);
    }
    /**
   * @param {number} offset
   * @return {ContentJSON}
   */ splice(offset) {
        const right = new $3d8addc4c1746845$export$6a907ea8f733ecf3(this.arr.slice(offset));
        this.arr = this.arr.slice(0, offset);
        return right;
    }
    /**
   * @param {ContentJSON} right
   * @return {boolean}
   */ mergeWith(right) {
        this.arr = this.arr.concat(right.arr);
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        const len = this.arr.length;
        encoder.writeLen(len - offset);
        for(let i = offset; i < len; i++){
            const c = this.arr[i];
            encoder.writeString(c === undefined ? 'undefined' : JSON.stringify(c));
        }
    }
    /**
   * @return {number}
   */ getRef() {
        return 2;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentJSON}
 */ const $3d8addc4c1746845$var$readContentJSON = (decoder)=>{
    const len = decoder.readLen();
    const cs = [];
    for(let i = 0; i < len; i++){
        const c = decoder.readString();
        if (c === 'undefined') cs.push(undefined);
        else cs.push(JSON.parse(c));
    }
    return new $3d8addc4c1746845$export$6a907ea8f733ecf3(cs);
};
const $3d8addc4c1746845$var$isDevMode = $44IZO.getVariable('node_env') === 'development';
class $3d8addc4c1746845$export$1d788b93bbb631a0 {
    /**
   * @param {Array<any>} arr
   */ constructor(arr){
        /**
     * @type {Array<any>}
     */ this.arr = arr;
        $3d8addc4c1746845$var$isDevMode && $kqHhc.deepFreeze(arr);
    }
    /**
   * @return {number}
   */ getLength() {
        return this.arr.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.arr;
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentAny}
   */ copy() {
        return new $3d8addc4c1746845$export$1d788b93bbb631a0(this.arr);
    }
    /**
   * @param {number} offset
   * @return {ContentAny}
   */ splice(offset) {
        const right = new $3d8addc4c1746845$export$1d788b93bbb631a0(this.arr.slice(offset));
        this.arr = this.arr.slice(0, offset);
        return right;
    }
    /**
   * @param {ContentAny} right
   * @return {boolean}
   */ mergeWith(right) {
        this.arr = this.arr.concat(right.arr);
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        const len = this.arr.length;
        encoder.writeLen(len - offset);
        for(let i = offset; i < len; i++){
            const c = this.arr[i];
            encoder.writeAny(c);
        }
    }
    /**
   * @return {number}
   */ getRef() {
        return 8;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentAny}
 */ const $3d8addc4c1746845$var$readContentAny = (decoder)=>{
    const len = decoder.readLen();
    const cs = [];
    for(let i = 0; i < len; i++)cs.push(decoder.readAny());
    return new $3d8addc4c1746845$export$1d788b93bbb631a0(cs);
};
/**
 * @private
 */ class $3d8addc4c1746845$export$ee670b2cf091bbb6 {
    /**
   * @param {string} str
   */ constructor(str){
        /**
     * @type {string}
     */ this.str = str;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.str.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.str.split('');
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentString}
   */ copy() {
        return new $3d8addc4c1746845$export$ee670b2cf091bbb6(this.str);
    }
    /**
   * @param {number} offset
   * @return {ContentString}
   */ splice(offset) {
        const right = new $3d8addc4c1746845$export$ee670b2cf091bbb6(this.str.slice(offset));
        this.str = this.str.slice(0, offset);
        // Prevent encoding invalid documents because of splitting of surrogate pairs: https://github.com/yjs/yjs/issues/248
        const firstCharCode = this.str.charCodeAt(offset - 1);
        if (firstCharCode >= 0xD800 && firstCharCode <= 0xDBFF) {
            // Last character of the left split is the start of a surrogate utf16/ucs2 pair.
            // We don't support splitting of surrogate pairs because this may lead to invalid documents.
            // Replace the invalid character with a unicode replacement character (� / U+FFFD)
            this.str = this.str.slice(0, offset - 1) + "\uFFFD";
            // replace right as well
            right.str = "\uFFFD" + right.str.slice(1);
        }
        return right;
    }
    /**
   * @param {ContentString} right
   * @return {boolean}
   */ mergeWith(right) {
        this.str += right.str;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeString(offset === 0 ? this.str : this.str.slice(offset));
    }
    /**
   * @return {number}
   */ getRef() {
        return 4;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentString}
 */ const $3d8addc4c1746845$var$readContentString = (decoder)=>new $3d8addc4c1746845$export$ee670b2cf091bbb6(decoder.readString());
/**
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractType<any>>}
 * @private
 */ const $3d8addc4c1746845$var$typeRefs = [
    $3d8addc4c1746845$var$readYArray,
    $3d8addc4c1746845$var$readYMap,
    $3d8addc4c1746845$var$readYText,
    $3d8addc4c1746845$var$readYXmlElement,
    $3d8addc4c1746845$var$readYXmlFragment,
    $3d8addc4c1746845$var$readYXmlHook,
    $3d8addc4c1746845$var$readYXmlText
];
const $3d8addc4c1746845$var$YArrayRefID = 0;
const $3d8addc4c1746845$var$YMapRefID = 1;
const $3d8addc4c1746845$var$YTextRefID = 2;
const $3d8addc4c1746845$var$YXmlElementRefID = 3;
const $3d8addc4c1746845$var$YXmlFragmentRefID = 4;
const $3d8addc4c1746845$var$YXmlHookRefID = 5;
const $3d8addc4c1746845$var$YXmlTextRefID = 6;
/**
 * @private
 */ class $3d8addc4c1746845$export$e2e108cbe2e4f865 {
    /**
   * @param {AbstractType<any>} type
   */ constructor(type){
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.type
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentType}
   */ copy() {
        return new $3d8addc4c1746845$export$e2e108cbe2e4f865(this.type._copy());
    }
    /**
   * @param {number} offset
   * @return {ContentType}
   */ splice(offset) {
        throw $AgXfe.methodUnimplemented();
    }
    /**
   * @param {ContentType} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        this.type._integrate(transaction.doc, item);
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {
        let item = this.type._start;
        while(item !== null){
            if (!item.deleted) item.delete(transaction);
            else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) // This will be gc'd later and we want to merge it if possible
            // We try to merge all deleted items after each transaction,
            // but we have no knowledge about that this needs to be merged
            // since it is not in transaction.ds. Hence we add it to transaction._mergeStructs
            transaction._mergeStructs.push(item);
            item = item.right;
        }
        this.type._map.forEach((item)=>{
            if (!item.deleted) item.delete(transaction);
            else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) // same as above
            transaction._mergeStructs.push(item);
        });
        transaction.changed.delete(this.type);
    }
    /**
   * @param {StructStore} store
   */ gc(store) {
        let item = this.type._start;
        while(item !== null){
            item.gc(store, true);
            item = item.right;
        }
        this.type._start = null;
        this.type._map.forEach(/** @param {Item | null} item */ (item)=>{
            while(item !== null){
                item.gc(store, true);
                item = item.left;
            }
        });
        this.type._map = new Map();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        this.type._write(encoder);
    }
    /**
   * @return {number}
   */ getRef() {
        return 7;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentType}
 */ const $3d8addc4c1746845$var$readContentType = (decoder)=>new $3d8addc4c1746845$export$e2e108cbe2e4f865($3d8addc4c1746845$var$typeRefs[decoder.readTypeRef()](decoder));
/**
 * @todo This should return several items
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {{item:Item, diff:number}}
 */ const $3d8addc4c1746845$var$followRedone = (store, id)=>{
    /**
   * @type {ID|null}
   */ let nextID = id;
    let diff = 0;
    let item;
    do {
        if (diff > 0) nextID = $3d8addc4c1746845$export$6c7d4e6171d008d0(nextID.client, nextID.clock + diff);
        item = $3d8addc4c1746845$export$f92dfeb71e9bb569(store, nextID);
        diff = nextID.clock - item.id.clock;
        nextID = item.redone;
    }while (nextID !== null && item instanceof $3d8addc4c1746845$export$6d08773d2e66f8f2);
    return {
        item: item,
        diff: diff
    };
};
/**
 * Make sure that neither item nor any of its parents is ever deleted.
 *
 * This property does not persist when storing it into a database or when
 * sending it to other peers
 *
 * @param {Item|null} item
 * @param {boolean} keep
 */ const $3d8addc4c1746845$var$keepItem = (item, keep)=>{
    while(item !== null && item.keep !== keep){
        item.keep = keep;
        item = /** @type {AbstractType<any>} */ item.parent._item;
    }
};
/**
 * Split leftItem into two items
 * @param {Transaction} transaction
 * @param {Item} leftItem
 * @param {number} diff
 * @return {Item}
 *
 * @function
 * @private
 */ const $3d8addc4c1746845$var$splitItem = (transaction, leftItem, diff)=>{
    // create rightItem
    const { client: client, clock: clock } = leftItem.id;
    const rightItem = new $3d8addc4c1746845$export$6d08773d2e66f8f2($3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock + diff), leftItem, $3d8addc4c1746845$export$6c7d4e6171d008d0(client, clock + diff - 1), leftItem.right, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    if (leftItem.deleted) rightItem.markDeleted();
    if (leftItem.keep) rightItem.keep = true;
    if (leftItem.redone !== null) rightItem.redone = $3d8addc4c1746845$export$6c7d4e6171d008d0(leftItem.redone.client, leftItem.redone.clock + diff);
    // update left (do not set leftItem.rightOrigin as it will lead to problems when syncing)
    leftItem.right = rightItem;
    // update right
    if (rightItem.right !== null) rightItem.right.left = rightItem;
    // right is more specific.
    transaction._mergeStructs.push(rightItem);
    // update parent._map
    if (rightItem.parentSub !== null && rightItem.right === null) /** @type {AbstractType<any>} */ rightItem.parent._map.set(rightItem.parentSub, rightItem);
    leftItem.length = diff;
    return rightItem;
};
/**
 * @param {Array<StackItem>} stack
 * @param {ID} id
 */ const $3d8addc4c1746845$var$isDeletedByUndoStack = (stack, id)=>$5DExo.some(stack, /** @param {StackItem} s */ (s)=>$3d8addc4c1746845$export$dcb04af092e44fde(s.deletions, id));
/**
 * Redoes the effect of this operation.
 *
 * @param {Transaction} transaction The Yjs instance.
 * @param {Item} item
 * @param {Set<Item>} redoitems
 * @param {DeleteSet} itemsToDelete
 * @param {boolean} ignoreRemoteMapChanges
 * @param {import('../utils/UndoManager.js').UndoManager} um
 *
 * @return {Item|null}
 *
 * @private
 */ const $3d8addc4c1746845$var$redoItem = (transaction, item, redoitems, itemsToDelete, ignoreRemoteMapChanges, um)=>{
    const doc = transaction.doc;
    const store = doc.store;
    const ownClientID = doc.clientID;
    const redone = item.redone;
    if (redone !== null) return $3d8addc4c1746845$export$e550586ad633138d(transaction, redone);
    let parentItem = /** @type {AbstractType<any>} */ item.parent._item;
    /**
   * @type {Item|null}
   */ let left = null;
    /**
   * @type {Item|null}
   */ let right;
    // make sure that parent is redone
    if (parentItem !== null && parentItem.deleted === true) {
        // try to undo parent if it will be undone anyway
        if (parentItem.redone === null && (!redoitems.has(parentItem) || $3d8addc4c1746845$var$redoItem(transaction, parentItem, redoitems, itemsToDelete, ignoreRemoteMapChanges, um) === null)) return null;
        while(parentItem.redone !== null)parentItem = $3d8addc4c1746845$export$e550586ad633138d(transaction, parentItem.redone);
    }
    const parentType = parentItem === null ? /** @type {AbstractType<any>} */ item.parent : /** @type {ContentType} */ parentItem.content.type;
    if (item.parentSub === null) {
        // Is an array item. Insert at the old position
        left = item.left;
        right = item;
        // find next cloned_redo items
        while(left !== null){
            /**
       * @type {Item|null}
       */ let leftTrace = left;
            // trace redone until parent matches
            while(leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item !== parentItem)leftTrace = leftTrace.redone === null ? null : $3d8addc4c1746845$export$e550586ad633138d(transaction, leftTrace.redone);
            if (leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item === parentItem) {
                left = leftTrace;
                break;
            }
            left = left.left;
        }
        while(right !== null){
            /**
       * @type {Item|null}
       */ let rightTrace = right;
            // trace redone until parent matches
            while(rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item !== parentItem)rightTrace = rightTrace.redone === null ? null : $3d8addc4c1746845$export$e550586ad633138d(transaction, rightTrace.redone);
            if (rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item === parentItem) {
                right = rightTrace;
                break;
            }
            right = right.right;
        }
    } else {
        right = null;
        if (item.right && !ignoreRemoteMapChanges) {
            left = item;
            // Iterate right while right is in itemsToDelete
            // If it is intended to delete right while item is redone, we can expect that item should replace right.
            while(left !== null && left.right !== null && (left.right.redone || $3d8addc4c1746845$export$dcb04af092e44fde(itemsToDelete, left.right.id) || $3d8addc4c1746845$var$isDeletedByUndoStack(um.undoStack, left.right.id) || $3d8addc4c1746845$var$isDeletedByUndoStack(um.redoStack, left.right.id))){
                left = left.right;
                // follow redone
                while(left.redone)left = $3d8addc4c1746845$export$e550586ad633138d(transaction, left.redone);
            }
            if (left && left.right !== null) // It is not possible to redo this item because it conflicts with a
            // change from another client
            return null;
        } else left = parentType._map.get(item.parentSub) || null;
        // drop cross-parent left so origin doesn't mislead the remote (#757)
        if (left !== null && /** @type {AbstractType<any>} */ left.parent._item !== parentItem) left = parentType._map.get(item.parentSub) || null;
    }
    const nextClock = $3d8addc4c1746845$export$50fdfeece43146fd(store, ownClientID);
    const nextId = $3d8addc4c1746845$export$6c7d4e6171d008d0(ownClientID, nextClock);
    const redoneItem = new $3d8addc4c1746845$export$6d08773d2e66f8f2(nextId, left, left && left.lastId, right, right && right.id, parentType, item.parentSub, item.content.copy());
    item.redone = nextId;
    $3d8addc4c1746845$var$keepItem(redoneItem, true);
    redoneItem.integrate(transaction, 0);
    return redoneItem;
};
/**
 * Abstract class that represents any content.
 */ class $3d8addc4c1746845$export$6d08773d2e66f8f2 extends $3d8addc4c1746845$export$3cf6f9765c5c3196 {
    /**
   * @param {ID} id
   * @param {Item | null} left
   * @param {ID | null} origin
   * @param {Item | null} right
   * @param {ID | null} rightOrigin
   * @param {AbstractType<any>|ID|null} parent Is a type if integrated, is null if it is possible to copy parent from left or right, is ID before integration to search for it.
   * @param {string | null} parentSub
   * @param {AbstractContent} content
   */ constructor(id, left, origin, right, rightOrigin, parent, parentSub, content){
        super(id, content.getLength());
        /**
     * The item that was originally to the left of this item.
     * @type {ID | null}
     */ this.origin = origin;
        /**
     * The item that is currently to the left of this item.
     * @type {Item | null}
     */ this.left = left;
        /**
     * The item that is currently to the right of this item.
     * @type {Item | null}
     */ this.right = right;
        /**
     * The item that was originally to the right of this item.
     * @type {ID | null}
     */ this.rightOrigin = rightOrigin;
        /**
     * @type {AbstractType<any>|ID|null}
     */ this.parent = parent;
        /**
     * If the parent refers to this item with some kind of key (e.g. YMap, the
     * key is specified here. The key is then used to refer to the list in which
     * to insert this item. If `parentSub = null` type._start is the list in
     * which to insert to. Otherwise it is `parent._map`.
     * @type {String | null}
     */ this.parentSub = parentSub;
        /**
     * If this type's effect is redone this type refers to the type that undid
     * this operation.
     * @type {ID | null}
     */ this.redone = null;
        /**
     * @type {AbstractContent}
     */ this.content = content;
        /**
     * bit1: keep
     * bit2: countable
     * bit3: deleted
     * bit4: mark - mark node as fast-search-marker
     * @type {number} byte
     */ this.info = this.content.isCountable() ? $8FTfp.BIT2 : 0;
    }
    /**
   * This is used to mark the item as an indexed fast-search marker
   *
   * @type {boolean}
   */ set marker(isMarked) {
        if ((this.info & $8FTfp.BIT4) > 0 !== isMarked) this.info ^= $8FTfp.BIT4;
    }
    get marker() {
        return (this.info & $8FTfp.BIT4) > 0;
    }
    /**
   * If true, do not garbage collect this Item.
   */ get keep() {
        return (this.info & $8FTfp.BIT1) > 0;
    }
    set keep(doKeep) {
        if (this.keep !== doKeep) this.info ^= $8FTfp.BIT1;
    }
    get countable() {
        return (this.info & $8FTfp.BIT2) > 0;
    }
    /**
   * Whether this item was deleted or not.
   * @type {Boolean}
   */ get deleted() {
        return (this.info & $8FTfp.BIT3) > 0;
    }
    set deleted(doDelete) {
        if (this.deleted !== doDelete) this.info ^= $8FTfp.BIT3;
    }
    markDeleted() {
        this.info |= $8FTfp.BIT3;
    }
    /**
   * Return the creator clientID of the missing op or define missing items and return null.
   *
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= $3d8addc4c1746845$export$50fdfeece43146fd(store, this.origin.client)) return this.origin.client;
        if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= $3d8addc4c1746845$export$50fdfeece43146fd(store, this.rightOrigin.client)) return this.rightOrigin.client;
        if (this.parent && this.parent.constructor === $3d8addc4c1746845$export$8be180ec26319f9f && this.id.client !== this.parent.client && this.parent.clock >= $3d8addc4c1746845$export$50fdfeece43146fd(store, this.parent.client)) return this.parent.client;
        // We have all missing ids, now find the items
        if (this.origin) {
            this.left = $3d8addc4c1746845$export$73a181de908c608(transaction, store, this.origin);
            this.origin = this.left.lastId;
        }
        if (this.rightOrigin) {
            this.right = $3d8addc4c1746845$export$e550586ad633138d(transaction, this.rightOrigin);
            this.rightOrigin = this.right.id;
        }
        if (this.left && this.left.constructor === $3d8addc4c1746845$export$12d259ff017e6b58 || this.right && this.right.constructor === $3d8addc4c1746845$export$12d259ff017e6b58) this.parent = null;
        else if (!this.parent) {
            // only set parent if this shouldn't be garbage collected
            if (this.left && this.left.constructor === $3d8addc4c1746845$export$6d08773d2e66f8f2) {
                this.parent = this.left.parent;
                this.parentSub = this.left.parentSub;
            } else if (this.right && this.right.constructor === $3d8addc4c1746845$export$6d08773d2e66f8f2) {
                this.parent = this.right.parent;
                this.parentSub = this.right.parentSub;
            }
        } else if (this.parent.constructor === $3d8addc4c1746845$export$8be180ec26319f9f) {
            const parentItem = $3d8addc4c1746845$export$f92dfeb71e9bb569(store, this.parent);
            if (parentItem.constructor === $3d8addc4c1746845$export$12d259ff017e6b58) this.parent = null;
            else this.parent = /** @type {ContentType} */ parentItem.content.type;
        }
        return null;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        if (offset > 0) {
            this.id.clock += offset;
            this.left = $3d8addc4c1746845$export$73a181de908c608(transaction, transaction.doc.store, $3d8addc4c1746845$export$6c7d4e6171d008d0(this.id.client, this.id.clock - 1));
            this.origin = this.left.lastId;
            this.content = this.content.splice(offset);
            this.length -= offset;
        }
        if (this.parent) {
            if (!this.left && (!this.right || this.right.left !== null) || this.left && this.left.right !== this.right) {
                /**
         * @type {Item|null}
         */ let left = this.left;
                /**
         * @type {Item|null}
         */ let o;
                // set o to the first conflicting item
                if (left !== null) o = left.right;
                else if (this.parentSub !== null) {
                    o = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                    while(o !== null && o.left !== null)o = o.left;
                } else o = /** @type {AbstractType<any>} */ this.parent._start;
                // TODO: use something like DeleteSet here (a tree implementation would be best)
                // @todo use global set definitions
                /**
         * @type {Set<Item>}
         */ const conflictingItems = new Set();
                /**
         * @type {Set<Item>}
         */ const itemsBeforeOrigin = new Set();
                // Let c in conflictingItems, b in itemsBeforeOrigin
                // ***{origin}bbbb{this}{c,b}{c,b}{o}***
                // Note that conflictingItems is a subset of itemsBeforeOrigin
                while(o !== null && o !== this.right){
                    itemsBeforeOrigin.add(o);
                    conflictingItems.add(o);
                    if ($3d8addc4c1746845$export$c0af976e7e459c02(this.origin, o.origin)) {
                        // case 1
                        if (o.id.client < this.id.client) {
                            left = o;
                            conflictingItems.clear();
                        } else if ($3d8addc4c1746845$export$c0af976e7e459c02(this.rightOrigin, o.rightOrigin)) break;
                         // else, o might be integrated before an item that this conflicts with. If so, we will find it in the next iterations
                    } else if (o.origin !== null && itemsBeforeOrigin.has($3d8addc4c1746845$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) // case 2
                    {
                        if (!conflictingItems.has($3d8addc4c1746845$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) {
                            left = o;
                            conflictingItems.clear();
                        }
                    } else break;
                    o = o.right;
                }
                this.left = left;
            }
            // reconnect left/right + update parent map/start if necessary
            if (this.left !== null) {
                const right = this.left.right;
                this.right = right;
                this.left.right = this;
            } else {
                let r;
                if (this.parentSub !== null) {
                    r = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                    while(r !== null && r.left !== null)r = r.left;
                } else {
                    r = /** @type {AbstractType<any>} */ this.parent._start; /** @type {AbstractType<any>} */ 
                    this.parent._start = this;
                }
                this.right = r;
            }
            if (this.right !== null) this.right.left = this;
            else if (this.parentSub !== null) {
                // set as current parent value if right === null and this is parentSub
                /** @type {AbstractType<any>} */ this.parent._map.set(this.parentSub, this);
                if (this.left !== null) // this is the current attribute value of parent. delete right
                this.left.delete(transaction);
            }
            // adjust length of parent
            if (this.parentSub === null && this.countable && !this.deleted) /** @type {AbstractType<any>} */ this.parent._length += this.length;
            $3d8addc4c1746845$var$addStruct(transaction.doc.store, this);
            this.content.integrate(transaction, this);
            // add parent to transaction.changed
            $3d8addc4c1746845$var$addChangedTypeToTransaction(transaction, /** @type {AbstractType<any>} */ this.parent, this.parentSub);
            if (/** @type {AbstractType<any>} */ this.parent._item !== null && /** @type {AbstractType<any>} */ this.parent._item.deleted || this.parentSub !== null && this.right !== null) // delete if parent is deleted or if this is not the current attribute value of parent
            this.delete(transaction);
        } else // parent is not defined. Integrate GC struct instead
        new $3d8addc4c1746845$export$12d259ff017e6b58(this.id, this.length).integrate(transaction, 0);
    }
    /**
   * Returns the next non-deleted item
   */ get next() {
        let n = this.right;
        while(n !== null && n.deleted)n = n.right;
        return n;
    }
    /**
   * Returns the previous non-deleted item
   */ get prev() {
        let n = this.left;
        while(n !== null && n.deleted)n = n.left;
        return n;
    }
    /**
   * Computes the last content address of this Item.
   */ get lastId() {
        // allocating ids is pretty costly because of the amount of ids created, so we try to reuse whenever possible
        return this.length === 1 ? this.id : $3d8addc4c1746845$export$6c7d4e6171d008d0(this.id.client, this.id.clock + this.length - 1);
    }
    /**
   * Try to merge two items
   *
   * @param {Item} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor === right.constructor && $3d8addc4c1746845$export$c0af976e7e459c02(right.origin, this.lastId) && this.right === right && $3d8addc4c1746845$export$c0af976e7e459c02(this.rightOrigin, right.rightOrigin) && this.id.client === right.id.client && this.id.clock + this.length === right.id.clock && this.deleted === right.deleted && this.redone === null && right.redone === null && this.content.constructor === right.content.constructor && this.content.mergeWith(right.content)) {
            const searchMarker = /** @type {AbstractType<any>} */ this.parent._searchMarker;
            if (searchMarker) searchMarker.forEach((marker)=>{
                if (marker.p === right) {
                    // right is going to be "forgotten" so we need to update the marker
                    marker.p = this;
                    // adjust marker index
                    if (!this.deleted && this.countable) marker.index -= this.length;
                }
            });
            if (right.keep) this.keep = true;
            this.right = right.right;
            if (this.right !== null) this.right.left = this;
            this.length += right.length;
            return true;
        }
        return false;
    }
    /**
   * Mark this Item as deleted.
   *
   * @param {Transaction} transaction
   */ delete(transaction) {
        if (!this.deleted) {
            const parent = /** @type {AbstractType<any>} */ this.parent;
            // adjust the length of parent
            if (this.countable && this.parentSub === null) parent._length -= this.length;
            this.markDeleted();
            $3d8addc4c1746845$var$addToDeleteSet(transaction.deleteSet, this.id.client, this.id.clock, this.length);
            $3d8addc4c1746845$var$addChangedTypeToTransaction(transaction, parent, this.parentSub);
            this.content.delete(transaction);
        }
    }
    /**
   * @param {StructStore} store
   * @param {boolean} parentGCd
   */ gc(store, parentGCd) {
        if (!this.deleted) throw $AgXfe.unexpectedCase();
        this.content.gc(store);
        if (parentGCd) $3d8addc4c1746845$var$replaceStruct(store, this, new $3d8addc4c1746845$export$12d259ff017e6b58(this.id, this.length));
        else this.content = new $3d8addc4c1746845$export$3b06e0b3a2ece602(this.length);
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   */ write(encoder, offset) {
        const origin = offset > 0 ? $3d8addc4c1746845$export$6c7d4e6171d008d0(this.id.client, this.id.clock + offset - 1) : this.origin;
        const rightOrigin = this.rightOrigin;
        const parentSub = this.parentSub;
        const info = this.content.getRef() & $8FTfp.BITS5 | (origin === null ? 0 : $8FTfp.BIT8) | // origin is defined
        (rightOrigin === null ? 0 : $8FTfp.BIT7) | // right origin is defined
        (parentSub === null ? 0 : $8FTfp.BIT6); // parentSub is non-null
        encoder.writeInfo(info);
        if (origin !== null) encoder.writeLeftID(origin);
        if (rightOrigin !== null) encoder.writeRightID(rightOrigin);
        if (origin === null && rightOrigin === null) {
            const parent = /** @type {AbstractType<any>} */ this.parent;
            if (parent._item !== undefined) {
                const parentItem = parent._item;
                if (parentItem === null) {
                    // parent type on y._map
                    // find the correct key
                    const ykey = $3d8addc4c1746845$export$e726a40920d54663(parent);
                    encoder.writeParentInfo(true); // write parentYKey
                    encoder.writeString(ykey);
                } else {
                    encoder.writeParentInfo(false); // write parent id
                    encoder.writeLeftID(parentItem.id);
                }
            } else if (parent.constructor === String) {
                encoder.writeParentInfo(true); // write parentYKey
                encoder.writeString(parent);
            } else if (parent.constructor === $3d8addc4c1746845$export$8be180ec26319f9f) {
                encoder.writeParentInfo(false); // write parent id
                encoder.writeLeftID(parent);
            } else $AgXfe.unexpectedCase();
            if (parentSub !== null) encoder.writeString(parentSub);
        }
        this.content.write(encoder, offset);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @param {number} info
 */ const $3d8addc4c1746845$var$readItemContent = (decoder, info)=>$3d8addc4c1746845$var$contentRefs[info & $8FTfp.BITS5](decoder);
/**
 * A lookup map for reading Item content.
 *
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractContent>}
 */ const $3d8addc4c1746845$var$contentRefs = [
    ()=>{
        $AgXfe.unexpectedCase();
    },
    $3d8addc4c1746845$var$readContentDeleted,
    $3d8addc4c1746845$var$readContentJSON,
    $3d8addc4c1746845$var$readContentBinary,
    $3d8addc4c1746845$var$readContentString,
    $3d8addc4c1746845$var$readContentEmbed,
    $3d8addc4c1746845$var$readContentFormat,
    $3d8addc4c1746845$var$readContentType,
    $3d8addc4c1746845$var$readContentAny,
    $3d8addc4c1746845$var$readContentDoc,
    ()=>{
        $AgXfe.unexpectedCase();
    } // 10 - Skip is not ItemContent
];
const $3d8addc4c1746845$var$structSkipRefNumber = 10;
/**
 * @private
 */ class $3d8addc4c1746845$export$38d24f5c1eb0e4c0 extends $3d8addc4c1746845$export$3cf6f9765c5c3196 {
    get deleted() {
        return true;
    }
    delete() {}
    /**
   * @param {Skip} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor !== right.constructor) return false;
        this.length += right.length;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        // skip structs cannot be integrated
        $AgXfe.unexpectedCase();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeInfo($3d8addc4c1746845$var$structSkipRefNumber);
        // write as VarUint because Skips can't make use of predictable length-encoding
        $xchLN.writeVarUint(encoder.restEncoder, this.length - offset);
    }
    /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        return null;
    }
}
/** eslint-env browser */ const $3d8addc4c1746845$var$glo = /** @type {any} */ typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $3d8addc4c1746845$var$importIdentifier = '__ $YJS$ __';
if ($3d8addc4c1746845$var$glo[$3d8addc4c1746845$var$importIdentifier] === true) /**
   * Dear reader of this message. Please take this seriously.
   *
   * If you see this message, make sure that you only import one version of Yjs. In many cases,
   * your package manager installs two versions of Yjs that are used by different packages within your project.
   * Another reason for this message is that some parts of your project use the commonjs version of Yjs
   * and others use the EcmaScript version of Yjs.
   *
   * This often leads to issues that are hard to debug. We often need to perform constructor checks,
   * e.g. `struct instanceof GC`. If you imported different versions of Yjs, it is impossible for us to
   * do the constructor checks anymore - which might break the CRDT algorithm.
   *
   * https://github.com/yjs/yjs/issues/438
   */ console.error('Yjs was already imported. This breaks constructor checks and will lead to issues! - https://github.com/yjs/yjs/issues/438');
$3d8addc4c1746845$var$glo[$3d8addc4c1746845$var$importIdentifier] = true;

});
parcelRegister("1UXIn", function(module, exports) {

$parcel$export(module.exports, "ObservableV2", () => $165957858115949c$export$e23d3436ce401adc);
$parcel$export(module.exports, "Observable", () => $165957858115949c$export$77cea355fa80b5f4);
/**
 * Observable class prototype.
 *
 * @module observable
 */ 
var $iUvcZ = parcelRequire("iUvcZ");

var $ivn6P = parcelRequire("ivn6P");

var $5DExo = parcelRequire("5DExo");
class $165957858115949c$export$e23d3436ce401adc {
    constructor(){
        /**
     * Some desc.
     * @type {Map<string, Set<any>>}
     */ this._observers = $iUvcZ.create();
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ on(name, f) {
        $iUvcZ.setIfUndefined(this._observers, /** @type {string} */ name, $ivn6P.create).add(f);
        return f;
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ once(name, f) {
        /**
     * @param  {...any} args
     */ const _f = (...args)=>{
            this.off(name, /** @type {any} */ _f);
            f(...args);
        };
        this.on(name, /** @type {any} */ _f);
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ off(name, f) {
        const observers = this._observers.get(name);
        if (observers !== undefined) {
            observers.delete(f);
            if (observers.size === 0) this._observers.delete(name);
        }
    }
    /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name The event name.
   * @param {Parameters<EVENTS[NAME]>} args The arguments that are applied to the event listener.
   */ emit(name, args) {
        // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
        return $5DExo.from((this._observers.get(name) || $iUvcZ.create()).values()).forEach((f)=>f(...args));
    }
    destroy() {
        this._observers = $iUvcZ.create();
    }
}
class $165957858115949c$export$77cea355fa80b5f4 {
    constructor(){
        /**
     * Some desc.
     * @type {Map<N, any>}
     */ this._observers = $iUvcZ.create();
    }
    /**
   * @param {N} name
   * @param {function} f
   */ on(name, f) {
        $iUvcZ.setIfUndefined(this._observers, name, $ivn6P.create).add(f);
    }
    /**
   * @param {N} name
   * @param {function} f
   */ once(name, f) {
        /**
     * @param  {...any} args
     */ const _f = (...args)=>{
            this.off(name, _f);
            f(...args);
        };
        this.on(name, _f);
    }
    /**
   * @param {N} name
   * @param {function} f
   */ off(name, f) {
        const observers = this._observers.get(name);
        if (observers !== undefined) {
            observers.delete(f);
            if (observers.size === 0) this._observers.delete(name);
        }
    }
    /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @param {N} name The event name.
   * @param {Array<any>} args The arguments that are applied to the event listener.
   */ emit(name, args) {
        // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
        return $5DExo.from((this._observers.get(name) || $iUvcZ.create()).values()).forEach((f)=>f(...args));
    }
    destroy() {
        this._observers = $iUvcZ.create();
    }
} /* c8 ignore end */ 

});
parcelRegister("iUvcZ", function(module, exports) {

$parcel$export(module.exports, "create", () => $dc45aa4ef27703bb$export$185802fd694ee1f5);
$parcel$export(module.exports, "copy", () => $dc45aa4ef27703bb$export$784d13d8ee351f07);
$parcel$export(module.exports, "setIfUndefined", () => $dc45aa4ef27703bb$export$dccd489362a8619);
$parcel$export(module.exports, "map", () => $dc45aa4ef27703bb$export$871de8747c9eaa88);
$parcel$export(module.exports, "any", () => $dc45aa4ef27703bb$export$4154a199d7d90455);
/**
 * Utility module to work with key-value stores.
 *
 * @module map
 */ /**
 * @template K
 * @template V
 * @typedef {Map<K,V>} GlobalMap
 */ /**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */ const $dc45aa4ef27703bb$export$185802fd694ee1f5 = ()=>new Map();
const $dc45aa4ef27703bb$export$784d13d8ee351f07 = (m)=>{
    const r = $dc45aa4ef27703bb$export$185802fd694ee1f5();
    m.forEach((v, k)=>{
        r.set(k, v);
    });
    return r;
};
const $dc45aa4ef27703bb$export$dccd489362a8619 = (map, key, createT)=>{
    let set = map.get(key);
    if (set === undefined) map.set(key, set = createT());
    return set;
};
const $dc45aa4ef27703bb$export$871de8747c9eaa88 = (m, f)=>{
    const res = [];
    for (const [key, value] of m)res.push(f(value, key));
    return res;
};
const $dc45aa4ef27703bb$export$4154a199d7d90455 = (m, f)=>{
    for (const [key, value] of m){
        if (f(value, key)) return true;
    }
    return false;
};
const $dc45aa4ef27703bb$export$84bf76cd7afc7469 = (m, f)=>{
    for (const [key, value] of m){
        if (!f(value, key)) return false;
    }
    return true;
};

});

parcelRegister("ivn6P", function(module, exports) {

$parcel$export(module.exports, "create", () => $d78d0c39ac4631a0$export$185802fd694ee1f5);
$parcel$export(module.exports, "from", () => $d78d0c39ac4631a0$export$6788812c4e6611e6);
/**
 * Utility module to work with sets.
 *
 * @module set
 */ const $d78d0c39ac4631a0$export$185802fd694ee1f5 = ()=>new Set();
const $d78d0c39ac4631a0$export$45b10814cc054894 = (set)=>Array.from(set);
const $d78d0c39ac4631a0$export$43128fadae87b74a = (set)=>set.values().next().value;
const $d78d0c39ac4631a0$export$6788812c4e6611e6 = (entries)=>new Set(entries);

});

parcelRegister("5DExo", function(module, exports) {

$parcel$export(module.exports, "last", () => $41b00a2e2395c04e$export$4c7897fafd92b108);
$parcel$export(module.exports, "appendTo", () => $41b00a2e2395c04e$export$9ceefe31f12a3778);
$parcel$export(module.exports, "from", () => $41b00a2e2395c04e$export$6788812c4e6611e6);
$parcel$export(module.exports, "every", () => $41b00a2e2395c04e$export$7ecc1a3b11b57dab);
$parcel$export(module.exports, "some", () => $41b00a2e2395c04e$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "equalFlat", () => $41b00a2e2395c04e$export$4f1c34abb2bb4c8);
$parcel$export(module.exports, "unfold", () => $41b00a2e2395c04e$export$c48e357c1a89b78d);
$parcel$export(module.exports, "isArray", () => $41b00a2e2395c04e$export$43bee75e5e14138e);
$parcel$export(module.exports, "map", () => $41b00a2e2395c04e$export$871de8747c9eaa88);
/**
 * Utility module to work with Arrays.
 *
 * @module array
 */ 
var $ivn6P = parcelRequire("ivn6P");
const $41b00a2e2395c04e$export$4c7897fafd92b108 = (arr)=>arr[arr.length - 1];
const $41b00a2e2395c04e$export$185802fd694ee1f5 = ()=>/** @type {Array<C>} */ [];
const $41b00a2e2395c04e$export$784d13d8ee351f07 = (a)=>/** @type {Array<D>} */ a.slice();
const $41b00a2e2395c04e$export$9ceefe31f12a3778 = (dest, src)=>{
    for(let i = 0; i < src.length; i++)dest.push(src[i]);
};
const $41b00a2e2395c04e$export$6788812c4e6611e6 = Array.from;
const $41b00a2e2395c04e$export$7ecc1a3b11b57dab = (arr, f)=>{
    for(let i = 0; i < arr.length; i++){
        if (!f(arr[i], i, arr)) return false;
    }
    return true;
};
const $41b00a2e2395c04e$export$ad14ef4001db2bcd = (arr, f)=>{
    for(let i = 0; i < arr.length; i++){
        if (f(arr[i], i, arr)) return true;
    }
    return false;
};
const $41b00a2e2395c04e$export$4f1c34abb2bb4c8 = (a, b)=>a.length === b.length && $41b00a2e2395c04e$export$7ecc1a3b11b57dab(a, (item, index)=>item === b[index]);
const $41b00a2e2395c04e$export$bffa455ba8c619a6 = (arr)=>$41b00a2e2395c04e$export$93e2b83da34ff82a(arr, /** @type {Array<ELEM>} */ [], (acc, val)=>acc.concat(val));
const $41b00a2e2395c04e$export$c48e357c1a89b78d = (len, f)=>{
    const array = new Array(len);
    for(let i = 0; i < len; i++)array[i] = f(i, array);
    return array;
};
const $41b00a2e2395c04e$export$93e2b83da34ff82a = (arr, seed, folder)=>arr.reduce(folder, seed);
const $41b00a2e2395c04e$export$43bee75e5e14138e = Array.isArray;
const $41b00a2e2395c04e$export$7a5d5c156e7dc406 = (arr)=>$41b00a2e2395c04e$export$6788812c4e6611e6($ivn6P.from(arr));
const $41b00a2e2395c04e$export$abf0e2545164275f = (arr, mapper)=>{
    /**
   * @type {Set<M>}
   */ const happened = $ivn6P.create();
    /**
   * @type {Array<T>}
   */ const result = [];
    for(let i = 0; i < arr.length; i++){
        const el = arr[i];
        const mapped = mapper(el);
        if (!happened.has(mapped)) {
            happened.add(mapped);
            result.push(el);
        }
    }
    return result;
};
const $41b00a2e2395c04e$export$871de8747c9eaa88 = (arr, mapper)=>{
    /**
   * @type {Array<any>}
   */ const res = Array(arr.length);
    for(let i = 0; i < arr.length; i++)res[i] = mapper(/** @type {any} */ arr[i], i, /** @type {any} */ arr);
    return /** @type {any} */ res;
};
const $41b00a2e2395c04e$export$1fa5196c4dc9a213 = (arr, i, compareFn)=>{
    const n = arr[i];
    let j = i;
    // try to sort to the right
    while(j + 1 < arr.length && compareFn(n, arr[j + 1]) > 0){
        arr[j] = arr[j + 1];
        arr[++j] = n;
    }
    if (i === j && j > 0) // sort to the left
    while(j > 0 && compareFn(arr[j - 1], n) > 0){
        arr[j] = arr[j - 1];
        arr[--j] = n;
    }
    return j;
};

});


parcelRegister("3Lr38", function(module, exports) {

$parcel$export(module.exports, "floor", () => $2bdabe5926168ff3$export$a3fe094919f356fd);
$parcel$export(module.exports, "ceil", () => $2bdabe5926168ff3$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "abs", () => $2bdabe5926168ff3$export$2335f513bbd82c6d);
$parcel$export(module.exports, "round", () => $2bdabe5926168ff3$export$2077e0241d6afd3c);
$parcel$export(module.exports, "log10", () => $2bdabe5926168ff3$export$75e08744a3ff8516);
$parcel$export(module.exports, "min", () => $2bdabe5926168ff3$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $2bdabe5926168ff3$export$8960430cfd85939f);
$parcel$export(module.exports, "pow", () => $2bdabe5926168ff3$export$9c297f60e22e3389);
$parcel$export(module.exports, "exp10", () => $2bdabe5926168ff3$export$1bb2a14208c790f7);
$parcel$export(module.exports, "isNegativeZero", () => $2bdabe5926168ff3$export$dc0a61f4a9121f92);
/**
 * Common Math expressions.
 *
 * @module math
 */ const $2bdabe5926168ff3$export$a3fe094919f356fd = Math.floor;
const $2bdabe5926168ff3$export$803ce6b71a0a94b2 = Math.ceil;
const $2bdabe5926168ff3$export$2335f513bbd82c6d = Math.abs;
const $2bdabe5926168ff3$export$46de3d998ca9a030 = Math.imul;
const $2bdabe5926168ff3$export$2077e0241d6afd3c = Math.round;
const $2bdabe5926168ff3$export$75e08744a3ff8516 = Math.log10;
const $2bdabe5926168ff3$export$b9fae0bba9d9094d = Math.log2;
const $2bdabe5926168ff3$export$bef1f36f5486a6a3 = Math.log;
const $2bdabe5926168ff3$export$eba8049fb5020b81 = Math.sqrt;
const $2bdabe5926168ff3$export$e16d8520af44a096 = (a, b)=>a + b;
const $2bdabe5926168ff3$export$96ec731ed4dcb222 = (a, b)=>a < b ? a : b;
const $2bdabe5926168ff3$export$8960430cfd85939f = (a, b)=>a > b ? a : b;
const $2bdabe5926168ff3$export$c9f5652083b8129d = Number.isNaN;
const $2bdabe5926168ff3$export$9c297f60e22e3389 = Math.pow;
const $2bdabe5926168ff3$export$1bb2a14208c790f7 = (exp)=>Math.pow(10, exp);
const $2bdabe5926168ff3$export$c5552dfdbc7cec71 = Math.sign;
const $2bdabe5926168ff3$export$dc0a61f4a9121f92 = (n)=>n !== 0 ? n < 0 : 1 / n < 0;

});

parcelRegister("xchLN", function(module, exports) {

$parcel$export(module.exports, "createEncoder", () => $063c9cd954cb382b$export$4e76eeb6df88c889);
$parcel$export(module.exports, "encode", () => $063c9cd954cb382b$export$c564cdbbe6da493);
$parcel$export(module.exports, "toUint8Array", () => $063c9cd954cb382b$export$73470fd2221e6aef);
$parcel$export(module.exports, "length", () => $063c9cd954cb382b$export$f24224f1c91d8156);
$parcel$export(module.exports, "write", () => $063c9cd954cb382b$export$68d8715fc104d294);
$parcel$export(module.exports, "writeUint8", () => $063c9cd954cb382b$export$826a1a6619653272);
$parcel$export(module.exports, "writeVarUint", () => $063c9cd954cb382b$export$872f48c75febcd2b);
$parcel$export(module.exports, "writeVarInt", () => $063c9cd954cb382b$export$ff90f819e16cc9bb);
$parcel$export(module.exports, "writeVarUint8Array", () => $063c9cd954cb382b$export$f7d11515275e88a2);
$parcel$export(module.exports, "writeVarString", () => $063c9cd954cb382b$export$dde49cb52d5f1650);
$parcel$export(module.exports, "writeBinaryEncoder", () => $063c9cd954cb382b$export$c029b62321ea3da);
$parcel$export(module.exports, "writeUint8Array", () => $063c9cd954cb382b$export$73b5e63e27d2b4c7);
$parcel$export(module.exports, "writeAny", () => $063c9cd954cb382b$export$264b1e8551468ea);
$parcel$export(module.exports, "RleEncoder", () => $063c9cd954cb382b$export$8fa72bb4fa9409ff);
$parcel$export(module.exports, "UintOptRleEncoder", () => $063c9cd954cb382b$export$785ebd3312c38061);
$parcel$export(module.exports, "IntDiffOptRleEncoder", () => $063c9cd954cb382b$export$7542c66a59375c6f);
$parcel$export(module.exports, "StringEncoder", () => $063c9cd954cb382b$export$7dcdc5c32f31c550);
/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */ 
var $3Lr38 = parcelRequire("3Lr38");

var $5165E = parcelRequire("5165E");

var $8FTfp = parcelRequire("8FTfp");

var $552MW = parcelRequire("552MW");

var $5DExo = parcelRequire("5DExo");
class $063c9cd954cb382b$export$a50aceb0e02a00aa {
    constructor(){
        this.cpos = 0;
        this.cbuf = new Uint8Array(100);
        /**
     * @type {Array<Uint8Array>}
     */ this.bufs = [];
    }
}
const $063c9cd954cb382b$export$4e76eeb6df88c889 = ()=>new $063c9cd954cb382b$export$a50aceb0e02a00aa();
const $063c9cd954cb382b$export$c564cdbbe6da493 = (f)=>{
    const encoder = $063c9cd954cb382b$export$4e76eeb6df88c889();
    f(encoder);
    return $063c9cd954cb382b$export$73470fd2221e6aef(encoder);
};
const $063c9cd954cb382b$export$f24224f1c91d8156 = (encoder)=>{
    let len = encoder.cpos;
    for(let i = 0; i < encoder.bufs.length; i++)len += encoder.bufs[i].length;
    return len;
};
const $063c9cd954cb382b$export$7ad75c69830b76d7 = (encoder)=>encoder.cpos > 0 || encoder.bufs.length > 0;
const $063c9cd954cb382b$export$73470fd2221e6aef = (encoder)=>{
    const uint8arr = new Uint8Array($063c9cd954cb382b$export$f24224f1c91d8156(encoder));
    let curPos = 0;
    for(let i = 0; i < encoder.bufs.length; i++){
        const d = encoder.bufs[i];
        uint8arr.set(d, curPos);
        curPos += d.length;
    }
    uint8arr.set(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
    return uint8arr;
};
const $063c9cd954cb382b$export$39fb588b9aff60c5 = (encoder, len)=>{
    const bufferLen = encoder.cbuf.length;
    if (bufferLen - encoder.cpos < len) {
        encoder.bufs.push(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos));
        encoder.cbuf = new Uint8Array($3Lr38.max(bufferLen, len) * 2);
        encoder.cpos = 0;
    }
};
const $063c9cd954cb382b$export$68d8715fc104d294 = (encoder, num)=>{
    const bufferLen = encoder.cbuf.length;
    if (encoder.cpos === bufferLen) {
        encoder.bufs.push(encoder.cbuf);
        encoder.cbuf = new Uint8Array(bufferLen * 2);
        encoder.cpos = 0;
    }
    encoder.cbuf[encoder.cpos++] = num;
};
const $063c9cd954cb382b$export$adaa4cf7ef1b65be = (encoder, pos, num)=>{
    let buffer = null;
    // iterate all buffers and adjust position
    for(let i = 0; i < encoder.bufs.length && buffer === null; i++){
        const b = encoder.bufs[i];
        if (pos < b.length) buffer = b // found buffer
        ;
        else pos -= b.length;
    }
    if (buffer === null) // use current buffer
    buffer = encoder.cbuf;
    buffer[pos] = num;
};
const $063c9cd954cb382b$export$826a1a6619653272 = $063c9cd954cb382b$export$68d8715fc104d294;
const $063c9cd954cb382b$export$83964ea8501fbf8 = $063c9cd954cb382b$export$adaa4cf7ef1b65be;
const $063c9cd954cb382b$export$ba6b74b6f3145a00 = (encoder, num)=>{
    $063c9cd954cb382b$export$68d8715fc104d294(encoder, num & $8FTfp.BITS8);
    $063c9cd954cb382b$export$68d8715fc104d294(encoder, num >>> 8 & $8FTfp.BITS8);
};
const $063c9cd954cb382b$export$f86e1edc3d839287 = (encoder, pos, num)=>{
    $063c9cd954cb382b$export$adaa4cf7ef1b65be(encoder, pos, num & $8FTfp.BITS8);
    $063c9cd954cb382b$export$adaa4cf7ef1b65be(encoder, pos + 1, num >>> 8 & $8FTfp.BITS8);
};
const $063c9cd954cb382b$export$835343b0f7799f5b = (encoder, num)=>{
    for(let i = 0; i < 4; i++){
        $063c9cd954cb382b$export$68d8715fc104d294(encoder, num & $8FTfp.BITS8);
        num >>>= 8;
    }
};
const $063c9cd954cb382b$export$efed0d8c16230d13 = (encoder, num)=>{
    for(let i = 3; i >= 0; i--)$063c9cd954cb382b$export$68d8715fc104d294(encoder, num >>> 8 * i & $8FTfp.BITS8);
};
const $063c9cd954cb382b$export$5517b6394fc440fb = (encoder, pos, num)=>{
    for(let i = 0; i < 4; i++){
        $063c9cd954cb382b$export$adaa4cf7ef1b65be(encoder, pos + i, num & $8FTfp.BITS8);
        num >>>= 8;
    }
};
const $063c9cd954cb382b$export$872f48c75febcd2b = (encoder, num)=>{
    while(num > $8FTfp.BITS7){
        $063c9cd954cb382b$export$68d8715fc104d294(encoder, $8FTfp.BIT8 | $8FTfp.BITS7 & num);
        num = $3Lr38.floor(num / 128) // shift >>> 7
        ;
    }
    $063c9cd954cb382b$export$68d8715fc104d294(encoder, $8FTfp.BITS7 & num);
};
const $063c9cd954cb382b$export$ff90f819e16cc9bb = (encoder, num)=>{
    const isNegative = $3Lr38.isNegativeZero(num);
    if (isNegative) num = -num;
    //             |- whether to continue reading         |- whether is negative     |- number
    $063c9cd954cb382b$export$68d8715fc104d294(encoder, (num > $8FTfp.BITS6 ? $8FTfp.BIT8 : 0) | (isNegative ? $8FTfp.BIT7 : 0) | $8FTfp.BITS6 & num);
    num = $3Lr38.floor(num / 64) // shift >>> 6
    ;
    // We don't need to consider the case of num === 0 so we can use a different
    // pattern here than above.
    while(num > 0){
        $063c9cd954cb382b$export$68d8715fc104d294(encoder, (num > $8FTfp.BITS7 ? $8FTfp.BIT8 : 0) | $8FTfp.BITS7 & num);
        num = $3Lr38.floor(num / 128) // shift >>> 7
        ;
    }
};
/**
 * A cache to store strings temporarily
 */ const $063c9cd954cb382b$var$_strBuffer = new Uint8Array(30000);
const $063c9cd954cb382b$var$_maxStrBSize = $063c9cd954cb382b$var$_strBuffer.length / 3;
const $063c9cd954cb382b$export$dff327976627e12b = (encoder, str)=>{
    if (str.length < $063c9cd954cb382b$var$_maxStrBSize) {
        // We can encode the string into the existing buffer
        /* c8 ignore next */ const written = $552MW.utf8TextEncoder.encodeInto(str, $063c9cd954cb382b$var$_strBuffer).written || 0;
        $063c9cd954cb382b$export$872f48c75febcd2b(encoder, written);
        for(let i = 0; i < written; i++)$063c9cd954cb382b$export$68d8715fc104d294(encoder, $063c9cd954cb382b$var$_strBuffer[i]);
    } else $063c9cd954cb382b$export$f7d11515275e88a2(encoder, $552MW.encodeUtf8(str));
};
const $063c9cd954cb382b$export$94cf4193edfe959a = (encoder, str)=>{
    const encodedString = unescape(encodeURIComponent(str));
    const len = encodedString.length;
    $063c9cd954cb382b$export$872f48c75febcd2b(encoder, len);
    for(let i = 0; i < len; i++)$063c9cd954cb382b$export$68d8715fc104d294(encoder, /** @type {number} */ encodedString.codePointAt(i));
};
const $063c9cd954cb382b$export$dde49cb52d5f1650 = $552MW.utf8TextEncoder && /** @type {any} */ $552MW.utf8TextEncoder.encodeInto ? $063c9cd954cb382b$export$dff327976627e12b : $063c9cd954cb382b$export$94cf4193edfe959a;
const $063c9cd954cb382b$export$be5604ffb9fbbd0c = (encoder, str)=>$063c9cd954cb382b$export$6c17d6eec4abdaa6(encoder, $552MW.encodeUtf8(str));
const $063c9cd954cb382b$export$6c17d6eec4abdaa6 = (encoder, buf)=>{
    for(let i = 0; i < buf.length; i++){
        const b = buf[i];
        if (b === 0 || b === 1) $063c9cd954cb382b$export$68d8715fc104d294(encoder, 1);
        $063c9cd954cb382b$export$68d8715fc104d294(encoder, buf[i]);
    }
    $063c9cd954cb382b$export$68d8715fc104d294(encoder, 0);
};
const $063c9cd954cb382b$export$c029b62321ea3da = (encoder, append)=>$063c9cd954cb382b$export$73b5e63e27d2b4c7(encoder, $063c9cd954cb382b$export$73470fd2221e6aef(append));
const $063c9cd954cb382b$export$73b5e63e27d2b4c7 = (encoder, uint8Array)=>{
    const bufferLen = encoder.cbuf.length;
    const cpos = encoder.cpos;
    const leftCopyLen = $3Lr38.min(bufferLen - cpos, uint8Array.length);
    const rightCopyLen = uint8Array.length - leftCopyLen;
    encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
    encoder.cpos += leftCopyLen;
    if (rightCopyLen > 0) {
        // Still something to write, write right half..
        // Append new buffer
        encoder.bufs.push(encoder.cbuf);
        // must have at least size of remaining buffer
        encoder.cbuf = new Uint8Array($3Lr38.max(bufferLen * 2, rightCopyLen));
        // copy array
        encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
        encoder.cpos = rightCopyLen;
    }
};
const $063c9cd954cb382b$export$f7d11515275e88a2 = (encoder, uint8Array)=>{
    $063c9cd954cb382b$export$872f48c75febcd2b(encoder, uint8Array.byteLength);
    $063c9cd954cb382b$export$73b5e63e27d2b4c7(encoder, uint8Array);
};
const $063c9cd954cb382b$export$1f031ae9c71bd530 = (encoder, len)=>{
    $063c9cd954cb382b$export$39fb588b9aff60c5(encoder, len);
    const dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
    encoder.cpos += len;
    return dview;
};
const $063c9cd954cb382b$export$a33455db0a9638a6 = (encoder, num)=>$063c9cd954cb382b$export$1f031ae9c71bd530(encoder, 4).setFloat32(0, num, false);
const $063c9cd954cb382b$export$231a04cea676c54c = (encoder, num)=>$063c9cd954cb382b$export$1f031ae9c71bd530(encoder, 8).setFloat64(0, num, false);
const $063c9cd954cb382b$export$4fbfa93dd6e14543 = (encoder, num)=>/** @type {any} */ $063c9cd954cb382b$export$1f031ae9c71bd530(encoder, 8).setBigInt64(0, num, false);
const $063c9cd954cb382b$export$663ca46034903888 = (encoder, num)=>/** @type {any} */ $063c9cd954cb382b$export$1f031ae9c71bd530(encoder, 8).setBigUint64(0, num, false);
const $063c9cd954cb382b$var$floatTestBed = new DataView(new ArrayBuffer(4));
/**
 * Check if a number can be encoded as a 32 bit float.
 *
 * @param {number} num
 * @return {boolean}
 */ const $063c9cd954cb382b$var$isFloat32 = (num)=>{
    $063c9cd954cb382b$var$floatTestBed.setFloat32(0, num);
    return $063c9cd954cb382b$var$floatTestBed.getFloat32(0) === num;
};
const $063c9cd954cb382b$export$264b1e8551468ea = (encoder, data)=>{
    switch(typeof data){
        case 'string':
            // TYPE 119: STRING
            $063c9cd954cb382b$export$68d8715fc104d294(encoder, 119);
            $063c9cd954cb382b$export$dde49cb52d5f1650(encoder, data);
            break;
        case 'number':
            if ($5165E.isInteger(data) && $3Lr38.abs(data) <= $8FTfp.BITS31) {
                // TYPE 125: INTEGER
                $063c9cd954cb382b$export$68d8715fc104d294(encoder, 125);
                $063c9cd954cb382b$export$ff90f819e16cc9bb(encoder, data);
            } else if ($063c9cd954cb382b$var$isFloat32(data)) {
                // TYPE 124: FLOAT32
                $063c9cd954cb382b$export$68d8715fc104d294(encoder, 124);
                $063c9cd954cb382b$export$a33455db0a9638a6(encoder, data);
            } else {
                // TYPE 123: FLOAT64
                $063c9cd954cb382b$export$68d8715fc104d294(encoder, 123);
                $063c9cd954cb382b$export$231a04cea676c54c(encoder, data);
            }
            break;
        case 'bigint':
            // TYPE 122: BigInt
            $063c9cd954cb382b$export$68d8715fc104d294(encoder, 122);
            $063c9cd954cb382b$export$4fbfa93dd6e14543(encoder, data);
            break;
        case 'object':
            if (data === null) // TYPE 126: null
            $063c9cd954cb382b$export$68d8715fc104d294(encoder, 126);
            else if ($5DExo.isArray(data)) {
                // TYPE 117: Array
                $063c9cd954cb382b$export$68d8715fc104d294(encoder, 117);
                $063c9cd954cb382b$export$872f48c75febcd2b(encoder, data.length);
                for(let i = 0; i < data.length; i++)$063c9cd954cb382b$export$264b1e8551468ea(encoder, data[i]);
            } else if (data instanceof Uint8Array) {
                // TYPE 116: ArrayBuffer
                $063c9cd954cb382b$export$68d8715fc104d294(encoder, 116);
                $063c9cd954cb382b$export$f7d11515275e88a2(encoder, data);
            } else {
                // TYPE 118: Object
                $063c9cd954cb382b$export$68d8715fc104d294(encoder, 118);
                const keys = Object.keys(data);
                $063c9cd954cb382b$export$872f48c75febcd2b(encoder, keys.length);
                for(let i = 0; i < keys.length; i++){
                    const key = keys[i];
                    $063c9cd954cb382b$export$dde49cb52d5f1650(encoder, key);
                    $063c9cd954cb382b$export$264b1e8551468ea(encoder, data[key]);
                }
            }
            break;
        case 'boolean':
            // TYPE 120/121: boolean (true/false)
            $063c9cd954cb382b$export$68d8715fc104d294(encoder, data ? 120 : 121);
            break;
        default:
            // TYPE 127: undefined
            $063c9cd954cb382b$export$68d8715fc104d294(encoder, 127);
    }
};
class $063c9cd954cb382b$export$8fa72bb4fa9409ff extends $063c9cd954cb382b$export$a50aceb0e02a00aa {
    /**
   * @param {function(Encoder, T):void} writer
   */ constructor(writer){
        super();
        /**
     * The writer
     */ this.w = writer;
        /**
     * Current state
     * @type {T|null}
     */ this.s = null;
        this.count = 0;
    }
    /**
   * @param {T} v
   */ write(v) {
        if (this.s === v) this.count++;
        else {
            if (this.count > 0) // flush counter, unless this is the first value (count = 0)
            $063c9cd954cb382b$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
            ;
            this.count = 1;
            // write first value
            this.w(this, v);
            this.s = v;
        }
    }
}
class $063c9cd954cb382b$export$c636f3fa46f2752c extends $063c9cd954cb382b$export$a50aceb0e02a00aa {
    /**
   * @param {number} start
   */ constructor(start){
        super();
        /**
     * Current state
     * @type {number}
     */ this.s = start;
    }
    /**
   * @param {number} v
   */ write(v) {
        $063c9cd954cb382b$export$ff90f819e16cc9bb(this, v - this.s);
        this.s = v;
    }
}
class $063c9cd954cb382b$export$29917ece4cb403fb extends $063c9cd954cb382b$export$a50aceb0e02a00aa {
    /**
   * @param {number} start
   */ constructor(start){
        super();
        /**
     * Current state
     * @type {number}
     */ this.s = start;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s === v && this.count > 0) this.count++;
        else {
            if (this.count > 0) // flush counter, unless this is the first value (count = 0)
            $063c9cd954cb382b$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
            ;
            this.count = 1;
            // write first value
            $063c9cd954cb382b$export$ff90f819e16cc9bb(this, v - this.s);
            this.s = v;
        }
    }
}
/**
 * @param {UintOptRleEncoder} encoder
 */ const $063c9cd954cb382b$var$flushUintOptRleEncoder = (encoder)=>{
    if (encoder.count > 0) {
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set sign to positive
        // case 2: write several values. set sign to negative to indicate that there is a length coming
        $063c9cd954cb382b$export$ff90f819e16cc9bb(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
        if (encoder.count > 1) $063c9cd954cb382b$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
class $063c9cd954cb382b$export$785ebd3312c38061 {
    constructor(){
        this.encoder = new $063c9cd954cb382b$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s === v) this.count++;
        else {
            $063c9cd954cb382b$var$flushUintOptRleEncoder(this);
            this.count = 1;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $063c9cd954cb382b$var$flushUintOptRleEncoder(this);
        return $063c9cd954cb382b$export$73470fd2221e6aef(this.encoder);
    }
}
class $063c9cd954cb382b$export$f460a01fb0702193 {
    constructor(){
        this.encoder = new $063c9cd954cb382b$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s + this.count === v) this.count++;
        else {
            $063c9cd954cb382b$var$flushUintOptRleEncoder(this);
            this.count = 1;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $063c9cd954cb382b$var$flushUintOptRleEncoder(this);
        return $063c9cd954cb382b$export$73470fd2221e6aef(this.encoder);
    }
}
/**
 * @param {IntDiffOptRleEncoder} encoder
 */ const $063c9cd954cb382b$var$flushIntDiffOptRleEncoder = (encoder)=>{
    if (encoder.count > 0) {
        //          31 bit making up the diff | wether to write the counter
        // const encodedDiff = encoder.diff << 1 | (encoder.count === 1 ? 0 : 1)
        const encodedDiff = encoder.diff * 2 + (encoder.count === 1 ? 0 : 1);
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set first bit to positive
        // case 2: write several values. set first bit to negative to indicate that there is a length coming
        $063c9cd954cb382b$export$ff90f819e16cc9bb(encoder.encoder, encodedDiff);
        if (encoder.count > 1) $063c9cd954cb382b$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
class $063c9cd954cb382b$export$7542c66a59375c6f {
    constructor(){
        this.encoder = new $063c9cd954cb382b$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.diff === v - this.s) {
            this.s = v;
            this.count++;
        } else {
            $063c9cd954cb382b$var$flushIntDiffOptRleEncoder(this);
            this.count = 1;
            this.diff = v - this.s;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $063c9cd954cb382b$var$flushIntDiffOptRleEncoder(this);
        return $063c9cd954cb382b$export$73470fd2221e6aef(this.encoder);
    }
}
class $063c9cd954cb382b$export$7dcdc5c32f31c550 {
    constructor(){
        /**
     * @type {Array<string>}
     */ this.sarr = [];
        this.s = '';
        this.lensE = new $063c9cd954cb382b$export$785ebd3312c38061();
    }
    /**
   * @param {string} string
   */ write(string) {
        this.s += string;
        if (this.s.length > 19) {
            this.sarr.push(this.s);
            this.s = '';
        }
        this.lensE.write(string.length);
    }
    toUint8Array() {
        const encoder = new $063c9cd954cb382b$export$a50aceb0e02a00aa();
        this.sarr.push(this.s);
        this.s = '';
        $063c9cd954cb382b$export$dde49cb52d5f1650(encoder, this.sarr.join(''));
        $063c9cd954cb382b$export$73b5e63e27d2b4c7(encoder, this.lensE.toUint8Array());
        return $063c9cd954cb382b$export$73470fd2221e6aef(encoder);
    }
}

});
parcelRegister("5165E", function(module, exports) {

$parcel$export(module.exports, "MAX_SAFE_INTEGER", () => $3a71c5256d05de9c$export$18510406f204a1b9);
$parcel$export(module.exports, "MIN_SAFE_INTEGER", () => $3a71c5256d05de9c$export$91ddad910c1af487);
$parcel$export(module.exports, "isInteger", () => $3a71c5256d05de9c$export$a287f47fed4544b8);
/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */ 
var $3Lr38 = parcelRequire("3Lr38");

var $8FTfp = parcelRequire("8FTfp");
const $3a71c5256d05de9c$export$18510406f204a1b9 = Number.MAX_SAFE_INTEGER;
const $3a71c5256d05de9c$export$91ddad910c1af487 = Number.MIN_SAFE_INTEGER;
const $3a71c5256d05de9c$export$7accc3db8e859605 = -2147483648;
const $3a71c5256d05de9c$export$a5f353c3c14c00d0 = $8FTfp.BITS31;
const $3a71c5256d05de9c$export$f055c566d4c0f541 = $8FTfp.BITS32;
const $3a71c5256d05de9c$export$a287f47fed4544b8 = Number.isInteger || ((num)=>typeof num === 'number' && isFinite(num) && $3Lr38.floor(num) === num);
const $3a71c5256d05de9c$export$c9f5652083b8129d = Number.isNaN;
const $3a71c5256d05de9c$export$5f87784a266e50a4 = Number.parseInt;
const $3a71c5256d05de9c$export$33de6ea056a4cdbb = (n)=>{
    n &= $8FTfp.BITS32;
    let count = 0;
    while(n){
        n &= n - 1;
        count++;
    }
    return count;
};

});
parcelRegister("8FTfp", function(module, exports) {

$parcel$export(module.exports, "BIT1", () => $650d0215e544463d$export$ee2c6657cb286da4);
$parcel$export(module.exports, "BIT2", () => $650d0215e544463d$export$1f117f3b0edc2676);
$parcel$export(module.exports, "BIT3", () => $650d0215e544463d$export$e5294f8c78cf7711);
$parcel$export(module.exports, "BIT4", () => $650d0215e544463d$export$873ae8db4cef5125);
$parcel$export(module.exports, "BIT6", () => $650d0215e544463d$export$daf23f774967089);
$parcel$export(module.exports, "BIT7", () => $650d0215e544463d$export$eb5a8e0006ab4bb5);
$parcel$export(module.exports, "BIT8", () => $650d0215e544463d$export$e25597372303a045);
$parcel$export(module.exports, "BITS5", () => $650d0215e544463d$export$bc2aba63e4099c09);
$parcel$export(module.exports, "BITS6", () => $650d0215e544463d$export$f39f4e074e983a34);
$parcel$export(module.exports, "BITS7", () => $650d0215e544463d$export$f84d6bebff154ceb);
$parcel$export(module.exports, "BITS8", () => $650d0215e544463d$export$c880072ee0e87648);
$parcel$export(module.exports, "BITS21", () => $650d0215e544463d$export$b5ffbef7f0f6f536);
$parcel$export(module.exports, "BITS31", () => $650d0215e544463d$export$87ec42487f19c66c);
$parcel$export(module.exports, "BITS32", () => $650d0215e544463d$export$3ea07c5174cba08a);
/* eslint-env browser */ /**
 * Binary data constants.
 *
 * @module binary
 */ /**
 * n-th bit activated.
 *
 * @type {number}
 */ const $650d0215e544463d$export$ee2c6657cb286da4 = 1;
const $650d0215e544463d$export$1f117f3b0edc2676 = 2;
const $650d0215e544463d$export$e5294f8c78cf7711 = 4;
const $650d0215e544463d$export$873ae8db4cef5125 = 8;
const $650d0215e544463d$export$b6e6496517dfbd31 = 16;
const $650d0215e544463d$export$daf23f774967089 = 32;
const $650d0215e544463d$export$eb5a8e0006ab4bb5 = 64;
const $650d0215e544463d$export$e25597372303a045 = 128;
const $650d0215e544463d$export$f15587807021fe79 = 256;
const $650d0215e544463d$export$70939d57ba836c5 = 512;
const $650d0215e544463d$export$9ec47920d80e8c85 = 1024;
const $650d0215e544463d$export$bc5dd16b35d4584b = 2048;
const $650d0215e544463d$export$76a85e893e6d6ecc = 4096;
const $650d0215e544463d$export$fb6ca64a3ffa3aa9 = 8192;
const $650d0215e544463d$export$e7adc86ee9ea4b00 = 16384;
const $650d0215e544463d$export$6aa68b9346d558bb = 32768;
const $650d0215e544463d$export$5d7aab37466c79ea = 65536;
const $650d0215e544463d$export$3aa401309ff3940 = 131072;
const $650d0215e544463d$export$1fd8467d3320465f = 262144;
const $650d0215e544463d$export$d1dceb84a396f684 = 524288;
const $650d0215e544463d$export$ef62e7729d79baec = 1048576;
const $650d0215e544463d$export$40651ae3846a7710 = 2097152;
const $650d0215e544463d$export$e03976987cb0b818 = 4194304;
const $650d0215e544463d$export$dd5dceb22223d8ef = 8388608;
const $650d0215e544463d$export$aecaefba6ae044e4 = 16777216;
const $650d0215e544463d$export$6e47d6f6c411c0e1 = 33554432;
const $650d0215e544463d$export$321a8fda0150a18 = 67108864;
const $650d0215e544463d$export$d7843230fff08622 = 134217728;
const $650d0215e544463d$export$9fe7219cb72d1ed8 = 268435456;
const $650d0215e544463d$export$c85121a54e1cc97f = 536870912;
const $650d0215e544463d$export$76075a64dc7c21ef = 1073741824;
const $650d0215e544463d$export$49d5cdcf29800e09 = -2147483648;
const $650d0215e544463d$export$853d99058378c102 = 0;
const $650d0215e544463d$export$b859c32a415b3ec1 = 1;
const $650d0215e544463d$export$decefe6957191373 = 3;
const $650d0215e544463d$export$d1defff3cbd2c6f4 = 7;
const $650d0215e544463d$export$8d2b432c8c02ae65 = 15;
const $650d0215e544463d$export$bc2aba63e4099c09 = 31;
const $650d0215e544463d$export$f39f4e074e983a34 = 63;
const $650d0215e544463d$export$f84d6bebff154ceb = 127;
const $650d0215e544463d$export$c880072ee0e87648 = 255;
const $650d0215e544463d$export$cbbfa5d3c076ad8c = 511;
const $650d0215e544463d$export$e365aa75b5fa7293 = 1023;
const $650d0215e544463d$export$51bfc23c1b7b60c3 = 2047;
const $650d0215e544463d$export$3b0a099b88523ac = 4095;
const $650d0215e544463d$export$8345c1c06d3e5fc1 = 8191;
const $650d0215e544463d$export$e20cffba663a7688 = 16383;
const $650d0215e544463d$export$cd0970fd37b207c6 = 32767;
const $650d0215e544463d$export$250487b182389b6a = 65535;
const $650d0215e544463d$export$9d6e01d73abdaadb = $650d0215e544463d$export$3aa401309ff3940 - 1;
const $650d0215e544463d$export$eedeab0ac4009664 = $650d0215e544463d$export$1fd8467d3320465f - 1;
const $650d0215e544463d$export$e1840c3c33a76ffc = $650d0215e544463d$export$d1dceb84a396f684 - 1;
const $650d0215e544463d$export$f0ae3ba8312e92e3 = $650d0215e544463d$export$ef62e7729d79baec - 1;
const $650d0215e544463d$export$b5ffbef7f0f6f536 = $650d0215e544463d$export$40651ae3846a7710 - 1;
const $650d0215e544463d$export$33ae34bc8e747862 = $650d0215e544463d$export$e03976987cb0b818 - 1;
const $650d0215e544463d$export$3629272792e6a9a0 = $650d0215e544463d$export$dd5dceb22223d8ef - 1;
const $650d0215e544463d$export$a07300a4cc2ba23c = $650d0215e544463d$export$aecaefba6ae044e4 - 1;
const $650d0215e544463d$export$9137f2824b26e02b = $650d0215e544463d$export$6e47d6f6c411c0e1 - 1;
const $650d0215e544463d$export$94d4c3aa7cfbb8dd = $650d0215e544463d$export$321a8fda0150a18 - 1;
const $650d0215e544463d$export$8af89455097efce0 = $650d0215e544463d$export$d7843230fff08622 - 1;
const $650d0215e544463d$export$dee9196bb8567fe9 = $650d0215e544463d$export$9fe7219cb72d1ed8 - 1;
const $650d0215e544463d$export$bd0b5ef1d89e90f = $650d0215e544463d$export$c85121a54e1cc97f - 1;
const $650d0215e544463d$export$e5560e011efa8766 = $650d0215e544463d$export$76075a64dc7c21ef - 1;
const $650d0215e544463d$export$87ec42487f19c66c = 0x7FFFFFFF;
const $650d0215e544463d$export$3ea07c5174cba08a = 0xFFFFFFFF;

});


parcelRegister("552MW", function(module, exports) {

$parcel$export(module.exports, "fromCharCode", () => $3b2f95159c4bf1c8$export$30216c0101da0ee0);
$parcel$export(module.exports, "fromCodePoint", () => $3b2f95159c4bf1c8$export$73bfc63873071f74);
$parcel$export(module.exports, "fromCamelCase", () => $3b2f95159c4bf1c8$export$87429743646c3257);
$parcel$export(module.exports, "utf8TextEncoder", () => $3b2f95159c4bf1c8$export$f3ce4806f2484eb);
$parcel$export(module.exports, "encodeUtf8", () => $3b2f95159c4bf1c8$export$8f647c2204da8484);
$parcel$export(module.exports, "utf8TextDecoder", () => $3b2f95159c4bf1c8$export$f477633695bbbcd);
$parcel$export(module.exports, "decodeUtf8", () => $3b2f95159c4bf1c8$export$72118b85b055afd);
$parcel$export(module.exports, "repeat", () => $3b2f95159c4bf1c8$export$76d90c956114f2c2);

var $5DExo = parcelRequire("5DExo");
const $3b2f95159c4bf1c8$export$30216c0101da0ee0 = String.fromCharCode;
const $3b2f95159c4bf1c8$export$73bfc63873071f74 = String.fromCodePoint;
const $3b2f95159c4bf1c8$export$e3a9a653b2a11ac1 = $3b2f95159c4bf1c8$export$30216c0101da0ee0(65535);
/**
 * @param {string} s
 * @return {string}
 */ const $3b2f95159c4bf1c8$var$toLowerCase = (s)=>s.toLowerCase();
const $3b2f95159c4bf1c8$var$trimLeftRegex = /^\s*/g;
const $3b2f95159c4bf1c8$export$c5557f40488c48ec = (s)=>s.replace($3b2f95159c4bf1c8$var$trimLeftRegex, '');
const $3b2f95159c4bf1c8$var$fromCamelCaseRegex = /([A-Z])/g;
const $3b2f95159c4bf1c8$export$87429743646c3257 = (s, separator)=>$3b2f95159c4bf1c8$export$c5557f40488c48ec(s.replace($3b2f95159c4bf1c8$var$fromCamelCaseRegex, (match)=>`${separator}${$3b2f95159c4bf1c8$var$toLowerCase(match)}`));
const $3b2f95159c4bf1c8$export$ba35f6b806a3dbd4 = (str)=>unescape(encodeURIComponent(str)).length;
const $3b2f95159c4bf1c8$export$83d8cea287b4dfcd = (str)=>{
    const encodedString = unescape(encodeURIComponent(str));
    const len = encodedString.length;
    const buf = new Uint8Array(len);
    for(let i = 0; i < len; i++)buf[i] = /** @type {number} */ encodedString.codePointAt(i);
    return buf;
};
const $3b2f95159c4bf1c8$export$f3ce4806f2484eb = /** @type {TextEncoder} */ typeof TextEncoder !== 'undefined' ? new TextEncoder() : null;
const $3b2f95159c4bf1c8$export$9a0a70804ee285dd = (str)=>$3b2f95159c4bf1c8$export$f3ce4806f2484eb.encode(str);
const $3b2f95159c4bf1c8$export$8f647c2204da8484 = $3b2f95159c4bf1c8$export$f3ce4806f2484eb ? $3b2f95159c4bf1c8$export$9a0a70804ee285dd : $3b2f95159c4bf1c8$export$83d8cea287b4dfcd;
const $3b2f95159c4bf1c8$export$154b750182ae32cf = (buf)=>{
    let remainingLen = buf.length;
    let encodedString = '';
    let bufPos = 0;
    while(remainingLen > 0){
        const nextLen = remainingLen < 10000 ? remainingLen : 10000;
        const bytes = buf.subarray(bufPos, bufPos + nextLen);
        bufPos += nextLen;
        // Starting with ES5.1 we can supply a generic array-like object as arguments
        encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
        remainingLen -= nextLen;
    }
    return decodeURIComponent(escape(encodedString));
};
let $3b2f95159c4bf1c8$export$f477633695bbbcd = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8', {
    fatal: true,
    ignoreBOM: true
});
/* c8 ignore start */ if ($3b2f95159c4bf1c8$export$f477633695bbbcd && $3b2f95159c4bf1c8$export$f477633695bbbcd.decode(new Uint8Array()).length === 1) // Safari doesn't handle BOM correctly.
// This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
// Another issue is that from then on no BOM chars are recognized anymore
/* c8 ignore next */ $3b2f95159c4bf1c8$export$f477633695bbbcd = null;
const $3b2f95159c4bf1c8$export$23d5f1ce72f56168 = (buf)=>/** @type {TextDecoder} */ $3b2f95159c4bf1c8$export$f477633695bbbcd.decode(buf);
const $3b2f95159c4bf1c8$export$72118b85b055afd = $3b2f95159c4bf1c8$export$f477633695bbbcd ? $3b2f95159c4bf1c8$export$23d5f1ce72f56168 : $3b2f95159c4bf1c8$export$154b750182ae32cf;
const $3b2f95159c4bf1c8$export$869882364835d202 = (str, index, remove, insert = '')=>str.slice(0, index) + insert + str.slice(index + remove);
const $3b2f95159c4bf1c8$export$76d90c956114f2c2 = (source, n)=>$5DExo.unfold(n, ()=>source).join('');
const $3b2f95159c4bf1c8$export$5dd27816c66fb702 = (str)=>str.replace(/[&<>'"]/g, (r)=>/** @type {string} */ ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            "'": '&#39;',
            '"': '&quot;'
        })[r]);
const $3b2f95159c4bf1c8$export$f584d1703b02250e = (str)=>str.replace(/&amp;|&lt;|&gt;|&#39;|&quot;/g, (r)=>/** @type {string} */ ({
            '&amp;': '&',
            '&lt;': '<',
            '&gt;': '>',
            '&#39;': "'",
            '&quot;': '"'
        })[r]);

});


parcelRegister("dB3PR", function(module, exports) {

$parcel$export(module.exports, "createDecoder", () => $9e61b4b389e7f570$export$f8c898e83b60faaa);
$parcel$export(module.exports, "hasContent", () => $9e61b4b389e7f570$export$7ad75c69830b76d7);
$parcel$export(module.exports, "readVarUint8Array", () => $9e61b4b389e7f570$export$7418bbc18dee40f3);
$parcel$export(module.exports, "readVarUint", () => $9e61b4b389e7f570$export$5a476e4dbe7923d5);
$parcel$export(module.exports, "readUint8", () => $9e61b4b389e7f570$export$d5778a2beba4ceef);
$parcel$export(module.exports, "readVarInt", () => $9e61b4b389e7f570$export$1dd5b9ddf6575ae8);
$parcel$export(module.exports, "readVarString", () => $9e61b4b389e7f570$export$3b64b4d753b81ec2);
$parcel$export(module.exports, "readAny", () => $9e61b4b389e7f570$export$82863139061f472f);
$parcel$export(module.exports, "RleDecoder", () => $9e61b4b389e7f570$export$f1f1200492b832af);
$parcel$export(module.exports, "UintOptRleDecoder", () => $9e61b4b389e7f570$export$2dc62fb2f864b82e);
$parcel$export(module.exports, "IntDiffOptRleDecoder", () => $9e61b4b389e7f570$export$d502ab0bf048a596);
$parcel$export(module.exports, "StringDecoder", () => $9e61b4b389e7f570$export$63a7aa211a91ed69);
/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * Security: Decoders process untrusted input, and `decoder.arr` may be a view on a larger (possibly pooled) ArrayBuffer.
 * Never create views via `new Uint8Array(arr.buffer, ..)` / `new DataView(arr.buffer, ..)`; use the private `subarray` /
 * `subdataview` helpers, which throw on out-of-bounds access instead of exposing foreign memory.
 *
 * @module decoding
 */ 
var $8FTfp = parcelRequire("8FTfp");

var $3Lr38 = parcelRequire("3Lr38");

var $5165E = parcelRequire("5165E");

var $552MW = parcelRequire("552MW");

var $AgXfe = parcelRequire("AgXfe");

var $xchLN = parcelRequire("xchLN");
const $9e61b4b389e7f570$var$errorUnexpectedEndOfArray = $AgXfe.create('Unexpected end of array');
const $9e61b4b389e7f570$var$errorIntegerOutOfRange = $AgXfe.create('Integer out of Range');
/**
 * Create a view of `len` bytes of `arr`, starting at `begin`. Throws if the range exceeds `arr`.
 *
 * Security: Always use this (or `subdataview`) instead of `new Uint8Array(arr.buffer, ..)`. `arr` may be a view on a
 * larger (possibly shared/pooled) ArrayBuffer. An unchecked view could expose memory outside of `arr`.
 *
 * @template {ArrayBufferLike} Buf
 * @param {Uint8Array<Buf>} arr
 * @param {number} begin
 * @param {number} len
 * @return {Uint8Array<Buf>}
 */ const $9e61b4b389e7f570$var$subarray = (arr, begin, len)=>{
    if (begin < 0 || len < 0 || begin + len > arr.length) throw $9e61b4b389e7f570$var$errorUnexpectedEndOfArray;
    return new Uint8Array(arr.buffer, arr.byteOffset + begin, len);
};
/**
 * Create a DataView of `len` bytes of `arr`, starting at `begin`. Throws if the range exceeds `arr`.
 *
 * Security: See `subarray`.
 *
 * @param {Uint8Array} arr
 * @param {number} begin
 * @param {number} len
 * @return {DataView}
 */ const $9e61b4b389e7f570$var$subdataview = (arr, begin, len)=>{
    if (begin < 0 || len < 0 || begin + len > arr.length) throw $9e61b4b389e7f570$var$errorUnexpectedEndOfArray;
    return new DataView(arr.buffer, arr.byteOffset + begin, len);
};
class $9e61b4b389e7f570$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array<Buf>} uint8Array Binary data to decode
   */ constructor(uint8Array){
        /**
     * Decoding target.
     *
     * @type {Uint8Array<Buf>}
     */ this.arr = uint8Array;
        /**
     * Current decoding position.
     *
     * @type {number}
     */ this.pos = 0;
    }
}
const $9e61b4b389e7f570$export$f8c898e83b60faaa = (uint8Array)=>new $9e61b4b389e7f570$export$f9de6ca0bc043724(uint8Array);
const $9e61b4b389e7f570$export$7ad75c69830b76d7 = (decoder)=>decoder.pos !== decoder.arr.length;
const $9e61b4b389e7f570$export$9cd59f9826255e47 = (decoder, newPos = decoder.pos)=>{
    const _decoder = $9e61b4b389e7f570$export$f8c898e83b60faaa(decoder.arr);
    _decoder.pos = newPos;
    return _decoder;
};
const $9e61b4b389e7f570$export$e21b2fe168d56a89 = (decoder, len)=>{
    const view = $9e61b4b389e7f570$var$subarray(decoder.arr, decoder.pos, len);
    decoder.pos += len;
    return view;
};
const $9e61b4b389e7f570$export$7418bbc18dee40f3 = (decoder)=>$9e61b4b389e7f570$export$e21b2fe168d56a89(decoder, $9e61b4b389e7f570$export$5a476e4dbe7923d5(decoder));
const $9e61b4b389e7f570$export$8c9f57cb3e3e2d3b = (decoder)=>$9e61b4b389e7f570$export$e21b2fe168d56a89(decoder, decoder.arr.length - decoder.pos);
const $9e61b4b389e7f570$export$228a9507fbdfcdb6 = (decoder)=>decoder.pos++;
const $9e61b4b389e7f570$export$d5778a2beba4ceef = (decoder)=>decoder.arr[decoder.pos++];
const $9e61b4b389e7f570$export$ef14636f4cf20706 = (decoder)=>{
    const uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
    decoder.pos += 2;
    return uint;
};
const $9e61b4b389e7f570$export$967c96218130b9ba = (decoder)=>{
    const uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
const $9e61b4b389e7f570$export$adb88b5d4ab91f4e = (decoder)=>{
    const uint = decoder.arr[decoder.pos + 3] + (decoder.arr[decoder.pos + 2] << 8) + (decoder.arr[decoder.pos + 1] << 16) + (decoder.arr[decoder.pos] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
const $9e61b4b389e7f570$export$c6eca102d0b41ca0 = (decoder)=>decoder.arr[decoder.pos];
const $9e61b4b389e7f570$export$e5eb1e52afa13f8d = (decoder)=>decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
const $9e61b4b389e7f570$export$67e54e775d28f9ae = (decoder)=>decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
const $9e61b4b389e7f570$export$5a476e4dbe7923d5 = (decoder)=>{
    let num = 0;
    let mult = 1;
    const len = decoder.arr.length;
    while(decoder.pos < len){
        const r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $8FTfp.BITS7) * mult // shift $r << (7*#iterations) and add it to num
        ;
        mult *= 128 // next iteration, shift 7 "more" to the left
        ;
        if (r < $8FTfp.BIT8) return num;
        /* c8 ignore start */ if (num > $5165E.MAX_SAFE_INTEGER) throw $9e61b4b389e7f570$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $9e61b4b389e7f570$var$errorUnexpectedEndOfArray;
};
const $9e61b4b389e7f570$export$1dd5b9ddf6575ae8 = (decoder)=>{
    let r = decoder.arr[decoder.pos++];
    let num = r & $8FTfp.BITS6;
    let mult = 64;
    const sign = (r & $8FTfp.BIT7) > 0 ? -1 : 1;
    if ((r & $8FTfp.BIT8) === 0) // don't continue reading
    return sign * num;
    const len = decoder.arr.length;
    while(decoder.pos < len){
        r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $8FTfp.BITS7) * mult;
        mult *= 128;
        if (r < $8FTfp.BIT8) return sign * num;
        /* c8 ignore start */ if (num > $5165E.MAX_SAFE_INTEGER) throw $9e61b4b389e7f570$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $9e61b4b389e7f570$var$errorUnexpectedEndOfArray;
};
const $9e61b4b389e7f570$export$dc86e1eb544aa5ab = (decoder)=>{
    const pos = decoder.pos;
    const s = $9e61b4b389e7f570$export$5a476e4dbe7923d5(decoder);
    decoder.pos = pos;
    return s;
};
const $9e61b4b389e7f570$export$47c43df02cd47fca = (decoder)=>{
    const pos = decoder.pos;
    const s = $9e61b4b389e7f570$export$1dd5b9ddf6575ae8(decoder);
    decoder.pos = pos;
    return s;
};
const $9e61b4b389e7f570$export$e73299e6158668bb = (decoder)=>{
    let remainingLen = $9e61b4b389e7f570$export$5a476e4dbe7923d5(decoder);
    if (remainingLen === 0) return '';
    else {
        let encodedString = String.fromCodePoint($9e61b4b389e7f570$export$d5778a2beba4ceef(decoder)) // remember to decrease remainingLen
        ;
        if (--remainingLen < 100) while(remainingLen--)encodedString += String.fromCodePoint($9e61b4b389e7f570$export$d5778a2beba4ceef(decoder));
        else while(remainingLen > 0){
            const nextLen = remainingLen < 10000 ? remainingLen : 10000;
            // this is dangerous, we create a fresh array view from the existing buffer
            const bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
            decoder.pos += nextLen;
            // Starting with ES5.1 we can supply a generic array-like object as arguments
            encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
            remainingLen -= nextLen;
        }
        return decodeURIComponent(escape(encodedString));
    }
};
const $9e61b4b389e7f570$export$7247eefae50fb91a = (decoder)=>/** @type any */ $552MW.utf8TextDecoder.decode($9e61b4b389e7f570$export$7418bbc18dee40f3(decoder));
const $9e61b4b389e7f570$export$3b64b4d753b81ec2 = $552MW.utf8TextDecoder ? $9e61b4b389e7f570$export$7247eefae50fb91a : $9e61b4b389e7f570$export$e73299e6158668bb;
const $9e61b4b389e7f570$export$23764cfecad9ae2f = (decoder)=>{
    const encoder = $xchLN.createEncoder();
    let b;
    while(true){
        b = $9e61b4b389e7f570$export$d5778a2beba4ceef(decoder);
        if (b === 0) return $xchLN.toUint8Array(encoder);
        if (b === 1) b = $9e61b4b389e7f570$export$d5778a2beba4ceef(decoder);
        $xchLN.write(encoder, b);
    }
};
const $9e61b4b389e7f570$export$d38ec182b293d566 = (decoder)=>$552MW.decodeUtf8($9e61b4b389e7f570$export$23764cfecad9ae2f(decoder));
const $9e61b4b389e7f570$export$91c1f3f0dd9bd2f5 = (decoder)=>{
    const pos = decoder.pos;
    const s = $9e61b4b389e7f570$export$3b64b4d753b81ec2(decoder);
    decoder.pos = pos;
    return s;
};
const $9e61b4b389e7f570$export$d7dd05f632129fe5 = (decoder, len)=>{
    const dv = $9e61b4b389e7f570$var$subdataview(decoder.arr, decoder.pos, len);
    decoder.pos += len;
    return dv;
};
const $9e61b4b389e7f570$export$dbc4aa781d9afe3b = (decoder)=>$9e61b4b389e7f570$export$d7dd05f632129fe5(decoder, 4).getFloat32(0, false);
const $9e61b4b389e7f570$export$d89a471990a89a7f = (decoder)=>$9e61b4b389e7f570$export$d7dd05f632129fe5(decoder, 8).getFloat64(0, false);
const $9e61b4b389e7f570$export$99e633bd4f295d85 = (decoder)=>/** @type {any} */ $9e61b4b389e7f570$export$d7dd05f632129fe5(decoder, 8).getBigInt64(0, false);
const $9e61b4b389e7f570$export$21575c47d1f9b652 = (decoder)=>/** @type {any} */ $9e61b4b389e7f570$export$d7dd05f632129fe5(decoder, 8).getBigUint64(0, false);
/**
 * @type {Array<function(Decoder):any>}
 */ const $9e61b4b389e7f570$var$readAnyLookupTable = [
    (decoder)=>undefined,
    (decoder)=>null,
    $9e61b4b389e7f570$export$1dd5b9ddf6575ae8,
    $9e61b4b389e7f570$export$dbc4aa781d9afe3b,
    $9e61b4b389e7f570$export$d89a471990a89a7f,
    $9e61b4b389e7f570$export$99e633bd4f295d85,
    (decoder)=>false,
    (decoder)=>true,
    $9e61b4b389e7f570$export$3b64b4d753b81ec2,
    (decoder)=>{
        const len = $9e61b4b389e7f570$export$5a476e4dbe7923d5(decoder);
        /**
     * @type {Object<string,any>}
     */ const obj = {};
        for(let i = 0; i < len; i++){
            const key = $9e61b4b389e7f570$export$3b64b4d753b81ec2(decoder);
            obj[key] = $9e61b4b389e7f570$export$82863139061f472f(decoder);
        }
        return obj;
    },
    (decoder)=>{
        const len = $9e61b4b389e7f570$export$5a476e4dbe7923d5(decoder);
        const arr = [];
        for(let i = 0; i < len; i++)arr.push($9e61b4b389e7f570$export$82863139061f472f(decoder));
        return arr;
    },
    $9e61b4b389e7f570$export$7418bbc18dee40f3 // CASE 116: Uint8Array
];
const $9e61b4b389e7f570$export$82863139061f472f = (decoder)=>$9e61b4b389e7f570$var$readAnyLookupTable[127 - $9e61b4b389e7f570$export$d5778a2beba4ceef(decoder)](decoder);
class $9e61b4b389e7f570$export$f1f1200492b832af extends $9e61b4b389e7f570$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */ constructor(uint8Array, reader){
        super(uint8Array);
        /**
     * The reader
     */ this.reader = reader;
        /**
     * Current state
     * @type {T|null}
     */ this.s = null;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = this.reader(this);
            if ($9e61b4b389e7f570$export$7ad75c69830b76d7(this)) this.count = $9e61b4b389e7f570$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
            ;
            else this.count = -1 // read the current value forever
            ;
        }
        this.count--;
        return /** @type {T} */ this.s;
    }
}
class $9e61b4b389e7f570$export$938378143fffe1b4 extends $9e61b4b389e7f570$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */ constructor(uint8Array, start){
        super(uint8Array);
        /**
     * Current state
     * @type {number}
     */ this.s = start;
    }
    /**
   * @return {number}
   */ read() {
        this.s += $9e61b4b389e7f570$export$1dd5b9ddf6575ae8(this);
        return this.s;
    }
}
class $9e61b4b389e7f570$export$595b36f1b42934c6 extends $9e61b4b389e7f570$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */ constructor(uint8Array, start){
        super(uint8Array);
        /**
     * Current state
     * @type {number}
     */ this.s = start;
        this.count = 0;
    }
    /**
   * @return {number}
   */ read() {
        if (this.count === 0) {
            this.s += $9e61b4b389e7f570$export$1dd5b9ddf6575ae8(this);
            if ($9e61b4b389e7f570$export$7ad75c69830b76d7(this)) this.count = $9e61b4b389e7f570$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
            ;
            else this.count = -1 // read the current value forever
            ;
        }
        this.count--;
        return /** @type {number} */ this.s;
    }
}
class $9e61b4b389e7f570$export$2dc62fb2f864b82e extends $9e61b4b389e7f570$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = $9e61b4b389e7f570$export$1dd5b9ddf6575ae8(this);
            // if the sign is negative, we read the count too, otherwise count is 1
            const isNegative = $3Lr38.isNegativeZero(this.s);
            this.count = 1;
            if (isNegative) {
                this.s = -this.s;
                this.count = $9e61b4b389e7f570$export$5a476e4dbe7923d5(this) + 2;
            }
        }
        this.count--;
        return /** @type {number} */ this.s;
    }
}
class $9e61b4b389e7f570$export$727389af14dfe417 extends $9e61b4b389e7f570$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = $9e61b4b389e7f570$export$1dd5b9ddf6575ae8(this);
            // if the sign is negative, we read the count too, otherwise count is 1
            const isNegative = $3Lr38.isNegativeZero(this.s);
            this.count = 1;
            if (isNegative) {
                this.s = -this.s;
                this.count = $9e61b4b389e7f570$export$5a476e4dbe7923d5(this) + 2;
            }
        }
        this.count--;
        return /** @type {number} */ this.s++;
    }
}
class $9e61b4b389e7f570$export$d502ab0bf048a596 extends $9e61b4b389e7f570$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
    /**
   * @return {number}
   */ read() {
        if (this.count === 0) {
            const diff = $9e61b4b389e7f570$export$1dd5b9ddf6575ae8(this);
            // if the first bit is set, we read more data
            const hasCount = diff & 1;
            this.diff = $3Lr38.floor(diff / 2) // shift >> 1
            ;
            this.count = 1;
            if (hasCount) this.count = $9e61b4b389e7f570$export$5a476e4dbe7923d5(this) + 2;
        }
        this.s += this.diff;
        this.count--;
        return this.s;
    }
}
class $9e61b4b389e7f570$export$63a7aa211a91ed69 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        this.decoder = new $9e61b4b389e7f570$export$2dc62fb2f864b82e(uint8Array);
        this.str = $9e61b4b389e7f570$export$3b64b4d753b81ec2(this.decoder);
        /**
     * @type {number}
     */ this.spos = 0;
    }
    /**
   * @return {string}
   */ read() {
        const end = this.spos + this.decoder.read();
        const res = this.str.slice(this.spos, end);
        this.spos = end;
        return res;
    }
}

});
parcelRegister("AgXfe", function(module, exports) {

$parcel$export(module.exports, "create", () => $06d083bae116d703$export$185802fd694ee1f5);
$parcel$export(module.exports, "methodUnimplemented", () => $06d083bae116d703$export$73ced5c7e10d6d0f);
$parcel$export(module.exports, "unexpectedCase", () => $06d083bae116d703$export$965b6bccecbd9673);
/**
 * Error helpers.
 *
 * @module error
 */ /**
 * @param {string} s
 * @return {Error}
 */ /* c8 ignore next */ const $06d083bae116d703$export$185802fd694ee1f5 = (s)=>new Error(s);
const $06d083bae116d703$export$73ced5c7e10d6d0f = ()=>{
    throw $06d083bae116d703$export$185802fd694ee1f5('Method unimplemented');
};
const $06d083bae116d703$export$965b6bccecbd9673 = ()=>{
    throw $06d083bae116d703$export$185802fd694ee1f5('Unexpected case');
};
const $06d083bae116d703$export$a7a9523472993e97 = (property)=>{
    if (!property) throw $06d083bae116d703$export$185802fd694ee1f5('Assert failed');
};

});


parcelRegister("fwtVw", function(module, exports) {

$parcel$export(module.exports, "uint32", () => $b4d10f0146fe38e6$export$de9ffb9418dd7d0d);
$parcel$export(module.exports, "uuidv4", () => $b4d10f0146fe38e6$export$abe4376e1bf796d6);
/**
 * Isomorphic module for true random numbers / buffers / uuids.
 *
 * Attention: falls back to Math.random if the browser does not support crypto.
 *
 * @module random
 */ 
var $3Lr38 = parcelRequire("3Lr38");

var $8FTfp = parcelRequire("8FTfp");

var $iJGAB = parcelRequire("iJGAB");
const $b4d10f0146fe38e6$export$bb0a9c36cf454ea0 = Math.random;
const $b4d10f0146fe38e6$export$de9ffb9418dd7d0d = ()=>(0, $iJGAB.getRandomValues)(new Uint32Array(1))[0];
const $b4d10f0146fe38e6$export$6bf94e3d82617e4e = ()=>{
    const arr = (0, $iJGAB.getRandomValues)(new Uint32Array(8));
    return (arr[0] & $8FTfp.BITS21) * ($8FTfp.BITS32 + 1) + (arr[1] >>> 0);
};
const $b4d10f0146fe38e6$export$a9a18ae5ba42aeab = (arr)=>arr[$3Lr38.floor($b4d10f0146fe38e6$export$bb0a9c36cf454ea0() * arr.length)];
// @ts-ignore
const $b4d10f0146fe38e6$var$uuidv4Template = "10000000-1000-4000-8000-100000000000";
const $b4d10f0146fe38e6$export$abe4376e1bf796d6 = ()=>$b4d10f0146fe38e6$var$uuidv4Template.replace(/[018]/g, /** @param {number} c */ (c)=>(c ^ $b4d10f0146fe38e6$export$de9ffb9418dd7d0d() & 15 >> c / 4).toString(16));

});
parcelRegister("iJGAB", function(module, exports) {

$parcel$export(module.exports, "getRandomValues", () => $da3d775993419f8d$export$960b9ff25e7d4257);
/* eslint-env browser */ const $da3d775993419f8d$export$f45422fd2e8042d4 = crypto.subtle;
const $da3d775993419f8d$export$960b9ff25e7d4257 = crypto.getRandomValues.bind(crypto);

});


parcelRegister("hX8wf", function(module, exports) {

$parcel$export(module.exports, "create", () => $d11e8e1685bf5de1$export$185802fd694ee1f5);
/**
 * Utility helpers to work with promises.
 *
 * @module promise
 */ 
var $g2kVL = parcelRequire("g2kVL");
const $d11e8e1685bf5de1$export$185802fd694ee1f5 = (f)=>/** @type {Promise<T>} */ new Promise(f);
const $d11e8e1685bf5de1$export$fe201bb3bbe031e9 = (f)=>new Promise(f);
const $d11e8e1685bf5de1$export$84bf76cd7afc7469 = Promise.all.bind(Promise);
const $d11e8e1685bf5de1$export$2800f3ceda99eb84 = (reason)=>Promise.reject(reason);
const $d11e8e1685bf5de1$export$f7ad0328861e2f03 = (res)=>Promise.resolve(res);
const $d11e8e1685bf5de1$export$65eff93aa071dbbd = (res)=>Promise.resolve(res);
const $d11e8e1685bf5de1$export$a40009bd2c363351 = (timeout, check, intervalResolution = 10)=>$d11e8e1685bf5de1$export$185802fd694ee1f5((resolve, reject)=>{
        const startTime = $g2kVL.getUnixTime();
        const hasTimeout = timeout > 0;
        const untilInterval = ()=>{
            if (check()) {
                clearInterval(intervalHandle);
                resolve();
            } else if (hasTimeout) /* c8 ignore else */ {
                if ($g2kVL.getUnixTime() - startTime > timeout) {
                    clearInterval(intervalHandle);
                    reject(new Error('Timeout'));
                }
            }
        };
        const intervalHandle = setInterval(untilInterval, intervalResolution);
    });
const $d11e8e1685bf5de1$export$6ab8c822a2b03a03 = async (check, timeout = 0, intervalResolution = 10)=>{
    const startTime = $g2kVL.getUnixTime();
    const noTimeout = timeout <= 0;
    // eslint-disable-next-line no-unmodified-loop-condition
    while(noTimeout || $g2kVL.getUnixTime() - startTime <= timeout){
        if (await check()) return;
        await $d11e8e1685bf5de1$export$5c069c93d2b7493f(intervalResolution);
    }
    throw new Error('Timeout');
};
const $d11e8e1685bf5de1$export$5c069c93d2b7493f = (timeout)=>$d11e8e1685bf5de1$export$185802fd694ee1f5((resolve, _reject)=>setTimeout(resolve, timeout));
const $d11e8e1685bf5de1$export$4369c812aac99591 = (p)=>p instanceof Promise || p && p.then && p.catch && p.finally;

});
parcelRegister("g2kVL", function(module, exports) {

$parcel$export(module.exports, "getUnixTime", () => $bacd11a76d35613d$export$1f77c0008d16313);
/**
 * Utility module to work with time.
 *
 * @module time
 */ 
var $cB8yM = parcelRequire("cB8yM");

var $3Lr38 = parcelRequire("3Lr38");
const $bacd11a76d35613d$export$aa350b96d91cd94 = ()=>new Date();
const $bacd11a76d35613d$export$1f77c0008d16313 = Date.now;
const $bacd11a76d35613d$export$70cb903099cabea3 = (d)=>{
    if (d < 60000) {
        const p = $cB8yM.prefix(d, -1);
        return $3Lr38.round(p.n * 100) / 100 + p.prefix + 's';
    }
    d = $3Lr38.floor(d / 1000);
    const seconds = d % 60;
    const minutes = $3Lr38.floor(d / 60) % 60;
    const hours = $3Lr38.floor(d / 3600) % 24;
    const days = $3Lr38.floor(d / 86400);
    if (days > 0) return days + 'd' + (hours > 0 || minutes > 30 ? ' ' + (minutes > 30 ? hours + 1 : hours) + 'h' : '');
    if (hours > 0) /* c8 ignore next */ return hours + 'h' + (minutes > 0 || seconds > 30 ? ' ' + (seconds > 30 ? minutes + 1 : minutes) + 'min' : '');
    return minutes + 'min' + (seconds > 0 ? ' ' + seconds + 's' : '');
};

});
parcelRegister("cB8yM", function(module, exports) {

$parcel$export(module.exports, "prefix", () => $92bf9494cf3cbda8$export$82e9f45cca5ba907);
/**
 * Utility module to convert metric values.
 *
 * @module metric
 */ 
var $3Lr38 = parcelRequire("3Lr38");
const $92bf9494cf3cbda8$export$3c3f39195836e927 = 1e24;
const $92bf9494cf3cbda8$export$bc1fc8bc8e1895cf = 1e21;
const $92bf9494cf3cbda8$export$91377b751fc464a0 = 1e18;
const $92bf9494cf3cbda8$export$fc10d2598c9417a5 = 1e15;
const $92bf9494cf3cbda8$export$ce366dc9d5abf7ac = 1e12;
const $92bf9494cf3cbda8$export$197e40aa3a484017 = 1e9;
const $92bf9494cf3cbda8$export$580f1e8cf64f2815 = 1e6;
const $92bf9494cf3cbda8$export$a3ed9693cfbf67fa = 1e3;
const $92bf9494cf3cbda8$export$6ec17edd70114a88 = 1e2;
const $92bf9494cf3cbda8$export$6ffbaf3528ca9f3f = 10;
const $92bf9494cf3cbda8$export$ec5800edbd9f0b69 = 0.1;
const $92bf9494cf3cbda8$export$9faf718fe58aaa35 = 0.01;
const $92bf9494cf3cbda8$export$fab274f99578ceb6 = 1e-3;
const $92bf9494cf3cbda8$export$77bd0ce503b87b26 = 1e-6;
const $92bf9494cf3cbda8$export$ddef5c050164e23e = 1e-9;
const $92bf9494cf3cbda8$export$e10c52a2ab594201 = 1e-12;
const $92bf9494cf3cbda8$export$c49f04803481822 = 1e-15;
const $92bf9494cf3cbda8$export$5510a0bcf77f39 = 1e-18;
const $92bf9494cf3cbda8$export$2b85cc24af20b7fe = 1e-21;
const $92bf9494cf3cbda8$export$a2878e23774b59ce = 1e-24;
const $92bf9494cf3cbda8$var$prefixUp = [
    '',
    'k',
    'M',
    'G',
    'T',
    'P',
    'E',
    'Z',
    'Y'
];
const $92bf9494cf3cbda8$var$prefixDown = [
    '',
    'm',
    "\u03BC",
    'n',
    'p',
    'f',
    'a',
    'z',
    'y'
];
const $92bf9494cf3cbda8$export$82e9f45cca5ba907 = (n, baseMultiplier = 0)=>{
    const nPow = n === 0 ? 0 : $3Lr38.log10(n);
    let mult = 0;
    while(nPow < mult * 3 && baseMultiplier > -8){
        baseMultiplier--;
        mult--;
    }
    while(nPow >= 3 + mult * 3 && baseMultiplier < 8){
        baseMultiplier++;
        mult++;
    }
    const prefix = baseMultiplier < 0 ? $92bf9494cf3cbda8$var$prefixDown[-baseMultiplier] : $92bf9494cf3cbda8$var$prefixUp[baseMultiplier];
    return {
        n: $3Lr38.round((mult > 0 ? n / $3Lr38.exp10(mult * 3) : n * $3Lr38.exp10(mult * -3)) * 1e12) / 1e12,
        prefix: prefix
    };
};

});



parcelRegister("0Sial", function(module, exports) {

$parcel$export(module.exports, "createUint8ArrayFromLen", () => $002a1d76201a228b$export$79a0c4c40eecffbb);
$parcel$export(module.exports, "createUint8ArrayFromArrayBuffer", () => $002a1d76201a228b$export$1b999ddd54e5bed1);
$parcel$export(module.exports, "toBase64", () => $002a1d76201a228b$export$37cc283d8fbd3462);
$parcel$export(module.exports, "fromBase64", () => $002a1d76201a228b$export$c537b38001c583b7);
$parcel$export(module.exports, "copyUint8Array", () => $002a1d76201a228b$export$fe6f60023cd5ffaf);
/**
 * Utility functions to work with buffers (Uint8Array).
 *
 * @module buffer
 */ 
var $552MW = parcelRequire("552MW");

var $44IZO = parcelRequire("44IZO");

var $5DExo = parcelRequire("5DExo");

var $3Lr38 = parcelRequire("3Lr38");

var $xchLN = parcelRequire("xchLN");

var $dB3PR = parcelRequire("dB3PR");

var $1Fpjh = parcelRequire("1Fpjh");
var $002a1d76201a228b$require$Buffer = $1Fpjh.Buffer;
const $002a1d76201a228b$export$79a0c4c40eecffbb = (len)=>new Uint8Array(len);
const $002a1d76201a228b$export$f3c8b5f6d250ec43 = (buffer, byteOffset, length)=>new Uint8Array(buffer, byteOffset, length);
const $002a1d76201a228b$export$1b999ddd54e5bed1 = (buffer)=>new Uint8Array(buffer);
/* c8 ignore start */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ const $002a1d76201a228b$var$toBase64Browser = (bytes)=>{
    let s = '';
    for(let i = 0; i < bytes.byteLength; i++)s += $552MW.fromCharCode(bytes[i]);
    // eslint-disable-next-line no-undef
    return btoa(s);
};
/* c8 ignore stop */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ const $002a1d76201a228b$var$toBase64Node = (bytes)=>$002a1d76201a228b$require$Buffer.from(bytes.buffer, bytes.byteOffset, bytes.byteLength).toString('base64');
/* c8 ignore start */ /**
 * @param {string} s
 * @return {Uint8Array<ArrayBuffer>}
 */ const $002a1d76201a228b$var$fromBase64Browser = (s)=>{
    // eslint-disable-next-line no-undef
    const a = atob(s);
    const bytes = $002a1d76201a228b$export$79a0c4c40eecffbb(a.length);
    for(let i = 0; i < a.length; i++)bytes[i] = a.charCodeAt(i);
    return bytes;
};
/* c8 ignore stop */ /**
 * Copies the result: small Buffers are allocated from Node's shared pool, and a view on it would expose unrelated
 * memory via `.buffer`.
 *
 * @param {string} s
 * @return {Uint8Array<ArrayBuffer>}
 */ const $002a1d76201a228b$var$fromBase64Node = (s)=>new Uint8Array($002a1d76201a228b$require$Buffer.from(s, 'base64'));
const $002a1d76201a228b$export$37cc283d8fbd3462 = $44IZO.isBrowser ? $002a1d76201a228b$var$toBase64Browser : $002a1d76201a228b$var$toBase64Node;
const $002a1d76201a228b$export$c537b38001c583b7 = $44IZO.isBrowser ? $002a1d76201a228b$var$fromBase64Browser : $002a1d76201a228b$var$fromBase64Node;
const $002a1d76201a228b$export$31f478961f22a29 = (buf)=>$002a1d76201a228b$export$37cc283d8fbd3462(buf).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
const $002a1d76201a228b$export$2fcb175ca881fa06 = (base64)=>$002a1d76201a228b$export$c537b38001c583b7(base64.replaceAll('-', '+').replaceAll('_', '/'));
const $002a1d76201a228b$export$f4915efbb94d4d01 = (buf)=>$5DExo.map(buf, (b)=>b.toString(16).padStart(2, '0')).join('');
const $002a1d76201a228b$export$99a70112ceb8327b = (hex)=>{
    const hlen = hex.length;
    const buf = new Uint8Array($3Lr38.ceil(hlen / 2));
    for(let i = 0; i < hlen; i += 2)buf[buf.length - i / 2 - 1] = Number.parseInt(hex.slice(hlen - i - 2, hlen - i), 16);
    return buf;
};
const $002a1d76201a228b$export$fe6f60023cd5ffaf = (uint8Array)=>{
    const newBuf = $002a1d76201a228b$export$79a0c4c40eecffbb(uint8Array.byteLength);
    newBuf.set(uint8Array);
    return newBuf;
};
const $002a1d76201a228b$export$355ad3726be07997 = (data)=>$xchLN.encode((encoder)=>$xchLN.writeAny(encoder, data));
const $002a1d76201a228b$export$929c279cfec29a23 = (buf)=>$dB3PR.readAny($dB3PR.createDecoder(buf));
const $002a1d76201a228b$export$e87773390ebfdab4 = (bs, N)=>{
    if (N === 0) return bs;
    bs = new Uint8Array(bs);
    bs[0] <<= N;
    for(let i = 1; i < bs.length; i++){
        bs[i - 1] |= bs[i] >>> 8 - N;
        bs[i] <<= N;
    }
    return bs;
};

});
parcelRegister("44IZO", function(module, exports) {

$parcel$export(module.exports, "isNode", () => $2f7a70636bed8ad9$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isBrowser", () => $2f7a70636bed8ad9$export$4e09c449d6c407f7);
$parcel$export(module.exports, "getVariable", () => $2f7a70636bed8ad9$export$39fb32ac18db3f88);
$parcel$export(module.exports, "production", () => $2f7a70636bed8ad9$export$d71d1489bc353e92);
$parcel$export(module.exports, "supportsColor", () => $2f7a70636bed8ad9$export$fcbe44f5d6fcebd);
/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module environment
 */ 
var $iUvcZ = parcelRequire("iUvcZ");

var $552MW = parcelRequire("552MW");

var $ajU0z = parcelRequire("ajU0z");

var $2eeaT = parcelRequire("2eeaT");

var $5Ci8T = parcelRequire("5Ci8T");

var $l0O7d = parcelRequire("l0O7d");
const $2f7a70636bed8ad9$export$8ee0fc9ee280b4ee = false;
const $2f7a70636bed8ad9$export$4e09c449d6c407f7 = typeof window !== 'undefined' && typeof document !== 'undefined' && !$2f7a70636bed8ad9$export$8ee0fc9ee280b4ee;
const $2f7a70636bed8ad9$export$9ac100e40613ea10 = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
/**
 * @type {Map<string,string>}
 */ let $2f7a70636bed8ad9$var$params;
const $2f7a70636bed8ad9$var$args = [];
/* c8 ignore start */ const $2f7a70636bed8ad9$var$computeParams = ()=>{
    if ($2f7a70636bed8ad9$var$params === undefined) {
        if ($2f7a70636bed8ad9$export$8ee0fc9ee280b4ee) {
            $2f7a70636bed8ad9$var$params = $iUvcZ.create();
            const pargs = $l0O7d.argv;
            let currParamName = null;
            for(let i = 0; i < pargs.length; i++){
                const parg = pargs[i];
                if (parg[0] === '-') {
                    if (currParamName !== null) $2f7a70636bed8ad9$var$params.set(currParamName, '');
                    currParamName = parg;
                } else if (currParamName !== null) {
                    $2f7a70636bed8ad9$var$params.set(currParamName, parg);
                    currParamName = null;
                } else $2f7a70636bed8ad9$var$args.push(parg);
            }
            if (currParamName !== null) $2f7a70636bed8ad9$var$params.set(currParamName, '');
        // in ReactNative for example this would not be true (unless connected to the Remote Debugger)
        } else if (typeof location === 'object') {
            $2f7a70636bed8ad9$var$params = $iUvcZ.create(); // eslint-disable-next-line no-undef
            (location.search || '?').slice(1).split('&').forEach((kv)=>{
                if (kv.length !== 0) {
                    const [key, value] = kv.split('=');
                    $2f7a70636bed8ad9$var$params.set(`--${$552MW.fromCamelCase(key, '-')}`, value);
                    $2f7a70636bed8ad9$var$params.set(`-${$552MW.fromCamelCase(key, '-')}`, value);
                }
            });
        } else $2f7a70636bed8ad9$var$params = $iUvcZ.create();
    }
    return $2f7a70636bed8ad9$var$params;
};
const $2f7a70636bed8ad9$export$3ad523d4e4ddff75 = (name)=>$2f7a70636bed8ad9$var$computeParams().has(name);
const $2f7a70636bed8ad9$export$ecf541e09a511845 = (name, defaultVal)=>$2f7a70636bed8ad9$var$computeParams().get(name) || defaultVal;
const $2f7a70636bed8ad9$export$39fb32ac18db3f88 = (name)=>$2f7a70636bed8ad9$export$8ee0fc9ee280b4ee ? $ajU0z.undefinedToNull($l0O7d.env[name.toUpperCase().replaceAll('-', '_')]) : $ajU0z.undefinedToNull($2eeaT.varStorage.getItem(name));
const $2f7a70636bed8ad9$export$137940a4fd07b923 = (name)=>$2f7a70636bed8ad9$var$computeParams().get('--' + name) || $2f7a70636bed8ad9$export$39fb32ac18db3f88(name);
const $2f7a70636bed8ad9$export$e336c1d2b3b2390d = (name)=>{
    const c = $2f7a70636bed8ad9$export$137940a4fd07b923(name);
    if (c == null) throw new Error(`Expected configuration "${name.toUpperCase().replaceAll('-', '_')}"`);
    return c;
};
const $2f7a70636bed8ad9$export$41f29dc169f5b0eb = (name)=>$2f7a70636bed8ad9$export$3ad523d4e4ddff75('--' + name) || $2f7a70636bed8ad9$export$39fb32ac18db3f88(name) !== null;
const $2f7a70636bed8ad9$export$d71d1489bc353e92 = $2f7a70636bed8ad9$export$41f29dc169f5b0eb('production');
/* c8 ignore next 2 */ const $2f7a70636bed8ad9$var$forceColor = $2f7a70636bed8ad9$export$8ee0fc9ee280b4ee && $5Ci8T.isOneOf(undefined, [
    'true',
    '1',
    '2'
]);
const $2f7a70636bed8ad9$export$fcbe44f5d6fcebd = $2f7a70636bed8ad9$var$forceColor || !$2f7a70636bed8ad9$export$3ad523d4e4ddff75('--no-colors') && // @todo deprecate --no-colors
!$2f7a70636bed8ad9$export$41f29dc169f5b0eb('no-color') && (!$2f7a70636bed8ad9$export$8ee0fc9ee280b4ee || $l0O7d.stdout.isTTY) && (!$2f7a70636bed8ad9$export$8ee0fc9ee280b4ee || $2f7a70636bed8ad9$export$3ad523d4e4ddff75('--color') || $2f7a70636bed8ad9$export$39fb32ac18db3f88('COLORTERM') !== null || ($2f7a70636bed8ad9$export$39fb32ac18db3f88('TERM') || '').includes('color')) /* c8 ignore stop */ ;

});
parcelRegister("ajU0z", function(module, exports) {

$parcel$export(module.exports, "undefinedToNull", () => $78371fcf75253138$export$43874719a1af321f);
/**
 * Often used conditions.
 *
 * @module conditions
 */ /**
 * @template T
 * @param {T|null|undefined} v
 * @return {T|null}
 */ /* c8 ignore next */ const $78371fcf75253138$export$43874719a1af321f = (v)=>v === undefined ? null : v;

});

parcelRegister("2eeaT", function(module, exports) {

$parcel$export(module.exports, "varStorage", () => $19f7e25dc07b6f14$export$86b84a8d42aa2c65);
$parcel$export(module.exports, "onChange", () => $19f7e25dc07b6f14$export$bd913411069e59d3);
$parcel$export(module.exports, "offChange", () => $19f7e25dc07b6f14$export$ff6a13ad336aa064);
/* eslint-env browser */ /**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */ /* c8 ignore start */ class $19f7e25dc07b6f14$var$VarStoragePolyfill {
    constructor(){
        this.map = new Map();
    }
    /**
   * @param {string} key
   * @param {any} newValue
   */ setItem(key, newValue) {
        this.map.set(key, newValue);
    }
    /**
   * @param {string} key
   */ getItem(key) {
        return this.map.get(key);
    }
}
/* c8 ignore stop */ /**
 * @type {any}
 */ let $19f7e25dc07b6f14$var$_localStorage = new $19f7e25dc07b6f14$var$VarStoragePolyfill();
let $19f7e25dc07b6f14$var$usePolyfill = true;
/* c8 ignore start */ try {
    // if the same-origin rule is violated, accessing localStorage might thrown an error
    if (typeof localStorage !== 'undefined' && localStorage) {
        $19f7e25dc07b6f14$var$_localStorage = localStorage;
        $19f7e25dc07b6f14$var$usePolyfill = false;
    }
} catch (e) {}
const $19f7e25dc07b6f14$export$86b84a8d42aa2c65 = $19f7e25dc07b6f14$var$_localStorage;
const $19f7e25dc07b6f14$export$bd913411069e59d3 = (eventHandler)=>$19f7e25dc07b6f14$var$usePolyfill || addEventListener('storage', /** @type {any} */ eventHandler);
const $19f7e25dc07b6f14$export$ff6a13ad336aa064 = (eventHandler)=>$19f7e25dc07b6f14$var$usePolyfill || removeEventListener('storage', /** @type {any} */ eventHandler);

});

parcelRegister("5Ci8T", function(module, exports) {

$parcel$export(module.exports, "callAll", () => $416e9312606291f7$export$9dd9a52f2dd5b9ce);
$parcel$export(module.exports, "nop", () => $416e9312606291f7$export$b5f1cfe7b08e6ed5);
$parcel$export(module.exports, "id", () => $416e9312606291f7$export$d560c7e4a29451c2);
$parcel$export(module.exports, "equalityDeep", () => $416e9312606291f7$export$2ca9a723affd5d11);
$parcel$export(module.exports, "isOneOf", () => $416e9312606291f7$export$532a90c0e5e8e48c);
/**
 * Common functions and function call helpers.
 *
 * @module function
 */ 
var $5DExo = parcelRequire("5DExo");

var $kqHhc = parcelRequire("kqHhc");

var $bh6Eu = parcelRequire("bh6Eu");
const $416e9312606291f7$export$9dd9a52f2dd5b9ce = (fs, args, i = 0)=>{
    try {
        for(; i < fs.length; i++)fs[i](...args);
    } finally{
        if (i < fs.length) $416e9312606291f7$export$9dd9a52f2dd5b9ce(fs, args, i + 1);
    }
};
const $416e9312606291f7$export$b5f1cfe7b08e6ed5 = ()=>{};
const $416e9312606291f7$export$5635d7ef4b8fee1c = (f)=>f();
const $416e9312606291f7$export$d560c7e4a29451c2 = (a)=>a;
const $416e9312606291f7$export$bbb1dcf8c6c6bac1 = (a, b)=>a === b;
const $416e9312606291f7$export$6ca82605a98f2278 = (a, b)=>a === b || a != null && b != null && a.constructor === b.constructor && ($5DExo.isArray(a) && $5DExo.equalFlat(a, /** @type {Array<T>} */ b) || typeof a === 'object' && $kqHhc.equalFlat(a, b));
const $416e9312606291f7$export$2ca9a723affd5d11 = (a, b)=>{
    if (a === b) return true;
    if (a == null || b == null || a.constructor !== b.constructor && (a.constructor || Object) !== (b.constructor || Object)) return false;
    if (a[$bh6Eu.EqualityTraitSymbol] != null) return a[$bh6Eu.EqualityTraitSymbol](b);
    switch(a.constructor){
        case ArrayBuffer:
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // eslint-disable-next-line no-fallthrough
        case Uint8Array:
            if (a.byteLength !== b.byteLength) return false;
            for(let i = 0; i < a.length; i++){
                if (a[i] !== b[i]) return false;
            }
            break;
        case Set:
            if (a.size !== b.size) return false;
            for (const value of a){
                if (!b.has(value)) return false;
            }
            break;
        case Map:
            if (a.size !== b.size) return false;
            for (const key of a.keys()){
                if (!b.has(key) || !$416e9312606291f7$export$2ca9a723affd5d11(a.get(key), b.get(key))) return false;
            }
            break;
        case undefined:
        case Object:
            if ($kqHhc.size(a) !== $kqHhc.size(b)) return false;
            for(const key in a){
                if (!$kqHhc.hasProperty(a, key) || !$416e9312606291f7$export$2ca9a723affd5d11(a[key], b[key])) return false;
            }
            break;
        case Array:
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!$416e9312606291f7$export$2ca9a723affd5d11(a[i], b[i])) return false;
            }
            break;
        default:
            return false;
    }
    return true;
};
const $416e9312606291f7$export$532a90c0e5e8e48c = (value, options)=>options.includes(value);
const $416e9312606291f7$export$43bee75e5e14138e = $5DExo.isArray;
const $416e9312606291f7$export$844ec244b1367d54 = (s)=>s && s.constructor === String;
const $416e9312606291f7$export$7e4aa119212bc614 = (n)=>n != null && n.constructor === Number;
const $416e9312606291f7$export$226b3eccf92c9ed9 = (n, T)=>n && n.constructor === T;
const $416e9312606291f7$export$6306e0d85c68df69 = (T)=>/**
   * @param {any} n
   * @return {n is InstanceType<TYPE>}
   **/ (n)=>n && n.constructor === T;

});
parcelRegister("kqHhc", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $edf7ce2509c9cf8f$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "assign", () => $edf7ce2509c9cf8f$export$e6e34fd1f2686227);
$parcel$export(module.exports, "forEach", () => $edf7ce2509c9cf8f$export$4b80e395e36b5a56);
$parcel$export(module.exports, "map", () => $edf7ce2509c9cf8f$export$871de8747c9eaa88);
$parcel$export(module.exports, "size", () => $edf7ce2509c9cf8f$export$346677f925de839c);
$parcel$export(module.exports, "isEmpty", () => $edf7ce2509c9cf8f$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "every", () => $edf7ce2509c9cf8f$export$7ecc1a3b11b57dab);
$parcel$export(module.exports, "hasProperty", () => $edf7ce2509c9cf8f$export$bf9617eaf5d2451);
$parcel$export(module.exports, "equalFlat", () => $edf7ce2509c9cf8f$export$4f1c34abb2bb4c8);
$parcel$export(module.exports, "deepFreeze", () => $edf7ce2509c9cf8f$export$7e32b29e1cb162e1);

var $bh6Eu = parcelRequire("bh6Eu");
const $edf7ce2509c9cf8f$export$185802fd694ee1f5 = ()=>Object.create(null);
const $edf7ce2509c9cf8f$export$a6cdc56e425d0d0a = (o)=>typeof o === 'object';
const $edf7ce2509c9cf8f$export$e6e34fd1f2686227 = Object.assign;
const $edf7ce2509c9cf8f$export$ed97f33186d4b816 = Object.keys;
const $edf7ce2509c9cf8f$export$68c286be0e7e55b7 = Object.values;
const $edf7ce2509c9cf8f$export$4b80e395e36b5a56 = (obj, f)=>{
    for(const key in obj)f(obj[key], key);
};
const $edf7ce2509c9cf8f$export$871de8747c9eaa88 = (obj, f)=>{
    const results = [];
    for(const key in obj)results.push(f(obj[key], key));
    return results;
};
const $edf7ce2509c9cf8f$export$f24224f1c91d8156 = (obj)=>$edf7ce2509c9cf8f$export$ed97f33186d4b816(obj).length;
const $edf7ce2509c9cf8f$export$346677f925de839c = (obj)=>$edf7ce2509c9cf8f$export$ed97f33186d4b816(obj).length;
const $edf7ce2509c9cf8f$export$ad14ef4001db2bcd = (obj, f)=>{
    for(const key in obj){
        if (f(obj[key], key)) return true;
    }
    return false;
};
const $edf7ce2509c9cf8f$export$dd1bc94b04021eeb = (obj)=>{
    // eslint-disable-next-line no-unreachable-loop
    for(const _k in obj)return false;
    return true;
};
const $edf7ce2509c9cf8f$export$7ecc1a3b11b57dab = (obj, f)=>{
    for(const key in obj){
        if (!f(obj[key], key)) return false;
    }
    return true;
};
const $edf7ce2509c9cf8f$export$bf9617eaf5d2451 = (obj, key)=>Object.prototype.hasOwnProperty.call(obj, key);
const $edf7ce2509c9cf8f$export$4f1c34abb2bb4c8 = (a, b)=>a === b || $edf7ce2509c9cf8f$export$346677f925de839c(a) === $edf7ce2509c9cf8f$export$346677f925de839c(b) && $edf7ce2509c9cf8f$export$7ecc1a3b11b57dab(a, (val, key)=>(val !== undefined || $edf7ce2509c9cf8f$export$bf9617eaf5d2451(b, key)) && $bh6Eu.equals(b[key], val));
const $edf7ce2509c9cf8f$export$792f3d81ea979f55 = Object.freeze;
const $edf7ce2509c9cf8f$export$7e32b29e1cb162e1 = (o)=>{
    for(const key in o){
        const c = o[key];
        if (typeof c === 'object' || typeof c === 'function') $edf7ce2509c9cf8f$export$7e32b29e1cb162e1(o[key]);
    }
    return $edf7ce2509c9cf8f$export$792f3d81ea979f55(o);
};
const $edf7ce2509c9cf8f$export$dccd489362a8619 = (o, key, createT)=>$edf7ce2509c9cf8f$export$bf9617eaf5d2451(o, key) ? o[key] : o[key] = createT();

});
parcelRegister("bh6Eu", function(module, exports) {

$parcel$export(module.exports, "EqualityTraitSymbol", () => $83567133ce1c22cd$export$dfb9393df7ffcf17);
$parcel$export(module.exports, "equals", () => $83567133ce1c22cd$export$e9bab7fafb253603);
const $83567133ce1c22cd$export$dfb9393df7ffcf17 = Symbol('Equality');
const $83567133ce1c22cd$export$e9bab7fafb253603 = (a, b)=>a === b || !!a?.[$83567133ce1c22cd$export$dfb9393df7ffcf17]?.(b) || false;

});



parcelRegister("l0O7d", function(module, exports) {
// shim for using process in browser
var $f4c078f3922484fe$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $f4c078f3922484fe$var$cachedSetTimeout;
var $f4c078f3922484fe$var$cachedClearTimeout;
function $f4c078f3922484fe$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $f4c078f3922484fe$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $f4c078f3922484fe$var$cachedSetTimeout = setTimeout;
        else $f4c078f3922484fe$var$cachedSetTimeout = $f4c078f3922484fe$var$defaultSetTimout;
    } catch (e) {
        $f4c078f3922484fe$var$cachedSetTimeout = $f4c078f3922484fe$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $f4c078f3922484fe$var$cachedClearTimeout = clearTimeout;
        else $f4c078f3922484fe$var$cachedClearTimeout = $f4c078f3922484fe$var$defaultClearTimeout;
    } catch (e) {
        $f4c078f3922484fe$var$cachedClearTimeout = $f4c078f3922484fe$var$defaultClearTimeout;
    }
})();
function $f4c078f3922484fe$var$runTimeout(fun) {
    if ($f4c078f3922484fe$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($f4c078f3922484fe$var$cachedSetTimeout === $f4c078f3922484fe$var$defaultSetTimout || !$f4c078f3922484fe$var$cachedSetTimeout) && setTimeout) {
        $f4c078f3922484fe$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $f4c078f3922484fe$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $f4c078f3922484fe$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $f4c078f3922484fe$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $f4c078f3922484fe$var$runClearTimeout(marker) {
    if ($f4c078f3922484fe$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($f4c078f3922484fe$var$cachedClearTimeout === $f4c078f3922484fe$var$defaultClearTimeout || !$f4c078f3922484fe$var$cachedClearTimeout) && clearTimeout) {
        $f4c078f3922484fe$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $f4c078f3922484fe$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $f4c078f3922484fe$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $f4c078f3922484fe$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $f4c078f3922484fe$var$queue = [];
var $f4c078f3922484fe$var$draining = false;
var $f4c078f3922484fe$var$currentQueue;
var $f4c078f3922484fe$var$queueIndex = -1;
function $f4c078f3922484fe$var$cleanUpNextTick() {
    if (!$f4c078f3922484fe$var$draining || !$f4c078f3922484fe$var$currentQueue) return;
    $f4c078f3922484fe$var$draining = false;
    if ($f4c078f3922484fe$var$currentQueue.length) $f4c078f3922484fe$var$queue = $f4c078f3922484fe$var$currentQueue.concat($f4c078f3922484fe$var$queue);
    else $f4c078f3922484fe$var$queueIndex = -1;
    if ($f4c078f3922484fe$var$queue.length) $f4c078f3922484fe$var$drainQueue();
}
function $f4c078f3922484fe$var$drainQueue() {
    if ($f4c078f3922484fe$var$draining) return;
    var timeout = $f4c078f3922484fe$var$runTimeout($f4c078f3922484fe$var$cleanUpNextTick);
    $f4c078f3922484fe$var$draining = true;
    var len = $f4c078f3922484fe$var$queue.length;
    while(len){
        $f4c078f3922484fe$var$currentQueue = $f4c078f3922484fe$var$queue;
        $f4c078f3922484fe$var$queue = [];
        while(++$f4c078f3922484fe$var$queueIndex < len)if ($f4c078f3922484fe$var$currentQueue) $f4c078f3922484fe$var$currentQueue[$f4c078f3922484fe$var$queueIndex].run();
        $f4c078f3922484fe$var$queueIndex = -1;
        len = $f4c078f3922484fe$var$queue.length;
    }
    $f4c078f3922484fe$var$currentQueue = null;
    $f4c078f3922484fe$var$draining = false;
    $f4c078f3922484fe$var$runClearTimeout(timeout);
}
$f4c078f3922484fe$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $f4c078f3922484fe$var$queue.push(new $f4c078f3922484fe$var$Item(fun, args));
    if ($f4c078f3922484fe$var$queue.length === 1 && !$f4c078f3922484fe$var$draining) $f4c078f3922484fe$var$runTimeout($f4c078f3922484fe$var$drainQueue);
};
// v8 likes predictible objects
function $f4c078f3922484fe$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$f4c078f3922484fe$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$f4c078f3922484fe$var$process.title = 'browser';
$f4c078f3922484fe$var$process.browser = true;
$f4c078f3922484fe$var$process.env = {};
$f4c078f3922484fe$var$process.argv = [];
$f4c078f3922484fe$var$process.version = ''; // empty string to avoid regexp issues
$f4c078f3922484fe$var$process.versions = {};
function $f4c078f3922484fe$var$noop() {}
$f4c078f3922484fe$var$process.on = $f4c078f3922484fe$var$noop;
$f4c078f3922484fe$var$process.addListener = $f4c078f3922484fe$var$noop;
$f4c078f3922484fe$var$process.once = $f4c078f3922484fe$var$noop;
$f4c078f3922484fe$var$process.off = $f4c078f3922484fe$var$noop;
$f4c078f3922484fe$var$process.removeListener = $f4c078f3922484fe$var$noop;
$f4c078f3922484fe$var$process.removeAllListeners = $f4c078f3922484fe$var$noop;
$f4c078f3922484fe$var$process.emit = $f4c078f3922484fe$var$noop;
$f4c078f3922484fe$var$process.prependListener = $f4c078f3922484fe$var$noop;
$f4c078f3922484fe$var$process.prependOnceListener = $f4c078f3922484fe$var$noop;
$f4c078f3922484fe$var$process.listeners = function(name) {
    return [];
};
$f4c078f3922484fe$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$f4c078f3922484fe$var$process.cwd = function() {
    return '/';
};
$f4c078f3922484fe$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$f4c078f3922484fe$var$process.umask = function() {
    return 0;
};

});


parcelRegister("1Fpjh", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $136d40cdb268fe10$export$a143d493d941bafc, (v) => $136d40cdb268fe10$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $136d40cdb268fe10$export$f99ded8fe4b79145, (v) => $136d40cdb268fe10$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $136d40cdb268fe10$export$a143d493d941bafc;
var $136d40cdb268fe10$export$e4cf37d7f6fb9e0a;
var $136d40cdb268fe10$export$f99ded8fe4b79145;
var $136d40cdb268fe10$export$599f31c3813fae4d;
'use strict';

var $jjjpe = parcelRequire("jjjpe");

var $bV5Xi = parcelRequire("bV5Xi");
const $136d40cdb268fe10$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$136d40cdb268fe10$export$a143d493d941bafc = $136d40cdb268fe10$var$Buffer;
$136d40cdb268fe10$export$e4cf37d7f6fb9e0a = $136d40cdb268fe10$var$SlowBuffer;
$136d40cdb268fe10$export$f99ded8fe4b79145 = 50;
const $136d40cdb268fe10$var$K_MAX_LENGTH = 0x7fffffff;
$136d40cdb268fe10$export$599f31c3813fae4d = $136d40cdb268fe10$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $136d40cdb268fe10$var$Buffer.TYPED_ARRAY_SUPPORT = $136d40cdb268fe10$var$typedArraySupport();
if (!$136d40cdb268fe10$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $136d40cdb268fe10$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($136d40cdb268fe10$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$136d40cdb268fe10$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($136d40cdb268fe10$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$136d40cdb268fe10$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $136d40cdb268fe10$var$createBuffer(length) {
    if (length > $136d40cdb268fe10$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $136d40cdb268fe10$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $136d40cdb268fe10$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $136d40cdb268fe10$var$allocUnsafe(arg);
    }
    return $136d40cdb268fe10$var$from(arg, encodingOrOffset, length);
}
$136d40cdb268fe10$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $136d40cdb268fe10$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $136d40cdb268fe10$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $136d40cdb268fe10$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($136d40cdb268fe10$var$isInstance(value, ArrayBuffer) || value && $136d40cdb268fe10$var$isInstance(value.buffer, ArrayBuffer)) return $136d40cdb268fe10$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($136d40cdb268fe10$var$isInstance(value, SharedArrayBuffer) || value && $136d40cdb268fe10$var$isInstance(value.buffer, SharedArrayBuffer))) return $136d40cdb268fe10$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $136d40cdb268fe10$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $136d40cdb268fe10$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $136d40cdb268fe10$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $136d40cdb268fe10$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $136d40cdb268fe10$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($136d40cdb268fe10$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($136d40cdb268fe10$var$Buffer, Uint8Array);
function $136d40cdb268fe10$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $136d40cdb268fe10$var$alloc(size, fill, encoding) {
    $136d40cdb268fe10$var$assertSize(size);
    if (size <= 0) return $136d40cdb268fe10$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $136d40cdb268fe10$var$createBuffer(size).fill(fill, encoding) : $136d40cdb268fe10$var$createBuffer(size).fill(fill);
    return $136d40cdb268fe10$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $136d40cdb268fe10$var$Buffer.alloc = function(size, fill, encoding) {
    return $136d40cdb268fe10$var$alloc(size, fill, encoding);
};
function $136d40cdb268fe10$var$allocUnsafe(size) {
    $136d40cdb268fe10$var$assertSize(size);
    return $136d40cdb268fe10$var$createBuffer(size < 0 ? 0 : $136d40cdb268fe10$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $136d40cdb268fe10$var$Buffer.allocUnsafe = function(size) {
    return $136d40cdb268fe10$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $136d40cdb268fe10$var$Buffer.allocUnsafeSlow = function(size) {
    return $136d40cdb268fe10$var$allocUnsafe(size);
};
function $136d40cdb268fe10$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$136d40cdb268fe10$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $136d40cdb268fe10$var$byteLength(string, encoding) | 0;
    let buf = $136d40cdb268fe10$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $136d40cdb268fe10$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $136d40cdb268fe10$var$checked(array.length) | 0;
    const buf = $136d40cdb268fe10$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $136d40cdb268fe10$var$fromArrayView(arrayView) {
    if ($136d40cdb268fe10$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $136d40cdb268fe10$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $136d40cdb268fe10$var$fromArrayLike(arrayView);
}
function $136d40cdb268fe10$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $136d40cdb268fe10$var$Buffer.prototype);
    return buf;
}
function $136d40cdb268fe10$var$fromObject(obj) {
    if ($136d40cdb268fe10$var$Buffer.isBuffer(obj)) {
        const len = $136d40cdb268fe10$var$checked(obj.length) | 0;
        const buf = $136d40cdb268fe10$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $136d40cdb268fe10$var$numberIsNaN(obj.length)) return $136d40cdb268fe10$var$createBuffer(0);
        return $136d40cdb268fe10$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $136d40cdb268fe10$var$fromArrayLike(obj.data);
}
function $136d40cdb268fe10$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $136d40cdb268fe10$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $136d40cdb268fe10$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $136d40cdb268fe10$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $136d40cdb268fe10$var$Buffer.alloc(+length);
}
$136d40cdb268fe10$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $136d40cdb268fe10$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$136d40cdb268fe10$var$Buffer.compare = function compare(a, b) {
    if ($136d40cdb268fe10$var$isInstance(a, Uint8Array)) a = $136d40cdb268fe10$var$Buffer.from(a, a.offset, a.byteLength);
    if ($136d40cdb268fe10$var$isInstance(b, Uint8Array)) b = $136d40cdb268fe10$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(a) || !$136d40cdb268fe10$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$136d40cdb268fe10$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$136d40cdb268fe10$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $136d40cdb268fe10$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $136d40cdb268fe10$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($136d40cdb268fe10$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$136d40cdb268fe10$var$Buffer.isBuffer(buf)) buf = $136d40cdb268fe10$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$136d40cdb268fe10$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $136d40cdb268fe10$var$byteLength(string, encoding) {
    if ($136d40cdb268fe10$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $136d40cdb268fe10$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $136d40cdb268fe10$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $136d40cdb268fe10$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $136d40cdb268fe10$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$136d40cdb268fe10$var$Buffer.byteLength = $136d40cdb268fe10$var$byteLength;
function $136d40cdb268fe10$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $136d40cdb268fe10$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $136d40cdb268fe10$var$utf8Slice(this, start, end);
        case 'ascii':
            return $136d40cdb268fe10$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $136d40cdb268fe10$var$latin1Slice(this, start, end);
        case 'base64':
            return $136d40cdb268fe10$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $136d40cdb268fe10$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$136d40cdb268fe10$var$Buffer.prototype._isBuffer = true;
function $136d40cdb268fe10$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$136d40cdb268fe10$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$136d40cdb268fe10$var$swap(this, i, i + 1);
    return this;
};
$136d40cdb268fe10$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $136d40cdb268fe10$var$swap(this, i, i + 3);
        $136d40cdb268fe10$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$136d40cdb268fe10$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $136d40cdb268fe10$var$swap(this, i, i + 7);
        $136d40cdb268fe10$var$swap(this, i + 1, i + 6);
        $136d40cdb268fe10$var$swap(this, i + 2, i + 5);
        $136d40cdb268fe10$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$136d40cdb268fe10$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $136d40cdb268fe10$var$utf8Slice(this, 0, length);
    return $136d40cdb268fe10$var$slowToString.apply(this, arguments);
};
$136d40cdb268fe10$var$Buffer.prototype.toLocaleString = $136d40cdb268fe10$var$Buffer.prototype.toString;
$136d40cdb268fe10$var$Buffer.prototype.equals = function equals(b) {
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $136d40cdb268fe10$var$Buffer.compare(this, b) === 0;
};
$136d40cdb268fe10$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $136d40cdb268fe10$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($136d40cdb268fe10$var$customInspectSymbol) $136d40cdb268fe10$var$Buffer.prototype[$136d40cdb268fe10$var$customInspectSymbol] = $136d40cdb268fe10$var$Buffer.prototype.inspect;
$136d40cdb268fe10$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($136d40cdb268fe10$var$isInstance(target, Uint8Array)) target = $136d40cdb268fe10$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $136d40cdb268fe10$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($136d40cdb268fe10$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $136d40cdb268fe10$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($136d40cdb268fe10$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $136d40cdb268fe10$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $136d40cdb268fe10$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $136d40cdb268fe10$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$136d40cdb268fe10$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$136d40cdb268fe10$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $136d40cdb268fe10$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$136d40cdb268fe10$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $136d40cdb268fe10$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $136d40cdb268fe10$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($136d40cdb268fe10$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $136d40cdb268fe10$var$utf8Write(buf, string, offset, length) {
    return $136d40cdb268fe10$var$blitBuffer($136d40cdb268fe10$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $136d40cdb268fe10$var$asciiWrite(buf, string, offset, length) {
    return $136d40cdb268fe10$var$blitBuffer($136d40cdb268fe10$var$asciiToBytes(string), buf, offset, length);
}
function $136d40cdb268fe10$var$base64Write(buf, string, offset, length) {
    return $136d40cdb268fe10$var$blitBuffer($136d40cdb268fe10$var$base64ToBytes(string), buf, offset, length);
}
function $136d40cdb268fe10$var$ucs2Write(buf, string, offset, length) {
    return $136d40cdb268fe10$var$blitBuffer($136d40cdb268fe10$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$136d40cdb268fe10$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $136d40cdb268fe10$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $136d40cdb268fe10$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $136d40cdb268fe10$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $136d40cdb268fe10$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $136d40cdb268fe10$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$136d40cdb268fe10$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $136d40cdb268fe10$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $jjjpe.fromByteArray(buf);
    else return $jjjpe.fromByteArray(buf.slice(start, end));
}
function $136d40cdb268fe10$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $136d40cdb268fe10$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $136d40cdb268fe10$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $136d40cdb268fe10$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $136d40cdb268fe10$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $136d40cdb268fe10$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $136d40cdb268fe10$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $136d40cdb268fe10$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $136d40cdb268fe10$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $136d40cdb268fe10$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $136d40cdb268fe10$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$136d40cdb268fe10$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $136d40cdb268fe10$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $136d40cdb268fe10$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$136d40cdb268fe10$var$Buffer.prototype.readUintLE = $136d40cdb268fe10$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$136d40cdb268fe10$var$Buffer.prototype.readUintBE = $136d40cdb268fe10$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$136d40cdb268fe10$var$Buffer.prototype.readUint8 = $136d40cdb268fe10$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$136d40cdb268fe10$var$Buffer.prototype.readUint16LE = $136d40cdb268fe10$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$136d40cdb268fe10$var$Buffer.prototype.readUint16BE = $136d40cdb268fe10$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$136d40cdb268fe10$var$Buffer.prototype.readUint32LE = $136d40cdb268fe10$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$136d40cdb268fe10$var$Buffer.prototype.readUint32BE = $136d40cdb268fe10$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$136d40cdb268fe10$var$Buffer.prototype.readBigUInt64LE = $136d40cdb268fe10$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $136d40cdb268fe10$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$136d40cdb268fe10$var$Buffer.prototype.readBigUInt64BE = $136d40cdb268fe10$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $136d40cdb268fe10$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$136d40cdb268fe10$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$136d40cdb268fe10$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$136d40cdb268fe10$var$Buffer.prototype.readBigInt64LE = $136d40cdb268fe10$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $136d40cdb268fe10$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$136d40cdb268fe10$var$Buffer.prototype.readBigInt64BE = $136d40cdb268fe10$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $136d40cdb268fe10$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$136d40cdb268fe10$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return $bV5Xi.read(this, offset, true, 23, 4);
};
$136d40cdb268fe10$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return $bV5Xi.read(this, offset, false, 23, 4);
};
$136d40cdb268fe10$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 8, this.length);
    return $bV5Xi.read(this, offset, true, 52, 8);
};
$136d40cdb268fe10$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 8, this.length);
    return $bV5Xi.read(this, offset, false, 52, 8);
};
function $136d40cdb268fe10$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$136d40cdb268fe10$var$Buffer.prototype.writeUintLE = $136d40cdb268fe10$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $136d40cdb268fe10$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUintBE = $136d40cdb268fe10$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $136d40cdb268fe10$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint8 = $136d40cdb268fe10$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint16LE = $136d40cdb268fe10$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint16BE = $136d40cdb268fe10$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint32LE = $136d40cdb268fe10$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint32BE = $136d40cdb268fe10$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $136d40cdb268fe10$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $136d40cdb268fe10$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $136d40cdb268fe10$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $136d40cdb268fe10$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$136d40cdb268fe10$var$Buffer.prototype.writeBigUInt64LE = $136d40cdb268fe10$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $136d40cdb268fe10$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$136d40cdb268fe10$var$Buffer.prototype.writeBigUInt64BE = $136d40cdb268fe10$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $136d40cdb268fe10$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$136d40cdb268fe10$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $136d40cdb268fe10$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$136d40cdb268fe10$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $136d40cdb268fe10$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$136d40cdb268fe10$var$Buffer.prototype.writeBigInt64LE = $136d40cdb268fe10$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $136d40cdb268fe10$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$136d40cdb268fe10$var$Buffer.prototype.writeBigInt64BE = $136d40cdb268fe10$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $136d40cdb268fe10$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $136d40cdb268fe10$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $136d40cdb268fe10$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $bV5Xi.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$136d40cdb268fe10$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $136d40cdb268fe10$var$writeFloat(this, value, offset, true, noAssert);
};
$136d40cdb268fe10$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $136d40cdb268fe10$var$writeFloat(this, value, offset, false, noAssert);
};
function $136d40cdb268fe10$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $bV5Xi.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$136d40cdb268fe10$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $136d40cdb268fe10$var$writeDouble(this, value, offset, true, noAssert);
};
$136d40cdb268fe10$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $136d40cdb268fe10$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$136d40cdb268fe10$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$136d40cdb268fe10$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$136d40cdb268fe10$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $136d40cdb268fe10$var$Buffer.isBuffer(val) ? val : $136d40cdb268fe10$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $136d40cdb268fe10$var$errors = {};
function $136d40cdb268fe10$var$E(sym, getMessage, Base) {
    $136d40cdb268fe10$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$136d40cdb268fe10$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$136d40cdb268fe10$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$136d40cdb268fe10$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $136d40cdb268fe10$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $136d40cdb268fe10$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $136d40cdb268fe10$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $136d40cdb268fe10$var$checkBounds(buf, offset, byteLength) {
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $136d40cdb268fe10$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $136d40cdb268fe10$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $136d40cdb268fe10$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $136d40cdb268fe10$var$checkBounds(buf, offset, byteLength);
}
function $136d40cdb268fe10$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $136d40cdb268fe10$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $136d40cdb268fe10$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $136d40cdb268fe10$var$validateNumber(value, type);
        throw new $136d40cdb268fe10$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $136d40cdb268fe10$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $136d40cdb268fe10$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $136d40cdb268fe10$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $136d40cdb268fe10$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($136d40cdb268fe10$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $136d40cdb268fe10$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $136d40cdb268fe10$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $136d40cdb268fe10$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $136d40cdb268fe10$var$base64ToBytes(str) {
    return $jjjpe.toByteArray($136d40cdb268fe10$var$base64clean(str));
}
function $136d40cdb268fe10$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $136d40cdb268fe10$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $136d40cdb268fe10$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $136d40cdb268fe10$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $136d40cdb268fe10$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $136d40cdb268fe10$var$BufferBigIntNotDefined : fn;
}
function $136d40cdb268fe10$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("jjjpe", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $e0eed84d5498f6e4$export$d622b2ad8d90c771, (v) => $e0eed84d5498f6e4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $e0eed84d5498f6e4$export$6100ba28696e12de, (v) => $e0eed84d5498f6e4$export$6100ba28696e12de = v);
var $e0eed84d5498f6e4$export$a48f0734ac7c2329;
var $e0eed84d5498f6e4$export$d622b2ad8d90c771;
var $e0eed84d5498f6e4$export$6100ba28696e12de;
'use strict';
$e0eed84d5498f6e4$export$a48f0734ac7c2329 = $e0eed84d5498f6e4$var$byteLength;
$e0eed84d5498f6e4$export$d622b2ad8d90c771 = $e0eed84d5498f6e4$var$toByteArray;
$e0eed84d5498f6e4$export$6100ba28696e12de = $e0eed84d5498f6e4$var$fromByteArray;
var $e0eed84d5498f6e4$var$lookup = [];
var $e0eed84d5498f6e4$var$revLookup = [];
var $e0eed84d5498f6e4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e0eed84d5498f6e4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e0eed84d5498f6e4$var$i = 0, $e0eed84d5498f6e4$var$len = $e0eed84d5498f6e4$var$code.length; $e0eed84d5498f6e4$var$i < $e0eed84d5498f6e4$var$len; ++$e0eed84d5498f6e4$var$i){
    $e0eed84d5498f6e4$var$lookup[$e0eed84d5498f6e4$var$i] = $e0eed84d5498f6e4$var$code[$e0eed84d5498f6e4$var$i];
    $e0eed84d5498f6e4$var$revLookup[$e0eed84d5498f6e4$var$code.charCodeAt($e0eed84d5498f6e4$var$i)] = $e0eed84d5498f6e4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e0eed84d5498f6e4$var$revLookup['-'.charCodeAt(0)] = 62;
$e0eed84d5498f6e4$var$revLookup['_'.charCodeAt(0)] = 63;
function $e0eed84d5498f6e4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e0eed84d5498f6e4$var$byteLength(b64) {
    var lens = $e0eed84d5498f6e4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e0eed84d5498f6e4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e0eed84d5498f6e4$var$toByteArray(b64) {
    var tmp;
    var lens = $e0eed84d5498f6e4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e0eed84d5498f6e4$var$Arr($e0eed84d5498f6e4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i)] << 18 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i)] << 2 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i)] << 10 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e0eed84d5498f6e4$var$tripletToBase64(num) {
    return $e0eed84d5498f6e4$var$lookup[num >> 18 & 0x3F] + $e0eed84d5498f6e4$var$lookup[num >> 12 & 0x3F] + $e0eed84d5498f6e4$var$lookup[num >> 6 & 0x3F] + $e0eed84d5498f6e4$var$lookup[num & 0x3F];
}
function $e0eed84d5498f6e4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e0eed84d5498f6e4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e0eed84d5498f6e4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e0eed84d5498f6e4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e0eed84d5498f6e4$var$lookup[tmp >> 2] + $e0eed84d5498f6e4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e0eed84d5498f6e4$var$lookup[tmp >> 10] + $e0eed84d5498f6e4$var$lookup[tmp >> 4 & 0x3F] + $e0eed84d5498f6e4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("bV5Xi", function(module, exports) {

$parcel$export(module.exports, "read", () => $8ad9a3380a876530$export$aafa59e2e03f2942, (v) => $8ad9a3380a876530$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $8ad9a3380a876530$export$68d8715fc104d294, (v) => $8ad9a3380a876530$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $8ad9a3380a876530$export$aafa59e2e03f2942;
var $8ad9a3380a876530$export$68d8715fc104d294;
$8ad9a3380a876530$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$8ad9a3380a876530$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("70wUZ", function(module, exports) {

$parcel$export(module.exports, "print", () => $51a21156f8206a3a$export$c2d084dc44961371);
$parcel$export(module.exports, "warn", () => $51a21156f8206a3a$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "BOLD", () => (parcelRequire("bamwN")).BOLD);
$parcel$export(module.exports, "UNBOLD", () => (parcelRequire("bamwN")).UNBOLD);
$parcel$export(module.exports, "RED", () => (parcelRequire("bamwN")).RED);
$parcel$export(module.exports, "ORANGE", () => (parcelRequire("bamwN")).ORANGE);
/**
 * Isomorphic logging module with support for colors!
 *
 * @module logging
 */ 
var $44IZO = parcelRequire("44IZO");

var $ivn6P = parcelRequire("ivn6P");

var $ZUGGI = parcelRequire("ZUGGI");

var $4AiqZ = parcelRequire("4AiqZ");

var $c9Seu = parcelRequire("c9Seu");

var $iUvcZ = parcelRequire("iUvcZ");

var $he2rK = parcelRequire("he2rK");

var $3Lr38 = parcelRequire("3Lr38");

var $bamwN = parcelRequire("bamwN");
/**
 * @type {Object<Symbol,pair.Pair<string,string>>}
 */ const $51a21156f8206a3a$var$_browserStyleMap = {
    [$bamwN.BOLD]: $ZUGGI.create('font-weight', 'bold'),
    [$bamwN.UNBOLD]: $ZUGGI.create('font-weight', 'normal'),
    [$bamwN.BLUE]: $ZUGGI.create('color', 'blue'),
    [$bamwN.GREEN]: $ZUGGI.create('color', 'green'),
    [$bamwN.GREY]: $ZUGGI.create('color', 'grey'),
    [$bamwN.RED]: $ZUGGI.create('color', 'red'),
    [$bamwN.PURPLE]: $ZUGGI.create('color', 'purple'),
    [$bamwN.ORANGE]: $ZUGGI.create('color', 'orange'),
    [$bamwN.UNCOLOR]: $ZUGGI.create('color', 'black')
};
/**
 * @param {Array<string|Symbol|Object|number|function():any>} args
 * @return {Array<string|object|number>}
 */ /* c8 ignore start */ const $51a21156f8206a3a$var$computeBrowserLoggingArgs = (args)=>{
    if (args.length === 1 && args[0]?.constructor === Function) args = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args[0]();
    const strBuilder = [];
    const styles = [];
    const currentStyle = $iUvcZ.create();
    /**
   * @type {Array<string|Object|number>}
   */ let logArgs = [];
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        // @ts-ignore
        const style = $51a21156f8206a3a$var$_browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg === undefined) break;
            if (arg.constructor === String || arg.constructor === Number) {
                const style = $4AiqZ.mapToStyleString(currentStyle);
                if (i > 0 || style.length > 0) {
                    strBuilder.push('%c' + arg);
                    styles.push(style);
                } else strBuilder.push(arg);
            } else break;
        }
    }
    if (i > 0) {
        // create logArgs with what we have so far
        logArgs = styles;
        logArgs.unshift(strBuilder.join(''));
    }
    // append the rest
    for(; i < args.length; i++){
        const arg = args[i];
        if (!(arg instanceof Symbol)) logArgs.push(arg);
    }
    return logArgs;
};
/* c8 ignore stop */ /* c8 ignore start */ const $51a21156f8206a3a$var$computeLoggingArgs = $44IZO.supportsColor ? $51a21156f8206a3a$var$computeBrowserLoggingArgs : $bamwN.computeNoColorLoggingArgs;
const $51a21156f8206a3a$export$c2d084dc44961371 = (...args)=>{
    console.log(...$51a21156f8206a3a$var$computeLoggingArgs(args));
    /* c8 ignore next */ $51a21156f8206a3a$export$6f0283bff34730a1.forEach((vc)=>vc.print(args));
};
const $51a21156f8206a3a$export$c106dd0671a0fc2d = (...args)=>{
    console.warn(...$51a21156f8206a3a$var$computeLoggingArgs(args));
    args.unshift($bamwN.ORANGE);
    $51a21156f8206a3a$export$6f0283bff34730a1.forEach((vc)=>vc.print(args));
};
const $51a21156f8206a3a$export$55ee1551a3f962e6 = (err)=>{
    console.error(err);
    $51a21156f8206a3a$export$6f0283bff34730a1.forEach((vc)=>vc.printError(err));
};
const $51a21156f8206a3a$export$85acd411250ab137 = (url, height)=>{
    if ($44IZO.isBrowser) console.log('%c                      ', `font-size: ${height}px; background-size: contain; background-repeat: no-repeat; background-image: url(${url})`);
    $51a21156f8206a3a$export$6f0283bff34730a1.forEach((vc)=>vc.printImg(url, height));
};
const $51a21156f8206a3a$export$fcd48d8a033dbfbf = (base64, height)=>$51a21156f8206a3a$export$85acd411250ab137(`data:image/gif;base64,${base64}`, height);
const $51a21156f8206a3a$export$e5e25fbcc1f7affe = (...args)=>{
    console.group(...$51a21156f8206a3a$var$computeLoggingArgs(args));
    /* c8 ignore next */ $51a21156f8206a3a$export$6f0283bff34730a1.forEach((vc)=>vc.group(args));
};
const $51a21156f8206a3a$export$488ef8fb3416a29f = (...args)=>{
    console.groupCollapsed(...$51a21156f8206a3a$var$computeLoggingArgs(args));
    /* c8 ignore next */ $51a21156f8206a3a$export$6f0283bff34730a1.forEach((vc)=>vc.groupCollapsed(args));
};
const $51a21156f8206a3a$export$a57f3dfe595273e6 = ()=>{
    console.groupEnd();
    /* c8 ignore next */ $51a21156f8206a3a$export$6f0283bff34730a1.forEach((vc)=>vc.groupEnd());
};
const $51a21156f8206a3a$export$76dff282388623b3 = (createNode)=>$51a21156f8206a3a$export$6f0283bff34730a1.forEach((vc)=>vc.printDom(createNode()));
const $51a21156f8206a3a$export$98f2e847362d891 = (canvas, height)=>$51a21156f8206a3a$export$85acd411250ab137(canvas.toDataURL(), height);
const $51a21156f8206a3a$export$6f0283bff34730a1 = $ivn6P.create();
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<Element>}
 */ /* c8 ignore start */ const $51a21156f8206a3a$var$_computeLineSpans = (args)=>{
    const spans = [];
    const currentStyle = new Map();
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        let arg = args[i];
        // @ts-ignore
        const style = $51a21156f8206a3a$var$_browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg === undefined) arg = 'undefined ';
            if (arg.constructor === String || arg.constructor === Number) {
                // @ts-ignore
                const span = $4AiqZ.element('span', [
                    $ZUGGI.create('style', $4AiqZ.mapToStyleString(currentStyle))
                ], [
                    $4AiqZ.text(arg.toString())
                ]);
                if (span.innerHTML === '') span.innerHTML = '&nbsp;';
                spans.push(span);
            } else break;
        }
    }
    // append the rest
    for(; i < args.length; i++){
        let content = args[i];
        if (!(content instanceof Symbol)) {
            if (content.constructor !== String && content.constructor !== Number) content = ' ' + $c9Seu.stringify(content) + ' ';
            spans.push($4AiqZ.element('span', [], [
                $4AiqZ.text(/** @type {string} */ content)
            ]));
        }
    }
    return spans;
};
/* c8 ignore stop */ const $51a21156f8206a3a$var$lineStyle = 'font-family:monospace;border-bottom:1px solid #e2e2e2;padding:2px;';
class $51a21156f8206a3a$export$79dd518d42f6d7a1 {
    /**
   * @param {Element} dom
   */ constructor(dom){
        this.dom = dom;
        /**
     * @type {Element}
     */ this.ccontainer = this.dom;
        this.depth = 0;
        $51a21156f8206a3a$export$6f0283bff34730a1.add(this);
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   * @param {boolean} collapsed
   */ group(args, collapsed = false) {
        $he2rK.enqueue(()=>{
            const triangleDown = $4AiqZ.element('span', [
                $ZUGGI.create('hidden', collapsed),
                $ZUGGI.create('style', 'color:grey;font-size:120%;')
            ], [
                $4AiqZ.text("\u25BC")
            ]);
            const triangleRight = $4AiqZ.element('span', [
                $ZUGGI.create('hidden', !collapsed),
                $ZUGGI.create('style', 'color:grey;font-size:125%;')
            ], [
                $4AiqZ.text("\u25B6")
            ]);
            const content = $4AiqZ.element('div', [
                $ZUGGI.create('style', `${$51a21156f8206a3a$var$lineStyle};padding-left:${this.depth * 10}px`)
            ], [
                triangleDown,
                triangleRight,
                $4AiqZ.text(' ')
            ].concat($51a21156f8206a3a$var$_computeLineSpans(args)));
            const nextContainer = $4AiqZ.element('div', [
                $ZUGGI.create('hidden', collapsed)
            ]);
            const nextLine = $4AiqZ.element('div', [], [
                content,
                nextContainer
            ]);
            $4AiqZ.append(this.ccontainer, [
                nextLine
            ]);
            this.ccontainer = nextContainer;
            this.depth++;
            // when header is clicked, collapse/uncollapse container
            $4AiqZ.addEventListener(content, 'click', (_event)=>{
                nextContainer.toggleAttribute('hidden');
                triangleDown.toggleAttribute('hidden');
                triangleRight.toggleAttribute('hidden');
            });
        });
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   */ groupCollapsed(args) {
        this.group(args, true);
    }
    groupEnd() {
        $he2rK.enqueue(()=>{
            if (this.depth > 0) {
                this.depth--;
                // @ts-ignore
                this.ccontainer = this.ccontainer.parentElement.parentElement;
            }
        });
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   */ print(args) {
        $he2rK.enqueue(()=>{
            $4AiqZ.append(this.ccontainer, [
                $4AiqZ.element('div', [
                    $ZUGGI.create('style', `${$51a21156f8206a3a$var$lineStyle};padding-left:${this.depth * 10}px`)
                ], $51a21156f8206a3a$var$_computeLineSpans(args))
            ]);
        });
    }
    /**
   * @param {Error} err
   */ printError(err) {
        this.print([
            $bamwN.RED,
            $bamwN.BOLD,
            err.toString()
        ]);
    }
    /**
   * @param {string} url
   * @param {number} height
   */ printImg(url, height) {
        $he2rK.enqueue(()=>{
            $4AiqZ.append(this.ccontainer, [
                $4AiqZ.element('img', [
                    $ZUGGI.create('src', url),
                    $ZUGGI.create('height', `${$3Lr38.round(height * 1.5)}px`)
                ])
            ]);
        });
    }
    /**
   * @param {Node} node
   */ printDom(node) {
        $he2rK.enqueue(()=>{
            $4AiqZ.append(this.ccontainer, [
                node
            ]);
        });
    }
    destroy() {
        $he2rK.enqueue(()=>{
            $51a21156f8206a3a$export$6f0283bff34730a1.delete(this);
        });
    }
}
const $51a21156f8206a3a$export$3b589da4ab12cf23 = (dom)=>new $51a21156f8206a3a$export$79dd518d42f6d7a1(dom);
const $51a21156f8206a3a$export$c2977e725d59a2fd = (moduleName)=>$bamwN.createModuleLogger($51a21156f8206a3a$export$c2d084dc44961371, moduleName);

});
parcelRegister("ZUGGI", function(module, exports) {

$parcel$export(module.exports, "create", () => $0ba1ab9454088cfb$export$185802fd694ee1f5);
$parcel$export(module.exports, "forEach", () => $0ba1ab9454088cfb$export$4b80e395e36b5a56);
/**
 * Working with value pairs.
 *
 * @module pair
 */ /**
 * @template L,R
 */ class $0ba1ab9454088cfb$export$d63d7cff08fe4dc9 {
    /**
   * @param {L} left
   * @param {R} right
   */ constructor(left, right){
        this.left = left;
        this.right = right;
    }
}
const $0ba1ab9454088cfb$export$185802fd694ee1f5 = (left, right)=>new $0ba1ab9454088cfb$export$d63d7cff08fe4dc9(left, right);
const $0ba1ab9454088cfb$export$ca0ea131672c5a9b = (right, left)=>new $0ba1ab9454088cfb$export$d63d7cff08fe4dc9(left, right);
const $0ba1ab9454088cfb$export$4b80e395e36b5a56 = (arr, f)=>arr.forEach((p)=>f(p.left, p.right));
const $0ba1ab9454088cfb$export$871de8747c9eaa88 = (arr, f)=>arr.map((p)=>f(p.left, p.right));

});

parcelRegister("4AiqZ", function(module, exports) {

$parcel$export(module.exports, "append", () => $3568d2e1b71699ee$export$10d8903dec122b9d);
$parcel$export(module.exports, "addEventListener", () => $3568d2e1b71699ee$export$3f65cefe8380dbea);
$parcel$export(module.exports, "element", () => $3568d2e1b71699ee$export$8454457683f90105);
$parcel$export(module.exports, "text", () => $3568d2e1b71699ee$export$6f093cfa640b7166);
$parcel$export(module.exports, "mapToStyleString", () => $3568d2e1b71699ee$export$7d9cafe158c3b49);
/* eslint-env browser */ /**
 * Utility module to work with the DOM.
 *
 * @module dom
 */ 
var $ZUGGI = parcelRequire("ZUGGI");

var $iUvcZ = parcelRequire("iUvcZ");

var $lzAXm = parcelRequire("lzAXm");
const $3568d2e1b71699ee$export$2a111da947c407d2 = /** @type {Document} */ typeof document !== 'undefined' ? document : {};
const $3568d2e1b71699ee$export$c8a8987d4410bf2d = (name)=>$3568d2e1b71699ee$export$2a111da947c407d2.createElement(name);
const $3568d2e1b71699ee$export$fb51152cd5328759 = ()=>$3568d2e1b71699ee$export$2a111da947c407d2.createDocumentFragment();
const $3568d2e1b71699ee$export$cc5ef639ec238639 = $lzAXm.$custom((el)=>el.nodeType === $3568d2e1b71699ee$export$b86725031ae151ee);
const $3568d2e1b71699ee$export$b2ce9ad90858ed7a = (text)=>$3568d2e1b71699ee$export$2a111da947c407d2.createTextNode(text);
const $3568d2e1b71699ee$export$fb621bb527230cda = /** @type {DOMParser} */ typeof DOMParser !== 'undefined' ? new DOMParser() : null;
const $3568d2e1b71699ee$export$77c9ee5a14f9d7cf = (el, name, opts)=>el.dispatchEvent(new CustomEvent(name, opts));
const $3568d2e1b71699ee$export$74da2cba014bdc09 = (el, attrs)=>{
    $ZUGGI.forEach(attrs, (key, value)=>{
        if (value === false) el.removeAttribute(key);
        else if (value === true) el.setAttribute(key, '');
        else // @ts-ignore
        el.setAttribute(key, value);
    });
    return el;
};
const $3568d2e1b71699ee$export$ba744f7d152abea1 = (el, attrs)=>{
    attrs.forEach((value, key)=>{
        el.setAttribute(key, value);
    });
    return el;
};
const $3568d2e1b71699ee$export$f00aeb236b6f05af = (children)=>{
    const fragment = $3568d2e1b71699ee$export$fb51152cd5328759();
    for(let i = 0; i < children.length; i++)$3568d2e1b71699ee$export$1b8e57c9ea42f1d2(fragment, children[i]);
    return fragment;
};
const $3568d2e1b71699ee$export$10d8903dec122b9d = (parent, nodes)=>{
    $3568d2e1b71699ee$export$1b8e57c9ea42f1d2(parent, $3568d2e1b71699ee$export$f00aeb236b6f05af(nodes));
    return parent;
};
const $3568d2e1b71699ee$export$cd7f480d6b8286c3 = (el)=>el.remove();
const $3568d2e1b71699ee$export$3f65cefe8380dbea = (el, name, f)=>el.addEventListener(name, f);
const $3568d2e1b71699ee$export$8ff9f68337b520c0 = (el, name, f)=>el.removeEventListener(name, f);
const $3568d2e1b71699ee$export$40a4ed63e5cb7043 = (node, listeners)=>{
    $ZUGGI.forEach(listeners, (name, f)=>$3568d2e1b71699ee$export$3f65cefe8380dbea(node, name, f));
    return node;
};
const $3568d2e1b71699ee$export$8c7b13b21690651d = (node, listeners)=>{
    $ZUGGI.forEach(listeners, (name, f)=>$3568d2e1b71699ee$export$8ff9f68337b520c0(node, name, f));
    return node;
};
const $3568d2e1b71699ee$export$8454457683f90105 = (name, attrs = [], children = [])=>$3568d2e1b71699ee$export$10d8903dec122b9d($3568d2e1b71699ee$export$74da2cba014bdc09($3568d2e1b71699ee$export$c8a8987d4410bf2d(name), attrs), children);
const $3568d2e1b71699ee$export$ccb14863e5ed22f7 = $lzAXm.$custom((el)=>el.nodeType === $3568d2e1b71699ee$export$51c8a276ee4b8f51);
const $3568d2e1b71699ee$export$67ea982130081db = (width, height)=>{
    const c = /** @type {HTMLCanvasElement} */ $3568d2e1b71699ee$export$c8a8987d4410bf2d('canvas');
    c.height = height;
    c.width = width;
    return c;
};
const $3568d2e1b71699ee$export$6f093cfa640b7166 = $3568d2e1b71699ee$export$b2ce9ad90858ed7a;
const $3568d2e1b71699ee$export$68028ad1cb93a754 = $lzAXm.$custom((el)=>el.nodeType === $3568d2e1b71699ee$export$5bcc40203615fc2e);
const $3568d2e1b71699ee$export$7f60f118cd3e6292 = (pair)=>`${pair.left}:${pair.right};`;
const $3568d2e1b71699ee$export$3d24a00500154f45 = (pairs)=>pairs.map($3568d2e1b71699ee$export$7f60f118cd3e6292).join('');
const $3568d2e1b71699ee$export$7d9cafe158c3b49 = (m)=>$iUvcZ.map(m, (value, key)=>`${key}:${value};`).join('');
const $3568d2e1b71699ee$export$78fb49a702cc1f2 = (el, query)=>el.querySelector(query);
const $3568d2e1b71699ee$export$2e83b5c43fb7af7b = (el, query)=>el.querySelectorAll(query);
const $3568d2e1b71699ee$export$83595b84fc78b9b4 = (id)=>/** @type {HTMLElement} */ $3568d2e1b71699ee$export$2a111da947c407d2.getElementById(id);
/**
 * @param {string} html
 * @return {HTMLElement}
 */ const $3568d2e1b71699ee$var$_parse = (html)=>$3568d2e1b71699ee$export$fb621bb527230cda.parseFromString(`<html><body>${html}</body></html>`, 'text/html').body;
const $3568d2e1b71699ee$export$e1152f5efcc82ad = (html)=>$3568d2e1b71699ee$export$f00aeb236b6f05af(/** @type {any} */ $3568d2e1b71699ee$var$_parse(html).childNodes);
const $3568d2e1b71699ee$export$b23064c2dcaf2b63 = (html)=>/** @type HTMLElement */ $3568d2e1b71699ee$var$_parse(html).firstElementChild;
const $3568d2e1b71699ee$export$e6a6680780233a77 = (oldEl, newEl)=>oldEl.replaceWith(newEl);
const $3568d2e1b71699ee$export$86b68c7dbeb53c22 = (parent, el, ref)=>parent.insertBefore(el, ref);
const $3568d2e1b71699ee$export$1b8e57c9ea42f1d2 = (parent, child)=>parent.appendChild(child);
const $3568d2e1b71699ee$export$51c8a276ee4b8f51 = $3568d2e1b71699ee$export$2a111da947c407d2.ELEMENT_NODE;
const $3568d2e1b71699ee$export$5bcc40203615fc2e = $3568d2e1b71699ee$export$2a111da947c407d2.TEXT_NODE;
const $3568d2e1b71699ee$export$e5fc6332c1c8eb8e = $3568d2e1b71699ee$export$2a111da947c407d2.CDATA_SECTION_NODE;
const $3568d2e1b71699ee$export$3d597a6ef0f08b0a = $3568d2e1b71699ee$export$2a111da947c407d2.COMMENT_NODE;
const $3568d2e1b71699ee$export$4139dcda4f7f83db = $3568d2e1b71699ee$export$2a111da947c407d2.DOCUMENT_NODE;
const $3568d2e1b71699ee$export$e9e7ddfdb004b848 = $3568d2e1b71699ee$export$2a111da947c407d2.DOCUMENT_TYPE_NODE;
const $3568d2e1b71699ee$export$b86725031ae151ee = $3568d2e1b71699ee$export$2a111da947c407d2.DOCUMENT_FRAGMENT_NODE;
const $3568d2e1b71699ee$export$a1f067982540fe7e = $lzAXm.$custom((el)=>el.nodeType === $3568d2e1b71699ee$export$4139dcda4f7f83db);
const $3568d2e1b71699ee$export$1aa65d86db59b879 = (node, type)=>node.nodeType === type;
const $3568d2e1b71699ee$export$3c81af374b054d6a = (parent, child)=>{
    let p = child.parentNode;
    while(p && p !== parent)p = p.parentNode;
    return p === parent;
} /* c8 ignore stop */ ;

});
parcelRegister("lzAXm", function(module, exports) {

$parcel$export(module.exports, "$custom", () => $fb4988a3bd886481$export$9d8ff4a6a9aa2751);
/**
 * @experimental WIP
 *
 * Simple & efficient schemas for your data.
 */ 
var $kqHhc = parcelRequire("kqHhc");

var $5DExo = parcelRequire("5DExo");

var $AgXfe = parcelRequire("AgXfe");

var $44IZO = parcelRequire("44IZO");

var $bh6Eu = parcelRequire("bh6Eu");

var $5Ci8T = parcelRequire("5Ci8T");

var $552MW = parcelRequire("552MW");

var $5avZG = parcelRequire("5avZG");

var $5165E = parcelRequire("5165E");
/**
 * @typedef {string|number|bigint|boolean|null|undefined|symbol} Primitive
 */ /**
 * @typedef {{ [k:string|number|symbol]: any }} AnyObject
 */ /**
 * @template T
 * @typedef {T extends Schema<infer X> ? X : T} Unwrap
 */ /**
 * @template T
 * @typedef {T extends Schema<infer X> ? X : T} TypeOf
 */ /**
 * @template {readonly unknown[]} T
 * @typedef {T extends readonly [Schema<infer First>, ...infer Rest] ? [First, ...UnwrapArray<Rest>] : [] } UnwrapArray
 */ /**
 * @template T
 * @typedef {T extends Schema<infer S> ? Schema<S> : never} CastToSchema
 */ /**
 * @template {unknown[]} Arr
 * @typedef {Arr extends [...unknown[], infer L] ? L : never} TupleLast
 */ /**
 * @template {unknown[]} Arr
 * @typedef {Arr extends [...infer Fs, unknown] ? Fs : never} TuplePop
 */ /**
 * @template {readonly unknown[]} T
 * @typedef {T extends []
 *   ? {}
 *   : T extends [infer First]
 *   ? First
 *   : T extends [infer First, ...infer Rest]
 *   ? First & Intersect<Rest>
 *   : never
 * } Intersect
 */ const $fb4988a3bd886481$var$schemaSymbol = Symbol('0schema');
class $fb4988a3bd886481$export$2191b9da168c6cf0 {
    constructor(){
        /**
     * Reverse errors
     * @type {Array<{ path: string?, expected: string, has: string, message: string? }>}
     */ this._rerrs = [];
    }
    /**
   * @param {string?} path
   * @param {string} expected
   * @param {string} has
   * @param {string?} message
   */ extend(path, expected, has, message = null) {
        this._rerrs.push({
            path: path,
            expected: expected,
            has: has,
            message: message
        });
    }
    toString() {
        const s = [];
        for(let i = this._rerrs.length - 1; i > 0; i--){
            const r = this._rerrs[i];
            /* c8 ignore next */ s.push($552MW.repeat(' ', (this._rerrs.length - i) * 2) + `${r.path != null ? `[${r.path}] ` : ''}${r.has} doesn't match ${r.expected}. ${r.message}`);
        }
        return s.join('\n');
    }
}
/**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */ const $fb4988a3bd886481$var$shapeExtends = (a, b)=>{
    if (a === b) return true;
    if (a == null || b == null || a.constructor !== b.constructor) return false;
    if (a[$bh6Eu.EqualityTraitSymbol]) return $bh6Eu.equals(a, b) // last resort: check equality (do this before array and obj check which don't implement the equality trait)
    ;
    if ($5DExo.isArray(a)) return $5DExo.every(a, (aitem)=>$5DExo.some(b, (bitem)=>$fb4988a3bd886481$var$shapeExtends(aitem, bitem)));
    else if ($kqHhc.isObject(a)) return $kqHhc.every(a, (aitem, akey)=>$fb4988a3bd886481$var$shapeExtends(aitem, b[akey]));
    /* c8 ignore next */ return false;
};
class $fb4988a3bd886481$export$19342e026b58ebb7 {
    // this.shape must not be defined on Schema. Otherwise typecheck on metatypes (e.g. $$object) won't work as expected anymore
    /**
   * If true, the more things are added to the shape the more objects this schema will accept (e.g.
   * union). By default, the more objects are added, the the fewer objects this schema will accept.
   * @protected
   */ static _dilutes = false;
    /**
   * @param {Schema<any>} other
   */ extends(other) {
        let [a, b] = [
            /** @type {any} */ this.shape,
            /** @type {any} */ other.shape
        ];
        if (/** @type {typeof Schema<any>} */ this.constructor._dilutes) [b, a] = [
            a,
            b
        ];
        return $fb4988a3bd886481$var$shapeExtends(a, b);
    }
    /**
   * Overwrite this when necessary. By default, we only check the `shape` property which every shape
   * should have.
   * @param {Schema<any>} other
   */ equals(other) {
        // @ts-ignore
        return this.constructor === other.constructor && $5Ci8T.equalityDeep(this.shape, other.shape);
    }
    [$fb4988a3bd886481$var$schemaSymbol]() {
        return true;
    }
    /**
   * @param {object} other
   */ [$bh6Eu.EqualityTraitSymbol](other) {
        return this.equals(/** @type {any} */ other);
    }
    /**
   * Use `schema.validate(obj)` with a typed parameter that is already of typed to be an instance of
   * Schema. Validate will check the structure of the parameter and return true iff the instance
   * really is an instance of Schema.
   *
   * @param {T} o
   * @return {boolean}
   */ validate(o) {
        return this.check(o);
    }
    /* c8 ignore start */ /**
   * Similar to validate, but this method accepts untyped parameters.
   *
   * @param {any} _o
   * @param {ValidationError} [_err]
   * @return {_o is T}
   */ check(_o, _err) {
        $AgXfe.methodUnimplemented();
    }
    /* c8 ignore stop */ /**
   * @type {Schema<T?>}
   */ get nullable() {
        // @ts-ignore
        return $fb4988a3bd886481$export$bfb2cc2f000ac822(this, $fb4988a3bd886481$export$ccfb20865dc3ca5b);
    }
    /**
   * @type {$Optional<Schema<T>>}
   */ get optional() {
        return new $fb4988a3bd886481$var$$Optional(/** @type {Schema<T>} */ this);
    }
    /**
   * Cast a variable to a specific type. Returns the casted value, or throws an exception otherwise.
   * Use this if you know that the type is of a specific type and you just want to convince the type
   * system.
   *
   * **Do not rely on these error messages!**
   * Performs an assertion check only if not in a production environment.
   *
   * @template OO
   * @param {OO} o
   * @return {Extract<OO, T> extends never ? T : (OO extends Array<never> ? T : Extract<OO,T>)}
   */ cast(o) {
        $fb4988a3bd886481$export$a7a9523472993e97(o, this);
        return /** @type {any} */ o;
    }
    /**
   * EXPECTO PATRONUM!! 🪄
   * This function protects against type errors. Though it may not work in the real world.
   *
   * "After all this time?"
   * "Always." - Snape, talking about type safety
   *
   * Ensures that a variable is a a specific type. Returns the value, or throws an exception if the assertion check failed.
   * Use this if you know that the type is of a specific type and you just want to convince the type
   * system.
   *
   * Can be useful when defining lambdas: `s.lambda(s.$number, s.$void).expect((n) => n + 1)`
   *
   * **Do not rely on these error messages!**
   * Performs an assertion check if not in a production environment.
   *
   * @param {T} o
   * @return {o extends T ? T : never}
   */ expect(o) {
        $fb4988a3bd886481$export$a7a9523472993e97(o, this);
        return o;
    }
}
class $fb4988a3bd886481$export$2b336380e101c240 extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {C} c
   * @param {((o:Instance<C>)=>boolean)|null} check
   */ constructor(c, check){
        super();
        this.shape = c;
        this._c = check;
    }
    /**
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is C extends ((...args:any[]) => infer T) ? T : (C extends (new (...args:any[]) => any) ? InstanceType<C> : never)} o
   */ check(o, err) {
        const c = o?.constructor === this.shape && (this._c == null || this._c(o));
        /* c8 ignore next */ !c && err?.extend(null, this.shape.name, o?.constructor.name, o?.constructor !== this.shape ? 'Constructor match failed' : 'Check failed');
        return c;
    }
}
const $fb4988a3bd886481$export$c81896a98af3d6b1 = (c, check = null)=>new $fb4988a3bd886481$export$2b336380e101c240(c, check);
const $fb4988a3bd886481$export$bb7f076462913898 = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$2b336380e101c240);
class $fb4988a3bd886481$export$5d252712f12ea6a5 extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {(o:any) => boolean} check
   */ constructor(check){
        super();
        /**
     * @type {(o:any) => boolean}
     */ this.shape = check;
    }
    /**
   * @param {any} o
   * @param {ValidationError} err
   * @return {o is any}
   */ check(o, err) {
        const c = this.shape(o);
        /* c8 ignore next */ !c && err?.extend(null, 'custom prop', o?.constructor.name, 'failed to check custom prop');
        return c;
    }
}
const $fb4988a3bd886481$export$9d8ff4a6a9aa2751 = (check)=>new $fb4988a3bd886481$export$5d252712f12ea6a5(check);
const $fb4988a3bd886481$export$f1184d56e4530f2e = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$5d252712f12ea6a5);
class $fb4988a3bd886481$export$cfd9da23915aa722 extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {Array<T>} literals
   */ constructor(literals){
        super();
        this.shape = literals;
    }
    /**
   *
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is T}
   */ check(o, err) {
        const c = this.shape.some((a)=>a === o);
        /* c8 ignore next */ !c && err?.extend(null, this.shape.join(' | '), o.toString());
        return c;
    }
}
const $fb4988a3bd886481$export$13f7a91d3a055e50 = (...literals)=>new $fb4988a3bd886481$export$cfd9da23915aa722(literals);
const $fb4988a3bd886481$export$8e8ce8ac0c773751 = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$cfd9da23915aa722);
/**
 * @template {Array<string|Schema<string|number>>} Ts
 * @typedef {Ts extends [] ? `` : (Ts extends [infer T] ? (Unwrap<T> extends (string|number) ? Unwrap<T> : never) : (Ts extends [infer T1, ...infer Rest] ? `${Unwrap<T1> extends (string|number) ? Unwrap<T1> : never}${Rest extends Array<string|Schema<string|number>> ? CastStringTemplateArgsToTemplate<Rest> : never}` : never))} CastStringTemplateArgsToTemplate
 */ /**
 * @param {string} str
 * @return {string}
 */ const $fb4988a3bd886481$var$_regexEscape = /** @type {any} */ RegExp.escape || /** @type {(str:string) => string} */ ((str)=>str.replace(/[().|&,$^[\]]/g, (s)=>'\\' + s));
/**
 * @param {string|Schema<any>} s
 * @return {string[]}
 */ const $fb4988a3bd886481$var$_schemaStringTemplateToRegex = (s)=>{
    if ($fb4988a3bd886481$export$d9567eeca45fccde.check(s)) return [
        $fb4988a3bd886481$var$_regexEscape(s)
    ];
    if ($fb4988a3bd886481$export$8e8ce8ac0c773751.check(s)) return /** @type {Array<string|number>} */ s.shape.map((v)=>v + '');
    if ($fb4988a3bd886481$export$2053aaf254b8f1f6.check(s)) return [
        '[+-]?\\d+.?\\d*'
    ];
    if ($fb4988a3bd886481$export$f0332ae418fa09e9.check(s)) return [
        '.*'
    ];
    if ($fb4988a3bd886481$export$83e34eadbb38cb93.check(s)) return s.shape.map($fb4988a3bd886481$var$_schemaStringTemplateToRegex).flat(1);
    /* c8 ignore next 2 */ // unexpected schema structure (only supports unions and string in literal types)
    $AgXfe.unexpectedCase();
};
class $fb4988a3bd886481$export$6699d28e3200ccdf extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {T} shape
   */ constructor(shape){
        super();
        this.shape = shape;
        this._r = new RegExp('^' + shape.map($fb4988a3bd886481$var$_schemaStringTemplateToRegex).map((opts)=>`(${opts.join('|')})`).join('') + '$');
    }
    /**
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is CastStringTemplateArgsToTemplate<T>}
   */ check(o, err) {
        const c = this._r.exec(o) != null;
        /* c8 ignore next */ !c && err?.extend(null, this._r.toString(), o.toString(), 'String doesn\'t match string template.');
        return c;
    }
}
const $fb4988a3bd886481$export$e23edf3d89be2f56 = (...literals)=>new $fb4988a3bd886481$export$6699d28e3200ccdf(literals);
const $fb4988a3bd886481$export$c1418c4f90c80eae = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$6699d28e3200ccdf);
const $fb4988a3bd886481$var$isOptionalSymbol = Symbol('optional');
/**
 * @template {Schema<any>} S
 * @extends Schema<Unwrap<S>|undefined>
 */ class $fb4988a3bd886481$var$$Optional extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {S} shape
   */ constructor(shape){
        super();
        this.shape = shape;
    }
    /**
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is (Unwrap<S>|undefined)}
   */ check(o, err) {
        const c = o === undefined || this.shape.check(o);
        /* c8 ignore next */ !c && err?.extend(null, 'undefined (optional)', '()');
        return c;
    }
    get [$fb4988a3bd886481$var$isOptionalSymbol]() {
        return true;
    }
}
const $fb4988a3bd886481$export$a8006462f6df005e = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$var$$Optional);
/**
 * @extends Schema<never>
 */ class $fb4988a3bd886481$var$$Never extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {any} _o
   * @param {ValidationError} [err]
   * @return {_o is never}
   */ check(_o, err) {
        /* c8 ignore next */ err?.extend(null, 'never', typeof _o);
        return false;
    }
}
const $fb4988a3bd886481$export$9f377cc58f91f2dc = new $fb4988a3bd886481$var$$Never();
const $fb4988a3bd886481$export$c9cca6f07e1da2e2 = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$var$$Never);
class $fb4988a3bd886481$export$b3a2cbdd14778b75 extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {S} shape
   * @param {boolean} partial
   */ constructor(shape, partial = false){
        super();
        /**
     * @type {S}
     */ this.shape = shape;
        this._isPartial = partial;
    }
    static _dilutes = true;
    /**
   * @type {Schema<Partial<$ObjectToType<S>>>}
   */ get partial() {
        return new $fb4988a3bd886481$export$b3a2cbdd14778b75(this.shape, true);
    }
    /**
   * @param {any} o
   * @param {ValidationError} err
   * @return {o is $ObjectToType<S>}
   */ check(o, err) {
        if (o == null) {
            /* c8 ignore next */ err?.extend(null, 'object', 'null');
            return false;
        }
        return $kqHhc.every(this.shape, (vv, vk)=>{
            const c = this._isPartial && !$kqHhc.hasProperty(o, vk) || vv.check(o[vk], err);
            !c && err?.extend(vk.toString(), vv.toString(), typeof o[vk], 'Object property does not match');
            return c;
        });
    }
}
const $fb4988a3bd886481$export$12235c93089d605f = (def)=>/** @type {any} */ new $fb4988a3bd886481$export$b3a2cbdd14778b75(def);
const $fb4988a3bd886481$export$664ea3567ff71680 = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$b3a2cbdd14778b75);
const $fb4988a3bd886481$export$754f97a97fe890e4 = $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>o != null && (o.constructor === Object || o.constructor == null));
class $fb4988a3bd886481$export$3df71630e633552a extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {Keys} keys
   * @param {Values} values
   */ constructor(keys, values){
        super();
        this.shape = {
            keys: keys,
            values: values
        };
    }
    /**
   * @param {any} o
   * @param {ValidationError} err
   * @return {o is { [key in Unwrap<Keys>]: Unwrap<Values> }}
   */ check(o, err) {
        return o != null && $kqHhc.every(o, (vv, vk)=>{
            const ck = this.shape.keys.check(vk, err);
            /* c8 ignore next */ !ck && err?.extend(vk + '', 'Record', typeof o, ck ? 'Key doesn\'t match schema' : 'Value doesn\'t match value');
            return ck && this.shape.values.check(vv, err);
        });
    }
}
const $fb4988a3bd886481$export$ee08716ef53d51e3 = (keys, values)=>new $fb4988a3bd886481$export$3df71630e633552a(keys, values);
const $fb4988a3bd886481$export$2d91d9b38ea6989b = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$3df71630e633552a);
class $fb4988a3bd886481$export$aa4adb07ac7ea37e extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {S} shape
   */ constructor(shape){
        super();
        this.shape = shape;
    }
    /**
   * @param {any} o
   * @param {ValidationError} err
   * @return {o is { [K in keyof S]: S[K] extends Schema<infer Type> ? Type : never }}
   */ check(o, err) {
        return o != null && $kqHhc.every(this.shape, (vv, vk)=>{
            const c = /** @type {Schema<any>} */ vv.check(o[vk], err);
            /* c8 ignore next */ !c && err?.extend(vk.toString(), 'Tuple', typeof vv);
            return c;
        });
    }
}
const $fb4988a3bd886481$export$87268a8adcd70ac8 = (...def)=>new $fb4988a3bd886481$export$aa4adb07ac7ea37e(def);
const $fb4988a3bd886481$export$c2815a81f4307d74 = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$aa4adb07ac7ea37e);
class $fb4988a3bd886481$export$4481e11156552e2f extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {Array<S>} v
   */ constructor(v){
        super();
        /**
     * @type {Schema<S extends Schema<infer T> ? T : never>}
     */ this.shape = v.length === 1 ? v[0] : new $fb4988a3bd886481$export$8d76b90d0e3a18a0(v);
    }
    /**
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is Array<S extends Schema<infer T> ? T : never>} o
   */ check(o, err) {
        const c = $5DExo.isArray(o) && $5DExo.every(o, (oi)=>this.shape.check(oi));
        /* c8 ignore next */ !c && err?.extend(null, 'Array', '');
        return c;
    }
}
const $fb4988a3bd886481$export$7bc5c8a6f409c3ee = (...def)=>new $fb4988a3bd886481$export$4481e11156552e2f(def);
const $fb4988a3bd886481$export$212a10cf262fab43 = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$4481e11156552e2f);
const $fb4988a3bd886481$export$c7a31cdcf7aaf708 = $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>$5DExo.isArray(o));
class $fb4988a3bd886481$export$8e61405e68ca415f extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {new (...args:any) => T} constructor
   * @param {((o:T) => boolean)|null} check
   */ constructor(constructor, check){
        super();
        this.shape = constructor;
        this._c = check;
    }
    /**
   * @param {any} o
   * @param {ValidationError} err
   * @return {o is T}
   */ check(o, err) {
        const c = o instanceof this.shape && (this._c == null || this._c(o));
        /* c8 ignore next */ !c && err?.extend(null, this.shape.name, o?.constructor.name);
        return c;
    }
}
const $fb4988a3bd886481$export$f94400731e376c1d = (c, check = null)=>new $fb4988a3bd886481$export$8e61405e68ca415f(c, check);
const $fb4988a3bd886481$export$bc12d45faf16744a = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$8e61405e68ca415f);
const $fb4988a3bd886481$export$1e628d3948985b7 = $fb4988a3bd886481$export$f94400731e376c1d($fb4988a3bd886481$export$19342e026b58ebb7);
class $fb4988a3bd886481$export$40662f6b02aedfc5 extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {Args} args
   */ constructor(args){
        super();
        this.len = args.length - 1;
        this.args = $fb4988a3bd886481$export$87268a8adcd70ac8(...args.slice(-1));
        this.res = args[this.len];
    }
    /**
   * @param {any} f
   * @param {ValidationError} err
   * @return {f is _LArgsToLambdaDef<Args>}
   */ check(f, err) {
        const c = f.constructor === Function && f.length <= this.len;
        /* c8 ignore next */ !c && err?.extend(null, 'function', typeof f);
        return c;
    }
}
const $fb4988a3bd886481$export$81021b9a1bc808e1 = (...args)=>new $fb4988a3bd886481$export$40662f6b02aedfc5(args.length > 0 ? args : [
        $fb4988a3bd886481$export$f1b055e4b696f550
    ]);
const $fb4988a3bd886481$export$1508dc9aa4b0fd8c = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$40662f6b02aedfc5);
const $fb4988a3bd886481$export$bb6e4318ed88ea45 = $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>typeof o === 'function');
class $fb4988a3bd886481$export$73375cef2a39310d extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    /**
   * @param {T} v
   */ constructor(v){
        super();
        /**
     * @type {T}
     */ this.shape = v;
    }
    /**
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is Intersect<UnwrapArray<T>>}
   */ check(o, err) {
        // @ts-ignore
        const c = $5DExo.every(this.shape, (check)=>check.check(o, err));
        /* c8 ignore next */ !c && err?.extend(null, 'Intersectinon', typeof o);
        return c;
    }
}
const $fb4988a3bd886481$export$29dd51e23743d8b7 = (...def)=>new $fb4988a3bd886481$export$73375cef2a39310d(def);
const $fb4988a3bd886481$export$aed8423fdefcd17b = $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$73375cef2a39310d, (o)=>o.shape.length > 0) // Intersection with length=0 is considered "any"
;
class $fb4988a3bd886481$export$8d76b90d0e3a18a0 extends $fb4988a3bd886481$export$19342e026b58ebb7 {
    static _dilutes = true;
    /**
   * @param {Array<Schema<S>>} v
   */ constructor(v){
        super();
        this.shape = v;
    }
    /**
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is S}
   */ check(o, err) {
        const c = $5DExo.some(this.shape, (vv)=>vv.check(o, err));
        err?.extend(null, 'Union', typeof o);
        return c;
    }
}
const $fb4988a3bd886481$export$bfb2cc2f000ac822 = (...schemas)=>schemas.findIndex(($s)=>$fb4988a3bd886481$export$83e34eadbb38cb93.check($s)) >= 0 ? $fb4988a3bd886481$export$bfb2cc2f000ac822(...schemas.map(($s)=>$fb4988a3bd886481$export$3d8c2f653ac9d0b9($s)).map(($s)=>$fb4988a3bd886481$export$83e34eadbb38cb93.check($s) ? $s.shape : [
            $s
        ]).flat(1)) : schemas.length === 1 ? schemas[0] : new $fb4988a3bd886481$export$8d76b90d0e3a18a0(schemas);
const $fb4988a3bd886481$export$83e34eadbb38cb93 = /** @type {Schema<$Union<any>>} */ $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$8d76b90d0e3a18a0);
const $fb4988a3bd886481$var$_t = ()=>true;
const $fb4988a3bd886481$export$93fd4f526e2bbf19 = $fb4988a3bd886481$export$9d8ff4a6a9aa2751($fb4988a3bd886481$var$_t);
const $fb4988a3bd886481$export$c78c40e00a6616a8 = /** @type {Schema<Schema<any>>} */ $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$5d252712f12ea6a5, (o)=>o.shape === $fb4988a3bd886481$var$_t);
const $fb4988a3bd886481$export$88bf5393bca0681a = $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>typeof o === 'bigint');
const $fb4988a3bd886481$export$5eccf413bfc5b3bc = /** @type {Schema<Schema<BigInt>>} */ $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>o === $fb4988a3bd886481$export$88bf5393bca0681a);
const $fb4988a3bd886481$export$77a006fb0e866f0e = $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>typeof o === 'symbol');
const $fb4988a3bd886481$export$6de464b4780b6414 = /** @type {Schema<Schema<Symbol>>} */ $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>o === $fb4988a3bd886481$export$77a006fb0e866f0e);
const $fb4988a3bd886481$export$8fbd6ce2218d446a = $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>typeof o === 'number');
const $fb4988a3bd886481$export$2053aaf254b8f1f6 = /** @type {Schema<Schema<number>>} */ $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>o === $fb4988a3bd886481$export$8fbd6ce2218d446a);
const $fb4988a3bd886481$export$d9567eeca45fccde = $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>typeof o === 'string');
const $fb4988a3bd886481$export$f0332ae418fa09e9 = /** @type {Schema<Schema<string>>} */ $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>o === $fb4988a3bd886481$export$d9567eeca45fccde);
const $fb4988a3bd886481$export$f24b79c77c1574e5 = $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>typeof o === 'boolean');
const $fb4988a3bd886481$export$769691791d4088db = /** @type {Schema<Schema<Boolean>>} */ $fb4988a3bd886481$export$9d8ff4a6a9aa2751((o)=>o === $fb4988a3bd886481$export$f24b79c77c1574e5);
const $fb4988a3bd886481$export$9963cfa28fdc81bc = $fb4988a3bd886481$export$13f7a91d3a055e50(undefined);
const $fb4988a3bd886481$export$ebf8947478e7a809 = /** @type {Schema<Schema<undefined>>} */ $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$cfd9da23915aa722, (o)=>o.shape.length === 1 && o.shape[0] === undefined);
const $fb4988a3bd886481$export$f1b055e4b696f550 = $fb4988a3bd886481$export$13f7a91d3a055e50(undefined);
const $fb4988a3bd886481$export$8e4331aba1bca5f9 = /** @type {Schema<Schema<void>>} */ $fb4988a3bd886481$export$ebf8947478e7a809;
const $fb4988a3bd886481$export$ccfb20865dc3ca5b = $fb4988a3bd886481$export$13f7a91d3a055e50(null);
const $fb4988a3bd886481$export$75050adc5191c049 = /** @type {Schema<Schema<null>>} */ $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$cfd9da23915aa722, (o)=>o.shape.length === 1 && o.shape[0] === null);
const $fb4988a3bd886481$export$ecb3be5508166712 = $fb4988a3bd886481$export$c81896a98af3d6b1(Uint8Array);
const $fb4988a3bd886481$export$574be269becf01a6 = /** @type {Schema<Schema<Uint8Array>>} */ $fb4988a3bd886481$export$c81896a98af3d6b1($fb4988a3bd886481$export$2b336380e101c240, (o)=>o.shape === Uint8Array);
const $fb4988a3bd886481$export$9a143cc0da946ba6 = $fb4988a3bd886481$export$bfb2cc2f000ac822($fb4988a3bd886481$export$8fbd6ce2218d446a, $fb4988a3bd886481$export$d9567eeca45fccde, $fb4988a3bd886481$export$ccfb20865dc3ca5b, $fb4988a3bd886481$export$9963cfa28fdc81bc, $fb4988a3bd886481$export$88bf5393bca0681a, $fb4988a3bd886481$export$f24b79c77c1574e5, $fb4988a3bd886481$export$77a006fb0e866f0e);
const $fb4988a3bd886481$export$4d4f5090e84d0726 = (()=>{
    const $jsonArr = /** @type {$Array<$any>} */ $fb4988a3bd886481$export$7bc5c8a6f409c3ee($fb4988a3bd886481$export$93fd4f526e2bbf19);
    const $jsonRecord = /** @type {$Record<$string,$any>} */ $fb4988a3bd886481$export$ee08716ef53d51e3($fb4988a3bd886481$export$d9567eeca45fccde, $fb4988a3bd886481$export$93fd4f526e2bbf19);
    const $json = $fb4988a3bd886481$export$bfb2cc2f000ac822($fb4988a3bd886481$export$8fbd6ce2218d446a, $fb4988a3bd886481$export$d9567eeca45fccde, $fb4988a3bd886481$export$ccfb20865dc3ca5b, $fb4988a3bd886481$export$f24b79c77c1574e5, $jsonArr, $jsonRecord);
    $jsonArr.shape = $json;
    $jsonRecord.shape.values = $json;
    return $json;
})();
const $fb4988a3bd886481$export$3d8c2f653ac9d0b9 = (o)=>{
    if ($fb4988a3bd886481$export$1e628d3948985b7.check(o)) return /** @type {any} */ o;
    else if ($fb4988a3bd886481$export$754f97a97fe890e4.check(o)) {
        /**
     * @type {any}
     */ const o2 = {};
        for(const k in o)o2[k] = $fb4988a3bd886481$export$3d8c2f653ac9d0b9(o[k]);
        return /** @type {any} */ $fb4988a3bd886481$export$12235c93089d605f(o2);
    } else if ($fb4988a3bd886481$export$c7a31cdcf7aaf708.check(o)) return /** @type {any} */ $fb4988a3bd886481$export$bfb2cc2f000ac822(...o.map($fb4988a3bd886481$export$3d8c2f653ac9d0b9));
    else if ($fb4988a3bd886481$export$9a143cc0da946ba6.check(o)) return /** @type {any} */ $fb4988a3bd886481$export$13f7a91d3a055e50(o);
    else if ($fb4988a3bd886481$export$bb6e4318ed88ea45.check(o)) return /** @type {any} */ $fb4988a3bd886481$export$c81896a98af3d6b1(/** @type {any} */ o);
    /* c8 ignore next */ $AgXfe.unexpectedCase();
};
const $fb4988a3bd886481$export$a7a9523472993e97 = $44IZO.production ? ()=>{} : (o, schema)=>{
    const err = new $fb4988a3bd886481$export$2191b9da168c6cf0();
    if (!schema.check(o, err)) throw $AgXfe.create(`Expected value to be of type ${schema.constructor.name}.\n${err.toString()}`);
};
class $fb4988a3bd886481$export$dc12c563bfd68cd {
    /**
   * @param {Schema<State>} [$state]
   */ constructor($state){
        /**
     * @type {Array<Patterns>}
     */ this.patterns = [];
        this.$state = $state;
    }
    /**
   * @template P
   * @template R
   * @param {P} pattern
   * @param {(o:NoInfer<Unwrap<ReadSchema<P>>>,s:State)=>R} handler
   * @return {PatternMatcher<State,Patterns|Pattern<Unwrap<ReadSchema<P>>,R>>}
   */ if(pattern, handler) {
        // @ts-ignore
        this.patterns.push({
            if: $fb4988a3bd886481$export$3d8c2f653ac9d0b9(pattern),
            h: handler
        });
        // @ts-ignore
        return this;
    }
    /**
   * @template R
   * @param {(o:any,s:State)=>R} h
   */ else(h) {
        return this.if($fb4988a3bd886481$export$93fd4f526e2bbf19, h);
    }
    /**
   * @return {State extends undefined
   *   ? <In extends Unwrap<Patterns['if']>>(o:In,state?:undefined)=>PatternMatchResult<Patterns,In>
   *   : <In extends Unwrap<Patterns['if']>>(o:In,state:State)=>PatternMatchResult<Patterns,In>}
   */ done() {
        // @ts-ignore
        return /** @type {any} */ (o, s)=>{
            for(let i = 0; i < this.patterns.length; i++){
                const p = this.patterns[i];
                if (p.if.check(o)) // @ts-ignore
                return p.h(o, s);
            }
            throw $AgXfe.create('Unhandled pattern');
        };
    }
}
const $fb4988a3bd886481$export$4659b591c19bdf3d = (state)=>new $fb4988a3bd886481$export$dc12c563bfd68cd(/** @type {any} */ state);
/**
 * Helper function to generate a (non-exhaustive) sample set from a gives schema.
 *
 * @type {<T>(o:T,gen:prng.PRNG)=>T}
 */ const $fb4988a3bd886481$var$_random = /** @type {any} */ $fb4988a3bd886481$export$4659b591c19bdf3d(/** @type {Schema<prng.PRNG>} */ $fb4988a3bd886481$export$93fd4f526e2bbf19).if($fb4988a3bd886481$export$2053aaf254b8f1f6, (_o, gen)=>$5avZG.int53(gen, $5165E.MIN_SAFE_INTEGER, $5165E.MAX_SAFE_INTEGER)).if($fb4988a3bd886481$export$f0332ae418fa09e9, (_o, gen)=>$5avZG.word(gen)).if($fb4988a3bd886481$export$769691791d4088db, (_o, gen)=>$5avZG.bool(gen)).if($fb4988a3bd886481$export$5eccf413bfc5b3bc, (_o, gen)=>BigInt($5avZG.int53(gen, $5165E.MIN_SAFE_INTEGER, $5165E.MAX_SAFE_INTEGER))).if($fb4988a3bd886481$export$83e34eadbb38cb93, (o, gen)=>$fb4988a3bd886481$export$4385e60b38654f68(gen, $5avZG.oneOf(gen, o.shape))).if($fb4988a3bd886481$export$664ea3567ff71680, (o, gen)=>{
    /**
     * @type {any}
     */ const res = {};
    for(const k in o.shape){
        let prop = o.shape[k];
        if ($fb4988a3bd886481$export$a8006462f6df005e.check(prop)) {
            if ($5avZG.bool(gen)) continue;
            prop = prop.shape;
        }
        res[k] = $fb4988a3bd886481$var$_random(prop, gen);
    }
    return res;
}).if($fb4988a3bd886481$export$212a10cf262fab43, (o, gen)=>{
    const arr = [];
    const n = $5avZG.int32(gen, 0, 42);
    for(let i = 0; i < n; i++)arr.push($fb4988a3bd886481$export$4385e60b38654f68(gen, o.shape));
    return arr;
}).if($fb4988a3bd886481$export$8e8ce8ac0c773751, (o, gen)=>{
    return $5avZG.oneOf(gen, o.shape);
}).if($fb4988a3bd886481$export$75050adc5191c049, (o, gen)=>{
    return null;
}).if($fb4988a3bd886481$export$1508dc9aa4b0fd8c, (o, gen)=>{
    const res = $fb4988a3bd886481$export$4385e60b38654f68(gen, o.res);
    return ()=>res;
}).if($fb4988a3bd886481$export$c78c40e00a6616a8, (o, gen)=>$fb4988a3bd886481$export$4385e60b38654f68(gen, $5avZG.oneOf(gen, [
        $fb4988a3bd886481$export$8fbd6ce2218d446a,
        $fb4988a3bd886481$export$d9567eeca45fccde,
        $fb4988a3bd886481$export$ccfb20865dc3ca5b,
        $fb4988a3bd886481$export$9963cfa28fdc81bc,
        $fb4988a3bd886481$export$88bf5393bca0681a,
        $fb4988a3bd886481$export$f24b79c77c1574e5,
        $fb4988a3bd886481$export$7bc5c8a6f409c3ee($fb4988a3bd886481$export$8fbd6ce2218d446a),
        $fb4988a3bd886481$export$ee08716ef53d51e3($fb4988a3bd886481$export$bfb2cc2f000ac822('a', 'b', 'c'), $fb4988a3bd886481$export$8fbd6ce2218d446a)
    ]))).if($fb4988a3bd886481$export$2d91d9b38ea6989b, (o, gen)=>{
    /**
     * @type {any}
     */ const res = {};
    const keysN = $5avZG.int53(gen, 0, 3);
    for(let i = 0; i < keysN; i++){
        const key = $fb4988a3bd886481$export$4385e60b38654f68(gen, o.shape.keys);
        const val = $fb4988a3bd886481$export$4385e60b38654f68(gen, o.shape.values);
        res[key] = val;
    }
    return res;
}).done();
const $fb4988a3bd886481$export$4385e60b38654f68 = (gen, schema)=>/** @type {any} */ $fb4988a3bd886481$var$_random($fb4988a3bd886481$export$3d8c2f653ac9d0b9(schema), gen);

});
parcelRegister("5avZG", function(module, exports) {

$parcel$export(module.exports, "bool", () => $3c36b43d6a2c34db$export$87b259aa03e3d267);
$parcel$export(module.exports, "int53", () => $3c36b43d6a2c34db$export$19ee924d4eeaa52);
$parcel$export(module.exports, "int32", () => $3c36b43d6a2c34db$export$1d95835383bb05a);
$parcel$export(module.exports, "word", () => $3c36b43d6a2c34db$export$ac351257249182a8);
$parcel$export(module.exports, "oneOf", () => $3c36b43d6a2c34db$export$a9a18ae5ba42aeab);
/**
 * Fast Pseudo Random Number Generators.
 *
 * Given a seed a PRNG generates a sequence of numbers that cannot be reasonably predicted.
 * Two PRNGs must generate the same random sequence of numbers if  given the same seed.
 *
 * @module prng
 */ 
var $8FTfp = parcelRequire("8FTfp");

var $552MW = parcelRequire("552MW");

var $3Lr38 = parcelRequire("3Lr38");

var $kdEEd = parcelRequire("kdEEd");

var $0Sial = parcelRequire("0Sial");
const $3c36b43d6a2c34db$export$ff8f2f54bcf6e6cc = (0, $kdEEd.Xoroshiro128plus);
const $3c36b43d6a2c34db$export$185802fd694ee1f5 = (seed)=>new $3c36b43d6a2c34db$export$ff8f2f54bcf6e6cc(seed);
const $3c36b43d6a2c34db$export$87b259aa03e3d267 = (gen)=>gen.next() >= 0.5;
const $3c36b43d6a2c34db$export$19ee924d4eeaa52 = (gen, min, max)=>$3Lr38.floor(gen.next() * (max + 1 - min) + min);
const $3c36b43d6a2c34db$export$6bf94e3d82617e4e = (gen, min, max)=>$3Lr38.abs($3c36b43d6a2c34db$export$19ee924d4eeaa52(gen, min, max));
const $3c36b43d6a2c34db$export$1d95835383bb05a = (gen, min, max)=>$3Lr38.floor(gen.next() * (max + 1 - min) + min);
const $3c36b43d6a2c34db$export$de9ffb9418dd7d0d = (gen, min, max)=>$3c36b43d6a2c34db$export$1d95835383bb05a(gen, min, max) >>> 0;
const $3c36b43d6a2c34db$export$9e33ec65f5839057 = (gen, min, max)=>$3c36b43d6a2c34db$export$1d95835383bb05a(gen, min, max);
const $3c36b43d6a2c34db$export$5d5fcd5c50d7eccb = (gen)=>gen.next() // (((gen.next() >>> 5) * binary.BIT26) + (gen.next() >>> 6)) / MAX_SAFE_INTEGER
;
const $3c36b43d6a2c34db$export$eba6f6f03b0a92e7 = (gen)=>(0, $552MW.fromCharCode)($3c36b43d6a2c34db$export$9e33ec65f5839057(gen, 32, 126));
const $3c36b43d6a2c34db$export$30780d0b6b610af8 = (gen)=>(0, $552MW.fromCharCode)($3c36b43d6a2c34db$export$9e33ec65f5839057(gen, 97, 122));
const $3c36b43d6a2c34db$export$ac351257249182a8 = (gen, minLen = 0, maxLen = 20)=>{
    const len = $3c36b43d6a2c34db$export$9e33ec65f5839057(gen, minLen, maxLen);
    let str = '';
    for(let i = 0; i < len; i++)str += $3c36b43d6a2c34db$export$30780d0b6b610af8(gen);
    return str;
};
const $3c36b43d6a2c34db$export$2e4c8c2946979aa9 = (gen)=>{
    const codepoint = $3c36b43d6a2c34db$export$9e33ec65f5839057(gen, 0, 256);
    return (0, $552MW.fromCodePoint)(codepoint);
};
const $3c36b43d6a2c34db$export$c774f72cf497da34 = (gen, maxlen = 20)=>{
    const len = $3c36b43d6a2c34db$export$9e33ec65f5839057(gen, 0, maxlen);
    let str = '';
    for(let i = 0; i < len; i++)str += $3c36b43d6a2c34db$export$2e4c8c2946979aa9(gen);
    return str;
};
const $3c36b43d6a2c34db$export$a9a18ae5ba42aeab = (gen, array)=>array[$3c36b43d6a2c34db$export$9e33ec65f5839057(gen, 0, array.length - 1)];
const $3c36b43d6a2c34db$export$d7e5036dad7e20bb = (gen, len)=>{
    const buf = $0Sial.createUint8ArrayFromLen(len);
    for(let i = 0; i < buf.length; i++)buf[i] = $3c36b43d6a2c34db$export$1d95835383bb05a(gen, 0, $8FTfp.BITS8);
    return buf;
};
const $3c36b43d6a2c34db$export$1b0fcb357ffba442 = (gen, len)=>new Uint16Array($3c36b43d6a2c34db$export$d7e5036dad7e20bb(gen, len * 2).buffer);
const $3c36b43d6a2c34db$export$cfc27d0ff30e330b = (gen, len)=>new Uint32Array($3c36b43d6a2c34db$export$d7e5036dad7e20bb(gen, len * 4).buffer) /* c8 ignore stop */ ;

});
parcelRegister("kdEEd", function(module, exports) {

$parcel$export(module.exports, "Xoroshiro128plus", () => $eb848d536c665a5f$export$3b6ede621cb1bb78);
/**
 * @module prng
 */ 
var $F1wmW = parcelRequire("F1wmW");

var $8FTfp = parcelRequire("8FTfp");
class $eb848d536c665a5f$export$3b6ede621cb1bb78 {
    /**
   * @param {number} seed Unsigned 32 bit number
   */ constructor(seed){
        this.seed = seed;
        // This is a variant of Xoroshiro128plus to fill the initial state
        const xorshift32 = new (0, $F1wmW.Xorshift32)(seed);
        this.state = new Uint32Array(4);
        for(let i = 0; i < 4; i++)this.state[i] = xorshift32.next() * $8FTfp.BITS32;
        this._fresh = true;
    }
    /**
   * @return {number} Float/Double in [0,1)
   */ next() {
        const state = this.state;
        if (this._fresh) {
            this._fresh = false;
            return (state[0] + state[2] >>> 0) / ($8FTfp.BITS32 + 1);
        } else {
            this._fresh = true;
            const s0 = state[0];
            const s1 = state[1];
            const s2 = state[2] ^ s0;
            const s3 = state[3] ^ s1;
            // function js_rotl (x, k) {
            //   k = k - 32
            //   const x1 = x[0]
            //   const x2 = x[1]
            //   x[0] = x2 << k | x1 >>> (32 - k)
            //   x[1] = x1 << k | x2 >>> (32 - k)
            // }
            // rotl(s0, 55) // k = 23 = 55 - 32; j = 9 =  32 - 23
            state[0] = (s1 << 23 | s0 >>> 9) ^ s2 ^ (s2 << 14 | s3 >>> 18);
            state[1] = (s0 << 23 | s1 >>> 9) ^ s3 ^ s3 << 14;
            // rol(s1, 36) // k = 4 = 36 - 32; j = 23 = 32 - 9
            state[2] = s3 << 4 | s2 >>> 28;
            state[3] = s2 << 4 | s3 >>> 28;
            return (state[1] + state[3] >>> 0) / ($8FTfp.BITS32 + 1);
        }
    }
} /*
// Reference implementation
// Source: http://vigna.di.unimi.it/xorshift/xoroshiro128plus.c
// By David Blackman and Sebastiano Vigna
// Who published the reference implementation under Public Domain (CC0)

#include <stdint.h>
#include <stdio.h>

uint64_t s[2];

static inline uint64_t rotl(const uint64_t x, int k) {
    return (x << k) | (x >> (64 - k));
}

uint64_t next(void) {
    const uint64_t s0 = s[0];
    uint64_t s1 = s[1];
    s1 ^= s0;
    s[0] = rotl(s0, 55) ^ s1 ^ (s1 << 14); // a, b
    s[1] = rotl(s1, 36); // c
    return (s[0] + s[1]) & 0xFFFFFFFF;
}

int main(void)
{
    int i;
    s[0] = 1111 | (1337ul << 32);
    s[1] = 1234 | (9999ul << 32);

    printf("1000 outputs of genrand_int31()\n");
    for (i=0; i<100; i++) {
        printf("%10lu ", i);
        printf("%10lu ", next());
        printf("- %10lu ", s[0] >> 32);
        printf("%10lu ", (s[0] << 32) >> 32);
        printf("%10lu ", s[1] >> 32);
        printf("%10lu ", (s[1] << 32) >> 32);
        printf("\n");
        // if (i%5==4) printf("\n");
    }
    return 0;
}
*/ 

});
parcelRegister("F1wmW", function(module, exports) {

$parcel$export(module.exports, "Xorshift32", () => $07b50281455756da$export$1a123e145bc1b5ac);
/**
 * @module prng
 */ 
var $8FTfp = parcelRequire("8FTfp");
class $07b50281455756da$export$1a123e145bc1b5ac {
    /**
   * @param {number} seed Unsigned 32 bit number
   */ constructor(seed){
        this.seed = seed;
        /**
     * @type {number}
     */ this._state = seed;
    }
    /**
   * Generate a random signed integer.
   *
   * @return {Number} A 32 bit signed integer.
   */ next() {
        let x = this._state;
        x ^= x << 13;
        x ^= x >> 17;
        x ^= x << 5;
        this._state = x;
        return (x >>> 0) / ($8FTfp.BITS32 + 1);
    }
}

});





parcelRegister("c9Seu", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $8da064c5bff745e1$export$fac44ee5b035f737);
/**
 * JSON utility functions.
 *
 * @module json
 */ /**
 * Transform JavaScript object to JSON.
 *
 * @param {any} object
 * @return {string}
 */ const $8da064c5bff745e1$export$fac44ee5b035f737 = JSON.stringify;
const $8da064c5bff745e1$export$98e6a39c04603d36 = JSON.parse;

});

parcelRegister("he2rK", function(module, exports) {

$parcel$export(module.exports, "enqueue", () => $c8a5a4507b2ec700$export$513072ba72100d9c);
/* global requestIdleCallback, requestAnimationFrame, cancelIdleCallback, cancelAnimationFrame */ 
var $g2kVL = parcelRequire("g2kVL");
/**
 * Utility module to work with EcmaScript's event loop.
 *
 * @module eventloop
 */ /**
 * @type {Array<function>}
 */ let $c8a5a4507b2ec700$var$queue = [];
const $c8a5a4507b2ec700$var$_runQueue = ()=>{
    for(let i = 0; i < $c8a5a4507b2ec700$var$queue.length; i++)$c8a5a4507b2ec700$var$queue[i]();
    $c8a5a4507b2ec700$var$queue = [];
};
const $c8a5a4507b2ec700$export$513072ba72100d9c = (f)=>{
    $c8a5a4507b2ec700$var$queue.push(f);
    if ($c8a5a4507b2ec700$var$queue.length === 1) setTimeout($c8a5a4507b2ec700$var$_runQueue, 0);
};
/**
 * @typedef {Object} TimeoutObject
 * @property {function} TimeoutObject.destroy
 */ /**
 * @param {function(number):void} clearFunction
 */ const $c8a5a4507b2ec700$var$createTimeoutClass = (clearFunction)=>class TT {
        /**
   * @param {number} timeoutId
   */ constructor(timeoutId){
            this._ = timeoutId;
        }
        destroy() {
            clearFunction(this._);
        }
    };
const $c8a5a4507b2ec700$var$Timeout = $c8a5a4507b2ec700$var$createTimeoutClass(clearTimeout);
const $c8a5a4507b2ec700$export$83e74882c5df8fe1 = (timeout, callback)=>new $c8a5a4507b2ec700$var$Timeout(setTimeout(callback, timeout));
const $c8a5a4507b2ec700$var$Interval = $c8a5a4507b2ec700$var$createTimeoutClass(clearInterval);
const $c8a5a4507b2ec700$export$3174cdbf0a0cbc84 = (timeout, callback)=>new $c8a5a4507b2ec700$var$Interval(setInterval(callback, timeout));
const $c8a5a4507b2ec700$export$c35d437ae5945fcd = $c8a5a4507b2ec700$var$createTimeoutClass((arg)=>typeof requestAnimationFrame !== 'undefined' && cancelAnimationFrame(arg));
const $c8a5a4507b2ec700$export$1402cba6a733f33a = (cb)=>typeof requestAnimationFrame === 'undefined' ? $c8a5a4507b2ec700$export$83e74882c5df8fe1(0, cb) : new $c8a5a4507b2ec700$export$c35d437ae5945fcd(requestAnimationFrame(cb));
/* c8 ignore next */ // @ts-ignore
const $c8a5a4507b2ec700$var$Idle = $c8a5a4507b2ec700$var$createTimeoutClass((arg)=>typeof cancelIdleCallback !== 'undefined' && cancelIdleCallback(arg));
const $c8a5a4507b2ec700$export$9f62c65f1b707875 = (cb)=>typeof requestIdleCallback !== 'undefined' ? new $c8a5a4507b2ec700$var$Idle(requestIdleCallback(cb)) : $c8a5a4507b2ec700$export$83e74882c5df8fe1(1000, cb);
const $c8a5a4507b2ec700$export$21cd608c50c2ba31 = (timeout, triggerAfter = -1)=>{
    let timer = -1;
    /**
   * @type {number?}
    */ let lastCall = null;
    /**
   * @param {((...args: any)=>void)?} cb function to trigger after debounce. If null, it will reset the
   *                         debounce.
   */ return (cb)=>{
        clearTimeout(timer);
        if (cb) {
            if (triggerAfter >= 0) {
                const now = $g2kVL.getUnixTime();
                if (lastCall === null) lastCall = now;
                if (now - lastCall > triggerAfter) {
                    lastCall = null;
                    timer = /** @type {any} */ setTimeout(cb, 0);
                    return;
                }
            }
            timer = /** @type {any} */ setTimeout(()=>{
                lastCall = null;
                cb();
            }, timeout);
        } else lastCall = null;
    };
};

});

parcelRegister("bamwN", function(module, exports) {

$parcel$export(module.exports, "BOLD", () => $021910f15d0c39e3$export$c1286c4c2a7c066);
$parcel$export(module.exports, "UNBOLD", () => $021910f15d0c39e3$export$f0ce1666bb40789b);
$parcel$export(module.exports, "BLUE", () => $021910f15d0c39e3$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "GREY", () => $021910f15d0c39e3$export$7d278ca694634874);
$parcel$export(module.exports, "GREEN", () => $021910f15d0c39e3$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "RED", () => $021910f15d0c39e3$export$aa201224bb439d47);
$parcel$export(module.exports, "PURPLE", () => $021910f15d0c39e3$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "ORANGE", () => $021910f15d0c39e3$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "UNCOLOR", () => $021910f15d0c39e3$export$b586f81201748dd0);
$parcel$export(module.exports, "computeNoColorLoggingArgs", () => $021910f15d0c39e3$export$3454091cc3c6c473);
$parcel$export(module.exports, "createModuleLogger", () => $021910f15d0c39e3$export$c2977e725d59a2fd);

var $kPF5D = parcelRequire("kPF5D");

var $g2kVL = parcelRequire("g2kVL");

var $44IZO = parcelRequire("44IZO");

var $5Ci8T = parcelRequire("5Ci8T");

var $c9Seu = parcelRequire("c9Seu");
const $021910f15d0c39e3$export$c1286c4c2a7c066 = $kPF5D.create();
const $021910f15d0c39e3$export$f0ce1666bb40789b = $kPF5D.create();
const $021910f15d0c39e3$export$738c3b9a44c87ecc = $kPF5D.create();
const $021910f15d0c39e3$export$7d278ca694634874 = $kPF5D.create();
const $021910f15d0c39e3$export$48d4b2cd5bc0e88b = $kPF5D.create();
const $021910f15d0c39e3$export$aa201224bb439d47 = $kPF5D.create();
const $021910f15d0c39e3$export$7ffdeca4b2f927a2 = $kPF5D.create();
const $021910f15d0c39e3$export$3de5e29ed1757f9b = $kPF5D.create();
const $021910f15d0c39e3$export$b586f81201748dd0 = $kPF5D.create();
const $021910f15d0c39e3$export$3454091cc3c6c473 = (args)=>{
    if (args.length === 1 && args[0]?.constructor === Function) args = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args[0]();
    const strBuilder = [];
    const logArgs = [];
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        if (arg === undefined) break;
        else if (arg.constructor === String || arg.constructor === Number) strBuilder.push(arg);
        else if (arg.constructor === Object) break;
    }
    if (i > 0) // create logArgs with what we have so far
    logArgs.push(strBuilder.join(''));
    // append the rest
    for(; i < args.length; i++){
        const arg = args[i];
        if (!(arg instanceof Symbol)) logArgs.push(arg);
    }
    return logArgs;
};
/* c8 ignore stop */ const $021910f15d0c39e3$var$loggingColors = [
    $021910f15d0c39e3$export$48d4b2cd5bc0e88b,
    $021910f15d0c39e3$export$7ffdeca4b2f927a2,
    $021910f15d0c39e3$export$3de5e29ed1757f9b,
    $021910f15d0c39e3$export$738c3b9a44c87ecc
];
let $021910f15d0c39e3$var$nextColor = 0;
let $021910f15d0c39e3$var$lastLoggingTime = $g2kVL.getUnixTime();
const $021910f15d0c39e3$export$c2977e725d59a2fd = (_print, moduleName)=>{
    const color = $021910f15d0c39e3$var$loggingColors[$021910f15d0c39e3$var$nextColor];
    const debugRegexVar = $44IZO.getVariable('log');
    const doLogging = debugRegexVar !== null && (debugRegexVar === '*' || debugRegexVar === 'true' || new RegExp(debugRegexVar, 'gi').test(moduleName));
    $021910f15d0c39e3$var$nextColor = ($021910f15d0c39e3$var$nextColor + 1) % $021910f15d0c39e3$var$loggingColors.length;
    moduleName += ': ';
    return !doLogging ? $5Ci8T.nop : (...args)=>{
        if (args.length === 1 && args[0]?.constructor === Function) args = args[0]();
        const timeNow = $g2kVL.getUnixTime();
        const timeDiff = timeNow - $021910f15d0c39e3$var$lastLoggingTime;
        $021910f15d0c39e3$var$lastLoggingTime = timeNow;
        _print(color, moduleName, $021910f15d0c39e3$export$b586f81201748dd0, ...args.map((arg)=>{
            if (arg != null && arg.constructor === Uint8Array) arg = Array.from(arg);
            const t = typeof arg;
            switch(t){
                case 'string':
                case 'symbol':
                    return arg;
                default:
                    return $c9Seu.stringify(arg);
            }
        }), color, ' +' + timeDiff + 'ms');
    };
} /* c8 ignore stop */ ;

});
parcelRegister("kPF5D", function(module, exports) {

$parcel$export(module.exports, "create", () => $f2a871a6b0b13136$export$185802fd694ee1f5);
/**
 * Utility module to work with EcmaScript Symbols.
 *
 * @module symbol
 */ /**
 * Return fresh symbol.
 */ const $f2a871a6b0b13136$export$185802fd694ee1f5 = Symbol;
const $f2a871a6b0b13136$export$a244864fd9645c7f = (s)=>typeof s === 'symbol';

});



parcelRegister("3ZDaC", function(module, exports) {

$parcel$export(module.exports, "iteratorFilter", () => $2e857403967c5ef8$export$88f0b2eef157f31a);
$parcel$export(module.exports, "iteratorMap", () => $2e857403967c5ef8$export$1570d514f543056a);
/**
 * Utility module to create and manipulate Iterators.
 *
 * @module iterator
 */ /**
 * @template T,R
 * @param {Iterator<T>} iterator
 * @param {function(T):R} f
 * @return {IterableIterator<R>}
 */ const $2e857403967c5ef8$export$68b1bda190f54159 = (iterator, f)=>({
        [Symbol.iterator] () {
            return this;
        },
        // @ts-ignore
        next () {
            const r = iterator.next();
            return {
                value: r.done ? undefined : f(r.value),
                done: r.done
            };
        }
    });
const $2e857403967c5ef8$export$7342c78d7e13e778 = (next)=>({
        /**
   * @return {IterableIterator<T>}
   */ [Symbol.iterator] () {
            return this;
        },
        next: // @ts-ignore
        next
    });
const $2e857403967c5ef8$export$88f0b2eef157f31a = (iterator, filter)=>$2e857403967c5ef8$export$7342c78d7e13e778(()=>{
        let res;
        do res = iterator.next();
        while (!res.done && !filter(res.value));
        return res;
    });
const $2e857403967c5ef8$export$1570d514f543056a = (iterator, fmap)=>$2e857403967c5ef8$export$7342c78d7e13e778(()=>{
        const { done: done, value: value } = iterator.next();
        return {
            done: done,
            value: done ? undefined : fmap(value)
        };
    });

});


parcelRegister("dGheI", function(module, exports) {

$parcel$export(module.exports, "WebsocketProvider", () => $9f5c915f0579f3cf$export$c0e03644998998fb);
/**
 * @module provider/websocket
 */ /* eslint-env browser */ 

var $jshSA = parcelRequire("jshSA");

var $g2kVL = parcelRequire("g2kVL");

var $xchLN = parcelRequire("xchLN");

var $dB3PR = parcelRequire("dB3PR");

var $1UONF = parcelRequire("1UONF");

var $eMsL6 = parcelRequire("eMsL6");

var $23ZAc = parcelRequire("23ZAc");

var $1UXIn = parcelRequire("1UXIn");

var $3Lr38 = parcelRequire("3Lr38");

var $6zOa3 = parcelRequire("6zOa3");

var $44IZO = parcelRequire("44IZO");
const $9f5c915f0579f3cf$export$70790f6f28b13205 = 0;
const $9f5c915f0579f3cf$export$83b62f7afdd0e333 = 3;
const $9f5c915f0579f3cf$export$790bca08a5d3ef2c = 1;
const $9f5c915f0579f3cf$export$89c03a973d1d6923 = 2;
/**
 *                       encoder,          decoder,          provider,          emitSynced, messageType
 * @type {Array<function(encoding.Encoder, decoding.Decoder, WebsocketProvider, boolean,    number):void>}
 */ const $9f5c915f0579f3cf$var$messageHandlers = [];
$9f5c915f0579f3cf$var$messageHandlers[$9f5c915f0579f3cf$export$70790f6f28b13205] = (encoder, decoder, provider, emitSynced, _messageType)=>{
    $xchLN.writeVarUint(encoder, $9f5c915f0579f3cf$export$70790f6f28b13205);
    const syncMessageType = $1UONF.readSyncMessage(decoder, encoder, provider.doc, provider);
    if (emitSynced && syncMessageType === $1UONF.messageYjsSyncStep2 && !provider.synced) provider.synced = true;
};
$9f5c915f0579f3cf$var$messageHandlers[$9f5c915f0579f3cf$export$83b62f7afdd0e333] = (encoder, _decoder, provider, _emitSynced, _messageType)=>{
    $xchLN.writeVarUint(encoder, $9f5c915f0579f3cf$export$790bca08a5d3ef2c);
    $xchLN.writeVarUint8Array(encoder, $23ZAc.encodeAwarenessUpdate(provider.awareness, Array.from(provider.awareness.getStates().keys())));
};
$9f5c915f0579f3cf$var$messageHandlers[$9f5c915f0579f3cf$export$790bca08a5d3ef2c] = (_encoder, decoder, provider, _emitSynced, _messageType)=>{
    $23ZAc.applyAwarenessUpdate(provider.awareness, $dB3PR.readVarUint8Array(decoder), provider);
};
$9f5c915f0579f3cf$var$messageHandlers[$9f5c915f0579f3cf$export$89c03a973d1d6923] = (_encoder, decoder, provider, _emitSynced, _messageType)=>{
    $eMsL6.readAuthMessage(decoder, provider.doc, (_ydoc, reason)=>$9f5c915f0579f3cf$var$permissionDeniedHandler(provider, reason));
};
// @todo - this should depend on awareness.outdatedTime
const $9f5c915f0579f3cf$var$messageReconnectTimeout = 30000;
/**
 * @param {WebsocketProvider} provider
 * @param {string} reason
 */ const $9f5c915f0579f3cf$var$permissionDeniedHandler = (provider, reason)=>console.warn(`Permission denied to access ${provider.url}.\n${reason}`);
/**
 * @param {WebsocketProvider} provider
 * @param {Uint8Array} buf
 * @param {boolean} emitSynced
 * @return {encoding.Encoder}
 */ const $9f5c915f0579f3cf$var$readMessage = (provider, buf, emitSynced)=>{
    const decoder = $dB3PR.createDecoder(buf);
    const encoder = $xchLN.createEncoder();
    const messageType = $dB3PR.readVarUint(decoder);
    const messageHandler = provider.messageHandlers[messageType];
    if (/** @type {any} */ messageHandler) messageHandler(encoder, decoder, provider, emitSynced, messageType);
    else console.error('Unable to compute message');
    return encoder;
};
/**
 * The default `shouldReconnect` implementation. Close codes 4000-4999 are reserved for private
 * use (RFC 6455). By convention, the 4400-4499 sub-range mirrors the HTTP 4xx class: the server
 * made a deliberate decision that reconnecting can't fix - e.g. the permission to access the
 * document was revoked, or the document doesn't exist anymore. Every other close code is treated
 * as transient, including 4500-4599, which is the matching "try again later" range.
 *
 * This is intentionally written as the negation of the positive range test. A WebSocket polyfill
 * that doesn't report a close code must not be mistaken for a permanent error.
 *
 * @param {CloseEvent} event
 * @return {boolean}
 */ const $9f5c915f0579f3cf$var$defaultShouldReconnect = (event)=>!(event.code >= 4400 && event.code < 4500);
/**
 * Outsource this function so that a new websocket connection is created immediately.
 * I suspect that the `ws.onclose` event is not always fired if there are network issues.
 *
 * `event` is `null` when we closed the connection ourselves - `provider.disconnect()`, or the
 * "no message received" watchdog. We always reconnect in that case: a local close is not a
 * signal from the server, and `provider.shouldConnect` already reflects the user's intention.
 *
 * @param {WebsocketProvider} provider
 * @param {WebSocket} ws
 * @param {CloseEvent | null} event
 */ const $9f5c915f0579f3cf$var$closeWebsocketConnection = (provider, ws, event)=>{
    if (ws !== null && ws === provider.ws) {
        provider.emit('connection-close', [
            event,
            provider
        ]);
        provider.ws = null;
        // detach the handlers so that a socket that is still flushing buffered frames (e.g. a Node
        // `ws` socket in CLOSING state) cannot mutate the provider state anymore
        ws.onmessage = null;
        ws.onopen = null;
        ws.onclose = null;
        // `onerror` is swallowed instead of detached: closing a socket that is still connecting is
        // reported as an error event, and in nodejs an error event without a listener is rethrown as
        // an uncaught exception
        ws.onerror = ()=>{};
        ws.close();
        provider.wsconnecting = false;
        if (provider.wsconnected) {
            provider.wsconnected = false;
            provider.synced = false;
            // update awareness (all users except local left)
            $23ZAc.removeAwarenessStates(provider.awareness, Array.from(provider.awareness.getStates().keys()).filter((client)=>client !== provider.doc.clientID), provider);
            provider.emit('status', [
                {
                    status: 'disconnected'
                }
            ]);
        }
        // Every closed connection counts as an unsuccessful attempt. The counter is reset once a
        // connection synced successfully (see the `synced` setter). Hence a server that accepts the
        // connection and then closes it is backed off just like a server that refuses it.
        provider.wsUnsuccessfulReconnects++;
        /**
     * @type {{ code: number, reason: string } | null}
     */ let terminalClose = null;
        if (event != null && !provider.shouldReconnect(event, provider)) {
            // The server signaled that reconnecting is pointless. We go through the existing
            // `shouldConnect` mechanism, so that the `setupWS` scheduled below turns into a no-op,
            // while a deliberate `provider.connect()` can still resume the connection.
            provider.shouldConnect = false;
            terminalClose = {
                code: event.code,
                reason: event.reason
            };
        }
        // Increase the timeout using exponential backoff, starting with 200ms
        setTimeout($9f5c915f0579f3cf$var$setupWS, $3Lr38.min($3Lr38.pow(2, provider.wsUnsuccessfulReconnects) * 100, provider.maxBackoffTime), provider);
        // emitted last, so that a `closed` handler may call `provider.connect()` synchronously
        if (terminalClose !== null) provider.emit('closed', [
            terminalClose,
            provider
        ]);
    }
};
/**
 * @param {WebsocketProvider} provider
 */ const $9f5c915f0579f3cf$var$setupWS = (provider)=>{
    if (provider.shouldConnect && provider.ws === null) {
        const websocket = new provider._WS(provider.url, provider.protocols);
        websocket.binaryType = 'arraybuffer';
        provider.ws = websocket;
        provider.wsconnecting = true;
        provider.wsconnected = false;
        provider.synced = false;
        websocket.onmessage = (event)=>{
            if (provider.ws !== websocket) return;
            provider.wsLastMessageReceived = $g2kVL.getUnixTime();
            const encoder = $9f5c915f0579f3cf$var$readMessage(provider, new Uint8Array(event.data), true);
            if ($xchLN.length(encoder) > 1) websocket.send($xchLN.toUint8Array(encoder));
        };
        websocket.onerror = (event)=>{
            if (provider.ws !== websocket) return;
            provider.emit('connection-error', [
                event,
                provider
            ]);
        };
        websocket.onclose = (event)=>{
            $9f5c915f0579f3cf$var$closeWebsocketConnection(provider, websocket, event);
        };
        websocket.onopen = ()=>{
            if (provider.ws !== websocket) return;
            provider.wsLastMessageReceived = $g2kVL.getUnixTime();
            provider.wsconnecting = false;
            provider.wsconnected = true;
            provider.emit('status', [
                {
                    status: 'connected'
                }
            ]);
            // always send sync step 1 when connected
            const encoder = $xchLN.createEncoder();
            $xchLN.writeVarUint(encoder, $9f5c915f0579f3cf$export$70790f6f28b13205);
            $1UONF.writeSyncStep1(encoder, provider.doc);
            websocket.send($xchLN.toUint8Array(encoder));
            // broadcast local awareness state
            if (provider.awareness.getLocalState() !== null) {
                const encoderAwarenessState = $xchLN.createEncoder();
                $xchLN.writeVarUint(encoderAwarenessState, $9f5c915f0579f3cf$export$790bca08a5d3ef2c);
                $xchLN.writeVarUint8Array(encoderAwarenessState, $23ZAc.encodeAwarenessUpdate(provider.awareness, [
                    provider.doc.clientID
                ]));
                websocket.send($xchLN.toUint8Array(encoderAwarenessState));
            }
        };
        provider.emit('status', [
            {
                status: 'connecting'
            }
        ]);
    }
};
/**
 * @param {WebsocketProvider} provider
 * @param {ArrayBuffer} buf
 */ const $9f5c915f0579f3cf$var$broadcastMessage = (provider, buf)=>{
    const ws = provider.ws;
    if (provider.wsconnected && ws && ws.readyState === ws.OPEN) ws.send(buf);
    if (provider.bcconnected) $jshSA.publish(provider.bcChannel, buf, provider);
};
class $9f5c915f0579f3cf$export$c0e03644998998fb extends (0, $1UXIn.ObservableV2) {
    /**
   * @param {string} serverUrl
   * @param {string} roomname
   * @param {Y.Doc} doc
   * @param {object} opts
   * @param {boolean} [opts.connect]
   * @param {awarenessProtocol.Awareness} [opts.awareness]
   * @param {Object<string,string>} [opts.params] specify url parameters
   * @param {Array<string>} [opts.protocols] specify websocket protocols
   * @param {typeof WebSocket} [opts.WebSocketPolyfill] Optionall provide a WebSocket polyfill
   * @param {number} [opts.resyncInterval] Request server state every `resyncInterval` milliseconds
   * @param {number} [opts.maxBackoffTime] Maximum amount of time to wait before trying to reconnect (we try to reconnect using exponential backoff)
   * @param {boolean} [opts.disableBc] Disable cross-tab BroadcastChannel communication
   * @param {(event: CloseEvent, provider: WebsocketProvider) => boolean} [opts.shouldReconnect] Decide whether to reconnect after the server closed the connection. By default, close codes in the 4400-4499 range are permanent - we stop reconnecting and emit a `closed` event. This is never called for connections that were closed locally (e.g. via `provider.disconnect()`).
   */ constructor(serverUrl, roomname, doc, { connect: connect = true, awareness: awareness = new $23ZAc.Awareness(doc), params: params = {}, protocols: protocols = [], WebSocketPolyfill: WebSocketPolyfill = WebSocket, resyncInterval: resyncInterval = -1, maxBackoffTime: maxBackoffTime = 2500, disableBc: disableBc = false, shouldReconnect: shouldReconnect = $9f5c915f0579f3cf$var$defaultShouldReconnect } = {}){
        super();
        // ensure that serverUrl does not end with /
        while(serverUrl[serverUrl.length - 1] === '/')serverUrl = serverUrl.slice(0, serverUrl.length - 1);
        this.serverUrl = serverUrl;
        this.bcChannel = serverUrl + '/' + roomname;
        this.maxBackoffTime = maxBackoffTime;
        /**
     * Decides whether to reconnect after the server closed the connection. This can be safely
     * updated. The new predicate is used for the next close event.
     * @type {(event: CloseEvent, provider: WebsocketProvider) => boolean}
     */ this.shouldReconnect = shouldReconnect;
        /**
     * The specified url parameters. This can be safely updated. The changed parameters will be used
     * when a new connection is established.
     * @type {Object<string,string>}
     */ this.params = params;
        this.protocols = protocols;
        this.roomname = roomname;
        this.doc = doc;
        this._WS = WebSocketPolyfill;
        this.awareness = awareness;
        this.wsconnected = false;
        this.wsconnecting = false;
        this.bcconnected = false;
        this.disableBc = disableBc;
        this.wsUnsuccessfulReconnects = 0;
        this.messageHandlers = $9f5c915f0579f3cf$var$messageHandlers.slice();
        /**
     * @type {boolean}
     */ this._synced = false;
        /**
     * @type {WebSocket?}
     */ this.ws = null;
        this.wsLastMessageReceived = 0;
        /**
     * Whether to connect to other peers or not
     * @type {boolean}
     */ this.shouldConnect = connect;
        /**
     * @type {number}
     */ this._resyncInterval = 0;
        if (resyncInterval > 0) this._resyncInterval = /** @type {any} */ setInterval(()=>{
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                // resend sync step 1
                const encoder = $xchLN.createEncoder();
                $xchLN.writeVarUint(encoder, $9f5c915f0579f3cf$export$70790f6f28b13205);
                $1UONF.writeSyncStep1(encoder, doc);
                this.ws.send($xchLN.toUint8Array(encoder));
            }
        }, resyncInterval);
        /**
     * @param {ArrayBuffer} data
     * @param {any} origin
     */ this._bcSubscriber = (data, origin)=>{
            if (origin !== this) {
                const encoder = $9f5c915f0579f3cf$var$readMessage(this, new Uint8Array(data), false);
                if ($xchLN.length(encoder) > 1) $jshSA.publish(this.bcChannel, $xchLN.toUint8Array(encoder), this);
            }
        };
        /**
     * Listens to Yjs updates and sends them to remote peers (ws and broadcastchannel)
     * @param {Uint8Array} update
     * @param {any} origin
     */ this._updateHandler = (update, origin)=>{
            if (origin !== this) {
                const encoder = $xchLN.createEncoder();
                $xchLN.writeVarUint(encoder, $9f5c915f0579f3cf$export$70790f6f28b13205);
                $1UONF.writeUpdate(encoder, update);
                $9f5c915f0579f3cf$var$broadcastMessage(this, $xchLN.toUint8Array(encoder));
            }
        };
        this.doc.on('update', this._updateHandler);
        /**
     * @param {any} changed
     * @param {any} _origin
     */ this._awarenessUpdateHandler = ({ added: added, updated: updated, removed: removed }, _origin)=>{
            const changedClients = added.concat(updated).concat(removed);
            const encoder = $xchLN.createEncoder();
            $xchLN.writeVarUint(encoder, $9f5c915f0579f3cf$export$790bca08a5d3ef2c);
            $xchLN.writeVarUint8Array(encoder, $23ZAc.encodeAwarenessUpdate(awareness, changedClients));
            $9f5c915f0579f3cf$var$broadcastMessage(this, $xchLN.toUint8Array(encoder));
        };
        this._exitHandler = ()=>{
            $23ZAc.removeAwarenessStates(this.awareness, [
                doc.clientID
            ], 'app closed');
        };
        $44IZO.isNode;
        awareness.on('update', this._awarenessUpdateHandler);
        this._checkInterval = /** @type {any} */ setInterval(()=>{
            if (this.wsconnected && $9f5c915f0579f3cf$var$messageReconnectTimeout < $g2kVL.getUnixTime() - this.wsLastMessageReceived) // no message received in a long time - not even your own awareness
            // updates (which are updated every 15 seconds)
            $9f5c915f0579f3cf$var$closeWebsocketConnection(this, /** @type {WebSocket} */ this.ws, null);
        }, $9f5c915f0579f3cf$var$messageReconnectTimeout / 10);
        if (connect) this.connect();
    }
    get url() {
        const encodedParams = $6zOa3.encodeQueryParams(this.params);
        return this.serverUrl + '/' + this.roomname + (encodedParams.length === 0 ? '' : '?' + encodedParams);
    }
    /**
   * @type {boolean}
   */ get synced() {
        return this._synced;
    }
    set synced(state) {
        if (this._synced !== state) {
            this._synced = state;
            if (state) // a connection that synced did useful work - reset the reconnect backoff
            this.wsUnsuccessfulReconnects = 0;
            // @ts-ignore
            this.emit('synced', [
                state
            ]);
            this.emit('sync', [
                state
            ]);
        }
    }
    destroy() {
        if (this._resyncInterval !== 0) clearInterval(this._resyncInterval);
        clearInterval(this._checkInterval);
        this.disconnect();
        $44IZO.isNode;
        this.awareness.off('update', this._awarenessUpdateHandler);
        this.doc.off('update', this._updateHandler);
        super.destroy();
    }
    connectBc() {
        if (this.disableBc) return;
        if (!this.bcconnected) {
            $jshSA.subscribe(this.bcChannel, this._bcSubscriber);
            this.bcconnected = true;
        }
        // send sync step1 to bc
        // write sync step 1
        const encoderSync = $xchLN.createEncoder();
        $xchLN.writeVarUint(encoderSync, $9f5c915f0579f3cf$export$70790f6f28b13205);
        $1UONF.writeSyncStep1(encoderSync, this.doc);
        $jshSA.publish(this.bcChannel, $xchLN.toUint8Array(encoderSync), this);
        // broadcast local state
        const encoderState = $xchLN.createEncoder();
        $xchLN.writeVarUint(encoderState, $9f5c915f0579f3cf$export$70790f6f28b13205);
        $1UONF.writeSyncStep2(encoderState, this.doc);
        $jshSA.publish(this.bcChannel, $xchLN.toUint8Array(encoderState), this);
        // write queryAwareness
        const encoderAwarenessQuery = $xchLN.createEncoder();
        $xchLN.writeVarUint(encoderAwarenessQuery, $9f5c915f0579f3cf$export$83b62f7afdd0e333);
        $jshSA.publish(this.bcChannel, $xchLN.toUint8Array(encoderAwarenessQuery), this);
        // broadcast local awareness state
        const encoderAwarenessState = $xchLN.createEncoder();
        $xchLN.writeVarUint(encoderAwarenessState, $9f5c915f0579f3cf$export$790bca08a5d3ef2c);
        $xchLN.writeVarUint8Array(encoderAwarenessState, $23ZAc.encodeAwarenessUpdate(this.awareness, [
            this.doc.clientID
        ]));
        $jshSA.publish(this.bcChannel, $xchLN.toUint8Array(encoderAwarenessState), this);
    }
    disconnectBc() {
        // broadcast message with local awareness state set to null (indicating disconnect)
        const encoder = $xchLN.createEncoder();
        $xchLN.writeVarUint(encoder, $9f5c915f0579f3cf$export$790bca08a5d3ef2c);
        $xchLN.writeVarUint8Array(encoder, $23ZAc.encodeAwarenessUpdate(this.awareness, [
            this.doc.clientID
        ], new Map()));
        $9f5c915f0579f3cf$var$broadcastMessage(this, $xchLN.toUint8Array(encoder));
        if (this.bcconnected) {
            $jshSA.unsubscribe(this.bcChannel, this._bcSubscriber);
            this.bcconnected = false;
        }
    }
    disconnect() {
        this.shouldConnect = false;
        this.disconnectBc();
        if (this.ws !== null) $9f5c915f0579f3cf$var$closeWebsocketConnection(this, this.ws, null);
    }
    connect() {
        this.shouldConnect = true;
        if (!this.wsconnected && this.ws === null) {
            $9f5c915f0579f3cf$var$setupWS(this);
            this.connectBc();
        }
    }
}

});
parcelRegister("jshSA", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $e29e8056f40f4877$export$ec068583843480e7);
$parcel$export(module.exports, "unsubscribe", () => $e29e8056f40f4877$export$f500693cef883ffd);
$parcel$export(module.exports, "publish", () => $e29e8056f40f4877$export$89b472e03be495df);
/* eslint-env browser */ /**
 * Helpers for cross-tab communication using broadcastchannel with LocalStorage fallback.
 *
 * ```js
 * // In browser window A:
 * broadcastchannel.subscribe('my events', data => console.log(data))
 * broadcastchannel.publish('my events', 'Hello world!') // => A: 'Hello world!' fires synchronously in same tab
 *
 * // In browser window B:
 * broadcastchannel.publish('my events', 'hello from tab B') // => A: 'hello from tab B'
 * ```
 *
 * @module broadcastchannel
 */ // @todo before next major: use Uint8Array instead as buffer object

var $iUvcZ = parcelRequire("iUvcZ");

var $ivn6P = parcelRequire("ivn6P");

var $0Sial = parcelRequire("0Sial");

var $2eeaT = parcelRequire("2eeaT");
/**
 * @typedef {Object} Channel
 * @property {Set<function(any, any):any>} Channel.subs
 * @property {any} Channel.bc
 */ /**
 * @type {Map<string, Channel>}
 */ const $e29e8056f40f4877$var$channels = new Map();
/* c8 ignore start */ class $e29e8056f40f4877$var$LocalStoragePolyfill {
    /**
   * @param {string} room
   */ constructor(room){
        this.room = room;
        /**
     * @type {null|function({data:Uint8Array}):void}
     */ this.onmessage = null;
        /**
     * @param {any} e
     */ this._onChange = (e)=>e.key === room && this.onmessage !== null && this.onmessage({
                data: $0Sial.fromBase64(e.newValue || '')
            });
        $2eeaT.onChange(this._onChange);
    }
    /**
   * @param {ArrayBuffer} buf
   */ postMessage(buf) {
        $2eeaT.varStorage.setItem(this.room, $0Sial.toBase64($0Sial.createUint8ArrayFromArrayBuffer(buf)));
    }
    close() {
        $2eeaT.offChange(this._onChange);
    }
}
/* c8 ignore stop */ // Use BroadcastChannel or Polyfill
/* c8 ignore next */ const $e29e8056f40f4877$var$BC = typeof BroadcastChannel === 'undefined' ? $e29e8056f40f4877$var$LocalStoragePolyfill : BroadcastChannel;
/**
 * @param {string} room
 * @return {Channel}
 */ const $e29e8056f40f4877$var$getChannel = (room)=>$iUvcZ.setIfUndefined($e29e8056f40f4877$var$channels, room, ()=>{
        const subs = $ivn6P.create();
        const bc = new $e29e8056f40f4877$var$BC(room);
        /**
     * @param {{data:ArrayBuffer}} e
     */ /* c8 ignore next */ bc.onmessage = (e)=>subs.forEach((sub)=>sub(e.data, 'broadcastchannel'));
        return {
            bc: bc,
            subs: subs
        };
    });
const $e29e8056f40f4877$export$ec068583843480e7 = (room, f)=>{
    $e29e8056f40f4877$var$getChannel(room).subs.add(f);
    return f;
};
const $e29e8056f40f4877$export$f500693cef883ffd = (room, f)=>{
    const channel = $e29e8056f40f4877$var$getChannel(room);
    const unsubscribed = channel.subs.delete(f);
    if (unsubscribed && channel.subs.size === 0) {
        channel.bc.close();
        $e29e8056f40f4877$var$channels.delete(room);
    }
    return unsubscribed;
};
const $e29e8056f40f4877$export$89b472e03be495df = (room, data, origin = null)=>{
    const c = $e29e8056f40f4877$var$getChannel(room);
    c.bc.postMessage(data);
    c.subs.forEach((sub)=>sub(data, origin));
};

});

parcelRegister("1UONF", function(module, exports) {

$parcel$export(module.exports, "messageYjsSyncStep2", () => $16526d435366152f$export$ff102031071a8f85);
$parcel$export(module.exports, "writeSyncStep1", () => $16526d435366152f$export$2a4abf6cf2c7e66f);
$parcel$export(module.exports, "writeSyncStep2", () => $16526d435366152f$export$b2b01faa10f64871);
$parcel$export(module.exports, "writeUpdate", () => $16526d435366152f$export$72c173541034b28e);
$parcel$export(module.exports, "readSyncMessage", () => $16526d435366152f$export$26b589e63b591e96);
/**
 * @module sync-protocol
 */ 
var $xchLN = parcelRequire("xchLN");

var $dB3PR = parcelRequire("dB3PR");

var $eokS8 = parcelRequire("eokS8");
const $16526d435366152f$export$edbc8479a3fd0d51 = 0;
const $16526d435366152f$export$ff102031071a8f85 = 1;
const $16526d435366152f$export$f589a35bfce33e17 = 2;
const $16526d435366152f$export$2a4abf6cf2c7e66f = (encoder, doc)=>{
    $xchLN.writeVarUint(encoder, $16526d435366152f$export$edbc8479a3fd0d51);
    const sv = $eokS8.encodeStateVector(doc);
    $xchLN.writeVarUint8Array(encoder, sv);
};
const $16526d435366152f$export$b2b01faa10f64871 = (encoder, doc, encodedStateVector)=>{
    $xchLN.writeVarUint(encoder, $16526d435366152f$export$ff102031071a8f85);
    $xchLN.writeVarUint8Array(encoder, $eokS8.encodeStateAsUpdate(doc, encodedStateVector));
};
const $16526d435366152f$export$24e7fa74cb33e063 = (decoder, encoder, doc)=>$16526d435366152f$export$b2b01faa10f64871(encoder, doc, $dB3PR.readVarUint8Array(decoder));
const $16526d435366152f$export$60818ebea09048c1 = (decoder, doc, transactionOrigin, errorHandler)=>{
    try {
        $eokS8.applyUpdate(doc, $dB3PR.readVarUint8Array(decoder), transactionOrigin);
    } catch (error) {
        if (errorHandler != null) errorHandler(/** @type {Error} */ error);
        // This catches errors that are thrown by event handlers
        console.error('Caught error while handling a Yjs update', error);
    }
};
const $16526d435366152f$export$72c173541034b28e = (encoder, update)=>{
    $xchLN.writeVarUint(encoder, $16526d435366152f$export$f589a35bfce33e17);
    $xchLN.writeVarUint8Array(encoder, update);
};
const $16526d435366152f$export$d67ac8d73b7d336c = $16526d435366152f$export$60818ebea09048c1;
const $16526d435366152f$export$26b589e63b591e96 = (decoder, encoder, doc, transactionOrigin, errorHandler)=>{
    const messageType = $dB3PR.readVarUint(decoder);
    switch(messageType){
        case $16526d435366152f$export$edbc8479a3fd0d51:
            $16526d435366152f$export$24e7fa74cb33e063(decoder, encoder, doc);
            break;
        case $16526d435366152f$export$ff102031071a8f85:
            $16526d435366152f$export$60818ebea09048c1(decoder, doc, transactionOrigin, errorHandler);
            break;
        case $16526d435366152f$export$f589a35bfce33e17:
            $16526d435366152f$export$d67ac8d73b7d336c(decoder, doc, transactionOrigin, errorHandler);
            break;
        default:
            throw new Error('Unknown message type');
    }
    return messageType;
};

});

parcelRegister("eMsL6", function(module, exports) {

$parcel$export(module.exports, "readAuthMessage", () => $ac2bdb3fcc7224c9$export$7e13d1a8c99eb68e);


var $xchLN = parcelRequire("xchLN");

var $dB3PR = parcelRequire("dB3PR");
const $ac2bdb3fcc7224c9$export$cfc218bc4e82266b = 0;
const $ac2bdb3fcc7224c9$export$492291cd287a058f = (encoder, reason)=>{
    $xchLN.writeVarUint(encoder, $ac2bdb3fcc7224c9$export$cfc218bc4e82266b);
    $xchLN.writeVarString(encoder, reason);
};
const $ac2bdb3fcc7224c9$export$7e13d1a8c99eb68e = (decoder, y, permissionDeniedHandler)=>{
    switch($dB3PR.readVarUint(decoder)){
        case $ac2bdb3fcc7224c9$export$cfc218bc4e82266b:
            permissionDeniedHandler(y, $dB3PR.readVarString(decoder));
    }
};

});

parcelRegister("23ZAc", function(module, exports) {

$parcel$export(module.exports, "Awareness", () => $180ba1ad8c2c791e$export$5bb40478b91fee65);
$parcel$export(module.exports, "removeAwarenessStates", () => $180ba1ad8c2c791e$export$3edbfe2f45ae9ff8);
$parcel$export(module.exports, "encodeAwarenessUpdate", () => $180ba1ad8c2c791e$export$e194fa93ebd743e9);
$parcel$export(module.exports, "applyAwarenessUpdate", () => $180ba1ad8c2c791e$export$2f92845406d72d1a);
/**
 * @module awareness-protocol
 */ 
var $xchLN = parcelRequire("xchLN");

var $dB3PR = parcelRequire("dB3PR");

var $g2kVL = parcelRequire("g2kVL");

var $3Lr38 = parcelRequire("3Lr38");

var $1UXIn = parcelRequire("1UXIn");

var $5Ci8T = parcelRequire("5Ci8T");

const $180ba1ad8c2c791e$export$47b58b45939fff5e = 30000;
class $180ba1ad8c2c791e$export$5bb40478b91fee65 extends (0, $1UXIn.Observable) {
    /**
   * @param {Y.Doc} doc
   */ constructor(doc){
        super();
        this.doc = doc;
        /**
     * @type {number}
     */ this.clientID = doc.clientID;
        /**
     * Maps from client id to client state
     * @type {Map<number, Object<string, any>>}
     */ this.states = new Map();
        /**
     * @type {Map<number, MetaClientState>}
     */ this.meta = new Map();
        this._checkInterval = /** @type {any} */ setInterval(()=>{
            const now = $g2kVL.getUnixTime();
            if (this.getLocalState() !== null && $180ba1ad8c2c791e$export$47b58b45939fff5e / 2 <= now - /** @type {{lastUpdated:number}} */ this.meta.get(this.clientID).lastUpdated) // renew local clock
            this.setLocalState(this.getLocalState());
            /**
       * @type {Array<number>}
       */ const remove = [];
            this.meta.forEach((meta, clientid)=>{
                if (clientid !== this.clientID && $180ba1ad8c2c791e$export$47b58b45939fff5e <= now - meta.lastUpdated && this.states.has(clientid)) remove.push(clientid);
            });
            if (remove.length > 0) $180ba1ad8c2c791e$export$3edbfe2f45ae9ff8(this, remove, 'timeout');
        }, $3Lr38.floor($180ba1ad8c2c791e$export$47b58b45939fff5e / 10));
        doc.on('destroy', ()=>{
            this.destroy();
        });
        this.setLocalState({});
    }
    destroy() {
        this.emit('destroy', [
            this
        ]);
        this.setLocalState(null);
        super.destroy();
        clearInterval(this._checkInterval);
    }
    /**
   * @return {Object<string,any>|null}
   */ getLocalState() {
        return this.states.get(this.clientID) || null;
    }
    /**
   * @param {Object<string,any>|null} state
   */ setLocalState(state) {
        const clientID = this.clientID;
        const currLocalMeta = this.meta.get(clientID);
        const clock = currLocalMeta === undefined ? 0 : currLocalMeta.clock + 1;
        const prevState = this.states.get(clientID);
        if (state === null) this.states.delete(clientID);
        else this.states.set(clientID, state);
        this.meta.set(clientID, {
            clock: clock,
            lastUpdated: $g2kVL.getUnixTime()
        });
        const added = [];
        const updated = [];
        const filteredUpdated = [];
        const removed = [];
        if (state === null) removed.push(clientID);
        else if (prevState == null) {
            if (state != null) added.push(clientID);
        } else {
            updated.push(clientID);
            if (!$5Ci8T.equalityDeep(prevState, state)) filteredUpdated.push(clientID);
        }
        if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) this.emit('change', [
            {
                added: added,
                updated: filteredUpdated,
                removed: removed
            },
            'local'
        ]);
        this.emit('update', [
            {
                added: added,
                updated: updated,
                removed: removed
            },
            'local'
        ]);
    }
    /**
   * @param {string} field
   * @param {any} value
   */ setLocalStateField(field, value) {
        const state = this.getLocalState();
        if (state !== null) this.setLocalState({
            ...state,
            [field]: value
        });
    }
    /**
   * @return {Map<number,Object<string,any>>}
   */ getStates() {
        return this.states;
    }
}
const $180ba1ad8c2c791e$export$3edbfe2f45ae9ff8 = (awareness, clients, origin)=>{
    const removed = [];
    for(let i = 0; i < clients.length; i++){
        const clientID = clients[i];
        if (awareness.states.has(clientID)) {
            awareness.states.delete(clientID);
            if (clientID === awareness.clientID) {
                const curMeta = /** @type {MetaClientState} */ awareness.meta.get(clientID);
                awareness.meta.set(clientID, {
                    clock: curMeta.clock + 1,
                    lastUpdated: $g2kVL.getUnixTime()
                });
            }
            removed.push(clientID);
        }
    }
    if (removed.length > 0) {
        awareness.emit('change', [
            {
                added: [],
                updated: [],
                removed: removed
            },
            origin
        ]);
        awareness.emit('update', [
            {
                added: [],
                updated: [],
                removed: removed
            },
            origin
        ]);
    }
};
const $180ba1ad8c2c791e$export$e194fa93ebd743e9 = (awareness, clients, states = awareness.states)=>{
    const len = clients.length;
    const encoder = $xchLN.createEncoder();
    $xchLN.writeVarUint(encoder, len);
    for(let i = 0; i < len; i++){
        const clientID = clients[i];
        const state = states.get(clientID) || null;
        const clock = /** @type {MetaClientState} */ awareness.meta.get(clientID).clock;
        $xchLN.writeVarUint(encoder, clientID);
        $xchLN.writeVarUint(encoder, clock);
        $xchLN.writeVarString(encoder, JSON.stringify(state));
    }
    return $xchLN.toUint8Array(encoder);
};
const $180ba1ad8c2c791e$export$17dfc8fb4d274726 = (update, modify)=>{
    const decoder = $dB3PR.createDecoder(update);
    const encoder = $xchLN.createEncoder();
    const len = $dB3PR.readVarUint(decoder);
    $xchLN.writeVarUint(encoder, len);
    for(let i = 0; i < len; i++){
        const clientID = $dB3PR.readVarUint(decoder);
        const clock = $dB3PR.readVarUint(decoder);
        const state = JSON.parse($dB3PR.readVarString(decoder));
        const modifiedState = modify(state);
        $xchLN.writeVarUint(encoder, clientID);
        $xchLN.writeVarUint(encoder, clock);
        $xchLN.writeVarString(encoder, JSON.stringify(modifiedState));
    }
    return $xchLN.toUint8Array(encoder);
};
const $180ba1ad8c2c791e$export$2f92845406d72d1a = (awareness, update, origin)=>{
    const decoder = $dB3PR.createDecoder(update);
    const timestamp = $g2kVL.getUnixTime();
    const added = [];
    const updated = [];
    const filteredUpdated = [];
    const removed = [];
    const len = $dB3PR.readVarUint(decoder);
    for(let i = 0; i < len; i++){
        const clientID = $dB3PR.readVarUint(decoder);
        let clock = $dB3PR.readVarUint(decoder);
        const state = JSON.parse($dB3PR.readVarString(decoder));
        const clientMeta = awareness.meta.get(clientID);
        const prevState = awareness.states.get(clientID);
        const currClock = clientMeta === undefined ? 0 : clientMeta.clock;
        if (currClock < clock || currClock === clock && state === null && awareness.states.has(clientID)) {
            if (state === null) {
                // never let a remote client remove this local state
                if (clientID === awareness.clientID && awareness.getLocalState() != null) // remote client removed the local state. Do not remote state. Broadcast a message indicating
                // that this client still exists by increasing the clock
                clock++;
                else awareness.states.delete(clientID);
            } else awareness.states.set(clientID, state);
            awareness.meta.set(clientID, {
                clock: clock,
                lastUpdated: timestamp
            });
            if (clientMeta === undefined && state !== null) added.push(clientID);
            else if (clientMeta !== undefined && state === null) removed.push(clientID);
            else if (state !== null) {
                if (!$5Ci8T.equalityDeep(state, prevState)) filteredUpdated.push(clientID);
                updated.push(clientID);
            }
        }
    }
    if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) awareness.emit('change', [
        {
            added: added,
            updated: filteredUpdated,
            removed: removed
        },
        origin
    ]);
    if (added.length > 0 || updated.length > 0 || removed.length > 0) awareness.emit('update', [
        {
            added: added,
            updated: updated,
            removed: removed
        },
        origin
    ]);
};

});

parcelRegister("6zOa3", function(module, exports) {

$parcel$export(module.exports, "encodeQueryParams", () => $4c9cebf0607497ea$export$8c0ce924e434923b);
/**
 * Utility module to work with urls.
 *
 * @module url
 */ 
var $kqHhc = parcelRequire("kqHhc");
const $4c9cebf0607497ea$export$6025d61c37f75253 = (url)=>{
    /**
   * @type {Object<string,string>}
   */ const query = {};
    const urlQuerySplit = url.split('?');
    const pairs = urlQuerySplit[urlQuerySplit.length - 1].split('&');
    for(let i = 0; i < pairs.length; i++){
        const item = pairs[i];
        if (item.length > 0) {
            const pair = item.split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
    }
    return query;
};
const $4c9cebf0607497ea$export$8c0ce924e434923b = (params)=>$kqHhc.map(params, (val, key)=>`${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');

});


parcelRegister("7hmfH", function(module, exports) {

$parcel$export(module.exports, "listen", () => $54cb61c1e4eebfbc$export$63174c828edd6ff8);
$parcel$export(module.exports, "elem", () => $54cb61c1e4eebfbc$export$5bf96401662340b7);
$parcel$export(module.exports, "getScaleFreeNetwork", () => $54cb61c1e4eebfbc$export$6bf6edce410823e2);
$parcel$export(module.exports, "uuidv4", () => $54cb61c1e4eebfbc$export$abe4376e1bf796d6);
$parcel$export(module.exports, "isEmpty", () => $54cb61c1e4eebfbc$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "deepMerge", () => $54cb61c1e4eebfbc$export$6969335ea1e4e77c);
$parcel$export(module.exports, "deepCopy", () => $54cb61c1e4eebfbc$export$6c40052bed430212);
$parcel$export(module.exports, "objectEquals", () => $54cb61c1e4eebfbc$export$5b4d20f570fee173);
$parcel$export(module.exports, "clean", () => $54cb61c1e4eebfbc$export$cf0b2a6c63f9e656);
$parcel$export(module.exports, "strip", () => $54cb61c1e4eebfbc$export$6a0f863afc2134d8);
$parcel$export(module.exports, "splitText", () => $54cb61c1e4eebfbc$export$2878cc467c8be8fe);
$parcel$export(module.exports, "mostFrequentString", () => $54cb61c1e4eebfbc$export$259847a30265f1bf);
$parcel$export(module.exports, "factorSizeToPercent", () => $54cb61c1e4eebfbc$export$ac4113339a72565f);
$parcel$export(module.exports, "setFactorSizeFromPercent", () => $54cb61c1e4eebfbc$export$a0bb1be471bb15e6);
$parcel$export(module.exports, "getDashes", () => $54cb61c1e4eebfbc$export$530c09b40c9ab953);
$parcel$export(module.exports, "convertDashes", () => $54cb61c1e4eebfbc$export$adbf3e12eca5d8b);
$parcel$export(module.exports, "dragElement", () => $54cb61c1e4eebfbc$export$69374dc2b307e4);
$parcel$export(module.exports, "addContextMenu", () => $54cb61c1e4eebfbc$export$598e091c8246c6cb);
$parcel$export(module.exports, "rgbIsLight", () => $54cb61c1e4eebfbc$export$85b2291ebd5476b5);
$parcel$export(module.exports, "getCSSVariable", () => $54cb61c1e4eebfbc$export$11f9234565cca346);
$parcel$export(module.exports, "generateName", () => $54cb61c1e4eebfbc$export$5d832d6580b26c5);
$parcel$export(module.exports, "statusMsg", () => $54cb61c1e4eebfbc$export$3cb6beff6f79e98b);
$parcel$export(module.exports, "alertMsg", () => $54cb61c1e4eebfbc$export$9968692a49529c1);
$parcel$export(module.exports, "cancelAlertMsg", () => $54cb61c1e4eebfbc$export$3f0900b8af1937e2);
$parcel$export(module.exports, "clearStatusBar", () => $54cb61c1e4eebfbc$export$62fd92124955fcd2);
$parcel$export(module.exports, "shorten", () => $54cb61c1e4eebfbc$export$dd78866213f805a5);
$parcel$export(module.exports, "initials", () => $54cb61c1e4eebfbc$export$82a129a7016c8ea8);
$parcel$export(module.exports, "getTextWidth", () => $54cb61c1e4eebfbc$export$37827d046293d309);
$parcel$export(module.exports, "setNodeHidden", () => $54cb61c1e4eebfbc$export$607b01733b83ff83);
$parcel$export(module.exports, "hexToRgba", () => $54cb61c1e4eebfbc$export$9665a07d9187b414);
$parcel$export(module.exports, "setEdgeHidden", () => $54cb61c1e4eebfbc$export$d2556b5c60092110);
$parcel$export(module.exports, "standardizeColor", () => $54cb61c1e4eebfbc$export$7f57f51729968d3b);
$parcel$export(module.exports, "rgbToArray", () => $54cb61c1e4eebfbc$export$1777c9ba3e6d9ae0);
$parcel$export(module.exports, "makeColor", () => $54cb61c1e4eebfbc$export$b09d2a0246869f74);
$parcel$export(module.exports, "CP", () => $54cb61c1e4eebfbc$export$6d0b2a5dd774590a);
$parcel$export(module.exports, "timeAndDate", () => $54cb61c1e4eebfbc$export$b3902f047e75d149);
$parcel$export(module.exports, "setEndOfContenteditable", () => $54cb61c1e4eebfbc$export$8bc063faa2ba2bd3);
$parcel$export(module.exports, "exactTime", () => $54cb61c1e4eebfbc$export$cdee113d0db2579a);
$parcel$export(module.exports, "capitalizeFirstLetter", () => $54cb61c1e4eebfbc$export$d07f57595c356899);
$parcel$export(module.exports, "lowerFirstLetter", () => $54cb61c1e4eebfbc$export$81b06ab76a3757ce);
$parcel$export(module.exports, "humanSize", () => $54cb61c1e4eebfbc$export$89dc6f1d08c41ada);
$parcel$export(module.exports, "isQuillEmpty", () => $54cb61c1e4eebfbc$export$99f0341e4542bf23);
$parcel$export(module.exports, "stripNL", () => $54cb61c1e4eebfbc$export$e6b553c28e5248fd);
$parcel$export(module.exports, "encodeHTMLEntities", () => $54cb61c1e4eebfbc$export$9adb60ba67eebe15);
$parcel$export(module.exports, "displayHelp", () => $54cb61c1e4eebfbc$export$9f711266042c4a52);
/*********************************************************************************************************************  

PRSM Participatory System Mapper 

	Copyright (C) 2022  Nigel Gilbert prsm@prsm.uk

This software is licenced under the PolyForm Noncommercial License 1.0.0

<https://polyformproject.org/licenses/noncommercial/1.0.0>

See the file LICENSE.md for details.

This module provides a set of utility functions used widely within the PRSM code.  
**********************************************************************************************************************/ 
var $eUXNC = parcelRequire("eUXNC");
const $54cb61c1e4eebfbc$var$MANUALURL = './doc/help/doc_build/manual/Introduction.html';
function $54cb61c1e4eebfbc$export$63174c828edd6ff8(id, event, callback, options) {
    $54cb61c1e4eebfbc$export$5bf96401662340b7(id).addEventListener(event, callback, options);
}
function $54cb61c1e4eebfbc$export$5bf96401662340b7(id) {
    return document.getElementById(id);
}
function $54cb61c1e4eebfbc$export$c81866d3953e7921(array, item) {
    if (array) {
        if (!array.includes(item)) array.push(item);
    } else array = [
        item
    ];
    return array;
}
function $54cb61c1e4eebfbc$export$6bf6edce410823e2(nodeCount) {
    const nodes = [];
    const edges = [];
    const connectionCount = [];
    // randomly create some nodes and edges
    for(let i = 0; i < nodeCount; i++){
        nodes.push({
            id: String(i),
            label: String(i),
            grp: 'group0',
            value: 1
        });
        connectionCount[i] = 0;
        // create edges in a scale-free-network way
        if (i === 1) {
            const from = i;
            const to = 0;
            edges.push({
                from: from.toString(),
                to: to.toString(),
                grp: 'edge0'
            });
            connectionCount[from]++;
            connectionCount[to]++;
        } else if (i > 1) {
            const conn = edges.length * 2;
            const rand = Math.floor($54cb61c1e4eebfbc$var$seededRandom() * conn);
            let cum = 0;
            let j = 0;
            while(j < connectionCount.length && cum < rand){
                cum += connectionCount[j];
                j++;
            }
            const from = i;
            const to = j;
            edges.push({
                from: from.toString(),
                to: to.toString(),
                grp: 'edge0'
            });
            connectionCount[from]++;
            connectionCount[to]++;
        }
    }
    return {
        nodes: nodes,
        edges: edges
    };
}
let $54cb61c1e4eebfbc$var$randomSeed = 764 // Math.round(Math.random()*1000)
;
/**
 * Generate a seeded random number
 * @returns {number} a random number between 0 and 1                                           ...
 */ function $54cb61c1e4eebfbc$var$seededRandom() {
    const x = Math.sin($54cb61c1e4eebfbc$var$randomSeed++) * 10000;
    return x - Math.floor(x);
}
function $54cb61c1e4eebfbc$export$abe4376e1bf796d6() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}
function $54cb61c1e4eebfbc$export$dd1bc94b04021eeb(obj) {
    for(const p in obj){
        if (Object.prototype.hasOwnProperty.call(obj, p)) return false;
    }
    return true;
}
function $54cb61c1e4eebfbc$export$6969335ea1e4e77c() {
    // Setup merged object
    const newObj = {};
    // Merge the object into the newObj object
    function merge(obj) {
        for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            // If property is an object, merge properties
            if (Object.prototype.toString.call(obj[prop]) === '[object Object]') newObj[prop] = $54cb61c1e4eebfbc$export$6969335ea1e4e77c(newObj[prop], obj[prop]);
            else newObj[prop] = obj[prop];
        }
    }
    // Loop through each object and conduct a merge
    for(let i = 0; i < arguments.length; i++)merge(arguments[i]);
    return newObj;
}
function $54cb61c1e4eebfbc$export$6c40052bed430212(obj) {
    /* 	if (typeof obj !== 'object' || obj === null) {
		return obj
	}
	if (obj instanceof Array) {
		return obj.reduce((arr, item, i) => {
			arr[i] = deepCopy(item)
			return arr
		}, [])
	}
	if (obj instanceof Object) {
		return Object.keys(obj).reduce((newObj, key) => {
			newObj[key] = deepCopy(obj[key])
			return newObj
		}, {})
	} */ return structuredClone(obj);
}
window.deepCopy = $54cb61c1e4eebfbc$export$6c40052bed430212;
function $54cb61c1e4eebfbc$export$5b4d20f570fee173(x, y) {
    if (x === y) return true;
    // if both x and y are null or undefined and exactly the same
    if (!(x instanceof Object) || !(y instanceof Object)) return false;
    // if they are not strictly equal, they both need to be Objects
    if (x.constructor !== y.constructor) return false;
    // they must have the exact same prototype chain, the closest we can do is
    // test their constructor.
    for(const p in x){
        if (!Object.prototype.hasOwnProperty.call(x, p)) continue;
        // other properties were tested using x.constructor === y.constructor
        if (!Object.prototype.hasOwnProperty.call(y, p)) return false;
        // allows to compare x[ p ] and y[ p ] when set to undefined
        if (x[p] === y[p]) continue;
        // if they have the same strict value or identity then they are equal
        if (typeof x[p] !== 'object') return false;
        // Numbers, Strings, Functions, Booleans must be strictly equal
        if (!$54cb61c1e4eebfbc$export$5b4d20f570fee173(x[p], y[p])) return false;
    // Objects and Arrays must be tested recursively
    }
    for(const p in y){
        if (Object.prototype.hasOwnProperty.call(y, p) && !Object.prototype.hasOwnProperty.call(x, p)) return false;
    }
    // allows x[ p ] to be set to undefined
    return true;
}
window.objectEquals = $54cb61c1e4eebfbc$export$5b4d20f570fee173;
function $54cb61c1e4eebfbc$export$cf0b2a6c63f9e656(source, propsToRemove) {
    const out = {};
    for(const key in source)if (!(key in propsToRemove)) out[key] = source[key];
    return out;
}
function $54cb61c1e4eebfbc$export$c39b210f955bc1b8(arr, propsToRemove) {
    return arr.map((item)=>{
        return $54cb61c1e4eebfbc$export$cf0b2a6c63f9e656(item, propsToRemove);
    });
}
function $54cb61c1e4eebfbc$export$6a0f863afc2134d8(obj, allowed) {
    return allowed.reduce((a, e)=>{
        a[e] = obj[e];
        return a;
    }, {});
}
function $54cb61c1e4eebfbc$export$50e6910b3ca580ae(arr, allowed) {
    return arr.map((item)=>$54cb61c1e4eebfbc$export$6a0f863afc2134d8(item, allowed));
}
function $54cb61c1e4eebfbc$export$2878cc467c8be8fe(txt, width = 10) {
    let lines = '';
    const chunks = txt.trim().split('\n');
    chunks.forEach((chunk)=>{
        const words = chunk.trim().split(/\s/);
        const nChars = chunk.trim().length;
        if (nChars > 2 * width) width = Math.floor(Math.sqrt(nChars));
        for(let i = 0, linelength = 0; i < words.length; i++){
            lines += words[i];
            if (i === words.length - 1) break;
            linelength += words[i].length;
            if (linelength > width) {
                lines += '\n';
                linelength = 0;
            } else lines += ' ';
        }
        lines += '\n';
    });
    return lines.trim();
}
function $54cb61c1e4eebfbc$export$b1a349b639be7674(thisSet, otherSet) {
    const intersectionSet = new Set();
    for (const el of otherSet)if (thisSet.has(el)) intersectionSet.add(el);
    return intersectionSet;
}
function $54cb61c1e4eebfbc$export$259847a30265f1bf(arr) {
    if (!arr.length) return null // handle empty array
    ;
    const counts = new Map();
    // Count occurrences
    for (const str of arr)counts.set(str, (counts.get(str) || 0) + 1);
    // Find the highest frequency
    const maxCount = Math.max(...counts.values());
    // Collect all strings with that frequency
    const mostFrequent = [
        ...counts.entries()
    ].filter(([, count])=>count === maxCount).map(([str])=>str);
    // Pick one at random if there are ties
    const randomIndex = Math.floor(Math.random() * mostFrequent.length);
    return mostFrequent[randomIndex];
}
function $54cb61c1e4eebfbc$export$ac4113339a72565f(size) {
    const fSize = (size - 20) / 2.5;
    return isNaN(fSize) || fSize < 30 ? 0 : fSize;
}
function $54cb61c1e4eebfbc$export$a0bb1be471bb15e6(node, percent) {
    if (percent < 5) {
        if (node.widthConstraint?.minimum || node.heightConstraint?.minimum) return;
        node.size = 25;
        node.heightConstraint = node.widthConstraint = false;
    } else node.heightConstraint = node.widthConstraint = node.size = percent * 2.5 + 20;
}
function $54cb61c1e4eebfbc$export$530c09b40c9ab953(bDashes, bWidth) {
    if (bWidth === 0) return 'none';
    if (bDashes === false) return 'solid';
    if (bDashes === true) return 'dashed';
    if (Array.isArray(bDashes)) {
        if (bDashes[0] === 10) return 'dashedLinks';
        return 'dots';
    }
    return null;
}
function $54cb61c1e4eebfbc$export$adbf3e12eca5d8b(val) {
    switch(val){
        case 'dashed':
            return true;
        case 'dashedLinks':
            return [
                10,
                10
            ];
        case 'solid':
            return false;
        case 'none':
            return false;
        case 'dots':
            return [
                2,
                8
            ];
        default:
            return false;
    }
}
function $54cb61c1e4eebfbc$export$69374dc2b307e4(el, header) {
    let isDragging = false;
    let startPosX = 0;
    let startPosY = 0;
    let lastPosX = 0;
    let lastPosY = 0;
    let width = 0;
    let height = 0;
    function onPointerDown(ev) {
        // Don't start dragging if clicking on interactive button elements
        const target = ev.target;
        // Check if the target or any of its ancestors (up to the header) has the interactiveButton class
        let element = target;
        while(element && element !== header){
            if (element.classList && element.classList.contains('interactiveButton')) return; // Don't start dragging
            element = element.parentElement;
        }
        // Start dragging (allow clicking on header or any of its children)
        isDragging = true;
        startPosX = ev.clientX;
        startPosY = ev.clientY;
        lastPosX = el.offsetLeft;
        lastPosY = el.offsetTop;
        width = el.offsetWidth;
        height = el.offsetHeight;
        header.setPointerCapture(ev.pointerId);
        el.style.cursor = 'move';
    }
    function onPointerMove(ev) {
        if (!isDragging) return;
        // Calculate delta from start position
        const deltaX = ev.clientX - startPosX;
        const deltaY = ev.clientY - startPosY;
        // Calculate new position with boundary constraints
        let posX = lastPosX + deltaX;
        if (posX < 0) posX = 0;
        if (posX > window.innerWidth - width) posX = window.innerWidth - width;
        let posY = lastPosY + deltaY;
        if (posY < 0) posY = 0;
        if (posY > window.innerHeight - height) posY = window.innerHeight - height;
        // Move element to new position
        el.style.left = posX + 'px';
        el.style.top = posY + 'px';
    }
    function onPointerUp(ev) {
        if (!isDragging) return;
        isDragging = false;
        el.style.cursor = 'auto';
        header.releasePointerCapture(ev.pointerId);
    }
    function onPointerCancel(ev) {
        if (!isDragging) return;
        isDragging = false;
        el.style.cursor = 'auto';
        header.releasePointerCapture(ev.pointerId);
    }
    header.addEventListener('pointerdown', onPointerDown);
    header.addEventListener('pointermove', onPointerMove);
    header.addEventListener('pointerup', onPointerUp);
    header.addEventListener('pointercancel', onPointerCancel);
}
function $54cb61c1e4eebfbc$export$598e091c8246c6cb(elem, menu) {
    const menuEl = document.createElement('div');
    menuEl.classList.add('context-menu');
    document.body.appendChild(menuEl);
    const removeMenu = ()=>{
        if (menuEl.parentNode) document.body.removeChild(menuEl);
        document.removeEventListener('click', handleClickOutside);
    };
    // Handler for clicks outside the menu
    const handleClickOutside = (event)=>{
        if (!menuEl.contains(event.target)) removeMenu();
    };
    // Handler for clicks on a menu item
    elem.addEventListener('contextmenu', (event)=>{
        event.preventDefault();
        const { clientX: mouseX, clientY: mouseY } = event;
        const posX = window.innerWidth - mouseX < menuEl.offsetWidth + 4 ? window.innerWidth - menuEl.offsetWidth - 4 : mouseX;
        const posY = window.innerHeight - mouseY < menuEl.offsetHeight + 4 ? window.innerHeight - menuEl.offsetHeight - 4 : mouseY;
        menuEl.style.top = `${posY}px`;
        menuEl.style.left = `${posX}px`;
        menuEl.classList.remove('visible');
        setTimeout(()=>{
            menuEl.classList.add('visible');
            // Attach click listener after menu becomes visible
            document.addEventListener('click', handleClickOutside);
        });
    });
    menu.forEach((item)=>{
        const { label: label, action: action } = item;
        const option = document.createElement('div');
        option.classList.add('item');
        option.innerHTML = label;
        option.addEventListener('click', ()=>{
            removeMenu();
            action();
        });
        option.addEventListener('contextmenu', (event)=>event.preventDefault());
        menuEl.appendChild(option);
    });
}
const $54cb61c1e4eebfbc$var$SEA_CREATURES = Object.freeze([
    'walrus',
    'seal',
    'fish',
    'shark',
    'clam',
    'coral',
    'whale',
    'crab',
    'lobster',
    'starfish',
    'eel',
    'dolphin',
    'squid',
    'jellyfish',
    'ray',
    'shrimp',
    'herring',
    'angler',
    'mackerel',
    'salmon',
    'urchin',
    'anemone',
    'morel',
    'axolotl',
    'blobfish',
    'tubeworm',
    'seabream',
    'seaweed',
    'anchovy',
    'cod',
    'barramundi',
    'carp',
    'crayfish',
    'haddock',
    'hake',
    'octopus',
    'plaice',
    'sardine',
    'skate',
    'sturgeon',
    'swordfish',
    'whelk'
]);
const $54cb61c1e4eebfbc$var$ADJECTIVES = Object.freeze([
    'cute',
    'adorable',
    'lovable',
    'happy',
    'sandy',
    'bubbly',
    'friendly',
    'drifting',
    'huge',
    'big',
    'small',
    'giant',
    'massive',
    'tiny',
    'nippy',
    'odd',
    'perfect',
    'rude',
    'wonderful',
    'agile',
    'beautiful',
    'bossy',
    'candid',
    'carnivorous',
    'clever',
    'cold',
    'cold-blooded',
    'colorful',
    'cuddly',
    'curious',
    'cute',
    'dangerous',
    'deadly',
    'domestic',
    'dominant',
    'energetic',
    'fast',
    'feisty',
    'ferocious',
    'fierce',
    'fluffy',
    'friendly',
    'furry',
    'fuzzy',
    'grumpy',
    'hairy',
    'heavy',
    'herbivorous',
    'jealous',
    'large',
    'lazy',
    'loud',
    'lovable',
    'loving',
    'malicious',
    'maternal',
    'mean',
    'messy',
    'nocturnal',
    'noisy',
    'nosy',
    'picky',
    'playful',
    'poisonous',
    'quick',
    'rough',
    'sassy',
    'scaly',
    'short',
    'shy',
    'slimy',
    'slow',
    'small',
    'smart',
    'smelly',
    'soft',
    'spikey',
    'stinky',
    'strong',
    'stubborn',
    'submissive',
    'tall',
    'tame',
    'tenacious',
    'territorial',
    'tiny',
    'vicious',
    'warm',
    'wild'
]);
const $54cb61c1e4eebfbc$var$colors = [
    '#00ffff',
    '#f0ffff',
    '#f5f5dc',
    '#0000ff',
    '#a52a2a',
    '#00008b',
    '#008b8b',
    '#a9a9a9',
    '#006400',
    '#bdb76b',
    '#8b008b',
    '#556b2f',
    '#ff8c00',
    '#9932cc',
    '#8b0000',
    '#e9967a',
    '#9400d3',
    '#ff00ff',
    '#ffd700',
    '#008000',
    '#4b0082',
    '#f0e68c',
    '#add8e6',
    '#e0ffff',
    '#90ee90',
    '#d3d3d3',
    '#ffb6c1',
    '#ffffe0',
    '#00ff00',
    '#ff00ff',
    '#800000',
    '#000080',
    '#808000',
    '#ffa500',
    '#ffc0cb',
    '#800080',
    '#ff0000',
    '#c0c0c0',
    '#ffff00'
];
const $54cb61c1e4eebfbc$var$random = (items)=>items[Math.random() * items.length | 0];
const $54cb61c1e4eebfbc$export$85b2291ebd5476b5 = (r, g, b, differencePoint = 128)=>(r * 299 + g * 587 + b * 114) / 1000 >= differencePoint;
/**
 * return a random colour, with a flag to show whether the color is light or dark,
 *  to suggest whether text applied should be white or black
 * @returns {Object} {color: string, isLight: boolean}
 */ function $54cb61c1e4eebfbc$var$randomColour() {
    const color = $54cb61c1e4eebfbc$var$random($54cb61c1e4eebfbc$var$colors);
    const rgb = color.replace('#', '');
    return {
        color: color,
        isLight: $54cb61c1e4eebfbc$export$85b2291ebd5476b5(parseInt(rgb.substring(0, 2), 16), parseInt(rgb.substring(2, 4), 16), parseInt(rgb.substring(4, 6), 16), 128)
    };
}
function $54cb61c1e4eebfbc$export$11f9234565cca346(varName) {
    return window.getComputedStyle(document.body).getPropertyValue(varName);
}
const $54cb61c1e4eebfbc$var$capitalize = (string)=>string[0].toUpperCase() + string.slice(1);
function $54cb61c1e4eebfbc$export$5d832d6580b26c5() {
    const name = $54cb61c1e4eebfbc$var$capitalize($54cb61c1e4eebfbc$var$random($54cb61c1e4eebfbc$var$ADJECTIVES)) + ' ' + $54cb61c1e4eebfbc$var$capitalize($54cb61c1e4eebfbc$var$random($54cb61c1e4eebfbc$var$SEA_CREATURES));
    return {
        ...$54cb61c1e4eebfbc$var$randomColour(),
        name: name,
        anon: true,
        asleep: false
    };
}
function $54cb61c1e4eebfbc$export$3cb6beff6f79e98b(msg) {
    $54cb61c1e4eebfbc$export$5bf96401662340b7('statusBar').innerHTML = $54cb61c1e4eebfbc$var$htmlEntities(msg);
}
function $54cb61c1e4eebfbc$export$9968692a49529c1(msg, status, dontFade = false) {
    const errMsgElement = $54cb61c1e4eebfbc$export$5bf96401662340b7('errMsg');
    switch(status){
        case 'info':
            errMsgElement.style.backgroundColor = $54cb61c1e4eebfbc$export$11f9234565cca346('--primary-color');
            errMsgElement.style.color = 'white';
            break;
        case 'warn':
            errMsgElement.style.backgroundColor = $54cb61c1e4eebfbc$export$11f9234565cca346('--warning-color');
            errMsgElement.style.color = 'black';
            break;
        case 'error':
            errMsgElement.style.backgroundColor = $54cb61c1e4eebfbc$export$11f9234565cca346('--alert-color');
            errMsgElement.style.color = 'white';
            break;
        default:
            console.log('Unknown status in alertMsg: ' + status);
            return;
    }
    errMsgElement.innerHTML = msg;
    if (dontFade) errMsgElement.style.opacity = 1;
    else {
        $54cb61c1e4eebfbc$export$63174c828edd6ff8('errMsg', 'animationend', ()=>{
            $54cb61c1e4eebfbc$export$5bf96401662340b7('errMsg').classList.remove('fadeInAndOut');
        });
        errMsgElement.classList.add('fadeInAndOut');
    }
}
function $54cb61c1e4eebfbc$export$3f0900b8af1937e2() {
    $54cb61c1e4eebfbc$export$5bf96401662340b7('errMsg').style.opacity = 0;
}
/**
 * replace special characters with their HTML entity codes
 * @param {string} str
 */ function $54cb61c1e4eebfbc$var$htmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&quot;');
}
function $54cb61c1e4eebfbc$export$62fd92124955fcd2() {
    $54cb61c1e4eebfbc$export$3cb6beff6f79e98b(' ');
}
/**
 * shorten the label if necessary and add an ellipsis
 * @param {string} label text to shorten
 * @param {number} maxLength if longer than this, cut the excess
 */ const $54cb61c1e4eebfbc$var$SHORTLABELLEN = 25 // when listing node labels, use ellipsis after this number of chars
;
function $54cb61c1e4eebfbc$export$dd78866213f805a5(label, maxLength = $54cb61c1e4eebfbc$var$SHORTLABELLEN) {
    return label.length > maxLength ? label.substring(0, maxLength) + '...' : label;
}
function $54cb61c1e4eebfbc$export$82a129a7016c8ea8(name) {
    return name.replace(/[^A-Za-z0-9À-ÿ ]/gi, '').replace(/ +/gi, ' ').match(/(^\S\S?|\b\S)?/g).join('').match(/(^\S|\S$)?/g).join('').toUpperCase();
}
function $54cb61c1e4eebfbc$export$37827d046293d309(text, font = 'normal 11px Oxygen') {
    // Create a dummy canvas (not added to DOM)
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    // The font must match the target element's CSS font e.g. "normal 11px Oxygen"
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
}
/**********************************************************colours ************************************************** */ const $54cb61c1e4eebfbc$var$hiddenOpacity = 0.1;
function $54cb61c1e4eebfbc$export$607b01733b83ff83(node, hide) {
    node.nodeHidden = hide;
    node.opacity = hide ? $54cb61c1e4eebfbc$var$hiddenOpacity : 1.0;
    if (node.font.color.charAt(0) === '#') node.font.color = $54cb61c1e4eebfbc$export$9665a07d9187b414(node.font.color);
    node.font.color = $54cb61c1e4eebfbc$var$rgba(node.font.color, hide ? $54cb61c1e4eebfbc$var$hiddenOpacity : 1.0);
    return node;
}
function $54cb61c1e4eebfbc$export$9665a07d9187b414(hex, alpha = 1) {
    hex = hex.replace('#', '');
    if (hex.length === 3) hex = hex.split('').map((c)=>c + c).join('');
    const [r, g, b] = [
        0,
        2,
        4
    ].map((i)=>parseInt(hex.slice(i, i + 2), 16));
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
function $54cb61c1e4eebfbc$export$d2556b5c60092110(edge, hide) {
    edge.edgeHidden = hide;
    edge.color.opacity = hide ? $54cb61c1e4eebfbc$var$hiddenOpacity : 1.0;
    if (!edge.font.color) edge.font.color = 'rgba(0,0,0,1)';
    edge.font.color = $54cb61c1e4eebfbc$var$rgba(edge.font.color, hide ? $54cb61c1e4eebfbc$var$hiddenOpacity : 1.0);
    return edge;
}
/**
 * convert an rgb(a) string to rgba with given alpha value
 */ function $54cb61c1e4eebfbc$var$rgba(rgb, alpha) {
    if (rgb.indexOf('a') === -1) rgb = rgb.replace('rgb', 'rgba').replace(')', ',0.0)');
    return rgb.replace(/[^,]*$/, ` ${alpha})`);
}
function $54cb61c1e4eebfbc$export$7f57f51729968d3b(str) {
    if (!str) return '#000000';
    if (str.charAt(0) === '#') return str;
    const ctx = document.createElement('canvas').getContext('2d');
    ctx.fillStyle = str;
    return ctx.fillStyle;
}
function $54cb61c1e4eebfbc$export$1777c9ba3e6d9ae0(rgb) {
    const values = rgb.slice(rgb.indexOf('(') + 1, rgb.indexOf(')')).split(',');
    return values.map((value)=>{
        return parseInt(value);
    });
}
function $54cb61c1e4eebfbc$export$34921afaa5f8c308(color) {
    return '#' + ('000000' + (0xffffff ^ parseInt(color.substring(1), 16)).toString(16)).slice(-6);
}
function $54cb61c1e4eebfbc$export$b09d2a0246869f74(seed) {
    // Mulberry32 seeded PRNG
    function mulberry32(a) {
        return function() {
            a |= 0;
            a = a + 0x6d2b79f5 | 0;
            let t = Math.imul(a ^ a >>> 15, 1 | a);
            t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
            return ((t ^ t >>> 14) >>> 0) / 4294967296;
        };
    }
    if (typeof seed === 'number') {
        // Seeded PRNG (deterministic but well distributed)
        const rand = mulberry32(seed);
        const r = Math.floor(rand() * 256);
        const g = Math.floor(rand() * 256);
        const b = Math.floor(rand() * 256);
        return `rgb(${r}, ${g}, ${b})`;
    } else {
        // Non-deterministic path
        const r = Math.floor(Math.random() * 256);
        const g = Math.floor(Math.random() * 256);
        const b = Math.floor(Math.random() * 256);
        return `rgb(${r}, ${g}, ${b})`;
    }
}
window.makeColor = $54cb61c1e4eebfbc$export$b09d2a0246869f74;
function $54cb61c1e4eebfbc$export$c44b387df32fe705(color) {
    // Variables for red, green, blue values
    let r, g, b;
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        r = color[1];
        g = color[2];
        b = color[3];
    } else {
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) return 'light';
    else return 'dark';
}
class $54cb61c1e4eebfbc$export$6d0b2a5dd774590a {
    constructor(){
        this.container = document.createElement('div');
        this.container.className = 'color-picker-container';
        this.container.id = 'colorPicker';
        const controls = document.createElement('div');
        controls.id = 'colorPickerControls';
        this.container.appendChild(controls);
        document.querySelector('body').insertAdjacentElement('beforeend', this.container);
        // see https://iro.js.org/guide.html#getting-started
        this.colorPicker = new (0, $eUXNC.default).ColorPicker('#colorPickerControls', {
            width: 160,
            color: 'rgba(255, 255, 255, 1)',
            borderWidth: 1,
            borderColor: 'rgba(255, 255, 255,1)',
            margin: 6,
            layout: [
                {
                    component: (0, $eUXNC.default).ui.Wheel,
                    options: {
                        borderColor: '#ffffff'
                    }
                },
                {
                    component: (0, $eUXNC.default).ui.Slider,
                    options: {
                        borderColor: '#000000',
                        sliderType: 'value',
                        padding: 2,
                        handleRadius: 4
                    }
                },
                {
                    component: (0, $eUXNC.default).ui.Slider,
                    options: {
                        borderColor: '#000000',
                        sliderType: 'alpha',
                        padding: 2,
                        handleRadius: 4
                    }
                }
            ]
        });
        // set up a grid of squares to hold last 8 selected colors
        this.colorCache = document.createElement('div');
        this.colorCache.id = 'colorCache';
        this.colorCache.className = 'color-cache';
        for(let i = 0; i < 8; i++){
            const c = document.createElement('div');
            c.id = 'color' + i;
            c.className = 'cached-color';
            // prefill with standard colours
            c.style.backgroundColor = [
                'rgba(255, 0, 0,1)',
                'rgba(0, 255, 0,1)',
                'rgb(0, 0, 255)',
                'rgba(255, 255, 0,1)',
                'rgb(255, 255, 255)',
                'rgba(0, 0, 0,1)',
                'rgba(154, 219, 180,1)',
                'rgba(219, 110, 103,1)'
            ][i];
            c.addEventListener('click', (e)=>{
                const color = e.target.style.backgroundColor;
                if (color) this.colorPicker.color.rgbaString = e.target.style.backgroundColor;
            });
            this.colorCache.appendChild(c);
        }
        document.getElementById('colorPickerControls').insertAdjacentElement('afterend', this.colorCache);
    }
    /**
   * attach a color picker to an element to recolour the background to that element
   * @param {string} wellId the id of the DOM element to attach the color picker to
   * @param {string} callback - function to call when the color has been chosen, with that color as argument
   */ createColorPicker(wellId, callback, onChange) {
        const well = $54cb61c1e4eebfbc$export$5bf96401662340b7(wellId);
        well.style.backgroundColor = '#ffffff';
        // add listener to display picker when well clicked
        well.addEventListener('click', (event)=>{
            this.container.style.display = 'block';
            const netPane = $54cb61c1e4eebfbc$export$5bf96401662340b7('net-pane').getBoundingClientRect();
            // locate picker so it does not go outside netPane
            let top = event.clientY + well.offsetHeight + 10;
            if (top > netPane.bottom - this.container.offsetHeight) top = netPane.bottom - this.container.offsetHeight - 10;
            if (top < netPane.top) top = netPane.top + 10;
            let left = event.clientX - this.container.offsetWidth / 2;
            if (left < netPane.left) left = netPane.left + 10;
            if (left > netPane.right - this.container.offsetWidth) left = netPane.right - this.container.offsetWidth - 10;
            this.container.style.top = `${top}px`;
            this.container.style.left = `${left}px`;
            this.container.well = well;
            this.container.callback = callback;
            this.container.onChange = onChange;
            this.colorPicker.color.rgbaString = well.style.backgroundColor;
            this.onclose = this.closeColorPicker.bind(this);
            document.addEventListener('click', this.onclose, true);
            // update well as color is changed
            this.colorPicker.on('color:change', (color)=>{
                well.style.backgroundColor = color.rgbaString;
                if (onChange) onChange();
            });
        });
    }
    /**
   * Report chosen colour when user clicks outside of picker (and well)
   * Hide the picker and save the colour choice in the previously selected colour grid
   * @param {event} event
   */ closeColorPicker(event) {
        if (!(this.container.contains(event.target) || this.container.well.contains(event.target))) {
            this.container.style.display = 'none';
            document.removeEventListener('click', this.onclose, true);
            const color = this.container.well.style.backgroundColor;
            // save the chosen color for future selection if it is not already there
            this.saveColor(color);
            const callback = this.container.callback;
            if (callback) callback(color);
            this.colorPicker.off('color:change');
        }
    }
    /**
   * Save the color in the previously selected colour grid, if not already saved
   * into a free slot, or if there isn't one shift the current colours to the left
   * and save the new at the right end
   * @param {string} color
   */ saveColor(color) {
        const saveds = this.colorCache.children;
        for(let i = 0; i < 8; i++){
            if (saveds[i].style.backgroundColor === color) return;
        }
        for(let i = 0; i < 8; i++)if (saveds[i].style.backgroundColor === '') {
            saveds[i].style.backgroundColor = color;
            return;
        }
        for(let i = 0, j = 1; j < 8; i++, j++)saveds[i].style.backgroundColor = saveds[j].style.backgroundColor;
        saveds[7].style.backgroundColor = color;
    }
}
function $54cb61c1e4eebfbc$export$b3902f047e75d149(utc, full = false) {
    const time = new Date();
    time.setTime(utc);
    if (!full && time.toDateString() === new Date().toDateString()) // return Today, 12:34
    return 'Today, ' + time.toLocaleString('en-GB', {
        hour: '2-digit',
        minute: '2-digit'
    });
    if (!full && time.getFullYear() === new Date().getFullYear()) // return 12 Sept, 12:34
    return time.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit'
    });
    // return 12 Sep 2023, 12:34
    return time.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).replace('Sept', 'Sep');
}
function $54cb61c1e4eebfbc$export$8bc063faa2ba2bd3(contentEditableElement) {
    const range = document.createRange() //Create a range (a range is a like the selection but invisible)
    ;
    range.selectNodeContents(contentEditableElement) //Select the entire contents of the element with the range
    ;
    range.collapse(false) //collapse the range to the end point. false means collapse to end rather than the start
    ;
    const selection = window.getSelection() //get the selection object (allows you to change selection)
    ;
    selection.removeAllRanges() //remove any selections already made
    ;
    selection.addRange(range) //make the range you have just created the visible selection
    ;
}
function $54cb61c1e4eebfbc$export$cdee113d0db2579a(time) {
    const d = time ? new Date(time) : new Date();
    return `${d.toLocaleTimeString()}:${d.getMilliseconds()} `;
}
function $54cb61c1e4eebfbc$export$d07f57595c356899(string) {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}
function $54cb61c1e4eebfbc$export$81b06ab76a3757ce(string) {
    return string ? string.charAt(0).toLowerCase() + string.slice(1) : '';
}
function $54cb61c1e4eebfbc$export$89dc6f1d08c41ada(bytes, isDecimal = true) {
    if (bytes === 0) return '0B';
    const decimalUnits = [
        'B',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB'
    ];
    const binaryUnits = [
        'B',
        'KiB',
        'MiB',
        'GiB',
        'TiB',
        'PiB'
    ];
    const base = isDecimal ? 1000 : 1024;
    const units = isDecimal ? decimalUnits : binaryUnits;
    const i = Math.floor(Math.log(bytes) / Math.log(base));
    const size = bytes / Math.pow(base, i);
    const formatted = size % 1 === 0 ? size.toString() : size.toFixed(1);
    return `${formatted}${units[i]}`;
}
function $54cb61c1e4eebfbc$export$99f0341e4542bf23(quill) {
    if ((quill.getContents()['ops'] || []).length !== 1) return false;
    return quill.getText().trim().length === 0;
}
function $54cb61c1e4eebfbc$export$e6b553c28e5248fd(str) {
    return str.replace(/\r?\n|\r/g, ' ');
}
function $54cb61c1e4eebfbc$export$9adb60ba67eebe15(text) {
    return text.replace(/[&<>"']/g, (match)=>({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        })[match]);
}
function $54cb61c1e4eebfbc$export$9f711266042c4a52() {
    window.open($54cb61c1e4eebfbc$var$MANUALURL, 'helpWindow');
}
async function $54cb61c1e4eebfbc$export$d9b1660906972725(preserve = [
    'doneIntro',
    'seenWN',
    'myName',
    'recents'
]) {
    // remove all local storage items that are not in the list
    const keys = Object.keys(localStorage);
    keys.forEach((key)=>{
        if (!preserve.includes(key)) localStorage.removeItem(key);
    });
    // remove all IndexDB databases (we don't use them any more) except localforage
    indexedDB.databases().then((dbs)=>dbs.forEach((db)=>{
            if (db.name !== 'localforage') indexedDB.deleteDatabase(db.name);
        }));
}

});
parcelRegister("eUXNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adc4ae8a4d756edf$export$2e2bcd8739ae039);
/*!
 * iro.js v5.5.2
 * 2016-2021 James Daniel
 * Licensed under MPL 2.0
 * github.com/jaames/iro.js
 */ var $adc4ae8a4d756edf$var$n, $adc4ae8a4d756edf$var$u, $adc4ae8a4d756edf$var$t, $adc4ae8a4d756edf$var$i, $adc4ae8a4d756edf$var$r, $adc4ae8a4d756edf$var$o, $adc4ae8a4d756edf$var$f = {}, $adc4ae8a4d756edf$var$e = [], $adc4ae8a4d756edf$var$c = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|^--/i;
function $adc4ae8a4d756edf$var$s(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $adc4ae8a4d756edf$var$a(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $adc4ae8a4d756edf$var$h(n, l, u) {
    var t, i, r, o, f = arguments;
    if (l = $adc4ae8a4d756edf$var$s({}, l), arguments.length > 3) for(u = [
        u
    ], t = 3; t < arguments.length; t++)u.push(f[t]);
    if (null != u && (l.children = u), null != n && null != n.defaultProps) for(i in n.defaultProps)void 0 === l[i] && (l[i] = n.defaultProps[i]);
    return o = l.key, null != (r = l.ref) && delete l.ref, null != o && delete l.key, $adc4ae8a4d756edf$var$v(n, l, o, r);
}
function $adc4ae8a4d756edf$var$v(l, u, t, i) {
    var r = {
        type: l,
        props: u,
        key: t,
        ref: i,
        __k: null,
        __p: null,
        __b: 0,
        __e: null,
        l: null,
        __c: null,
        constructor: void 0
    };
    return $adc4ae8a4d756edf$var$n.vnode && $adc4ae8a4d756edf$var$n.vnode(r), r;
}
function $adc4ae8a4d756edf$var$d(n) {
    return n.children;
}
function $adc4ae8a4d756edf$var$y(n) {
    if (null == n || "boolean" == typeof n) return null;
    if ("string" == typeof n || "number" == typeof n) return $adc4ae8a4d756edf$var$v(null, n, null, null);
    if (null != n.__e || null != n.__c) {
        var l = $adc4ae8a4d756edf$var$v(n.type, n.props, n.key, null);
        return l.__e = n.__e, l;
    }
    return n;
}
function $adc4ae8a4d756edf$var$m(n, l) {
    this.props = n, this.context = l;
}
function $adc4ae8a4d756edf$var$w(n, l) {
    if (null == l) return n.__p ? $adc4ae8a4d756edf$var$w(n.__p, n.__p.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++){
        if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    }
    return "function" == typeof n.type ? $adc4ae8a4d756edf$var$w(n) : null;
}
function $adc4ae8a4d756edf$var$g(n) {
    var l, u;
    if (null != (n = n.__p) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $adc4ae8a4d756edf$var$g(n);
    }
}
function $adc4ae8a4d756edf$var$k(l) {
    (!l.__d && (l.__d = !0) && 1 === $adc4ae8a4d756edf$var$u.push(l) || $adc4ae8a4d756edf$var$i !== $adc4ae8a4d756edf$var$n.debounceRendering) && ($adc4ae8a4d756edf$var$i = $adc4ae8a4d756edf$var$n.debounceRendering, ($adc4ae8a4d756edf$var$n.debounceRendering || $adc4ae8a4d756edf$var$t)($adc4ae8a4d756edf$var$_));
}
function $adc4ae8a4d756edf$var$_() {
    var n, l, t, i, r, o, f, e;
    for($adc4ae8a4d756edf$var$u.sort(function(n, l) {
        return l.__v.__b - n.__v.__b;
    }); n = $adc4ae8a4d756edf$var$u.pop();)n.__d && (t = void 0, i = void 0, o = (r = (l = n).__v).__e, f = l.__P, e = l.u, l.u = !1, f && (t = [], i = $adc4ae8a4d756edf$var$$(f, r, $adc4ae8a4d756edf$var$s({}, r), l.__n, void 0 !== f.ownerSVGElement, null, t, e, null == o ? $adc4ae8a4d756edf$var$w(r) : o), $adc4ae8a4d756edf$var$j(t, r), i != o && $adc4ae8a4d756edf$var$g(r)));
}
function $adc4ae8a4d756edf$var$b(n, l, u, t, i, r, o, c, s) {
    var h, v, p, d, y, m, g, k = u && u.__k || $adc4ae8a4d756edf$var$e, _ = k.length;
    if (c == $adc4ae8a4d756edf$var$f && (c = null != r ? r[0] : _ ? $adc4ae8a4d756edf$var$w(u, 0) : null), h = 0, l.__k = $adc4ae8a4d756edf$var$x(l.__k, function(u) {
        if (null != u) {
            if (u.__p = l, u.__b = l.__b + 1, null === (p = k[h]) || p && u.key == p.key && u.type === p.type) k[h] = void 0;
            else for(v = 0; v < _; v++){
                if ((p = k[v]) && u.key == p.key && u.type === p.type) {
                    k[v] = void 0;
                    break;
                }
                p = null;
            }
            if (d = $adc4ae8a4d756edf$var$$(n, u, p = p || $adc4ae8a4d756edf$var$f, t, i, r, o, null, c, s), (v = u.ref) && p.ref != v && (g || (g = [])).push(v, u.__c || d, u), null != d) {
                if (null == m && (m = d), null != u.l) d = u.l, u.l = null;
                else if (r == p || d != c || null == d.parentNode) {
                    n: if (null == c || c.parentNode !== n) n.appendChild(d);
                    else {
                        for(y = c, v = 0; (y = y.nextSibling) && v < _; v += 2){
                            if (y == d) break n;
                        }
                        n.insertBefore(d, c);
                    }
                    "option" == l.type && (n.value = "");
                }
                c = d.nextSibling, "function" == typeof l.type && (l.l = d);
            }
        }
        return h++, u;
    }), l.__e = m, null != r && "function" != typeof l.type) for(h = r.length; h--;)null != r[h] && $adc4ae8a4d756edf$var$a(r[h]);
    for(h = _; h--;)null != k[h] && $adc4ae8a4d756edf$var$D(k[h], k[h]);
    if (g) for(h = 0; h < g.length; h++)$adc4ae8a4d756edf$var$A(g[h], g[++h], g[++h]);
}
function $adc4ae8a4d756edf$var$x(n, l, u) {
    if (null == u && (u = []), null == n || "boolean" == typeof n) l && u.push(l(null));
    else if (Array.isArray(n)) for(var t = 0; t < n.length; t++)$adc4ae8a4d756edf$var$x(n[t], l, u);
    else u.push(l ? l($adc4ae8a4d756edf$var$y(n)) : n);
    return u;
}
function $adc4ae8a4d756edf$var$C(n, l, u, t, i) {
    var r;
    for(r in u)r in l || $adc4ae8a4d756edf$var$N(n, r, null, u[r], t);
    for(r in l)i && "function" != typeof l[r] || "value" === r || "checked" === r || u[r] === l[r] || $adc4ae8a4d756edf$var$N(n, r, l[r], u[r], t);
}
function $adc4ae8a4d756edf$var$P(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = "number" == typeof u && !1 === $adc4ae8a4d756edf$var$c.test(l) ? u + "px" : null == u ? "" : u;
}
function $adc4ae8a4d756edf$var$N(n, l, u, t, i) {
    var r, o, f, e, c;
    if ("key" === (l = i ? "className" === l ? "class" : l : "class" === l ? "className" : l) || "children" === l) ;
    else if ("style" === l) {
        if (r = n.style, "string" == typeof u) r.cssText = u;
        else {
            if ("string" == typeof t && (r.cssText = "", t = null), t) for(o in t)u && o in u || $adc4ae8a4d756edf$var$P(r, o, "");
            if (u) for(f in u)t && u[f] === t[f] || $adc4ae8a4d756edf$var$P(r, f, u[f]);
        }
    } else "o" === l[0] && "n" === l[1] ? (e = l !== (l = l.replace(/Capture$/, "")), c = l.toLowerCase(), l = (c in n ? c : l).slice(2), u ? (t || n.addEventListener(l, $adc4ae8a4d756edf$var$T, e), (n.t || (n.t = {}))[l] = u) : n.removeEventListener(l, $adc4ae8a4d756edf$var$T, e)) : "list" !== l && "tagName" !== l && "form" !== l && !i && l in n ? n[l] = null == u ? "" : u : "function" != typeof u && "dangerouslySetInnerHTML" !== l && (l !== (l = l.replace(/^xlink:?/, "")) ? null == u || !1 === u ? n.removeAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase()) : n.setAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase(), u) : null == u || !1 === u ? n.removeAttribute(l) : n.setAttribute(l, u));
}
function $adc4ae8a4d756edf$var$T(l) {
    return this.t[l.type]($adc4ae8a4d756edf$var$n.event ? $adc4ae8a4d756edf$var$n.event(l) : l);
}
function $adc4ae8a4d756edf$var$$(l, u, t, i, r, o, f, e, c, a) {
    var h, v, p, y, w, g, k, _, C, P, N = u.type;
    if (void 0 !== u.constructor) return null;
    (h = $adc4ae8a4d756edf$var$n.__b) && h(u);
    try {
        n: if ("function" == typeof N) {
            if (_ = u.props, C = (h = N.contextType) && i[h.__c], P = h ? C ? C.props.value : h.__p : i, t.__c ? k = (v = u.__c = t.__c).__p = v.__E : ("prototype" in N && N.prototype.render ? u.__c = v = new N(_, P) : (u.__c = v = new $adc4ae8a4d756edf$var$m(_, P), v.constructor = N, v.render = $adc4ae8a4d756edf$var$H), C && C.sub(v), v.props = _, v.state || (v.state = {}), v.context = P, v.__n = i, p = v.__d = !0, v.__h = []), null == v.__s && (v.__s = v.state), null != N.getDerivedStateFromProps && $adc4ae8a4d756edf$var$s(v.__s == v.state ? v.__s = $adc4ae8a4d756edf$var$s({}, v.__s) : v.__s, N.getDerivedStateFromProps(_, v.__s)), p) null == N.getDerivedStateFromProps && null != v.componentWillMount && v.componentWillMount(), null != v.componentDidMount && f.push(v);
            else {
                if (null == N.getDerivedStateFromProps && null == e && null != v.componentWillReceiveProps && v.componentWillReceiveProps(_, P), !e && null != v.shouldComponentUpdate && !1 === v.shouldComponentUpdate(_, v.__s, P)) {
                    for(v.props = _, v.state = v.__s, v.__d = !1, v.__v = u, u.__e = null != c ? c !== t.__e ? c : t.__e : null, u.__k = t.__k, h = 0; h < u.__k.length; h++)u.__k[h] && (u.__k[h].__p = u);
                    break n;
                }
                null != v.componentWillUpdate && v.componentWillUpdate(_, v.__s, P);
            }
            for(y = v.props, w = v.state, v.context = P, v.props = _, v.state = v.__s, (h = $adc4ae8a4d756edf$var$n.__r) && h(u), v.__d = !1, v.__v = u, v.__P = l, h = v.render(v.props, v.state, v.context), u.__k = $adc4ae8a4d756edf$var$x(null != h && h.type == $adc4ae8a4d756edf$var$d && null == h.key ? h.props.children : h), null != v.getChildContext && (i = $adc4ae8a4d756edf$var$s($adc4ae8a4d756edf$var$s({}, i), v.getChildContext())), p || null == v.getSnapshotBeforeUpdate || (g = v.getSnapshotBeforeUpdate(y, w)), $adc4ae8a4d756edf$var$b(l, u, t, i, r, o, f, c, a), v.base = u.__e; h = v.__h.pop();)v.__s && (v.state = v.__s), h.call(v);
            p || null == y || null == v.componentDidUpdate || v.componentDidUpdate(y, w, g), k && (v.__E = v.__p = null);
        } else u.__e = $adc4ae8a4d756edf$var$z(t.__e, u, t, i, r, o, f, a);
        (h = $adc4ae8a4d756edf$var$n.diffed) && h(u);
    } catch (l) {
        $adc4ae8a4d756edf$var$n.__e(l, u, t);
    }
    return u.__e;
}
function $adc4ae8a4d756edf$var$j(l, u) {
    for(var t; t = l.pop();)try {
        t.componentDidMount();
    } catch (l) {
        $adc4ae8a4d756edf$var$n.__e(l, t.__v);
    }
    $adc4ae8a4d756edf$var$n.__c && $adc4ae8a4d756edf$var$n.__c(u);
}
function $adc4ae8a4d756edf$var$z(n, l, u, t, i, r, o, c) {
    var s, a, h, v, p = u.props, d = l.props;
    if (i = "svg" === l.type || i, null == n && null != r) {
        for(s = 0; s < r.length; s++)if (null != (a = r[s]) && (null === l.type ? 3 === a.nodeType : a.localName === l.type)) {
            n = a, r[s] = null;
            break;
        }
    }
    if (null == n) {
        if (null === l.type) return document.createTextNode(d);
        n = i ? document.createElementNS("http://www.w3.org/2000/svg", l.type) : document.createElement(l.type), r = null;
    }
    return null === l.type ? p !== d && (null != r && (r[r.indexOf(n)] = null), n.data = d) : l !== u && (null != r && (r = $adc4ae8a4d756edf$var$e.slice.call(n.childNodes)), h = (p = u.props || $adc4ae8a4d756edf$var$f).dangerouslySetInnerHTML, v = d.dangerouslySetInnerHTML, c || (v || h) && (v && h && v.__html == h.__html || (n.innerHTML = v && v.__html || "")), $adc4ae8a4d756edf$var$C(n, d, p, i, c), l.__k = l.props.children, v || $adc4ae8a4d756edf$var$b(n, l, u, t, "foreignObject" !== l.type && i, r, o, $adc4ae8a4d756edf$var$f, c), c || ("value" in d && void 0 !== d.value && d.value !== n.value && (n.value = null == d.value ? "" : d.value), "checked" in d && void 0 !== d.checked && d.checked !== n.checked && (n.checked = d.checked))), n;
}
function $adc4ae8a4d756edf$var$A(l, u, t) {
    try {
        "function" == typeof l ? l(u) : l.current = u;
    } catch (l) {
        $adc4ae8a4d756edf$var$n.__e(l, t);
    }
}
function $adc4ae8a4d756edf$var$D(l, u, t) {
    var i, r, o;
    if ($adc4ae8a4d756edf$var$n.unmount && $adc4ae8a4d756edf$var$n.unmount(l), (i = l.ref) && $adc4ae8a4d756edf$var$A(i, null, u), t || "function" == typeof l.type || (t = null != (r = l.__e)), l.__e = l.l = null, null != (i = l.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (l) {
            $adc4ae8a4d756edf$var$n.__e(l, u);
        }
        i.base = i.__P = null;
    }
    if (i = l.__k) for(o = 0; o < i.length; o++)i[o] && $adc4ae8a4d756edf$var$D(i[o], u, t);
    null != r && $adc4ae8a4d756edf$var$a(r);
}
function $adc4ae8a4d756edf$var$H(n, l, u) {
    return this.constructor(n, u);
}
function $adc4ae8a4d756edf$var$I(l, u, t) {
    var i, o, c;
    $adc4ae8a4d756edf$var$n.__p && $adc4ae8a4d756edf$var$n.__p(l, u), o = (i = t === $adc4ae8a4d756edf$var$r) ? null : t && t.__k || u.__k, l = $adc4ae8a4d756edf$var$h($adc4ae8a4d756edf$var$d, null, [
        l
    ]), c = [], $adc4ae8a4d756edf$var$$(u, i ? u.__k = l : (t || u).__k = l, o || $adc4ae8a4d756edf$var$f, $adc4ae8a4d756edf$var$f, void 0 !== u.ownerSVGElement, t && !i ? [
        t
    ] : o ? null : $adc4ae8a4d756edf$var$e.slice.call(u.childNodes), c, !1, t || $adc4ae8a4d756edf$var$f, i), $adc4ae8a4d756edf$var$j(c, l);
}
$adc4ae8a4d756edf$var$n = {}, $adc4ae8a4d756edf$var$m.prototype.setState = function(n, l) {
    var u = this.__s !== this.state && this.__s || (this.__s = $adc4ae8a4d756edf$var$s({}, this.state));
    ("function" != typeof n || (n = n(u, this.props))) && $adc4ae8a4d756edf$var$s(u, n), null != n && this.__v && (this.u = !1, l && this.__h.push(l), $adc4ae8a4d756edf$var$k(this));
}, $adc4ae8a4d756edf$var$m.prototype.forceUpdate = function(n) {
    this.__v && (n && this.__h.push(n), this.u = !0, $adc4ae8a4d756edf$var$k(this));
}, $adc4ae8a4d756edf$var$m.prototype.render = $adc4ae8a4d756edf$var$d, $adc4ae8a4d756edf$var$u = [], $adc4ae8a4d756edf$var$t = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $adc4ae8a4d756edf$var$i = $adc4ae8a4d756edf$var$n.debounceRendering, $adc4ae8a4d756edf$var$n.__e = function(n, l, u) {
    for(var t; l = l.__p;){
        if ((t = l.__c) && !t.__p) try {
            if (t.constructor && null != t.constructor.getDerivedStateFromError) t.setState(t.constructor.getDerivedStateFromError(n));
            else {
                if (null == t.componentDidCatch) continue;
                t.componentDidCatch(n);
            }
            return $adc4ae8a4d756edf$var$k(t.__E = t);
        } catch (l) {
            n = l;
        }
    }
    throw n;
}, $adc4ae8a4d756edf$var$r = $adc4ae8a4d756edf$var$f, $adc4ae8a4d756edf$var$o = 0;
function $adc4ae8a4d756edf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $adc4ae8a4d756edf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $adc4ae8a4d756edf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $adc4ae8a4d756edf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $adc4ae8a4d756edf$var$_extends() {
    $adc4ae8a4d756edf$var$_extends = Object.assign || function(target) {
        var arguments$1 = arguments;
        for(var i = 1; i < arguments.length; i++){
            var source = arguments$1[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $adc4ae8a4d756edf$var$_extends.apply(this, arguments);
}
// Some regular expressions for rgb() and hsl() Colors are borrowed from tinyColor
// https://github.com/bgrins/TinyColor
// Kelvin temperature math borrowed from Neil Barlett's implementation
// from https://github.com/neilbartlett/color-temperature
// https://www.w3.org/TR/css3-values/#integers
var $adc4ae8a4d756edf$var$CSS_INTEGER = '[-\\+]?\\d+%?'; // http://www.w3.org/TR/css3-values/#number-value
var $adc4ae8a4d756edf$var$CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?'; // Allow positive/negative integer/number. Don't capture the either/or, just the entire outcome
var $adc4ae8a4d756edf$var$CSS_UNIT = '(?:' + $adc4ae8a4d756edf$var$CSS_NUMBER + ')|(?:' + $adc4ae8a4d756edf$var$CSS_INTEGER + ')'; // Parse function params
// Parens and commas are optional, and this also allows for whitespace between numbers
var $adc4ae8a4d756edf$var$PERMISSIVE_MATCH_3 = '[\\s|\\(]+(' + $adc4ae8a4d756edf$var$CSS_UNIT + ')[,|\\s]+(' + $adc4ae8a4d756edf$var$CSS_UNIT + ')[,|\\s]+(' + $adc4ae8a4d756edf$var$CSS_UNIT + ')\\s*\\)?';
var $adc4ae8a4d756edf$var$PERMISSIVE_MATCH_4 = '[\\s|\\(]+(' + $adc4ae8a4d756edf$var$CSS_UNIT + ')[,|\\s]+(' + $adc4ae8a4d756edf$var$CSS_UNIT + ')[,|\\s]+(' + $adc4ae8a4d756edf$var$CSS_UNIT + ')[,|\\s]+(' + $adc4ae8a4d756edf$var$CSS_UNIT + ')\\s*\\)?'; // Regex patterns for functional color strings
var $adc4ae8a4d756edf$var$REGEX_FUNCTIONAL_RGB = new RegExp('rgb' + $adc4ae8a4d756edf$var$PERMISSIVE_MATCH_3);
var $adc4ae8a4d756edf$var$REGEX_FUNCTIONAL_RGBA = new RegExp('rgba' + $adc4ae8a4d756edf$var$PERMISSIVE_MATCH_4);
var $adc4ae8a4d756edf$var$REGEX_FUNCTIONAL_HSL = new RegExp('hsl' + $adc4ae8a4d756edf$var$PERMISSIVE_MATCH_3);
var $adc4ae8a4d756edf$var$REGEX_FUNCTIONAL_HSLA = new RegExp('hsla' + $adc4ae8a4d756edf$var$PERMISSIVE_MATCH_4); // Color string parsing regex
var $adc4ae8a4d756edf$var$HEX_START = '^(?:#?|0x?)';
var $adc4ae8a4d756edf$var$HEX_INT_SINGLE = '([0-9a-fA-F]{1})';
var $adc4ae8a4d756edf$var$HEX_INT_DOUBLE = '([0-9a-fA-F]{2})';
var $adc4ae8a4d756edf$var$REGEX_HEX_3 = new RegExp($adc4ae8a4d756edf$var$HEX_START + $adc4ae8a4d756edf$var$HEX_INT_SINGLE + $adc4ae8a4d756edf$var$HEX_INT_SINGLE + $adc4ae8a4d756edf$var$HEX_INT_SINGLE + '$');
var $adc4ae8a4d756edf$var$REGEX_HEX_4 = new RegExp($adc4ae8a4d756edf$var$HEX_START + $adc4ae8a4d756edf$var$HEX_INT_SINGLE + $adc4ae8a4d756edf$var$HEX_INT_SINGLE + $adc4ae8a4d756edf$var$HEX_INT_SINGLE + $adc4ae8a4d756edf$var$HEX_INT_SINGLE + '$');
var $adc4ae8a4d756edf$var$REGEX_HEX_6 = new RegExp($adc4ae8a4d756edf$var$HEX_START + $adc4ae8a4d756edf$var$HEX_INT_DOUBLE + $adc4ae8a4d756edf$var$HEX_INT_DOUBLE + $adc4ae8a4d756edf$var$HEX_INT_DOUBLE + '$');
var $adc4ae8a4d756edf$var$REGEX_HEX_8 = new RegExp($adc4ae8a4d756edf$var$HEX_START + $adc4ae8a4d756edf$var$HEX_INT_DOUBLE + $adc4ae8a4d756edf$var$HEX_INT_DOUBLE + $adc4ae8a4d756edf$var$HEX_INT_DOUBLE + $adc4ae8a4d756edf$var$HEX_INT_DOUBLE + '$'); // Kelvin temperature bounds
var $adc4ae8a4d756edf$var$KELVIN_MIN = 2000;
var $adc4ae8a4d756edf$var$KELVIN_MAX = 40000; // Math shorthands
var $adc4ae8a4d756edf$var$log = Math.log, $adc4ae8a4d756edf$var$round = Math.round, $adc4ae8a4d756edf$var$floor = Math.floor;
/**
 * @desc Clamp a number between a min and max value
 * @param num - input value
 * @param min - min allowed value
 * @param max - max allowed value
 */ function $adc4ae8a4d756edf$var$clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
/**
 * @desc Parse a css unit string - either regular int or a percentage number
 * @param str - css unit string
 * @param max - max unit value, used for calculating percentages
 */ function $adc4ae8a4d756edf$var$parseUnit(str, max) {
    var isPercentage = str.indexOf('%') > -1;
    var num = parseFloat(str);
    return isPercentage ? max / 100 * num : num;
}
/**
 * @desc Parse hex str to an int
 * @param str - hex string to parse
 */ function $adc4ae8a4d756edf$var$parseHexInt(str) {
    return parseInt(str, 16);
}
/**
 * @desc Convert nunber into to 2-digit hex
 * @param int - number to convert
 */ function $adc4ae8a4d756edf$var$intToHex(_int) {
    return _int.toString(16).padStart(2, '0');
}
var $adc4ae8a4d756edf$var$IroColor = /*#__PURE__*/ function() {
    /**
    * @constructor Color object
    * @param value - initial color value
  */ function IroColor(value, onChange) {
        // The default Color value
        this.$ = {
            h: 0,
            s: 0,
            v: 0,
            a: 1
        };
        if (value) this.set(value);
         // The watch callback function for this Color will be stored here
        this.onChange = onChange;
        this.initialValue = $adc4ae8a4d756edf$var$_extends({}, this.$); // copy initial value
    }
    /**
    * @desc Set the Color from any valid value
    * @param value - new color value
  */ var _proto = IroColor.prototype;
    _proto.set = function set(value) {
        if (typeof value === 'string') {
            if (/^(?:#?|0x?)[0-9a-fA-F]{3,8}$/.test(value)) this.hexString = value;
            else if (/^rgba?/.test(value)) this.rgbString = value;
            else if (/^hsla?/.test(value)) this.hslString = value;
        } else if (typeof value === 'object') {
            if (value instanceof IroColor) this.hsva = value.hsva;
            else if ('r' in value && 'g' in value && 'b' in value) this.rgb = value;
            else if ('h' in value && 's' in value && 'v' in value) this.hsv = value;
            else if ('h' in value && 's' in value && 'l' in value) this.hsl = value;
            else if ('kelvin' in value) this.kelvin = value.kelvin;
        } else throw new Error('Invalid color value');
    };
    _proto.setChannel = function setChannel(format, channel, value) {
        var _extends2;
        this[format] = $adc4ae8a4d756edf$var$_extends({}, this[format], (_extends2 = {}, _extends2[channel] = value, _extends2));
    };
    _proto.reset = function reset() {
        this.hsva = this.initialValue;
    };
    _proto.clone = function clone() {
        return new IroColor(this);
    };
    _proto.unbind = function unbind() {
        this.onChange = undefined;
    };
    IroColor.hsvToRgb = function hsvToRgb(hsv) {
        var h = hsv.h / 60;
        var s = hsv.s / 100;
        var v = hsv.v / 100;
        var i = $adc4ae8a4d756edf$var$floor(h);
        var f = h - i;
        var p = v * (1 - s);
        var q = v * (1 - f * s);
        var t = v * (1 - (1 - f) * s);
        var mod = i % 6;
        var r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod];
        var g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod];
        var b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: $adc4ae8a4d756edf$var$clamp(r * 255, 0, 255),
            g: $adc4ae8a4d756edf$var$clamp(g * 255, 0, 255),
            b: $adc4ae8a4d756edf$var$clamp(b * 255, 0, 255)
        };
    };
    IroColor.rgbToHsv = function rgbToHsv(rgb) {
        var r = rgb.r / 255;
        var g = rgb.g / 255;
        var b = rgb.b / 255;
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var delta = max - min;
        var hue = 0;
        var value = max;
        var saturation = max === 0 ? 0 : delta / max;
        switch(max){
            case min:
                hue = 0; // achromatic
                break;
            case r:
                hue = (g - b) / delta + (g < b ? 6 : 0);
                break;
            case g:
                hue = (b - r) / delta + 2;
                break;
            case b:
                hue = (r - g) / delta + 4;
                break;
        }
        return {
            h: hue * 60 % 360,
            s: $adc4ae8a4d756edf$var$clamp(saturation * 100, 0, 100),
            v: $adc4ae8a4d756edf$var$clamp(value * 100, 0, 100)
        };
    };
    IroColor.hsvToHsl = function hsvToHsl(hsv) {
        var s = hsv.s / 100;
        var v = hsv.v / 100;
        var l = (2 - s) * v;
        var divisor = l <= 1 ? l : 2 - l; // Avoid division by zero when lightness is close to zero
        var saturation = divisor < 1e-9 ? 0 : s * v / divisor;
        return {
            h: hsv.h,
            s: $adc4ae8a4d756edf$var$clamp(saturation * 100, 0, 100),
            l: $adc4ae8a4d756edf$var$clamp(l * 50, 0, 100)
        };
    };
    IroColor.hslToHsv = function hslToHsv(hsl) {
        var l = hsl.l * 2;
        var s = hsl.s * (l <= 100 ? l : 200 - l) / 100; // Avoid division by zero when l + s is near 0
        var saturation = l + s < 1e-9 ? 0 : 2 * s / (l + s);
        return {
            h: hsl.h,
            s: $adc4ae8a4d756edf$var$clamp(saturation * 100, 0, 100),
            v: $adc4ae8a4d756edf$var$clamp((l + s) / 2, 0, 100)
        };
    };
    IroColor.kelvinToRgb = function kelvinToRgb(kelvin) {
        var temp = kelvin / 100;
        var r, g, b;
        if (temp < 66) {
            r = 255;
            g = -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * $adc4ae8a4d756edf$var$log(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * $adc4ae8a4d756edf$var$log(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * $adc4ae8a4d756edf$var$log(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * $adc4ae8a4d756edf$var$log(g);
            b = 255;
        }
        return {
            r: $adc4ae8a4d756edf$var$clamp($adc4ae8a4d756edf$var$floor(r), 0, 255),
            g: $adc4ae8a4d756edf$var$clamp($adc4ae8a4d756edf$var$floor(g), 0, 255),
            b: $adc4ae8a4d756edf$var$clamp($adc4ae8a4d756edf$var$floor(b), 0, 255)
        };
    };
    IroColor.rgbToKelvin = function rgbToKelvin(rgb) {
        var r = rgb.r, b = rgb.b;
        var eps = 0.4;
        var minTemp = $adc4ae8a4d756edf$var$KELVIN_MIN;
        var maxTemp = $adc4ae8a4d756edf$var$KELVIN_MAX;
        var temp;
        while(maxTemp - minTemp > eps){
            temp = (maxTemp + minTemp) * 0.5;
            var _rgb = IroColor.kelvinToRgb(temp);
            if (_rgb.b / _rgb.r >= b / r) maxTemp = temp;
            else minTemp = temp;
        }
        return temp;
    };
    $adc4ae8a4d756edf$var$_createClass(IroColor, [
        {
            key: "hsv",
            get: function get() {
                // value is cloned to allow changes to be made to the values before passing them back
                var value = this.$;
                return {
                    h: value.h,
                    s: value.s,
                    v: value.v
                };
            },
            set: function set(newValue) {
                var oldValue = this.$;
                newValue = $adc4ae8a4d756edf$var$_extends({}, oldValue, newValue); // If this Color is being watched for changes we need to compare the new and old values to check the difference
                // Otherwise we can just be lazy
                if (this.onChange) {
                    // Compute changed values
                    var changes = {
                        h: false,
                        v: false,
                        s: false,
                        a: false
                    };
                    for(var key in oldValue)changes[key] = newValue[key] != oldValue[key];
                    this.$ = newValue; // If the value has changed, call hook callback
                    if (changes.h || changes.s || changes.v || changes.a) this.onChange(this, changes);
                } else this.$ = newValue;
            }
        },
        {
            key: "hsva",
            get: function get() {
                return $adc4ae8a4d756edf$var$_extends({}, this.$);
            },
            set: function set(value) {
                this.hsv = value;
            }
        },
        {
            key: "hue",
            get: function get() {
                return this.$.h;
            },
            set: function set(value) {
                this.hsv = {
                    h: value
                };
            }
        },
        {
            key: "saturation",
            get: function get() {
                return this.$.s;
            },
            set: function set(value) {
                this.hsv = {
                    s: value
                };
            }
        },
        {
            key: "value",
            get: function get() {
                return this.$.v;
            },
            set: function set(value) {
                this.hsv = {
                    v: value
                };
            }
        },
        {
            key: "alpha",
            get: function get() {
                return this.$.a;
            },
            set: function set(value) {
                this.hsv = $adc4ae8a4d756edf$var$_extends({}, this.hsv, {
                    a: value
                });
            }
        },
        {
            key: "kelvin",
            get: function get() {
                return IroColor.rgbToKelvin(this.rgb);
            },
            set: function set(value) {
                this.rgb = IroColor.kelvinToRgb(value);
            }
        },
        {
            key: "red",
            get: function get() {
                var rgb = this.rgb;
                return rgb.r;
            },
            set: function set(value) {
                this.rgb = $adc4ae8a4d756edf$var$_extends({}, this.rgb, {
                    r: value
                });
            }
        },
        {
            key: "green",
            get: function get() {
                var rgb = this.rgb;
                return rgb.g;
            },
            set: function set(value) {
                this.rgb = $adc4ae8a4d756edf$var$_extends({}, this.rgb, {
                    g: value
                });
            }
        },
        {
            key: "blue",
            get: function get() {
                var rgb = this.rgb;
                return rgb.b;
            },
            set: function set(value) {
                this.rgb = $adc4ae8a4d756edf$var$_extends({}, this.rgb, {
                    b: value
                });
            }
        },
        {
            key: "rgb",
            get: function get() {
                var _IroColor$hsvToRgb = IroColor.hsvToRgb(this.$), r = _IroColor$hsvToRgb.r, g = _IroColor$hsvToRgb.g, b = _IroColor$hsvToRgb.b;
                return {
                    r: $adc4ae8a4d756edf$var$round(r),
                    g: $adc4ae8a4d756edf$var$round(g),
                    b: $adc4ae8a4d756edf$var$round(b)
                };
            },
            set: function set(value) {
                this.hsv = $adc4ae8a4d756edf$var$_extends({}, IroColor.rgbToHsv(value), {
                    a: value.a === undefined ? 1 : value.a
                });
            }
        },
        {
            key: "rgba",
            get: function get() {
                return $adc4ae8a4d756edf$var$_extends({}, this.rgb, {
                    a: this.alpha
                });
            },
            set: function set(value) {
                this.rgb = value;
            }
        },
        {
            key: "hsl",
            get: function get() {
                var _IroColor$hsvToHsl = IroColor.hsvToHsl(this.$), h = _IroColor$hsvToHsl.h, s = _IroColor$hsvToHsl.s, l = _IroColor$hsvToHsl.l;
                return {
                    h: $adc4ae8a4d756edf$var$round(h),
                    s: $adc4ae8a4d756edf$var$round(s),
                    l: $adc4ae8a4d756edf$var$round(l)
                };
            },
            set: function set(value) {
                this.hsv = $adc4ae8a4d756edf$var$_extends({}, IroColor.hslToHsv(value), {
                    a: value.a === undefined ? 1 : value.a
                });
            }
        },
        {
            key: "hsla",
            get: function get() {
                return $adc4ae8a4d756edf$var$_extends({}, this.hsl, {
                    a: this.alpha
                });
            },
            set: function set(value) {
                this.hsl = value;
            }
        },
        {
            key: "rgbString",
            get: function get() {
                var rgb = this.rgb;
                return "rgb(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ")";
            },
            set: function set(value) {
                var match;
                var r, g, b, a = 1;
                if (match = $adc4ae8a4d756edf$var$REGEX_FUNCTIONAL_RGB.exec(value)) {
                    r = $adc4ae8a4d756edf$var$parseUnit(match[1], 255);
                    g = $adc4ae8a4d756edf$var$parseUnit(match[2], 255);
                    b = $adc4ae8a4d756edf$var$parseUnit(match[3], 255);
                } else if (match = $adc4ae8a4d756edf$var$REGEX_FUNCTIONAL_RGBA.exec(value)) {
                    r = $adc4ae8a4d756edf$var$parseUnit(match[1], 255);
                    g = $adc4ae8a4d756edf$var$parseUnit(match[2], 255);
                    b = $adc4ae8a4d756edf$var$parseUnit(match[3], 255);
                    a = $adc4ae8a4d756edf$var$parseUnit(match[4], 1);
                }
                if (match) this.rgb = {
                    r: r,
                    g: g,
                    b: b,
                    a: a
                };
                else throw new Error('Invalid rgb string');
            }
        },
        {
            key: "rgbaString",
            get: function get() {
                var rgba = this.rgba;
                return "rgba(" + rgba.r + ", " + rgba.g + ", " + rgba.b + ", " + rgba.a + ")";
            },
            set: function set(value) {
                this.rgbString = value;
            }
        },
        {
            key: "hexString",
            get: function get() {
                var rgb = this.rgb;
                return "#" + $adc4ae8a4d756edf$var$intToHex(rgb.r) + $adc4ae8a4d756edf$var$intToHex(rgb.g) + $adc4ae8a4d756edf$var$intToHex(rgb.b);
            },
            set: function set(value) {
                var match;
                var r, g, b, a = 255;
                if (match = $adc4ae8a4d756edf$var$REGEX_HEX_3.exec(value)) {
                    r = $adc4ae8a4d756edf$var$parseHexInt(match[1]) * 17;
                    g = $adc4ae8a4d756edf$var$parseHexInt(match[2]) * 17;
                    b = $adc4ae8a4d756edf$var$parseHexInt(match[3]) * 17;
                } else if (match = $adc4ae8a4d756edf$var$REGEX_HEX_4.exec(value)) {
                    r = $adc4ae8a4d756edf$var$parseHexInt(match[1]) * 17;
                    g = $adc4ae8a4d756edf$var$parseHexInt(match[2]) * 17;
                    b = $adc4ae8a4d756edf$var$parseHexInt(match[3]) * 17;
                    a = $adc4ae8a4d756edf$var$parseHexInt(match[4]) * 17;
                } else if (match = $adc4ae8a4d756edf$var$REGEX_HEX_6.exec(value)) {
                    r = $adc4ae8a4d756edf$var$parseHexInt(match[1]);
                    g = $adc4ae8a4d756edf$var$parseHexInt(match[2]);
                    b = $adc4ae8a4d756edf$var$parseHexInt(match[3]);
                } else if (match = $adc4ae8a4d756edf$var$REGEX_HEX_8.exec(value)) {
                    r = $adc4ae8a4d756edf$var$parseHexInt(match[1]);
                    g = $adc4ae8a4d756edf$var$parseHexInt(match[2]);
                    b = $adc4ae8a4d756edf$var$parseHexInt(match[3]);
                    a = $adc4ae8a4d756edf$var$parseHexInt(match[4]);
                }
                if (match) this.rgb = {
                    r: r,
                    g: g,
                    b: b,
                    a: a / 255
                };
                else throw new Error('Invalid hex string');
            }
        },
        {
            key: "hex8String",
            get: function get() {
                var rgba = this.rgba;
                return "#" + $adc4ae8a4d756edf$var$intToHex(rgba.r) + $adc4ae8a4d756edf$var$intToHex(rgba.g) + $adc4ae8a4d756edf$var$intToHex(rgba.b) + $adc4ae8a4d756edf$var$intToHex($adc4ae8a4d756edf$var$floor(rgba.a * 255));
            },
            set: function set(value) {
                this.hexString = value;
            }
        },
        {
            key: "hslString",
            get: function get() {
                var hsl = this.hsl;
                return "hsl(" + hsl.h + ", " + hsl.s + "%, " + hsl.l + "%)";
            },
            set: function set(value) {
                var match;
                var h, s, l, a = 1;
                if (match = $adc4ae8a4d756edf$var$REGEX_FUNCTIONAL_HSL.exec(value)) {
                    h = $adc4ae8a4d756edf$var$parseUnit(match[1], 360);
                    s = $adc4ae8a4d756edf$var$parseUnit(match[2], 100);
                    l = $adc4ae8a4d756edf$var$parseUnit(match[3], 100);
                } else if (match = $adc4ae8a4d756edf$var$REGEX_FUNCTIONAL_HSLA.exec(value)) {
                    h = $adc4ae8a4d756edf$var$parseUnit(match[1], 360);
                    s = $adc4ae8a4d756edf$var$parseUnit(match[2], 100);
                    l = $adc4ae8a4d756edf$var$parseUnit(match[3], 100);
                    a = $adc4ae8a4d756edf$var$parseUnit(match[4], 1);
                }
                if (match) this.hsl = {
                    h: h,
                    s: s,
                    l: l,
                    a: a
                };
                else throw new Error('Invalid hsl string');
            }
        },
        {
            key: "hslaString",
            get: function get() {
                var hsla = this.hsla;
                return "hsla(" + hsla.h + ", " + hsla.s + "%, " + hsla.l + "%, " + hsla.a + ")";
            },
            set: function set(value) {
                this.hslString = value;
            }
        }
    ]);
    return IroColor;
}();
var $adc4ae8a4d756edf$var$sliderDefaultOptions = {
    sliderShape: 'bar',
    sliderType: 'value',
    minTemperature: 2200,
    maxTemperature: 11000
};
/**
 * @desc Get the bounding dimensions of the slider
 * @param props - slider props
 */ function $adc4ae8a4d756edf$var$getSliderDimensions(props) {
    var _sliderSize;
    var width = props.width, sliderSize = props.sliderSize, borderWidth = props.borderWidth, handleRadius = props.handleRadius, padding = props.padding, sliderShape = props.sliderShape;
    var ishorizontal = props.layoutDirection === 'horizontal'; // automatically calculate sliderSize if its not defined
    sliderSize = (_sliderSize = sliderSize) != null ? _sliderSize : padding * 2 + handleRadius * 2;
    if (sliderShape === 'circle') return {
        handleStart: props.padding + props.handleRadius,
        handleRange: width - padding * 2 - handleRadius * 2,
        width: width,
        height: width,
        cx: width / 2,
        cy: width / 2,
        radius: width / 2 - borderWidth / 2
    };
    else return {
        handleStart: sliderSize / 2,
        handleRange: width - sliderSize,
        radius: sliderSize / 2,
        x: 0,
        y: 0,
        width: ishorizontal ? sliderSize : width,
        height: ishorizontal ? width : sliderSize
    };
}
/**
 * @desc Get the current slider value for a given color, as a percentage
 * @param props - slider props
 * @param color
 */ function $adc4ae8a4d756edf$var$getCurrentSliderValue(props, color) {
    var hsva = color.hsva;
    var rgb = color.rgb;
    switch(props.sliderType){
        case 'red':
            return rgb.r / 2.55;
        case 'green':
            return rgb.g / 2.55;
        case 'blue':
            return rgb.b / 2.55;
        case 'alpha':
            return hsva.a * 100;
        case 'kelvin':
            var minTemperature = props.minTemperature, maxTemperature = props.maxTemperature;
            var temperatureRange = maxTemperature - minTemperature;
            var percent = (color.kelvin - minTemperature) / temperatureRange * 100; // clmap percentage
            return Math.max(0, Math.min(percent, 100));
        case 'hue':
            return hsva.h /= 3.6;
        case 'saturation':
            return hsva.s;
        case 'value':
        default:
            return hsva.v;
    }
}
/**
 * @desc Get the current slider value from user input
 * @param props - slider props
 * @param x - global input x position
 * @param y - global input y position
 */ function $adc4ae8a4d756edf$var$getSliderValueFromInput(props, x, y) {
    var _getSliderDimensions = $adc4ae8a4d756edf$var$getSliderDimensions(props), handleRange = _getSliderDimensions.handleRange, handleStart = _getSliderDimensions.handleStart;
    var handlePos;
    if (props.layoutDirection === 'horizontal') handlePos = -1 * y + handleRange + handleStart;
    else handlePos = x - handleStart;
     // clamp handle position
    handlePos = Math.max(Math.min(handlePos, handleRange), 0);
    var percent = Math.round(100 / handleRange * handlePos);
    switch(props.sliderType){
        case 'kelvin':
            var minTemperature = props.minTemperature, maxTemperature = props.maxTemperature;
            var temperatureRange = maxTemperature - minTemperature;
            return minTemperature + temperatureRange * (percent / 100);
        case 'alpha':
            return percent / 100;
        case 'hue':
            return percent * 3.6;
        case 'red':
        case 'blue':
        case 'green':
            return percent * 2.55;
        default:
            return percent;
    }
}
/**
 * @desc Get the current handle position for a given color
 * @param props - slider props
 * @param color
 */ function $adc4ae8a4d756edf$var$getSliderHandlePosition(props, color) {
    var _getSliderDimensions2 = $adc4ae8a4d756edf$var$getSliderDimensions(props), width = _getSliderDimensions2.width, height = _getSliderDimensions2.height, handleRange = _getSliderDimensions2.handleRange, handleStart = _getSliderDimensions2.handleStart;
    var ishorizontal = props.layoutDirection === 'horizontal';
    var sliderValue = $adc4ae8a4d756edf$var$getCurrentSliderValue(props, color);
    var midPoint = ishorizontal ? width / 2 : height / 2;
    var handlePos = handleStart + sliderValue / 100 * handleRange;
    if (ishorizontal) handlePos = -1 * handlePos + handleRange + handleStart * 2;
    return {
        x: ishorizontal ? midPoint : handlePos,
        y: ishorizontal ? handlePos : midPoint
    };
}
/**
 * @desc Get the gradient stops for a slider
 * @param props - slider props
 * @param color
 */ function $adc4ae8a4d756edf$var$getSliderGradient(props, color) {
    var hsv = color.hsv;
    var rgb = color.rgb;
    switch(props.sliderType){
        case 'red':
            return [
                [
                    0,
                    "rgb(0," + rgb.g + "," + rgb.b + ")"
                ],
                [
                    100,
                    "rgb(255," + rgb.g + "," + rgb.b + ")"
                ]
            ];
        case 'green':
            return [
                [
                    0,
                    "rgb(" + rgb.r + "," + 0 + "," + rgb.b + ")"
                ],
                [
                    100,
                    "rgb(" + rgb.r + "," + 255 + "," + rgb.b + ")"
                ]
            ];
        case 'blue':
            return [
                [
                    0,
                    "rgb(" + rgb.r + "," + rgb.g + "," + 0 + ")"
                ],
                [
                    100,
                    "rgb(" + rgb.r + "," + rgb.g + "," + 255 + ")"
                ]
            ];
        case 'alpha':
            return [
                [
                    0,
                    "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ",0)"
                ],
                [
                    100,
                    "rgb(" + rgb.r + "," + rgb.g + "," + rgb.b + ")"
                ]
            ];
        case 'kelvin':
            var stops = [];
            var min = props.minTemperature;
            var max = props.maxTemperature;
            var numStops = 8;
            var range = max - min;
            for(var kelvin = min, stop = 0; kelvin < max; kelvin += range / numStops, stop += 1){
                var _IroColor$kelvinToRgb = $adc4ae8a4d756edf$var$IroColor.kelvinToRgb(kelvin), r = _IroColor$kelvinToRgb.r, g = _IroColor$kelvinToRgb.g, b = _IroColor$kelvinToRgb.b;
                stops.push([
                    100 / numStops * stop,
                    "rgb(" + r + "," + g + "," + b + ")"
                ]);
            }
            return stops;
        case 'hue':
            return [
                [
                    0,
                    '#f00'
                ],
                [
                    16.666,
                    '#ff0'
                ],
                [
                    33.333,
                    '#0f0'
                ],
                [
                    50,
                    '#0ff'
                ],
                [
                    66.666,
                    '#00f'
                ],
                [
                    83.333,
                    '#f0f'
                ],
                [
                    100,
                    '#f00'
                ]
            ];
        case 'saturation':
            var noSat = $adc4ae8a4d756edf$var$IroColor.hsvToHsl({
                h: hsv.h,
                s: 0,
                v: hsv.v
            });
            var fullSat = $adc4ae8a4d756edf$var$IroColor.hsvToHsl({
                h: hsv.h,
                s: 100,
                v: hsv.v
            });
            return [
                [
                    0,
                    "hsl(" + noSat.h + "," + noSat.s + "%," + noSat.l + "%)"
                ],
                [
                    100,
                    "hsl(" + fullSat.h + "," + fullSat.s + "%," + fullSat.l + "%)"
                ]
            ];
        case 'value':
        default:
            var hsl = $adc4ae8a4d756edf$var$IroColor.hsvToHsl({
                h: hsv.h,
                s: hsv.s,
                v: 100
            });
            return [
                [
                    0,
                    '#000'
                ],
                [
                    100,
                    "hsl(" + hsl.h + "," + hsl.s + "%," + hsl.l + "%)"
                ]
            ];
    }
}
var $adc4ae8a4d756edf$var$TAU = Math.PI * 2; // javascript's modulo operator doesn't produce positive numbers with negative input
// https://dev.to/maurobringolf/a-neat-trick-to-compute-modulo-of-negative-numbers-111e
var $adc4ae8a4d756edf$var$mod = function mod(a, n) {
    return (a % n + n) % n;
}; // distance between points (x, y) and (0, 0)
var $adc4ae8a4d756edf$var$dist = function dist(x, y) {
    return Math.sqrt(x * x + y * y);
};
/**
 * @param props - wheel props
 * @internal
 */ function $adc4ae8a4d756edf$var$getHandleRange(props) {
    return props.width / 2 - props.padding - props.handleRadius - props.borderWidth;
}
/**
 * Returns true if point (x, y) lands inside the wheel
 * @param props - wheel props
 * @param x
 * @param y
 */ function $adc4ae8a4d756edf$var$isInputInsideWheel(props, x, y) {
    var _getWheelDimensions = $adc4ae8a4d756edf$var$getWheelDimensions(props), cx = _getWheelDimensions.cx, cy = _getWheelDimensions.cy;
    var r = props.width / 2;
    return $adc4ae8a4d756edf$var$dist(cx - x, cy - y) < r;
}
/**
 * @desc Get the point as the center of the wheel
 * @param props - wheel props
 */ function $adc4ae8a4d756edf$var$getWheelDimensions(props) {
    var r = props.width / 2;
    return {
        width: props.width,
        radius: r - props.borderWidth,
        cx: r,
        cy: r
    };
}
/**
 * @desc Translate an angle according to wheelAngle and wheelDirection
 * @param props - wheel props
 * @param angle - input angle
 */ function $adc4ae8a4d756edf$var$translateWheelAngle(props, angle, invert) {
    var wheelAngle = props.wheelAngle;
    var wheelDirection = props.wheelDirection; // inverted and clockwisee
    if (invert && wheelDirection === 'clockwise') angle = wheelAngle + angle;
    else if (wheelDirection === 'clockwise') angle = 360 - wheelAngle + angle;
    else if (invert && wheelDirection === 'anticlockwise') angle = wheelAngle + 180 - angle;
    else if (wheelDirection === 'anticlockwise') angle = wheelAngle - angle;
    return $adc4ae8a4d756edf$var$mod(angle, 360);
}
/**
 * @desc Get the current handle position for a given color
 * @param props - wheel props
 * @param color
 */ function $adc4ae8a4d756edf$var$getWheelHandlePosition(props, color) {
    var hsv = color.hsv;
    var _getWheelDimensions2 = $adc4ae8a4d756edf$var$getWheelDimensions(props), cx = _getWheelDimensions2.cx, cy = _getWheelDimensions2.cy;
    var handleRange = $adc4ae8a4d756edf$var$getHandleRange(props);
    var handleAngle = (180 + $adc4ae8a4d756edf$var$translateWheelAngle(props, hsv.h, true)) * ($adc4ae8a4d756edf$var$TAU / 360);
    var handleDist = hsv.s / 100 * handleRange;
    var direction = props.wheelDirection === 'clockwise' ? -1 : 1;
    return {
        x: cx + handleDist * Math.cos(handleAngle) * direction,
        y: cy + handleDist * Math.sin(handleAngle) * direction
    };
}
/**
 * @desc Get the current wheel value from user input
 * @param props - wheel props
 * @param x - global input x position
 * @param y - global input y position
 */ function $adc4ae8a4d756edf$var$getWheelValueFromInput(props, x, y) {
    var _getWheelDimensions3 = $adc4ae8a4d756edf$var$getWheelDimensions(props), cx = _getWheelDimensions3.cx, cy = _getWheelDimensions3.cy;
    var handleRange = $adc4ae8a4d756edf$var$getHandleRange(props);
    x = cx - x;
    y = cy - y; // Calculate the hue by converting the angle to radians
    var hue = $adc4ae8a4d756edf$var$translateWheelAngle(props, Math.atan2(-y, -x) * (360 / $adc4ae8a4d756edf$var$TAU)); // Find the point's distance from the center of the wheel
    // This is used to show the saturation level
    var handleDist = Math.min($adc4ae8a4d756edf$var$dist(x, y), handleRange);
    return {
        h: Math.round(hue),
        s: Math.round(100 / handleRange * handleDist)
    };
}
/**
 * @desc Get the bounding dimensions of the box
 * @param props - box props
 */ function $adc4ae8a4d756edf$var$getBoxDimensions(props) {
    var width = props.width, boxHeight = props.boxHeight, padding = props.padding, handleRadius = props.handleRadius;
    return {
        width: width,
        height: boxHeight != null ? boxHeight : width,
        radius: padding + handleRadius
    };
}
/**
 * @desc Get the current box value from user input
 * @param props - box props
 * @param x - global input x position
 * @param y - global input y position
 */ function $adc4ae8a4d756edf$var$getBoxValueFromInput(props, x, y) {
    var _getBoxDimensions = $adc4ae8a4d756edf$var$getBoxDimensions(props), width = _getBoxDimensions.width, height = _getBoxDimensions.height, radius = _getBoxDimensions.radius;
    var handleStart = radius;
    var handleRangeX = width - radius * 2;
    var handleRangeY = height - radius * 2;
    var percentX = (x - handleStart) / handleRangeX * 100;
    var percentY = (y - handleStart) / handleRangeY * 100;
    return {
        s: Math.max(0, Math.min(percentX, 100)),
        v: Math.max(0, Math.min(100 - percentY, 100))
    };
}
/**
 * @desc Get the current box handle position for a given color
 * @param props - box props
 * @param color
 */ function $adc4ae8a4d756edf$var$getBoxHandlePosition(props, color) {
    var _getBoxDimensions2 = $adc4ae8a4d756edf$var$getBoxDimensions(props), width = _getBoxDimensions2.width, height = _getBoxDimensions2.height, radius = _getBoxDimensions2.radius;
    var hsv = color.hsv;
    var handleStart = radius;
    var handleRangeX = width - radius * 2;
    var handleRangeY = height - radius * 2;
    return {
        x: handleStart + hsv.s / 100 * handleRangeX,
        y: handleStart + (handleRangeY - hsv.v / 100 * handleRangeY)
    };
}
/**
 * @desc Get the gradient stops for a box
 * @param props - box props
 * @param color
 */ function $adc4ae8a4d756edf$var$getBoxGradients(props, color) {
    var hue = color.hue;
    return [
        [
            [
                0,
                '#fff'
            ],
            [
                100,
                "hsl(" + hue + ",100%,50%)"
            ]
        ],
        [
            [
                0,
                'rgba(0,0,0,0)'
            ],
            [
                100,
                '#000'
            ]
        ]
    ];
}
// Keep track of html <base> elements for resolveSvgUrl
// getElementsByTagName returns a live HTMLCollection, which stays in sync with the DOM tree
// So it only needs to be called once
var $adc4ae8a4d756edf$var$BASE_ELEMENTS;
/**
 * @desc Resolve an SVG reference URL
 * This is required to work around how Safari and iOS webviews handle gradient URLS under certain conditions
 * If a page is using a client-side routing library which makes use of the HTML <base> tag,
 * Safari won't be able to render SVG gradients properly (as they are referenced by URLs)
 * More info on the problem:
 * https://stackoverflow.com/questions/19742805/angular-and-svg-filters/19753427#19753427
 * https://github.com/jaames/iro.js/issues/18
 * https://github.com/jaames/iro.js/issues/45
 * https://github.com/jaames/iro.js/pull/89
 * @props url - SVG reference URL
 */ function $adc4ae8a4d756edf$var$resolveSvgUrl(url) {
    if (!$adc4ae8a4d756edf$var$BASE_ELEMENTS) $adc4ae8a4d756edf$var$BASE_ELEMENTS = document.getElementsByTagName('base');
     // Sniff useragent string to check if the user is running Safari
    var ua = window.navigator.userAgent;
    var isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    var isIos = /iPhone|iPod|iPad/i.test(ua);
    var location = window.location;
    return (isSafari || isIos) && $adc4ae8a4d756edf$var$BASE_ELEMENTS.length > 0 ? location.protocol + "//" + location.host + location.pathname + location.search + url : url;
}
/**
 * @desc Given a specifc (x, y) position, test if there's a handle there and return its index, else return null.
 *       This is used for components like the box and wheel which support multiple handles when multicolor is active
 * @props x - point x position
 * @props y - point y position
 * @props handlePositions - array of {x, y} coords for each handle
 */ function $adc4ae8a4d756edf$var$getHandleAtPoint(props, x, y, handlePositions) {
    for(var i = 0; i < handlePositions.length; i++){
        var dX = handlePositions[i].x - x;
        var dY = handlePositions[i].y - y;
        var dist = Math.sqrt(dX * dX + dY * dY);
        if (dist < props.handleRadius) return i;
    }
    return null;
}
function $adc4ae8a4d756edf$var$cssBorderStyles(props) {
    return {
        boxSizing: 'border-box',
        border: props.borderWidth + "px solid " + props.borderColor
    };
}
function $adc4ae8a4d756edf$var$cssGradient(type, direction, stops) {
    return type + "-gradient(" + direction + ", " + stops.map(function(_ref) {
        var o = _ref[0], col = _ref[1];
        return col + " " + o + "%";
    }).join(',') + ")";
}
function $adc4ae8a4d756edf$var$cssValue(value) {
    if (typeof value === 'string') return value;
    return value + "px";
}
var $adc4ae8a4d756edf$var$iroColorPickerOptionDefaults = {
    width: 300,
    height: 300,
    color: '#fff',
    colors: [],
    padding: 6,
    layoutDirection: 'vertical',
    borderColor: '#fff',
    borderWidth: 0,
    handleRadius: 8,
    activeHandleRadius: null,
    handleSvg: null,
    handleProps: {
        x: 0,
        y: 0
    },
    wheelLightness: true,
    wheelAngle: 0,
    wheelDirection: 'anticlockwise',
    sliderSize: null,
    sliderMargin: 12,
    boxHeight: null
};
var $adc4ae8a4d756edf$var$SECONDARY_EVENTS = [
    "mousemove" /* MouseMove */ ,
    "touchmove" /* TouchMove */ ,
    "mouseup" /* MouseUp */ ,
    "touchend" /* TouchEnd */ 
];
// Base component class for iro UI components
// This extends the Preact component class to allow them to react to mouse/touch input events by themselves
var $adc4ae8a4d756edf$var$IroComponentWrapper = /*@__PURE__*/ function(Component) {
    function IroComponentWrapper(props) {
        Component.call(this, props);
        // Generate unique ID for the component
        // This can be used to generate unique IDs for gradients, etc
        this.uid = (Math.random() + 1).toString(36).substring(5);
    }
    if (Component) IroComponentWrapper.__proto__ = Component;
    IroComponentWrapper.prototype = Object.create(Component && Component.prototype);
    IroComponentWrapper.prototype.constructor = IroComponentWrapper;
    IroComponentWrapper.prototype.render = function render(props) {
        var eventHandler = this.handleEvent.bind(this);
        var rootProps = {
            onMouseDown: eventHandler,
            // https://github.com/jaames/iro.js/issues/126
            // https://github.com/preactjs/preact/issues/2113#issuecomment-553408767
            ontouchstart: eventHandler
        };
        var isHorizontal = props.layoutDirection === 'horizontal';
        var margin = props.margin === null ? props.sliderMargin : props.margin;
        var rootStyles = {
            overflow: 'visible',
            display: isHorizontal ? 'inline-block' : 'block'
        };
        // first component shouldn't have any margin
        if (props.index > 0) rootStyles[isHorizontal ? 'marginLeft' : 'marginTop'] = margin;
        return $adc4ae8a4d756edf$var$h($adc4ae8a4d756edf$var$d, null, props.children(this.uid, rootProps, rootStyles));
    };
    // More info on handleEvent:
    // https://medium.com/@WebReflection/dom-handleevent-a-cross-platform-standard-since-year-2000-5bf17287fd38
    // TL;DR this lets us have a single point of entry for multiple events, and we can avoid callback/binding hell
    IroComponentWrapper.prototype.handleEvent = function handleEvent(e) {
        var this$1 = this;
        var inputHandler = this.props.onInput;
        // Get the screen position of the component
        var bounds = this.base.getBoundingClientRect();
        // Prefect default browser action
        e.preventDefault();
        // Detect if the event is a touch event by checking if it has the `touches` property
        // If it is a touch event, use the first touch input
        var point = e.touches ? e.changedTouches[0] : e;
        var x = point.clientX - bounds.left;
        var y = point.clientY - bounds.top;
        switch(e.type){
            case "mousedown" /* MouseDown */ :
            case "touchstart" /* TouchStart */ :
                var result = inputHandler(x, y, 0 /* Start */ );
                if (result !== false) $adc4ae8a4d756edf$var$SECONDARY_EVENTS.forEach(function(event) {
                    document.addEventListener(event, this$1, {
                        passive: false
                    });
                });
                break;
            case "mousemove" /* MouseMove */ :
            case "touchmove" /* TouchMove */ :
                inputHandler(x, y, 1 /* Move */ );
                break;
            case "mouseup" /* MouseUp */ :
            case "touchend" /* TouchEnd */ :
                inputHandler(x, y, 2 /* End */ );
                $adc4ae8a4d756edf$var$SECONDARY_EVENTS.forEach(function(event) {
                    document.removeEventListener(event, this$1, {
                        passive: false
                    });
                });
                break;
        }
    };
    return IroComponentWrapper;
}($adc4ae8a4d756edf$var$m);
function $adc4ae8a4d756edf$var$IroHandle(props) {
    var radius = props.r;
    var url = props.url;
    var cx = radius;
    var cy = radius;
    return $adc4ae8a4d756edf$var$h("svg", {
        className: "IroHandle IroHandle--" + props.index + " " + (props.isActive ? 'IroHandle--isActive' : ''),
        style: {
            '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0);',
            transform: "translate(" + $adc4ae8a4d756edf$var$cssValue(props.x) + ", " + $adc4ae8a4d756edf$var$cssValue(props.y) + ")",
            willChange: 'transform',
            top: $adc4ae8a4d756edf$var$cssValue(-radius),
            left: $adc4ae8a4d756edf$var$cssValue(-radius),
            width: $adc4ae8a4d756edf$var$cssValue(radius * 2),
            height: $adc4ae8a4d756edf$var$cssValue(radius * 2),
            position: 'absolute',
            overflow: 'visible'
        }
    }, url && $adc4ae8a4d756edf$var$h("use", Object.assign({
        xlinkHref: $adc4ae8a4d756edf$var$resolveSvgUrl(url)
    }, props.props)), !url && $adc4ae8a4d756edf$var$h("circle", {
        cx: cx,
        cy: cy,
        r: radius,
        fill: "none",
        "stroke-width": 2,
        stroke: "#000"
    }), !url && $adc4ae8a4d756edf$var$h("circle", {
        cx: cx,
        cy: cy,
        r: radius - 2,
        fill: props.fill,
        "stroke-width": 2,
        stroke: "#fff"
    }));
}
$adc4ae8a4d756edf$var$IroHandle.defaultProps = {
    fill: 'none',
    x: 0,
    y: 0,
    r: 8,
    url: null,
    props: {
        x: 0,
        y: 0
    }
};
function $adc4ae8a4d756edf$var$IroSlider(props) {
    var activeIndex = props.activeIndex;
    var activeColor = activeIndex !== undefined && activeIndex < props.colors.length ? props.colors[activeIndex] : props.color;
    var ref = $adc4ae8a4d756edf$var$getSliderDimensions(props);
    var width = ref.width;
    var height = ref.height;
    var radius = ref.radius;
    var handlePos = $adc4ae8a4d756edf$var$getSliderHandlePosition(props, activeColor);
    var gradient = $adc4ae8a4d756edf$var$getSliderGradient(props, activeColor);
    function handleInput(x, y, type) {
        var value = $adc4ae8a4d756edf$var$getSliderValueFromInput(props, x, y);
        props.parent.inputActive = true;
        activeColor[props.sliderType] = value;
        props.onInput(type, props.id);
    }
    return $adc4ae8a4d756edf$var$h($adc4ae8a4d756edf$var$IroComponentWrapper, Object.assign({}, props, {
        onInput: handleInput
    }), function(uid, rootProps, rootStyles) {
        return $adc4ae8a4d756edf$var$h("div", Object.assign({}, rootProps, {
            className: "IroSlider",
            style: Object.assign({}, {
                position: 'relative',
                width: $adc4ae8a4d756edf$var$cssValue(width),
                height: $adc4ae8a4d756edf$var$cssValue(height),
                borderRadius: $adc4ae8a4d756edf$var$cssValue(radius),
                // checkered bg to represent alpha
                background: "conic-gradient(#ccc 25%, #fff 0 50%, #ccc 0 75%, #fff 0)",
                backgroundSize: '8px 8px'
            }, rootStyles)
        }), $adc4ae8a4d756edf$var$h("div", {
            className: "IroSliderGradient",
            style: Object.assign({}, {
                position: 'absolute',
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: $adc4ae8a4d756edf$var$cssValue(radius),
                background: $adc4ae8a4d756edf$var$cssGradient('linear', props.layoutDirection === 'horizontal' ? 'to top' : 'to right', gradient)
            }, $adc4ae8a4d756edf$var$cssBorderStyles(props))
        }), $adc4ae8a4d756edf$var$h($adc4ae8a4d756edf$var$IroHandle, {
            isActive: true,
            index: activeColor.index,
            r: props.handleRadius,
            url: props.handleSvg,
            props: props.handleProps,
            x: handlePos.x,
            y: handlePos.y
        }));
    });
}
$adc4ae8a4d756edf$var$IroSlider.defaultProps = Object.assign({}, $adc4ae8a4d756edf$var$sliderDefaultOptions);
function $adc4ae8a4d756edf$var$IroBox(props) {
    var ref = $adc4ae8a4d756edf$var$getBoxDimensions(props);
    var width = ref.width;
    var height = ref.height;
    var radius = ref.radius;
    var colors = props.colors;
    var colorPicker = props.parent;
    var activeIndex = props.activeIndex;
    var activeColor = activeIndex !== undefined && activeIndex < props.colors.length ? props.colors[activeIndex] : props.color;
    var gradients = $adc4ae8a4d756edf$var$getBoxGradients(props, activeColor);
    var handlePositions = colors.map(function(color) {
        return $adc4ae8a4d756edf$var$getBoxHandlePosition(props, color);
    });
    function handleInput(x, y, inputType) {
        if (inputType === 0 /* Start */ ) {
            // getHandleAtPoint() returns the index for the handle if the point 'hits' it, or null otherwise
            var activeHandle = $adc4ae8a4d756edf$var$getHandleAtPoint(props, x, y, handlePositions);
            // If the input hit a handle, set it as the active handle, but don't update the color
            if (activeHandle !== null) colorPicker.setActiveColor(activeHandle);
            else {
                colorPicker.inputActive = true;
                activeColor.hsv = $adc4ae8a4d756edf$var$getBoxValueFromInput(props, x, y);
                props.onInput(inputType, props.id);
            }
        } else if (inputType === 1 /* Move */ ) {
            colorPicker.inputActive = true;
            activeColor.hsv = $adc4ae8a4d756edf$var$getBoxValueFromInput(props, x, y);
        }
        // let the color picker fire input:start, input:move or input:end events
        props.onInput(inputType, props.id);
    }
    return $adc4ae8a4d756edf$var$h($adc4ae8a4d756edf$var$IroComponentWrapper, Object.assign({}, props, {
        onInput: handleInput
    }), function(uid, rootProps, rootStyles) {
        return $adc4ae8a4d756edf$var$h("div", Object.assign({}, rootProps, {
            className: "IroBox",
            style: Object.assign({}, {
                width: $adc4ae8a4d756edf$var$cssValue(width),
                height: $adc4ae8a4d756edf$var$cssValue(height),
                position: 'relative'
            }, rootStyles)
        }), $adc4ae8a4d756edf$var$h("div", {
            className: "IroBox",
            style: Object.assign({}, {
                width: '100%',
                height: '100%',
                borderRadius: $adc4ae8a4d756edf$var$cssValue(radius)
            }, $adc4ae8a4d756edf$var$cssBorderStyles(props), {
                background: $adc4ae8a4d756edf$var$cssGradient('linear', 'to bottom', gradients[1]) + ',' + $adc4ae8a4d756edf$var$cssGradient('linear', 'to right', gradients[0])
            })
        }), colors.filter(function(color) {
            return color !== activeColor;
        }).map(function(color) {
            return $adc4ae8a4d756edf$var$h($adc4ae8a4d756edf$var$IroHandle, {
                isActive: false,
                index: color.index,
                fill: color.hslString,
                r: props.handleRadius,
                url: props.handleSvg,
                props: props.handleProps,
                x: handlePositions[color.index].x,
                y: handlePositions[color.index].y
            });
        }), $adc4ae8a4d756edf$var$h($adc4ae8a4d756edf$var$IroHandle, {
            isActive: true,
            index: activeColor.index,
            fill: activeColor.hslString,
            r: props.activeHandleRadius || props.handleRadius,
            url: props.handleSvg,
            props: props.handleProps,
            x: handlePositions[activeColor.index].x,
            y: handlePositions[activeColor.index].y
        }));
    });
}
var $adc4ae8a4d756edf$var$HUE_GRADIENT_CLOCKWISE = 'conic-gradient(red, yellow, lime, aqua, blue, magenta, red)';
var $adc4ae8a4d756edf$var$HUE_GRADIENT_ANTICLOCKWISE = 'conic-gradient(red, magenta, blue, aqua, lime, yellow, red)';
function $adc4ae8a4d756edf$var$IroWheel(props) {
    var ref = $adc4ae8a4d756edf$var$getWheelDimensions(props);
    var width = ref.width;
    var colors = props.colors;
    var borderWidth = props.borderWidth;
    var colorPicker = props.parent;
    var activeColor = props.color;
    var hsv = activeColor.hsv;
    var handlePositions = colors.map(function(color) {
        return $adc4ae8a4d756edf$var$getWheelHandlePosition(props, color);
    });
    var circleStyles = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        boxSizing: 'border-box'
    };
    function handleInput(x, y, inputType) {
        if (inputType === 0 /* Start */ ) {
            // input hitbox is a square, 
            // so we want to ignore any initial clicks outside the circular shape of the wheel
            if (!$adc4ae8a4d756edf$var$isInputInsideWheel(props, x, y)) // returning false will cease all event handling for this interaction
            return false;
            // getHandleAtPoint() returns the index for the handle if the point 'hits' it, or null otherwise
            var activeHandle = $adc4ae8a4d756edf$var$getHandleAtPoint(props, x, y, handlePositions);
            // If the input hit a handle, set it as the active handle, but don't update the color
            if (activeHandle !== null) colorPicker.setActiveColor(activeHandle);
            else {
                colorPicker.inputActive = true;
                activeColor.hsv = $adc4ae8a4d756edf$var$getWheelValueFromInput(props, x, y);
                props.onInput(inputType, props.id);
            }
        } else if (inputType === 1 /* Move */ ) {
            colorPicker.inputActive = true;
            activeColor.hsv = $adc4ae8a4d756edf$var$getWheelValueFromInput(props, x, y);
        }
        // let the color picker fire input:start, input:move or input:end events
        props.onInput(inputType, props.id);
    }
    return $adc4ae8a4d756edf$var$h($adc4ae8a4d756edf$var$IroComponentWrapper, Object.assign({}, props, {
        onInput: handleInput
    }), function(uid, rootProps, rootStyles) {
        return $adc4ae8a4d756edf$var$h("div", Object.assign({}, rootProps, {
            className: "IroWheel",
            style: Object.assign({}, {
                width: $adc4ae8a4d756edf$var$cssValue(width),
                height: $adc4ae8a4d756edf$var$cssValue(width),
                position: 'relative'
            }, rootStyles)
        }), $adc4ae8a4d756edf$var$h("div", {
            className: "IroWheelHue",
            style: Object.assign({}, circleStyles, {
                transform: "rotateZ(" + (props.wheelAngle + 90) + "deg)",
                background: props.wheelDirection === 'clockwise' ? $adc4ae8a4d756edf$var$HUE_GRADIENT_CLOCKWISE : $adc4ae8a4d756edf$var$HUE_GRADIENT_ANTICLOCKWISE
            })
        }), $adc4ae8a4d756edf$var$h("div", {
            className: "IroWheelSaturation",
            style: Object.assign({}, circleStyles, {
                background: 'radial-gradient(circle closest-side, #fff, transparent)'
            })
        }), props.wheelLightness && $adc4ae8a4d756edf$var$h("div", {
            className: "IroWheelLightness",
            style: Object.assign({}, circleStyles, {
                background: '#000',
                opacity: 1 - hsv.v / 100
            })
        }), $adc4ae8a4d756edf$var$h("div", {
            className: "IroWheelBorder",
            style: Object.assign({}, circleStyles, $adc4ae8a4d756edf$var$cssBorderStyles(props))
        }), colors.filter(function(color) {
            return color !== activeColor;
        }).map(function(color) {
            return $adc4ae8a4d756edf$var$h($adc4ae8a4d756edf$var$IroHandle, {
                isActive: false,
                index: color.index,
                fill: color.hslString,
                r: props.handleRadius,
                url: props.handleSvg,
                props: props.handleProps,
                x: handlePositions[color.index].x,
                y: handlePositions[color.index].y
            });
        }), $adc4ae8a4d756edf$var$h($adc4ae8a4d756edf$var$IroHandle, {
            isActive: true,
            index: activeColor.index,
            fill: activeColor.hslString,
            r: props.activeHandleRadius || props.handleRadius,
            url: props.handleSvg,
            props: props.handleProps,
            x: handlePositions[activeColor.index].x,
            y: handlePositions[activeColor.index].y
        }));
    });
}
function $adc4ae8a4d756edf$var$createWidget(WidgetComponent) {
    var widgetFactory = function(parent, props) {
        var widget; // will become an instance of the widget component class
        var widgetRoot = document.createElement('div');
        // Render widget into a temp DOM node
        $adc4ae8a4d756edf$var$I($adc4ae8a4d756edf$var$h(WidgetComponent, Object.assign({}, {
            ref: function(ref) {
                return widget = ref;
            }
        }, props)), widgetRoot);
        function mountWidget() {
            var container = parent instanceof Element ? parent : document.querySelector(parent);
            container.appendChild(widget.base);
            widget.onMount(container);
        }
        // Mount it into the DOM when the page document is ready
        if (document.readyState !== 'loading') mountWidget();
        else document.addEventListener('DOMContentLoaded', mountWidget);
        return widget;
    };
    // Allow the widget factory to inherit component prototype + static class methods
    // This makes it easier for plugin authors to extend the base widget component
    widgetFactory.prototype = WidgetComponent.prototype;
    Object.assign(widgetFactory, WidgetComponent);
    // Add reference to base component too
    widgetFactory.__component = WidgetComponent;
    return widgetFactory;
}
var $adc4ae8a4d756edf$var$IroColorPicker = /*@__PURE__*/ function(Component) {
    function IroColorPicker(props) {
        var this$1 = this;
        Component.call(this, props);
        this.colors = [];
        this.inputActive = false;
        this.events = {};
        this.activeEvents = {};
        this.deferredEvents = {};
        this.id = props.id;
        var colors = props.colors.length > 0 ? props.colors : [
            props.color
        ];
        colors.forEach(function(colorValue) {
            return this$1.addColor(colorValue);
        });
        this.setActiveColor(0);
        // Pass all the props into the component's state,
        // Except we want to add the color object and make sure that refs aren't passed down to children
        this.state = Object.assign({}, props, {
            color: this.color,
            colors: this.colors,
            layout: props.layout
        });
    }
    if (Component) IroColorPicker.__proto__ = Component;
    IroColorPicker.prototype = Object.create(Component && Component.prototype);
    IroColorPicker.prototype.constructor = IroColorPicker;
    // Plubic multicolor API
    /**
    * @desc Add a color to the color picker
    * @param color new color to add
    * @param index optional color index
    */ IroColorPicker.prototype.addColor = function addColor(color, index) {
        if (index === void 0) index = this.colors.length;
        // Create a new iro.Color
        // Also bind it to onColorChange, so whenever the color changes it updates the color picker
        var newColor = new $adc4ae8a4d756edf$var$IroColor(color, this.onColorChange.bind(this));
        // Insert color @ the given index
        this.colors.splice(index, 0, newColor);
        // Reindex colors
        this.colors.forEach(function(color, index) {
            return color.index = index;
        });
        // Update picker state if necessary
        if (this.state) this.setState({
            colors: this.colors
        });
        // Fire color init event
        this.deferredEmit('color:init', newColor);
    };
    /**
     * @desc Remove a color from the color picker
     * @param index color index
     */ IroColorPicker.prototype.removeColor = function removeColor(index) {
        var color = this.colors.splice(index, 1)[0];
        // Destroy the color object -- this unbinds it from the color picker
        color.unbind();
        // Reindex colors
        this.colors.forEach(function(color, index) {
            return color.index = index;
        });
        // Update picker state if necessary
        if (this.state) this.setState({
            colors: this.colors
        });
        // If the active color was removed, default active color to 0
        if (color.index === this.color.index) this.setActiveColor(0);
        // Fire color remove event
        this.emit('color:remove', color);
    };
    /**
     * @desc Set the currently active color
     * @param index color index
     */ IroColorPicker.prototype.setActiveColor = function setActiveColor(index) {
        this.color = this.colors[index];
        if (this.state) this.setState({
            color: this.color
        });
        // Fire color switch event
        this.emit('color:setActive', this.color);
    };
    /**
     * @desc Replace all of the current colorPicker colors
     * @param newColorValues list of new colors to add
     */ IroColorPicker.prototype.setColors = function setColors(newColorValues, activeColorIndex) {
        var this$1 = this;
        if (activeColorIndex === void 0) activeColorIndex = 0;
        // Unbind color events
        this.colors.forEach(function(color) {
            return color.unbind();
        });
        // Destroy old colors
        this.colors = [];
        // Add new colors
        newColorValues.forEach(function(colorValue) {
            return this$1.addColor(colorValue);
        });
        // Reset active color
        this.setActiveColor(activeColorIndex);
        this.emit('color:setAll', this.colors);
    };
    // Public ColorPicker events API
    /**
     * @desc Set a callback function for an event
     * @param eventList event(s) to listen to
     * @param callback - Function called when the event is fired
     */ IroColorPicker.prototype.on = function on(eventList, callback) {
        var this$1 = this;
        var events = this.events;
        // eventList can be an eventType string or an array of eventType strings
        (!Array.isArray(eventList) ? [
            eventList
        ] : eventList).forEach(function(eventType) {
            // Add event callback
            (events[eventType] || (events[eventType] = [])).push(callback);
            // Call deferred events
            // These are events that can be stored until a listener for them is added
            if (this$1.deferredEvents[eventType]) {
                // Deffered events store an array of arguments from when the event was called
                this$1.deferredEvents[eventType].forEach(function(args) {
                    callback.apply(null, args);
                });
                // Clear deferred events
                this$1.deferredEvents[eventType] = [];
            }
        });
    };
    /**
     * @desc Remove a callback function for an event added with on()
     * @param eventList - event(s) to listen to
     * @param callback - original callback function to remove
     */ IroColorPicker.prototype.off = function off(eventList, callback) {
        var this$1 = this;
        (!Array.isArray(eventList) ? [
            eventList
        ] : eventList).forEach(function(eventType) {
            var callbackList = this$1.events[eventType];
            // this.emitHook('event:off', eventType, callback);
            if (callbackList) callbackList.splice(callbackList.indexOf(callback), 1);
        });
    };
    /**
     * @desc Emit an event
     * @param eventType event to emit
     */ IroColorPicker.prototype.emit = function emit(eventType) {
        var this$1 = this;
        var args = [], len = arguments.length - 1;
        while(len-- > 0)args[len] = arguments[len + 1];
        var activeEvents = this.activeEvents;
        var isEventActive = activeEvents.hasOwnProperty(eventType) ? activeEvents[eventType] : false;
        // Prevent event callbacks from firing if the event is already active
        // This stops infinite loops if something in an event callback causes the same event to be fired again
        // (e.g. setting the color inside a color:change callback)
        if (!isEventActive) {
            activeEvents[eventType] = true;
            var callbackList = this.events[eventType] || [];
            callbackList.forEach(function(fn) {
                return fn.apply(this$1, args);
            });
            activeEvents[eventType] = false;
        }
    };
    /**
     * @desc Emit an event now, or save it for when the relevent event listener is added
     * @param eventType - The name of the event to emit
     */ IroColorPicker.prototype.deferredEmit = function deferredEmit(eventType) {
        var ref;
        var args = [], len = arguments.length - 1;
        while(len-- > 0)args[len] = arguments[len + 1];
        var deferredEvents = this.deferredEvents;
        (ref = this).emit.apply(ref, [
            eventType
        ].concat(args));
        (deferredEvents[eventType] || (deferredEvents[eventType] = [])).push(args);
    };
    // Public utility methods
    IroColorPicker.prototype.setOptions = function setOptions(newOptions) {
        this.setState(newOptions);
    };
    /**
     * @desc Resize the color picker
     * @param width - new width
     */ IroColorPicker.prototype.resize = function resize(width) {
        this.setOptions({
            width: width
        });
    };
    /**
     * @desc Reset the color picker to the initial color provided in the color picker options
     */ IroColorPicker.prototype.reset = function reset() {
        this.colors.forEach(function(color) {
            return color.reset();
        });
        this.setState({
            colors: this.colors
        });
    };
    /**
     * @desc Called by the createWidget wrapper when the element is mounted into the page
     * @param container - the container element for this ColorPicker instance
     */ IroColorPicker.prototype.onMount = function onMount(container) {
        this.el = container;
        this.deferredEmit('mount', this);
    };
    // Internal methods
    /**
     * @desc React to a color update
     * @param color - current color
     * @param changes - shows which h,s,v,a color channels changed
     */ IroColorPicker.prototype.onColorChange = function onColorChange(color, changes) {
        this.setState({
            color: this.color
        });
        if (this.inputActive) {
            this.inputActive = false;
            this.emit('input:change', color, changes);
        }
        this.emit('color:change', color, changes);
    };
    /**
     * @desc Handle input from a UI control element
     * @param type - event type
     */ IroColorPicker.prototype.emitInputEvent = function emitInputEvent(type, originId) {
        if (type === 0 /* Start */ ) this.emit('input:start', this.color, originId);
        else if (type === 1 /* Move */ ) this.emit('input:move', this.color, originId);
        else if (type === 2 /* End */ ) this.emit('input:end', this.color, originId);
    };
    IroColorPicker.prototype.render = function render(props, state) {
        var this$1 = this;
        var layout = state.layout;
        // use layout shorthands
        if (!Array.isArray(layout)) {
            layout;
            layout = [
                {
                    component: $adc4ae8a4d756edf$var$IroWheel
                },
                {
                    component: $adc4ae8a4d756edf$var$IroSlider
                }
            ];
            // add transparency slider to the layout
            if (state.transparency) layout.push({
                component: $adc4ae8a4d756edf$var$IroSlider,
                options: {
                    sliderType: 'alpha'
                }
            });
        }
        return $adc4ae8a4d756edf$var$h("div", {
            class: "IroColorPicker",
            id: state.id,
            style: {
                display: state.display
            }
        }, layout.map(function(ref, componentIndex) {
            var UiComponent = ref.component;
            var options = ref.options;
            return $adc4ae8a4d756edf$var$h(UiComponent, Object.assign({}, state, options, {
                ref: undefined,
                onInput: this$1.emitInputEvent.bind(this$1),
                parent: this$1,
                index: componentIndex
            }));
        }));
    };
    return IroColorPicker;
}($adc4ae8a4d756edf$var$m);
$adc4ae8a4d756edf$var$IroColorPicker.defaultProps = Object.assign({}, $adc4ae8a4d756edf$var$iroColorPickerOptionDefaults, {
    colors: [],
    display: 'block',
    id: null,
    layout: 'default',
    margin: null
});
var $adc4ae8a4d756edf$var$IroColorPickerWidget = $adc4ae8a4d756edf$var$createWidget($adc4ae8a4d756edf$var$IroColorPicker);
var $adc4ae8a4d756edf$var$iro;
(function(iro) {
    iro.version = "5.5.2"; // replaced by @rollup/plugin-replace; see rollup.config.js
    iro.Color = $adc4ae8a4d756edf$var$IroColor;
    iro.ColorPicker = $adc4ae8a4d756edf$var$IroColorPickerWidget;
    var ui;
    (function(ui) {
        ui.h = $adc4ae8a4d756edf$var$h;
        ui.ComponentBase = $adc4ae8a4d756edf$var$IroComponentWrapper;
        ui.Handle = $adc4ae8a4d756edf$var$IroHandle;
        ui.Slider = $adc4ae8a4d756edf$var$IroSlider;
        ui.Wheel = $adc4ae8a4d756edf$var$IroWheel;
        ui.Box = $adc4ae8a4d756edf$var$IroBox;
    })(ui = iro.ui || (iro.ui = {}));
})($adc4ae8a4d756edf$var$iro || ($adc4ae8a4d756edf$var$iro = {}));
var $adc4ae8a4d756edf$var$iro$1 = $adc4ae8a4d756edf$var$iro;
var $adc4ae8a4d756edf$export$2e2bcd8739ae039 = $adc4ae8a4d756edf$var$iro$1;

});


parcelRegister("lvw85", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa856a796bae9135$export$2e2bcd8739ae039);

var $a5SNS = parcelRequire("a5SNS");

var $dFEOL = parcelRequire("dFEOL");

var $iWFzb = parcelRequire("iWFzb");

var $gdglj = parcelRequire("gdglj");

var $itw5b = parcelRequire("itw5b");

var $iqhNc = parcelRequire("iqhNc");

var $9tKZs = parcelRequire("9tKZs");

var $5BkkP = parcelRequire("5BkkP");

var $4x8BI = parcelRequire("4x8BI");

var $kvjOh = parcelRequire("kvjOh");

var $jI3be = parcelRequire("jI3be");

var $do6DE = parcelRequire("do6DE");

var $8TA2O = parcelRequire("8TA2O");

var $46cdq = parcelRequire("46cdq");

var $8kCjH = parcelRequire("8kCjH");

var $jEYPr = parcelRequire("jEYPr");

var $jVKfz = parcelRequire("jVKfz");

var $2GSBL = parcelRequire("2GSBL");

var $3PWre = parcelRequire("3PWre");

var $5VZP3 = parcelRequire("5VZP3");

var $gwsDR = parcelRequire("gwsDR");

var $3MRPo = parcelRequire("3MRPo");

var $gkzBz = parcelRequire("gkzBz");

var $lGJ7D = parcelRequire("lGJ7D");

var $6tBRD = parcelRequire("6tBRD");

var $h2pi1 = parcelRequire("h2pi1");

var $hgZvN = parcelRequire("hgZvN");

var $5LEQd = parcelRequire("5LEQd");

var $eeTZS = parcelRequire("eeTZS");

var $3FYBi = parcelRequire("3FYBi");

var $j1VIk = parcelRequire("j1VIk");
(0, $a5SNS.default).register({
    'attributors/attribute/direction': (0, $iWFzb.DirectionAttribute),
    'attributors/class/align': (0, $dFEOL.AlignClass),
    'attributors/class/background': (0, $5BkkP.BackgroundClass),
    'attributors/class/color': (0, $4x8BI.ColorClass),
    'attributors/class/direction': (0, $iWFzb.DirectionClass),
    'attributors/class/font': (0, $kvjOh.FontClass),
    'attributors/class/size': (0, $jI3be.SizeClass),
    'attributors/style/align': (0, $dFEOL.AlignStyle),
    'attributors/style/background': (0, $5BkkP.BackgroundStyle),
    'attributors/style/color': (0, $4x8BI.ColorStyle),
    'attributors/style/direction': (0, $iWFzb.DirectionStyle),
    'attributors/style/font': (0, $kvjOh.FontStyle),
    'attributors/style/size': (0, $jI3be.SizeStyle)
}, true);
(0, $a5SNS.default).register({
    'formats/align': (0, $dFEOL.AlignClass),
    'formats/direction': (0, $iWFzb.DirectionClass),
    'formats/indent': (0, $gdglj.default),
    'formats/background': (0, $5BkkP.BackgroundStyle),
    'formats/color': (0, $4x8BI.ColorStyle),
    'formats/font': (0, $kvjOh.FontClass),
    'formats/size': (0, $jI3be.SizeClass),
    'formats/blockquote': (0, $itw5b.default),
    'formats/code-block': (0, $gwsDR.default),
    'formats/header': (0, $iqhNc.default),
    'formats/list': (0, $9tKZs.default),
    'formats/bold': (0, $do6DE.default),
    'formats/code': (0, $gwsDR.Code),
    'formats/italic': (0, $8TA2O.default),
    'formats/link': (0, $46cdq.default),
    'formats/script': (0, $8kCjH.default),
    'formats/strike': (0, $jEYPr.default),
    'formats/underline': (0, $jVKfz.default),
    'formats/formula': (0, $2GSBL.default),
    'formats/image': (0, $3PWre.default),
    'formats/video': (0, $5VZP3.default),
    'modules/syntax': (0, $3MRPo.default),
    'modules/table': (0, $gkzBz.default),
    'modules/toolbar': (0, $lGJ7D.default),
    'themes/bubble': (0, $3FYBi.default),
    'themes/snow': (0, $j1VIk.default),
    'ui/icons': (0, $6tBRD.default),
    'ui/picker': (0, $h2pi1.default),
    'ui/icon-picker': (0, $5LEQd.default),
    'ui/color-picker': (0, $hgZvN.default),
    'ui/tooltip': (0, $eeTZS.default)
}, true);
var $fa856a796bae9135$export$2e2bcd8739ae039 = (0, $a5SNS.default);

});
parcelRegister("a5SNS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7594e1da9bf628e2$export$2e2bcd8739ae039);

var $lcQXp = parcelRequire("lcQXp");

var $fp1Tt = parcelRequire("fp1Tt");

var $bmwCM = parcelRequire("bmwCM");

var $em4Pe = parcelRequire("em4Pe");

var $luQs7 = parcelRequire("luQs7");

var $9xp90 = parcelRequire("9xp90");

var $fWwa7 = parcelRequire("fWwa7");

var $03ycQ = parcelRequire("03ycQ");

var $bxVMH = parcelRequire("bxVMH");

var $lkNmd = parcelRequire("lkNmd");

var $jrSqt = parcelRequire("jrSqt");

var $lRlaz = parcelRequire("lRlaz");

var $5OX8I = parcelRequire("5OX8I");

var $kEXGb = parcelRequire("kEXGb");

var $ccFIq = parcelRequire("ccFIq");

var $7wMGU = parcelRequire("7wMGU");

var $5APNb = parcelRequire("5APNb");
(0, $lcQXp.default).register({
    'blots/block': (0, $fp1Tt.default),
    'blots/block/embed': (0, $fp1Tt.BlockEmbed),
    'blots/break': (0, $bmwCM.default),
    'blots/container': (0, $em4Pe.default),
    'blots/cursor': (0, $luQs7.default),
    'blots/embed': (0, $9xp90.default),
    'blots/inline': (0, $fWwa7.default),
    'blots/scroll': (0, $03ycQ.default),
    'blots/text': (0, $bxVMH.default),
    'modules/clipboard': (0, $lkNmd.default),
    'modules/history': (0, $jrSqt.default),
    'modules/keyboard': (0, $lRlaz.default),
    'modules/uploader': (0, $5OX8I.default),
    'modules/input': (0, $ccFIq.default),
    'modules/uiNode': (0, $7wMGU.default)
});
var $7594e1da9bf628e2$export$2e2bcd8739ae039 = (0, $lcQXp.default);

});
parcelRegister("lcQXp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f703cc29143734d2$export$2e2bcd8739ae039);

var $4exCq = parcelRequire("4exCq");

var $lHwOS = parcelRequire("lHwOS");

var $kEXGb = parcelRequire("kEXGb");

var $bLz0Y = parcelRequire("bLz0Y");

var $jJqnr = parcelRequire("jJqnr");

var $bp7pN = parcelRequire("bp7pN");

var $lkbqq = parcelRequire("lkbqq");

var $5APNb = parcelRequire("5APNb");

var $3EdO3 = parcelRequire("3EdO3");

var $gjzF2 = parcelRequire("gjzF2");

var $c7e5N = parcelRequire("c7e5N");

var $bb4Dz = parcelRequire("bb4Dz");

var $f3rcF = parcelRequire("f3rcF");
const $f703cc29143734d2$var$debug = (0, $lkbqq.default)('quill');
const $f703cc29143734d2$export$bc58ce2776ecdb6f = new $lHwOS.Registry();
$lHwOS.ParentBlot.uiClass = 'ql-ui';
/**
 * Options for initializing a Quill instance
 */ /**
 * Similar to QuillOptions, but with all properties expanded to their default values,
 * and all selectors resolved to HTMLElements.
 */ class $f703cc29143734d2$export$2e2bcd8739ae039 {
    static DEFAULTS = {
        bounds: null,
        modules: {
            clipboard: true,
            keyboard: true,
            history: true,
            uploader: true
        },
        placeholder: '',
        readOnly: false,
        registry: $f703cc29143734d2$export$bc58ce2776ecdb6f,
        theme: 'default'
    };
    static events = (0, $jJqnr.default).events;
    static sources = (0, $jJqnr.default).sources;
    static version = "2.0.3";
    static imports = {
        delta: (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb))),
        parchment: $lHwOS,
        'core/module': (0, $5APNb.default),
        'core/theme': (0, $c7e5N.default)
    };
    static debug(limit) {
        if (limit === true) limit = 'log';
        (0, $lkbqq.default).level(limit);
    }
    static find(node) {
        let bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return (0, $bp7pN.default).get(node) || $f703cc29143734d2$export$bc58ce2776ecdb6f.find(node, bubble);
    }
    static import(name) {
        if (this.imports[name] == null) $f703cc29143734d2$var$debug.error(`Cannot import ${name}. Are you sure it was registered?`);
        return this.imports[name];
    }
    static register() {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== 'string') {
            const target = arguments.length <= 0 ? undefined : arguments[0];
            const overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
            const name = 'attrName' in target ? target.attrName : target.blotName;
            if (typeof name === 'string') // Shortcut for formats:
            // register(Blot | Attributor, overwrite)
            this.register(`formats/${name}`, target, overwrite);
            else Object.keys(target).forEach((key)=>{
                this.register(key, target[key], overwrite);
            });
        } else {
            const path = arguments.length <= 0 ? undefined : arguments[0];
            const target = arguments.length <= 1 ? undefined : arguments[1];
            const overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
            if (this.imports[path] != null && !overwrite) $f703cc29143734d2$var$debug.warn(`Overwriting ${path} with`, target);
            this.imports[path] = target;
            if ((path.startsWith('blots/') || path.startsWith('formats/')) && target && typeof target !== 'boolean' && target.blotName !== 'abstract') $f703cc29143734d2$export$bc58ce2776ecdb6f.register(target);
            if (typeof target.register === 'function') target.register($f703cc29143734d2$export$bc58ce2776ecdb6f);
        }
    }
    constructor(container){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.options = $f703cc29143734d2$export$72ab7189806b6df5(container, options);
        this.container = this.options.container;
        if (this.container == null) {
            $f703cc29143734d2$var$debug.error('Invalid Quill container', container);
            return;
        }
        if (this.options.debug) $f703cc29143734d2$export$2e2bcd8739ae039.debug(this.options.debug);
        const html = this.container.innerHTML.trim();
        this.container.classList.add('ql-container');
        this.container.innerHTML = '';
        (0, $bp7pN.default).set(this.container, this);
        this.root = this.addContainer('ql-editor');
        this.root.classList.add('ql-blank');
        this.emitter = new (0, $jJqnr.default)();
        const scrollBlotName = $lHwOS.ScrollBlot.blotName;
        const ScrollBlot = this.options.registry.query(scrollBlotName);
        if (!ScrollBlot || !('blotName' in ScrollBlot)) throw new Error(`Cannot initialize Quill without "${scrollBlotName}" blot`);
        this.scroll = new ScrollBlot(this.options.registry, this.root, {
            emitter: this.emitter
        });
        this.editor = new (0, $bLz0Y.default)(this.scroll);
        this.selection = new (0, $3EdO3.default)(this.scroll, this.emitter);
        this.composition = new (0, $gjzF2.default)(this.scroll, this.emitter);
        this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
        this.keyboard = this.theme.addModule('keyboard');
        this.clipboard = this.theme.addModule('clipboard');
        this.history = this.theme.addModule('history');
        this.uploader = this.theme.addModule('uploader');
        this.theme.addModule('input');
        this.theme.addModule('uiNode');
        this.theme.init();
        this.emitter.on((0, $jJqnr.default).events.EDITOR_CHANGE, (type)=>{
            if (type === (0, $jJqnr.default).events.TEXT_CHANGE) this.root.classList.toggle('ql-blank', this.editor.isBlank());
        });
        this.emitter.on((0, $jJqnr.default).events.SCROLL_UPDATE, (source, mutations)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $f703cc29143734d2$var$modify.call(this, ()=>this.editor.update(null, mutations, selectionInfo), source);
        });
        this.emitter.on((0, $jJqnr.default).events.SCROLL_EMBED_UPDATE, (blot, delta)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $f703cc29143734d2$var$modify.call(this, ()=>{
                const change = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(blot.offset(this)).retain({
                    [blot.statics.blotName]: delta
                });
                return this.editor.update(change, [], selectionInfo);
            }, $f703cc29143734d2$export$2e2bcd8739ae039.sources.USER);
        });
        if (html) {
            const contents = this.clipboard.convert({
                html: `${html}<p><br></p>`,
                text: '\n'
            });
            this.setContents(contents);
        }
        this.history.clear();
        if (this.options.placeholder) this.root.setAttribute('data-placeholder', this.options.placeholder);
        if (this.options.readOnly) this.disable();
        this.allowReadOnlyEdits = false;
    }
    addContainer(container) {
        let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof container === 'string') {
            const className = container;
            container = document.createElement('div');
            container.classList.add(className);
        }
        this.container.insertBefore(container, refNode);
        return container;
    }
    blur() {
        this.selection.setRange(null);
    }
    deleteText(index, length, source) {
        // @ts-expect-error
        [index, length, , source] = $f703cc29143734d2$export$e336952123c0bccd(index, length, source);
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            return this.editor.deleteText(index, length);
        }, source, index, -1 * length);
    }
    disable() {
        this.enable(false);
    }
    editReadOnly(modifier) {
        this.allowReadOnlyEdits = true;
        const value = modifier();
        this.allowReadOnlyEdits = false;
        return value;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.scroll.enable(enabled);
        this.container.classList.toggle('ql-disabled', !enabled);
    }
    focus() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.selection.focus();
        if (!options.preventScroll) this.scrollSelectionIntoView();
    }
    format(name, value) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $jJqnr.default).sources.API;
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            const range = this.getSelection(true);
            let change = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
            if (range == null) return change;
            if (this.scroll.query(name, $lHwOS.Scope.BLOCK)) change = this.editor.formatLine(range.index, range.length, {
                [name]: value
            });
            else if (range.length === 0) {
                this.selection.format(name, value);
                return change;
            } else change = this.editor.formatText(range.index, range.length, {
                [name]: value
            });
            this.setSelection(range, (0, $jJqnr.default).sources.SILENT);
            return change;
        }, source);
    }
    formatLine(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $f703cc29143734d2$export$e336952123c0bccd(index, length, // @ts-expect-error
        name, value, source);
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            return this.editor.formatLine(index, length, formats);
        }, source, index, 0);
    }
    formatText(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $f703cc29143734d2$export$e336952123c0bccd(// @ts-expect-error
        index, length, name, value, source);
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            return this.editor.formatText(index, length, formats);
        }, source, index, 0);
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let bounds = null;
        if (typeof index === 'number') bounds = this.selection.getBounds(index, length);
        else bounds = this.selection.getBounds(index.index, index.length);
        if (!bounds) return null;
        const containerBounds = this.container.getBoundingClientRect();
        return {
            bottom: bounds.bottom - containerBounds.top,
            height: bounds.height,
            left: bounds.left - containerBounds.left,
            right: bounds.right - containerBounds.left,
            top: bounds.top - containerBounds.top,
            width: bounds.width
        };
    }
    getContents() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
        [index, length] = $f703cc29143734d2$export$e336952123c0bccd(index, length);
        return this.editor.getContents(index, length);
    }
    getFormat() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof index === 'number') return this.editor.getFormat(index, length);
        return this.editor.getFormat(index.index, index.length);
    }
    getIndex(blot) {
        return blot.offset(this.scroll);
    }
    getLength() {
        return this.scroll.length();
    }
    getLeaf(index) {
        return this.scroll.leaf(index);
    }
    getLine(index) {
        return this.scroll.line(index);
    }
    getLines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        if (typeof index !== 'number') return this.scroll.lines(index.index, index.length);
        return this.scroll.lines(index, length);
    }
    getModule(name) {
        return this.theme.modules[name];
    }
    getSelection() {
        let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (focus) this.focus();
        this.update(); // Make sure we access getRange with editor in consistent state
        return this.selection.getRange()[0];
    }
    getSemanticHTML() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $f703cc29143734d2$export$e336952123c0bccd(index, length);
        return this.editor.getHTML(index, length);
    }
    getText() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $f703cc29143734d2$export$e336952123c0bccd(index, length);
        return this.editor.getText(index, length);
    }
    hasFocus() {
        return this.selection.hasFocus();
    }
    insertEmbed(index, embed, value) {
        let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $f703cc29143734d2$export$2e2bcd8739ae039.sources.API;
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            return this.editor.insertEmbed(index, embed, value);
        }, source, index);
    }
    insertText(index, text, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        // @ts-expect-error
        [index, , formats, source] = $f703cc29143734d2$export$e336952123c0bccd(index, 0, name, value, source);
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            return this.editor.insertText(index, text, formats);
        }, source, index, text.length);
    }
    isEnabled() {
        return this.scroll.isEnabled();
    }
    off() {
        return this.emitter.off(...arguments);
    }
    on() {
        return this.emitter.on(...arguments);
    }
    once() {
        return this.emitter.once(...arguments);
    }
    removeFormat(index, length, source) {
        [index, length, , source] = $f703cc29143734d2$export$e336952123c0bccd(index, length, source);
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            return this.editor.removeFormat(index, length);
        }, source, index);
    }
    scrollRectIntoView(rect) {
        (0, $bb4Dz.default)(this.root, rect);
    }
    /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */ scrollIntoView() {
        console.warn('Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.');
        this.scrollSelectionIntoView();
    }
    /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */ scrollSelectionIntoView() {
        const range = this.selection.lastRange;
        const bounds = range && this.selection.getBounds(range.index, range.length);
        if (bounds) this.scrollRectIntoView(bounds);
    }
    setContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $jJqnr.default).sources.API;
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))(delta);
            const length = this.getLength();
            // Quill will set empty editor to \n
            const delete1 = this.editor.deleteText(0, length);
            const applied = this.editor.insertContents(0, delta);
            // Remove extra \n from empty editor initialization
            const delete2 = this.editor.deleteText(this.getLength() - 1, 1);
            return delete1.compose(applied).compose(delete2);
        }, source);
    }
    setSelection(index, length, source) {
        if (index == null) // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
        this.selection.setRange(null, length || $f703cc29143734d2$export$2e2bcd8739ae039.sources.API);
        else {
            // @ts-expect-error
            [index, length, , source] = $f703cc29143734d2$export$e336952123c0bccd(index, length, source);
            this.selection.setRange(new (0, $3EdO3.Range)(Math.max(0, index), length), source);
            if (source !== (0, $jJqnr.default).sources.SILENT) this.scrollSelectionIntoView();
        }
    }
    setText(text) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $jJqnr.default).sources.API;
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(text);
        return this.setContents(delta, source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $jJqnr.default).sources.USER;
        const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
        this.selection.update(source);
        // TODO this is usually undefined
        return change;
    }
    updateContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $jJqnr.default).sources.API;
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))(delta);
            return this.editor.applyDelta(delta);
        }, source, true);
    }
}
function $f703cc29143734d2$var$resolveSelector(selector) {
    return typeof selector === 'string' ? document.querySelector(selector) : selector;
}
function $f703cc29143734d2$var$expandModuleConfig(config) {
    return Object.entries(config ?? {}).reduce((expanded, _ref)=>{
        let [key, value] = _ref;
        return {
            ...expanded,
            [key]: value === true ? {} : value
        };
    }, {});
}
function $f703cc29143734d2$var$omitUndefinedValuesFromOptions(obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry)=>entry[1] !== undefined));
}
function $f703cc29143734d2$export$72ab7189806b6df5(containerOrSelector, options) {
    const container = $f703cc29143734d2$var$resolveSelector(containerOrSelector);
    if (!container) throw new Error('Invalid Quill container');
    const shouldUseDefaultTheme = !options.theme || options.theme === $f703cc29143734d2$export$2e2bcd8739ae039.DEFAULTS.theme;
    const theme = shouldUseDefaultTheme ? (0, $c7e5N.default) : $f703cc29143734d2$export$2e2bcd8739ae039.import(`themes/${options.theme}`);
    if (!theme) throw new Error(`Invalid theme ${options.theme}. Did you register it?`);
    const { modules: quillModuleDefaults, ...quillDefaults } = $f703cc29143734d2$export$2e2bcd8739ae039.DEFAULTS;
    const { modules: themeModuleDefaults, ...themeDefaults } = theme.DEFAULTS;
    let userModuleOptions = $f703cc29143734d2$var$expandModuleConfig(options.modules);
    // Special case toolbar shorthand
    if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) userModuleOptions = {
        ...userModuleOptions,
        toolbar: {
            container: userModuleOptions.toolbar
        }
    };
    const modules = (0, $4exCq.default)({}, $f703cc29143734d2$var$expandModuleConfig(quillModuleDefaults), $f703cc29143734d2$var$expandModuleConfig(themeModuleDefaults), userModuleOptions);
    const config = {
        ...quillDefaults,
        ...$f703cc29143734d2$var$omitUndefinedValuesFromOptions(themeDefaults),
        ...$f703cc29143734d2$var$omitUndefinedValuesFromOptions(options)
    };
    let registry = options.registry;
    if (registry) {
        if (options.formats) $f703cc29143734d2$var$debug.warn('Ignoring "formats" option because "registry" is specified');
    } else registry = options.formats ? (0, $f3rcF.default)(options.formats, config.registry, $f703cc29143734d2$var$debug) : config.registry;
    return {
        ...config,
        registry: registry,
        container: container,
        theme: theme,
        modules: Object.entries(modules).reduce((modulesWithDefaults, _ref2)=>{
            let [name, value] = _ref2;
            if (!value) return modulesWithDefaults;
            const moduleClass = $f703cc29143734d2$export$2e2bcd8739ae039.import(`modules/${name}`);
            if (moduleClass == null) {
                $f703cc29143734d2$var$debug.error(`Cannot load ${name} module. Are you sure you registered it?`);
                return modulesWithDefaults;
            }
            return {
                ...modulesWithDefaults,
                // @ts-expect-error
                [name]: (0, $4exCq.default)({}, moduleClass.DEFAULTS || {}, value)
            };
        }, {}),
        bounds: $f703cc29143734d2$var$resolveSelector(config.bounds)
    };
}
// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function $f703cc29143734d2$var$modify(modifier, source, index, shift) {
    if (!this.isEnabled() && source === (0, $jJqnr.default).sources.USER && !this.allowReadOnlyEdits) return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
    let range = index == null ? null : this.getSelection();
    const oldDelta = this.editor.delta;
    const change = modifier();
    if (range != null) {
        if (index === true) index = range.index; // eslint-disable-line prefer-destructuring
        if (shift == null) range = $f703cc29143734d2$var$shiftRange(range, change, source);
        else if (shift !== 0) // @ts-expect-error index should always be number
        range = $f703cc29143734d2$var$shiftRange(range, index, shift, source);
        this.setSelection(range, (0, $jJqnr.default).sources.SILENT);
    }
    if (change.length() > 0) {
        const args = [
            (0, $jJqnr.default).events.TEXT_CHANGE,
            change,
            oldDelta,
            source
        ];
        this.emitter.emit((0, $jJqnr.default).events.EDITOR_CHANGE, ...args);
        if (source !== (0, $jJqnr.default).sources.SILENT) this.emitter.emit(...args);
    }
    return change;
}
function $f703cc29143734d2$export$e336952123c0bccd(index, length, name, value, source) {
    let formats = {};
    // @ts-expect-error
    if (typeof index.index === 'number' && typeof index.length === 'number') {
        // Allow for throwaway end (used by insertText/insertEmbed)
        if (typeof length !== 'number') {
            // @ts-expect-error
            source = value;
            value = name;
            name = length;
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        } else {
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        }
    } else if (typeof length !== 'number') {
        // @ts-expect-error
        source = value;
        value = name;
        name = length;
        length = 0;
    }
    // Handle format being object, two format name/value strings or excluded
    if (typeof name === 'object') {
        // @ts-expect-error Fix me later
        formats = name;
        // @ts-expect-error
        source = value;
    } else if (typeof name === 'string') {
        if (value != null) formats[name] = value;
        else // @ts-expect-error
        source = name;
    }
    // Handle optional source
    source = source || (0, $jJqnr.default).sources.API;
    // @ts-expect-error
    return [
        index,
        length,
        formats,
        source
    ];
}
function $f703cc29143734d2$var$shiftRange(range, index, lengthOrSource, source) {
    const length = typeof lengthOrSource === 'number' ? lengthOrSource : 0;
    if (range == null) return null;
    let start;
    let end;
    // @ts-expect-error -- TODO: add a better type guard around `index`
    if (index && typeof index.transformPosition === 'function') [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>// @ts-expect-error -- TODO: add a better type guard around `index`
        index.transformPosition(pos, source !== (0, $jJqnr.default).sources.USER));
    else [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>{
        // @ts-expect-error -- TODO: add a better type guard around `index`
        if (pos < index || pos === index && source === (0, $jJqnr.default).sources.USER) return pos;
        if (length >= 0) return pos + length;
        // @ts-expect-error -- TODO: add a better type guard around `index`
        return Math.max(index, pos + length);
    });
    return new (0, $3EdO3.Range)(start, end - start);
}

});
parcelRegister("4exCq", function(module, exports) {

$parcel$export(module.exports, "default", () => $31528c3235d11c78$export$2e2bcd8739ae039);

var $9n4xL = parcelRequire("9n4xL");

var $1jwcU = parcelRequire("1jwcU");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $31528c3235d11c78$var$merge = (0, $1jwcU.default)(function(object, source, srcIndex) {
    (0, $9n4xL.default)(object, source, srcIndex);
});
var $31528c3235d11c78$export$2e2bcd8739ae039 = $31528c3235d11c78$var$merge;

});
parcelRegister("9n4xL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d29c9473147a495$export$2e2bcd8739ae039);

var $ch4ws = parcelRequire("ch4ws");

var $fa9ZF = parcelRequire("fa9ZF");

var $1gEEJ = parcelRequire("1gEEJ");

var $ce9Ft = parcelRequire("ce9Ft");

var $kXXxV = parcelRequire("kXXxV");

var $fIbiK = parcelRequire("fIbiK");

var $g7yOx = parcelRequire("g7yOx");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $6d29c9473147a495$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $1gEEJ.default)(source, function(srcValue, key) {
        stack || (stack = new (0, $ch4ws.default));
        if ((0, $kXXxV.default)(srcValue)) (0, $ce9Ft.default)(object, source, key, srcIndex, $6d29c9473147a495$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $g7yOx.default)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $fa9ZF.default)(object, key, newValue);
        }
    }, (0, $fIbiK.default));
}
var $6d29c9473147a495$export$2e2bcd8739ae039 = $6d29c9473147a495$var$baseMerge;

});
parcelRegister("ch4ws", function(module, exports) {

$parcel$export(module.exports, "default", () => $024e5d3c6325761d$export$2e2bcd8739ae039);

var $aG4ch = parcelRequire("aG4ch");

var $bUZ6i = parcelRequire("bUZ6i");

var $dZk6F = parcelRequire("dZk6F");

var $jRWRF = parcelRequire("jRWRF");

var $g3MUc = parcelRequire("g3MUc");

var $6M0L8 = parcelRequire("6M0L8");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $024e5d3c6325761d$var$Stack(entries) {
    var data = this.__data__ = new (0, $aG4ch.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$024e5d3c6325761d$var$Stack.prototype.clear = (0, $bUZ6i.default);
$024e5d3c6325761d$var$Stack.prototype['delete'] = (0, $dZk6F.default);
$024e5d3c6325761d$var$Stack.prototype.get = (0, $jRWRF.default);
$024e5d3c6325761d$var$Stack.prototype.has = (0, $g3MUc.default);
$024e5d3c6325761d$var$Stack.prototype.set = (0, $6M0L8.default);
var $024e5d3c6325761d$export$2e2bcd8739ae039 = $024e5d3c6325761d$var$Stack;

});
parcelRegister("aG4ch", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c6115142bbd100f$export$2e2bcd8739ae039);

var $6vLWY = parcelRequire("6vLWY");

var $jUnPr = parcelRequire("jUnPr");

var $1vLhu = parcelRequire("1vLhu");

var $9IMvv = parcelRequire("9IMvv");

var $4J4Ti = parcelRequire("4J4Ti");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7c6115142bbd100f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$7c6115142bbd100f$var$ListCache.prototype.clear = (0, $6vLWY.default);
$7c6115142bbd100f$var$ListCache.prototype['delete'] = (0, $jUnPr.default);
$7c6115142bbd100f$var$ListCache.prototype.get = (0, $1vLhu.default);
$7c6115142bbd100f$var$ListCache.prototype.has = (0, $9IMvv.default);
$7c6115142bbd100f$var$ListCache.prototype.set = (0, $4J4Ti.default);
var $7c6115142bbd100f$export$2e2bcd8739ae039 = $7c6115142bbd100f$var$ListCache;

});
parcelRegister("6vLWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bdad542d9db6cc0$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $4bdad542d9db6cc0$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $4bdad542d9db6cc0$export$2e2bcd8739ae039 = $4bdad542d9db6cc0$var$listCacheClear;

});

parcelRegister("jUnPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e5bb262cb888fb$export$2e2bcd8739ae039);

var $3jgi6 = parcelRequire("3jgi6");
/** Used for built-in method references. */ var $e7e5bb262cb888fb$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $e7e5bb262cb888fb$var$splice = $e7e5bb262cb888fb$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e7e5bb262cb888fb$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $3jgi6.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $e7e5bb262cb888fb$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $e7e5bb262cb888fb$export$2e2bcd8739ae039 = $e7e5bb262cb888fb$var$listCacheDelete;

});
parcelRegister("3jgi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $268fc8793075bd8e$export$2e2bcd8739ae039);

var $78Lr5 = parcelRequire("78Lr5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $268fc8793075bd8e$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $78Lr5.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $268fc8793075bd8e$export$2e2bcd8739ae039 = $268fc8793075bd8e$var$assocIndexOf;

});
parcelRegister("78Lr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $532e138903529660$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $532e138903529660$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $532e138903529660$export$2e2bcd8739ae039 = $532e138903529660$var$eq;

});



parcelRegister("1vLhu", function(module, exports) {

$parcel$export(module.exports, "default", () => $119d5cbce7b236be$export$2e2bcd8739ae039);

var $3jgi6 = parcelRequire("3jgi6");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $119d5cbce7b236be$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $3jgi6.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $119d5cbce7b236be$export$2e2bcd8739ae039 = $119d5cbce7b236be$var$listCacheGet;

});

parcelRegister("9IMvv", function(module, exports) {

$parcel$export(module.exports, "default", () => $713dd99bab35ecdc$export$2e2bcd8739ae039);

var $3jgi6 = parcelRequire("3jgi6");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $713dd99bab35ecdc$var$listCacheHas(key) {
    return (0, $3jgi6.default)(this.__data__, key) > -1;
}
var $713dd99bab35ecdc$export$2e2bcd8739ae039 = $713dd99bab35ecdc$var$listCacheHas;

});

parcelRegister("4J4Ti", function(module, exports) {

$parcel$export(module.exports, "default", () => $370f28a386fb97f7$export$2e2bcd8739ae039);

var $3jgi6 = parcelRequire("3jgi6");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $370f28a386fb97f7$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $3jgi6.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $370f28a386fb97f7$export$2e2bcd8739ae039 = $370f28a386fb97f7$var$listCacheSet;

});


parcelRegister("bUZ6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ad451fd7b83d8a3$export$2e2bcd8739ae039);

var $aG4ch = parcelRequire("aG4ch");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $8ad451fd7b83d8a3$var$stackClear() {
    this.__data__ = new (0, $aG4ch.default);
    this.size = 0;
}
var $8ad451fd7b83d8a3$export$2e2bcd8739ae039 = $8ad451fd7b83d8a3$var$stackClear;

});

parcelRegister("dZk6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2f0919cd5192709$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a2f0919cd5192709$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $a2f0919cd5192709$export$2e2bcd8739ae039 = $a2f0919cd5192709$var$stackDelete;

});

parcelRegister("jRWRF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e770a0dce54723de$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e770a0dce54723de$var$stackGet(key) {
    return this.__data__.get(key);
}
var $e770a0dce54723de$export$2e2bcd8739ae039 = $e770a0dce54723de$var$stackGet;

});

parcelRegister("g3MUc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb12dcc533c9fdbc$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bb12dcc533c9fdbc$var$stackHas(key) {
    return this.__data__.has(key);
}
var $bb12dcc533c9fdbc$export$2e2bcd8739ae039 = $bb12dcc533c9fdbc$var$stackHas;

});

parcelRegister("6M0L8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ee7d08a3b77c208$export$2e2bcd8739ae039);

var $aG4ch = parcelRequire("aG4ch");

var $fHOWn = parcelRequire("fHOWn");

var $j9mMr = parcelRequire("j9mMr");
/** Used as the size to enable large array optimizations. */ var $4ee7d08a3b77c208$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $4ee7d08a3b77c208$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $aG4ch.default)) {
        var pairs = data.__data__;
        if (!(0, $fHOWn.default) || pairs.length < $4ee7d08a3b77c208$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $j9mMr.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $4ee7d08a3b77c208$export$2e2bcd8739ae039 = $4ee7d08a3b77c208$var$stackSet;

});
parcelRegister("fHOWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6f262e5e80108d9$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");

var $2ZUhy = parcelRequire("2ZUhy");
/* Built-in method references that are verified to be native. */ var $b6f262e5e80108d9$var$Map = (0, $8dB7s.default)((0, $2ZUhy.default), 'Map');
var $b6f262e5e80108d9$export$2e2bcd8739ae039 = $b6f262e5e80108d9$var$Map;

});
parcelRegister("8dB7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fbc54bb4011da38$export$2e2bcd8739ae039);

var $ap7Bn = parcelRequire("ap7Bn");

var $ftBHs = parcelRequire("ftBHs");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5fbc54bb4011da38$var$getNative(object, key) {
    var value = (0, $ftBHs.default)(object, key);
    return (0, $ap7Bn.default)(value) ? value : undefined;
}
var $5fbc54bb4011da38$export$2e2bcd8739ae039 = $5fbc54bb4011da38$var$getNative;

});
parcelRegister("ap7Bn", function(module, exports) {

$parcel$export(module.exports, "default", () => $793222ba65e3682a$export$2e2bcd8739ae039);

var $8WSEV = parcelRequire("8WSEV");

var $dcqCR = parcelRequire("dcqCR");

var $kXXxV = parcelRequire("kXXxV");

var $gu9fH = parcelRequire("gu9fH");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $793222ba65e3682a$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $793222ba65e3682a$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $793222ba65e3682a$var$funcProto = Function.prototype, $793222ba65e3682a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $793222ba65e3682a$var$funcToString = $793222ba65e3682a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $793222ba65e3682a$var$hasOwnProperty = $793222ba65e3682a$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $793222ba65e3682a$var$reIsNative = RegExp('^' + $793222ba65e3682a$var$funcToString.call($793222ba65e3682a$var$hasOwnProperty).replace($793222ba65e3682a$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $793222ba65e3682a$var$baseIsNative(value) {
    if (!(0, $kXXxV.default)(value) || (0, $dcqCR.default)(value)) return false;
    var pattern = (0, $8WSEV.default)(value) ? $793222ba65e3682a$var$reIsNative : $793222ba65e3682a$var$reIsHostCtor;
    return pattern.test((0, $gu9fH.default)(value));
}
var $793222ba65e3682a$export$2e2bcd8739ae039 = $793222ba65e3682a$var$baseIsNative;

});
parcelRegister("8WSEV", function(module, exports) {

$parcel$export(module.exports, "default", () => $683e23aa99ebf6cc$export$2e2bcd8739ae039);

var $f4sy6 = parcelRequire("f4sy6");

var $kXXxV = parcelRequire("kXXxV");
/** `Object#toString` result references. */ var $683e23aa99ebf6cc$var$asyncTag = '[object AsyncFunction]', $683e23aa99ebf6cc$var$funcTag = '[object Function]', $683e23aa99ebf6cc$var$genTag = '[object GeneratorFunction]', $683e23aa99ebf6cc$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $683e23aa99ebf6cc$var$isFunction(value) {
    if (!(0, $kXXxV.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $f4sy6.default)(value);
    return tag == $683e23aa99ebf6cc$var$funcTag || tag == $683e23aa99ebf6cc$var$genTag || tag == $683e23aa99ebf6cc$var$asyncTag || tag == $683e23aa99ebf6cc$var$proxyTag;
}
var $683e23aa99ebf6cc$export$2e2bcd8739ae039 = $683e23aa99ebf6cc$var$isFunction;

});
parcelRegister("f4sy6", function(module, exports) {

$parcel$export(module.exports, "default", () => $af8d5ffd66c43371$export$2e2bcd8739ae039);

var $9O75z = parcelRequire("9O75z");

var $fURD0 = parcelRequire("fURD0");

var $6QTmG = parcelRequire("6QTmG");
/** `Object#toString` result references. */ var $af8d5ffd66c43371$var$nullTag = '[object Null]', $af8d5ffd66c43371$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $af8d5ffd66c43371$var$symToStringTag = (0, $9O75z.default) ? (0, $9O75z.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $af8d5ffd66c43371$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $af8d5ffd66c43371$var$undefinedTag : $af8d5ffd66c43371$var$nullTag;
    return $af8d5ffd66c43371$var$symToStringTag && $af8d5ffd66c43371$var$symToStringTag in Object(value) ? (0, $fURD0.default)(value) : (0, $6QTmG.default)(value);
}
var $af8d5ffd66c43371$export$2e2bcd8739ae039 = $af8d5ffd66c43371$var$baseGetTag;

});
parcelRegister("9O75z", function(module, exports) {

$parcel$export(module.exports, "default", () => $723e48429261b6fc$export$2e2bcd8739ae039);

var $2ZUhy = parcelRequire("2ZUhy");
/** Built-in value references. */ var $723e48429261b6fc$var$Symbol = (0, $2ZUhy.default).Symbol;
var $723e48429261b6fc$export$2e2bcd8739ae039 = $723e48429261b6fc$var$Symbol;

});
parcelRegister("2ZUhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $22ecefb7ce566abe$export$2e2bcd8739ae039);

var $eEY6y = parcelRequire("eEY6y");
/** Detect free variable `self`. */ var $22ecefb7ce566abe$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $22ecefb7ce566abe$var$root = (0, $eEY6y.default) || $22ecefb7ce566abe$var$freeSelf || Function('return this')();
var $22ecefb7ce566abe$export$2e2bcd8739ae039 = $22ecefb7ce566abe$var$root;

});
parcelRegister("eEY6y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aac36cae84e9f6dc$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $aac36cae84e9f6dc$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $aac36cae84e9f6dc$export$2e2bcd8739ae039 = $aac36cae84e9f6dc$var$freeGlobal;

});



parcelRegister("fURD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b965af6420d4a3e5$export$2e2bcd8739ae039);

var $9O75z = parcelRequire("9O75z");
/** Used for built-in method references. */ var $b965af6420d4a3e5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b965af6420d4a3e5$var$hasOwnProperty = $b965af6420d4a3e5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b965af6420d4a3e5$var$nativeObjectToString = $b965af6420d4a3e5$var$objectProto.toString;
/** Built-in value references. */ var $b965af6420d4a3e5$var$symToStringTag = (0, $9O75z.default) ? (0, $9O75z.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $b965af6420d4a3e5$var$getRawTag(value) {
    var isOwn = $b965af6420d4a3e5$var$hasOwnProperty.call(value, $b965af6420d4a3e5$var$symToStringTag), tag = value[$b965af6420d4a3e5$var$symToStringTag];
    try {
        value[$b965af6420d4a3e5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $b965af6420d4a3e5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$b965af6420d4a3e5$var$symToStringTag] = tag;
        else delete value[$b965af6420d4a3e5$var$symToStringTag];
    }
    return result;
}
var $b965af6420d4a3e5$export$2e2bcd8739ae039 = $b965af6420d4a3e5$var$getRawTag;

});

parcelRegister("6QTmG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fd28bb4a1823413$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $4fd28bb4a1823413$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4fd28bb4a1823413$var$nativeObjectToString = $4fd28bb4a1823413$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $4fd28bb4a1823413$var$objectToString(value) {
    return $4fd28bb4a1823413$var$nativeObjectToString.call(value);
}
var $4fd28bb4a1823413$export$2e2bcd8739ae039 = $4fd28bb4a1823413$var$objectToString;

});


parcelRegister("kXXxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f43781fa538b922c$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f43781fa538b922c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $f43781fa538b922c$export$2e2bcd8739ae039 = $f43781fa538b922c$var$isObject;

});


parcelRegister("dcqCR", function(module, exports) {

$parcel$export(module.exports, "default", () => $99c10caa3b1bf583$export$2e2bcd8739ae039);

var $gQtST = parcelRequire("gQtST");
/** Used to detect methods masquerading as native. */ var $99c10caa3b1bf583$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $gQtST.default) && (0, $gQtST.default).keys && (0, $gQtST.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $99c10caa3b1bf583$var$isMasked(func) {
    return !!$99c10caa3b1bf583$var$maskSrcKey && $99c10caa3b1bf583$var$maskSrcKey in func;
}
var $99c10caa3b1bf583$export$2e2bcd8739ae039 = $99c10caa3b1bf583$var$isMasked;

});
parcelRegister("gQtST", function(module, exports) {

$parcel$export(module.exports, "default", () => $c438af103151eccd$export$2e2bcd8739ae039);

var $2ZUhy = parcelRequire("2ZUhy");
/** Used to detect overreaching core-js shims. */ var $c438af103151eccd$var$coreJsData = (0, $2ZUhy.default)['__core-js_shared__'];
var $c438af103151eccd$export$2e2bcd8739ae039 = $c438af103151eccd$var$coreJsData;

});


parcelRegister("gu9fH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0069ff645d76721$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $c0069ff645d76721$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $c0069ff645d76721$var$funcToString = $c0069ff645d76721$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $c0069ff645d76721$var$toSource(func) {
    if (func != null) {
        try {
            return $c0069ff645d76721$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $c0069ff645d76721$export$2e2bcd8739ae039 = $c0069ff645d76721$var$toSource;

});


parcelRegister("ftBHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b446ced8aaebeb76$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $b446ced8aaebeb76$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $b446ced8aaebeb76$export$2e2bcd8739ae039 = $b446ced8aaebeb76$var$getValue;

});



parcelRegister("j9mMr", function(module, exports) {

$parcel$export(module.exports, "default", () => $df10874410dc9ccf$export$2e2bcd8739ae039);

var $5lO2c = parcelRequire("5lO2c");

var $lBMRq = parcelRequire("lBMRq");

var $6i4Wx = parcelRequire("6i4Wx");

var $kP85e = parcelRequire("kP85e");

var $67Et0 = parcelRequire("67Et0");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $df10874410dc9ccf$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$df10874410dc9ccf$var$MapCache.prototype.clear = (0, $5lO2c.default);
$df10874410dc9ccf$var$MapCache.prototype['delete'] = (0, $lBMRq.default);
$df10874410dc9ccf$var$MapCache.prototype.get = (0, $6i4Wx.default);
$df10874410dc9ccf$var$MapCache.prototype.has = (0, $kP85e.default);
$df10874410dc9ccf$var$MapCache.prototype.set = (0, $67Et0.default);
var $df10874410dc9ccf$export$2e2bcd8739ae039 = $df10874410dc9ccf$var$MapCache;

});
parcelRegister("5lO2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e55b9bb47f2bbd0$export$2e2bcd8739ae039);

var $5IPv1 = parcelRequire("5IPv1");

var $aG4ch = parcelRequire("aG4ch");

var $fHOWn = parcelRequire("fHOWn");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $3e55b9bb47f2bbd0$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $5IPv1.default),
        'map': new ((0, $fHOWn.default) || (0, $aG4ch.default)),
        'string': new (0, $5IPv1.default)
    };
}
var $3e55b9bb47f2bbd0$export$2e2bcd8739ae039 = $3e55b9bb47f2bbd0$var$mapCacheClear;

});
parcelRegister("5IPv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $42a902825fae1889$export$2e2bcd8739ae039);

var $d5eW8 = parcelRequire("d5eW8");

var $2iHSP = parcelRequire("2iHSP");

var $8fXzA = parcelRequire("8fXzA");

var $fgg7G = parcelRequire("fgg7G");

var $8acEK = parcelRequire("8acEK");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $42a902825fae1889$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$42a902825fae1889$var$Hash.prototype.clear = (0, $d5eW8.default);
$42a902825fae1889$var$Hash.prototype['delete'] = (0, $2iHSP.default);
$42a902825fae1889$var$Hash.prototype.get = (0, $8fXzA.default);
$42a902825fae1889$var$Hash.prototype.has = (0, $fgg7G.default);
$42a902825fae1889$var$Hash.prototype.set = (0, $8acEK.default);
var $42a902825fae1889$export$2e2bcd8739ae039 = $42a902825fae1889$var$Hash;

});
parcelRegister("d5eW8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9867541cb5dac3ef$export$2e2bcd8739ae039);

var $61TQK = parcelRequire("61TQK");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $9867541cb5dac3ef$var$hashClear() {
    this.__data__ = (0, $61TQK.default) ? (0, $61TQK.default)(null) : {};
    this.size = 0;
}
var $9867541cb5dac3ef$export$2e2bcd8739ae039 = $9867541cb5dac3ef$var$hashClear;

});
parcelRegister("61TQK", function(module, exports) {

$parcel$export(module.exports, "default", () => $463e28aa276cb787$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");
/* Built-in method references that are verified to be native. */ var $463e28aa276cb787$var$nativeCreate = (0, $8dB7s.default)(Object, 'create');
var $463e28aa276cb787$export$2e2bcd8739ae039 = $463e28aa276cb787$var$nativeCreate;

});


parcelRegister("2iHSP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1acf4d8250d69dd9$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1acf4d8250d69dd9$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $1acf4d8250d69dd9$export$2e2bcd8739ae039 = $1acf4d8250d69dd9$var$hashDelete;

});

parcelRegister("8fXzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $602def647adec634$export$2e2bcd8739ae039);

var $61TQK = parcelRequire("61TQK");
/** Used to stand-in for `undefined` hash values. */ var $602def647adec634$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $602def647adec634$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $602def647adec634$var$hasOwnProperty = $602def647adec634$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $602def647adec634$var$hashGet(key) {
    var data = this.__data__;
    if (0, $61TQK.default) {
        var result = data[key];
        return result === $602def647adec634$var$HASH_UNDEFINED ? undefined : result;
    }
    return $602def647adec634$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $602def647adec634$export$2e2bcd8739ae039 = $602def647adec634$var$hashGet;

});

parcelRegister("fgg7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c4db4c990b2ea5$export$2e2bcd8739ae039);

var $61TQK = parcelRequire("61TQK");
/** Used for built-in method references. */ var $b1c4db4c990b2ea5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b1c4db4c990b2ea5$var$hasOwnProperty = $b1c4db4c990b2ea5$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b1c4db4c990b2ea5$var$hashHas(key) {
    var data = this.__data__;
    return (0, $61TQK.default) ? data[key] !== undefined : $b1c4db4c990b2ea5$var$hasOwnProperty.call(data, key);
}
var $b1c4db4c990b2ea5$export$2e2bcd8739ae039 = $b1c4db4c990b2ea5$var$hashHas;

});

parcelRegister("8acEK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0188a9998b3c27e6$export$2e2bcd8739ae039);

var $61TQK = parcelRequire("61TQK");
/** Used to stand-in for `undefined` hash values. */ var $0188a9998b3c27e6$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $0188a9998b3c27e6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $61TQK.default) && value === undefined ? $0188a9998b3c27e6$var$HASH_UNDEFINED : value;
    return this;
}
var $0188a9998b3c27e6$export$2e2bcd8739ae039 = $0188a9998b3c27e6$var$hashSet;

});



parcelRegister("lBMRq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb2f467985a4f81$export$2e2bcd8739ae039);

var $dsxLI = parcelRequire("dsxLI");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fbb2f467985a4f81$var$mapCacheDelete(key) {
    var result = (0, $dsxLI.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $fbb2f467985a4f81$export$2e2bcd8739ae039 = $fbb2f467985a4f81$var$mapCacheDelete;

});
parcelRegister("dsxLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc8159e5ed69efe$export$2e2bcd8739ae039);

var $aaVA2 = parcelRequire("aaVA2");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $9cc8159e5ed69efe$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $aaVA2.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $9cc8159e5ed69efe$export$2e2bcd8739ae039 = $9cc8159e5ed69efe$var$getMapData;

});
parcelRegister("aaVA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $768780c93ac19bf2$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $768780c93ac19bf2$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $768780c93ac19bf2$export$2e2bcd8739ae039 = $768780c93ac19bf2$var$isKeyable;

});



parcelRegister("6i4Wx", function(module, exports) {

$parcel$export(module.exports, "default", () => $49484220c3a992e5$export$2e2bcd8739ae039);

var $dsxLI = parcelRequire("dsxLI");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $49484220c3a992e5$var$mapCacheGet(key) {
    return (0, $dsxLI.default)(this, key).get(key);
}
var $49484220c3a992e5$export$2e2bcd8739ae039 = $49484220c3a992e5$var$mapCacheGet;

});

parcelRegister("kP85e", function(module, exports) {

$parcel$export(module.exports, "default", () => $f28ed73c0d93261f$export$2e2bcd8739ae039);

var $dsxLI = parcelRequire("dsxLI");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f28ed73c0d93261f$var$mapCacheHas(key) {
    return (0, $dsxLI.default)(this, key).has(key);
}
var $f28ed73c0d93261f$export$2e2bcd8739ae039 = $f28ed73c0d93261f$var$mapCacheHas;

});

parcelRegister("67Et0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4752c95eb7794262$export$2e2bcd8739ae039);

var $dsxLI = parcelRequire("dsxLI");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $4752c95eb7794262$var$mapCacheSet(key, value) {
    var data = (0, $dsxLI.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $4752c95eb7794262$export$2e2bcd8739ae039 = $4752c95eb7794262$var$mapCacheSet;

});




parcelRegister("fa9ZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b09f8ab906eab8aa$export$2e2bcd8739ae039);

var $bWSGY = parcelRequire("bWSGY");

var $78Lr5 = parcelRequire("78Lr5");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b09f8ab906eab8aa$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $78Lr5.default)(object[key], value) || value === undefined && !(key in object)) (0, $bWSGY.default)(object, key, value);
}
var $b09f8ab906eab8aa$export$2e2bcd8739ae039 = $b09f8ab906eab8aa$var$assignMergeValue;

});
parcelRegister("bWSGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b2f8934178fcc6a$export$2e2bcd8739ae039);

var $cfI3G = parcelRequire("cfI3G");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $8b2f8934178fcc6a$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $cfI3G.default)) (0, $cfI3G.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $8b2f8934178fcc6a$export$2e2bcd8739ae039 = $8b2f8934178fcc6a$var$baseAssignValue;

});
parcelRegister("cfI3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eb90fd6adb57b5f$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");
var $8eb90fd6adb57b5f$var$defineProperty = function() {
    try {
        var func = (0, $8dB7s.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $8eb90fd6adb57b5f$export$2e2bcd8739ae039 = $8eb90fd6adb57b5f$var$defineProperty;

});



parcelRegister("1gEEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ec6d281b8e95206$export$2e2bcd8739ae039);

var $bYQjx = parcelRequire("bYQjx");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $0ec6d281b8e95206$var$baseFor = (0, $bYQjx.default)();
var $0ec6d281b8e95206$export$2e2bcd8739ae039 = $0ec6d281b8e95206$var$baseFor;

});
parcelRegister("bYQjx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8de0cf760e2676$export$2e2bcd8739ae039);
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $8b8de0cf760e2676$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $8b8de0cf760e2676$export$2e2bcd8739ae039 = $8b8de0cf760e2676$var$createBaseFor;

});


parcelRegister("ce9Ft", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e6e4aab838488a1$export$2e2bcd8739ae039);

var $fa9ZF = parcelRequire("fa9ZF");

var $imxSd = parcelRequire("imxSd");

var $70ZJW = parcelRequire("70ZJW");

var $6x0q0 = parcelRequire("6x0q0");

var $hMPMN = parcelRequire("hMPMN");

var $ebAE7 = parcelRequire("ebAE7");

var $hXn90 = parcelRequire("hXn90");

var $icZJv = parcelRequire("icZJv");

var $hiJJV = parcelRequire("hiJJV");

var $8WSEV = parcelRequire("8WSEV");

var $kXXxV = parcelRequire("kXXxV");

var $bOFVz = parcelRequire("bOFVz");

var $ckYSa = parcelRequire("ckYSa");

var $g7yOx = parcelRequire("g7yOx");

var $eCWAz = parcelRequire("eCWAz");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $8e6e4aab838488a1$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $g7yOx.default)(object, key), srcValue = (0, $g7yOx.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $fa9ZF.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $hXn90.default)(srcValue), isBuff = !isArr && (0, $hiJJV.default)(srcValue), isTyped = !isArr && !isBuff && (0, $ckYSa.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $hXn90.default)(objValue)) newValue = objValue;
            else if ((0, $icZJv.default)(objValue)) newValue = (0, $6x0q0.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $imxSd.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $70ZJW.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, $bOFVz.default)(srcValue) || (0, $ebAE7.default)(srcValue)) {
            newValue = objValue;
            if ((0, $ebAE7.default)(objValue)) newValue = (0, $eCWAz.default)(objValue);
            else if (!(0, $kXXxV.default)(objValue) || (0, $8WSEV.default)(objValue)) newValue = (0, $hMPMN.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $fa9ZF.default)(object, key, newValue);
}
var $8e6e4aab838488a1$export$2e2bcd8739ae039 = $8e6e4aab838488a1$var$baseMergeDeep;

});
parcelRegister("imxSd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e48ea47ae18000$export$2e2bcd8739ae039);

var $2ZUhy = parcelRequire("2ZUhy");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2ZUhy.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $d5e48ea47ae18000$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("70ZJW", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b86cbfdf253641$export$2e2bcd8739ae039);

var $aal8n = parcelRequire("aal8n");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $51b86cbfdf253641$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $aal8n.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $51b86cbfdf253641$export$2e2bcd8739ae039 = $51b86cbfdf253641$var$cloneTypedArray;

});
parcelRegister("aal8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $766b3b5c1b005675$export$2e2bcd8739ae039);

var $7uREm = parcelRequire("7uREm");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $766b3b5c1b005675$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $7uREm.default)(result).set(new (0, $7uREm.default)(arrayBuffer));
    return result;
}
var $766b3b5c1b005675$export$2e2bcd8739ae039 = $766b3b5c1b005675$var$cloneArrayBuffer;

});
parcelRegister("7uREm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5754f38924ac1fdd$export$2e2bcd8739ae039);

var $2ZUhy = parcelRequire("2ZUhy");
/** Built-in value references. */ var $5754f38924ac1fdd$var$Uint8Array = (0, $2ZUhy.default).Uint8Array;
var $5754f38924ac1fdd$export$2e2bcd8739ae039 = $5754f38924ac1fdd$var$Uint8Array;

});



parcelRegister("6x0q0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c162636d6c60380$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $4c162636d6c60380$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $4c162636d6c60380$export$2e2bcd8739ae039 = $4c162636d6c60380$var$copyArray;

});

parcelRegister("hMPMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf2f16f8d1cd5b3d$export$2e2bcd8739ae039);

var $acO6k = parcelRequire("acO6k");

var $lPOv3 = parcelRequire("lPOv3");

var $7H3cd = parcelRequire("7H3cd");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $cf2f16f8d1cd5b3d$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $7H3cd.default)(object) ? (0, $acO6k.default)((0, $lPOv3.default)(object)) : {};
}
var $cf2f16f8d1cd5b3d$export$2e2bcd8739ae039 = $cf2f16f8d1cd5b3d$var$initCloneObject;

});
parcelRegister("acO6k", function(module, exports) {

$parcel$export(module.exports, "default", () => $76e1e36434315ed3$export$2e2bcd8739ae039);

var $kXXxV = parcelRequire("kXXxV");
/** Built-in value references. */ var $76e1e36434315ed3$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $76e1e36434315ed3$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $kXXxV.default)(proto)) return {};
        if ($76e1e36434315ed3$var$objectCreate) return $76e1e36434315ed3$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $76e1e36434315ed3$export$2e2bcd8739ae039 = $76e1e36434315ed3$var$baseCreate;

});

parcelRegister("lPOv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe558899101fb74c$export$2e2bcd8739ae039);

var $3knOV = parcelRequire("3knOV");
/** Built-in value references. */ var $fe558899101fb74c$var$getPrototype = (0, $3knOV.default)(Object.getPrototypeOf, Object);
var $fe558899101fb74c$export$2e2bcd8739ae039 = $fe558899101fb74c$var$getPrototype;

});
parcelRegister("3knOV", function(module, exports) {

$parcel$export(module.exports, "default", () => $26c5b79670c770f2$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $26c5b79670c770f2$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $26c5b79670c770f2$export$2e2bcd8739ae039 = $26c5b79670c770f2$var$overArg;

});


parcelRegister("7H3cd", function(module, exports) {

$parcel$export(module.exports, "default", () => $599f0731d714e584$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $599f0731d714e584$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $599f0731d714e584$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $599f0731d714e584$var$objectProto;
    return value === proto;
}
var $599f0731d714e584$export$2e2bcd8739ae039 = $599f0731d714e584$var$isPrototype;

});


parcelRegister("ebAE7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a53e84e52eaf8a5a$export$2e2bcd8739ae039);

var $hAmYU = parcelRequire("hAmYU");

var $ydcRw = parcelRequire("ydcRw");
/** Used for built-in method references. */ var $a53e84e52eaf8a5a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a53e84e52eaf8a5a$var$hasOwnProperty = $a53e84e52eaf8a5a$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $a53e84e52eaf8a5a$var$propertyIsEnumerable = $a53e84e52eaf8a5a$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $a53e84e52eaf8a5a$var$isArguments = (0, $hAmYU.default)(function() {
    return arguments;
}()) ? (0, $hAmYU.default) : function(value) {
    return (0, $ydcRw.default)(value) && $a53e84e52eaf8a5a$var$hasOwnProperty.call(value, 'callee') && !$a53e84e52eaf8a5a$var$propertyIsEnumerable.call(value, 'callee');
};
var $a53e84e52eaf8a5a$export$2e2bcd8739ae039 = $a53e84e52eaf8a5a$var$isArguments;

});
parcelRegister("hAmYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd7a014d1bcafef$export$2e2bcd8739ae039);

var $f4sy6 = parcelRequire("f4sy6");

var $ydcRw = parcelRequire("ydcRw");
/** `Object#toString` result references. */ var $ccd7a014d1bcafef$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ccd7a014d1bcafef$var$baseIsArguments(value) {
    return (0, $ydcRw.default)(value) && (0, $f4sy6.default)(value) == $ccd7a014d1bcafef$var$argsTag;
}
var $ccd7a014d1bcafef$export$2e2bcd8739ae039 = $ccd7a014d1bcafef$var$baseIsArguments;

});
parcelRegister("ydcRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $066d6b9e024fded7$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $066d6b9e024fded7$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $066d6b9e024fded7$export$2e2bcd8739ae039 = $066d6b9e024fded7$var$isObjectLike;

});



parcelRegister("hXn90", function(module, exports) {

$parcel$export(module.exports, "default", () => $d129e6568a5c9a2e$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d129e6568a5c9a2e$var$isArray = Array.isArray;
var $d129e6568a5c9a2e$export$2e2bcd8739ae039 = $d129e6568a5c9a2e$var$isArray;

});

parcelRegister("icZJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4193bdfe2397598$export$2e2bcd8739ae039);

var $8pHBa = parcelRequire("8pHBa");

var $ydcRw = parcelRequire("ydcRw");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $d4193bdfe2397598$var$isArrayLikeObject(value) {
    return (0, $ydcRw.default)(value) && (0, $8pHBa.default)(value);
}
var $d4193bdfe2397598$export$2e2bcd8739ae039 = $d4193bdfe2397598$var$isArrayLikeObject;

});
parcelRegister("8pHBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $62027a42d464cbbf$export$2e2bcd8739ae039);

var $8WSEV = parcelRequire("8WSEV");

var $fpNby = parcelRequire("fpNby");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $62027a42d464cbbf$var$isArrayLike(value) {
    return value != null && (0, $fpNby.default)(value.length) && !(0, $8WSEV.default)(value);
}
var $62027a42d464cbbf$export$2e2bcd8739ae039 = $62027a42d464cbbf$var$isArrayLike;

});
parcelRegister("fpNby", function(module, exports) {

$parcel$export(module.exports, "default", () => $b38f57fe9b1971bb$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $b38f57fe9b1971bb$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $b38f57fe9b1971bb$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $b38f57fe9b1971bb$var$MAX_SAFE_INTEGER;
}
var $b38f57fe9b1971bb$export$2e2bcd8739ae039 = $b38f57fe9b1971bb$var$isLength;

});



parcelRegister("hiJJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c987991464247417$export$2e2bcd8739ae039);

var $2ZUhy = parcelRequire("2ZUhy");

var $iE4IL = parcelRequire("iE4IL");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2ZUhy.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $iE4IL.default);
var $c987991464247417$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("iE4IL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d92f9fef287f6869$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $d92f9fef287f6869$var$stubFalse() {
    return false;
}
var $d92f9fef287f6869$export$2e2bcd8739ae039 = $d92f9fef287f6869$var$stubFalse;

});


parcelRegister("bOFVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a4e328099889b2$export$2e2bcd8739ae039);

var $f4sy6 = parcelRequire("f4sy6");

var $lPOv3 = parcelRequire("lPOv3");

var $ydcRw = parcelRequire("ydcRw");
/** `Object#toString` result references. */ var $89a4e328099889b2$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $89a4e328099889b2$var$funcProto = Function.prototype, $89a4e328099889b2$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $89a4e328099889b2$var$funcToString = $89a4e328099889b2$var$funcProto.toString;
/** Used to check objects for own properties. */ var $89a4e328099889b2$var$hasOwnProperty = $89a4e328099889b2$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $89a4e328099889b2$var$objectCtorString = $89a4e328099889b2$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $89a4e328099889b2$var$isPlainObject(value) {
    if (!(0, $ydcRw.default)(value) || (0, $f4sy6.default)(value) != $89a4e328099889b2$var$objectTag) return false;
    var proto = (0, $lPOv3.default)(value);
    if (proto === null) return true;
    var Ctor = $89a4e328099889b2$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $89a4e328099889b2$var$funcToString.call(Ctor) == $89a4e328099889b2$var$objectCtorString;
}
var $89a4e328099889b2$export$2e2bcd8739ae039 = $89a4e328099889b2$var$isPlainObject;

});

parcelRegister("ckYSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fb692530855fc35$export$2e2bcd8739ae039);

var $euZ8c = parcelRequire("euZ8c");

var $i0Jgc = parcelRequire("i0Jgc");

var $lAe6g = parcelRequire("lAe6g");
/* Node.js helper references. */ var $8fb692530855fc35$var$nodeIsTypedArray = (0, $lAe6g.default) && (0, $lAe6g.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $8fb692530855fc35$var$isTypedArray = $8fb692530855fc35$var$nodeIsTypedArray ? (0, $i0Jgc.default)($8fb692530855fc35$var$nodeIsTypedArray) : (0, $euZ8c.default);
var $8fb692530855fc35$export$2e2bcd8739ae039 = $8fb692530855fc35$var$isTypedArray;

});
parcelRegister("euZ8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8e349708fb24653$export$2e2bcd8739ae039);

var $f4sy6 = parcelRequire("f4sy6");

var $fpNby = parcelRequire("fpNby");

var $ydcRw = parcelRequire("ydcRw");
/** `Object#toString` result references. */ var $a8e349708fb24653$var$argsTag = '[object Arguments]', $a8e349708fb24653$var$arrayTag = '[object Array]', $a8e349708fb24653$var$boolTag = '[object Boolean]', $a8e349708fb24653$var$dateTag = '[object Date]', $a8e349708fb24653$var$errorTag = '[object Error]', $a8e349708fb24653$var$funcTag = '[object Function]', $a8e349708fb24653$var$mapTag = '[object Map]', $a8e349708fb24653$var$numberTag = '[object Number]', $a8e349708fb24653$var$objectTag = '[object Object]', $a8e349708fb24653$var$regexpTag = '[object RegExp]', $a8e349708fb24653$var$setTag = '[object Set]', $a8e349708fb24653$var$stringTag = '[object String]', $a8e349708fb24653$var$weakMapTag = '[object WeakMap]';
var $a8e349708fb24653$var$arrayBufferTag = '[object ArrayBuffer]', $a8e349708fb24653$var$dataViewTag = '[object DataView]', $a8e349708fb24653$var$float32Tag = '[object Float32Array]', $a8e349708fb24653$var$float64Tag = '[object Float64Array]', $a8e349708fb24653$var$int8Tag = '[object Int8Array]', $a8e349708fb24653$var$int16Tag = '[object Int16Array]', $a8e349708fb24653$var$int32Tag = '[object Int32Array]', $a8e349708fb24653$var$uint8Tag = '[object Uint8Array]', $a8e349708fb24653$var$uint8ClampedTag = '[object Uint8ClampedArray]', $a8e349708fb24653$var$uint16Tag = '[object Uint16Array]', $a8e349708fb24653$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $a8e349708fb24653$var$typedArrayTags = {};
$a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$float32Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$float64Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$int8Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$int16Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$int32Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$uint8Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$uint8ClampedTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$uint16Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$uint32Tag] = true;
$a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$argsTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$arrayTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$arrayBufferTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$boolTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$dataViewTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$dateTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$errorTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$funcTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$mapTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$numberTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$objectTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$regexpTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$setTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$stringTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a8e349708fb24653$var$baseIsTypedArray(value) {
    return (0, $ydcRw.default)(value) && (0, $fpNby.default)(value.length) && !!$a8e349708fb24653$var$typedArrayTags[(0, $f4sy6.default)(value)];
}
var $a8e349708fb24653$export$2e2bcd8739ae039 = $a8e349708fb24653$var$baseIsTypedArray;

});

parcelRegister("i0Jgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1cb55d2b1225f37$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $d1cb55d2b1225f37$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $d1cb55d2b1225f37$export$2e2bcd8739ae039 = $d1cb55d2b1225f37$var$baseUnary;

});

parcelRegister("lAe6g", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb67e5bd130cd129$export$2e2bcd8739ae039);

var $eEY6y = parcelRequire("eEY6y");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $eEY6y.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $fb67e5bd130cd129$export$2e2bcd8739ae039 = nodeUtil;

});


parcelRegister("g7yOx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbc84e2c2a83f7db$export$2e2bcd8739ae039);
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $bbc84e2c2a83f7db$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $bbc84e2c2a83f7db$export$2e2bcd8739ae039 = $bbc84e2c2a83f7db$var$safeGet;

});

parcelRegister("eCWAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $02bf84625a8b8755$export$2e2bcd8739ae039);

var $8Up13 = parcelRequire("8Up13");

var $fIbiK = parcelRequire("fIbiK");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $02bf84625a8b8755$var$toPlainObject(value) {
    return (0, $8Up13.default)(value, (0, $fIbiK.default)(value));
}
var $02bf84625a8b8755$export$2e2bcd8739ae039 = $02bf84625a8b8755$var$toPlainObject;

});
parcelRegister("8Up13", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c6f55e9e7fb040$export$2e2bcd8739ae039);

var $kYkm0 = parcelRequire("kYkm0");

var $bWSGY = parcelRequire("bWSGY");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $67c6f55e9e7fb040$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $bWSGY.default)(object, key, newValue);
        else (0, $kYkm0.default)(object, key, newValue);
    }
    return object;
}
var $67c6f55e9e7fb040$export$2e2bcd8739ae039 = $67c6f55e9e7fb040$var$copyObject;

});
parcelRegister("kYkm0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f449331fcce2b408$export$2e2bcd8739ae039);

var $bWSGY = parcelRequire("bWSGY");

var $78Lr5 = parcelRequire("78Lr5");
/** Used for built-in method references. */ var $f449331fcce2b408$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f449331fcce2b408$var$hasOwnProperty = $f449331fcce2b408$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f449331fcce2b408$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($f449331fcce2b408$var$hasOwnProperty.call(object, key) && (0, $78Lr5.default)(objValue, value)) || value === undefined && !(key in object)) (0, $bWSGY.default)(object, key, value);
}
var $f449331fcce2b408$export$2e2bcd8739ae039 = $f449331fcce2b408$var$assignValue;

});


parcelRegister("fIbiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b703bb51de33f3da$export$2e2bcd8739ae039);

var $fuUH8 = parcelRequire("fuUH8");

var $6mi2A = parcelRequire("6mi2A");

var $8pHBa = parcelRequire("8pHBa");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $b703bb51de33f3da$var$keysIn(object) {
    return (0, $8pHBa.default)(object) ? (0, $fuUH8.default)(object, true) : (0, $6mi2A.default)(object);
}
var $b703bb51de33f3da$export$2e2bcd8739ae039 = $b703bb51de33f3da$var$keysIn;

});
parcelRegister("fuUH8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b485a2c4081a5d7a$export$2e2bcd8739ae039);

var $ds54F = parcelRequire("ds54F");

var $ebAE7 = parcelRequire("ebAE7");

var $hXn90 = parcelRequire("hXn90");

var $hiJJV = parcelRequire("hiJJV");

var $g3KRC = parcelRequire("g3KRC");

var $ckYSa = parcelRequire("ckYSa");
/** Used for built-in method references. */ var $b485a2c4081a5d7a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b485a2c4081a5d7a$var$hasOwnProperty = $b485a2c4081a5d7a$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $b485a2c4081a5d7a$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $hXn90.default)(value), isArg = !isArr && (0, $ebAE7.default)(value), isBuff = !isArr && !isArg && (0, $hiJJV.default)(value), isType = !isArr && !isArg && !isBuff && (0, $ckYSa.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $ds54F.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $b485a2c4081a5d7a$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $g3KRC.default)(key, length)))) result.push(key);
    return result;
}
var $b485a2c4081a5d7a$export$2e2bcd8739ae039 = $b485a2c4081a5d7a$var$arrayLikeKeys;

});
parcelRegister("ds54F", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cb1d388d31961ff$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $9cb1d388d31961ff$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $9cb1d388d31961ff$export$2e2bcd8739ae039 = $9cb1d388d31961ff$var$baseTimes;

});

parcelRegister("g3KRC", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb1147505a697450$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $bb1147505a697450$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $bb1147505a697450$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $bb1147505a697450$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $bb1147505a697450$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $bb1147505a697450$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $bb1147505a697450$export$2e2bcd8739ae039 = $bb1147505a697450$var$isIndex;

});


parcelRegister("6mi2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a12caaf9a168473$export$2e2bcd8739ae039);

var $kXXxV = parcelRequire("kXXxV");

var $7H3cd = parcelRequire("7H3cd");

var $kXLw9 = parcelRequire("kXLw9");
/** Used for built-in method references. */ var $4a12caaf9a168473$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4a12caaf9a168473$var$hasOwnProperty = $4a12caaf9a168473$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $4a12caaf9a168473$var$baseKeysIn(object) {
    if (!(0, $kXXxV.default)(object)) return (0, $kXLw9.default)(object);
    var isProto = (0, $7H3cd.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$4a12caaf9a168473$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $4a12caaf9a168473$export$2e2bcd8739ae039 = $4a12caaf9a168473$var$baseKeysIn;

});
parcelRegister("kXLw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f42e2d565706b6d4$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f42e2d565706b6d4$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $f42e2d565706b6d4$export$2e2bcd8739ae039 = $f42e2d565706b6d4$var$nativeKeysIn;

});






parcelRegister("1jwcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f508c7875557669$export$2e2bcd8739ae039);

var $e5ePl = parcelRequire("e5ePl");

var $bPTtD = parcelRequire("bPTtD");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $0f508c7875557669$var$createAssigner(assigner) {
    return (0, $e5ePl.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $bPTtD.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $0f508c7875557669$export$2e2bcd8739ae039 = $0f508c7875557669$var$createAssigner;

});
parcelRegister("e5ePl", function(module, exports) {

$parcel$export(module.exports, "default", () => $02a55f1ba864368b$export$2e2bcd8739ae039);

var $fktFl = parcelRequire("fktFl");

var $3LRzs = parcelRequire("3LRzs");

var $6iyEc = parcelRequire("6iyEc");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $02a55f1ba864368b$var$baseRest(func, start) {
    return (0, $6iyEc.default)((0, $3LRzs.default)(func, start, (0, $fktFl.default)), func + '');
}
var $02a55f1ba864368b$export$2e2bcd8739ae039 = $02a55f1ba864368b$var$baseRest;

});
parcelRegister("fktFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b28fbc494eeb3145$export$2e2bcd8739ae039);
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $b28fbc494eeb3145$var$identity(value) {
    return value;
}
var $b28fbc494eeb3145$export$2e2bcd8739ae039 = $b28fbc494eeb3145$var$identity;

});

parcelRegister("3LRzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bef50f13d973928$export$2e2bcd8739ae039);

var $g4av9 = parcelRequire("g4av9");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2bef50f13d973928$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $2bef50f13d973928$var$overRest(func, start, transform) {
    start = $2bef50f13d973928$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $2bef50f13d973928$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $g4av9.default)(func, this, otherArgs);
    };
}
var $2bef50f13d973928$export$2e2bcd8739ae039 = $2bef50f13d973928$var$overRest;

});
parcelRegister("g4av9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb252a691659aeb8$export$2e2bcd8739ae039);
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $bb252a691659aeb8$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $bb252a691659aeb8$export$2e2bcd8739ae039 = $bb252a691659aeb8$var$apply;

});


parcelRegister("6iyEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $495f4cc291d9adf3$export$2e2bcd8739ae039);

var $8CIs9 = parcelRequire("8CIs9");

var $k4rRt = parcelRequire("k4rRt");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $495f4cc291d9adf3$var$setToString = (0, $k4rRt.default)((0, $8CIs9.default));
var $495f4cc291d9adf3$export$2e2bcd8739ae039 = $495f4cc291d9adf3$var$setToString;

});
parcelRegister("8CIs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $64745acdfc17e50f$export$2e2bcd8739ae039);

var $74LjD = parcelRequire("74LjD");

var $cfI3G = parcelRequire("cfI3G");

var $fktFl = parcelRequire("fktFl");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $64745acdfc17e50f$var$baseSetToString = !(0, $cfI3G.default) ? (0, $fktFl.default) : function(func, string) {
    return (0, $cfI3G.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $74LjD.default)(string),
        'writable': true
    });
};
var $64745acdfc17e50f$export$2e2bcd8739ae039 = $64745acdfc17e50f$var$baseSetToString;

});
parcelRegister("74LjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $526d9c0a5c43b886$export$2e2bcd8739ae039);
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $526d9c0a5c43b886$var$constant(value) {
    return function() {
        return value;
    };
}
var $526d9c0a5c43b886$export$2e2bcd8739ae039 = $526d9c0a5c43b886$var$constant;

});


parcelRegister("k4rRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9c9cb134a523c22$export$2e2bcd8739ae039);
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $e9c9cb134a523c22$var$HOT_COUNT = 800, $e9c9cb134a523c22$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e9c9cb134a523c22$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $e9c9cb134a523c22$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $e9c9cb134a523c22$var$nativeNow(), remaining = $e9c9cb134a523c22$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $e9c9cb134a523c22$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $e9c9cb134a523c22$export$2e2bcd8739ae039 = $e9c9cb134a523c22$var$shortOut;

});



parcelRegister("bPTtD", function(module, exports) {

$parcel$export(module.exports, "default", () => $89df7db7ae630b98$export$2e2bcd8739ae039);

var $78Lr5 = parcelRequire("78Lr5");

var $8pHBa = parcelRequire("8pHBa");

var $g3KRC = parcelRequire("g3KRC");

var $kXXxV = parcelRequire("kXXxV");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $89df7db7ae630b98$var$isIterateeCall(value, index, object) {
    if (!(0, $kXXxV.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $8pHBa.default)(object) && (0, $g3KRC.default)(index, object.length) : type == 'string' && index in object) return (0, $78Lr5.default)(object[index], value);
    return false;
}
var $89df7db7ae630b98$export$2e2bcd8739ae039 = $89df7db7ae630b98$var$isIterateeCall;

});



parcelRegister("lHwOS", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $fcc7126f4809333a$export$775b6bb06e53a214);
$parcel$export(module.exports, "Attributor", () => $fcc7126f4809333a$export$217610c4183502d0);
$parcel$export(module.exports, "Registry", () => $fcc7126f4809333a$export$4d9facee29974f3);
$parcel$export(module.exports, "ClassAttributor", () => $fcc7126f4809333a$export$651d45509677cf07);
$parcel$export(module.exports, "StyleAttributor", () => $fcc7126f4809333a$export$7c8099bbfe87b94d);
$parcel$export(module.exports, "AttributorStore", () => $fcc7126f4809333a$export$68ad86ab95e8de42);
$parcel$export(module.exports, "LeafBlot", () => $fcc7126f4809333a$export$7420b9c542181544);
$parcel$export(module.exports, "ParentBlot", () => $fcc7126f4809333a$export$e43113f0aad76fe);
$parcel$export(module.exports, "InlineBlot", () => $fcc7126f4809333a$export$f67a34bc25a7a861);
$parcel$export(module.exports, "BlockBlot", () => $fcc7126f4809333a$export$4f7f03641f7bfc8c);
$parcel$export(module.exports, "ContainerBlot", () => $fcc7126f4809333a$export$c898d510319704c0);
$parcel$export(module.exports, "EmbedBlot", () => $fcc7126f4809333a$export$297a1fa96f55f00f);
$parcel$export(module.exports, "ScrollBlot", () => $fcc7126f4809333a$export$7175329dad7a46f1);
$parcel$export(module.exports, "TextBlot", () => $fcc7126f4809333a$export$10ac0c5716409de6);
var $fcc7126f4809333a$export$775b6bb06e53a214 = /* @__PURE__ */ ((Scope2)=>(Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2))($fcc7126f4809333a$export$775b6bb06e53a214 || {});
class $fcc7126f4809333a$export$217610c4183502d0 {
    constructor(attrName, keyName, options = {}){
        this.attrName = attrName, this.keyName = keyName;
        const attributeBit = $fcc7126f4809333a$export$775b6bb06e53a214.TYPE & $fcc7126f4809333a$export$775b6bb06e53a214.ATTRIBUTE;
        this.scope = options.scope != null ? // Ignore type bits, force attribute bit
        options.scope & $fcc7126f4809333a$export$775b6bb06e53a214.LEVEL | attributeBit : $fcc7126f4809333a$export$775b6bb06e53a214.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
    }
    static keys(node) {
        return Array.from(node.attributes).map((item)=>item.name);
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
    }
    canAdd(_node, value) {
        return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
    }
    remove(node) {
        node.removeAttribute(this.keyName);
    }
    value(node) {
        const value = node.getAttribute(this.keyName);
        return this.canAdd(node, value) && value ? value : "";
    }
}
class $fcc7126f4809333a$var$ParchmentError extends Error {
    constructor(message){
        message = "[Parchment] " + message, super(message), this.message = message, this.name = this.constructor.name;
    }
}
const $fcc7126f4809333a$var$_Registry = class _Registry {
    constructor(){
        this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
    }
    static find(node, bubble = !1) {
        if (node == null) return null;
        if (this.blots.has(node)) return this.blots.get(node) || null;
        if (bubble) {
            let parentNode = null;
            try {
                parentNode = node.parentNode;
            } catch  {
                return null;
            }
            return this.find(parentNode, bubble);
        }
        return null;
    }
    create(scroll, input, value) {
        const match2 = this.query(input);
        if (match2 == null) throw new $fcc7126f4809333a$var$ParchmentError(`Unable to create ${input} blot`);
        const blotClass = match2, node = // @ts-expect-error Fix me later
        input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value), blot = new blotClass(scroll, node, value);
        return _Registry.blots.set(blot.domNode, blot), blot;
    }
    find(node, bubble = !1) {
        return _Registry.find(node, bubble);
    }
    query(query, scope = $fcc7126f4809333a$export$775b6bb06e53a214.ANY) {
        let match2;
        return typeof query == "string" ? match2 = this.types[query] || this.attributes[query] : query instanceof Text || query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof query == "number" ? query & $fcc7126f4809333a$export$775b6bb06e53a214.LEVEL & $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK ? match2 = this.types.block : query & $fcc7126f4809333a$export$775b6bb06e53a214.LEVEL & $fcc7126f4809333a$export$775b6bb06e53a214.INLINE && (match2 = this.types.inline) : query instanceof Element && ((query.getAttribute("class") || "").split(/\s+/).some((name)=>(match2 = this.classes[name], !!match2)), match2 = match2 || this.tags[query.tagName]), match2 == null ? null : "scope" in match2 && scope & $fcc7126f4809333a$export$775b6bb06e53a214.LEVEL & match2.scope && scope & $fcc7126f4809333a$export$775b6bb06e53a214.TYPE & match2.scope ? match2 : null;
    }
    register(...definitions) {
        return definitions.map((definition)=>{
            const isBlot = "blotName" in definition, isAttr = "attrName" in definition;
            if (!isBlot && !isAttr) throw new $fcc7126f4809333a$var$ParchmentError("Invalid definition");
            if (isBlot && definition.blotName === "abstract") throw new $fcc7126f4809333a$var$ParchmentError("Cannot register abstract class");
            const key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
            return this.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (this.attributes[definition.keyName] = definition) : isBlot && (definition.className && (this.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map((tagName)=>tagName.toUpperCase()) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [
                definition.tagName
            ]).forEach((tag)=>{
                (this.tags[tag] == null || definition.className == null) && (this.tags[tag] = definition);
            }))), definition;
        });
    }
};
$fcc7126f4809333a$var$_Registry.blots = /* @__PURE__ */ new WeakMap();
let $fcc7126f4809333a$export$4d9facee29974f3 = $fcc7126f4809333a$var$_Registry;
function $fcc7126f4809333a$var$match(node, prefix) {
    return (node.getAttribute("class") || "").split(/\s+/).filter((name)=>name.indexOf(`${prefix}-`) === 0);
}
class $fcc7126f4809333a$var$ClassAttributor extends $fcc7126f4809333a$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("class") || "").split(/\s+/).map((name)=>name.split("-").slice(0, -1).join("-"));
    }
    add(node, value) {
        return this.canAdd(node, value) ? (this.remove(node), node.classList.add(`${this.keyName}-${value}`), !0) : !1;
    }
    remove(node) {
        $fcc7126f4809333a$var$match(node, this.keyName).forEach((name)=>{
            node.classList.remove(name);
        }), node.classList.length === 0 && node.removeAttribute("class");
    }
    value(node) {
        const value = ($fcc7126f4809333a$var$match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
        return this.canAdd(node, value) ? value : "";
    }
}
const $fcc7126f4809333a$export$651d45509677cf07 = $fcc7126f4809333a$var$ClassAttributor;
function $fcc7126f4809333a$var$camelize(name) {
    const parts = name.split("-"), rest = parts.slice(1).map((part)=>part[0].toUpperCase() + part.slice(1)).join("");
    return parts[0] + rest;
}
class $fcc7126f4809333a$var$StyleAttributor extends $fcc7126f4809333a$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("style") || "").split(";").map((value)=>value.split(":")[0].trim());
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.style[$fcc7126f4809333a$var$camelize(this.keyName)] = value, !0) : !1;
    }
    remove(node) {
        node.style[$fcc7126f4809333a$var$camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
    }
    value(node) {
        const value = node.style[$fcc7126f4809333a$var$camelize(this.keyName)];
        return this.canAdd(node, value) ? value : "";
    }
}
const $fcc7126f4809333a$export$7c8099bbfe87b94d = $fcc7126f4809333a$var$StyleAttributor;
class $fcc7126f4809333a$var$AttributorStore {
    constructor(domNode){
        this.attributes = {}, this.domNode = domNode, this.build();
    }
    attribute(attribute, value) {
        value ? attribute.add(this.domNode, value) && (attribute.value(this.domNode) != null ? this.attributes[attribute.attrName] = attribute : delete this.attributes[attribute.attrName]) : (attribute.remove(this.domNode), delete this.attributes[attribute.attrName]);
    }
    build() {
        this.attributes = {};
        const blot = $fcc7126f4809333a$export$4d9facee29974f3.find(this.domNode);
        if (blot == null) return;
        const attributes = $fcc7126f4809333a$export$217610c4183502d0.keys(this.domNode), classes = $fcc7126f4809333a$export$651d45509677cf07.keys(this.domNode), styles = $fcc7126f4809333a$export$7c8099bbfe87b94d.keys(this.domNode);
        attributes.concat(classes).concat(styles).forEach((name)=>{
            const attr = blot.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.ATTRIBUTE);
            attr instanceof $fcc7126f4809333a$export$217610c4183502d0 && (this.attributes[attr.attrName] = attr);
        });
    }
    copy(target) {
        Object.keys(this.attributes).forEach((key)=>{
            const value = this.attributes[key].value(this.domNode);
            target.format(key, value);
        });
    }
    move(target) {
        this.copy(target), Object.keys(this.attributes).forEach((key)=>{
            this.attributes[key].remove(this.domNode);
        }), this.attributes = {};
    }
    values() {
        return Object.keys(this.attributes).reduce((attributes, name)=>(attributes[name] = this.attributes[name].value(this.domNode), attributes), {});
    }
}
const $fcc7126f4809333a$export$68ad86ab95e8de42 = $fcc7126f4809333a$var$AttributorStore, $fcc7126f4809333a$var$_ShadowBlot = class _ShadowBlot {
    constructor(scroll, domNode){
        this.scroll = scroll, this.domNode = domNode, $fcc7126f4809333a$export$4d9facee29974f3.blots.set(domNode, this), this.prev = null, this.next = null;
    }
    static create(rawValue) {
        if (this.tagName == null) throw new $fcc7126f4809333a$var$ParchmentError("Blot definition missing tagName");
        let node, value;
        return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
    }
    // Hack for accessing inherited static methods
    get statics() {
        return this.constructor;
    }
    attach() {}
    clone() {
        const domNode = this.domNode.cloneNode(!1);
        return this.scroll.create(domNode);
    }
    detach() {
        this.parent != null && this.parent.removeChild(this), $fcc7126f4809333a$export$4d9facee29974f3.blots.delete(this.domNode);
    }
    deleteAt(index, length) {
        this.isolate(index, length).remove();
    }
    formatAt(index, length, name, value) {
        const blot = this.isolate(index, length);
        if (this.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.BLOT) != null && value) blot.wrap(name, value);
        else if (this.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.ATTRIBUTE) != null) {
            const parent = this.scroll.create(this.statics.scope);
            blot.wrap(parent), parent.format(name, value);
        }
    }
    insertAt(index, value, def) {
        const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def), ref = this.split(index);
        this.parent.insertBefore(blot, ref || void 0);
    }
    isolate(index, length) {
        const target = this.split(index);
        if (target == null) throw new Error("Attempt to isolate at end");
        return target.split(length), target;
    }
    length() {
        return 1;
    }
    offset(root = this.parent) {
        return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
    }
    optimize(_context) {
        this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
    }
    remove() {
        this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
    }
    split(index, _force) {
        return index === 0 ? this : this.next;
    }
    update(_mutations, _context) {}
    wrap(name, value) {
        const wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
        if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function") throw new $fcc7126f4809333a$var$ParchmentError(`Cannot wrap ${name}`);
        return wrapper.appendChild(this), wrapper;
    }
};
$fcc7126f4809333a$var$_ShadowBlot.blotName = "abstract";
let $fcc7126f4809333a$var$ShadowBlot = $fcc7126f4809333a$var$_ShadowBlot;
const $fcc7126f4809333a$var$_LeafBlot = class _LeafBlot extends $fcc7126f4809333a$var$ShadowBlot {
    /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */ static value(_domNode) {
        return !0;
    }
    /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */ index(node, offset) {
        return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
    }
    /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */ position(index, _inclusive) {
        let offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
        return index > 0 && (offset += 1), [
            this.parent.domNode,
            offset
        ];
    }
    /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */ value() {
        return {
            [this.statics.blotName]: this.statics.value(this.domNode) || !0
        };
    }
};
$fcc7126f4809333a$var$_LeafBlot.scope = $fcc7126f4809333a$export$775b6bb06e53a214.INLINE_BLOT;
let $fcc7126f4809333a$var$LeafBlot = $fcc7126f4809333a$var$_LeafBlot;
const $fcc7126f4809333a$export$7420b9c542181544 = $fcc7126f4809333a$var$LeafBlot;
class $fcc7126f4809333a$var$LinkedList {
    constructor(){
        this.head = null, this.tail = null, this.length = 0;
    }
    append(...nodes) {
        if (this.insertBefore(nodes[0], null), nodes.length > 1) {
            const rest = nodes.slice(1);
            this.append(...rest);
        }
    }
    at(index) {
        const next = this.iterator();
        let cur = next();
        for(; cur && index > 0;)index -= 1, cur = next();
        return cur;
    }
    contains(node) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            if (cur === node) return !0;
            cur = next();
        }
        return !1;
    }
    indexOf(node) {
        const next = this.iterator();
        let cur = next(), index = 0;
        for(; cur;){
            if (cur === node) return index;
            index += 1, cur = next();
        }
        return -1;
    }
    insertBefore(node, refNode) {
        node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
    }
    offset(target) {
        let index = 0, cur = this.head;
        for(; cur != null;){
            if (cur === target) return index;
            index += cur.length(), cur = cur.next;
        }
        return -1;
    }
    remove(node) {
        this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
    }
    iterator(curNode = this.head) {
        return ()=>{
            const ret = curNode;
            return curNode != null && (curNode = curNode.next), ret;
        };
    }
    find(index, inclusive = !1) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            const length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                cur,
                index
            ];
            index -= length, cur = next();
        }
        return [
            null,
            0
        ];
    }
    forEach(callback) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)callback(cur), cur = next();
    }
    forEachAt(index, length, callback) {
        if (length <= 0) return;
        const [startNode, offset] = this.find(index);
        let curIndex = index - offset;
        const next = this.iterator(startNode);
        let cur = next();
        for(; cur && curIndex < index + length;){
            const curLength = cur.length();
            index > curIndex ? callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index)) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
        }
    }
    map(callback) {
        return this.reduce((memo, cur)=>(memo.push(callback(cur)), memo), []);
    }
    reduce(callback, memo) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)memo = callback(memo, cur), cur = next();
        return memo;
    }
}
function $fcc7126f4809333a$var$makeAttachedBlot(node, scroll) {
    const found = scroll.find(node);
    if (found) return found;
    try {
        return scroll.create(node);
    } catch  {
        const blot = scroll.create($fcc7126f4809333a$export$775b6bb06e53a214.INLINE);
        return Array.from(node.childNodes).forEach((child)=>{
            blot.domNode.appendChild(child);
        }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
    }
}
const $fcc7126f4809333a$var$_ParentBlot = class _ParentBlot extends $fcc7126f4809333a$var$ShadowBlot {
    constructor(scroll, domNode){
        super(scroll, domNode), this.uiNode = null, this.build();
    }
    appendChild(other) {
        this.insertBefore(other);
    }
    attach() {
        super.attach(), this.children.forEach((child)=>{
            child.attach();
        });
    }
    attachUI(node) {
        this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
    }
    /**
   * Called during construction, should fill its own children LinkedList.
   */ build() {
        this.children = new $fcc7126f4809333a$var$LinkedList(), Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode).reverse().forEach((node)=>{
            try {
                const child = $fcc7126f4809333a$var$makeAttachedBlot(node, this.scroll);
                this.insertBefore(child, this.children.head || void 0);
            } catch (err) {
                if (err instanceof $fcc7126f4809333a$var$ParchmentError) return;
                throw err;
            }
        });
    }
    deleteAt(index, length) {
        if (index === 0 && length === this.length()) return this.remove();
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.deleteAt(offset, childLength);
        });
    }
    descendant(criteria, index = 0) {
        const [child, offset] = this.children.find(index);
        return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [
            child,
            offset
        ] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [
            null,
            -1
        ];
    }
    descendants(criteria, index = 0, length = Number.MAX_VALUE) {
        let descendants = [], lengthLeft = length;
        return this.children.forEachAt(index, length, (child, childIndex, childLength)=>{
            (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft))), lengthLeft -= childLength;
        }), descendants;
    }
    detach() {
        this.children.forEach((child)=>{
            child.detach();
        }), super.detach();
    }
    enforceAllowedChildren() {
        let done = !1;
        this.children.forEach((child)=>{
            done || this.statics.allowedChildren.some((def)=>child instanceof def) || (child.statics.scope === $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK_BLOT ? (child.next != null && this.splitAfter(child), child.prev != null && this.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
        });
    }
    formatAt(index, length, name, value) {
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.formatAt(offset, childLength, name, value);
        });
    }
    insertAt(index, value, def) {
        const [child, offset] = this.children.find(index);
        if (child) child.insertAt(offset, value, def);
        else {
            const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
            this.appendChild(blot);
        }
    }
    insertBefore(childBlot, refBlot) {
        childBlot.parent != null && childBlot.parent.children.remove(childBlot);
        let refDomNode = null;
        this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
    }
    length() {
        return this.children.reduce((memo, child)=>memo + child.length(), 0);
    }
    moveChildren(targetParent, refNode) {
        this.children.forEach((child)=>{
            targetParent.insertBefore(child, refNode);
        });
    }
    optimize(context) {
        if (super.optimize(context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                const child = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(child);
            } else this.remove();
        }
    }
    path(index, inclusive = !1) {
        const [child, offset] = this.children.find(index, inclusive), position = [
            [
                this,
                index
            ]
        ];
        return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([
            child,
            offset
        ]), position);
    }
    removeChild(child) {
        this.children.remove(child);
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return replacement instanceof _ParentBlot && this.moveChildren(replacement), super.replaceWith(replacement);
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.clone();
        return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), (child, offset, _length)=>{
            const split = child.split(offset, force);
            split != null && after.appendChild(split);
        }), after;
    }
    splitAfter(child) {
        const after = this.clone();
        for(; child.next != null;)after.appendChild(child.next);
        return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
    }
    unwrap() {
        this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
    }
    update(mutations, _context) {
        const addedNodes = [], removedNodes = [];
        mutations.forEach((mutation)=>{
            mutation.target === this.domNode && mutation.type === "childList" && (addedNodes.push(...mutation.addedNodes), removedNodes.push(...mutation.removedNodes));
        }), removedNodes.forEach((node)=>{
            if (node.parentNode != null && // @ts-expect-error Fix me later
            node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
            const blot = this.scroll.find(node);
            blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === this.domNode) && blot.detach();
        }), addedNodes.filter((node)=>node.parentNode === this.domNode && node !== this.uiNode).sort((a, b)=>a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((node)=>{
            let refBlot = null;
            node.nextSibling != null && (refBlot = this.scroll.find(node.nextSibling));
            const blot = $fcc7126f4809333a$var$makeAttachedBlot(node, this.scroll);
            (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(this), this.insertBefore(blot, refBlot || void 0));
        }), this.enforceAllowedChildren();
    }
};
$fcc7126f4809333a$var$_ParentBlot.uiClass = "";
let $fcc7126f4809333a$var$ParentBlot = $fcc7126f4809333a$var$_ParentBlot;
const $fcc7126f4809333a$export$e43113f0aad76fe = $fcc7126f4809333a$var$ParentBlot;
function $fcc7126f4809333a$var$isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return !1;
    for(const prop in obj1)if (obj1[prop] !== obj2[prop]) return !1;
    return !0;
}
const $fcc7126f4809333a$var$_InlineBlot = class _InlineBlot extends $fcc7126f4809333a$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_InlineBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $fcc7126f4809333a$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        if (name === this.statics.blotName && !value) this.children.forEach((child)=>{
            child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), this.attributes.copy(child);
        }), this.unwrap();
        else {
            const format = this.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.INLINE);
            if (format == null) return;
            format instanceof $fcc7126f4809333a$export$217610c4183502d0 ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
        }
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.formats()[name] != null || this.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        const formats = this.formats();
        if (Object.keys(formats).length === 0) return this.unwrap();
        const next = this.next;
        next instanceof _InlineBlot && next.prev === this && $fcc7126f4809333a$var$isEqual(formats, next.formats()) && (next.moveChildren(this), next.remove());
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
    wrap(name, value) {
        const wrapper = super.wrap(name, value);
        return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
    }
};
$fcc7126f4809333a$var$_InlineBlot.allowedChildren = [
    $fcc7126f4809333a$var$_InlineBlot,
    $fcc7126f4809333a$export$7420b9c542181544
], $fcc7126f4809333a$var$_InlineBlot.blotName = "inline", $fcc7126f4809333a$var$_InlineBlot.scope = $fcc7126f4809333a$export$775b6bb06e53a214.INLINE_BLOT, $fcc7126f4809333a$var$_InlineBlot.tagName = "SPAN";
let $fcc7126f4809333a$var$InlineBlot = $fcc7126f4809333a$var$_InlineBlot;
const $fcc7126f4809333a$export$f67a34bc25a7a861 = $fcc7126f4809333a$var$InlineBlot, $fcc7126f4809333a$var$_BlockBlot = class _BlockBlot extends $fcc7126f4809333a$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_BlockBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $fcc7126f4809333a$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        const format = this.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK);
        format != null && (format instanceof $fcc7126f4809333a$export$217610c4183502d0 ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK) != null ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        if (def == null || this.scroll.query(value, $fcc7126f4809333a$export$775b6bb06e53a214.INLINE) != null) super.insertAt(index, value, def);
        else {
            const after = this.split(index);
            if (after != null) {
                const blot = this.scroll.create(value, def);
                after.parent.insertBefore(blot, after);
            } else throw new Error("Attempt to insertAt after block boundaries");
        }
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
};
$fcc7126f4809333a$var$_BlockBlot.blotName = "block", $fcc7126f4809333a$var$_BlockBlot.scope = $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK_BLOT, $fcc7126f4809333a$var$_BlockBlot.tagName = "P", $fcc7126f4809333a$var$_BlockBlot.allowedChildren = [
    $fcc7126f4809333a$export$f67a34bc25a7a861,
    $fcc7126f4809333a$var$_BlockBlot,
    $fcc7126f4809333a$export$7420b9c542181544
];
let $fcc7126f4809333a$var$BlockBlot = $fcc7126f4809333a$var$_BlockBlot;
const $fcc7126f4809333a$export$4f7f03641f7bfc8c = $fcc7126f4809333a$var$BlockBlot, $fcc7126f4809333a$var$_ContainerBlot = class _ContainerBlot extends $fcc7126f4809333a$export$e43113f0aad76fe {
    checkMerge() {
        return this.next !== null && this.next.statics.blotName === this.statics.blotName;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length), this.enforceAllowedChildren();
    }
    formatAt(index, length, name, value) {
        super.formatAt(index, length, name, value), this.enforceAllowedChildren();
    }
    insertAt(index, value, def) {
        super.insertAt(index, value, def), this.enforceAllowedChildren();
    }
    optimize(context) {
        super.optimize(context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
    }
};
$fcc7126f4809333a$var$_ContainerBlot.blotName = "container", $fcc7126f4809333a$var$_ContainerBlot.scope = $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK_BLOT;
let $fcc7126f4809333a$var$ContainerBlot = $fcc7126f4809333a$var$_ContainerBlot;
const $fcc7126f4809333a$export$c898d510319704c0 = $fcc7126f4809333a$var$ContainerBlot;
class $fcc7126f4809333a$var$EmbedBlot extends $fcc7126f4809333a$export$7420b9c542181544 {
    static formats(_domNode, _scroll) {}
    format(name, value) {
        super.formatAt(0, this.length(), name, value);
    }
    formatAt(index, length, name, value) {
        index === 0 && length === this.length() ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    formats() {
        return this.statics.formats(this.domNode, this.scroll);
    }
}
const $fcc7126f4809333a$export$297a1fa96f55f00f = $fcc7126f4809333a$var$EmbedBlot, $fcc7126f4809333a$var$OBSERVER_CONFIG = {
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
}, $fcc7126f4809333a$var$MAX_OPTIMIZE_ITERATIONS = 100, $fcc7126f4809333a$var$_ScrollBlot = class _ScrollBlot extends $fcc7126f4809333a$export$e43113f0aad76fe {
    constructor(registry, node){
        super(null, node), this.registry = registry, this.scroll = this, this.build(), this.observer = new MutationObserver((mutations)=>{
            this.update(mutations);
        }), this.observer.observe(this.domNode, $fcc7126f4809333a$var$OBSERVER_CONFIG), this.attach();
    }
    create(input, value) {
        return this.registry.create(this, input, value);
    }
    find(node, bubble = !1) {
        const blot = this.registry.find(node, bubble);
        return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
    }
    query(query, scope = $fcc7126f4809333a$export$775b6bb06e53a214.ANY) {
        return this.registry.query(query, scope);
    }
    register(...definitions) {
        return this.registry.register(...definitions);
    }
    build() {
        this.scroll != null && super.build();
    }
    detach() {
        super.detach(), this.observer.disconnect();
    }
    deleteAt(index, length) {
        this.update(), index === 0 && length === this.length() ? this.children.forEach((child)=>{
            child.remove();
        }) : super.deleteAt(index, length);
    }
    formatAt(index, length, name, value) {
        this.update(), super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        this.update(), super.insertAt(index, value, def);
    }
    optimize(mutations = [], context = {}) {
        super.optimize(context);
        const mutationsMap = context.mutationsMap || /* @__PURE__ */ new WeakMap();
        let records = Array.from(this.observer.takeRecords());
        for(; records.length > 0;)mutations.push(records.pop());
        const mark = (blot, markParent = !0)=>{
            blot == null || blot === this || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
        }, optimize = (blot)=>{
            mutationsMap.has(blot.domNode) && (blot instanceof $fcc7126f4809333a$export$e43113f0aad76fe && blot.children.forEach(optimize), mutationsMap.delete(blot.domNode), blot.optimize(context));
        };
        let remaining = mutations;
        for(let i = 0; remaining.length > 0; i += 1){
            if (i >= $fcc7126f4809333a$var$MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
            for(remaining.forEach((mutation)=>{
                const blot = this.find(mutation.target, !0);
                blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(this.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach((node)=>{
                    const child = this.find(node, !1);
                    mark(child, !1), child instanceof $fcc7126f4809333a$export$e43113f0aad76fe && child.children.forEach((grandChild)=>{
                        mark(grandChild, !1);
                    });
                })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
            }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0;)mutations.push(records.pop());
        }
    }
    update(mutations, context = {}) {
        mutations = mutations || this.observer.takeRecords();
        const mutationsMap = /* @__PURE__ */ new WeakMap();
        mutations.map((mutation)=>{
            const blot = this.find(mutation.target, !0);
            return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [
                mutation
            ]), blot);
        }).forEach((blot)=>{
            blot != null && blot !== this && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
        }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && super.update(mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
    }
};
$fcc7126f4809333a$var$_ScrollBlot.blotName = "scroll", $fcc7126f4809333a$var$_ScrollBlot.defaultChild = $fcc7126f4809333a$export$4f7f03641f7bfc8c, $fcc7126f4809333a$var$_ScrollBlot.allowedChildren = [
    $fcc7126f4809333a$export$4f7f03641f7bfc8c,
    $fcc7126f4809333a$export$c898d510319704c0
], $fcc7126f4809333a$var$_ScrollBlot.scope = $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK_BLOT, $fcc7126f4809333a$var$_ScrollBlot.tagName = "DIV";
let $fcc7126f4809333a$var$ScrollBlot = $fcc7126f4809333a$var$_ScrollBlot;
const $fcc7126f4809333a$export$7175329dad7a46f1 = $fcc7126f4809333a$var$ScrollBlot, $fcc7126f4809333a$var$_TextBlot = class _TextBlot extends $fcc7126f4809333a$export$7420b9c542181544 {
    static create(value) {
        return document.createTextNode(value);
    }
    static value(domNode) {
        return domNode.data;
    }
    constructor(scroll, node){
        super(scroll, node), this.text = this.statics.value(this.domNode);
    }
    deleteAt(index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    }
    index(node, offset) {
        return this.domNode === node ? offset : -1;
    }
    insertAt(index, value, def) {
        def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : super.insertAt(index, value, def);
    }
    length() {
        return this.text.length;
    }
    optimize(context) {
        super.optimize(context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
    }
    position(index, _inclusive = !1) {
        return [
            this.domNode,
            index
        ];
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.scroll.create(this.domNode.splitText(index));
        return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
    }
    update(mutations, _context) {
        mutations.some((mutation)=>mutation.type === "characterData" && mutation.target === this.domNode) && (this.text = this.statics.value(this.domNode));
    }
    value() {
        return this.text;
    }
};
$fcc7126f4809333a$var$_TextBlot.blotName = "text", $fcc7126f4809333a$var$_TextBlot.scope = $fcc7126f4809333a$export$775b6bb06e53a214.INLINE_BLOT;
let $fcc7126f4809333a$var$TextBlot = $fcc7126f4809333a$var$_TextBlot;
const $fcc7126f4809333a$export$10ac0c5716409de6 = $fcc7126f4809333a$var$TextBlot;

});

parcelRegister("kEXGb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AttributeMap = module.exports.OpIterator = module.exports.Op = void 0;

var $kp0J9 = parcelRequire("kp0J9");

var $l8f2B = parcelRequire("l8f2B");

var $3IYP4 = parcelRequire("3IYP4");

var $dGgcE = parcelRequire("dGgcE");
module.exports.AttributeMap = $dGgcE.default;

var $03VRP = parcelRequire("03VRP");
module.exports.Op = $03VRP.default;

var $bmFu7 = parcelRequire("bmFu7");
module.exports.OpIterator = $bmFu7.default;
const $f0a5d622b7cbf8c6$var$NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
const $f0a5d622b7cbf8c6$var$getEmbedTypeAndData = (a, b)=>{
    if (typeof a !== 'object' || a === null) throw new Error(`cannot retain a ${typeof a}`);
    if (typeof b !== 'object' || b === null) throw new Error(`cannot retain a ${typeof b}`);
    const embedType = Object.keys(a)[0];
    if (!embedType || embedType !== Object.keys(b)[0]) throw new Error(`embed types not matched: ${embedType} != ${Object.keys(b)[0]}`);
    return [
        embedType,
        a[embedType],
        b[embedType]
    ];
};
class $f0a5d622b7cbf8c6$var$Delta {
    constructor(ops){
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) this.ops = ops;
        else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
        else this.ops = [];
    }
    static registerEmbed(embedType, handler) {
        this.handlers[embedType] = handler;
    }
    static unregisterEmbed(embedType) {
        delete this.handlers[embedType];
    }
    static getHandler(embedType) {
        const handler = this.handlers[embedType];
        if (!handler) throw new Error(`no handlers for embed type "${embedType}"`);
        return handler;
    }
    insert(arg, attributes) {
        const newOp = {};
        if (typeof arg === 'string' && arg.length === 0) return this;
        newOp.insert = arg;
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    delete(length) {
        if (length <= 0) return this;
        return this.push({
            delete: length
        });
    }
    retain(length, attributes) {
        if (typeof length === 'number' && length <= 0) return this;
        const newOp = {
            retain: length
        };
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    push(newOp) {
        let index = this.ops.length;
        let lastOp = this.ops[index - 1];
        newOp = $l8f2B(newOp);
        if (typeof lastOp === 'object') {
            if (typeof newOp.delete === 'number' && typeof lastOp.delete === 'number') {
                this.ops[index - 1] = {
                    delete: lastOp.delete + newOp.delete
                };
                return this;
            }
            // Since it does not matter if we insert before or after deleting at the same index,
            // always prefer to insert first
            if (typeof lastOp.delete === 'number' && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== 'object') {
                    this.ops.unshift(newOp);
                    return this;
                }
            }
            if ($3IYP4(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                    this.ops[index - 1] = {
                        insert: lastOp.insert + newOp.insert
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                    this.ops[index - 1] = {
                        retain: lastOp.retain + newOp.retain
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                }
            }
        }
        if (index === this.ops.length) this.ops.push(newOp);
        else this.ops.splice(index, 0, newOp);
        return this;
    }
    chop() {
        const lastOp = this.ops[this.ops.length - 1];
        if (lastOp && typeof lastOp.retain === 'number' && !lastOp.attributes) this.ops.pop();
        return this;
    }
    filter(predicate) {
        return this.ops.filter(predicate);
    }
    forEach(predicate) {
        this.ops.forEach(predicate);
    }
    map(predicate) {
        return this.ops.map(predicate);
    }
    partition(predicate) {
        const passed = [];
        const failed = [];
        this.forEach((op)=>{
            const target = predicate(op) ? passed : failed;
            target.push(op);
        });
        return [
            passed,
            failed
        ];
    }
    reduce(predicate, initialValue) {
        return this.ops.reduce(predicate, initialValue);
    }
    changeLength() {
        return this.reduce((length, elem)=>{
            if (elem.insert) return length + $03VRP.default.length(elem);
            else if (elem.delete) return length - elem.delete;
            return length;
        }, 0);
    }
    length() {
        return this.reduce((length, elem)=>{
            return length + $03VRP.default.length(elem);
        }, 0);
    }
    slice(start = 0, end = Infinity) {
        const ops = [];
        const iter = new $bmFu7.default(this.ops);
        let index = 0;
        while(index < end && iter.hasNext()){
            let nextOp;
            if (index < start) nextOp = iter.next(start - index);
            else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
            }
            index += $03VRP.default.length(nextOp);
        }
        return new $f0a5d622b7cbf8c6$var$Delta(ops);
    }
    compose(other) {
        const thisIter = new $bmFu7.default(this.ops);
        const otherIter = new $bmFu7.default(other.ops);
        const ops = [];
        const firstOther = otherIter.peek();
        if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
            let firstLeft = firstOther.retain;
            while(thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft){
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
            }
            if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
        }
        const delta = new $f0a5d622b7cbf8c6$var$Delta(ops);
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else if (thisIter.peekType() === 'delete') delta.push(thisIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (otherOp.retain) {
                    const newOp = {};
                    if (typeof thisOp.retain === 'number') newOp.retain = typeof otherOp.retain === 'number' ? length : otherOp.retain;
                    else if (typeof otherOp.retain === 'number') {
                        if (thisOp.retain == null) newOp.insert = thisOp.insert;
                        else newOp.retain = thisOp.retain;
                    } else {
                        const action = thisOp.retain == null ? 'insert' : 'retain';
                        const [embedType, thisData, otherData] = $f0a5d622b7cbf8c6$var$getEmbedTypeAndData(thisOp[action], otherOp.retain);
                        const handler = $f0a5d622b7cbf8c6$var$Delta.getHandler(embedType);
                        newOp[action] = {
                            [embedType]: handler.compose(thisData, otherData, action === 'retain')
                        };
                    }
                    // Preserve null when composing with a retain, otherwise remove it for inserts
                    const attributes = $dGgcE.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                    if (attributes) newOp.attributes = attributes;
                    delta.push(newOp);
                    // Optimization if rest of other is just retain
                    if (!otherIter.hasNext() && $3IYP4(delta.ops[delta.ops.length - 1], newOp)) {
                        const rest = new $f0a5d622b7cbf8c6$var$Delta(thisIter.rest());
                        return delta.concat(rest).chop();
                    }
                // Other op should be delete, we could be an insert or retain
                // Insert + delete cancels out
                } else if (typeof otherOp.delete === 'number' && (typeof thisOp.retain === 'number' || typeof thisOp.retain === 'object' && thisOp.retain !== null)) delta.push(otherOp);
            }
        }
        return delta.chop();
    }
    concat(other) {
        const delta = new $f0a5d622b7cbf8c6$var$Delta(this.ops.slice());
        if (other.ops.length > 0) {
            delta.push(other.ops[0]);
            delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
    }
    diff(other, cursor) {
        if (this.ops === other.ops) return new $f0a5d622b7cbf8c6$var$Delta();
        const strings = [
            this,
            other
        ].map((delta)=>{
            return delta.map((op)=>{
                if (op.insert != null) return typeof op.insert === 'string' ? op.insert : $f0a5d622b7cbf8c6$var$NULL_CHARACTER;
                const prep = delta === other ? 'on' : 'with';
                throw new Error('diff() called ' + prep + ' non-document');
            }).join('');
        });
        const retDelta = new $f0a5d622b7cbf8c6$var$Delta();
        const diffResult = $kp0J9(strings[0], strings[1], cursor, true);
        const thisIter = new $bmFu7.default(this.ops);
        const otherIter = new $bmFu7.default(other.ops);
        diffResult.forEach((component)=>{
            let length = component[1].length;
            while(length > 0){
                let opLength = 0;
                switch(component[0]){
                    case $kp0J9.INSERT:
                        opLength = Math.min(otherIter.peekLength(), length);
                        retDelta.push(otherIter.next(opLength));
                        break;
                    case $kp0J9.DELETE:
                        opLength = Math.min(length, thisIter.peekLength());
                        thisIter.next(opLength);
                        retDelta.delete(opLength);
                        break;
                    case $kp0J9.EQUAL:
                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                        const thisOp = thisIter.next(opLength);
                        const otherOp = otherIter.next(opLength);
                        if ($3IYP4(thisOp.insert, otherOp.insert)) retDelta.retain(opLength, $dGgcE.default.diff(thisOp.attributes, otherOp.attributes));
                        else retDelta.push(otherOp).delete(opLength);
                        break;
                }
                length -= opLength;
            }
        });
        return retDelta.chop();
    }
    eachLine(predicate, newline = '\n') {
        const iter = new $bmFu7.default(this.ops);
        let line = new $f0a5d622b7cbf8c6$var$Delta();
        let i = 0;
        while(iter.hasNext()){
            if (iter.peekType() !== 'insert') return;
            const thisOp = iter.peek();
            const start = $03VRP.default.length(thisOp) - iter.peekLength();
            const index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
            if (index < 0) line.push(iter.next());
            else if (index > 0) line.push(iter.next(index));
            else {
                if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                i += 1;
                line = new $f0a5d622b7cbf8c6$var$Delta();
            }
        }
        if (line.length() > 0) predicate(line, {}, i);
    }
    invert(base) {
        const inverted = new $f0a5d622b7cbf8c6$var$Delta();
        this.reduce((baseIndex, op)=>{
            if (op.insert) inverted.delete($03VRP.default.length(op));
            else if (typeof op.retain === 'number' && op.attributes == null) {
                inverted.retain(op.retain);
                return baseIndex + op.retain;
            } else if (op.delete || typeof op.retain === 'number') {
                const length = op.delete || op.retain;
                const slice = base.slice(baseIndex, baseIndex + length);
                slice.forEach((baseOp)=>{
                    if (op.delete) inverted.push(baseOp);
                    else if (op.retain && op.attributes) inverted.retain($03VRP.default.length(baseOp), $dGgcE.default.invert(op.attributes, baseOp.attributes));
                });
                return baseIndex + length;
            } else if (typeof op.retain === 'object' && op.retain !== null) {
                const slice = base.slice(baseIndex, baseIndex + 1);
                const baseOp = new $bmFu7.default(slice.ops).next();
                const [embedType, opData, baseOpData] = $f0a5d622b7cbf8c6$var$getEmbedTypeAndData(op.retain, baseOp.insert);
                const handler = $f0a5d622b7cbf8c6$var$Delta.getHandler(embedType);
                inverted.retain({
                    [embedType]: handler.invert(opData, baseOpData)
                }, $dGgcE.default.invert(op.attributes, baseOp.attributes));
                return baseIndex + 1;
            }
            return baseIndex;
        }, 0);
        return inverted.chop();
    }
    transform(arg, priority = false) {
        priority = !!priority;
        if (typeof arg === 'number') return this.transformPosition(arg, priority);
        const other = arg;
        const thisIter = new $bmFu7.default(this.ops);
        const otherIter = new $bmFu7.default(other.ops);
        const delta = new $f0a5d622b7cbf8c6$var$Delta();
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) delta.retain($03VRP.default.length(thisIter.next()));
            else if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (thisOp.delete) continue;
                else if (otherOp.delete) delta.push(otherOp);
                else {
                    const thisData = thisOp.retain;
                    const otherData = otherOp.retain;
                    let transformedData = typeof otherData === 'object' && otherData !== null ? otherData : length;
                    if (typeof thisData === 'object' && thisData !== null && typeof otherData === 'object' && otherData !== null) {
                        const embedType = Object.keys(thisData)[0];
                        if (embedType === Object.keys(otherData)[0]) {
                            const handler = $f0a5d622b7cbf8c6$var$Delta.getHandler(embedType);
                            if (handler) transformedData = {
                                [embedType]: handler.transform(thisData[embedType], otherData[embedType], priority)
                            };
                        }
                    }
                    // We retain either their retain or insert
                    delta.retain(transformedData, $dGgcE.default.transform(thisOp.attributes, otherOp.attributes, priority));
                }
            }
        }
        return delta.chop();
    }
    transformPosition(index, priority = false) {
        priority = !!priority;
        const thisIter = new $bmFu7.default(this.ops);
        let offset = 0;
        while(thisIter.hasNext() && offset <= index){
            const length = thisIter.peekLength();
            const nextType = thisIter.peekType();
            thisIter.next();
            if (nextType === 'delete') {
                index -= Math.min(length, index - offset);
                continue;
            } else if (nextType === 'insert' && (offset < index || !priority)) index += length;
            offset += length;
        }
        return index;
    }
}
$f0a5d622b7cbf8c6$var$Delta.Op = $03VRP.default;
$f0a5d622b7cbf8c6$var$Delta.OpIterator = $bmFu7.default;
$f0a5d622b7cbf8c6$var$Delta.AttributeMap = $dGgcE.default;
$f0a5d622b7cbf8c6$var$Delta.handlers = {};
module.exports.default = $f0a5d622b7cbf8c6$var$Delta;
module.exports = $f0a5d622b7cbf8c6$var$Delta;
module.exports.default = $f0a5d622b7cbf8c6$var$Delta;

});
parcelRegister("kp0J9", function(module, exports) {
/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $eda6b4d975180353$var$DIFF_DELETE = -1;
var $eda6b4d975180353$var$DIFF_INSERT = 1;
var $eda6b4d975180353$var$DIFF_EQUAL = 0;
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @param {boolean} [cleanup] Apply semantic cleanup before returning.
 * @return {Array} Array of diff tuples.
 */ function $eda6b4d975180353$var$diff_main(text1, text2, cursor_pos, cleanup, _fix_unicode) {
    // Check for equality
    if (text1 === text2) {
        if (text1) return [
            [
                $eda6b4d975180353$var$DIFF_EQUAL,
                text1
            ]
        ];
        return [];
    }
    if (cursor_pos != null) {
        var editdiff = $eda6b4d975180353$var$find_cursor_edit_diff(text1, text2, cursor_pos);
        if (editdiff) return editdiff;
    }
    // Trim off common prefix (speedup).
    var commonlength = $eda6b4d975180353$var$diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = $eda6b4d975180353$var$diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = $eda6b4d975180353$var$diff_compute_(text1, text2);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift([
        $eda6b4d975180353$var$DIFF_EQUAL,
        commonprefix
    ]);
    if (commonsuffix) diffs.push([
        $eda6b4d975180353$var$DIFF_EQUAL,
        commonsuffix
    ]);
    $eda6b4d975180353$var$diff_cleanupMerge(diffs, _fix_unicode);
    if (cleanup) $eda6b4d975180353$var$diff_cleanupSemantic(diffs);
    return diffs;
}
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function $eda6b4d975180353$var$diff_compute_(text1, text2) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        [
            $eda6b4d975180353$var$DIFF_INSERT,
            text2
        ]
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        [
            $eda6b4d975180353$var$DIFF_DELETE,
            text1
        ]
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i !== -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [
                $eda6b4d975180353$var$DIFF_INSERT,
                longtext.substring(0, i)
            ],
            [
                $eda6b4d975180353$var$DIFF_EQUAL,
                shorttext
            ],
            [
                $eda6b4d975180353$var$DIFF_INSERT,
                longtext.substring(i + shorttext.length)
            ]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $eda6b4d975180353$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length === 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        [
            $eda6b4d975180353$var$DIFF_DELETE,
            text1
        ],
        [
            $eda6b4d975180353$var$DIFF_INSERT,
            text2
        ]
    ];
    // Check to see if the problem can be split in two.
    var hm = $eda6b4d975180353$var$diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = $eda6b4d975180353$var$diff_main(text1_a, text2_a);
        var diffs_b = $eda6b4d975180353$var$diff_main(text1_b, text2_b);
        // Merge the results.
        return diffs_a.concat([
            [
                $eda6b4d975180353$var$DIFF_EQUAL,
                mid_common
            ]
        ], diffs_b);
    }
    return $eda6b4d975180353$var$diff_bisect_(text1, text2);
}
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function $eda6b4d975180353$var$diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 !== 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 === -d || k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) === text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return $eda6b4d975180353$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 === -d || k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return $eda6b4d975180353$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        [
            $eda6b4d975180353$var$DIFF_DELETE,
            text1
        ],
        [
            $eda6b4d975180353$var$DIFF_INSERT,
            text2
        ]
    ];
}
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function $eda6b4d975180353$var$diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = $eda6b4d975180353$var$diff_main(text1a, text2a);
    var diffsb = $eda6b4d975180353$var$diff_main(text1b, text2b);
    return diffs.concat(diffsb);
}
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function $eda6b4d975180353$var$diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($eda6b4d975180353$var$is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) pointermid--;
    return pointermid;
}
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ function $eda6b4d975180353$var$diff_commonOverlap_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: http://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
}
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function $eda6b4d975180353$var$diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($eda6b4d975180353$var$is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) pointermid--;
    return pointermid;
}
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function $eda6b4d975180353$var$diff_halfMatch_(text1, text2) {
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) !== -1){
            var prefixLength = $eda6b4d975180353$var$diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = $eda6b4d975180353$var$diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
}
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $eda6b4d975180353$var$diff_cleanupSemantic(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $eda6b4d975180353$var$DIFF_EQUAL) {
            // Equality found.
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastequality = diffs[pointer][1];
        } else {
            // An insertion or deletion.
            if (diffs[pointer][0] == $eda6b4d975180353$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $eda6b4d975180353$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $eda6b4d975180353$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastequality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) $eda6b4d975180353$var$diff_cleanupMerge(diffs);
    $eda6b4d975180353$var$diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $eda6b4d975180353$var$DIFF_DELETE && diffs[pointer][0] == $eda6b4d975180353$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = $eda6b4d975180353$var$diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = $eda6b4d975180353$var$diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, [
                        $eda6b4d975180353$var$DIFF_EQUAL,
                        insertion.substring(0, overlap_length1)
                    ]);
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, [
                    $eda6b4d975180353$var$DIFF_EQUAL,
                    deletion.substring(0, overlap_length2)
                ]);
                diffs[pointer - 1][0] = $eda6b4d975180353$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $eda6b4d975180353$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
}
var $eda6b4d975180353$var$nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
var $eda6b4d975180353$var$whitespaceRegex_ = /\s/;
var $eda6b4d975180353$var$linebreakRegex_ = /[\r\n]/;
var $eda6b4d975180353$var$blanklineEndRegex_ = /\n\r?\n$/;
var $eda6b4d975180353$var$blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $eda6b4d975180353$var$diff_cleanupSemanticLossless(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($eda6b4d975180353$var$nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($eda6b4d975180353$var$nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($eda6b4d975180353$var$whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($eda6b4d975180353$var$whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($eda6b4d975180353$var$linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($eda6b4d975180353$var$linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($eda6b4d975180353$var$blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($eda6b4d975180353$var$blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $eda6b4d975180353$var$DIFF_EQUAL && diffs[pointer + 1][0] == $eda6b4d975180353$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = $eda6b4d975180353$var$diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
}
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */ function $eda6b4d975180353$var$diff_cleanupMerge(diffs, fix_unicode) {
    diffs.push([
        $eda6b4d975180353$var$DIFF_EQUAL,
        ""
    ]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length){
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
            diffs.splice(pointer, 1);
            continue;
        }
        switch(diffs[pointer][0]){
            case $eda6b4d975180353$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                pointer++;
                break;
            case $eda6b4d975180353$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                pointer++;
                break;
            case $eda6b4d975180353$var$DIFF_EQUAL:
                var previous_equality = pointer - count_insert - count_delete - 1;
                if (fix_unicode) {
                    // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
                    // we assume that the old and new text in the diff are complete and correct
                    // unicode-encoded JS strings, but the tuple boundaries may fall between
                    // surrogate pairs.  we fix this by shaving off stray surrogates from the end
                    // of the previous equality and the beginning of this equality.  this may create
                    // empty equalities or a common prefix or suffix.  for example, if AB and AC are
                    // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
                    // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
                    // particular case, both equalities go away, we absorb any previous inequalities,
                    // and we keep scanning for the next equality before rewriting the tuples.
                    if (previous_equality >= 0 && $eda6b4d975180353$var$ends_with_pair_start(diffs[previous_equality][1])) {
                        var stray = diffs[previous_equality][1].slice(-1);
                        diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
                        text_delete = stray + text_delete;
                        text_insert = stray + text_insert;
                        if (!diffs[previous_equality][1]) {
                            // emptied out previous equality, so delete it and include previous delete/insert
                            diffs.splice(previous_equality, 1);
                            pointer--;
                            var k = previous_equality - 1;
                            if (diffs[k] && diffs[k][0] === $eda6b4d975180353$var$DIFF_INSERT) {
                                count_insert++;
                                text_insert = diffs[k][1] + text_insert;
                                k--;
                            }
                            if (diffs[k] && diffs[k][0] === $eda6b4d975180353$var$DIFF_DELETE) {
                                count_delete++;
                                text_delete = diffs[k][1] + text_delete;
                                k--;
                            }
                            previous_equality = k;
                        }
                    }
                    if ($eda6b4d975180353$var$starts_with_pair_end(diffs[pointer][1])) {
                        var stray = diffs[pointer][1].charAt(0);
                        diffs[pointer][1] = diffs[pointer][1].slice(1);
                        text_delete += stray;
                        text_insert += stray;
                    }
                }
                if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
                    // for empty equality not at end, wait for next equality
                    diffs.splice(pointer, 1);
                    break;
                }
                if (text_delete.length > 0 || text_insert.length > 0) {
                    // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
                    if (text_delete.length > 0 && text_insert.length > 0) {
                        // Factor out any common prefixes.
                        commonlength = $eda6b4d975180353$var$diff_commonPrefix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            if (previous_equality >= 0) diffs[previous_equality][1] += text_insert.substring(0, commonlength);
                            else {
                                diffs.splice(0, 0, [
                                    $eda6b4d975180353$var$DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)
                                ]);
                                pointer++;
                            }
                            text_insert = text_insert.substring(commonlength);
                            text_delete = text_delete.substring(commonlength);
                        }
                        // Factor out any common suffixes.
                        commonlength = $eda6b4d975180353$var$diff_commonSuffix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                            text_insert = text_insert.substring(0, text_insert.length - commonlength);
                            text_delete = text_delete.substring(0, text_delete.length - commonlength);
                        }
                    }
                    // Delete the offending records and add the merged ones.
                    var n = count_insert + count_delete;
                    if (text_delete.length === 0 && text_insert.length === 0) {
                        diffs.splice(pointer - n, n);
                        pointer = pointer - n;
                    } else if (text_delete.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $eda6b4d975180353$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 1;
                    } else if (text_insert.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $eda6b4d975180353$var$DIFF_DELETE,
                            text_delete
                        ]);
                        pointer = pointer - n + 1;
                    } else {
                        diffs.splice(pointer - n, n, [
                            $eda6b4d975180353$var$DIFF_DELETE,
                            text_delete
                        ], [
                            $eda6b4d975180353$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 2;
                    }
                }
                if (pointer !== 0 && diffs[pointer - 1][0] === $eda6b4d975180353$var$DIFF_EQUAL) {
                    // Merge this equality with the previous one.
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                } else pointer++;
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] === $eda6b4d975180353$var$DIFF_EQUAL && diffs[pointer + 1][0] === $eda6b4d975180353$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) $eda6b4d975180353$var$diff_cleanupMerge(diffs, fix_unicode);
}
function $eda6b4d975180353$var$is_surrogate_pair_start(charCode) {
    return charCode >= 0xd800 && charCode <= 0xdbff;
}
function $eda6b4d975180353$var$is_surrogate_pair_end(charCode) {
    return charCode >= 0xdc00 && charCode <= 0xdfff;
}
function $eda6b4d975180353$var$starts_with_pair_end(str) {
    return $eda6b4d975180353$var$is_surrogate_pair_end(str.charCodeAt(0));
}
function $eda6b4d975180353$var$ends_with_pair_start(str) {
    return $eda6b4d975180353$var$is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}
function $eda6b4d975180353$var$remove_empty_tuples(tuples) {
    var ret = [];
    for(var i = 0; i < tuples.length; i++)if (tuples[i][1].length > 0) ret.push(tuples[i]);
    return ret;
}
function $eda6b4d975180353$var$make_edit_splice(before, oldMiddle, newMiddle, after) {
    if ($eda6b4d975180353$var$ends_with_pair_start(before) || $eda6b4d975180353$var$starts_with_pair_end(after)) return null;
    return $eda6b4d975180353$var$remove_empty_tuples([
        [
            $eda6b4d975180353$var$DIFF_EQUAL,
            before
        ],
        [
            $eda6b4d975180353$var$DIFF_DELETE,
            oldMiddle
        ],
        [
            $eda6b4d975180353$var$DIFF_INSERT,
            newMiddle
        ],
        [
            $eda6b4d975180353$var$DIFF_EQUAL,
            after
        ]
    ]);
}
function $eda6b4d975180353$var$find_cursor_edit_diff(oldText, newText, cursor_pos) {
    // note: this runs after equality check has ruled out exact equality
    var oldRange = typeof cursor_pos === "number" ? {
        index: cursor_pos,
        length: 0
    } : cursor_pos.oldRange;
    var newRange = typeof cursor_pos === "number" ? null : cursor_pos.newRange;
    // take into account the old and new selection to generate the best diff
    // possible for a text edit.  for example, a text change from "xxx" to "xx"
    // could be a delete or forwards-delete of any one of the x's, or the
    // result of selecting two of the x's and typing "x".
    var oldLength = oldText.length;
    var newLength = newText.length;
    if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
        // see if we have an insert or delete before or after cursor
        var oldCursor = oldRange.index;
        var oldBefore = oldText.slice(0, oldCursor);
        var oldAfter = oldText.slice(oldCursor);
        var maybeNewCursor = newRange ? newRange.index : null;
        editBefore: {
            // is this an insert or delete right before oldCursor?
            var newCursor = oldCursor + newLength - oldLength;
            if (maybeNewCursor !== null && maybeNewCursor !== newCursor) break editBefore;
            if (newCursor < 0 || newCursor > newLength) break editBefore;
            var newBefore = newText.slice(0, newCursor);
            var newAfter = newText.slice(newCursor);
            if (newAfter !== oldAfter) break editBefore;
            var prefixLength = Math.min(oldCursor, newCursor);
            var oldPrefix = oldBefore.slice(0, prefixLength);
            var newPrefix = newBefore.slice(0, prefixLength);
            if (oldPrefix !== newPrefix) break editBefore;
            var oldMiddle = oldBefore.slice(prefixLength);
            var newMiddle = newBefore.slice(prefixLength);
            return $eda6b4d975180353$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
        }
        editAfter: {
            // is this an insert or delete right after oldCursor?
            if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) break editAfter;
            var cursor = oldCursor;
            var newBefore = newText.slice(0, cursor);
            var newAfter = newText.slice(cursor);
            if (newBefore !== oldBefore) break editAfter;
            var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
            var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
            var newSuffix = newAfter.slice(newAfter.length - suffixLength);
            if (oldSuffix !== newSuffix) break editAfter;
            var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
            var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
            return $eda6b4d975180353$var$make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
        }
    }
    if (oldRange.length > 0 && newRange && newRange.length === 0) replaceRange: {
        // see if diff could be a splice of the old selection range
        var oldPrefix = oldText.slice(0, oldRange.index);
        var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
        var prefixLength = oldPrefix.length;
        var suffixLength = oldSuffix.length;
        if (newLength < prefixLength + suffixLength) break replaceRange;
        var newPrefix = newText.slice(0, prefixLength);
        var newSuffix = newText.slice(newLength - suffixLength);
        if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) break replaceRange;
        var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
        var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
        return $eda6b4d975180353$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
    return null;
}
function $eda6b4d975180353$var$diff(text1, text2, cursor_pos, cleanup) {
    // only pass fix_unicode=true at the top level, not when diff_main is
    // recursively invoked
    return $eda6b4d975180353$var$diff_main(text1, text2, cursor_pos, cleanup, true);
}
$eda6b4d975180353$var$diff.INSERT = $eda6b4d975180353$var$DIFF_INSERT;
$eda6b4d975180353$var$diff.DELETE = $eda6b4d975180353$var$DIFF_DELETE;
$eda6b4d975180353$var$diff.EQUAL = $eda6b4d975180353$var$DIFF_EQUAL;
module.exports = $eda6b4d975180353$var$diff;

});

parcelRegister("l8f2B", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("3IYP4", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("dGgcE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l8f2B = parcelRequire("l8f2B");

var $3IYP4 = parcelRequire("3IYP4");
var $9f5bc434b2268299$var$AttributeMap;
(function(AttributeMap) {
    function compose(a = {}, b = {}, keepNull = false) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        let attributes = $l8f2B(b);
        if (!keepNull) attributes = Object.keys(attributes).reduce((copy, key)=>{
            if (attributes[key] != null) copy[key] = attributes[key];
            return copy;
        }, {});
        for(const key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.compose = compose;
    function diff(a = {}, b = {}) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        const attributes = Object.keys(a).concat(Object.keys(b)).reduce((attrs, key)=>{
            if (!$3IYP4(a[key], b[key])) attrs[key] = b[key] === undefined ? null : b[key];
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.diff = diff;
    function invert(attr = {}, base = {}) {
        attr = attr || {};
        const baseInverted = Object.keys(base).reduce((memo, key)=>{
            if (base[key] !== attr[key] && attr[key] !== undefined) memo[key] = base[key];
            return memo;
        }, {});
        return Object.keys(attr).reduce((memo, key)=>{
            if (attr[key] !== base[key] && base[key] === undefined) memo[key] = null;
            return memo;
        }, baseInverted);
    }
    AttributeMap.invert = invert;
    function transform(a, b, priority = false) {
        if (typeof a !== 'object') return b;
        if (typeof b !== 'object') return undefined;
        if (!priority) return b; // b simply overwrites us without priority
        const attributes = Object.keys(b).reduce((attrs, key)=>{
            if (a[key] === undefined) attrs[key] = b[key]; // null is a valid value
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.transform = transform;
})($9f5bc434b2268299$var$AttributeMap || ($9f5bc434b2268299$var$AttributeMap = {}));
module.exports.default = $9f5bc434b2268299$var$AttributeMap;

});

parcelRegister("03VRP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $00bd2b2687979ad4$var$Op;
(function(Op) {
    function length(op) {
        if (typeof op.delete === 'number') return op.delete;
        else if (typeof op.retain === 'number') return op.retain;
        else if (typeof op.retain === 'object' && op.retain !== null) return 1;
        else return typeof op.insert === 'string' ? op.insert.length : 1;
    }
    Op.length = length;
})($00bd2b2687979ad4$var$Op || ($00bd2b2687979ad4$var$Op = {}));
module.exports.default = $00bd2b2687979ad4$var$Op;

});

parcelRegister("bmFu7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $03VRP = parcelRequire("03VRP");
class $8461edc910d6a1b9$var$Iterator {
    constructor(ops){
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
    }
    hasNext() {
        return this.peekLength() < Infinity;
    }
    next(length) {
        if (!length) length = Infinity;
        const nextOp = this.ops[this.index];
        if (nextOp) {
            const offset = this.offset;
            const opLength = $03VRP.default.length(nextOp);
            if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
            } else this.offset += length;
            if (typeof nextOp.delete === 'number') return {
                delete: length
            };
            else {
                const retOp = {};
                if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                if (typeof nextOp.retain === 'number') retOp.retain = length;
                else if (typeof nextOp.retain === 'object' && nextOp.retain !== null) // offset should === 0, length should === 1
                retOp.retain = nextOp.retain;
                else if (typeof nextOp.insert === 'string') retOp.insert = nextOp.insert.substr(offset, length);
                else // offset should === 0, length should === 1
                retOp.insert = nextOp.insert;
                return retOp;
            }
        } else return {
            retain: Infinity
        };
    }
    peek() {
        return this.ops[this.index];
    }
    peekLength() {
        if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
        return $03VRP.default.length(this.ops[this.index]) - this.offset;
        else return Infinity;
    }
    peekType() {
        const op = this.ops[this.index];
        if (op) {
            if (typeof op.delete === 'number') return 'delete';
            else if (typeof op.retain === 'number' || typeof op.retain === 'object' && op.retain !== null) return 'retain';
            else return 'insert';
        }
        return 'retain';
    }
    rest() {
        if (!this.hasNext()) return [];
        else if (this.offset === 0) return this.ops.slice(this.index);
        else {
            const offset = this.offset;
            const index = this.index;
            const next = this.next();
            const rest = this.ops.slice(this.index);
            this.offset = offset;
            this.index = index;
            return [
                next
            ].concat(rest);
        }
    }
}
module.exports.default = $8461edc910d6a1b9$var$Iterator;

});


parcelRegister("bLz0Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $890f3eb14eb0e0b8$export$2e2bcd8739ae039);

var $4exCq = parcelRequire("4exCq");
var $kaYY4 = parcelRequire("kaYY4");
var $d7fWe = parcelRequire("d7fWe");

var $lHwOS = parcelRequire("lHwOS");

var $kEXGb = parcelRequire("kEXGb");

var $fp1Tt = parcelRequire("fp1Tt");

var $bmwCM = parcelRequire("bmwCM");

var $luQs7 = parcelRequire("luQs7");

var $bxVMH = parcelRequire("bxVMH");

var $3EdO3 = parcelRequire("3EdO3");
const $890f3eb14eb0e0b8$var$ASCII = /^[ -~]*$/;
class $890f3eb14eb0e0b8$var$Editor {
    constructor(scroll){
        this.scroll = scroll;
        this.delta = this.getDelta();
    }
    applyDelta(delta) {
        this.scroll.update();
        let scrollLength = this.scroll.length();
        this.scroll.batchStart();
        const normalizedDelta = $890f3eb14eb0e0b8$var$normalizeDelta(delta);
        const deleteDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
        const normalizedOps = $890f3eb14eb0e0b8$var$splitOpLines(normalizedDelta.ops.slice());
        normalizedOps.reduce((index, op)=>{
            const length = (0, $kEXGb.Op).length(op);
            let attributes = op.attributes || {};
            let isImplicitNewlinePrepended = false;
            let isImplicitNewlineAppended = false;
            if (op.insert != null) {
                deleteDelta.retain(length);
                if (typeof op.insert === 'string') {
                    const text = op.insert;
                    isImplicitNewlineAppended = !text.endsWith('\n') && (scrollLength <= index || !!this.scroll.descendant((0, $fp1Tt.BlockEmbed), index)[0]);
                    this.scroll.insertAt(index, text);
                    const [line, offset] = this.scroll.line(index);
                    let formats = (0, $4exCq.default)({}, (0, $fp1Tt.bubbleFormats)(line));
                    if (line instanceof (0, $fp1Tt.default)) {
                        const [leaf] = line.descendant((0, $lHwOS.LeafBlot), offset);
                        if (leaf) formats = (0, $4exCq.default)(formats, (0, $fp1Tt.bubbleFormats)(leaf));
                    }
                    attributes = (0, $kEXGb.AttributeMap).diff(formats, attributes) || {};
                } else if (typeof op.insert === 'object') {
                    const key = Object.keys(op.insert)[0]; // There should only be one key
                    if (key == null) return index;
                    const isInlineEmbed = this.scroll.query(key, (0, $lHwOS.Scope).INLINE) != null;
                    if (isInlineEmbed) {
                        if (scrollLength <= index || !!this.scroll.descendant((0, $fp1Tt.BlockEmbed), index)[0]) isImplicitNewlineAppended = true;
                    } else if (index > 0) {
                        const [leaf, offset] = this.scroll.descendant((0, $lHwOS.LeafBlot), index - 1);
                        if (leaf instanceof (0, $bxVMH.default)) {
                            const text = leaf.value();
                            if (text[offset] !== '\n') isImplicitNewlinePrepended = true;
                        } else if (leaf instanceof (0, $lHwOS.EmbedBlot) && leaf.statics.scope === (0, $lHwOS.Scope).INLINE_BLOT) isImplicitNewlinePrepended = true;
                    }
                    this.scroll.insertAt(index, key, op.insert[key]);
                    if (isInlineEmbed) {
                        const [leaf] = this.scroll.descendant((0, $lHwOS.LeafBlot), index);
                        if (leaf) {
                            const formats = (0, $4exCq.default)({}, (0, $fp1Tt.bubbleFormats)(leaf));
                            attributes = (0, $kEXGb.AttributeMap).diff(formats, attributes) || {};
                        }
                    }
                }
                scrollLength += length;
            } else {
                deleteDelta.push(op);
                if (op.retain !== null && typeof op.retain === 'object') {
                    const key = Object.keys(op.retain)[0];
                    if (key == null) return index;
                    this.scroll.updateEmbedAt(index, key, op.retain[key]);
                }
            }
            Object.keys(attributes).forEach((name)=>{
                this.scroll.formatAt(index, length, name, attributes[name]);
            });
            const prependedLength = isImplicitNewlinePrepended ? 1 : 0;
            const addedLength = isImplicitNewlineAppended ? 1 : 0;
            scrollLength += prependedLength + addedLength;
            deleteDelta.retain(prependedLength);
            deleteDelta.delete(addedLength);
            return index + length + prependedLength + addedLength;
        }, 0);
        deleteDelta.reduce((index, op)=>{
            if (typeof op.delete === 'number') {
                this.scroll.deleteAt(index, op.delete);
                return index;
            }
            return index + (0, $kEXGb.Op).length(op);
        }, 0);
        this.scroll.batchEnd();
        this.scroll.optimize();
        return this.update(normalizedDelta);
    }
    deleteText(index, length) {
        this.scroll.deleteAt(index, length);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).delete(length));
    }
    formatLine(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.scroll.update();
        Object.keys(formats).forEach((format)=>{
            this.scroll.lines(index, Math.max(length, 1)).forEach((line)=>{
                line.format(format, formats[format]);
            });
        });
        this.scroll.optimize();
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).retain(length, (0, $kaYY4.default)(formats));
        return this.update(delta);
    }
    formatText(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, length, format, formats[format]);
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).retain(length, (0, $kaYY4.default)(formats));
        return this.update(delta);
    }
    getContents(index, length) {
        return this.delta.slice(index, index + length);
    }
    getDelta() {
        return this.scroll.lines().reduce((delta, line)=>{
            return delta.concat(line.delta());
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
    }
    getFormat(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let lines = [];
        let leaves = [];
        if (length === 0) this.scroll.path(index).forEach((path)=>{
            const [blot] = path;
            if (blot instanceof (0, $fp1Tt.default)) lines.push(blot);
            else if (blot instanceof (0, $lHwOS.LeafBlot)) leaves.push(blot);
        });
        else {
            lines = this.scroll.lines(index, length);
            leaves = this.scroll.descendants((0, $lHwOS.LeafBlot), index, length);
        }
        const [lineFormats, leafFormats] = [
            lines,
            leaves
        ].map((blots)=>{
            const blot = blots.shift();
            if (blot == null) return {};
            let formats = (0, $fp1Tt.bubbleFormats)(blot);
            while(Object.keys(formats).length > 0){
                const blot = blots.shift();
                if (blot == null) return formats;
                formats = $890f3eb14eb0e0b8$var$combineFormats((0, $fp1Tt.bubbleFormats)(blot), formats);
            }
            return formats;
        });
        return {
            ...lineFormats,
            ...leafFormats
        };
    }
    getHTML(index, length) {
        const [line, lineOffset] = this.scroll.line(index);
        if (line) {
            const lineLength = line.length();
            const isWithinLine = line.length() >= lineOffset + length;
            if (isWithinLine && !(lineOffset === 0 && length === lineLength)) return $890f3eb14eb0e0b8$var$convertHTML(line, lineOffset, length, true);
            return $890f3eb14eb0e0b8$var$convertHTML(this.scroll, index, length, true);
        }
        return '';
    }
    getText(index, length) {
        return this.getContents(index, length).filter((op)=>typeof op.insert === 'string').map((op)=>op.insert).join('');
    }
    insertContents(index, contents) {
        const normalizedDelta = $890f3eb14eb0e0b8$var$normalizeDelta(contents);
        const change = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).concat(normalizedDelta);
        this.scroll.insertContents(index, normalizedDelta);
        return this.update(change);
    }
    insertEmbed(index, embed, value) {
        this.scroll.insertAt(index, embed, value);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).insert({
            [embed]: value
        }));
    }
    insertText(index, text) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        this.scroll.insertAt(index, text);
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, text.length, format, formats[format]);
        });
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).insert(text, (0, $kaYY4.default)(formats)));
    }
    isBlank() {
        if (this.scroll.children.length === 0) return true;
        if (this.scroll.children.length > 1) return false;
        const blot = this.scroll.children.head;
        if (blot?.statics.blotName !== (0, $fp1Tt.default).blotName) return false;
        const block = blot;
        if (block.children.length > 1) return false;
        return block.children.head instanceof (0, $bmwCM.default);
    }
    removeFormat(index, length) {
        const text = this.getText(index, length);
        const [line, offset] = this.scroll.line(index + length);
        let suffixLength = 0;
        let suffix = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
        if (line != null) {
            suffixLength = line.length() - offset;
            suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
        }
        const contents = this.getContents(index, length + suffixLength);
        const diff = contents.diff(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(text).concat(suffix));
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).concat(diff);
        return this.applyDelta(delta);
    }
    update(change) {
        let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        const oldDelta = this.delta;
        if (mutations.length === 1 && mutations[0].type === 'characterData' && // @ts-expect-error Fix me later
        mutations[0].target.data.match($890f3eb14eb0e0b8$var$ASCII) && this.scroll.find(mutations[0].target)) {
            // Optimization for character changes
            const textBlot = this.scroll.find(mutations[0].target);
            const formats = (0, $fp1Tt.bubbleFormats)(textBlot);
            const index = textBlot.offset(this.scroll);
            // @ts-expect-error Fix me later
            const oldValue = mutations[0].oldValue.replace((0, $luQs7.default).CONTENTS, '');
            const oldText = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(oldValue);
            // @ts-expect-error
            const newText = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(textBlot.value());
            const relativeSelectionInfo = selectionInfo && {
                oldRange: $890f3eb14eb0e0b8$var$shiftRange(selectionInfo.oldRange, -index),
                newRange: $890f3eb14eb0e0b8$var$shiftRange(selectionInfo.newRange, -index)
            };
            const diffDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
            change = diffDelta.reduce((delta, op)=>{
                if (op.insert) return delta.insert(op.insert, formats);
                return delta.push(op);
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
            this.delta = oldDelta.compose(change);
        } else {
            this.delta = this.getDelta();
            if (!change || !(0, $d7fWe.default)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, selectionInfo);
        }
        return change;
    }
}
function $890f3eb14eb0e0b8$var$convertListHTML(items, lastIndent, types) {
    if (items.length === 0) {
        const [endTag] = $890f3eb14eb0e0b8$var$getListType(types.pop());
        if (lastIndent <= 0) return `</li></${endTag}>`;
        return `</li></${endTag}>${$890f3eb14eb0e0b8$var$convertListHTML([], lastIndent - 1, types)}`;
    }
    const [{ child: child, offset: offset, length: length, indent: indent, type: type }, ...rest] = items;
    const [tag, attribute] = $890f3eb14eb0e0b8$var$getListType(type);
    if (indent > lastIndent) {
        types.push(type);
        if (indent === lastIndent + 1) return `<${tag}><li${attribute}>${$890f3eb14eb0e0b8$var$convertHTML(child, offset, length)}${$890f3eb14eb0e0b8$var$convertListHTML(rest, indent, types)}`;
        return `<${tag}><li>${$890f3eb14eb0e0b8$var$convertListHTML(items, lastIndent + 1, types)}`;
    }
    const previousType = types[types.length - 1];
    if (indent === lastIndent && type === previousType) return `</li><li${attribute}>${$890f3eb14eb0e0b8$var$convertHTML(child, offset, length)}${$890f3eb14eb0e0b8$var$convertListHTML(rest, indent, types)}`;
    const [endTag] = $890f3eb14eb0e0b8$var$getListType(types.pop());
    return `</li></${endTag}>${$890f3eb14eb0e0b8$var$convertListHTML(items, lastIndent - 1, types)}`;
}
function $890f3eb14eb0e0b8$var$convertHTML(blot, index, length) {
    let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if ('html' in blot && typeof blot.html === 'function') return blot.html(index, length);
    if (blot instanceof (0, $bxVMH.default)) {
        const escapedText = (0, $bxVMH.escapeText)(blot.value().slice(index, index + length));
        return escapedText.replaceAll(' ', '&nbsp;');
    }
    if (blot instanceof (0, $lHwOS.ParentBlot)) {
        // TODO fix API
        if (blot.statics.blotName === 'list-container') {
            const items = [];
            blot.children.forEachAt(index, length, (child, offset, childLength)=>{
                const formats = 'formats' in child && typeof child.formats === 'function' ? child.formats() : {};
                items.push({
                    child: child,
                    offset: offset,
                    length: childLength,
                    indent: formats.indent || 0,
                    type: formats.list
                });
            });
            return $890f3eb14eb0e0b8$var$convertListHTML(items, -1, []);
        }
        const parts = [];
        blot.children.forEachAt(index, length, (child, offset, childLength)=>{
            parts.push($890f3eb14eb0e0b8$var$convertHTML(child, offset, childLength));
        });
        if (isRoot || blot.statics.blotName === 'list') return parts.join('');
        const { outerHTML: outerHTML, innerHTML: innerHTML } = blot.domNode;
        const [start, end] = outerHTML.split(`>${innerHTML}<`);
        // TODO cleanup
        if (start === '<table') return `<table style="border: 1px solid #000;">${parts.join('')}<${end}`;
        return `${start}>${parts.join('')}<${end}`;
    }
    return blot.domNode instanceof Element ? blot.domNode.outerHTML : '';
}
function $890f3eb14eb0e0b8$var$combineFormats(formats, combined) {
    return Object.keys(combined).reduce((merged, name)=>{
        if (formats[name] == null) return merged;
        const combinedValue = combined[name];
        if (combinedValue === formats[name]) merged[name] = combinedValue;
        else if (Array.isArray(combinedValue)) {
            if (combinedValue.indexOf(formats[name]) < 0) merged[name] = combinedValue.concat([
                formats[name]
            ]);
            else // If style already exists, don't add to an array, but don't lose other styles
            merged[name] = combinedValue;
        } else merged[name] = [
            combinedValue,
            formats[name]
        ];
        return merged;
    }, {});
}
function $890f3eb14eb0e0b8$var$getListType(type) {
    const tag = type === 'ordered' ? 'ol' : 'ul';
    switch(type){
        case 'checked':
            return [
                tag,
                ' data-list="checked"'
            ];
        case 'unchecked':
            return [
                tag,
                ' data-list="unchecked"'
            ];
        default:
            return [
                tag,
                ''
            ];
    }
}
function $890f3eb14eb0e0b8$var$normalizeDelta(delta) {
    return delta.reduce((normalizedDelta, op)=>{
        if (typeof op.insert === 'string') {
            const text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            return normalizedDelta.insert(text, op.attributes);
        }
        return normalizedDelta.push(op);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
}
function $890f3eb14eb0e0b8$var$shiftRange(_ref, amount) {
    let { index: index, length: length } = _ref;
    return new (0, $3EdO3.Range)(index + amount, length);
}
function $890f3eb14eb0e0b8$var$splitOpLines(ops) {
    const split = [];
    ops.forEach((op)=>{
        if (typeof op.insert === 'string') {
            const lines = op.insert.split('\n');
            lines.forEach((line, index)=>{
                if (index) split.push({
                    insert: '\n',
                    attributes: op.attributes
                });
                if (line) split.push({
                    insert: line,
                    attributes: op.attributes
                });
            });
        } else split.push(op);
    });
    return split;
}
var $890f3eb14eb0e0b8$export$2e2bcd8739ae039 = $890f3eb14eb0e0b8$var$Editor;

});
parcelRegister("kaYY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb0408c135f33041$export$2e2bcd8739ae039);

var $IAViM = parcelRequire("IAViM");
/** Used to compose bitmasks for cloning. */ var $eb0408c135f33041$var$CLONE_DEEP_FLAG = 1, $eb0408c135f33041$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $eb0408c135f33041$var$cloneDeep(value) {
    return (0, $IAViM.default)(value, $eb0408c135f33041$var$CLONE_DEEP_FLAG | $eb0408c135f33041$var$CLONE_SYMBOLS_FLAG);
}
var $eb0408c135f33041$export$2e2bcd8739ae039 = $eb0408c135f33041$var$cloneDeep;

});
parcelRegister("IAViM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0860c05bc80ebbfa$export$2e2bcd8739ae039);

var $ch4ws = parcelRequire("ch4ws");

var $5rLOb = parcelRequire("5rLOb");

var $kYkm0 = parcelRequire("kYkm0");

var $2oR8L = parcelRequire("2oR8L");

var $fnLNg = parcelRequire("fnLNg");

var $imxSd = parcelRequire("imxSd");

var $6x0q0 = parcelRequire("6x0q0");

var $5vHz2 = parcelRequire("5vHz2");

var $9pdV7 = parcelRequire("9pdV7");

var $bZZOu = parcelRequire("bZZOu");

var $8sQaT = parcelRequire("8sQaT");

var $81bAo = parcelRequire("81bAo");

var $dseQ6 = parcelRequire("dseQ6");

var $1Nluj = parcelRequire("1Nluj");

var $hMPMN = parcelRequire("hMPMN");

var $hXn90 = parcelRequire("hXn90");

var $hiJJV = parcelRequire("hiJJV");

var $4frQp = parcelRequire("4frQp");

var $kXXxV = parcelRequire("kXXxV");

var $gFm9h = parcelRequire("gFm9h");

var $8tp0Q = parcelRequire("8tp0Q");

var $fIbiK = parcelRequire("fIbiK");
/** Used to compose bitmasks for cloning. */ var $0860c05bc80ebbfa$var$CLONE_DEEP_FLAG = 1, $0860c05bc80ebbfa$var$CLONE_FLAT_FLAG = 2, $0860c05bc80ebbfa$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $0860c05bc80ebbfa$var$argsTag = '[object Arguments]', $0860c05bc80ebbfa$var$arrayTag = '[object Array]', $0860c05bc80ebbfa$var$boolTag = '[object Boolean]', $0860c05bc80ebbfa$var$dateTag = '[object Date]', $0860c05bc80ebbfa$var$errorTag = '[object Error]', $0860c05bc80ebbfa$var$funcTag = '[object Function]', $0860c05bc80ebbfa$var$genTag = '[object GeneratorFunction]', $0860c05bc80ebbfa$var$mapTag = '[object Map]', $0860c05bc80ebbfa$var$numberTag = '[object Number]', $0860c05bc80ebbfa$var$objectTag = '[object Object]', $0860c05bc80ebbfa$var$regexpTag = '[object RegExp]', $0860c05bc80ebbfa$var$setTag = '[object Set]', $0860c05bc80ebbfa$var$stringTag = '[object String]', $0860c05bc80ebbfa$var$symbolTag = '[object Symbol]', $0860c05bc80ebbfa$var$weakMapTag = '[object WeakMap]';
var $0860c05bc80ebbfa$var$arrayBufferTag = '[object ArrayBuffer]', $0860c05bc80ebbfa$var$dataViewTag = '[object DataView]', $0860c05bc80ebbfa$var$float32Tag = '[object Float32Array]', $0860c05bc80ebbfa$var$float64Tag = '[object Float64Array]', $0860c05bc80ebbfa$var$int8Tag = '[object Int8Array]', $0860c05bc80ebbfa$var$int16Tag = '[object Int16Array]', $0860c05bc80ebbfa$var$int32Tag = '[object Int32Array]', $0860c05bc80ebbfa$var$uint8Tag = '[object Uint8Array]', $0860c05bc80ebbfa$var$uint8ClampedTag = '[object Uint8ClampedArray]', $0860c05bc80ebbfa$var$uint16Tag = '[object Uint16Array]', $0860c05bc80ebbfa$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $0860c05bc80ebbfa$var$cloneableTags = {};
$0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$argsTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$arrayTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$arrayBufferTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$dataViewTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$boolTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$dateTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$float32Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$float64Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$int8Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$int16Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$int32Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$mapTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$numberTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$objectTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$regexpTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$setTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$stringTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$symbolTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$uint8Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$uint8ClampedTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$uint16Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$uint32Tag] = true;
$0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$errorTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$funcTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $0860c05bc80ebbfa$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $0860c05bc80ebbfa$var$CLONE_DEEP_FLAG, isFlat = bitmask & $0860c05bc80ebbfa$var$CLONE_FLAT_FLAG, isFull = bitmask & $0860c05bc80ebbfa$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $kXXxV.default)(value)) return value;
    var isArr = (0, $hXn90.default)(value);
    if (isArr) {
        result = (0, $dseQ6.default)(value);
        if (!isDeep) return (0, $6x0q0.default)(value, result);
    } else {
        var tag = (0, $81bAo.default)(value), isFunc = tag == $0860c05bc80ebbfa$var$funcTag || tag == $0860c05bc80ebbfa$var$genTag;
        if ((0, $hiJJV.default)(value)) return (0, $imxSd.default)(value, isDeep);
        if (tag == $0860c05bc80ebbfa$var$objectTag || tag == $0860c05bc80ebbfa$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $hMPMN.default)(value);
            if (!isDeep) return isFlat ? (0, $9pdV7.default)(value, (0, $fnLNg.default)(result, value)) : (0, $5vHz2.default)(value, (0, $2oR8L.default)(result, value));
        } else {
            if (!$0860c05bc80ebbfa$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $1Nluj.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $ch4ws.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $gFm9h.default)(value)) value.forEach(function(subValue) {
        result.add($0860c05bc80ebbfa$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $4frQp.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $0860c05bc80ebbfa$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $8sQaT.default) : (0, $bZZOu.default) : isFlat ? (0, $fIbiK.default) : (0, $8tp0Q.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $5rLOb.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $kYkm0.default)(result, key, $0860c05bc80ebbfa$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $0860c05bc80ebbfa$export$2e2bcd8739ae039 = $0860c05bc80ebbfa$var$baseClone;

});
parcelRegister("5rLOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f748f2213654a26$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $3f748f2213654a26$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $3f748f2213654a26$export$2e2bcd8739ae039 = $3f748f2213654a26$var$arrayEach;

});

parcelRegister("2oR8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf70b3936fb696c$export$2e2bcd8739ae039);

var $8Up13 = parcelRequire("8Up13");

var $8tp0Q = parcelRequire("8tp0Q");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $1bf70b3936fb696c$var$baseAssign(object, source) {
    return object && (0, $8Up13.default)(source, (0, $8tp0Q.default)(source), object);
}
var $1bf70b3936fb696c$export$2e2bcd8739ae039 = $1bf70b3936fb696c$var$baseAssign;

});
parcelRegister("8tp0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $62b46f28be927459$export$2e2bcd8739ae039);

var $fuUH8 = parcelRequire("fuUH8");

var $703j7 = parcelRequire("703j7");

var $8pHBa = parcelRequire("8pHBa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $62b46f28be927459$var$keys(object) {
    return (0, $8pHBa.default)(object) ? (0, $fuUH8.default)(object) : (0, $703j7.default)(object);
}
var $62b46f28be927459$export$2e2bcd8739ae039 = $62b46f28be927459$var$keys;

});
parcelRegister("703j7", function(module, exports) {

$parcel$export(module.exports, "default", () => $518b193f31e88dad$export$2e2bcd8739ae039);

var $7H3cd = parcelRequire("7H3cd");

var $gBGBx = parcelRequire("gBGBx");
/** Used for built-in method references. */ var $518b193f31e88dad$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $518b193f31e88dad$var$hasOwnProperty = $518b193f31e88dad$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $518b193f31e88dad$var$baseKeys(object) {
    if (!(0, $7H3cd.default)(object)) return (0, $gBGBx.default)(object);
    var result = [];
    for(var key in Object(object))if ($518b193f31e88dad$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $518b193f31e88dad$export$2e2bcd8739ae039 = $518b193f31e88dad$var$baseKeys;

});
parcelRegister("gBGBx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c171266a6ece1d65$export$2e2bcd8739ae039);

var $3knOV = parcelRequire("3knOV");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c171266a6ece1d65$var$nativeKeys = (0, $3knOV.default)(Object.keys, Object);
var $c171266a6ece1d65$export$2e2bcd8739ae039 = $c171266a6ece1d65$var$nativeKeys;

});




parcelRegister("fnLNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b32e13d40e8591ac$export$2e2bcd8739ae039);

var $8Up13 = parcelRequire("8Up13");

var $fIbiK = parcelRequire("fIbiK");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b32e13d40e8591ac$var$baseAssignIn(object, source) {
    return object && (0, $8Up13.default)(source, (0, $fIbiK.default)(source), object);
}
var $b32e13d40e8591ac$export$2e2bcd8739ae039 = $b32e13d40e8591ac$var$baseAssignIn;

});

parcelRegister("5vHz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4031a3ea56a713cc$export$2e2bcd8739ae039);

var $8Up13 = parcelRequire("8Up13");

var $fAy44 = parcelRequire("fAy44");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $4031a3ea56a713cc$var$copySymbols(source, object) {
    return (0, $8Up13.default)(source, (0, $fAy44.default)(source), object);
}
var $4031a3ea56a713cc$export$2e2bcd8739ae039 = $4031a3ea56a713cc$var$copySymbols;

});
parcelRegister("fAy44", function(module, exports) {

$parcel$export(module.exports, "default", () => $b594a45b62448ad3$export$2e2bcd8739ae039);

var $2V7We = parcelRequire("2V7We");

var $72SgP = parcelRequire("72SgP");
/** Used for built-in method references. */ var $b594a45b62448ad3$var$objectProto = Object.prototype;
/** Built-in value references. */ var $b594a45b62448ad3$var$propertyIsEnumerable = $b594a45b62448ad3$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b594a45b62448ad3$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b594a45b62448ad3$var$getSymbols = !$b594a45b62448ad3$var$nativeGetSymbols ? (0, $72SgP.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $2V7We.default)($b594a45b62448ad3$var$nativeGetSymbols(object), function(symbol) {
        return $b594a45b62448ad3$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $b594a45b62448ad3$export$2e2bcd8739ae039 = $b594a45b62448ad3$var$getSymbols;

});
parcelRegister("2V7We", function(module, exports) {

$parcel$export(module.exports, "default", () => $2207100852ffb107$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $2207100852ffb107$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $2207100852ffb107$export$2e2bcd8739ae039 = $2207100852ffb107$var$arrayFilter;

});

parcelRegister("72SgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5212d14793e4f03b$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $5212d14793e4f03b$var$stubArray() {
    return [];
}
var $5212d14793e4f03b$export$2e2bcd8739ae039 = $5212d14793e4f03b$var$stubArray;

});



parcelRegister("9pdV7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d913f1bf92079a5$export$2e2bcd8739ae039);

var $8Up13 = parcelRequire("8Up13");

var $eywhD = parcelRequire("eywhD");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $6d913f1bf92079a5$var$copySymbolsIn(source, object) {
    return (0, $8Up13.default)(source, (0, $eywhD.default)(source), object);
}
var $6d913f1bf92079a5$export$2e2bcd8739ae039 = $6d913f1bf92079a5$var$copySymbolsIn;

});
parcelRegister("eywhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a98d4874d94f7a2a$export$2e2bcd8739ae039);

var $2aSL7 = parcelRequire("2aSL7");

var $lPOv3 = parcelRequire("lPOv3");

var $fAy44 = parcelRequire("fAy44");

var $72SgP = parcelRequire("72SgP");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a98d4874d94f7a2a$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a98d4874d94f7a2a$var$getSymbolsIn = !$a98d4874d94f7a2a$var$nativeGetSymbols ? (0, $72SgP.default) : function(object) {
    var result = [];
    while(object){
        (0, $2aSL7.default)(result, (0, $fAy44.default)(object));
        object = (0, $lPOv3.default)(object);
    }
    return result;
};
var $a98d4874d94f7a2a$export$2e2bcd8739ae039 = $a98d4874d94f7a2a$var$getSymbolsIn;

});
parcelRegister("2aSL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1956fdf36ee5f114$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $1956fdf36ee5f114$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $1956fdf36ee5f114$export$2e2bcd8739ae039 = $1956fdf36ee5f114$var$arrayPush;

});



parcelRegister("bZZOu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc5570c7156bb88$export$2e2bcd8739ae039);

var $6vvEy = parcelRequire("6vvEy");

var $fAy44 = parcelRequire("fAy44");

var $8tp0Q = parcelRequire("8tp0Q");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8bc5570c7156bb88$var$getAllKeys(object) {
    return (0, $6vvEy.default)(object, (0, $8tp0Q.default), (0, $fAy44.default));
}
var $8bc5570c7156bb88$export$2e2bcd8739ae039 = $8bc5570c7156bb88$var$getAllKeys;

});
parcelRegister("6vvEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bce30f8fa9644a6$export$2e2bcd8739ae039);

var $2aSL7 = parcelRequire("2aSL7");

var $hXn90 = parcelRequire("hXn90");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $4bce30f8fa9644a6$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $hXn90.default)(object) ? result : (0, $2aSL7.default)(result, symbolsFunc(object));
}
var $4bce30f8fa9644a6$export$2e2bcd8739ae039 = $4bce30f8fa9644a6$var$baseGetAllKeys;

});


parcelRegister("8sQaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6299690b9db96e04$export$2e2bcd8739ae039);

var $6vvEy = parcelRequire("6vvEy");

var $eywhD = parcelRequire("eywhD");

var $fIbiK = parcelRequire("fIbiK");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6299690b9db96e04$var$getAllKeysIn(object) {
    return (0, $6vvEy.default)(object, (0, $fIbiK.default), (0, $eywhD.default));
}
var $6299690b9db96e04$export$2e2bcd8739ae039 = $6299690b9db96e04$var$getAllKeysIn;

});

parcelRegister("81bAo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d6767722ca7e051$export$2e2bcd8739ae039);

var $hEfjz = parcelRequire("hEfjz");

var $fHOWn = parcelRequire("fHOWn");

var $2w9T8 = parcelRequire("2w9T8");

var $ilyUh = parcelRequire("ilyUh");

var $fvdpy = parcelRequire("fvdpy");

var $f4sy6 = parcelRequire("f4sy6");

var $gu9fH = parcelRequire("gu9fH");
/** `Object#toString` result references. */ var $5d6767722ca7e051$var$mapTag = '[object Map]', $5d6767722ca7e051$var$objectTag = '[object Object]', $5d6767722ca7e051$var$promiseTag = '[object Promise]', $5d6767722ca7e051$var$setTag = '[object Set]', $5d6767722ca7e051$var$weakMapTag = '[object WeakMap]';
var $5d6767722ca7e051$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $5d6767722ca7e051$var$dataViewCtorString = (0, $gu9fH.default)((0, $hEfjz.default)), $5d6767722ca7e051$var$mapCtorString = (0, $gu9fH.default)((0, $fHOWn.default)), $5d6767722ca7e051$var$promiseCtorString = (0, $gu9fH.default)((0, $2w9T8.default)), $5d6767722ca7e051$var$setCtorString = (0, $gu9fH.default)((0, $ilyUh.default)), $5d6767722ca7e051$var$weakMapCtorString = (0, $gu9fH.default)((0, $fvdpy.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $5d6767722ca7e051$var$getTag = (0, $f4sy6.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $hEfjz.default) && $5d6767722ca7e051$var$getTag(new (0, $hEfjz.default)(new ArrayBuffer(1))) != $5d6767722ca7e051$var$dataViewTag || (0, $fHOWn.default) && $5d6767722ca7e051$var$getTag(new (0, $fHOWn.default)) != $5d6767722ca7e051$var$mapTag || (0, $2w9T8.default) && $5d6767722ca7e051$var$getTag((0, $2w9T8.default).resolve()) != $5d6767722ca7e051$var$promiseTag || (0, $ilyUh.default) && $5d6767722ca7e051$var$getTag(new (0, $ilyUh.default)) != $5d6767722ca7e051$var$setTag || (0, $fvdpy.default) && $5d6767722ca7e051$var$getTag(new (0, $fvdpy.default)) != $5d6767722ca7e051$var$weakMapTag) $5d6767722ca7e051$var$getTag = function(value) {
    var result = (0, $f4sy6.default)(value), Ctor = result == $5d6767722ca7e051$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $gu9fH.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $5d6767722ca7e051$var$dataViewCtorString:
            return $5d6767722ca7e051$var$dataViewTag;
        case $5d6767722ca7e051$var$mapCtorString:
            return $5d6767722ca7e051$var$mapTag;
        case $5d6767722ca7e051$var$promiseCtorString:
            return $5d6767722ca7e051$var$promiseTag;
        case $5d6767722ca7e051$var$setCtorString:
            return $5d6767722ca7e051$var$setTag;
        case $5d6767722ca7e051$var$weakMapCtorString:
            return $5d6767722ca7e051$var$weakMapTag;
    }
    return result;
};
var $5d6767722ca7e051$export$2e2bcd8739ae039 = $5d6767722ca7e051$var$getTag;

});
parcelRegister("hEfjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd920d411d2eb52f$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");

var $2ZUhy = parcelRequire("2ZUhy");
/* Built-in method references that are verified to be native. */ var $cd920d411d2eb52f$var$DataView = (0, $8dB7s.default)((0, $2ZUhy.default), 'DataView');
var $cd920d411d2eb52f$export$2e2bcd8739ae039 = $cd920d411d2eb52f$var$DataView;

});

parcelRegister("2w9T8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d563d83fcff7b61$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");

var $2ZUhy = parcelRequire("2ZUhy");
/* Built-in method references that are verified to be native. */ var $1d563d83fcff7b61$var$Promise = (0, $8dB7s.default)((0, $2ZUhy.default), 'Promise');
var $1d563d83fcff7b61$export$2e2bcd8739ae039 = $1d563d83fcff7b61$var$Promise;

});

parcelRegister("ilyUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5b543ee395fc2f5$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");

var $2ZUhy = parcelRequire("2ZUhy");
/* Built-in method references that are verified to be native. */ var $d5b543ee395fc2f5$var$Set = (0, $8dB7s.default)((0, $2ZUhy.default), 'Set');
var $d5b543ee395fc2f5$export$2e2bcd8739ae039 = $d5b543ee395fc2f5$var$Set;

});

parcelRegister("fvdpy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4942771dda5629d$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");

var $2ZUhy = parcelRequire("2ZUhy");
/* Built-in method references that are verified to be native. */ var $b4942771dda5629d$var$WeakMap = (0, $8dB7s.default)((0, $2ZUhy.default), 'WeakMap');
var $b4942771dda5629d$export$2e2bcd8739ae039 = $b4942771dda5629d$var$WeakMap;

});


parcelRegister("dseQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cb966a6de1f6e55$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $9cb966a6de1f6e55$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9cb966a6de1f6e55$var$hasOwnProperty = $9cb966a6de1f6e55$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $9cb966a6de1f6e55$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $9cb966a6de1f6e55$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $9cb966a6de1f6e55$export$2e2bcd8739ae039 = $9cb966a6de1f6e55$var$initCloneArray;

});

parcelRegister("1Nluj", function(module, exports) {

$parcel$export(module.exports, "default", () => $14eb0915c8354295$export$2e2bcd8739ae039);

var $aal8n = parcelRequire("aal8n");

var $iwlNg = parcelRequire("iwlNg");

var $6nUzy = parcelRequire("6nUzy");

var $dsYzv = parcelRequire("dsYzv");

var $70ZJW = parcelRequire("70ZJW");
/** `Object#toString` result references. */ var $14eb0915c8354295$var$boolTag = '[object Boolean]', $14eb0915c8354295$var$dateTag = '[object Date]', $14eb0915c8354295$var$mapTag = '[object Map]', $14eb0915c8354295$var$numberTag = '[object Number]', $14eb0915c8354295$var$regexpTag = '[object RegExp]', $14eb0915c8354295$var$setTag = '[object Set]', $14eb0915c8354295$var$stringTag = '[object String]', $14eb0915c8354295$var$symbolTag = '[object Symbol]';
var $14eb0915c8354295$var$arrayBufferTag = '[object ArrayBuffer]', $14eb0915c8354295$var$dataViewTag = '[object DataView]', $14eb0915c8354295$var$float32Tag = '[object Float32Array]', $14eb0915c8354295$var$float64Tag = '[object Float64Array]', $14eb0915c8354295$var$int8Tag = '[object Int8Array]', $14eb0915c8354295$var$int16Tag = '[object Int16Array]', $14eb0915c8354295$var$int32Tag = '[object Int32Array]', $14eb0915c8354295$var$uint8Tag = '[object Uint8Array]', $14eb0915c8354295$var$uint8ClampedTag = '[object Uint8ClampedArray]', $14eb0915c8354295$var$uint16Tag = '[object Uint16Array]', $14eb0915c8354295$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $14eb0915c8354295$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $14eb0915c8354295$var$arrayBufferTag:
            return (0, $aal8n.default)(object);
        case $14eb0915c8354295$var$boolTag:
        case $14eb0915c8354295$var$dateTag:
            return new Ctor(+object);
        case $14eb0915c8354295$var$dataViewTag:
            return (0, $iwlNg.default)(object, isDeep);
        case $14eb0915c8354295$var$float32Tag:
        case $14eb0915c8354295$var$float64Tag:
        case $14eb0915c8354295$var$int8Tag:
        case $14eb0915c8354295$var$int16Tag:
        case $14eb0915c8354295$var$int32Tag:
        case $14eb0915c8354295$var$uint8Tag:
        case $14eb0915c8354295$var$uint8ClampedTag:
        case $14eb0915c8354295$var$uint16Tag:
        case $14eb0915c8354295$var$uint32Tag:
            return (0, $70ZJW.default)(object, isDeep);
        case $14eb0915c8354295$var$mapTag:
            return new Ctor;
        case $14eb0915c8354295$var$numberTag:
        case $14eb0915c8354295$var$stringTag:
            return new Ctor(object);
        case $14eb0915c8354295$var$regexpTag:
            return (0, $6nUzy.default)(object);
        case $14eb0915c8354295$var$setTag:
            return new Ctor;
        case $14eb0915c8354295$var$symbolTag:
            return (0, $dsYzv.default)(object);
    }
}
var $14eb0915c8354295$export$2e2bcd8739ae039 = $14eb0915c8354295$var$initCloneByTag;

});
parcelRegister("iwlNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7bc1ee4e27dfdcf$export$2e2bcd8739ae039);

var $aal8n = parcelRequire("aal8n");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $d7bc1ee4e27dfdcf$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $aal8n.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $d7bc1ee4e27dfdcf$export$2e2bcd8739ae039 = $d7bc1ee4e27dfdcf$var$cloneDataView;

});

parcelRegister("6nUzy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a60c62793ffe472$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $4a60c62793ffe472$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $4a60c62793ffe472$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $4a60c62793ffe472$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $4a60c62793ffe472$export$2e2bcd8739ae039 = $4a60c62793ffe472$var$cloneRegExp;

});

parcelRegister("dsYzv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cdce02535daccfa$export$2e2bcd8739ae039);

var $9O75z = parcelRequire("9O75z");
/** Used to convert symbols to primitives and strings. */ var $9cdce02535daccfa$var$symbolProto = (0, $9O75z.default) ? (0, $9O75z.default).prototype : undefined, $9cdce02535daccfa$var$symbolValueOf = $9cdce02535daccfa$var$symbolProto ? $9cdce02535daccfa$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $9cdce02535daccfa$var$cloneSymbol(symbol) {
    return $9cdce02535daccfa$var$symbolValueOf ? Object($9cdce02535daccfa$var$symbolValueOf.call(symbol)) : {};
}
var $9cdce02535daccfa$export$2e2bcd8739ae039 = $9cdce02535daccfa$var$cloneSymbol;

});


parcelRegister("4frQp", function(module, exports) {

$parcel$export(module.exports, "default", () => $317e296c7c43244d$export$2e2bcd8739ae039);

var $l24B7 = parcelRequire("l24B7");

var $i0Jgc = parcelRequire("i0Jgc");

var $lAe6g = parcelRequire("lAe6g");
/* Node.js helper references. */ var $317e296c7c43244d$var$nodeIsMap = (0, $lAe6g.default) && (0, $lAe6g.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $317e296c7c43244d$var$isMap = $317e296c7c43244d$var$nodeIsMap ? (0, $i0Jgc.default)($317e296c7c43244d$var$nodeIsMap) : (0, $l24B7.default);
var $317e296c7c43244d$export$2e2bcd8739ae039 = $317e296c7c43244d$var$isMap;

});
parcelRegister("l24B7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4fd59e09539f481$export$2e2bcd8739ae039);

var $81bAo = parcelRequire("81bAo");

var $ydcRw = parcelRequire("ydcRw");
/** `Object#toString` result references. */ var $f4fd59e09539f481$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $f4fd59e09539f481$var$baseIsMap(value) {
    return (0, $ydcRw.default)(value) && (0, $81bAo.default)(value) == $f4fd59e09539f481$var$mapTag;
}
var $f4fd59e09539f481$export$2e2bcd8739ae039 = $f4fd59e09539f481$var$baseIsMap;

});


parcelRegister("gFm9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $c221a7ee0bc88bd2$export$2e2bcd8739ae039);

var $8d0Ps = parcelRequire("8d0Ps");

var $i0Jgc = parcelRequire("i0Jgc");

var $lAe6g = parcelRequire("lAe6g");
/* Node.js helper references. */ var $c221a7ee0bc88bd2$var$nodeIsSet = (0, $lAe6g.default) && (0, $lAe6g.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $c221a7ee0bc88bd2$var$isSet = $c221a7ee0bc88bd2$var$nodeIsSet ? (0, $i0Jgc.default)($c221a7ee0bc88bd2$var$nodeIsSet) : (0, $8d0Ps.default);
var $c221a7ee0bc88bd2$export$2e2bcd8739ae039 = $c221a7ee0bc88bd2$var$isSet;

});
parcelRegister("8d0Ps", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fa02e3c94def8cf$export$2e2bcd8739ae039);

var $81bAo = parcelRequire("81bAo");

var $ydcRw = parcelRequire("ydcRw");
/** `Object#toString` result references. */ var $5fa02e3c94def8cf$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $5fa02e3c94def8cf$var$baseIsSet(value) {
    return (0, $ydcRw.default)(value) && (0, $81bAo.default)(value) == $5fa02e3c94def8cf$var$setTag;
}
var $5fa02e3c94def8cf$export$2e2bcd8739ae039 = $5fa02e3c94def8cf$var$baseIsSet;

});




parcelRegister("d7fWe", function(module, exports) {

$parcel$export(module.exports, "default", () => $98c84ad0f39c492c$export$2e2bcd8739ae039);

var $4Svu9 = parcelRequire("4Svu9");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $98c84ad0f39c492c$var$isEqual(value, other) {
    return (0, $4Svu9.default)(value, other);
}
var $98c84ad0f39c492c$export$2e2bcd8739ae039 = $98c84ad0f39c492c$var$isEqual;

});
parcelRegister("4Svu9", function(module, exports) {

$parcel$export(module.exports, "default", () => $38d4a0e30de809f2$export$2e2bcd8739ae039);

var $g4toE = parcelRequire("g4toE");

var $ydcRw = parcelRequire("ydcRw");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $38d4a0e30de809f2$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $ydcRw.default)(value) && !(0, $ydcRw.default)(other)) return value !== value && other !== other;
    return (0, $g4toE.default)(value, other, bitmask, customizer, $38d4a0e30de809f2$var$baseIsEqual, stack);
}
var $38d4a0e30de809f2$export$2e2bcd8739ae039 = $38d4a0e30de809f2$var$baseIsEqual;

});
parcelRegister("g4toE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb33d29d0aeb67aa$export$2e2bcd8739ae039);

var $ch4ws = parcelRequire("ch4ws");

var $5k7WO = parcelRequire("5k7WO");

var $jMbee = parcelRequire("jMbee");

var $dxYwk = parcelRequire("dxYwk");

var $81bAo = parcelRequire("81bAo");

var $hXn90 = parcelRequire("hXn90");

var $hiJJV = parcelRequire("hiJJV");

var $ckYSa = parcelRequire("ckYSa");
/** Used to compose bitmasks for value comparisons. */ var $bb33d29d0aeb67aa$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $bb33d29d0aeb67aa$var$argsTag = '[object Arguments]', $bb33d29d0aeb67aa$var$arrayTag = '[object Array]', $bb33d29d0aeb67aa$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $bb33d29d0aeb67aa$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bb33d29d0aeb67aa$var$hasOwnProperty = $bb33d29d0aeb67aa$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $bb33d29d0aeb67aa$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $hXn90.default)(object), othIsArr = (0, $hXn90.default)(other), objTag = objIsArr ? $bb33d29d0aeb67aa$var$arrayTag : (0, $81bAo.default)(object), othTag = othIsArr ? $bb33d29d0aeb67aa$var$arrayTag : (0, $81bAo.default)(other);
    objTag = objTag == $bb33d29d0aeb67aa$var$argsTag ? $bb33d29d0aeb67aa$var$objectTag : objTag;
    othTag = othTag == $bb33d29d0aeb67aa$var$argsTag ? $bb33d29d0aeb67aa$var$objectTag : othTag;
    var objIsObj = objTag == $bb33d29d0aeb67aa$var$objectTag, othIsObj = othTag == $bb33d29d0aeb67aa$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $hiJJV.default)(object)) {
        if (!(0, $hiJJV.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $ch4ws.default));
        return objIsArr || (0, $ckYSa.default)(object) ? (0, $5k7WO.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, $jMbee.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $bb33d29d0aeb67aa$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $bb33d29d0aeb67aa$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $bb33d29d0aeb67aa$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $ch4ws.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $ch4ws.default));
    return (0, $dxYwk.default)(object, other, bitmask, customizer, equalFunc, stack);
}
var $bb33d29d0aeb67aa$export$2e2bcd8739ae039 = $bb33d29d0aeb67aa$var$baseIsEqualDeep;

});
parcelRegister("5k7WO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e04fc3a5fa7ba65$export$2e2bcd8739ae039);

var $5vzqX = parcelRequire("5vzqX");

var $gFXKj = parcelRequire("gFXKj");

var $giJzR = parcelRequire("giJzR");
/** Used to compose bitmasks for value comparisons. */ var $3e04fc3a5fa7ba65$var$COMPARE_PARTIAL_FLAG = 1, $3e04fc3a5fa7ba65$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $3e04fc3a5fa7ba65$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3e04fc3a5fa7ba65$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $3e04fc3a5fa7ba65$var$COMPARE_UNORDERED_FLAG ? new (0, $5vzqX.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $gFXKj.default)(other, function(othValue, othIndex) {
                if (!(0, $giJzR.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $3e04fc3a5fa7ba65$export$2e2bcd8739ae039 = $3e04fc3a5fa7ba65$var$equalArrays;

});
parcelRegister("5vzqX", function(module, exports) {

$parcel$export(module.exports, "default", () => $402b556556c042c3$export$2e2bcd8739ae039);

var $j9mMr = parcelRequire("j9mMr");

var $kIatD = parcelRequire("kIatD");

var $5LWBr = parcelRequire("5LWBr");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $402b556556c042c3$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $j9mMr.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$402b556556c042c3$var$SetCache.prototype.add = $402b556556c042c3$var$SetCache.prototype.push = (0, $kIatD.default);
$402b556556c042c3$var$SetCache.prototype.has = (0, $5LWBr.default);
var $402b556556c042c3$export$2e2bcd8739ae039 = $402b556556c042c3$var$SetCache;

});
parcelRegister("kIatD", function(module, exports) {

$parcel$export(module.exports, "default", () => $03e421368511473f$export$2e2bcd8739ae039);
/** Used to stand-in for `undefined` hash values. */ var $03e421368511473f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $03e421368511473f$var$setCacheAdd(value) {
    this.__data__.set(value, $03e421368511473f$var$HASH_UNDEFINED);
    return this;
}
var $03e421368511473f$export$2e2bcd8739ae039 = $03e421368511473f$var$setCacheAdd;

});

parcelRegister("5LWBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $433eccd36bf486e4$export$2e2bcd8739ae039);
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $433eccd36bf486e4$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $433eccd36bf486e4$export$2e2bcd8739ae039 = $433eccd36bf486e4$var$setCacheHas;

});


parcelRegister("gFXKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23ed1fb8be6bc70$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c23ed1fb8be6bc70$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $c23ed1fb8be6bc70$export$2e2bcd8739ae039 = $c23ed1fb8be6bc70$var$arraySome;

});

parcelRegister("giJzR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde1ae7fa7cc55b1$export$2e2bcd8739ae039);
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bde1ae7fa7cc55b1$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $bde1ae7fa7cc55b1$export$2e2bcd8739ae039 = $bde1ae7fa7cc55b1$var$cacheHas;

});


parcelRegister("jMbee", function(module, exports) {

$parcel$export(module.exports, "default", () => $e65b35c84a7dc362$export$2e2bcd8739ae039);

var $9O75z = parcelRequire("9O75z");

var $7uREm = parcelRequire("7uREm");

var $78Lr5 = parcelRequire("78Lr5");

var $5k7WO = parcelRequire("5k7WO");

var $66uCe = parcelRequire("66uCe");

var $eBtAy = parcelRequire("eBtAy");
/** Used to compose bitmasks for value comparisons. */ var $e65b35c84a7dc362$var$COMPARE_PARTIAL_FLAG = 1, $e65b35c84a7dc362$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $e65b35c84a7dc362$var$boolTag = '[object Boolean]', $e65b35c84a7dc362$var$dateTag = '[object Date]', $e65b35c84a7dc362$var$errorTag = '[object Error]', $e65b35c84a7dc362$var$mapTag = '[object Map]', $e65b35c84a7dc362$var$numberTag = '[object Number]', $e65b35c84a7dc362$var$regexpTag = '[object RegExp]', $e65b35c84a7dc362$var$setTag = '[object Set]', $e65b35c84a7dc362$var$stringTag = '[object String]', $e65b35c84a7dc362$var$symbolTag = '[object Symbol]';
var $e65b35c84a7dc362$var$arrayBufferTag = '[object ArrayBuffer]', $e65b35c84a7dc362$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $e65b35c84a7dc362$var$symbolProto = (0, $9O75z.default) ? (0, $9O75z.default).prototype : undefined, $e65b35c84a7dc362$var$symbolValueOf = $e65b35c84a7dc362$var$symbolProto ? $e65b35c84a7dc362$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e65b35c84a7dc362$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $e65b35c84a7dc362$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $e65b35c84a7dc362$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $7uREm.default)(object), new (0, $7uREm.default)(other))) return false;
            return true;
        case $e65b35c84a7dc362$var$boolTag:
        case $e65b35c84a7dc362$var$dateTag:
        case $e65b35c84a7dc362$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $78Lr5.default)(+object, +other);
        case $e65b35c84a7dc362$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $e65b35c84a7dc362$var$regexpTag:
        case $e65b35c84a7dc362$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $e65b35c84a7dc362$var$mapTag:
            var convert = (0, $66uCe.default);
        case $e65b35c84a7dc362$var$setTag:
            var isPartial = bitmask & $e65b35c84a7dc362$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $eBtAy.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $e65b35c84a7dc362$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $5k7WO.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $e65b35c84a7dc362$var$symbolTag:
            if ($e65b35c84a7dc362$var$symbolValueOf) return $e65b35c84a7dc362$var$symbolValueOf.call(object) == $e65b35c84a7dc362$var$symbolValueOf.call(other);
    }
    return false;
}
var $e65b35c84a7dc362$export$2e2bcd8739ae039 = $e65b35c84a7dc362$var$equalByTag;

});
parcelRegister("66uCe", function(module, exports) {

$parcel$export(module.exports, "default", () => $471b0d3d26a123a7$export$2e2bcd8739ae039);
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $471b0d3d26a123a7$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $471b0d3d26a123a7$export$2e2bcd8739ae039 = $471b0d3d26a123a7$var$mapToArray;

});

parcelRegister("eBtAy", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa1b790e15273fb4$export$2e2bcd8739ae039);
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $aa1b790e15273fb4$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $aa1b790e15273fb4$export$2e2bcd8739ae039 = $aa1b790e15273fb4$var$setToArray;

});


parcelRegister("dxYwk", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dcd4d8a0780abe9$export$2e2bcd8739ae039);

var $bZZOu = parcelRequire("bZZOu");
/** Used to compose bitmasks for value comparisons. */ var $9dcd4d8a0780abe9$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $9dcd4d8a0780abe9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9dcd4d8a0780abe9$var$hasOwnProperty = $9dcd4d8a0780abe9$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $9dcd4d8a0780abe9$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $9dcd4d8a0780abe9$var$COMPARE_PARTIAL_FLAG, objProps = (0, $bZZOu.default)(object), objLength = objProps.length, othProps = (0, $bZZOu.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $9dcd4d8a0780abe9$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $9dcd4d8a0780abe9$export$2e2bcd8739ae039 = $9dcd4d8a0780abe9$var$equalObjects;

});




parcelRegister("fp1Tt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b36aa8dae9fa5d84$export$2e2bcd8739ae039);
$parcel$export(module.exports, "blockDelta", () => $b36aa8dae9fa5d84$export$992ff47219af5a2b);
$parcel$export(module.exports, "BlockEmbed", () => $b36aa8dae9fa5d84$export$48b9f0688962d028);
$parcel$export(module.exports, "bubbleFormats", () => $b36aa8dae9fa5d84$export$e4bb5a6163449612);

var $lHwOS = parcelRequire("lHwOS");

var $kEXGb = parcelRequire("kEXGb");

var $bmwCM = parcelRequire("bmwCM");

var $fWwa7 = parcelRequire("fWwa7");

var $bxVMH = parcelRequire("bxVMH");
const $b36aa8dae9fa5d84$var$NEWLINE_LENGTH = 1;
class $b36aa8dae9fa5d84$export$2e2bcd8739ae039 extends (0, $lHwOS.BlockBlot) {
    cache = {};
    delta() {
        if (this.cache.delta == null) this.cache.delta = $b36aa8dae9fa5d84$export$992ff47219af5a2b(this);
        return this.cache.delta;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length);
        this.cache = {};
    }
    formatAt(index, length, name, value) {
        if (length <= 0) return;
        if (this.scroll.query(name, (0, $lHwOS.Scope).BLOCK)) {
            if (index + length === this.length()) this.format(name, value);
        } else super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);
        this.cache = {};
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            this.cache = {};
            return;
        }
        if (value.length === 0) return;
        const lines = value.split('\n');
        const text = lines.shift();
        if (text.length > 0) {
            if (index < this.length() - 1 || this.children.tail == null) super.insertAt(Math.min(index, this.length() - 1), text);
            else this.children.tail.insertAt(this.children.tail.length(), text);
            this.cache = {};
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let block = this;
        lines.reduce((lineIndex, line)=>{
            // @ts-expect-error Fix me later
            block = block.split(lineIndex, true);
            block.insertAt(0, line);
            return line.length;
        }, index + text.length);
    }
    insertBefore(blot, ref) {
        const { head: head } = this.children;
        super.insertBefore(blot, ref);
        if (head instanceof (0, $bmwCM.default)) head.remove();
        this.cache = {};
    }
    length() {
        if (this.cache.length == null) this.cache.length = super.length() + $b36aa8dae9fa5d84$var$NEWLINE_LENGTH;
        return this.cache.length;
    }
    moveChildren(target, ref) {
        super.moveChildren(target, ref);
        this.cache = {};
    }
    optimize(context) {
        super.optimize(context);
        this.cache = {};
    }
    path(index) {
        return super.path(index, true);
    }
    removeChild(child) {
        super.removeChild(child);
        this.cache = {};
    }
    split(index) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (force && (index === 0 || index >= this.length() - $b36aa8dae9fa5d84$var$NEWLINE_LENGTH)) {
            const clone = this.clone();
            if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
            }
            this.parent.insertBefore(clone, this.next);
            return clone;
        }
        const next = super.split(index, force);
        this.cache = {};
        return next;
    }
}
$b36aa8dae9fa5d84$export$2e2bcd8739ae039.blotName = 'block';
$b36aa8dae9fa5d84$export$2e2bcd8739ae039.tagName = 'P';
$b36aa8dae9fa5d84$export$2e2bcd8739ae039.defaultChild = (0, $bmwCM.default);
$b36aa8dae9fa5d84$export$2e2bcd8739ae039.allowedChildren = [
    (0, $bmwCM.default),
    (0, $fWwa7.default),
    (0, $lHwOS.EmbedBlot),
    (0, $bxVMH.default)
];
class $b36aa8dae9fa5d84$export$48b9f0688962d028 extends (0, $lHwOS.EmbedBlot) {
    attach() {
        super.attach();
        this.attributes = new (0, $lHwOS.AttributorStore)(this.domNode);
    }
    delta() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(this.value(), {
            ...this.formats(),
            ...this.attributes.values()
        });
    }
    format(name, value) {
        const attribute = this.scroll.query(name, (0, $lHwOS.Scope).BLOCK_ATTRIBUTE);
        if (attribute != null) // @ts-expect-error TODO: Scroll#query() should return Attributor when scope is attribute
        this.attributes.attribute(attribute, value);
    }
    formatAt(index, length, name, value) {
        this.format(name, value);
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            return;
        }
        const lines = value.split('\n');
        const text = lines.pop();
        const blocks = lines.map((line)=>{
            const block = this.scroll.create($b36aa8dae9fa5d84$export$2e2bcd8739ae039.blotName);
            block.insertAt(0, line);
            return block;
        });
        const ref = this.split(index);
        blocks.forEach((block)=>{
            this.parent.insertBefore(block, ref);
        });
        if (text) this.parent.insertBefore(this.scroll.create('text', text), ref);
    }
}
$b36aa8dae9fa5d84$export$48b9f0688962d028.scope = (0, $lHwOS.Scope).BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements
function $b36aa8dae9fa5d84$export$992ff47219af5a2b(blot) {
    let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return blot.descendants((0, $lHwOS.LeafBlot)).reduce((delta, leaf)=>{
        if (leaf.length() === 0) return delta;
        return delta.insert(leaf.value(), $b36aa8dae9fa5d84$export$e4bb5a6163449612(leaf, {}, filter));
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))()).insert('\n', $b36aa8dae9fa5d84$export$e4bb5a6163449612(blot));
}
function $b36aa8dae9fa5d84$export$e4bb5a6163449612(blot) {
    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (blot == null) return formats;
    if ('formats' in blot && typeof blot.formats === 'function') {
        formats = {
            ...formats,
            ...blot.formats()
        };
        if (filter) // exclude syntax highlighting from deltas and getFormat()
        delete formats['code-token'];
    }
    if (blot.parent == null || blot.parent.statics.blotName === 'scroll' || blot.parent.statics.scope !== blot.statics.scope) return formats;
    return $b36aa8dae9fa5d84$export$e4bb5a6163449612(blot.parent, formats, filter);
}

});
parcelRegister("bmwCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $845b0e4f439932ae$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");
class $845b0e4f439932ae$var$Break extends (0, $lHwOS.EmbedBlot) {
    static value() {
        return undefined;
    }
    optimize() {
        if (this.prev || this.next) this.remove();
    }
    length() {
        return 0;
    }
    value() {
        return '';
    }
}
$845b0e4f439932ae$var$Break.blotName = 'break';
$845b0e4f439932ae$var$Break.tagName = 'BR';
var $845b0e4f439932ae$export$2e2bcd8739ae039 = $845b0e4f439932ae$var$Break;

});

parcelRegister("fWwa7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9b5388c87c2e1a4$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $bmwCM = parcelRequire("bmwCM");

var $bxVMH = parcelRequire("bxVMH");
class $b9b5388c87c2e1a4$var$Inline extends (0, $lHwOS.InlineBlot) {
    static allowedChildren = [
        $b9b5388c87c2e1a4$var$Inline,
        (0, $bmwCM.default),
        (0, $lHwOS.EmbedBlot),
        (0, $bxVMH.default)
    ];
    // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
    static order = [
        'cursor',
        'inline',
        // Must be lower
        'link',
        // Chrome wants <a> to be lower
        'underline',
        'strike',
        'italic',
        'bold',
        'script',
        'code' // Must be higher
    ];
    static compare(self, other) {
        const selfIndex = $b9b5388c87c2e1a4$var$Inline.order.indexOf(self);
        const otherIndex = $b9b5388c87c2e1a4$var$Inline.order.indexOf(other);
        if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
        if (self === other) return 0;
        if (self < other) return -1;
        return 1;
    }
    formatAt(index, length, name, value) {
        if ($b9b5388c87c2e1a4$var$Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, (0, $lHwOS.Scope).BLOT)) {
            const blot = this.isolate(index, length);
            if (value) blot.wrap(name, value);
        } else super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent instanceof $b9b5388c87c2e1a4$var$Inline && $b9b5388c87c2e1a4$var$Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
            const parent = this.parent.isolate(this.offset(), this.length());
            // @ts-expect-error TODO: make isolate generic
            this.moveChildren(parent);
            parent.wrap(this);
        }
    }
}
var $b9b5388c87c2e1a4$export$2e2bcd8739ae039 = $b9b5388c87c2e1a4$var$Inline;

});
parcelRegister("bxVMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $867f998ee7d46ca2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "escapeText", () => $867f998ee7d46ca2$export$96e6fc3a139b2555);

var $lHwOS = parcelRequire("lHwOS");
class $867f998ee7d46ca2$export$2e2bcd8739ae039 extends (0, $lHwOS.TextBlot) {
}
// https://lodash.com/docs#escape
const $867f998ee7d46ca2$var$entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
function $867f998ee7d46ca2$export$96e6fc3a139b2555(text) {
    return text.replace(/[&<>"']/g, (s)=>$867f998ee7d46ca2$var$entityMap[s]);
}

});



parcelRegister("luQs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa65164eb3dea7d2$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $bxVMH = parcelRequire("bxVMH");
class $fa65164eb3dea7d2$var$Cursor extends (0, $lHwOS.EmbedBlot) {
    static blotName = 'cursor';
    static className = 'ql-cursor';
    static tagName = 'span';
    static CONTENTS = '\uFEFF';
    static value() {
        return undefined;
    }
    constructor(scroll, domNode, selection){
        super(scroll, domNode);
        this.selection = selection;
        this.textNode = document.createTextNode($fa65164eb3dea7d2$var$Cursor.CONTENTS);
        this.domNode.appendChild(this.textNode);
        this.savedLength = 0;
    }
    detach() {
        // super.detach() will also clear domNode.__blot
        if (this.parent != null) this.parent.removeChild(this);
    }
    format(name, value) {
        if (this.savedLength !== 0) {
            super.format(name, value);
            return;
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let target = this;
        let index = 0;
        while(target != null && target.statics.scope !== (0, $lHwOS.Scope).BLOCK_BLOT){
            index += target.offset(target.parent);
            target = target.parent;
        }
        if (target != null) {
            this.savedLength = $fa65164eb3dea7d2$var$Cursor.CONTENTS.length;
            // @ts-expect-error TODO: allow empty context in Parchment
            target.optimize();
            target.formatAt(index, $fa65164eb3dea7d2$var$Cursor.CONTENTS.length, name, value);
            this.savedLength = 0;
        }
    }
    index(node, offset) {
        if (node === this.textNode) return 0;
        return super.index(node, offset);
    }
    length() {
        return this.savedLength;
    }
    position() {
        return [
            this.textNode,
            this.textNode.data.length
        ];
    }
    remove() {
        super.remove();
        // @ts-expect-error Fix me later
        this.parent = null;
    }
    restore() {
        if (this.selection.composing || this.parent == null) return null;
        const range = this.selection.getNativeRange();
        // Browser may push down styles/nodes inside the cursor blot.
        // https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#push-down-values
        while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)// @ts-expect-error Fix me later
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
        const prevTextBlot = this.prev instanceof (0, $bxVMH.default) ? this.prev : null;
        const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
        const nextTextBlot = this.next instanceof (0, $bxVMH.default) ? this.next : null;
        // @ts-expect-error TODO: make TextBlot.text public
        const nextText = nextTextBlot ? nextTextBlot.text : '';
        const { textNode: textNode } = this;
        // take text from inside this blot and reset it
        const newText = textNode.data.split($fa65164eb3dea7d2$var$Cursor.CONTENTS).join('');
        textNode.data = $fa65164eb3dea7d2$var$Cursor.CONTENTS;
        // proactively merge TextBlots around cursor so that optimization
        // doesn't lose the cursor.  the reason we are here in cursor.restore
        // could be that the user clicked in prevTextBlot or nextTextBlot, or
        // the user typed something.
        let mergedTextBlot;
        if (prevTextBlot) {
            mergedTextBlot = prevTextBlot;
            if (newText || nextTextBlot) {
                prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
                if (nextTextBlot) nextTextBlot.remove();
            }
        } else if (nextTextBlot) {
            mergedTextBlot = nextTextBlot;
            nextTextBlot.insertAt(0, newText);
        } else {
            const newTextNode = document.createTextNode(newText);
            mergedTextBlot = this.scroll.create(newTextNode);
            this.parent.insertBefore(mergedTextBlot, this);
        }
        this.remove();
        if (range) {
            // calculate selection to restore
            const remapOffset = (node, offset)=>{
                if (prevTextBlot && node === prevTextBlot.domNode) return offset;
                if (node === textNode) return prevTextLength + offset - 1;
                if (nextTextBlot && node === nextTextBlot.domNode) return prevTextLength + newText.length + offset;
                return null;
            };
            const start = remapOffset(range.start.node, range.start.offset);
            const end = remapOffset(range.end.node, range.end.offset);
            if (start !== null && end !== null) return {
                startNode: mergedTextBlot.domNode,
                startOffset: start,
                endNode: mergedTextBlot.domNode,
                endOffset: end
            };
        }
        return null;
    }
    update(mutations, context) {
        if (mutations.some((mutation)=>{
            return mutation.type === 'characterData' && mutation.target === this.textNode;
        })) {
            const range = this.restore();
            if (range) context.range = range;
        }
    }
    // Avoid .ql-cursor being a descendant of `<a/>`.
    // The reason is Safari pushes down `<a/>` on text insertion.
    // That will cause DOM nodes not sync with the model.
    //
    // For example ({I} is the caret), given the markup:
    //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
    // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
    //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
    // And then "x" will be inserted after `<a/>`:
    //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
    optimize(context) {
        // @ts-expect-error Fix me later
        super.optimize(context);
        let { parent: parent } = this;
        while(parent){
            if (parent.domNode.tagName === 'A') {
                this.savedLength = $fa65164eb3dea7d2$var$Cursor.CONTENTS.length;
                // @ts-expect-error TODO: make isolate generic
                parent.isolate(this.offset(parent), this.length()).unwrap();
                this.savedLength = 0;
                break;
            }
            parent = parent.parent;
        }
    }
    value() {
        return '';
    }
}
var $fa65164eb3dea7d2$export$2e2bcd8739ae039 = $fa65164eb3dea7d2$var$Cursor;

});

parcelRegister("3EdO3", function(module, exports) {

$parcel$export(module.exports, "Range", () => $2a7fd1325c8b4c35$export$9a58ef0d7ad3278c);
$parcel$export(module.exports, "default", () => $2a7fd1325c8b4c35$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $d7fWe = parcelRequire("d7fWe");
var $kaYY4 = parcelRequire("kaYY4");

var $jJqnr = parcelRequire("jJqnr");

var $lkbqq = parcelRequire("lkbqq");
const $2a7fd1325c8b4c35$var$debug = (0, $lkbqq.default)('quill:selection');
class $2a7fd1325c8b4c35$export$9a58ef0d7ad3278c {
    constructor(index){
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.index = index;
        this.length = length;
    }
}
class $2a7fd1325c8b4c35$var$Selection {
    constructor(scroll, emitter){
        this.emitter = emitter;
        this.scroll = scroll;
        this.composing = false;
        this.mouseDown = false;
        this.root = this.scroll.domNode;
        // @ts-expect-error
        this.cursor = this.scroll.create('cursor', this);
        // savedRange is last non-null range
        this.savedRange = new $2a7fd1325c8b4c35$export$9a58ef0d7ad3278c(0, 0);
        this.lastRange = this.savedRange;
        this.lastNative = null;
        this.handleComposition();
        this.handleDragging();
        this.emitter.listenDOM('selectionchange', document, ()=>{
            if (!this.mouseDown && !this.composing) setTimeout(this.update.bind(this, (0, $jJqnr.default).sources.USER), 1);
        });
        this.emitter.on((0, $jJqnr.default).events.SCROLL_BEFORE_UPDATE, ()=>{
            if (!this.hasFocus()) return;
            const native = this.getNativeRange();
            if (native == null) return;
            if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle
            this.emitter.once((0, $jJqnr.default).events.SCROLL_UPDATE, (source, mutations)=>{
                try {
                    if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                    const triggeredByTyping = mutations.some((mutation)=>mutation.type === 'characterData' || mutation.type === 'childList' || mutation.type === 'attributes' && mutation.target === this.root);
                    this.update(triggeredByTyping ? (0, $jJqnr.default).sources.SILENT : source);
                } catch (ignored) {
                // ignore
                }
            });
        });
        this.emitter.on((0, $jJqnr.default).events.SCROLL_OPTIMIZE, (mutations, context)=>{
            if (context.range) {
                const { startNode: startNode, startOffset: startOffset, endNode: endNode, endOffset: endOffset } = context.range;
                this.setNativeRange(startNode, startOffset, endNode, endOffset);
                this.update((0, $jJqnr.default).sources.SILENT);
            }
        });
        this.update((0, $jJqnr.default).sources.SILENT);
    }
    handleComposition() {
        this.emitter.on((0, $jJqnr.default).events.COMPOSITION_BEFORE_START, ()=>{
            this.composing = true;
        });
        this.emitter.on((0, $jJqnr.default).events.COMPOSITION_END, ()=>{
            this.composing = false;
            if (this.cursor.parent) {
                const range = this.cursor.restore();
                if (!range) return;
                setTimeout(()=>{
                    this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
            }
        });
    }
    handleDragging() {
        this.emitter.listenDOM('mousedown', document.body, ()=>{
            this.mouseDown = true;
        });
        this.emitter.listenDOM('mouseup', document.body, ()=>{
            this.mouseDown = false;
            this.update((0, $jJqnr.default).sources.USER);
        });
    }
    focus() {
        if (this.hasFocus()) return;
        this.root.focus({
            preventScroll: true
        });
        this.setRange(this.savedRange);
    }
    format(format, value) {
        this.scroll.update();
        const nativeRange = this.getNativeRange();
        if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, (0, $lHwOS.Scope).BLOCK)) return;
        if (nativeRange.start.node !== this.cursor.textNode) {
            const blot = this.scroll.find(nativeRange.start.node, false);
            if (blot == null) return;
            // TODO Give blot ability to not split
            if (blot instanceof (0, $lHwOS.LeafBlot)) {
                const after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
            } else // @ts-expect-error TODO: nativeRange.start.node doesn't seem to match function signature
            blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
            this.cursor.attach();
        }
        this.cursor.format(format, value);
        this.scroll.optimize();
        this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
        this.update();
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        const scrollLength = this.scroll.length();
        index = Math.min(index, scrollLength - 1);
        length = Math.min(index + length, scrollLength - 1) - index;
        let node;
        let [leaf, offset] = this.scroll.leaf(index);
        if (leaf == null) return null;
        if (length > 0 && offset === leaf.length()) {
            const [next] = this.scroll.leaf(index + 1);
            if (next) {
                const [line] = this.scroll.line(index);
                const [nextLine] = this.scroll.line(index + 1);
                if (line === nextLine) {
                    leaf = next;
                    offset = 0;
                }
            }
        }
        [node, offset] = leaf.position(offset, true);
        const range = document.createRange();
        if (length > 0) {
            range.setStart(node, offset);
            [leaf, offset] = this.scroll.leaf(index + length);
            if (leaf == null) return null;
            [node, offset] = leaf.position(offset, true);
            range.setEnd(node, offset);
            return range.getBoundingClientRect();
        }
        let side = 'left';
        let rect;
        if (node instanceof Text) {
            // Return null if the text node is empty because it is
            // not able to get a useful client rect:
            // https://github.com/w3c/csswg-drafts/issues/2514.
            // Empty text nodes are most likely caused by TextBlot#optimize()
            // not getting called when editor content changes.
            if (!node.data.length) return null;
            if (offset < node.data.length) {
                range.setStart(node, offset);
                range.setEnd(node, offset + 1);
            } else {
                range.setStart(node, offset - 1);
                range.setEnd(node, offset);
                side = 'right';
            }
            rect = range.getBoundingClientRect();
        } else {
            if (!(leaf.domNode instanceof Element)) return null;
            rect = leaf.domNode.getBoundingClientRect();
            if (offset > 0) side = 'right';
        }
        return {
            bottom: rect.top + rect.height,
            height: rect.height,
            left: rect[side],
            right: rect[side],
            top: rect.top,
            width: 0
        };
    }
    getNativeRange() {
        const selection = document.getSelection();
        if (selection == null || selection.rangeCount <= 0) return null;
        const nativeRange = selection.getRangeAt(0);
        if (nativeRange == null) return null;
        const range = this.normalizeNative(nativeRange);
        $2a7fd1325c8b4c35$var$debug.info('getNativeRange', range);
        return range;
    }
    getRange() {
        const root = this.scroll.domNode;
        if ('isConnected' in root && !root.isConnected) // document.getSelection() forces layout on Blink, so we trend to
        // not calling it.
        return [
            null,
            null
        ];
        const normalized = this.getNativeRange();
        if (normalized == null) return [
            null,
            null
        ];
        const range = this.normalizedToRange(normalized);
        return [
            range,
            normalized
        ];
    }
    hasFocus() {
        return document.activeElement === this.root || document.activeElement != null && $2a7fd1325c8b4c35$var$contains(this.root, document.activeElement);
    }
    normalizedToRange(range) {
        const positions = [
            [
                range.start.node,
                range.start.offset
            ]
        ];
        if (!range.native.collapsed) positions.push([
            range.end.node,
            range.end.offset
        ]);
        const indexes = positions.map((position)=>{
            const [node, offset] = position;
            const blot = this.scroll.find(node, true);
            // @ts-expect-error Fix me later
            const index = blot.offset(this.scroll);
            if (offset === 0) return index;
            if (blot instanceof (0, $lHwOS.LeafBlot)) return index + blot.index(node, offset);
            // @ts-expect-error Fix me later
            return index + blot.length();
        });
        const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);
        const start = Math.min(end, ...indexes);
        return new $2a7fd1325c8b4c35$export$9a58ef0d7ad3278c(start, end - start);
    }
    normalizeNative(nativeRange) {
        if (!$2a7fd1325c8b4c35$var$contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !$2a7fd1325c8b4c35$var$contains(this.root, nativeRange.endContainer)) return null;
        const range = {
            start: {
                node: nativeRange.startContainer,
                offset: nativeRange.startOffset
            },
            end: {
                node: nativeRange.endContainer,
                offset: nativeRange.endOffset
            },
            native: nativeRange
        };
        [
            range.start,
            range.end
        ].forEach((position)=>{
            let { node: node, offset: offset } = position;
            while(!(node instanceof Text) && node.childNodes.length > 0){
                if (node.childNodes.length > offset) {
                    node = node.childNodes[offset];
                    offset = 0;
                } else if (node.childNodes.length === offset) {
                    // @ts-expect-error Fix me later
                    node = node.lastChild;
                    if (node instanceof Text) offset = node.data.length;
                    else if (node.childNodes.length > 0) // Container case
                    offset = node.childNodes.length;
                    else // Embed case
                    offset = node.childNodes.length + 1;
                } else break;
            }
            position.node = node;
            position.offset = offset;
        });
        return range;
    }
    rangeToNative(range) {
        const scrollLength = this.scroll.length();
        const getPosition = (index, inclusive)=>{
            index = Math.min(scrollLength - 1, index);
            const [leaf, leafOffset] = this.scroll.leaf(index);
            return leaf ? leaf.position(leafOffset, inclusive) : [
                null,
                -1
            ];
        };
        return [
            ...getPosition(range.index, false),
            ...getPosition(range.index + range.length, true)
        ];
    }
    setNativeRange(startNode, startOffset) {
        let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
        let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
        let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        $2a7fd1325c8b4c35$var$debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
        if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || // @ts-expect-error Fix me later
        endNode.parentNode == null)) return;
        const selection = document.getSelection();
        if (selection == null) return;
        if (startNode != null) {
            if (!this.hasFocus()) this.root.focus({
                preventScroll: true
            });
            const { native: native } = this.getNativeRange() || {};
            if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                if (startNode instanceof Element && startNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
                    startNode = startNode.parentNode;
                }
                if (endNode instanceof Element && endNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
                    endNode = endNode.parentNode;
                }
                const range = document.createRange();
                // @ts-expect-error Fix me later
                range.setStart(startNode, startOffset);
                // @ts-expect-error Fix me later
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        } else {
            selection.removeAllRanges();
            this.root.blur();
        }
    }
    setRange(range) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $jJqnr.default).sources.API;
        if (typeof force === 'string') {
            source = force;
            force = false;
        }
        $2a7fd1325c8b4c35$var$debug.info('setRange', range);
        if (range != null) {
            const args = this.rangeToNative(range);
            this.setNativeRange(...args, force);
        } else this.setNativeRange(null);
        this.update(source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $jJqnr.default).sources.USER;
        const oldRange = this.lastRange;
        const [lastRange, nativeRange] = this.getRange();
        this.lastRange = lastRange;
        this.lastNative = nativeRange;
        if (this.lastRange != null) this.savedRange = this.lastRange;
        if (!(0, $d7fWe.default)(oldRange, this.lastRange)) {
            if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                const range = this.cursor.restore();
                if (range) this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
            }
            const args = [
                (0, $jJqnr.default).events.SELECTION_CHANGE,
                (0, $kaYY4.default)(this.lastRange),
                (0, $kaYY4.default)(oldRange),
                source
            ];
            this.emitter.emit((0, $jJqnr.default).events.EDITOR_CHANGE, ...args);
            if (source !== (0, $jJqnr.default).sources.SILENT) this.emitter.emit(...args);
        }
    }
}
function $2a7fd1325c8b4c35$var$contains(parent, descendant) {
    try {
        // Firefox inserts inaccessible nodes around video elements
        descendant.parentNode; // eslint-disable-line @typescript-eslint/no-unused-expressions
    } catch (e) {
        return false;
    }
    return parent.contains(descendant);
}
var $2a7fd1325c8b4c35$export$2e2bcd8739ae039 = $2a7fd1325c8b4c35$var$Selection;

});
parcelRegister("jJqnr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d6ae3fc671a64c$export$2e2bcd8739ae039);

var $9DR0g = parcelRequire("9DR0g");

var $bp7pN = parcelRequire("bp7pN");

var $lkbqq = parcelRequire("lkbqq");
const $e5d6ae3fc671a64c$var$debug = (0, $lkbqq.default)('quill:events');
const $e5d6ae3fc671a64c$var$EVENTS = [
    'selectionchange',
    'mousedown',
    'mouseup',
    'click'
];
$e5d6ae3fc671a64c$var$EVENTS.forEach((eventName)=>{
    document.addEventListener(eventName, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        Array.from(document.querySelectorAll('.ql-container')).forEach((node)=>{
            const quill = (0, $bp7pN.default).get(node);
            if (quill && quill.emitter) quill.emitter.handleDOM(...args);
        });
    });
});
class $e5d6ae3fc671a64c$var$Emitter extends (0, $9DR0g.EventEmitter) {
    static events = {
        EDITOR_CHANGE: 'editor-change',
        SCROLL_BEFORE_UPDATE: 'scroll-before-update',
        SCROLL_BLOT_MOUNT: 'scroll-blot-mount',
        SCROLL_BLOT_UNMOUNT: 'scroll-blot-unmount',
        SCROLL_OPTIMIZE: 'scroll-optimize',
        SCROLL_UPDATE: 'scroll-update',
        SCROLL_EMBED_UPDATE: 'scroll-embed-update',
        SELECTION_CHANGE: 'selection-change',
        TEXT_CHANGE: 'text-change',
        COMPOSITION_BEFORE_START: 'composition-before-start',
        COMPOSITION_START: 'composition-start',
        COMPOSITION_BEFORE_END: 'composition-before-end',
        COMPOSITION_END: 'composition-end'
    };
    static sources = {
        API: 'api',
        SILENT: 'silent',
        USER: 'user'
    };
    constructor(){
        super();
        this.domListeners = {};
        this.on('error', $e5d6ae3fc671a64c$var$debug.error);
    }
    emit() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $e5d6ae3fc671a64c$var$debug.log.call($e5d6ae3fc671a64c$var$debug, ...args);
        // @ts-expect-error
        return super.emit(...args);
    }
    handleDOM(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        (this.domListeners[event.type] || []).forEach((_ref)=>{
            let { node: node, handler: handler } = _ref;
            if (event.target === node || node.contains(event.target)) handler(event, ...args);
        });
    }
    listenDOM(eventName, node, handler) {
        if (!this.domListeners[eventName]) this.domListeners[eventName] = [];
        this.domListeners[eventName].push({
            node: node,
            handler: handler
        });
    }
}
var $e5d6ae3fc671a64c$export$2e2bcd8739ae039 = $e5d6ae3fc671a64c$var$Emitter;

});
parcelRegister("9DR0g", function(module, exports) {
'use strict';
var $7050dee46d134475$var$has = Object.prototype.hasOwnProperty, $7050dee46d134475$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $7050dee46d134475$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $7050dee46d134475$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $7050dee46d134475$var$Events().__proto__) $7050dee46d134475$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $7050dee46d134475$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $7050dee46d134475$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $7050dee46d134475$var$EE(fn, context || emitter, once), evt = $7050dee46d134475$var$prefix ? $7050dee46d134475$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $7050dee46d134475$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $7050dee46d134475$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $7050dee46d134475$var$EventEmitter() {
    this._events = new $7050dee46d134475$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($7050dee46d134475$var$has.call(events, name)) names.push($7050dee46d134475$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $7050dee46d134475$var$prefix ? $7050dee46d134475$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $7050dee46d134475$var$prefix ? $7050dee46d134475$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $7050dee46d134475$var$prefix ? $7050dee46d134475$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $7050dee46d134475$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $7050dee46d134475$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $7050dee46d134475$var$prefix ? $7050dee46d134475$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $7050dee46d134475$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $7050dee46d134475$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $7050dee46d134475$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $7050dee46d134475$var$prefix ? $7050dee46d134475$var$prefix + event : event;
        if (this._events[evt]) $7050dee46d134475$var$clearEvent(this, evt);
    } else {
        this._events = new $7050dee46d134475$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$7050dee46d134475$var$EventEmitter.prototype.off = $7050dee46d134475$var$EventEmitter.prototype.removeListener;
$7050dee46d134475$var$EventEmitter.prototype.addListener = $7050dee46d134475$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$7050dee46d134475$var$EventEmitter.prefixed = $7050dee46d134475$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$7050dee46d134475$var$EventEmitter.EventEmitter = $7050dee46d134475$var$EventEmitter;
module.exports = $7050dee46d134475$var$EventEmitter;

});

parcelRegister("bp7pN", function(module, exports) {

$parcel$export(module.exports, "default", () => $84d7c7fe096604f2$export$2e2bcd8739ae039);
var $84d7c7fe096604f2$export$2e2bcd8739ae039 = new WeakMap();

});

parcelRegister("lkbqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f864540b2feddf9d$export$2e2bcd8739ae039);
const $f864540b2feddf9d$var$levels = [
    'error',
    'warn',
    'log',
    'info'
];
let $f864540b2feddf9d$var$level = 'warn';
function $f864540b2feddf9d$var$debug(method) {
    if ($f864540b2feddf9d$var$level) {
        if ($f864540b2feddf9d$var$levels.indexOf(method) <= $f864540b2feddf9d$var$levels.indexOf($f864540b2feddf9d$var$level)) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            console[method](...args); // eslint-disable-line no-console
        }
    }
}
function $f864540b2feddf9d$var$namespace(ns) {
    return $f864540b2feddf9d$var$levels.reduce((logger, method)=>{
        logger[method] = $f864540b2feddf9d$var$debug.bind(console, method, ns);
        return logger;
    }, {});
}
$f864540b2feddf9d$var$namespace.level = (newLevel)=>{
    $f864540b2feddf9d$var$level = newLevel;
};
$f864540b2feddf9d$var$debug.level = $f864540b2feddf9d$var$namespace.level;
var $f864540b2feddf9d$export$2e2bcd8739ae039 = $f864540b2feddf9d$var$namespace;

});




parcelRegister("5APNb", function(module, exports) {

$parcel$export(module.exports, "default", () => $41287d67a7596657$export$2e2bcd8739ae039);
class $41287d67a7596657$var$Module {
    static DEFAULTS = {};
    constructor(quill){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.quill = quill;
        this.options = options;
    }
}
var $41287d67a7596657$export$2e2bcd8739ae039 = $41287d67a7596657$var$Module;

});

parcelRegister("gjzF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $be0a1534024d898e$export$2e2bcd8739ae039);

var $9xp90 = parcelRequire("9xp90");

var $jJqnr = parcelRequire("jJqnr");
class $be0a1534024d898e$var$Composition {
    isComposing = false;
    constructor(scroll, emitter){
        this.scroll = scroll;
        this.emitter = emitter;
        this.setupListeners();
    }
    setupListeners() {
        this.scroll.domNode.addEventListener('compositionstart', (event)=>{
            if (!this.isComposing) this.handleCompositionStart(event);
        });
        this.scroll.domNode.addEventListener('compositionend', (event)=>{
            if (this.isComposing) // Webkit makes DOM changes after compositionend, so we use microtask to
            // ensure the order.
            // https://bugs.webkit.org/show_bug.cgi?id=31902
            queueMicrotask(()=>{
                this.handleCompositionEnd(event);
            });
        });
    }
    handleCompositionStart(event) {
        const blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
        if (blot && !(blot instanceof (0, $9xp90.default))) {
            this.emitter.emit((0, $jJqnr.default).events.COMPOSITION_BEFORE_START, event);
            this.scroll.batchStart();
            this.emitter.emit((0, $jJqnr.default).events.COMPOSITION_START, event);
            this.isComposing = true;
        }
    }
    handleCompositionEnd(event) {
        this.emitter.emit((0, $jJqnr.default).events.COMPOSITION_BEFORE_END, event);
        this.scroll.batchEnd();
        this.emitter.emit((0, $jJqnr.default).events.COMPOSITION_END, event);
        this.isComposing = false;
    }
}
var $be0a1534024d898e$export$2e2bcd8739ae039 = $be0a1534024d898e$var$Composition;

});
parcelRegister("9xp90", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f1ab34356e15cb9$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $bxVMH = parcelRequire("bxVMH");
const $6f1ab34356e15cb9$var$GUARD_TEXT = '\uFEFF';
class $6f1ab34356e15cb9$var$Embed extends (0, $lHwOS.EmbedBlot) {
    constructor(scroll, node){
        super(scroll, node);
        this.contentNode = document.createElement('span');
        this.contentNode.setAttribute('contenteditable', 'false');
        Array.from(this.domNode.childNodes).forEach((childNode)=>{
            this.contentNode.appendChild(childNode);
        });
        this.leftGuard = document.createTextNode($6f1ab34356e15cb9$var$GUARD_TEXT);
        this.rightGuard = document.createTextNode($6f1ab34356e15cb9$var$GUARD_TEXT);
        this.domNode.appendChild(this.leftGuard);
        this.domNode.appendChild(this.contentNode);
        this.domNode.appendChild(this.rightGuard);
    }
    index(node, offset) {
        if (node === this.leftGuard) return 0;
        if (node === this.rightGuard) return 1;
        return super.index(node, offset);
    }
    restore(node) {
        let range = null;
        let textNode;
        const text = node.data.split($6f1ab34356e15cb9$var$GUARD_TEXT).join('');
        if (node === this.leftGuard) {
            if (this.prev instanceof (0, $bxVMH.default)) {
                const prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                    startNode: this.prev.domNode,
                    startOffset: prevLength + text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        } else if (node === this.rightGuard) {
            if (this.next instanceof (0, $bxVMH.default)) {
                this.next.insertAt(0, text);
                range = {
                    startNode: this.next.domNode,
                    startOffset: text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this.next);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        }
        node.data = $6f1ab34356e15cb9$var$GUARD_TEXT;
        return range;
    }
    update(mutations, context) {
        mutations.forEach((mutation)=>{
            if (mutation.type === 'characterData' && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {
                const range = this.restore(mutation.target);
                if (range) context.range = range;
            }
        });
    }
}
var $6f1ab34356e15cb9$export$2e2bcd8739ae039 = $6f1ab34356e15cb9$var$Embed;

});


parcelRegister("c7e5N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d2111f23e262436$export$2e2bcd8739ae039);
class $8d2111f23e262436$var$Theme {
    static DEFAULTS = {
        modules: {}
    };
    static themes = {
        default: $8d2111f23e262436$var$Theme
    };
    modules = {};
    constructor(quill, options){
        this.quill = quill;
        this.options = options;
    }
    init() {
        Object.keys(this.options.modules).forEach((name)=>{
            if (this.modules[name] == null) this.addModule(name);
        });
    }
    addModule(name) {
        // @ts-expect-error
        const ModuleClass = this.quill.constructor.import(`modules/${name}`);
        this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});
        return this.modules[name];
    }
}
var $8d2111f23e262436$export$2e2bcd8739ae039 = $8d2111f23e262436$var$Theme;

});

parcelRegister("bb4Dz", function(module, exports) {

$parcel$export(module.exports, "default", () => $823451a7fecc8999$export$2e2bcd8739ae039);
const $823451a7fecc8999$var$getParentElement = (element)=>element.parentElement || element.getRootNode().host || null;
const $823451a7fecc8999$var$getElementRect = (element)=>{
    const rect = element.getBoundingClientRect();
    const scaleX = 'offsetWidth' in element && Math.abs(rect.width) / element.offsetWidth || 1;
    const scaleY = 'offsetHeight' in element && Math.abs(rect.height) / element.offsetHeight || 1;
    return {
        top: rect.top,
        right: rect.left + element.clientWidth * scaleX,
        bottom: rect.top + element.clientHeight * scaleY,
        left: rect.left
    };
};
const $823451a7fecc8999$var$paddingValueToInt = (value)=>{
    const number = parseInt(value, 10);
    return Number.isNaN(number) ? 0 : number;
};
// Follow the steps described in https://www.w3.org/TR/cssom-view-1/#element-scrolling-members,
// assuming that the scroll option is set to 'nearest'.
const $823451a7fecc8999$var$getScrollDistance = (targetStart, targetEnd, scrollStart, scrollEnd, scrollPaddingStart, scrollPaddingEnd)=>{
    if (targetStart < scrollStart && targetEnd > scrollEnd) return 0;
    if (targetStart < scrollStart) return -(scrollStart - targetStart + scrollPaddingStart);
    if (targetEnd > scrollEnd) return targetEnd - targetStart > scrollEnd - scrollStart ? targetStart + scrollPaddingStart - scrollStart : targetEnd - scrollEnd + scrollPaddingEnd;
    return 0;
};
const $823451a7fecc8999$var$scrollRectIntoView = (root, targetRect)=>{
    const document = root.ownerDocument;
    let rect = targetRect;
    let current = root;
    while(current){
        const isDocumentBody = current === document.body;
        const bounding = isDocumentBody ? {
            top: 0,
            right: window.visualViewport?.width ?? document.documentElement.clientWidth,
            bottom: window.visualViewport?.height ?? document.documentElement.clientHeight,
            left: 0
        } : $823451a7fecc8999$var$getElementRect(current);
        const style = getComputedStyle(current);
        const scrollDistanceX = $823451a7fecc8999$var$getScrollDistance(rect.left, rect.right, bounding.left, bounding.right, $823451a7fecc8999$var$paddingValueToInt(style.scrollPaddingLeft), $823451a7fecc8999$var$paddingValueToInt(style.scrollPaddingRight));
        const scrollDistanceY = $823451a7fecc8999$var$getScrollDistance(rect.top, rect.bottom, bounding.top, bounding.bottom, $823451a7fecc8999$var$paddingValueToInt(style.scrollPaddingTop), $823451a7fecc8999$var$paddingValueToInt(style.scrollPaddingBottom));
        if (scrollDistanceX || scrollDistanceY) {
            if (isDocumentBody) document.defaultView?.scrollBy(scrollDistanceX, scrollDistanceY);
            else {
                const { scrollLeft: scrollLeft, scrollTop: scrollTop } = current;
                if (scrollDistanceY) current.scrollTop += scrollDistanceY;
                if (scrollDistanceX) current.scrollLeft += scrollDistanceX;
                const scrolledLeft = current.scrollLeft - scrollLeft;
                const scrolledTop = current.scrollTop - scrollTop;
                rect = {
                    left: rect.left - scrolledLeft,
                    top: rect.top - scrolledTop,
                    right: rect.right - scrolledLeft,
                    bottom: rect.bottom - scrolledTop
                };
            }
        }
        current = isDocumentBody || style.position === 'fixed' ? null : $823451a7fecc8999$var$getParentElement(current);
    }
};
var $823451a7fecc8999$export$2e2bcd8739ae039 = $823451a7fecc8999$var$scrollRectIntoView;

});

parcelRegister("f3rcF", function(module, exports) {

$parcel$export(module.exports, "default", () => $af5c3cdcba8d8c24$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");
const $af5c3cdcba8d8c24$var$MAX_REGISTER_ITERATIONS = 100;
const $af5c3cdcba8d8c24$var$CORE_FORMATS = [
    'block',
    'break',
    'cursor',
    'inline',
    'scroll',
    'text'
];
const $af5c3cdcba8d8c24$var$createRegistryWithFormats = (formats, sourceRegistry, debug)=>{
    const registry = new (0, $lHwOS.Registry)();
    $af5c3cdcba8d8c24$var$CORE_FORMATS.forEach((name)=>{
        const coreBlot = sourceRegistry.query(name);
        if (coreBlot) registry.register(coreBlot);
    });
    formats.forEach((name)=>{
        let format = sourceRegistry.query(name);
        if (!format) debug.error(`Cannot register "${name}" specified in "formats" config. Are you sure it was registered?`);
        let iterations = 0;
        while(format){
            registry.register(format);
            format = 'blotName' in format ? format.requiredContainer ?? null : null;
            iterations += 1;
            if (iterations > $af5c3cdcba8d8c24$var$MAX_REGISTER_ITERATIONS) {
                debug.error(`Cycle detected in registering blot requiredContainer: "${name}"`);
                break;
            }
        }
    });
    return registry;
};
var $af5c3cdcba8d8c24$export$2e2bcd8739ae039 = $af5c3cdcba8d8c24$var$createRegistryWithFormats;

});


parcelRegister("em4Pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a736dcfb1334b50a$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");
class $a736dcfb1334b50a$var$Container extends (0, $lHwOS.ContainerBlot) {
}
var $a736dcfb1334b50a$export$2e2bcd8739ae039 = $a736dcfb1334b50a$var$Container;

});

parcelRegister("03ycQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0002c14cbd5a5c37$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $kEXGb = parcelRequire("kEXGb");

var $jJqnr = parcelRequire("jJqnr");

var $fp1Tt = parcelRequire("fp1Tt");

var $bmwCM = parcelRequire("bmwCM");

var $em4Pe = parcelRequire("em4Pe");
function $0002c14cbd5a5c37$var$isLine(blot) {
    return blot instanceof (0, $fp1Tt.default) || blot instanceof (0, $fp1Tt.BlockEmbed);
}
function $0002c14cbd5a5c37$var$isUpdatable(blot) {
    return typeof blot.updateContent === 'function';
}
class $0002c14cbd5a5c37$var$Scroll extends (0, $lHwOS.ScrollBlot) {
    static blotName = 'scroll';
    static className = 'ql-editor';
    static tagName = 'DIV';
    static defaultChild = (0, $fp1Tt.default);
    static allowedChildren = [
        (0, $fp1Tt.default),
        (0, $fp1Tt.BlockEmbed),
        (0, $em4Pe.default)
    ];
    constructor(registry, domNode, _ref){
        let { emitter: emitter } = _ref;
        super(registry, domNode);
        this.emitter = emitter;
        this.batch = false;
        this.optimize();
        this.enable();
        this.domNode.addEventListener('dragstart', (e)=>this.handleDragStart(e));
    }
    batchStart() {
        if (!Array.isArray(this.batch)) this.batch = [];
    }
    batchEnd() {
        if (!this.batch) return;
        const mutations = this.batch;
        this.batch = false;
        this.update(mutations);
    }
    emitMount(blot) {
        this.emitter.emit((0, $jJqnr.default).events.SCROLL_BLOT_MOUNT, blot);
    }
    emitUnmount(blot) {
        this.emitter.emit((0, $jJqnr.default).events.SCROLL_BLOT_UNMOUNT, blot);
    }
    emitEmbedUpdate(blot, change) {
        this.emitter.emit((0, $jJqnr.default).events.SCROLL_EMBED_UPDATE, blot, change);
    }
    deleteAt(index, length) {
        const [first, offset] = this.line(index);
        const [last] = this.line(index + length);
        super.deleteAt(index, length);
        if (last != null && first !== last && offset > 0) {
            if (first instanceof (0, $fp1Tt.BlockEmbed) || last instanceof (0, $fp1Tt.BlockEmbed)) {
                this.optimize();
                return;
            }
            const ref = last.children.head instanceof (0, $bmwCM.default) ? null : last.children.head;
            // @ts-expect-error
            first.moveChildren(last, ref);
            // @ts-expect-error
            first.remove();
        }
        this.optimize();
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.domNode.setAttribute('contenteditable', enabled ? 'true' : 'false');
    }
    formatAt(index, length, format, value) {
        super.formatAt(index, length, format, value);
        this.optimize();
    }
    insertAt(index, value, def) {
        if (index >= this.length()) {
            if (def == null || this.scroll.query(value, (0, $lHwOS.Scope).BLOCK) == null) {
                const blot = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(blot);
                if (def == null && value.endsWith('\n')) blot.insertAt(0, value.slice(0, -1), def);
                else blot.insertAt(0, value, def);
            } else {
                const embed = this.scroll.create(value, def);
                this.appendChild(embed);
            }
        } else super.insertAt(index, value, def);
        this.optimize();
    }
    insertBefore(blot, ref) {
        if (blot.statics.scope === (0, $lHwOS.Scope).INLINE_BLOT) {
            const wrapper = this.scroll.create(this.statics.defaultChild.blotName);
            wrapper.appendChild(blot);
            super.insertBefore(wrapper, ref);
        } else super.insertBefore(blot, ref);
    }
    insertContents(index, delta) {
        const renderBlocks = this.deltaToRenderBlocks(delta.concat(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert('\n')));
        const last = renderBlocks.pop();
        if (last == null) return;
        this.batchStart();
        const first = renderBlocks.shift();
        if (first) {
            const shouldInsertNewlineChar = first.type === 'block' && (first.delta.length() === 0 || !this.descendant((0, $fp1Tt.BlockEmbed), index)[0] && index < this.length());
            const delta = first.type === 'block' ? first.delta : new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert({
                [first.key]: first.value
            });
            $0002c14cbd5a5c37$var$insertInlineContents(this, index, delta);
            const newlineCharLength = first.type === 'block' ? 1 : 0;
            const lineEndIndex = index + delta.length() + newlineCharLength;
            if (shouldInsertNewlineChar) this.insertAt(lineEndIndex - 1, '\n');
            const formats = (0, $fp1Tt.bubbleFormats)(this.line(index)[0]);
            const attributes = (0, $kEXGb.AttributeMap).diff(formats, first.attributes) || {};
            Object.keys(attributes).forEach((name)=>{
                this.formatAt(lineEndIndex - 1, 1, name, attributes[name]);
            });
            index = lineEndIndex;
        }
        let [refBlot, refBlotOffset] = this.children.find(index);
        if (renderBlocks.length) {
            if (refBlot) {
                refBlot = refBlot.split(refBlotOffset);
                refBlotOffset = 0;
            }
            renderBlocks.forEach((renderBlock)=>{
                if (renderBlock.type === 'block') {
                    const block = this.createBlock(renderBlock.attributes, refBlot || undefined);
                    $0002c14cbd5a5c37$var$insertInlineContents(block, 0, renderBlock.delta);
                } else {
                    const blockEmbed = this.create(renderBlock.key, renderBlock.value);
                    this.insertBefore(blockEmbed, refBlot || undefined);
                    Object.keys(renderBlock.attributes).forEach((name)=>{
                        blockEmbed.format(name, renderBlock.attributes[name]);
                    });
                }
            });
        }
        if (last.type === 'block' && last.delta.length()) {
            const offset = refBlot ? refBlot.offset(refBlot.scroll) + refBlotOffset : this.length();
            $0002c14cbd5a5c37$var$insertInlineContents(this, offset, last.delta);
        }
        this.batchEnd();
        this.optimize();
    }
    isEnabled() {
        return this.domNode.getAttribute('contenteditable') === 'true';
    }
    leaf(index) {
        const last = this.path(index).pop();
        if (!last) return [
            null,
            -1
        ];
        const [blot, offset] = last;
        return blot instanceof (0, $lHwOS.LeafBlot) ? [
            blot,
            offset
        ] : [
            null,
            -1
        ];
    }
    line(index) {
        if (index === this.length()) return this.line(index - 1);
        // @ts-expect-error TODO: make descendant() generic
        return this.descendant($0002c14cbd5a5c37$var$isLine, index);
    }
    lines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        const getLines = (blot, blotIndex, blotLength)=>{
            let lines = [];
            let lengthLeft = blotLength;
            blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength)=>{
                if ($0002c14cbd5a5c37$var$isLine(child)) lines.push(child);
                else if (child instanceof (0, $lHwOS.ContainerBlot)) lines = lines.concat(getLines(child, childIndex, lengthLeft));
                lengthLeft -= childLength;
            });
            return lines;
        };
        return getLines(this, index, length);
    }
    optimize() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.batch) return;
        super.optimize(mutations, context);
        if (mutations.length > 0) this.emitter.emit((0, $jJqnr.default).events.SCROLL_OPTIMIZE, mutations, context);
    }
    path(index) {
        return super.path(index).slice(1); // Exclude self
    }
    remove() {
    // Never remove self
    }
    update(mutations) {
        if (this.batch) {
            if (Array.isArray(mutations)) this.batch = this.batch.concat(mutations);
            return;
        }
        let source = (0, $jJqnr.default).sources.USER;
        if (typeof mutations === 'string') source = mutations;
        if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
        mutations = mutations.filter((_ref2)=>{
            let { target: target } = _ref2;
            const blot = this.find(target, true);
            return blot && !$0002c14cbd5a5c37$var$isUpdatable(blot);
        });
        if (mutations.length > 0) this.emitter.emit((0, $jJqnr.default).events.SCROLL_BEFORE_UPDATE, source, mutations);
        super.update(mutations.concat([])); // pass copy
        if (mutations.length > 0) this.emitter.emit((0, $jJqnr.default).events.SCROLL_UPDATE, source, mutations);
    }
    updateEmbedAt(index, key, change) {
        // Currently it only supports top-level embeds (BlockEmbed).
        // We can update `ParentBlot` in parchment to support inline embeds.
        const [blot] = this.descendant((b)=>b instanceof (0, $fp1Tt.BlockEmbed), index);
        if (blot && blot.statics.blotName === key && $0002c14cbd5a5c37$var$isUpdatable(blot)) blot.updateContent(change);
    }
    handleDragStart(event) {
        event.preventDefault();
    }
    deltaToRenderBlocks(delta) {
        const renderBlocks = [];
        let currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
        delta.forEach((op)=>{
            const insert = op?.insert;
            if (!insert) return;
            if (typeof insert === 'string') {
                const splitted = insert.split('\n');
                splitted.slice(0, -1).forEach((text)=>{
                    currentBlockDelta.insert(text, op.attributes);
                    renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: op.attributes ?? {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
                });
                const last = splitted[splitted.length - 1];
                if (last) currentBlockDelta.insert(last, op.attributes);
            } else {
                const key = Object.keys(insert)[0];
                if (!key) return;
                if (this.query(key, (0, $lHwOS.Scope).INLINE)) currentBlockDelta.push(op);
                else {
                    if (currentBlockDelta.length()) renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
                    renderBlocks.push({
                        type: 'blockEmbed',
                        key: key,
                        value: insert[key],
                        attributes: op.attributes ?? {}
                    });
                }
            }
        });
        if (currentBlockDelta.length()) renderBlocks.push({
            type: 'block',
            delta: currentBlockDelta,
            attributes: {}
        });
        return renderBlocks;
    }
    createBlock(attributes, refBlot) {
        let blotName;
        const formats = {};
        Object.entries(attributes).forEach((_ref3)=>{
            let [key, value] = _ref3;
            const isBlockBlot = this.query(key, (0, $lHwOS.Scope).BLOCK & (0, $lHwOS.Scope).BLOT) != null;
            if (isBlockBlot) blotName = key;
            else formats[key] = value;
        });
        const block = this.create(blotName || this.statics.defaultChild.blotName, blotName ? attributes[blotName] : undefined);
        this.insertBefore(block, refBlot || undefined);
        const length = block.length();
        Object.entries(formats).forEach((_ref4)=>{
            let [key, value] = _ref4;
            block.formatAt(0, length, key, value);
        });
        return block;
    }
}
function $0002c14cbd5a5c37$var$insertInlineContents(parent, index, inlineContents) {
    inlineContents.reduce((index, op)=>{
        const length = (0, $kEXGb.Op).length(op);
        let attributes = op.attributes || {};
        if (op.insert != null) {
            if (typeof op.insert === 'string') {
                const text = op.insert;
                parent.insertAt(index, text);
                const [leaf] = parent.descendant((0, $lHwOS.LeafBlot), index);
                const formats = (0, $fp1Tt.bubbleFormats)(leaf);
                attributes = (0, $kEXGb.AttributeMap).diff(formats, attributes) || {};
            } else if (typeof op.insert === 'object') {
                const key = Object.keys(op.insert)[0]; // There should only be one key
                if (key == null) return index;
                parent.insertAt(index, key, op.insert[key]);
                const isInlineEmbed = parent.scroll.query(key, (0, $lHwOS.Scope).INLINE) != null;
                if (isInlineEmbed) {
                    const [leaf] = parent.descendant((0, $lHwOS.LeafBlot), index);
                    const formats = (0, $fp1Tt.bubbleFormats)(leaf);
                    attributes = (0, $kEXGb.AttributeMap).diff(formats, attributes) || {};
                }
            }
        }
        Object.keys(attributes).forEach((key)=>{
            parent.formatAt(index, length, key, attributes[key]);
        });
        return index + length;
    }, index);
}
var $0002c14cbd5a5c37$export$2e2bcd8739ae039 = $0002c14cbd5a5c37$var$Scroll;

});

parcelRegister("lkNmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f881c0971119051e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "traverse", () => $f881c0971119051e$export$df3f009e3d155b20);

var $lHwOS = parcelRequire("lHwOS");

var $kEXGb = parcelRequire("kEXGb");

var $fp1Tt = parcelRequire("fp1Tt");

var $lkbqq = parcelRequire("lkbqq");

var $5APNb = parcelRequire("5APNb");

var $lcQXp = parcelRequire("lcQXp");

var $dFEOL = parcelRequire("dFEOL");

var $5BkkP = parcelRequire("5BkkP");

var $gwsDR = parcelRequire("gwsDR");

var $4x8BI = parcelRequire("4x8BI");

var $iWFzb = parcelRequire("iWFzb");

var $kvjOh = parcelRequire("kvjOh");

var $jI3be = parcelRequire("jI3be");

var $lRlaz = parcelRequire("lRlaz");

var $fYOV4 = parcelRequire("fYOV4");
const $f881c0971119051e$var$debug = (0, $lkbqq.default)('quill:clipboard');
const $f881c0971119051e$var$CLIPBOARD_CONFIG = [
    [
        Node.TEXT_NODE,
        $f881c0971119051e$export$9b884371b5570711
    ],
    [
        Node.TEXT_NODE,
        $f881c0971119051e$export$c695b9637111f586
    ],
    [
        'br',
        $f881c0971119051e$var$matchBreak
    ],
    [
        Node.ELEMENT_NODE,
        $f881c0971119051e$export$c695b9637111f586
    ],
    [
        Node.ELEMENT_NODE,
        $f881c0971119051e$export$e9719de873a22c03
    ],
    [
        Node.ELEMENT_NODE,
        $f881c0971119051e$export$7da59a717dc94488
    ],
    [
        Node.ELEMENT_NODE,
        $f881c0971119051e$var$matchStyles
    ],
    [
        'li',
        $f881c0971119051e$var$matchIndent
    ],
    [
        'ol, ul',
        $f881c0971119051e$var$matchList
    ],
    [
        'pre',
        $f881c0971119051e$var$matchCodeBlock
    ],
    [
        'tr',
        $f881c0971119051e$var$matchTable
    ],
    [
        'b',
        $f881c0971119051e$var$createMatchAlias('bold')
    ],
    [
        'i',
        $f881c0971119051e$var$createMatchAlias('italic')
    ],
    [
        'strike',
        $f881c0971119051e$var$createMatchAlias('strike')
    ],
    [
        'style',
        $f881c0971119051e$var$matchIgnore
    ]
];
const $f881c0971119051e$var$ATTRIBUTE_ATTRIBUTORS = [
    (0, $dFEOL.AlignAttribute),
    (0, $iWFzb.DirectionAttribute)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
const $f881c0971119051e$var$STYLE_ATTRIBUTORS = [
    (0, $dFEOL.AlignStyle),
    (0, $5BkkP.BackgroundStyle),
    (0, $4x8BI.ColorStyle),
    (0, $iWFzb.DirectionStyle),
    (0, $kvjOh.FontStyle),
    (0, $jI3be.SizeStyle)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
class $f881c0971119051e$export$2e2bcd8739ae039 extends (0, $5APNb.default) {
    static DEFAULTS = {
        matchers: []
    };
    constructor(quill, options){
        super(quill, options);
        this.quill.root.addEventListener('copy', (e)=>this.onCaptureCopy(e, false));
        this.quill.root.addEventListener('cut', (e)=>this.onCaptureCopy(e, true));
        this.quill.root.addEventListener('paste', this.onCapturePaste.bind(this));
        this.matchers = [];
        $f881c0971119051e$var$CLIPBOARD_CONFIG.concat(this.options.matchers ?? []).forEach((_ref)=>{
            let [selector, matcher] = _ref;
            this.addMatcher(selector, matcher);
        });
    }
    addMatcher(selector, matcher) {
        this.matchers.push([
            selector,
            matcher
        ]);
    }
    convert(_ref2) {
        let { html: html, text: text } = _ref2;
        let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (formats[(0, $gwsDR.default).blotName]) return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(text || '', {
            [(0, $gwsDR.default).blotName]: formats[(0, $gwsDR.default).blotName]
        });
        if (!html) return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(text || '', formats);
        const delta = this.convertHTML(html);
        // Remove trailing newline
        if ($f881c0971119051e$var$deltaEndsWith(delta, '\n') && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(delta.length() - 1).delete(1));
        return delta;
    }
    normalizeHTML(doc) {
        (0, $fYOV4.default)(doc);
    }
    convertHTML(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.normalizeHTML(doc);
        const container = doc.body;
        const nodeMatches = new WeakMap();
        const [elementMatchers, textMatchers] = this.prepareMatching(container, nodeMatches);
        return $f881c0971119051e$export$df3f009e3d155b20(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches);
    }
    dangerouslyPasteHTML(index, html) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $lcQXp.default).sources.API;
        if (typeof index === 'string') {
            const delta = this.convert({
                html: index,
                text: ''
            });
            // @ts-expect-error
            this.quill.setContents(delta, html);
            this.quill.setSelection(0, (0, $lcQXp.default).sources.SILENT);
        } else {
            const paste = this.convert({
                html: html,
                text: ''
            });
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).concat(paste), source);
            this.quill.setSelection(index + paste.length(), (0, $lcQXp.default).sources.SILENT);
        }
    }
    onCaptureCopy(e) {
        let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (e.defaultPrevented) return;
        e.preventDefault();
        const [range] = this.quill.selection.getRange();
        if (range == null) return;
        const { html: html, text: text } = this.onCopy(range, isCut);
        e.clipboardData?.setData('text/plain', text);
        e.clipboardData?.setData('text/html', html);
        if (isCut) (0, $lRlaz.deleteRange)({
            range: range,
            quill: this.quill
        });
    }
    /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */ normalizeURIList(urlList) {
        return urlList.split(/\r?\n/)// Ignore all comments
        .filter((url)=>url[0] !== '#').join('\n');
    }
    onCapturePaste(e) {
        if (e.defaultPrevented || !this.quill.isEnabled()) return;
        e.preventDefault();
        const range = this.quill.getSelection(true);
        if (range == null) return;
        const html = e.clipboardData?.getData('text/html');
        let text = e.clipboardData?.getData('text/plain');
        if (!html && !text) {
            const urlList = e.clipboardData?.getData('text/uri-list');
            if (urlList) text = this.normalizeURIList(urlList);
        }
        const files = Array.from(e.clipboardData?.files || []);
        if (!html && files.length > 0) {
            this.quill.uploader.upload(range, files);
            return;
        }
        if (html && files.length > 0) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            if (doc.body.childElementCount === 1 && doc.body.firstElementChild?.tagName === 'IMG') {
                this.quill.uploader.upload(range, files);
                return;
            }
        }
        this.onPaste(range, {
            html: html,
            text: text
        });
    }
    onCopy(range) {
        const text = this.quill.getText(range);
        const html = this.quill.getSemanticHTML(range);
        return {
            html: html,
            text: text
        };
    }
    onPaste(range, _ref3) {
        let { text: text, html: html } = _ref3;
        const formats = this.quill.getFormat(range.index);
        const pastedDelta = this.convert({
            text: text,
            html: html
        }, formats);
        $f881c0971119051e$var$debug.log('onPaste', pastedDelta, {
            text: text,
            html: html
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).delete(range.length).concat(pastedDelta);
        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
        // range.length contributes to delta.length()
        this.quill.setSelection(delta.length() - range.length, (0, $lcQXp.default).sources.SILENT);
        this.quill.scrollSelectionIntoView();
    }
    prepareMatching(container, nodeMatches) {
        const elementMatchers = [];
        const textMatchers = [];
        this.matchers.forEach((pair)=>{
            const [selector, matcher] = pair;
            switch(selector){
                case Node.TEXT_NODE:
                    textMatchers.push(matcher);
                    break;
                case Node.ELEMENT_NODE:
                    elementMatchers.push(matcher);
                    break;
                default:
                    Array.from(container.querySelectorAll(selector)).forEach((node)=>{
                        if (nodeMatches.has(node)) {
                            const matches = nodeMatches.get(node);
                            matches?.push(matcher);
                        } else nodeMatches.set(node, [
                            matcher
                        ]);
                    });
                    break;
            }
        });
        return [
            elementMatchers,
            textMatchers
        ];
    }
}
function $f881c0971119051e$var$applyFormat(delta, format, value, scroll) {
    if (!scroll.query(format)) return delta;
    return delta.reduce((newDelta, op)=>{
        if (!op.insert) return newDelta;
        if (op.attributes && op.attributes[format]) return newDelta.push(op);
        const formats = value ? {
            [format]: value
        } : {};
        return newDelta.insert(op.insert, {
            ...formats,
            ...op.attributes
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
}
function $f881c0971119051e$var$deltaEndsWith(delta, text) {
    let endText = '';
    for(let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus
    ){
        const op = delta.ops[i];
        if (typeof op.insert !== 'string') break;
        endText = op.insert + endText;
    }
    return endText.slice(-1 * text.length) === text;
}
function $f881c0971119051e$var$isLine(node, scroll) {
    if (!(node instanceof Element)) return false;
    const match = scroll.query(node);
    // @ts-expect-error
    if (match && match.prototype instanceof (0, $lHwOS.EmbedBlot)) return false;
    return [
        'address',
        'article',
        'blockquote',
        'canvas',
        'dd',
        'div',
        'dl',
        'dt',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'header',
        'iframe',
        'li',
        'main',
        'nav',
        'ol',
        'output',
        'p',
        'pre',
        'section',
        'table',
        'td',
        'tr',
        'ul',
        'video'
    ].includes(node.tagName.toLowerCase());
}
function $f881c0971119051e$var$isBetweenInlineElements(node, scroll) {
    return node.previousElementSibling && node.nextElementSibling && !$f881c0971119051e$var$isLine(node.previousElementSibling, scroll) && !$f881c0971119051e$var$isLine(node.nextElementSibling, scroll);
}
const $f881c0971119051e$var$preNodes = new WeakMap();
function $f881c0971119051e$var$isPre(node) {
    if (node == null) return false;
    if (!$f881c0971119051e$var$preNodes.has(node)) {
        // @ts-expect-error
        if (node.tagName === 'PRE') $f881c0971119051e$var$preNodes.set(node, true);
        else $f881c0971119051e$var$preNodes.set(node, $f881c0971119051e$var$isPre(node.parentNode));
    }
    return $f881c0971119051e$var$preNodes.get(node);
}
function $f881c0971119051e$export$df3f009e3d155b20(scroll, node, elementMatchers, textMatchers, nodeMatches) {
    // Post-order
    if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce((delta, matcher)=>{
        return matcher(node, delta, scroll);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
    if (node.nodeType === node.ELEMENT_NODE) return Array.from(node.childNodes || []).reduce((delta, childNode)=>{
        let childrenDelta = $f881c0971119051e$export$df3f009e3d155b20(scroll, childNode, elementMatchers, textMatchers, nodeMatches);
        if (childNode.nodeType === node.ELEMENT_NODE) {
            childrenDelta = elementMatchers.reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
            childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
        }
        return delta.concat(childrenDelta);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
}
function $f881c0971119051e$var$createMatchAlias(format) {
    return (_node, delta, scroll)=>{
        return $f881c0971119051e$var$applyFormat(delta, format, true, scroll);
    };
}
function $f881c0971119051e$export$7da59a717dc94488(node, delta, scroll) {
    const attributes = (0, $lHwOS.Attributor).keys(node);
    const classes = (0, $lHwOS.ClassAttributor).keys(node);
    const styles = (0, $lHwOS.StyleAttributor).keys(node);
    const formats = {};
    attributes.concat(classes).concat(styles).forEach((name)=>{
        let attr = scroll.query(name, (0, $lHwOS.Scope).ATTRIBUTE);
        if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
        }
        attr = $f881c0971119051e$var$ATTRIBUTE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
        attr = $f881c0971119051e$var$STYLE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            attr = $f881c0971119051e$var$STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
        }
    });
    return Object.entries(formats).reduce((newDelta, _ref4)=>{
        let [name, value] = _ref4;
        return $f881c0971119051e$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
}
function $f881c0971119051e$export$e9719de873a22c03(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null) return delta;
    // @ts-expect-error
    if (match.prototype instanceof (0, $lHwOS.EmbedBlot)) {
        const embed = {};
        // @ts-expect-error
        const value = match.value(node);
        if (value != null) {
            // @ts-expect-error
            embed[match.blotName] = value;
            // @ts-expect-error
            return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(embed, match.formats(node, scroll));
        }
    } else {
        // @ts-expect-error
        if (match.prototype instanceof (0, $lHwOS.BlockBlot) && !$f881c0971119051e$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
        if ('blotName' in match && 'formats' in match && typeof match.formats === 'function') return $f881c0971119051e$var$applyFormat(delta, match.blotName, match.formats(node, scroll), scroll);
    }
    return delta;
}
function $f881c0971119051e$var$matchBreak(node, delta) {
    if (!$f881c0971119051e$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
    return delta;
}
function $f881c0971119051e$var$matchCodeBlock(node, delta, scroll) {
    const match = scroll.query('code-block');
    const language = match && 'formats' in match && typeof match.formats === 'function' ? match.formats(node, scroll) : true;
    return $f881c0971119051e$var$applyFormat(delta, 'code-block', language, scroll);
}
function $f881c0971119051e$var$matchIgnore() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
}
function $f881c0971119051e$var$matchIndent(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null || // @ts-expect-error
    match.blotName !== 'list' || !$f881c0971119051e$var$deltaEndsWith(delta, '\n')) return delta;
    let indent = -1;
    let parent = node.parentNode;
    while(parent != null){
        // @ts-expect-error
        if ([
            'OL',
            'UL'
        ].includes(parent.tagName)) indent += 1;
        parent = parent.parentNode;
    }
    if (indent <= 0) return delta;
    return delta.reduce((composed, op)=>{
        if (!op.insert) return composed;
        if (op.attributes && typeof op.attributes.indent === 'number') return composed.push(op);
        return composed.insert(op.insert, {
            indent: indent,
            ...op.attributes || {}
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
}
function $f881c0971119051e$var$matchList(node, delta, scroll) {
    const element = node;
    let list = element.tagName === 'OL' ? 'ordered' : 'bullet';
    const checkedAttr = element.getAttribute('data-checked');
    if (checkedAttr) list = checkedAttr === 'true' ? 'checked' : 'unchecked';
    return $f881c0971119051e$var$applyFormat(delta, 'list', list, scroll);
}
function $f881c0971119051e$export$c695b9637111f586(node, delta, scroll) {
    if (!$f881c0971119051e$var$deltaEndsWith(delta, '\n')) {
        if ($f881c0971119051e$var$isLine(node, scroll) && (node.childNodes.length > 0 || node instanceof HTMLParagraphElement)) return delta.insert('\n');
        if (delta.length() > 0 && node.nextSibling) {
            let nextSibling = node.nextSibling;
            while(nextSibling != null){
                if ($f881c0971119051e$var$isLine(nextSibling, scroll)) return delta.insert('\n');
                const match = scroll.query(nextSibling);
                // @ts-expect-error
                if (match && match.prototype instanceof (0, $fp1Tt.BlockEmbed)) return delta.insert('\n');
                nextSibling = nextSibling.firstChild;
            }
        }
    }
    return delta;
}
function $f881c0971119051e$var$matchStyles(node, delta, scroll) {
    const formats = {};
    const style = node.style || {};
    if (style.fontStyle === 'italic') formats.italic = true;
    if (style.textDecoration === 'underline') formats.underline = true;
    if (style.textDecoration === 'line-through') formats.strike = true;
    if (style.fontWeight?.startsWith('bold') || // @ts-expect-error Fix me later
    parseInt(style.fontWeight, 10) >= 700) formats.bold = true;
    delta = Object.entries(formats).reduce((newDelta, _ref5)=>{
        let [name, value] = _ref5;
        return $f881c0971119051e$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
    // @ts-expect-error
    if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert('\t').concat(delta);
    return delta;
}
function $f881c0971119051e$var$matchTable(node, delta, scroll) {
    const table = node.parentElement?.tagName === 'TABLE' ? node.parentElement : node.parentElement?.parentElement;
    if (table != null) {
        const rows = Array.from(table.querySelectorAll('tr'));
        const row = rows.indexOf(node) + 1;
        return $f881c0971119051e$var$applyFormat(delta, 'table', row, scroll);
    }
    return delta;
}
function $f881c0971119051e$export$9b884371b5570711(node, delta, scroll) {
    // @ts-expect-error
    let text = node.data;
    // Word represents empty line with <o:p>&nbsp;</o:p>
    if (node.parentElement?.tagName === 'O:P') return delta.insert(text.trim());
    if (!$f881c0971119051e$var$isPre(node)) {
        if (text.trim().length === 0 && text.includes('\n') && !$f881c0971119051e$var$isBetweenInlineElements(node, scroll)) return delta;
        // convert all non-nbsp whitespace into regular space
        text = text.replace(/[^\S\u00a0]/g, ' ');
        // collapse consecutive spaces into one
        text = text.replace(/ {2,}/g, ' ');
        if (node.previousSibling == null && node.parentElement != null && $f881c0971119051e$var$isLine(node.parentElement, scroll) || node.previousSibling instanceof Element && $f881c0971119051e$var$isLine(node.previousSibling, scroll)) // block structure means we don't need leading space
        text = text.replace(/^ /, '');
        if (node.nextSibling == null && node.parentElement != null && $f881c0971119051e$var$isLine(node.parentElement, scroll) || node.nextSibling instanceof Element && $f881c0971119051e$var$isLine(node.nextSibling, scroll)) // block structure means we don't need trailing space
        text = text.replace(/ $/, '');
        // done removing whitespace and can normalize all to regular space
        text = text.replaceAll('\u00a0', ' ');
    }
    return delta.insert(text);
}

});
parcelRegister("dFEOL", function(module, exports) {

$parcel$export(module.exports, "AlignAttribute", () => $9f3ec447b9925575$export$2ef0f9fb04a51388);
$parcel$export(module.exports, "AlignClass", () => $9f3ec447b9925575$export$7f3685f5846c07da);
$parcel$export(module.exports, "AlignStyle", () => $9f3ec447b9925575$export$d2060f5d114c9fe8);

var $lHwOS = parcelRequire("lHwOS");
const $9f3ec447b9925575$var$config = {
    scope: (0, $lHwOS.Scope).BLOCK,
    whitelist: [
        'right',
        'center',
        'justify'
    ]
};
const $9f3ec447b9925575$export$2ef0f9fb04a51388 = new (0, $lHwOS.Attributor)('align', 'align', $9f3ec447b9925575$var$config);
const $9f3ec447b9925575$export$7f3685f5846c07da = new (0, $lHwOS.ClassAttributor)('align', 'ql-align', $9f3ec447b9925575$var$config);
const $9f3ec447b9925575$export$d2060f5d114c9fe8 = new (0, $lHwOS.StyleAttributor)('align', 'text-align', $9f3ec447b9925575$var$config);

});

parcelRegister("5BkkP", function(module, exports) {

$parcel$export(module.exports, "BackgroundClass", () => $41402e8ca4b64635$export$8aa96c8963152b12);
$parcel$export(module.exports, "BackgroundStyle", () => $41402e8ca4b64635$export$dc1cbcab4c682ef);

var $lHwOS = parcelRequire("lHwOS");

var $4x8BI = parcelRequire("4x8BI");
const $41402e8ca4b64635$export$8aa96c8963152b12 = new (0, $lHwOS.ClassAttributor)('background', 'ql-bg', {
    scope: (0, $lHwOS.Scope).INLINE
});
const $41402e8ca4b64635$export$dc1cbcab4c682ef = new (0, $4x8BI.ColorAttributor)('background', 'background-color', {
    scope: (0, $lHwOS.Scope).INLINE
});

});
parcelRegister("4x8BI", function(module, exports) {

$parcel$export(module.exports, "ColorAttributor", () => $34d0ebb67a61d8bd$export$c992e3369f248f6e);
$parcel$export(module.exports, "ColorClass", () => $34d0ebb67a61d8bd$export$42795dcf0ec6f3c8);
$parcel$export(module.exports, "ColorStyle", () => $34d0ebb67a61d8bd$export$1415f56796d9a5a9);

var $lHwOS = parcelRequire("lHwOS");
class $34d0ebb67a61d8bd$export$c992e3369f248f6e extends (0, $lHwOS.StyleAttributor) {
    value(domNode) {
        let value = super.value(domNode);
        if (!value.startsWith('rgb(')) return value;
        value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
        const hex = value.split(',').map((component)=>`00${parseInt(component, 10).toString(16)}`.slice(-2)).join('');
        return `#${hex}`;
    }
}
const $34d0ebb67a61d8bd$export$42795dcf0ec6f3c8 = new (0, $lHwOS.ClassAttributor)('color', 'ql-color', {
    scope: (0, $lHwOS.Scope).INLINE
});
const $34d0ebb67a61d8bd$export$1415f56796d9a5a9 = new $34d0ebb67a61d8bd$export$c992e3369f248f6e('color', 'color', {
    scope: (0, $lHwOS.Scope).INLINE
});

});


parcelRegister("gwsDR", function(module, exports) {

$parcel$export(module.exports, "CodeBlockContainer", () => $c075da2a83a1acdc$export$3b131632d3d15165);
$parcel$export(module.exports, "default", () => $c075da2a83a1acdc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Code", () => $c075da2a83a1acdc$export$52f0f02147b12c03);

var $fp1Tt = parcelRequire("fp1Tt");

var $bmwCM = parcelRequire("bmwCM");

var $luQs7 = parcelRequire("luQs7");

var $fWwa7 = parcelRequire("fWwa7");

var $bxVMH = parcelRequire("bxVMH");

var $em4Pe = parcelRequire("em4Pe");

var $lcQXp = parcelRequire("lcQXp");
class $c075da2a83a1acdc$export$3b131632d3d15165 extends (0, $em4Pe.default) {
    static create(value) {
        const domNode = super.create(value);
        domNode.setAttribute('spellcheck', 'false');
        return domNode;
    }
    code(index, length) {
        return this.children// @ts-expect-error
        .map((child)=>child.length() <= 1 ? '' : child.domNode.innerText).join('\n').slice(index, index + length);
    }
    html(index, length) {
        // `\n`s are needed in order to support empty lines at the beginning and the end.
        // https://html.spec.whatwg.org/multipage/syntax.html#element-restrictions
        return `<pre>\n${(0, $bxVMH.escapeText)(this.code(index, length))}\n</pre>`;
    }
}
class $c075da2a83a1acdc$export$2e2bcd8739ae039 extends (0, $fp1Tt.default) {
    static TAB = '  ';
    static register() {
        (0, $lcQXp.default).register($c075da2a83a1acdc$export$3b131632d3d15165);
    }
}
class $c075da2a83a1acdc$export$52f0f02147b12c03 extends (0, $fWwa7.default) {
}
$c075da2a83a1acdc$export$52f0f02147b12c03.blotName = 'code';
$c075da2a83a1acdc$export$52f0f02147b12c03.tagName = 'CODE';
$c075da2a83a1acdc$export$2e2bcd8739ae039.blotName = 'code-block';
$c075da2a83a1acdc$export$2e2bcd8739ae039.className = 'ql-code-block';
$c075da2a83a1acdc$export$2e2bcd8739ae039.tagName = 'DIV';
$c075da2a83a1acdc$export$3b131632d3d15165.blotName = 'code-block-container';
$c075da2a83a1acdc$export$3b131632d3d15165.className = 'ql-code-block-container';
$c075da2a83a1acdc$export$3b131632d3d15165.tagName = 'DIV';
$c075da2a83a1acdc$export$3b131632d3d15165.allowedChildren = [
    $c075da2a83a1acdc$export$2e2bcd8739ae039
];
$c075da2a83a1acdc$export$2e2bcd8739ae039.allowedChildren = [
    (0, $bxVMH.default),
    (0, $bmwCM.default),
    (0, $luQs7.default)
];
$c075da2a83a1acdc$export$2e2bcd8739ae039.requiredContainer = $c075da2a83a1acdc$export$3b131632d3d15165;

});

parcelRegister("iWFzb", function(module, exports) {

$parcel$export(module.exports, "DirectionAttribute", () => $dcade2fe1940da51$export$4158215dafad9efa);
$parcel$export(module.exports, "DirectionClass", () => $dcade2fe1940da51$export$630028b3af294dec);
$parcel$export(module.exports, "DirectionStyle", () => $dcade2fe1940da51$export$175979e518d1dfd1);

var $lHwOS = parcelRequire("lHwOS");
const $dcade2fe1940da51$var$config = {
    scope: (0, $lHwOS.Scope).BLOCK,
    whitelist: [
        'rtl'
    ]
};
const $dcade2fe1940da51$export$4158215dafad9efa = new (0, $lHwOS.Attributor)('direction', 'dir', $dcade2fe1940da51$var$config);
const $dcade2fe1940da51$export$630028b3af294dec = new (0, $lHwOS.ClassAttributor)('direction', 'ql-direction', $dcade2fe1940da51$var$config);
const $dcade2fe1940da51$export$175979e518d1dfd1 = new (0, $lHwOS.StyleAttributor)('direction', 'direction', $dcade2fe1940da51$var$config);

});

parcelRegister("kvjOh", function(module, exports) {

$parcel$export(module.exports, "FontClass", () => $eed611c337a2b6c0$export$78a99ee601572ab);
$parcel$export(module.exports, "FontStyle", () => $eed611c337a2b6c0$export$23b468d4ca3f8c96);

var $lHwOS = parcelRequire("lHwOS");
const $eed611c337a2b6c0$var$config = {
    scope: (0, $lHwOS.Scope).INLINE,
    whitelist: [
        'serif',
        'monospace'
    ]
};
const $eed611c337a2b6c0$export$78a99ee601572ab = new (0, $lHwOS.ClassAttributor)('font', 'ql-font', $eed611c337a2b6c0$var$config);
class $eed611c337a2b6c0$var$FontStyleAttributor extends (0, $lHwOS.StyleAttributor) {
    value(node) {
        return super.value(node).replace(/["']/g, '');
    }
}
const $eed611c337a2b6c0$export$23b468d4ca3f8c96 = new $eed611c337a2b6c0$var$FontStyleAttributor('font', 'font-family', $eed611c337a2b6c0$var$config);

});

parcelRegister("jI3be", function(module, exports) {

$parcel$export(module.exports, "SizeClass", () => $e59497eaff0bd080$export$c84684d52bca9684);
$parcel$export(module.exports, "SizeStyle", () => $e59497eaff0bd080$export$5443b95a30e89ac5);

var $lHwOS = parcelRequire("lHwOS");
const $e59497eaff0bd080$export$c84684d52bca9684 = new (0, $lHwOS.ClassAttributor)('size', 'ql-size', {
    scope: (0, $lHwOS.Scope).INLINE,
    whitelist: [
        'small',
        'large',
        'huge'
    ]
});
const $e59497eaff0bd080$export$5443b95a30e89ac5 = new (0, $lHwOS.StyleAttributor)('size', 'font-size', {
    scope: (0, $lHwOS.Scope).INLINE,
    whitelist: [
        '10px',
        '18px',
        '32px'
    ]
});

});

parcelRegister("lRlaz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe9ef80dc5bc7156$export$2e2bcd8739ae039);
$parcel$export(module.exports, "deleteRange", () => $fe9ef80dc5bc7156$export$a6c813797f379898);

var $d7fWe = parcelRequire("d7fWe");
var $kaYY4 = parcelRequire("kaYY4");

var $kEXGb = parcelRequire("kEXGb");

var $lHwOS = parcelRequire("lHwOS");

var $lcQXp = parcelRequire("lcQXp");

var $lkbqq = parcelRequire("lkbqq");

var $5APNb = parcelRequire("5APNb");
const $fe9ef80dc5bc7156$var$debug = (0, $lkbqq.default)('quill:keyboard');
const $fe9ef80dc5bc7156$export$34a157fc58f3dd07 = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
class $fe9ef80dc5bc7156$export$2e2bcd8739ae039 extends (0, $5APNb.default) {
    static match(evt, binding) {
        if ([
            'altKey',
            'ctrlKey',
            'metaKey',
            'shiftKey'
        ].some((key)=>{
            return !!binding[key] !== evt[key] && binding[key] !== null;
        })) return false;
        return binding.key === evt.key || binding.key === evt.which;
    }
    constructor(quill, options){
        super(quill, options);
        this.bindings = {};
        // @ts-expect-error Fix me later
        Object.keys(this.options.bindings).forEach((name)=>{
            // @ts-expect-error Fix me later
            if (this.options.bindings[name]) // @ts-expect-error Fix me later
            this.addBinding(this.options.bindings[name]);
        });
        this.addBinding({
            key: 'Enter',
            shiftKey: null
        }, this.handleEnter);
        this.addBinding({
            key: 'Enter',
            metaKey: null,
            ctrlKey: null,
            altKey: null
        }, ()=>{});
        if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true
            }, this.handleDelete);
        } else {
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true,
                prefix: /^.?$/
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true,
                suffix: /^.?$/
            }, this.handleDelete);
        }
        this.addBinding({
            key: 'Backspace'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Delete'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Backspace',
            altKey: null,
            ctrlKey: null,
            metaKey: null,
            shiftKey: null
        }, {
            collapsed: true,
            offset: 0
        }, this.handleBackspace);
        this.listen();
    }
    addBinding(keyBinding) {
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const binding = $fe9ef80dc5bc7156$export$a3295358bff77e(keyBinding);
        if (binding == null) {
            $fe9ef80dc5bc7156$var$debug.warn('Attempted to add invalid keyboard binding', binding);
            return;
        }
        if (typeof context === 'function') context = {
            handler: context
        };
        if (typeof handler === 'function') handler = {
            handler: handler
        };
        const keys = Array.isArray(binding.key) ? binding.key : [
            binding.key
        ];
        keys.forEach((key)=>{
            const singleBinding = {
                ...binding,
                key: key,
                ...context,
                ...handler
            };
            this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];
            this.bindings[singleBinding.key].push(singleBinding);
        });
    }
    listen() {
        this.quill.root.addEventListener('keydown', (evt)=>{
            if (evt.defaultPrevented || evt.isComposing) return;
            // evt.isComposing is false when pressing Enter/Backspace when composing in Safari
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            const isComposing = evt.keyCode === 229 && (evt.key === 'Enter' || evt.key === 'Backspace');
            if (isComposing) return;
            const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);
            const matches = bindings.filter((binding)=>$fe9ef80dc5bc7156$export$2e2bcd8739ae039.match(evt, binding));
            if (matches.length === 0) return;
            // @ts-expect-error
            const blot = (0, $lcQXp.default).find(evt.target, true);
            if (blot && blot.scroll !== this.quill.scroll) return;
            const range = this.quill.getSelection();
            if (range == null || !this.quill.hasFocus()) return;
            const [line, offset] = this.quill.getLine(range.index);
            const [leafStart, offsetStart] = this.quill.getLeaf(range.index);
            const [leafEnd, offsetEnd] = range.length === 0 ? [
                leafStart,
                offsetStart
            ] : this.quill.getLeaf(range.index + range.length);
            const prefixText = leafStart instanceof (0, $lHwOS.TextBlot) ? leafStart.value().slice(0, offsetStart) : '';
            const suffixText = leafEnd instanceof (0, $lHwOS.TextBlot) ? leafEnd.value().slice(offsetEnd) : '';
            const curContext = {
                collapsed: range.length === 0,
                // @ts-expect-error Fix me later
                empty: range.length === 0 && line.length() <= 1,
                format: this.quill.getFormat(range),
                line: line,
                offset: offset,
                prefix: prefixText,
                suffix: suffixText,
                event: evt
            };
            const prevented = matches.some((binding)=>{
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                    // any format is present
                    if (binding.format.every((name)=>curContext.format[name] == null)) return false;
                } else if (typeof binding.format === 'object') {
                    // all formats must match
                    if (!Object.keys(binding.format).every((name)=>{
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === true) return curContext.format[name] != null;
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === false) return curContext.format[name] == null;
                        // @ts-expect-error Fix me later
                        return (0, $d7fWe.default)(binding.format[name], curContext.format[name]);
                    })) return false;
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                // @ts-expect-error Fix me later
                return binding.handler.call(this, range, curContext, binding) !== true;
            });
            if (prevented) evt.preventDefault();
        });
    }
    handleBackspace(range, context) {
        // Check for astral symbols
        const length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        if (range.index === 0 || this.quill.getLength() <= 1) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index - length).delete(length);
        if (context.offset === 0) {
            // Always deleting newline here, length always 1
            const [prev] = this.quill.getLine(range.index - 1);
            if (prev) {
                const isPrevLineEmpty = prev.statics.blotName === 'block' && prev.length() <= 1;
                if (!isPrevLineEmpty) {
                    // @ts-expect-error Fix me later
                    const curFormats = line.formats();
                    const prevFormats = this.quill.getFormat(range.index - 1, 1);
                    formats = (0, $kEXGb.AttributeMap).diff(curFormats, prevFormats) || {};
                    if (Object.keys(formats).length > 0) {
                        // line.length() - 1 targets \n in line, another -1 for newline being deleted
                        const formatDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - 2).retain(1, formats);
                        delta = delta.compose(formatDelta);
                    }
                }
            }
        }
        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
        this.quill.focus();
    }
    handleDelete(range, context) {
        // Check for astral symbols
        const length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).delete(length);
        // @ts-expect-error Fix me later
        if (context.offset >= line.length() - 1) {
            const [next] = this.quill.getLine(range.index + 1);
            if (next) {
                // @ts-expect-error Fix me later
                const curFormats = line.formats();
                const nextFormats = this.quill.getFormat(range.index, 1);
                formats = (0, $kEXGb.AttributeMap).diff(curFormats, nextFormats) || {};
                if (Object.keys(formats).length > 0) delta = delta.retain(next.length() - 1).retain(1, formats);
            }
        }
        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
        this.quill.focus();
    }
    handleDeleteRange(range) {
        $fe9ef80dc5bc7156$export$a6c813797f379898({
            range: range,
            quill: this.quill
        });
        this.quill.focus();
    }
    handleEnter(range, context) {
        const lineFormats = Object.keys(context.format).reduce((formats, format)=>{
            if (this.quill.scroll.query(format, (0, $lHwOS.Scope).BLOCK) && !Array.isArray(context.format[format])) formats[format] = context.format[format];
            return formats;
        }, {});
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).delete(range.length).insert('\n', lineFormats);
        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
        this.quill.setSelection(range.index + 1, (0, $lcQXp.default).sources.SILENT);
        this.quill.focus();
    }
}
const $fe9ef80dc5bc7156$var$defaultOptions = {
    bindings: {
        bold: $fe9ef80dc5bc7156$var$makeFormatHandler('bold'),
        italic: $fe9ef80dc5bc7156$var$makeFormatHandler('italic'),
        underline: $fe9ef80dc5bc7156$var$makeFormatHandler('underline'),
        indent: {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: 'Tab',
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '+1', (0, $lcQXp.default).sources.USER);
                return false;
            }
        },
        outdent: {
            key: 'Tab',
            shiftKey: true,
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '-1', (0, $lcQXp.default).sources.USER);
                return false;
            }
        },
        'outdent backspace': {
            key: 'Backspace',
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: [
                'indent',
                'list'
            ],
            offset: 0,
            handler (range, context) {
                if (context.format.indent != null) this.quill.format('indent', '-1', (0, $lcQXp.default).sources.USER);
                else if (context.format.list != null) this.quill.format('list', false, (0, $lcQXp.default).sources.USER);
            }
        },
        'indent code-block': $fe9ef80dc5bc7156$var$makeCodeBlockHandler(true),
        'outdent code-block': $fe9ef80dc5bc7156$var$makeCodeBlockHandler(false),
        'remove tab': {
            key: 'Tab',
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler (range) {
                this.quill.deleteText(range.index - 1, 1, (0, $lcQXp.default).sources.USER);
            }
        },
        tab: {
            key: 'Tab',
            handler (range, context) {
                if (context.format.table) return true;
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).delete(range.length).insert('\t');
                this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index + 1, (0, $lcQXp.default).sources.SILENT);
                return false;
            }
        },
        'blockquote empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'blockquote'
            ],
            empty: true,
            handler () {
                this.quill.format('blockquote', false, (0, $lcQXp.default).sources.USER);
            }
        },
        'list empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'list'
            ],
            empty: true,
            handler (range, context) {
                const formats = {
                    list: false
                };
                if (context.format.indent) formats.indent = false;
                this.quill.formatLine(range.index, range.length, formats, (0, $lcQXp.default).sources.USER);
            }
        },
        'checklist enter': {
            key: 'Enter',
            collapsed: true,
            format: {
                list: 'checked'
            },
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                const formats = {
                    // @ts-expect-error Fix me later
                    ...line.formats(),
                    list: 'checked'
                };
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).insert('\n', formats)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    list: 'unchecked'
                });
                this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $lcQXp.default).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'header enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'header'
            ],
            suffix: /^$/,
            handler (range, context) {
                const [line, offset] = this.quill.getLine(range.index);
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).insert('\n', context.format)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    header: null
                });
                this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $lcQXp.default).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'table backspace': {
            key: 'Backspace',
            format: [
                'table'
            ],
            collapsed: true,
            offset: 0,
            handler () {}
        },
        'table delete': {
            key: 'Delete',
            format: [
                'table'
            ],
            collapsed: true,
            suffix: /^$/,
            handler () {}
        },
        'table enter': {
            key: 'Enter',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range) {
                const module = this.quill.getModule('table');
                if (module) {
                    // @ts-expect-error
                    const [table, row, cell, offset] = module.getTable(range);
                    const shift = $fe9ef80dc5bc7156$var$tableSide(table, row, cell, offset);
                    if (shift == null) return;
                    let index = table.offset();
                    if (shift < 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                        this.quill.setSelection(range.index + 1, range.length, (0, $lcQXp.default).sources.SILENT);
                    } else if (shift > 0) {
                        index += table.length();
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                        this.quill.setSelection(index, (0, $lcQXp.default).sources.USER);
                    }
                }
            }
        },
        'table tab': {
            key: 'Tab',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range, context) {
                const { event: event, line: cell } = context;
                const offset = cell.offset(this.quill.scroll);
                if (event.shiftKey) this.quill.setSelection(offset - 1, (0, $lcQXp.default).sources.USER);
                else this.quill.setSelection(offset + cell.length(), (0, $lcQXp.default).sources.USER);
            }
        },
        'list autofill': {
            key: ' ',
            shiftKey: null,
            collapsed: true,
            format: {
                'code-block': false,
                blockquote: false,
                table: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler (range, context) {
                if (this.quill.scroll.query('list') == null) return true;
                const { length: length } = context.prefix;
                const [line, offset] = this.quill.getLine(range.index);
                if (offset > length) return true;
                let value;
                switch(context.prefix.trim()){
                    case '[]':
                    case '[ ]':
                        value = 'unchecked';
                        break;
                    case '[x]':
                        value = 'checked';
                        break;
                    case '-':
                    case '*':
                        value = 'bullet';
                        break;
                    default:
                        value = 'ordered';
                }
                this.quill.insertText(range.index, ' ', (0, $lcQXp.default).sources.USER);
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index - offset).delete(length + 1)// @ts-expect-error Fix me later
                .retain(line.length() - 2 - offset).retain(1, {
                    list: value
                });
                this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index - length, (0, $lcQXp.default).sources.SILENT);
                return false;
            }
        },
        'code exit': {
            key: 'Enter',
            collapsed: true,
            format: [
                'code-block'
            ],
            prefix: /^$/,
            suffix: /^\s*$/,
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                let numLines = 2;
                let cur = line;
                while(cur != null && cur.length() <= 1 && cur.formats()['code-block']){
                    // @ts-expect-error
                    cur = cur.prev;
                    numLines -= 1;
                    // Requisite prev lines are empty
                    if (numLines <= 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - offset - 2).retain(1, {
                            'code-block': null
                        }).delete(1);
                        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                        this.quill.setSelection(range.index - 1, (0, $lcQXp.default).sources.SILENT);
                        return false;
                    }
                }
                return true;
            }
        },
        'embed left': $fe9ef80dc5bc7156$var$makeEmbedArrowHandler('ArrowLeft', false),
        'embed left shift': $fe9ef80dc5bc7156$var$makeEmbedArrowHandler('ArrowLeft', true),
        'embed right': $fe9ef80dc5bc7156$var$makeEmbedArrowHandler('ArrowRight', false),
        'embed right shift': $fe9ef80dc5bc7156$var$makeEmbedArrowHandler('ArrowRight', true),
        'table down': $fe9ef80dc5bc7156$var$makeTableArrowHandler(false),
        'table up': $fe9ef80dc5bc7156$var$makeTableArrowHandler(true)
    }
};
$fe9ef80dc5bc7156$export$2e2bcd8739ae039.DEFAULTS = $fe9ef80dc5bc7156$var$defaultOptions;
function $fe9ef80dc5bc7156$var$makeCodeBlockHandler(indent) {
    return {
        key: 'Tab',
        shiftKey: !indent,
        format: {
            'code-block': true
        },
        handler (range, _ref) {
            let { event: event } = _ref;
            const CodeBlock = this.quill.scroll.query('code-block');
            // @ts-expect-error
            const { TAB: TAB } = CodeBlock;
            if (range.length === 0 && !event.shiftKey) {
                this.quill.insertText(range.index, TAB, (0, $lcQXp.default).sources.USER);
                this.quill.setSelection(range.index + TAB.length, (0, $lcQXp.default).sources.SILENT);
                return;
            }
            const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);
            let { index: index, length: length } = range;
            lines.forEach((line, i)=>{
                if (indent) {
                    line.insertAt(0, TAB);
                    if (i === 0) index += TAB.length;
                    else length += TAB.length;
                // @ts-expect-error Fix me later
                } else if (line.domNode.textContent.startsWith(TAB)) {
                    line.deleteAt(0, TAB.length);
                    if (i === 0) index -= TAB.length;
                    else length -= TAB.length;
                }
            });
            this.quill.update((0, $lcQXp.default).sources.USER);
            this.quill.setSelection(index, length, (0, $lcQXp.default).sources.SILENT);
        }
    };
}
function $fe9ef80dc5bc7156$var$makeEmbedArrowHandler(key, shiftKey) {
    const where = key === 'ArrowLeft' ? 'prefix' : 'suffix';
    return {
        key: key,
        shiftKey: shiftKey,
        altKey: null,
        [where]: /^$/,
        handler (range) {
            let { index: index } = range;
            if (key === 'ArrowRight') index += range.length + 1;
            const [leaf] = this.quill.getLeaf(index);
            if (!(leaf instanceof (0, $lHwOS.EmbedBlot))) return true;
            if (key === 'ArrowLeft') {
                if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, (0, $lcQXp.default).sources.USER);
                else this.quill.setSelection(range.index - 1, (0, $lcQXp.default).sources.USER);
            } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, (0, $lcQXp.default).sources.USER);
            else this.quill.setSelection(range.index + range.length + 1, (0, $lcQXp.default).sources.USER);
            return false;
        }
    };
}
function $fe9ef80dc5bc7156$var$makeFormatHandler(format) {
    return {
        key: format[0],
        shortKey: true,
        handler (range, context) {
            this.quill.format(format, !context.format[format], (0, $lcQXp.default).sources.USER);
        }
    };
}
function $fe9ef80dc5bc7156$var$makeTableArrowHandler(up) {
    return {
        key: up ? 'ArrowUp' : 'ArrowDown',
        collapsed: true,
        format: [
            'table'
        ],
        handler (range, context) {
            // TODO move to table module
            const key = up ? 'prev' : 'next';
            const cell = context.line;
            const targetRow = cell.parent[key];
            if (targetRow != null) {
                if (targetRow.statics.blotName === 'table-row') {
                    // @ts-expect-error
                    let targetCell = targetRow.children.head;
                    let cur = cell;
                    while(cur.prev != null){
                        // @ts-expect-error
                        cur = cur.prev;
                        targetCell = targetCell.next;
                    }
                    const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);
                    this.quill.setSelection(index, 0, (0, $lcQXp.default).sources.USER);
                }
            } else {
                // @ts-expect-error
                const targetLine = cell.table()[key];
                if (targetLine != null) {
                    if (up) this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, (0, $lcQXp.default).sources.USER);
                    else this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, (0, $lcQXp.default).sources.USER);
                }
            }
            return false;
        }
    };
}
function $fe9ef80dc5bc7156$export$a3295358bff77e(binding) {
    if (typeof binding === 'string' || typeof binding === 'number') binding = {
        key: binding
    };
    else if (typeof binding === 'object') binding = (0, $kaYY4.default)(binding);
    else return null;
    if (binding.shortKey) {
        binding[$fe9ef80dc5bc7156$export$34a157fc58f3dd07] = binding.shortKey;
        delete binding.shortKey;
    }
    return binding;
}
// TODO: Move into quill.ts or editor.ts
function $fe9ef80dc5bc7156$export$a6c813797f379898(_ref2) {
    let { quill: quill, range: range } = _ref2;
    const lines = quill.getLines(range);
    let formats = {};
    if (lines.length > 1) {
        const firstFormats = lines[0].formats();
        const lastFormats = lines[lines.length - 1].formats();
        formats = (0, $kEXGb.AttributeMap).diff(lastFormats, firstFormats) || {};
    }
    quill.deleteText(range, (0, $lcQXp.default).sources.USER);
    if (Object.keys(formats).length > 0) quill.formatLine(range.index, 1, formats, (0, $lcQXp.default).sources.USER);
    quill.setSelection(range.index, (0, $lcQXp.default).sources.SILENT);
}
function $fe9ef80dc5bc7156$var$tableSide(_table, row, cell, offset) {
    if (row.prev == null && row.next == null) {
        if (cell.prev == null && cell.next == null) return offset === 0 ? -1 : 1;
        return cell.prev == null ? -1 : 1;
    }
    if (row.prev == null) return -1;
    if (row.next == null) return 1;
    return null;
}

});

parcelRegister("fYOV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba23f5278eaf5e5f$export$2e2bcd8739ae039);

var $44b6H = parcelRequire("44b6H");

var $jjvRV = parcelRequire("jjvRV");
const $ba23f5278eaf5e5f$var$NORMALIZERS = [
    (0, $jjvRV.default),
    (0, $44b6H.default)
];
const $ba23f5278eaf5e5f$var$normalizeExternalHTML = (doc)=>{
    if (doc.documentElement) $ba23f5278eaf5e5f$var$NORMALIZERS.forEach((normalize)=>{
        normalize(doc);
    });
};
var $ba23f5278eaf5e5f$export$2e2bcd8739ae039 = $ba23f5278eaf5e5f$var$normalizeExternalHTML;

});
parcelRegister("44b6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f6026c8dae984df$export$2e2bcd8739ae039);
const $2f6026c8dae984df$var$normalWeightRegexp = /font-weight:\s*normal/;
const $2f6026c8dae984df$var$blockTagNames = [
    'P',
    'OL',
    'UL'
];
const $2f6026c8dae984df$var$isBlockElement = (element)=>{
    return element && $2f6026c8dae984df$var$blockTagNames.includes(element.tagName);
};
const $2f6026c8dae984df$var$normalizeEmptyLines = (doc)=>{
    Array.from(doc.querySelectorAll('br')).filter((br)=>$2f6026c8dae984df$var$isBlockElement(br.previousElementSibling) && $2f6026c8dae984df$var$isBlockElement(br.nextElementSibling)).forEach((br)=>{
        br.parentNode?.removeChild(br);
    });
};
const $2f6026c8dae984df$var$normalizeFontWeight = (doc)=>{
    Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter((node)=>node.getAttribute('style')?.match($2f6026c8dae984df$var$normalWeightRegexp)).forEach((node)=>{
        const fragment = doc.createDocumentFragment();
        fragment.append(...node.childNodes);
        node.parentNode?.replaceChild(fragment, node);
    });
};
function $2f6026c8dae984df$export$2e2bcd8739ae039(doc) {
    if (doc.querySelector('[id^="docs-internal-guid-"]')) {
        $2f6026c8dae984df$var$normalizeFontWeight(doc);
        $2f6026c8dae984df$var$normalizeEmptyLines(doc);
    }
}

});

parcelRegister("jjvRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0f8832568fc71fd$export$2e2bcd8739ae039);
const $e0f8832568fc71fd$var$ignoreRegexp = /\bmso-list:[^;]*ignore/i;
const $e0f8832568fc71fd$var$idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
const $e0f8832568fc71fd$var$indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
const $e0f8832568fc71fd$var$parseListItem = (element, html)=>{
    const style = element.getAttribute('style');
    const idMatch = style?.match($e0f8832568fc71fd$var$idRegexp);
    if (!idMatch) return null;
    const id = Number(idMatch[1]);
    const indentMatch = style?.match($e0f8832568fc71fd$var$indentRegexp);
    const indent = indentMatch ? Number(indentMatch[1]) : 1;
    const typeRegexp = new RegExp(`@list l${id}:level${indent}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, 'i');
    const typeMatch = html.match(typeRegexp);
    const type = typeMatch && typeMatch[1] === 'bullet' ? 'bullet' : 'ordered';
    return {
        id: id,
        indent: indent,
        type: type,
        element: element
    };
};
// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
// 1. "0" in "l0" means the list item id;
// 2. "1" in "level1" means the indent level, starting from 1.
const $e0f8832568fc71fd$var$normalizeListItem = (doc)=>{
    const msoList = Array.from(doc.querySelectorAll('[style*=mso-list]'));
    const ignored = [];
    const others = [];
    msoList.forEach((node)=>{
        const shouldIgnore = (node.getAttribute('style') || '').match($e0f8832568fc71fd$var$ignoreRegexp);
        if (shouldIgnore) ignored.push(node);
        else others.push(node);
    });
    // Each list item contains a marker wrapped with "mso-list: Ignore".
    ignored.forEach((node)=>node.parentNode?.removeChild(node));
    // The list stype is not defined inline with the tag, instead, it's in the
    // style tag so we need to pass the html as a string.
    const html = doc.documentElement.innerHTML;
    const listItems = others.map((element)=>$e0f8832568fc71fd$var$parseListItem(element, html)).filter((parsed)=>parsed);
    while(listItems.length){
        const childListItems = [];
        let current = listItems.shift();
        // Group continuous items into the same group (aka "ul")
        while(current){
            childListItems.push(current);
            current = listItems.length && listItems[0]?.element === current.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
            listItems[0].id === current.id ? listItems.shift() : null;
        }
        const ul = document.createElement('ul');
        childListItems.forEach((listItem)=>{
            const li = document.createElement('li');
            li.setAttribute('data-list', listItem.type);
            if (listItem.indent > 1) li.setAttribute('class', `ql-indent-${listItem.indent - 1}`);
            li.innerHTML = listItem.element.innerHTML;
            ul.appendChild(li);
        });
        const element = childListItems[0]?.element;
        const { parentNode: parentNode } = element ?? {};
        if (element) parentNode?.replaceChild(ul, element);
        childListItems.slice(1).forEach((_ref)=>{
            let { element: e } = _ref;
            parentNode?.removeChild(e);
        });
    }
};
function $e0f8832568fc71fd$export$2e2bcd8739ae039(doc) {
    if (doc.documentElement.getAttribute('xmlns:w') === 'urn:schemas-microsoft-com:office:word') $e0f8832568fc71fd$var$normalizeListItem(doc);
}

});



parcelRegister("jrSqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e28ac1ce11304a79$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $5APNb = parcelRequire("5APNb");

var $lcQXp = parcelRequire("lcQXp");
class $e28ac1ce11304a79$export$2e2bcd8739ae039 extends (0, $5APNb.default) {
    static DEFAULTS = {
        delay: 1000,
        maxStack: 100,
        userOnly: false
    };
    lastRecorded = 0;
    ignoreChange = false;
    stack = {
        undo: [],
        redo: []
    };
    currentRange = null;
    constructor(quill, options){
        super(quill, options);
        this.quill.on((0, $lcQXp.default).events.EDITOR_CHANGE, (eventName, value, oldValue, source)=>{
            if (eventName === (0, $lcQXp.default).events.SELECTION_CHANGE) {
                if (value && source !== (0, $lcQXp.default).sources.SILENT) this.currentRange = value;
            } else if (eventName === (0, $lcQXp.default).events.TEXT_CHANGE) {
                if (!this.ignoreChange) {
                    if (!this.options.userOnly || source === (0, $lcQXp.default).sources.USER) this.record(value, oldValue);
                    else this.transform(value);
                }
                this.currentRange = $e28ac1ce11304a79$var$transformRange(this.currentRange, value);
            }
        });
        this.quill.keyboard.addBinding({
            key: 'z',
            shortKey: true
        }, this.undo.bind(this));
        this.quill.keyboard.addBinding({
            key: [
                'z',
                'Z'
            ],
            shortKey: true,
            shiftKey: true
        }, this.redo.bind(this));
        if (/Win/i.test(navigator.platform)) this.quill.keyboard.addBinding({
            key: 'y',
            shortKey: true
        }, this.redo.bind(this));
        this.quill.root.addEventListener('beforeinput', (event)=>{
            if (event.inputType === 'historyUndo') {
                this.undo();
                event.preventDefault();
            } else if (event.inputType === 'historyRedo') {
                this.redo();
                event.preventDefault();
            }
        });
    }
    change(source, dest) {
        if (this.stack[source].length === 0) return;
        const item = this.stack[source].pop();
        if (!item) return;
        const base = this.quill.getContents();
        const inverseDelta = item.delta.invert(base);
        this.stack[dest].push({
            delta: inverseDelta,
            range: $e28ac1ce11304a79$var$transformRange(item.range, inverseDelta)
        });
        this.lastRecorded = 0;
        this.ignoreChange = true;
        this.quill.updateContents(item.delta, (0, $lcQXp.default).sources.USER);
        this.ignoreChange = false;
        this.restoreSelection(item);
    }
    clear() {
        this.stack = {
            undo: [],
            redo: []
        };
    }
    cutoff() {
        this.lastRecorded = 0;
    }
    record(changeDelta, oldDelta) {
        if (changeDelta.ops.length === 0) return;
        this.stack.redo = [];
        let undoDelta = changeDelta.invert(oldDelta);
        let undoRange = this.currentRange;
        const timestamp = Date.now();
        if (// @ts-expect-error Fix me later
        this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
            const item = this.stack.undo.pop();
            if (item) {
                undoDelta = undoDelta.compose(item.delta);
                undoRange = item.range;
            }
        } else this.lastRecorded = timestamp;
        if (undoDelta.length() === 0) return;
        this.stack.undo.push({
            delta: undoDelta,
            range: undoRange
        });
        // @ts-expect-error Fix me later
        if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
    }
    redo() {
        this.change('redo', 'undo');
    }
    transform(delta) {
        $e28ac1ce11304a79$var$transformStack(this.stack.undo, delta);
        $e28ac1ce11304a79$var$transformStack(this.stack.redo, delta);
    }
    undo() {
        this.change('undo', 'redo');
    }
    restoreSelection(stackItem) {
        if (stackItem.range) this.quill.setSelection(stackItem.range, (0, $lcQXp.default).sources.USER);
        else {
            const index = $e28ac1ce11304a79$export$64042f78dc41d29e(this.quill.scroll, stackItem.delta);
            this.quill.setSelection(index, (0, $lcQXp.default).sources.USER);
        }
    }
}
function $e28ac1ce11304a79$var$transformStack(stack, delta) {
    let remoteDelta = delta;
    for(let i = stack.length - 1; i >= 0; i -= 1){
        const oldItem = stack[i];
        stack[i] = {
            delta: remoteDelta.transform(oldItem.delta, true),
            range: oldItem.range && $e28ac1ce11304a79$var$transformRange(oldItem.range, remoteDelta)
        };
        remoteDelta = oldItem.delta.transform(remoteDelta);
        if (stack[i].delta.length() === 0) stack.splice(i, 1);
    }
}
function $e28ac1ce11304a79$var$endsWithNewlineChange(scroll, delta) {
    const lastOp = delta.ops[delta.ops.length - 1];
    if (lastOp == null) return false;
    if (lastOp.insert != null) return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
    if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some((attr)=>{
        return scroll.query(attr, (0, $lHwOS.Scope).BLOCK) != null;
    });
    return false;
}
function $e28ac1ce11304a79$export$64042f78dc41d29e(scroll, delta) {
    const deleteLength = delta.reduce((length, op)=>{
        return length + (op.delete || 0);
    }, 0);
    let changeIndex = delta.length() - deleteLength;
    if ($e28ac1ce11304a79$var$endsWithNewlineChange(scroll, delta)) changeIndex -= 1;
    return changeIndex;
}
function $e28ac1ce11304a79$var$transformRange(range, delta) {
    if (!range) return range;
    const start = delta.transformPosition(range.index);
    const end = delta.transformPosition(range.index + range.length);
    return {
        index: start,
        length: end - start
    };
}

});

parcelRegister("5OX8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $43cf7f2c6e4ad356$export$2e2bcd8739ae039);

var $kEXGb = parcelRequire("kEXGb");

var $jJqnr = parcelRequire("jJqnr");

var $5APNb = parcelRequire("5APNb");
class $43cf7f2c6e4ad356$var$Uploader extends (0, $5APNb.default) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('drop', (e)=>{
            e.preventDefault();
            let native = null;
            if (document.caretRangeFromPoint) native = document.caretRangeFromPoint(e.clientX, e.clientY);
            else if (document.caretPositionFromPoint) {
                // @ts-expect-error
                const position = document.caretPositionFromPoint(e.clientX, e.clientY);
                native = document.createRange();
                native.setStart(position.offsetNode, position.offset);
                native.setEnd(position.offsetNode, position.offset);
            }
            const normalized = native && quill.selection.normalizeNative(native);
            if (normalized) {
                const range = quill.selection.normalizedToRange(normalized);
                if (e.dataTransfer?.files) this.upload(range, e.dataTransfer.files);
            }
        });
    }
    upload(range, files) {
        const uploads = [];
        Array.from(files).forEach((file)=>{
            if (file && this.options.mimetypes?.includes(file.type)) uploads.push(file);
        });
        if (uploads.length > 0) // @ts-expect-error Fix me later
        this.options.handler.call(this, range, uploads);
    }
}
$43cf7f2c6e4ad356$var$Uploader.DEFAULTS = {
    mimetypes: [
        'image/png',
        'image/jpeg'
    ],
    handler (range, files) {
        if (!this.quill.scroll.query('image')) return;
        const promises = files.map((file)=>{
            return new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onload = ()=>{
                    resolve(reader.result);
                };
                reader.readAsDataURL(file);
            });
        });
        Promise.all(promises).then((images)=>{
            const update = images.reduce((delta, image)=>{
                return delta.insert({
                    image: image
                });
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).delete(range.length));
            this.quill.updateContents(update, (0, $jJqnr.default).sources.USER);
            this.quill.setSelection(range.index + images.length, (0, $jJqnr.default).sources.SILENT);
        });
    }
};
var $43cf7f2c6e4ad356$export$2e2bcd8739ae039 = $43cf7f2c6e4ad356$var$Uploader;

});

parcelRegister("ccFIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e26f6e12626ebd5$export$2e2bcd8739ae039);

var $kEXGb = parcelRequire("kEXGb");

var $5APNb = parcelRequire("5APNb");

var $lcQXp = parcelRequire("lcQXp");

var $lRlaz = parcelRequire("lRlaz");
const $8e26f6e12626ebd5$var$INSERT_TYPES = [
    'insertText',
    'insertReplacementText'
];
class $8e26f6e12626ebd5$var$Input extends (0, $5APNb.default) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('beforeinput', (event)=>{
            this.handleBeforeInput(event);
        });
        // Gboard with English input on Android triggers `compositionstart` sometimes even
        // users are not going to type anything.
        if (!/Android/i.test(navigator.userAgent)) quill.on((0, $lcQXp.default).events.COMPOSITION_BEFORE_START, ()=>{
            this.handleCompositionStart();
        });
    }
    deleteRange(range) {
        (0, $lRlaz.deleteRange)({
            range: range,
            quill: this.quill
        });
    }
    replaceText(range) {
        let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (range.length === 0) return false;
        if (text) {
            // Follow the native behavior that inherits the formats of the first character
            const formats = this.quill.getFormat(range.index, 1);
            this.deleteRange(range);
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).insert(text, formats), (0, $lcQXp.default).sources.USER);
        } else this.deleteRange(range);
        this.quill.setSelection(range.index + text.length, 0, (0, $lcQXp.default).sources.SILENT);
        return true;
    }
    handleBeforeInput(event) {
        if (this.quill.composition.isComposing || event.defaultPrevented || !$8e26f6e12626ebd5$var$INSERT_TYPES.includes(event.inputType)) return;
        const staticRange = event.getTargetRanges ? event.getTargetRanges()[0] : null;
        if (!staticRange || staticRange.collapsed === true) return;
        const text = $8e26f6e12626ebd5$var$getPlainTextFromInputEvent(event);
        if (text == null) return;
        const normalized = this.quill.selection.normalizeNative(staticRange);
        const range = normalized ? this.quill.selection.normalizedToRange(normalized) : null;
        if (range && this.replaceText(range, text)) event.preventDefault();
    }
    handleCompositionStart() {
        const range = this.quill.getSelection();
        if (range) this.replaceText(range);
    }
}
function $8e26f6e12626ebd5$var$getPlainTextFromInputEvent(event) {
    // When `inputType` is "insertText":
    // - `event.data` should be string (Safari uses `event.dataTransfer`).
    // - `event.dataTransfer` should be null.
    // When `inputType` is "insertReplacementText":
    // - `event.data` should be null.
    // - `event.dataTransfer` should contain "text/plain" data.
    if (typeof event.data === 'string') return event.data;
    if (event.dataTransfer?.types.includes('text/plain')) return event.dataTransfer.getData('text/plain');
    return null;
}
var $8e26f6e12626ebd5$export$2e2bcd8739ae039 = $8e26f6e12626ebd5$var$Input;

});

parcelRegister("7wMGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b14a9997c447c8$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $5APNb = parcelRequire("5APNb");

var $lcQXp = parcelRequire("lcQXp");
const $57b14a9997c447c8$var$isMac = /Mac/i.test(navigator.platform);
const $57b14a9997c447c8$export$b6cc50769bf06658 = 100;
// A loose check to determine if the shortcut can move the caret before a UI node:
// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>
const $57b14a9997c447c8$var$canMoveCaretBeforeUINode = (event)=>{
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || // RTL scripts or moving from the end of the previous line
    event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Home') return true;
    if ($57b14a9997c447c8$var$isMac && event.key === 'a' && event.ctrlKey === true) return true;
    return false;
};
class $57b14a9997c447c8$var$UINode extends (0, $5APNb.default) {
    isListening = false;
    selectionChangeDeadline = 0;
    constructor(quill, options){
        super(quill, options);
        this.handleArrowKeys();
        this.handleNavigationShortcuts();
    }
    handleArrowKeys() {
        this.quill.keyboard.addBinding({
            key: [
                'ArrowLeft',
                'ArrowRight'
            ],
            offset: 0,
            shiftKey: null,
            handler (range, _ref) {
                let { line: line, event: event } = _ref;
                if (!(line instanceof (0, $lHwOS.ParentBlot)) || !line.uiNode) return true;
                const isRTL = getComputedStyle(line.domNode)['direction'] === 'rtl';
                if (isRTL && event.key !== 'ArrowRight' || !isRTL && event.key !== 'ArrowLeft') return true;
                this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), (0, $lcQXp.default).sources.USER);
                return false;
            }
        });
    }
    handleNavigationShortcuts() {
        this.quill.root.addEventListener('keydown', (event)=>{
            if (!event.defaultPrevented && $57b14a9997c447c8$var$canMoveCaretBeforeUINode(event)) this.ensureListeningToSelectionChange();
        });
    }
    /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */ ensureListeningToSelectionChange() {
        this.selectionChangeDeadline = Date.now() + $57b14a9997c447c8$export$b6cc50769bf06658;
        if (this.isListening) return;
        this.isListening = true;
        const listener = ()=>{
            this.isListening = false;
            if (Date.now() <= this.selectionChangeDeadline) this.handleSelectionChange();
        };
        document.addEventListener('selectionchange', listener, {
            once: true
        });
    }
    handleSelectionChange() {
        const selection = document.getSelection();
        if (!selection) return;
        const range = selection.getRangeAt(0);
        if (range.collapsed !== true || range.startOffset !== 0) return;
        const line = this.quill.scroll.find(range.startContainer);
        if (!(line instanceof (0, $lHwOS.ParentBlot)) || !line.uiNode) return;
        const newRange = document.createRange();
        newRange.setStartAfter(line.uiNode);
        newRange.setEndAfter(line.uiNode);
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
}
var $57b14a9997c447c8$export$2e2bcd8739ae039 = $57b14a9997c447c8$var$UINode;

});


parcelRegister("gdglj", function(module, exports) {

$parcel$export(module.exports, "default", () => $030bc8697e5992e9$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");
class $030bc8697e5992e9$var$IndentAttributor extends (0, $lHwOS.ClassAttributor) {
    add(node, value) {
        let normalizedValue = 0;
        if (value === '+1' || value === '-1') {
            const indent = this.value(node) || 0;
            normalizedValue = value === '+1' ? indent + 1 : indent - 1;
        } else if (typeof value === 'number') normalizedValue = value;
        if (normalizedValue === 0) {
            this.remove(node);
            return true;
        }
        return super.add(node, normalizedValue.toString());
    }
    canAdd(node, value) {
        return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));
    }
    value(node) {
        return parseInt(super.value(node), 10) || undefined; // Don't return NaN
    }
}
const $030bc8697e5992e9$var$IndentClass = new $030bc8697e5992e9$var$IndentAttributor('indent', 'ql-indent', {
    scope: (0, $lHwOS.Scope).BLOCK,
    // @ts-expect-error
    whitelist: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]
});
var $030bc8697e5992e9$export$2e2bcd8739ae039 = $030bc8697e5992e9$var$IndentClass;

});

parcelRegister("itw5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $d733d2629ce55f93$export$2e2bcd8739ae039);

var $fp1Tt = parcelRequire("fp1Tt");
class $d733d2629ce55f93$var$Blockquote extends (0, $fp1Tt.default) {
    static blotName = 'blockquote';
    static tagName = 'blockquote';
}
var $d733d2629ce55f93$export$2e2bcd8739ae039 = $d733d2629ce55f93$var$Blockquote;

});

parcelRegister("iqhNc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d69874f3d54e87db$export$2e2bcd8739ae039);

var $fp1Tt = parcelRequire("fp1Tt");
class $d69874f3d54e87db$var$Header extends (0, $fp1Tt.default) {
    static blotName = 'header';
    static tagName = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    static formats(domNode) {
        return this.tagName.indexOf(domNode.tagName) + 1;
    }
}
var $d69874f3d54e87db$export$2e2bcd8739ae039 = $d69874f3d54e87db$var$Header;

});

parcelRegister("9tKZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e6b45c117fc3d8e$export$2e2bcd8739ae039);

var $fp1Tt = parcelRequire("fp1Tt");

var $em4Pe = parcelRequire("em4Pe");

var $lcQXp = parcelRequire("lcQXp");
class $6e6b45c117fc3d8e$export$122a2a667e12876b extends (0, $em4Pe.default) {
}
$6e6b45c117fc3d8e$export$122a2a667e12876b.blotName = 'list-container';
$6e6b45c117fc3d8e$export$122a2a667e12876b.tagName = 'OL';
class $6e6b45c117fc3d8e$export$2e2bcd8739ae039 extends (0, $fp1Tt.default) {
    static create(value) {
        const node = super.create();
        node.setAttribute('data-list', value);
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('data-list') || undefined;
    }
    static register() {
        (0, $lcQXp.default).register($6e6b45c117fc3d8e$export$122a2a667e12876b);
    }
    constructor(scroll, domNode){
        super(scroll, domNode);
        const ui = domNode.ownerDocument.createElement('span');
        const listEventHandler = (e)=>{
            if (!scroll.isEnabled()) return;
            const format = this.statics.formats(domNode, scroll);
            if (format === 'checked') {
                this.format('list', 'unchecked');
                e.preventDefault();
            } else if (format === 'unchecked') {
                this.format('list', 'checked');
                e.preventDefault();
            }
        };
        ui.addEventListener('mousedown', listEventHandler);
        ui.addEventListener('touchstart', listEventHandler);
        this.attachUI(ui);
    }
    format(name, value) {
        if (name === this.statics.blotName && value) this.domNode.setAttribute('data-list', value);
        else super.format(name, value);
    }
}
$6e6b45c117fc3d8e$export$2e2bcd8739ae039.blotName = 'list';
$6e6b45c117fc3d8e$export$2e2bcd8739ae039.tagName = 'LI';
$6e6b45c117fc3d8e$export$122a2a667e12876b.allowedChildren = [
    $6e6b45c117fc3d8e$export$2e2bcd8739ae039
];
$6e6b45c117fc3d8e$export$2e2bcd8739ae039.requiredContainer = $6e6b45c117fc3d8e$export$122a2a667e12876b;

});

parcelRegister("do6DE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf2aa86229ae61c$export$2e2bcd8739ae039);

var $fWwa7 = parcelRequire("fWwa7");
class $9bf2aa86229ae61c$var$Bold extends (0, $fWwa7.default) {
    static blotName = 'bold';
    static tagName = [
        'STRONG',
        'B'
    ];
    static create() {
        return super.create();
    }
    static formats() {
        return true;
    }
    optimize(context) {
        super.optimize(context);
        if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
    }
}
var $9bf2aa86229ae61c$export$2e2bcd8739ae039 = $9bf2aa86229ae61c$var$Bold;

});

parcelRegister("8TA2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $679f6b75ec696ed0$export$2e2bcd8739ae039);

var $do6DE = parcelRequire("do6DE");
class $679f6b75ec696ed0$var$Italic extends (0, $do6DE.default) {
    static blotName = 'italic';
    static tagName = [
        'EM',
        'I'
    ];
}
var $679f6b75ec696ed0$export$2e2bcd8739ae039 = $679f6b75ec696ed0$var$Italic;

});

parcelRegister("46cdq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fc132bd2f39661c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "sanitize", () => $2fc132bd2f39661c$export$83d2e9e3e4ee39ed);

var $fWwa7 = parcelRequire("fWwa7");
class $2fc132bd2f39661c$export$2e2bcd8739ae039 extends (0, $fWwa7.default) {
    static blotName = 'link';
    static tagName = 'A';
    static SANITIZED_URL = 'about:blank';
    static PROTOCOL_WHITELIST = [
        'http',
        'https',
        'mailto',
        'tel',
        'sms'
    ];
    static create(value) {
        const node = super.create(value);
        node.setAttribute('href', this.sanitize(value));
        node.setAttribute('rel', 'noopener noreferrer');
        node.setAttribute('target', '_blank');
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('href');
    }
    static sanitize(url) {
        return $2fc132bd2f39661c$export$83d2e9e3e4ee39ed(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
    format(name, value) {
        if (name !== this.statics.blotName || !value) super.format(name, value);
        else // @ts-expect-error
        this.domNode.setAttribute('href', this.constructor.sanitize(value));
    }
}
function $2fc132bd2f39661c$export$83d2e9e3e4ee39ed(url, protocols) {
    const anchor = document.createElement('a');
    anchor.href = url;
    const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
    return protocols.indexOf(protocol) > -1;
}

});

parcelRegister("8kCjH", function(module, exports) {

$parcel$export(module.exports, "default", () => $610de9df6c46ceb3$export$2e2bcd8739ae039);

var $fWwa7 = parcelRequire("fWwa7");
class $610de9df6c46ceb3$var$Script extends (0, $fWwa7.default) {
    static blotName = 'script';
    static tagName = [
        'SUB',
        'SUP'
    ];
    static create(value) {
        if (value === 'super') return document.createElement('sup');
        if (value === 'sub') return document.createElement('sub');
        return super.create(value);
    }
    static formats(domNode) {
        if (domNode.tagName === 'SUB') return 'sub';
        if (domNode.tagName === 'SUP') return 'super';
        return undefined;
    }
}
var $610de9df6c46ceb3$export$2e2bcd8739ae039 = $610de9df6c46ceb3$var$Script;

});

parcelRegister("jEYPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e500f00f0018d2cd$export$2e2bcd8739ae039);

var $do6DE = parcelRequire("do6DE");
class $e500f00f0018d2cd$var$Strike extends (0, $do6DE.default) {
    static blotName = 'strike';
    static tagName = [
        'S',
        'STRIKE'
    ];
}
var $e500f00f0018d2cd$export$2e2bcd8739ae039 = $e500f00f0018d2cd$var$Strike;

});

parcelRegister("jVKfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e82737837a146548$export$2e2bcd8739ae039);

var $fWwa7 = parcelRequire("fWwa7");
class $e82737837a146548$var$Underline extends (0, $fWwa7.default) {
    static blotName = 'underline';
    static tagName = 'U';
}
var $e82737837a146548$export$2e2bcd8739ae039 = $e82737837a146548$var$Underline;

});

parcelRegister("2GSBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f59dd059b0b60d6$export$2e2bcd8739ae039);

var $9xp90 = parcelRequire("9xp90");
class $1f59dd059b0b60d6$var$Formula extends (0, $9xp90.default) {
    static blotName = 'formula';
    static className = 'ql-formula';
    static tagName = 'SPAN';
    static create(value) {
        // @ts-expect-error
        if (window.katex == null) throw new Error('Formula module requires KaTeX.');
        const node = super.create(value);
        if (typeof value === 'string') {
            // @ts-expect-error
            window.katex.render(value, node, {
                throwOnError: false,
                errorColor: '#f00'
            });
            node.setAttribute('data-value', value);
        }
        return node;
    }
    static value(domNode) {
        return domNode.getAttribute('data-value');
    }
    html() {
        const { formula: formula } = this.value();
        return `<span>${formula}</span>`;
    }
}
var $1f59dd059b0b60d6$export$2e2bcd8739ae039 = $1f59dd059b0b60d6$var$Formula;

});

parcelRegister("3PWre", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cb377283139738e$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $46cdq = parcelRequire("46cdq");
const $2cb377283139738e$var$ATTRIBUTES = [
    'alt',
    'height',
    'width'
];
class $2cb377283139738e$var$Image extends (0, $lHwOS.EmbedBlot) {
    static blotName = 'image';
    static tagName = 'IMG';
    static create(value) {
        const node = super.create(value);
        if (typeof value === 'string') node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $2cb377283139738e$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static match(url) {
        return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }
    static sanitize(url) {
        return (0, $46cdq.sanitize)(url, [
            'http',
            'https',
            'data'
        ]) ? url : '//:0';
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($2cb377283139738e$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
}
var $2cb377283139738e$export$2e2bcd8739ae039 = $2cb377283139738e$var$Image;

});

parcelRegister("5VZP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $45223b4307b9f638$export$2e2bcd8739ae039);

var $fp1Tt = parcelRequire("fp1Tt");

var $46cdq = parcelRequire("46cdq");
const $45223b4307b9f638$var$ATTRIBUTES = [
    'height',
    'width'
];
class $45223b4307b9f638$var$Video extends (0, $fp1Tt.BlockEmbed) {
    static blotName = 'video';
    static className = 'ql-video';
    static tagName = 'IFRAME';
    static create(value) {
        const node = super.create(value);
        node.setAttribute('frameborder', '0');
        node.setAttribute('allowfullscreen', 'true');
        node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $45223b4307b9f638$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static sanitize(url) {
        return (0, $46cdq.default).sanitize(url);
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($45223b4307b9f638$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
    html() {
        const { video: video } = this.value();
        return `<a href="${video}">${video}</a>`;
    }
}
var $45223b4307b9f638$export$2e2bcd8739ae039 = $45223b4307b9f638$var$Video;

});

parcelRegister("3MRPo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c1f9bdf283ee6af$export$2e2bcd8739ae039);

var $kEXGb = parcelRequire("kEXGb");

var $lHwOS = parcelRequire("lHwOS");

var $fWwa7 = parcelRequire("fWwa7");

var $lcQXp = parcelRequire("lcQXp");

var $5APNb = parcelRequire("5APNb");

var $fp1Tt = parcelRequire("fp1Tt");

var $bmwCM = parcelRequire("bmwCM");

var $luQs7 = parcelRequire("luQs7");

var $bxVMH = parcelRequire("bxVMH");

var $gwsDR = parcelRequire("gwsDR");

var $lkNmd = parcelRequire("lkNmd");
const $2c1f9bdf283ee6af$var$TokenAttributor = new (0, $lHwOS.ClassAttributor)('code-token', 'hljs', {
    scope: (0, $lHwOS.Scope).INLINE
});
class $2c1f9bdf283ee6af$export$9460eee64f276be7 extends (0, $fWwa7.default) {
    static formats(node, scroll) {
        while(node != null && node !== scroll.domNode){
            if (node.classList && node.classList.contains((0, $gwsDR.default).className)) // @ts-expect-error
            return super.formats(node, scroll);
            // @ts-expect-error
            node = node.parentNode;
        }
        return undefined;
    }
    constructor(scroll, domNode, value){
        // @ts-expect-error
        super(scroll, domNode, value);
        $2c1f9bdf283ee6af$var$TokenAttributor.add(this.domNode, value);
    }
    format(format, value) {
        if (format !== $2c1f9bdf283ee6af$export$9460eee64f276be7.blotName) super.format(format, value);
        else if (value) $2c1f9bdf283ee6af$var$TokenAttributor.add(this.domNode, value);
        else {
            $2c1f9bdf283ee6af$var$TokenAttributor.remove(this.domNode);
            this.domNode.classList.remove(this.statics.className);
        }
    }
    optimize() {
        // @ts-expect-error
        super.optimize(...arguments);
        if (!$2c1f9bdf283ee6af$var$TokenAttributor.value(this.domNode)) this.unwrap();
    }
}
$2c1f9bdf283ee6af$export$9460eee64f276be7.blotName = 'code-token';
$2c1f9bdf283ee6af$export$9460eee64f276be7.className = 'ql-token';
class $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb extends (0, $gwsDR.default) {
    static create(value) {
        const domNode = super.create(value);
        if (typeof value === 'string') domNode.setAttribute('data-language', value);
        return domNode;
    }
    static formats(domNode) {
        // @ts-expect-error
        return domNode.getAttribute('data-language') || 'plain';
    }
    static register() {}
    format(name, value) {
        if (name === this.statics.blotName && value) // @ts-expect-error
        this.domNode.setAttribute('data-language', value);
        else super.format(name, value);
    }
    replaceWith(name, value) {
        this.formatAt(0, this.length(), $2c1f9bdf283ee6af$export$9460eee64f276be7.blotName, false);
        return super.replaceWith(name, value);
    }
}
class $2c1f9bdf283ee6af$var$SyntaxCodeBlockContainer extends (0, $gwsDR.CodeBlockContainer) {
    attach() {
        super.attach();
        this.forceNext = false;
        // @ts-expect-error
        this.scroll.emitMount(this);
    }
    format(name, value) {
        if (name === $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.blotName) {
            this.forceNext = true;
            this.children.forEach((child)=>{
                // @ts-expect-error
                child.format(name, value);
            });
        }
    }
    formatAt(index, length, name, value) {
        if (name === $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.blotName) this.forceNext = true;
        super.formatAt(index, length, name, value);
    }
    highlight(highlight) {
        let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.children.head == null) return;
        const nodes = Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode);
        const text = `${nodes.map((node)=>node.textContent).join('\n')}\n`;
        const language = $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
        if (forced || this.forceNext || this.cachedText !== text) {
            if (text.trim().length > 0 || this.cachedText == null) {
                const oldDelta = this.children.reduce((delta, child)=>{
                    // @ts-expect-error
                    return delta.concat((0, $fp1Tt.blockDelta)(child, false));
                }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
                const delta = highlight(text, language);
                oldDelta.diff(delta).reduce((index, _ref)=>{
                    let { retain: retain, attributes: attributes } = _ref;
                    // Should be all retains
                    if (!retain) return index;
                    if (attributes) Object.keys(attributes).forEach((format)=>{
                        if ([
                            $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.blotName,
                            $2c1f9bdf283ee6af$export$9460eee64f276be7.blotName
                        ].includes(format)) // @ts-expect-error
                        this.formatAt(index, retain, format, attributes[format]);
                    });
                    // @ts-expect-error
                    return index + retain;
                }, 0);
            }
            this.cachedText = text;
            this.forceNext = false;
        }
    }
    html(index, length) {
        const [codeBlock] = this.children.find(index);
        const language = codeBlock ? $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.formats(codeBlock.domNode) : 'plain';
        return `<pre data-language="${language}">\n${(0, $bxVMH.escapeText)(this.code(index, length))}\n</pre>`;
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent != null && this.children.head != null && this.uiNode != null) {
            const language = $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
            // @ts-expect-error
            if (language !== this.uiNode.value) // @ts-expect-error
            this.uiNode.value = language;
        }
    }
}
$2c1f9bdf283ee6af$var$SyntaxCodeBlockContainer.allowedChildren = [
    $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb
];
$2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.requiredContainer = $2c1f9bdf283ee6af$var$SyntaxCodeBlockContainer;
$2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.allowedChildren = [
    $2c1f9bdf283ee6af$export$9460eee64f276be7,
    (0, $luQs7.default),
    (0, $bxVMH.default),
    (0, $bmwCM.default)
];
const $2c1f9bdf283ee6af$var$highlight = (lib, language, text)=>{
    if (typeof lib.versionString === 'string') {
        const majorVersion = lib.versionString.split('.')[0];
        if (parseInt(majorVersion, 10) >= 11) return lib.highlight(text, {
            language: language
        }).value;
    }
    return lib.highlight(language, text).value;
};
class $2c1f9bdf283ee6af$export$2e2bcd8739ae039 extends (0, $5APNb.default) {
    static register() {
        (0, $lcQXp.default).register($2c1f9bdf283ee6af$export$9460eee64f276be7, true);
        (0, $lcQXp.default).register($2c1f9bdf283ee6af$export$6c415d1fdae3dfdb, true);
        (0, $lcQXp.default).register($2c1f9bdf283ee6af$var$SyntaxCodeBlockContainer, true);
    }
    constructor(quill, options){
        super(quill, options);
        if (this.options.hljs == null) throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
        // @ts-expect-error Fix me later
        this.languages = this.options.languages.reduce((memo, _ref2)=>{
            let { key: key } = _ref2;
            memo[key] = true;
            return memo;
        }, {});
        this.highlightBlot = this.highlightBlot.bind(this);
        this.initListener();
        this.initTimer();
    }
    initListener() {
        this.quill.on((0, $lcQXp.default).events.SCROLL_BLOT_MOUNT, (blot)=>{
            if (!(blot instanceof $2c1f9bdf283ee6af$var$SyntaxCodeBlockContainer)) return;
            const select = this.quill.root.ownerDocument.createElement('select');
            // @ts-expect-error Fix me later
            this.options.languages.forEach((_ref3)=>{
                let { key: key, label: label } = _ref3;
                const option = select.ownerDocument.createElement('option');
                option.textContent = label;
                option.setAttribute('value', key);
                select.appendChild(option);
            });
            select.addEventListener('change', ()=>{
                blot.format($2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.blotName, select.value);
                this.quill.root.focus(); // Prevent scrolling
                this.highlight(blot, true);
            });
            if (blot.uiNode == null) {
                blot.attachUI(select);
                if (blot.children.head) select.value = $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.formats(blot.children.head.domNode);
            }
        });
    }
    initTimer() {
        let timer = null;
        this.quill.on((0, $lcQXp.default).events.SCROLL_OPTIMIZE, ()=>{
            if (timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.highlight();
                timer = null;
            }, this.options.interval);
        });
    }
    highlight() {
        let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.quill.selection.composing) return;
        this.quill.update((0, $lcQXp.default).sources.USER);
        const range = this.quill.getSelection();
        const blots = blot == null ? this.quill.scroll.descendants($2c1f9bdf283ee6af$var$SyntaxCodeBlockContainer) : [
            blot
        ];
        blots.forEach((container)=>{
            container.highlight(this.highlightBlot, force);
        });
        this.quill.update((0, $lcQXp.default).sources.SILENT);
        if (range != null) this.quill.setSelection(range, (0, $lcQXp.default).sources.SILENT);
    }
    highlightBlot(text) {
        let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'plain';
        language = this.languages[language] ? language : 'plain';
        if (language === 'plain') return (0, $bxVMH.escapeText)(text).split('\n').reduce((delta, line, i)=>{
            if (i !== 0) delta.insert('\n', {
                [(0, $gwsDR.default).blotName]: language
            });
            return delta.insert(line);
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
        const container = this.quill.root.ownerDocument.createElement('div');
        container.classList.add((0, $gwsDR.default).className);
        container.innerHTML = $2c1f9bdf283ee6af$var$highlight(this.options.hljs, language, text);
        return (0, $lkNmd.traverse)(this.quill.scroll, container, [
            (node, delta)=>{
                // @ts-expect-error
                const value = $2c1f9bdf283ee6af$var$TokenAttributor.value(node);
                if (value) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(delta.length(), {
                    [$2c1f9bdf283ee6af$export$9460eee64f276be7.blotName]: value
                }));
                return delta;
            }
        ], [
            (node, delta)=>{
                // @ts-expect-error
                return node.data.split('\n').reduce((memo, nodeText, i)=>{
                    if (i !== 0) memo.insert('\n', {
                        [(0, $gwsDR.default).blotName]: language
                    });
                    return memo.insert(nodeText);
                }, delta);
            }
        ], new WeakMap());
    }
}
$2c1f9bdf283ee6af$export$2e2bcd8739ae039.DEFAULTS = {
    hljs: (()=>{
        return window.hljs;
    })(),
    interval: 1000,
    languages: [
        {
            key: 'plain',
            label: 'Plain'
        },
        {
            key: 'bash',
            label: 'Bash'
        },
        {
            key: 'cpp',
            label: 'C++'
        },
        {
            key: 'cs',
            label: 'C#'
        },
        {
            key: 'css',
            label: 'CSS'
        },
        {
            key: 'diff',
            label: 'Diff'
        },
        {
            key: 'xml',
            label: 'HTML/XML'
        },
        {
            key: 'java',
            label: 'Java'
        },
        {
            key: 'javascript',
            label: 'JavaScript'
        },
        {
            key: 'markdown',
            label: 'Markdown'
        },
        {
            key: 'php',
            label: 'PHP'
        },
        {
            key: 'python',
            label: 'Python'
        },
        {
            key: 'ruby',
            label: 'Ruby'
        },
        {
            key: 'sql',
            label: 'SQL'
        }
    ]
};

});

parcelRegister("gkzBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $be3a21ff81941f4a$export$2e2bcd8739ae039);

var $kEXGb = parcelRequire("kEXGb");

var $lcQXp = parcelRequire("lcQXp");

var $5APNb = parcelRequire("5APNb");

var $gPzxH = parcelRequire("gPzxH");
class $be3a21ff81941f4a$var$Table extends (0, $5APNb.default) {
    static register() {
        (0, $lcQXp.default).register((0, $gPzxH.TableCell));
        (0, $lcQXp.default).register((0, $gPzxH.TableRow));
        (0, $lcQXp.default).register((0, $gPzxH.TableBody));
        (0, $lcQXp.default).register((0, $gPzxH.TableContainer));
    }
    constructor(){
        super(...arguments);
        this.listenBalanceCells();
    }
    balanceTables() {
        this.quill.scroll.descendants((0, $gPzxH.TableContainer)).forEach((table)=>{
            table.balanceCells();
        });
    }
    deleteColumn() {
        const [table, , cell] = this.getTable();
        if (cell == null) return;
        // @ts-expect-error
        table.deleteColumn(cell.cellOffset());
        this.quill.update((0, $lcQXp.default).sources.USER);
    }
    deleteRow() {
        const [, row] = this.getTable();
        if (row == null) return;
        row.remove();
        this.quill.update((0, $lcQXp.default).sources.USER);
    }
    deleteTable() {
        const [table] = this.getTable();
        if (table == null) return;
        // @ts-expect-error
        const offset = table.offset();
        // @ts-expect-error
        table.remove();
        this.quill.update((0, $lcQXp.default).sources.USER);
        this.quill.setSelection(offset, (0, $lcQXp.default).sources.SILENT);
    }
    getTable() {
        let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
        if (range == null) return [
            null,
            null,
            null,
            -1
        ];
        const [cell, offset] = this.quill.getLine(range.index);
        if (cell == null || cell.statics.blotName !== (0, $gPzxH.TableCell).blotName) return [
            null,
            null,
            null,
            -1
        ];
        const row = cell.parent;
        const table = row.parent.parent;
        // @ts-expect-error
        return [
            table,
            row,
            cell,
            offset
        ];
    }
    insertColumn(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const column = cell.cellOffset();
        table.insertColumn(column + offset);
        this.quill.update((0, $lcQXp.default).sources.USER);
        let shift = row.rowOffset();
        if (offset === 0) shift += 1;
        this.quill.setSelection(range.index + shift, range.length, (0, $lcQXp.default).sources.SILENT);
    }
    insertColumnLeft() {
        this.insertColumn(0);
    }
    insertColumnRight() {
        this.insertColumn(1);
    }
    insertRow(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const index = row.rowOffset();
        table.insertRow(index + offset);
        this.quill.update((0, $lcQXp.default).sources.USER);
        if (offset > 0) this.quill.setSelection(range, (0, $lcQXp.default).sources.SILENT);
        else this.quill.setSelection(range.index + row.children.length, range.length, (0, $lcQXp.default).sources.SILENT);
    }
    insertRowAbove() {
        this.insertRow(0);
    }
    insertRowBelow() {
        this.insertRow(1);
    }
    insertTable(rows, columns) {
        const range = this.quill.getSelection();
        if (range == null) return;
        const delta = new Array(rows).fill(0).reduce((memo)=>{
            const text = new Array(columns).fill('\n').join('');
            return memo.insert(text, {
                table: (0, $gPzxH.tableId)()
            });
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index));
        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
        this.quill.setSelection(range.index, (0, $lcQXp.default).sources.SILENT);
        this.balanceTables();
    }
    listenBalanceCells() {
        this.quill.on((0, $lcQXp.default).events.SCROLL_OPTIMIZE, (mutations)=>{
            mutations.some((mutation)=>{
                if ([
                    'TD',
                    'TR',
                    'TBODY',
                    'TABLE'
                ].includes(mutation.target.tagName)) {
                    this.quill.once((0, $lcQXp.default).events.TEXT_CHANGE, (delta, old, source)=>{
                        if (source !== (0, $lcQXp.default).sources.USER) return;
                        this.balanceTables();
                    });
                    return true;
                }
                return false;
            });
        });
    }
}
var $be3a21ff81941f4a$export$2e2bcd8739ae039 = $be3a21ff81941f4a$var$Table;

});
parcelRegister("gPzxH", function(module, exports) {

$parcel$export(module.exports, "TableCell", () => $c40cfac39da1a7c0$export$1e4baea7053fc0e3);
$parcel$export(module.exports, "tableId", () => $c40cfac39da1a7c0$export$9bd6f73cbe857f1b);
$parcel$export(module.exports, "TableRow", () => $c40cfac39da1a7c0$export$b05581f4e764e162);
$parcel$export(module.exports, "TableBody", () => $c40cfac39da1a7c0$export$76ccd210b9029917);
$parcel$export(module.exports, "TableContainer", () => $c40cfac39da1a7c0$export$f2c3aea42b2a048f);

var $fp1Tt = parcelRequire("fp1Tt");

var $em4Pe = parcelRequire("em4Pe");
class $c40cfac39da1a7c0$export$1e4baea7053fc0e3 extends (0, $fp1Tt.default) {
    static blotName = 'table';
    static tagName = 'TD';
    static create(value) {
        const node = super.create();
        if (value) node.setAttribute('data-row', value);
        else node.setAttribute('data-row', $c40cfac39da1a7c0$export$9bd6f73cbe857f1b());
        return node;
    }
    static formats(domNode) {
        if (domNode.hasAttribute('data-row')) return domNode.getAttribute('data-row');
        return undefined;
    }
    cellOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    format(name, value) {
        if (name === $c40cfac39da1a7c0$export$1e4baea7053fc0e3.blotName && value) this.domNode.setAttribute('data-row', value);
        else super.format(name, value);
    }
    row() {
        return this.parent;
    }
    rowOffset() {
        if (this.row()) return this.row().rowOffset();
        return -1;
    }
    table() {
        return this.row() && this.row().table();
    }
}
class $c40cfac39da1a7c0$export$b05581f4e764e162 extends (0, $em4Pe.default) {
    static blotName = 'table-row';
    static tagName = 'TR';
    checkMerge() {
        // @ts-expect-error
        if (super.checkMerge() && this.next.children.head != null) {
            // @ts-expect-error
            const thisHead = this.children.head.formats();
            // @ts-expect-error
            const thisTail = this.children.tail.formats();
            // @ts-expect-error
            const nextHead = this.next.children.head.formats();
            // @ts-expect-error
            const nextTail = this.next.children.tail.formats();
            return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
        }
        return false;
    }
    optimize(context) {
        super.optimize(context);
        this.children.forEach((child)=>{
            if (child.next == null) return;
            const childFormats = child.formats();
            const nextFormats = child.next.formats();
            if (childFormats.table !== nextFormats.table) {
                const next = this.splitAfter(child);
                if (next) // @ts-expect-error TODO: parameters of optimize() should be a optional
                next.optimize();
                // We might be able to merge with prev now
                if (this.prev) // @ts-expect-error TODO: parameters of optimize() should be a optional
                this.prev.optimize();
            }
        });
    }
    rowOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    table() {
        return this.parent && this.parent.parent;
    }
}
class $c40cfac39da1a7c0$export$76ccd210b9029917 extends (0, $em4Pe.default) {
    static blotName = 'table-body';
    static tagName = 'TBODY';
}
class $c40cfac39da1a7c0$export$f2c3aea42b2a048f extends (0, $em4Pe.default) {
    static blotName = 'table-container';
    static tagName = 'TABLE';
    balanceCells() {
        const rows = this.descendants($c40cfac39da1a7c0$export$b05581f4e764e162);
        const maxColumns = rows.reduce((max, row)=>{
            return Math.max(row.children.length, max);
        }, 0);
        rows.forEach((row)=>{
            new Array(maxColumns - row.children.length).fill(0).forEach(()=>{
                let value;
                if (row.children.head != null) value = $c40cfac39da1a7c0$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
                const blot = this.scroll.create($c40cfac39da1a7c0$export$1e4baea7053fc0e3.blotName, value);
                row.appendChild(blot);
                // @ts-expect-error TODO: parameters of optimize() should be a optional
                blot.optimize(); // Add break blot
            });
        });
    }
    cells(column) {
        return this.rows().map((row)=>row.children.at(column));
    }
    deleteColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($c40cfac39da1a7c0$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const cell = row.children.at(index);
            if (cell != null) cell.remove();
        });
    }
    insertColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($c40cfac39da1a7c0$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const ref = row.children.at(index);
            // @ts-expect-error
            const value = $c40cfac39da1a7c0$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
            const cell = this.scroll.create($c40cfac39da1a7c0$export$1e4baea7053fc0e3.blotName, value);
            row.insertBefore(cell, ref);
        });
    }
    insertRow(index) {
        // @ts-expect-error
        const [body] = this.descendant($c40cfac39da1a7c0$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        const id = $c40cfac39da1a7c0$export$9bd6f73cbe857f1b();
        const row = this.scroll.create($c40cfac39da1a7c0$export$b05581f4e764e162.blotName);
        body.children.head.children.forEach(()=>{
            const cell = this.scroll.create($c40cfac39da1a7c0$export$1e4baea7053fc0e3.blotName, id);
            row.appendChild(cell);
        });
        const ref = body.children.at(index);
        body.insertBefore(row, ref);
    }
    rows() {
        const body = this.children.head;
        if (body == null) return [];
        return body.children.map((row)=>row);
    }
}
$c40cfac39da1a7c0$export$f2c3aea42b2a048f.allowedChildren = [
    $c40cfac39da1a7c0$export$76ccd210b9029917
];
$c40cfac39da1a7c0$export$76ccd210b9029917.requiredContainer = $c40cfac39da1a7c0$export$f2c3aea42b2a048f;
$c40cfac39da1a7c0$export$76ccd210b9029917.allowedChildren = [
    $c40cfac39da1a7c0$export$b05581f4e764e162
];
$c40cfac39da1a7c0$export$b05581f4e764e162.requiredContainer = $c40cfac39da1a7c0$export$76ccd210b9029917;
$c40cfac39da1a7c0$export$b05581f4e764e162.allowedChildren = [
    $c40cfac39da1a7c0$export$1e4baea7053fc0e3
];
$c40cfac39da1a7c0$export$1e4baea7053fc0e3.requiredContainer = $c40cfac39da1a7c0$export$b05581f4e764e162;
function $c40cfac39da1a7c0$export$9bd6f73cbe857f1b() {
    const id = Math.random().toString(36).slice(2, 6);
    return `row-${id}`;
}

});


parcelRegister("lGJ7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca085890def0461$export$2e2bcd8739ae039);

var $kEXGb = parcelRequire("kEXGb");

var $lHwOS = parcelRequire("lHwOS");

var $lcQXp = parcelRequire("lcQXp");

var $lkbqq = parcelRequire("lkbqq");

var $5APNb = parcelRequire("5APNb");
const $fca085890def0461$var$debug = (0, $lkbqq.default)('quill:toolbar');
class $fca085890def0461$export$2e2bcd8739ae039 extends (0, $5APNb.default) {
    constructor(quill, options){
        super(quill, options);
        if (Array.isArray(this.options.container)) {
            const container = document.createElement('div');
            container.setAttribute('role', 'toolbar');
            $fca085890def0461$export$faadaf0198b97fbe(container, this.options.container);
            quill.container?.parentNode?.insertBefore(container, quill.container);
            this.container = container;
        } else if (typeof this.options.container === 'string') this.container = document.querySelector(this.options.container);
        else this.container = this.options.container;
        if (!(this.container instanceof HTMLElement)) {
            $fca085890def0461$var$debug.error('Container required for toolbar', this.options);
            return;
        }
        this.container.classList.add('ql-toolbar');
        this.controls = [];
        this.handlers = {};
        if (this.options.handlers) Object.keys(this.options.handlers).forEach((format)=>{
            const handler = this.options.handlers?.[format];
            if (handler) this.addHandler(format, handler);
        });
        Array.from(this.container.querySelectorAll('button, select')).forEach((input)=>{
            // @ts-expect-error
            this.attach(input);
        });
        this.quill.on((0, $lcQXp.default).events.EDITOR_CHANGE, ()=>{
            const [range] = this.quill.selection.getRange(); // quill.getSelection triggers update
            this.update(range);
        });
    }
    addHandler(format, handler) {
        this.handlers[format] = handler;
    }
    attach(input) {
        let format = Array.from(input.classList).find((className)=>{
            return className.indexOf('ql-') === 0;
        });
        if (!format) return;
        format = format.slice(3);
        if (input.tagName === 'BUTTON') input.setAttribute('type', 'button');
        if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
            $fca085890def0461$var$debug.warn('ignoring attaching to nonexistent format', format, input);
            return;
        }
        const eventName = input.tagName === 'SELECT' ? 'change' : 'click';
        input.addEventListener(eventName, (e)=>{
            let value;
            if (input.tagName === 'SELECT') {
                // @ts-expect-error
                if (input.selectedIndex < 0) return;
                // @ts-expect-error
                const selected = input.options[input.selectedIndex];
                if (selected.hasAttribute('selected')) value = false;
                else value = selected.value || false;
            } else {
                if (input.classList.contains('ql-active')) value = false;
                else // @ts-expect-error
                value = input.value || !input.hasAttribute('value');
                e.preventDefault();
            }
            this.quill.focus();
            const [range] = this.quill.selection.getRange();
            if (this.handlers[format] != null) this.handlers[format].call(this, value);
            else if (// @ts-expect-error
            this.quill.scroll.query(format).prototype instanceof (0, $lHwOS.EmbedBlot)) {
                value = prompt(`Enter ${format}`); // eslint-disable-line no-alert
                if (!value) return;
                this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))()// @ts-expect-error Fix me later
                .retain(range.index)// @ts-expect-error Fix me later
                .delete(range.length).insert({
                    [format]: value
                }), (0, $lcQXp.default).sources.USER);
            } else this.quill.format(format, value, (0, $lcQXp.default).sources.USER);
            this.update(range);
        });
        this.controls.push([
            format,
            input
        ]);
    }
    update(range) {
        const formats = range == null ? {} : this.quill.getFormat(range);
        this.controls.forEach((pair)=>{
            const [format, input] = pair;
            if (input.tagName === 'SELECT') {
                let option = null;
                if (range == null) option = null;
                else if (formats[format] == null) option = input.querySelector('option[selected]');
                else if (!Array.isArray(formats[format])) {
                    let value = formats[format];
                    if (typeof value === 'string') value = value.replace(/"/g, '\\"');
                    option = input.querySelector(`option[value="${value}"]`);
                }
                if (option == null) {
                    // @ts-expect-error TODO fix me later
                    input.value = ''; // TODO make configurable?
                    // @ts-expect-error TODO fix me later
                    input.selectedIndex = -1;
                } else option.selected = true;
            } else if (range == null) {
                input.classList.remove('ql-active');
                input.setAttribute('aria-pressed', 'false');
            } else if (input.hasAttribute('value')) {
                // both being null should match (default values)
                // '1' should match with 1 (headers)
                const value = formats[format];
                const isActive = value === input.getAttribute('value') || value != null && value.toString() === input.getAttribute('value') || value == null && !input.getAttribute('value');
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            } else {
                const isActive = formats[format] != null;
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            }
        });
    }
}
$fca085890def0461$export$2e2bcd8739ae039.DEFAULTS = {};
function $fca085890def0461$var$addButton(container, format, value) {
    const input = document.createElement('button');
    input.setAttribute('type', 'button');
    input.classList.add(`ql-${format}`);
    input.setAttribute('aria-pressed', 'false');
    if (value != null) {
        input.value = value;
        input.setAttribute('aria-label', `${format}: ${value}`);
    } else input.setAttribute('aria-label', format);
    container.appendChild(input);
}
function $fca085890def0461$export$faadaf0198b97fbe(container, groups) {
    if (!Array.isArray(groups[0])) // @ts-expect-error
    groups = [
        groups
    ];
    groups.forEach((controls)=>{
        const group = document.createElement('span');
        group.classList.add('ql-formats');
        controls.forEach((control)=>{
            if (typeof control === 'string') $fca085890def0461$var$addButton(group, control);
            else {
                const format = Object.keys(control)[0];
                const value = control[format];
                if (Array.isArray(value)) $fca085890def0461$var$addSelect(group, format, value);
                else $fca085890def0461$var$addButton(group, format, value);
            }
        });
        container.appendChild(group);
    });
}
function $fca085890def0461$var$addSelect(container, format, values) {
    const input = document.createElement('select');
    input.classList.add(`ql-${format}`);
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value !== false) option.setAttribute('value', String(value));
        else option.setAttribute('selected', 'selected');
        input.appendChild(option);
    });
    container.appendChild(input);
}
$fca085890def0461$export$2e2bcd8739ae039.DEFAULTS = {
    container: null,
    handlers: {
        clean () {
            const range = this.quill.getSelection();
            if (range == null) return;
            if (range.length === 0) {
                const formats = this.quill.getFormat();
                Object.keys(formats).forEach((name)=>{
                    // Clean functionality in existing apps only clean inline formats
                    if (this.quill.scroll.query(name, (0, $lHwOS.Scope).INLINE) != null) this.quill.format(name, false, (0, $lcQXp.default).sources.USER);
                });
            } else this.quill.removeFormat(range.index, range.length, (0, $lcQXp.default).sources.USER);
        },
        direction (value) {
            const { align: align } = this.quill.getFormat();
            if (value === 'rtl' && align == null) this.quill.format('align', 'right', (0, $lcQXp.default).sources.USER);
            else if (!value && align === 'right') this.quill.format('align', false, (0, $lcQXp.default).sources.USER);
            this.quill.format('direction', value, (0, $lcQXp.default).sources.USER);
        },
        indent (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            // @ts-expect-error
            const indent = parseInt(formats.indent || 0, 10);
            if (value === '+1' || value === '-1') {
                let modifier = value === '+1' ? 1 : -1;
                if (formats.direction === 'rtl') modifier *= -1;
                this.quill.format('indent', indent + modifier, (0, $lcQXp.default).sources.USER);
            }
        },
        link (value) {
            if (value === true) value = prompt('Enter link URL:'); // eslint-disable-line no-alert
            this.quill.format('link', value, (0, $lcQXp.default).sources.USER);
        },
        list (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            if (value === 'check') {
                if (formats.list === 'checked' || formats.list === 'unchecked') this.quill.format('list', false, (0, $lcQXp.default).sources.USER);
                else this.quill.format('list', 'unchecked', (0, $lcQXp.default).sources.USER);
            } else this.quill.format('list', value, (0, $lcQXp.default).sources.USER);
        }
    }
};

});

parcelRegister("6tBRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b72d2854f1a515a$export$2e2bcd8739ae039);
const $4b72d2854f1a515a$var$alignLeftIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"13\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $4b72d2854f1a515a$var$alignCenterIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"14\" x2=\"4\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"12\" x2=\"6\" y1=\"4\" y2=\"4\"/></svg>";
const $4b72d2854f1a515a$var$alignRightIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"5\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $4b72d2854f1a515a$var$alignJustifyIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"4\" y2=\"4\"/></svg>";
const $4b72d2854f1a515a$var$backgroundIcon = "<svg viewbox=\"0 0 18 18\"><g class=\"ql-fill ql-color-label\"><polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"4\"/><polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"7\"/><polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"12\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"9\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"15\"/><polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"8\"/><path d=\"M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z\"/><path d=\"M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z\"/><path d=\"M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"3\"/><path d=\"M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"6\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"14\"/><polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"7\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"8\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"9\"/><path d=\"M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"3\"/><polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"4\"/><polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"14\"/><rect height=\"1\" width=\"1\" x=\"8\" y=\"15\"/><path d=\"M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"15\"/><path d=\"M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"15\"/><path d=\"M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"15\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"11\"/></g><polyline class=\"ql-stroke\" points=\"5.5 13 9 5 12.5 13\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"11\" y2=\"11\"/></svg>";
const $4b72d2854f1a515a$var$blockquoteIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"4\" y=\"5\"/><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"11\" y=\"5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M7,8c0,4.031-3,5-3,5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M14,8c0,4.031-3,5-3,5\"/></svg>";
const $4b72d2854f1a515a$var$boldIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z\"/><path class=\"ql-stroke\" d=\"M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z\"/></svg>";
const $4b72d2854f1a515a$var$cleanIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"5\" x2=\"13\" y1=\"3\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"9.35\" y1=\"12\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"11\" x2=\"15\" y1=\"11\" y2=\"15\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"11\" y1=\"11\" y2=\"15\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"7\" x=\"2\" y=\"14\"/></svg>";
const $4b72d2854f1a515a$var$codeIcon = "<svg viewbox=\"0 0 18 18\"><polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"/><polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"/><line class=\"ql-stroke\" x1=\"10\" x2=\"8\" y1=\"5\" y2=\"13\"/></svg>";
const $4b72d2854f1a515a$var$colorIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-color-label ql-stroke ql-transparent\" x1=\"3\" x2=\"15\" y1=\"15\" y2=\"15\"/><polyline class=\"ql-stroke\" points=\"5.5 11 9 3 12.5 11\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"9\" y2=\"9\"/></svg>";
const $4b72d2854f1a515a$var$directionLeftToRightIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"/><line class=\"ql-stroke ql-fill\" x1=\"15\" x2=\"11\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M11,3a3,3,0,0,0,0,6h1V3H11Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"11\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"13\" y=\"4\"/></svg>";
const $4b72d2854f1a515a$var$directionRightToLeftIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"/><line class=\"ql-stroke ql-fill\" x1=\"9\" x2=\"5\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M5,3A3,3,0,0,0,5,9H6V3H5Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"5\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"7\" y=\"4\"/></svg>";
const $4b72d2854f1a515a$var$formulaIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z\"/><rect class=\"ql-fill\" height=\"1.6\" rx=\"0.8\" ry=\"0.8\" width=\"5\" x=\"5.15\" y=\"6.2\"/><path class=\"ql-fill\" d=\"M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z\"/></svg>";
const $4b72d2854f1a515a$var$headerIcon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z\"/></svg>";
const $4b72d2854f1a515a$var$header2Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $4b72d2854f1a515a$var$header3Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $4b72d2854f1a515a$var$header4Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z\"/></svg>";
const $4b72d2854f1a515a$var$header5Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $4b72d2854f1a515a$var$header6Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z\"/></svg>";
const $4b72d2854f1a515a$var$italicIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"13\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"5\" x2=\"11\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"8\" x2=\"10\" y1=\"14\" y2=\"4\"/></svg>";
const $4b72d2854f1a515a$var$imageIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"10\" width=\"12\" x=\"3\" y=\"4\"/><circle class=\"ql-fill\" cx=\"6\" cy=\"7\" r=\"1\"/><polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"/></svg>";
const $4b72d2854f1a515a$var$indentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"/></svg>";
const $4b72d2854f1a515a$var$outdentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"5 7 5 11 3 9 5 7\"/></svg>";
const $4b72d2854f1a515a$var$linkIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"11\" y1=\"7\" y2=\"11\"/><path class=\"ql-even ql-stroke\" d=\"M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z\"/><path class=\"ql-even ql-stroke\" d=\"M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z\"/></svg>";
const $4b72d2854f1a515a$var$listBulletIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"14\" y2=\"14\"/></svg>";
const $4b72d2854f1a515a$var$listCheckIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"4\" y2=\"4\"/><polyline class=\"ql-stroke\" points=\"3 4 4 5 6 3\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"14\" y2=\"14\"/><polyline class=\"ql-stroke\" points=\"3 14 4 15 6 13\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"3 9 4 10 6 8\"/></svg>";
const $4b72d2854f1a515a$var$listOrderedIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke ql-thin\" x1=\"2.5\" x2=\"4.5\" y1=\"5.5\" y2=\"5.5\"/><path class=\"ql-fill\" d=\"M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z\"/><path class=\"ql-stroke ql-thin\" d=\"M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156\"/><path class=\"ql-stroke ql-thin\" d=\"M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109\"/></svg>";
const $4b72d2854f1a515a$var$subscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z\"/><path class=\"ql-fill\" d=\"M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z\"/></svg>";
const $4b72d2854f1a515a$var$superscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z\"/><path class=\"ql-fill\" d=\"M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z\"/></svg>";
const $4b72d2854f1a515a$var$strikeIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke ql-thin\" x1=\"15.5\" x2=\"2.5\" y1=\"8.5\" y2=\"9.5\"/><path class=\"ql-fill\" d=\"M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z\"/><path class=\"ql-fill\" d=\"M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z\"/></svg>";
const $4b72d2854f1a515a$var$tableIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"3\" x=\"5\" y=\"5\"/><rect class=\"ql-fill\" height=\"2\" width=\"4\" x=\"9\" y=\"5\"/><g class=\"ql-fill ql-transparent\"><rect height=\"2\" width=\"3\" x=\"5\" y=\"8\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"8\"/><rect height=\"2\" width=\"3\" x=\"5\" y=\"11\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"11\"/></g></svg>";
const $4b72d2854f1a515a$var$underlineIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"12\" x=\"3\" y=\"15\"/></svg>";
const $4b72d2854f1a515a$var$videoIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"5\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"12\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"8\" x=\"5\" y=\"8\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"12\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"12\"/></svg>";
var $4b72d2854f1a515a$export$2e2bcd8739ae039 = {
    align: {
        '': $4b72d2854f1a515a$var$alignLeftIcon,
        center: $4b72d2854f1a515a$var$alignCenterIcon,
        right: $4b72d2854f1a515a$var$alignRightIcon,
        justify: $4b72d2854f1a515a$var$alignJustifyIcon
    },
    background: $4b72d2854f1a515a$var$backgroundIcon,
    blockquote: $4b72d2854f1a515a$var$blockquoteIcon,
    bold: $4b72d2854f1a515a$var$boldIcon,
    clean: $4b72d2854f1a515a$var$cleanIcon,
    code: $4b72d2854f1a515a$var$codeIcon,
    'code-block': $4b72d2854f1a515a$var$codeIcon,
    color: $4b72d2854f1a515a$var$colorIcon,
    direction: {
        '': $4b72d2854f1a515a$var$directionLeftToRightIcon,
        rtl: $4b72d2854f1a515a$var$directionRightToLeftIcon
    },
    formula: $4b72d2854f1a515a$var$formulaIcon,
    header: {
        '1': $4b72d2854f1a515a$var$headerIcon,
        '2': $4b72d2854f1a515a$var$header2Icon,
        '3': $4b72d2854f1a515a$var$header3Icon,
        '4': $4b72d2854f1a515a$var$header4Icon,
        '5': $4b72d2854f1a515a$var$header5Icon,
        '6': $4b72d2854f1a515a$var$header6Icon
    },
    italic: $4b72d2854f1a515a$var$italicIcon,
    image: $4b72d2854f1a515a$var$imageIcon,
    indent: {
        '+1': $4b72d2854f1a515a$var$indentIcon,
        '-1': $4b72d2854f1a515a$var$outdentIcon
    },
    link: $4b72d2854f1a515a$var$linkIcon,
    list: {
        bullet: $4b72d2854f1a515a$var$listBulletIcon,
        check: $4b72d2854f1a515a$var$listCheckIcon,
        ordered: $4b72d2854f1a515a$var$listOrderedIcon
    },
    script: {
        sub: $4b72d2854f1a515a$var$subscriptIcon,
        super: $4b72d2854f1a515a$var$superscriptIcon
    },
    strike: $4b72d2854f1a515a$var$strikeIcon,
    table: $4b72d2854f1a515a$var$tableIcon,
    underline: $4b72d2854f1a515a$var$underlineIcon,
    video: $4b72d2854f1a515a$var$videoIcon
};

});

parcelRegister("h2pi1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6763d99421400db$export$2e2bcd8739ae039);
const $c6763d99421400db$var$DropdownIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke\" points=\"7 11 9 13 11 11 7 11\"/><polygon class=\"ql-stroke\" points=\"7 7 9 5 11 7 7 7\"/></svg>";
let $c6763d99421400db$var$optionsCounter = 0;
function $c6763d99421400db$var$toggleAriaAttribute(element, attribute) {
    element.setAttribute(attribute, `${!(element.getAttribute(attribute) === 'true')}`);
}
class $c6763d99421400db$var$Picker {
    constructor(select){
        this.select = select;
        this.container = document.createElement('span');
        this.buildPicker();
        this.select.style.display = 'none';
        // @ts-expect-error Fix me later
        this.select.parentNode.insertBefore(this.container, this.select);
        this.label.addEventListener('mousedown', ()=>{
            this.togglePicker();
        });
        this.label.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.togglePicker();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        this.select.addEventListener('change', this.update.bind(this));
    }
    togglePicker() {
        this.container.classList.toggle('ql-expanded');
        // Toggle aria-expanded and aria-hidden to make the picker accessible
        $c6763d99421400db$var$toggleAriaAttribute(this.label, 'aria-expanded');
        // @ts-expect-error
        $c6763d99421400db$var$toggleAriaAttribute(this.options, 'aria-hidden');
    }
    buildItem(option) {
        const item = document.createElement('span');
        // @ts-expect-error
        item.tabIndex = '0';
        item.setAttribute('role', 'button');
        item.classList.add('ql-picker-item');
        const value = option.getAttribute('value');
        if (value) item.setAttribute('data-value', value);
        if (option.textContent) item.setAttribute('data-label', option.textContent);
        item.addEventListener('click', ()=>{
            this.selectItem(item, true);
        });
        item.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.selectItem(item, true);
                    event.preventDefault();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        return item;
    }
    buildLabel() {
        const label = document.createElement('span');
        label.classList.add('ql-picker-label');
        label.innerHTML = $c6763d99421400db$var$DropdownIcon;
        // @ts-expect-error
        label.tabIndex = '0';
        label.setAttribute('role', 'button');
        label.setAttribute('aria-expanded', 'false');
        this.container.appendChild(label);
        return label;
    }
    buildOptions() {
        const options = document.createElement('span');
        options.classList.add('ql-picker-options');
        // Don't want screen readers to read this until options are visible
        options.setAttribute('aria-hidden', 'true');
        // @ts-expect-error
        options.tabIndex = '-1';
        // Need a unique id for aria-controls
        options.id = `ql-picker-options-${$c6763d99421400db$var$optionsCounter}`;
        $c6763d99421400db$var$optionsCounter += 1;
        this.label.setAttribute('aria-controls', options.id);
        // @ts-expect-error
        this.options = options;
        Array.from(this.select.options).forEach((option)=>{
            const item = this.buildItem(option);
            options.appendChild(item);
            if (option.selected === true) this.selectItem(item);
        });
        this.container.appendChild(options);
    }
    buildPicker() {
        Array.from(this.select.attributes).forEach((item)=>{
            this.container.setAttribute(item.name, item.value);
        });
        this.container.classList.add('ql-picker');
        this.label = this.buildLabel();
        this.buildOptions();
    }
    escape() {
        // Close menu and return focus to trigger label
        this.close();
        // Need setTimeout for accessibility to ensure that the browser executes
        // focus on the next process thread and after any DOM content changes
        setTimeout(()=>this.label.focus(), 1);
    }
    close() {
        this.container.classList.remove('ql-expanded');
        this.label.setAttribute('aria-expanded', 'false');
        // @ts-expect-error
        this.options.setAttribute('aria-hidden', 'true');
    }
    selectItem(item) {
        let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const selected = this.container.querySelector('.ql-selected');
        if (item === selected) return;
        if (selected != null) selected.classList.remove('ql-selected');
        if (item == null) return;
        item.classList.add('ql-selected');
        // @ts-expect-error Fix me later
        this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);
        if (item.hasAttribute('data-value')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
        else this.label.removeAttribute('data-value');
        if (item.hasAttribute('data-label')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
        else this.label.removeAttribute('data-label');
        if (trigger) {
            this.select.dispatchEvent(new Event('change'));
            this.close();
        }
    }
    update() {
        let option;
        if (this.select.selectedIndex > -1) {
            const item = // @ts-expect-error Fix me later
            this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
            option = this.select.options[this.select.selectedIndex];
            // @ts-expect-error
            this.selectItem(item);
        } else this.selectItem(null);
        const isActive = option != null && option !== this.select.querySelector('option[selected]');
        this.label.classList.toggle('ql-active', isActive);
    }
}
var $c6763d99421400db$export$2e2bcd8739ae039 = $c6763d99421400db$var$Picker;

});

parcelRegister("hgZvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c933a5456c3d149b$export$2e2bcd8739ae039);

var $h2pi1 = parcelRequire("h2pi1");
class $c933a5456c3d149b$var$ColorPicker extends (0, $h2pi1.default) {
    constructor(select, label){
        super(select);
        this.label.innerHTML = label;
        this.container.classList.add('ql-color-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).slice(0, 7).forEach((item)=>{
            item.classList.add('ql-primary');
        });
    }
    buildItem(option) {
        const item = super.buildItem(option);
        item.style.backgroundColor = option.getAttribute('value') || '';
        return item;
    }
    selectItem(item, trigger) {
        super.selectItem(item, trigger);
        const colorLabel = this.label.querySelector('.ql-color-label');
        const value = item ? item.getAttribute('data-value') || '' : '';
        if (colorLabel) {
            if (colorLabel.tagName === 'line') colorLabel.style.stroke = value;
            else colorLabel.style.fill = value;
        }
    }
}
var $c933a5456c3d149b$export$2e2bcd8739ae039 = $c933a5456c3d149b$var$ColorPicker;

});

parcelRegister("5LEQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $433105be8edf3158$export$2e2bcd8739ae039);

var $h2pi1 = parcelRequire("h2pi1");
class $433105be8edf3158$var$IconPicker extends (0, $h2pi1.default) {
    constructor(select, icons){
        super(select);
        this.container.classList.add('ql-icon-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).forEach((item)=>{
            item.innerHTML = icons[item.getAttribute('data-value') || ''];
        });
        this.defaultItem = this.container.querySelector('.ql-selected');
        this.selectItem(this.defaultItem);
    }
    selectItem(target, trigger) {
        super.selectItem(target, trigger);
        const item = target || this.defaultItem;
        if (item != null) {
            if (this.label.innerHTML === item.innerHTML) return;
            this.label.innerHTML = item.innerHTML;
        }
    }
}
var $433105be8edf3158$export$2e2bcd8739ae039 = $433105be8edf3158$var$IconPicker;

});

parcelRegister("eeTZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5ddcf577c721983$export$2e2bcd8739ae039);
const $a5ddcf577c721983$var$isScrollable = (el)=>{
    const { overflowY: overflowY } = getComputedStyle(el, null);
    return overflowY !== 'visible' && overflowY !== 'clip';
};
class $a5ddcf577c721983$var$Tooltip {
    constructor(quill, boundsContainer){
        this.quill = quill;
        this.boundsContainer = boundsContainer || document.body;
        this.root = quill.addContainer('ql-tooltip');
        // @ts-expect-error
        this.root.innerHTML = this.constructor.TEMPLATE;
        if ($a5ddcf577c721983$var$isScrollable(this.quill.root)) this.quill.root.addEventListener('scroll', ()=>{
            this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
        });
        this.hide();
    }
    hide() {
        this.root.classList.add('ql-hidden');
    }
    position(reference) {
        const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
        // root.scrollTop should be 0 if scrollContainer !== root
        const top = reference.bottom + this.quill.root.scrollTop;
        this.root.style.left = `${left}px`;
        this.root.style.top = `${top}px`;
        this.root.classList.remove('ql-flip');
        const containerBounds = this.boundsContainer.getBoundingClientRect();
        const rootBounds = this.root.getBoundingClientRect();
        let shift = 0;
        if (rootBounds.right > containerBounds.right) {
            shift = containerBounds.right - rootBounds.right;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.left < containerBounds.left) {
            shift = containerBounds.left - rootBounds.left;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.bottom > containerBounds.bottom) {
            const height = rootBounds.bottom - rootBounds.top;
            const verticalShift = reference.bottom - reference.top + height;
            this.root.style.top = `${top - verticalShift}px`;
            this.root.classList.add('ql-flip');
        }
        return shift;
    }
    show() {
        this.root.classList.remove('ql-editing');
        this.root.classList.remove('ql-hidden');
    }
}
var $a5ddcf577c721983$export$2e2bcd8739ae039 = $a5ddcf577c721983$var$Tooltip;

});

parcelRegister("3FYBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ad4356d8b023ab4$export$2e2bcd8739ae039);

var $4exCq = parcelRequire("4exCq");

var $jJqnr = parcelRequire("jJqnr");

var $3GeOH = parcelRequire("3GeOH");

var $3EdO3 = parcelRequire("3EdO3");

var $6tBRD = parcelRequire("6tBRD");

var $lcQXp = parcelRequire("lcQXp");
const $2ad4356d8b023ab4$var$TOOLBAR_CONFIG = [
    [
        'bold',
        'italic',
        'link'
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        },
        'blockquote'
    ]
];
class $2ad4356d8b023ab4$export$572b56f7a5e9813a extends (0, $3GeOH.BaseTooltip) {
    static TEMPLATE = [
        '<span class="ql-tooltip-arrow"></span>',
        '<div class="ql-tooltip-editor">',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-close"></a>',
        '</div>'
    ].join('');
    constructor(quill, bounds){
        super(quill, bounds);
        this.quill.on((0, $jJqnr.default).events.EDITOR_CHANGE, (type, range, oldRange, source)=>{
            if (type !== (0, $jJqnr.default).events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === (0, $jJqnr.default).sources.USER) {
                this.show();
                // Lock our width so we will expand beyond our offsetParent boundaries
                this.root.style.left = '0px';
                this.root.style.width = '';
                this.root.style.width = `${this.root.offsetWidth}px`;
                const lines = this.quill.getLines(range.index, range.length);
                if (lines.length === 1) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                } else {
                    const lastLine = lines[lines.length - 1];
                    const index = this.quill.getIndex(lastLine);
                    const length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    const indexBounds = this.quill.getBounds(new (0, $3EdO3.Range)(index, length));
                    if (indexBounds != null) this.position(indexBounds);
                }
            } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) this.hide();
        });
    }
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('.ql-close').addEventListener('click', ()=>{
            this.root.classList.remove('ql-editing');
        });
        this.quill.on((0, $jJqnr.default).events.SCROLL_OPTIMIZE, ()=>{
            // Let selection be restored by toolbar handlers before repositioning
            setTimeout(()=>{
                if (this.root.classList.contains('ql-hidden')) return;
                const range = this.quill.getSelection();
                if (range != null) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                }
            }, 1);
        });
    }
    cancel() {
        this.show();
    }
    position(reference) {
        const shift = super.position(reference);
        const arrow = this.root.querySelector('.ql-tooltip-arrow');
        // @ts-expect-error
        arrow.style.marginLeft = '';
        if (shift !== 0) // @ts-expect-error
        arrow.style.marginLeft = `${-1 * shift - arrow.offsetWidth / 2}px`;
        return shift;
    }
}
class $2ad4356d8b023ab4$export$2e2bcd8739ae039 extends (0, $3GeOH.default) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $2ad4356d8b023ab4$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-bubble');
    }
    extendToolbar(toolbar) {
        // @ts-expect-error
        this.tooltip = new $2ad4356d8b023ab4$export$572b56f7a5e9813a(this.quill, this.options.bounds);
        if (toolbar.container != null) {
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $6tBRD.default));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $6tBRD.default));
        }
    }
}
$2ad4356d8b023ab4$export$2e2bcd8739ae039.DEFAULTS = (0, $4exCq.default)({}, (0, $3GeOH.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (!value) this.quill.format('link', false, (0, $lcQXp.default).sources.USER);
                    else // @ts-expect-error
                    this.quill.theme.tooltip.edit();
                }
            }
        }
    }
});

});
parcelRegister("3GeOH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae0c9a27889409a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BaseTooltip", () => $2ae0c9a27889409a$export$ba0102162f9e195c);

var $4exCq = parcelRequire("4exCq");

var $jJqnr = parcelRequire("jJqnr");

var $c7e5N = parcelRequire("c7e5N");

var $hgZvN = parcelRequire("hgZvN");

var $5LEQd = parcelRequire("5LEQd");

var $h2pi1 = parcelRequire("h2pi1");

var $eeTZS = parcelRequire("eeTZS");
const $2ae0c9a27889409a$var$ALIGNS = [
    false,
    'center',
    'right',
    'justify'
];
const $2ae0c9a27889409a$var$COLORS = [
    '#000000',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    '#ffffff',
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
    '#bbbbbb',
    '#f06666',
    '#ffc266',
    '#ffff66',
    '#66b966',
    '#66a3e0',
    '#c285ff',
    '#888888',
    '#a10000',
    '#b26b00',
    '#b2b200',
    '#006100',
    '#0047b2',
    '#6b24b2',
    '#444444',
    '#5c0000',
    '#663d00',
    '#666600',
    '#003700',
    '#002966',
    '#3d1466'
];
const $2ae0c9a27889409a$var$FONTS = [
    false,
    'serif',
    'monospace'
];
const $2ae0c9a27889409a$var$HEADERS = [
    '1',
    '2',
    '3',
    false
];
const $2ae0c9a27889409a$var$SIZES = [
    'small',
    false,
    'large',
    'huge'
];
class $2ae0c9a27889409a$export$2e2bcd8739ae039 extends (0, $c7e5N.default) {
    constructor(quill, options){
        super(quill, options);
        const listener = (e)=>{
            if (!document.body.contains(quill.root)) {
                document.body.removeEventListener('click', listener);
                return;
            }
            if (this.tooltip != null && // @ts-expect-error
            !this.tooltip.root.contains(e.target) && // @ts-expect-error
            document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) this.tooltip.hide();
            if (this.pickers != null) this.pickers.forEach((picker)=>{
                // @ts-expect-error
                if (!picker.container.contains(e.target)) picker.close();
            });
        };
        quill.emitter.listenDOM('click', document.body, listener);
    }
    addModule(name) {
        const module = super.addModule(name);
        if (name === 'toolbar') // @ts-expect-error
        this.extendToolbar(module);
        return module;
    }
    buildButtons(buttons, icons) {
        Array.from(buttons).forEach((button)=>{
            const className = button.getAttribute('class') || '';
            className.split(/\s+/).forEach((name)=>{
                if (!name.startsWith('ql-')) return;
                name = name.slice(3);
                if (icons[name] == null) return;
                if (name === 'direction') // @ts-expect-error
                button.innerHTML = icons[name][''] + icons[name].rtl;
                else if (typeof icons[name] === 'string') // @ts-expect-error
                button.innerHTML = icons[name];
                else {
                    // @ts-expect-error
                    const value = button.value || '';
                    // @ts-expect-error
                    if (value != null && icons[name][value]) // @ts-expect-error
                    button.innerHTML = icons[name][value];
                }
            });
        });
    }
    buildPickers(selects, icons) {
        this.pickers = Array.from(selects).map((select)=>{
            if (select.classList.contains('ql-align')) {
                if (select.querySelector('option') == null) $2ae0c9a27889409a$var$fillSelect(select, $2ae0c9a27889409a$var$ALIGNS);
                if (typeof icons.align === 'object') return new (0, $5LEQd.default)(select, icons.align);
            }
            if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                const format = select.classList.contains('ql-background') ? 'background' : 'color';
                if (select.querySelector('option') == null) $2ae0c9a27889409a$var$fillSelect(select, $2ae0c9a27889409a$var$COLORS, format === 'background' ? '#ffffff' : '#000000');
                return new (0, $hgZvN.default)(select, icons[format]);
            }
            if (select.querySelector('option') == null) {
                if (select.classList.contains('ql-font')) $2ae0c9a27889409a$var$fillSelect(select, $2ae0c9a27889409a$var$FONTS);
                else if (select.classList.contains('ql-header')) $2ae0c9a27889409a$var$fillSelect(select, $2ae0c9a27889409a$var$HEADERS);
                else if (select.classList.contains('ql-size')) $2ae0c9a27889409a$var$fillSelect(select, $2ae0c9a27889409a$var$SIZES);
            }
            return new (0, $h2pi1.default)(select);
        });
        const update = ()=>{
            this.pickers.forEach((picker)=>{
                picker.update();
            });
        };
        this.quill.on((0, $jJqnr.default).events.EDITOR_CHANGE, update);
    }
}
$2ae0c9a27889409a$export$2e2bcd8739ae039.DEFAULTS = (0, $4exCq.default)({}, (0, $c7e5N.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                formula () {
                    this.quill.theme.tooltip.edit('formula');
                },
                image () {
                    let fileInput = this.container.querySelector('input.ql-image[type=file]');
                    if (fileInput == null) {
                        fileInput = document.createElement('input');
                        fileInput.setAttribute('type', 'file');
                        fileInput.setAttribute('accept', this.quill.uploader.options.mimetypes.join(', '));
                        fileInput.classList.add('ql-image');
                        fileInput.addEventListener('change', ()=>{
                            const range = this.quill.getSelection(true);
                            this.quill.uploader.upload(range, fileInput.files);
                            fileInput.value = '';
                        });
                        this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                },
                video () {
                    this.quill.theme.tooltip.edit('video');
                }
            }
        }
    }
});
class $2ae0c9a27889409a$export$ba0102162f9e195c extends (0, $eeTZS.default) {
    constructor(quill, boundsContainer){
        super(quill, boundsContainer);
        this.textbox = this.root.querySelector('input[type="text"]');
        this.listen();
    }
    listen() {
        // @ts-expect-error Fix me later
        this.textbox.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter') {
                this.save();
                event.preventDefault();
            } else if (event.key === 'Escape') {
                this.cancel();
                event.preventDefault();
            }
        });
    }
    cancel() {
        this.hide();
        this.restoreFocus();
    }
    edit() {
        let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
        let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.root.classList.remove('ql-hidden');
        this.root.classList.add('ql-editing');
        if (this.textbox == null) return;
        if (preview != null) this.textbox.value = preview;
        else if (mode !== this.root.getAttribute('data-mode')) this.textbox.value = '';
        const bounds = this.quill.getBounds(this.quill.selection.savedRange);
        if (bounds != null) this.position(bounds);
        this.textbox.select();
        this.textbox.setAttribute('placeholder', this.textbox.getAttribute(`data-${mode}`) || '');
        this.root.setAttribute('data-mode', mode);
    }
    restoreFocus() {
        this.quill.focus({
            preventScroll: true
        });
    }
    save() {
        // @ts-expect-error Fix me later
        let { value: value } = this.textbox;
        switch(this.root.getAttribute('data-mode')){
            case 'link':
                {
                    const { scrollTop: scrollTop } = this.quill.root;
                    if (this.linkRange) {
                        this.quill.formatText(this.linkRange, 'link', value, (0, $jJqnr.default).sources.USER);
                        delete this.linkRange;
                    } else {
                        this.restoreFocus();
                        this.quill.format('link', value, (0, $jJqnr.default).sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                }
            case 'video':
                value = $2ae0c9a27889409a$var$extractVideoUrl(value);
            // eslint-disable-next-line no-fallthrough
            case 'formula':
                {
                    if (!value) break;
                    const range = this.quill.getSelection(true);
                    if (range != null) {
                        const index = range.index + range.length;
                        this.quill.insertEmbed(index, // @ts-expect-error Fix me later
                        this.root.getAttribute('data-mode'), value, (0, $jJqnr.default).sources.USER);
                        if (this.root.getAttribute('data-mode') === 'formula') this.quill.insertText(index + 1, ' ', (0, $jJqnr.default).sources.USER);
                        this.quill.setSelection(index + 2, (0, $jJqnr.default).sources.USER);
                    }
                    break;
                }
            default:
        }
        // @ts-expect-error Fix me later
        this.textbox.value = '';
        this.hide();
    }
}
function $2ae0c9a27889409a$var$extractVideoUrl(url) {
    let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) return `${match[1] || 'https'}://www.youtube.com/embed/${match[2]}?showinfo=0`;
    // eslint-disable-next-line no-cond-assign
    if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) return `${match[1] || 'https'}://player.vimeo.com/video/${match[2]}/`;
    return url;
}
function $2ae0c9a27889409a$var$fillSelect(select, values) {
    let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value === defaultValue) option.setAttribute('selected', 'selected');
        else option.setAttribute('value', String(value));
        select.appendChild(option);
    });
}

});


parcelRegister("j1VIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddaae11e905e3261$export$2e2bcd8739ae039);

var $4exCq = parcelRequire("4exCq");

var $jJqnr = parcelRequire("jJqnr");

var $3GeOH = parcelRequire("3GeOH");

var $46cdq = parcelRequire("46cdq");

var $3EdO3 = parcelRequire("3EdO3");

var $6tBRD = parcelRequire("6tBRD");

var $lcQXp = parcelRequire("lcQXp");
const $ddaae11e905e3261$var$TOOLBAR_CONFIG = [
    [
        {
            header: [
                '1',
                '2',
                '3',
                false
            ]
        }
    ],
    [
        'bold',
        'italic',
        'underline',
        'link'
    ],
    [
        {
            list: 'ordered'
        },
        {
            list: 'bullet'
        }
    ],
    [
        'clean'
    ]
];
class $ddaae11e905e3261$var$SnowTooltip extends (0, $3GeOH.BaseTooltip) {
    static TEMPLATE = [
        '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-action"></a>',
        '<a class="ql-remove"></a>'
    ].join('');
    preview = this.root.querySelector('a.ql-preview');
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-action').addEventListener('click', (event)=>{
            if (this.root.classList.contains('ql-editing')) this.save();
            else // @ts-expect-error Fix me later
            this.edit('link', this.preview.textContent);
            event.preventDefault();
        });
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-remove').addEventListener('click', (event)=>{
            if (this.linkRange != null) {
                const range = this.linkRange;
                this.restoreFocus();
                this.quill.formatText(range, 'link', false, (0, $jJqnr.default).sources.USER);
                delete this.linkRange;
            }
            event.preventDefault();
            this.hide();
        });
        this.quill.on((0, $jJqnr.default).events.SELECTION_CHANGE, (range, oldRange, source)=>{
            if (range == null) return;
            if (range.length === 0 && source === (0, $jJqnr.default).sources.USER) {
                const [link, offset] = this.quill.scroll.descendant((0, $46cdq.default), range.index);
                if (link != null) {
                    this.linkRange = new (0, $3EdO3.Range)(range.index - offset, link.length());
                    const preview = (0, $46cdq.default).formats(link.domNode);
                    // @ts-expect-error Fix me later
                    this.preview.textContent = preview;
                    // @ts-expect-error Fix me later
                    this.preview.setAttribute('href', preview);
                    this.show();
                    const bounds = this.quill.getBounds(this.linkRange);
                    if (bounds != null) this.position(bounds);
                    return;
                }
            } else delete this.linkRange;
            this.hide();
        });
    }
    show() {
        super.show();
        this.root.removeAttribute('data-mode');
    }
}
class $ddaae11e905e3261$var$SnowTheme extends (0, $3GeOH.default) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $ddaae11e905e3261$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-snow');
    }
    extendToolbar(toolbar) {
        if (toolbar.container != null) {
            toolbar.container.classList.add('ql-snow');
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $6tBRD.default));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $6tBRD.default));
            // @ts-expect-error
            this.tooltip = new $ddaae11e905e3261$var$SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector('.ql-link')) this.quill.keyboard.addBinding({
                key: 'k',
                shortKey: true
            }, (_range, context)=>{
                toolbar.handlers.link.call(toolbar, !context.format.link);
            });
        }
    }
}
$ddaae11e905e3261$var$SnowTheme.DEFAULTS = (0, $4exCq.default)({}, (0, $3GeOH.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (value) {
                        const range = this.quill.getSelection();
                        if (range == null || range.length === 0) return;
                        let preview = this.quill.getText(range);
                        if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) preview = `mailto:${preview}`;
                        // @ts-expect-error
                        const { tooltip: tooltip } = this.quill.theme;
                        tooltip.edit('link', preview);
                    } else this.quill.format('link', false, (0, $lcQXp.default).sources.USER);
                }
            }
        }
    }
});
var $ddaae11e905e3261$export$2e2bcd8739ae039 = $ddaae11e905e3261$var$SnowTheme;

});



//# sourceMappingURL=prsm.0ff86092.js.map
